
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("mxO8C", function(module, exports) {
$parcel$export(module.exports, "isLeftClick", () => $6b6ab09e14a5b279$export$698c4f0ff5e11e52);
$parcel$export(module.exports, "isMiddleClick", () => $6b6ab09e14a5b279$export$fcc04c6d1a417b0c);
$parcel$export(module.exports, "isCmdOrCtrlClick", () => $6b6ab09e14a5b279$export$a8cc8ed95260f0c);
$parcel$export(module.exports, "default", () => $6b6ab09e14a5b279$export$2e2bcd8739ae039);
/* view-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8DB98 = parcelRequire("8DB98");

var $1RDZV = parcelRequire("1RDZV");

var $3cMgR = parcelRequire("3cMgR");

var $ix0Ab = parcelRequire("ix0Ab");

var $bfW07 = parcelRequire("bfW07");

var $dV1IY = parcelRequire("dV1IY");

var $cAbbc = parcelRequire("cAbbc");

var $i2Hw2 = parcelRequire("i2Hw2");

var $cakbO = parcelRequire("cakbO");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $l7iSF = parcelRequire("l7iSF");

var $dk7W5 = parcelRequire("dk7W5");

var $g90z9 = parcelRequire("g90z9");

var $16sa1 = parcelRequire("16sa1");

var $iTHAq = parcelRequire("iTHAq");

var $cAsfm = parcelRequire("cAsfm");
const $6b6ab09e14a5b279$var$SEVERITY_DEGRADED_THRESHOLD = 4102;
const $6b6ab09e14a5b279$var$SEVERITY_NORMAL_THRESHOLD = 3165;
const $6b6ab09e14a5b279$export$698c4f0ff5e11e52 = (event)=>event.button === 0;
const $6b6ab09e14a5b279$export$fcc04c6d1a417b0c = (event)=>event.button === 1;
const $6b6ab09e14a5b279$export$a8cc8ed95260f0c = (event)=>$6b6ab09e14a5b279$export$698c4f0ff5e11e52(event) && (event.metaKey || event.ctrlKey);
// eslint-disable-next-line jira/react/no-class-components
class $6b6ab09e14a5b279$var$RendererOld extends (0, $eJOHy.PureComponent) {
    static{
        this.displayName = 'Renderer';
    }
    static{
        this.defaultProps = {
            adf: undefined,
            placeholder: undefined
        };
    }
    constructor(props){
        super(props), this.onInlineCardClicked = (e, url)=>{
            const { linkActions: linkActions } = this.props;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const event = e || window.event;
            event.preventDefault();
            if ((0, $l7iSF.isExternalLink)(url)) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.open(url, '_blank', 'noopener,noreferrer');
                return;
            }
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const mouseEvent = event;
            const shouldOpenInNewTab = $6b6ab09e14a5b279$export$a8cc8ed95260f0c(mouseEvent) || $6b6ab09e14a5b279$export$fcc04c6d1a417b0c(mouseEvent);
            (0, $i2Hw2.default)(url, shouldOpenInNewTab, linkActions.push);
        }, this.onContentSelected = (e)=>{
            if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            !(e.target instanceof window.Element) || (0, $cAbbc.default)(e.target, e.currentTarget) || this.checkForMedia(e.target, e.currentTarget) || this.checkForTaskItem(e.target, e.currentTarget)) // This is to avoid entering edit mode when clicking on a link, task item, or video.
            e.stopPropagation();
        }, this.checkForMedia = (currentElement, topElement)=>{
            // If we reach the original div, we didn't find a video.
            if (!currentElement || currentElement === topElement) return false;
            // TODO: These checks are unsafe. Use the method outlined in
            // https://jdog.jira-dev.com/browse/BENTO-6367
            if (currentElement.className.includes?.('rich-media-item') || currentElement.className.includes?.('media-file-card-view') || currentElement.className.includes?.('media-viewer-popup') || currentElement.getAttribute('data-testId')?.includes('mediaAbuseModal')) return true;
            // Continue walking up the DOM tree looking for a video.
            return this.checkForMedia(currentElement.parentElement, topElement);
        }, // Can be refactored as an event handler
        // See platform/packages/editor/renderer/src/ui/Renderer/index.tsx
        // and `EventHandlers` from platform/packages/editor/editor-common/src/ui/EventHandlers/index.tsz
        this.checkForTaskItem = (currentElement, topElement, checkboxElement)=>{
            let foundCheckboxElement = checkboxElement;
            // Only consider the checkbox click as the valid event
            // i.e., clicking task item content should still open the edit-view
            if (currentElement?.getAttribute('type') === 'checkbox') foundCheckboxElement = currentElement;
            // If we reach the original element, we didn't find a task item.
            if (!currentElement || currentElement === topElement) return false;
            // Ensure it's an Atlaskit task item by checking `data-task-local-id`
            // See `platform/packages/elements/task-decision/src/components/TaskList.tsx`
            if (currentElement.getAttribute('data-task-local-id') != null && foundCheckboxElement != null) return true;
            // Continue walking up the DOM tree looking for a task item.
            return this.checkForTaskItem(currentElement.parentElement, topElement, foundCheckboxElement);
        }, this.spotlightTargetedOnExtensionNode = false, this.isEmpty = ()=>this.isAdfValueEmpty(), this.isAdfValueEmpty = ()=>{
            const { adf: adf } = this.props;
            // We should change this to an empty ADF object after this ticket is done: https://product-fabric.atlassian.net/browse/CS-235
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return !adf || (0, $dk7W5.isOnlyWhitespaceAdf)(adf);
        }, this.setNodeRef = (element)=>{
            this.node = element;
        };
        const { contextIdentifier: contextIdentifier, mediaProvider: mediaProvider, mentionProvider: mentionProvider, profileCardProvider: profileCardProvider, taskDecisionProvider: taskDecisionProvider } = this.props;
        this.node = null;
        this.dataProviders = new (0, $1RDZV.default)();
        this.dataProviders.setProvider('mediaProvider', mediaProvider);
        this.dataProviders.setProvider('mentionProvider', Promise.resolve(mentionProvider));
        if (!false) {
            let fetchAtStart = false;
            if (this.props.adf != null && typeof this.props.adf !== 'string') try {
                fetchAtStart = (0, $dk7W5.hasEmojiNode)(this.props.adf);
            } catch (_) {
                fetchAtStart = false;
            }
            this.dataProviders.setProvider('emojiProvider', (0, $dV1IY.getEmojiProviderWithCustomEmoji)(this.props.cloudId, this.props.loggedInUserAccountId, fetchAtStart));
        }
        if (contextIdentifier) this.dataProviders.setProvider('contextIdentifierProvider', Promise.resolve(contextIdentifier));
        this.dataProviders.setProvider('profilecardProvider', profileCardProvider);
        this.dataProviders.setProvider('taskDecisionProvider', Promise.resolve(taskDecisionProvider));
        this.eventHandlers = {
            smartCard: {
                onClick: this.onInlineCardClicked
            },
            link: {
                onClick: this.onInlineCardClicked
            }
        };
        this.extensionHandlers = {};
        if ((0, $7jTnu.fg)('enable_redaction_support_in_jira_issue_view')) this.extensionHandlers = (0, $g90z9.getRedactionExtensionHandler)(()=>{
            if (!this.spotlightTargetedOnExtensionNode) {
                this.spotlightTargetedOnExtensionNode = true;
                return props.fieldId || null;
            }
            return null;
        });
        if ((0, $epTsa.expVal)('platform_editor_support_table_in_comment_jira', 'isEnabled', false)) (0, $bfW07.setupEditorExperiments)('jira');
        this.rendererNodeComponentOverrides = (0, $iTHAq.getSyncRendererNodeOverrides)();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.taskDecisionProvider !== this.props.taskDecisionProvider) this.dataProviders.setProvider('taskDecisionProvider', Promise.resolve(this.props.taskDecisionProvider));
    }
    render() {
        const { adf: adf, disableActions: disableActions, placeholder: placeholder, mediaContext: mediaContext } = this.props;
        if (this.isEmpty()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            color: "color.text.subtlest"
        }, placeholder);
        this.spotlightTargetedOnExtensionNode = false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
            name: "issue-view-media-renderer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            role: "presentation",
            onClick: this.onContentSelected,
            onKeyPress: this.onContentSelected,
            ref: this.setNodeRef,
            className: (0, $hcewu.default)([
                (0, $7jTnu.fg)('platform_editor_initial_width_change') && "_1bsb1osq _7cca15wb"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix0Ab.default), {
            appearance: "comment",
            schema: (0, $8DB98.defaultSchema),
            document: (0, $dk7W5.removeCollectionFromAdf)(adf),
            dataProviders: this.dataProviders,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            allowAltTextOnImages: true,
            allowWrapCodeBlock: true,
            allowCopyToClipboard: true,
            media: (0, $cAsfm.getMediaOptions)({
                mediaContext: mediaContext
            }),
            portal: this.node,
            disableHeadingIDs: true,
            disableActions: disableActions,
            analyticsEventSeverityTracking: {
                enabled: true,
                severityDegradedThreshold: $6b6ab09e14a5b279$var$SEVERITY_DEGRADED_THRESHOLD,
                severityNormalThreshold: $6b6ab09e14a5b279$var$SEVERITY_NORMAL_THRESHOLD
            },
            unsupportedContentLevelsTracking: (0, $cakbO.getUnsupportedContentLevelsTracking)(),
            useSpecBasedValidator: true,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                // enables sending analytics event with renderer specific tti measurement
                // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
                'renderer-tti-tracking': (0, $7jTnu.fg)('renderer_tti_tracking_jira'),
                'allow-windowed-code-block': true
            },
            smartLinks: {
                ...(0, $7jTnu.fg)('jfp-magma-ssr-iv-editor-links') ? {
                    ssr: false
                } : {},
                hideHoverPreview: false,
                ...(0, $l7iSF.smartLinksDefault)
            },
            UNSTABLE_allowTableResizing: (0, $epTsa.expVal)('platform_editor_support_table_in_comment_jira', 'isEnabled', false),
            UNSTABLE_allowTableAlignment: (0, $epTsa.expVal)('platform_editor_support_table_in_comment_jira', 'isEnabled', false),
            nodeComponents: this.rendererNodeComponentOverrides
        })));
    }
}
const $6b6ab09e14a5b279$var$rendererStyles = null;
var $6b6ab09e14a5b279$export$2e2bcd8739ae039 = $6b6ab09e14a5b279$var$RendererOld;

});
parcelRegister("g90z9", function(module, exports) {
$parcel$export(module.exports, "getRedactionExtensionHandler", () => $e6a3ee86ab11edfa$export$fd010a581322717b);
$parcel$export(module.exports, "getRedactionExtension", () => $e6a3ee86ab11edfa$export$12bebc06194b8864);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $95gWV = parcelRequire("95gWV");
const $e6a3ee86ab11edfa$var$EXTENSION_TYPE = 'com.atlassian.guard-premium';
const $e6a3ee86ab11edfa$export$fd010a581322717b = (getSpotlightKey)=>({
        [$e6a3ee86ab11edfa$var$EXTENSION_TYPE]: ()=>{
            if (getSpotlightKey) {
                const key = getSpotlightKey();
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $guChT.default), {
                    name: `redaction-marker-${key}`,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $95gWV.RedactionMarker), {})
                });
            }
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $95gWV.RedactionMarker), {});
        }
    });

const $e6a3ee86ab11edfa$export$12bebc06194b8864 = ()=>{
    return {
        title: 'Redaction',
        type: $e6a3ee86ab11edfa$var$EXTENSION_TYPE,
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            '48': ()=>(parcelRequire("4UPtj"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(0, $95gWV.RedactionMarker)
                }
            }
        }
    };
};

});
parcelRegister("95gWV", function(module, exports) {
$parcel$export(module.exports, "RedactionMarker", () => $78de67c3958b6156$export$5d1828a8b51af09e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $5gWbO = parcelRequire("5gWbO");
const $78de67c3958b6156$var$redactionBarStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    aspectRatio: '3.4/1',
    height: '1lh',
    '@supports not (height: 1lh)': {
        height: '1.5em'
    },
    backgroundColor: 'color.background.neutral.bold.pressed',
    verticalAlign: 'middle',
    position: 'relative'
});
function $78de67c3958b6156$export$5d1828a8b51af09e() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if ((0, $eGOwo.fg)('jira-redaction-accessibility-followup')) return /*#__PURE__*/ (0, $gt9Am.jsx)($78de67c3958b6156$var$RedactionBar, {
        "aria-label": formatMessage((0, $5gWbO.default).redactionMarker)
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        as: "span",
        xcss: $78de67c3958b6156$var$redactionBarStyles
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $78de67c3958b6156$var$RedactionBar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_16fwhxg": (0, $awdRS.default)(CSS.supports('height', '1lh') ? '1lh' : '1.5em')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _1h1t1q25 _4t3immhw _bfhk1fxt _s7n4nkob _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5gWbO", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2401d645cf77231$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b2401d645cf77231$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    redactionMarker: {
        id: 'editor-extensions.redaction-extension.redaction-marker-aria-label',
        defaultMessage: 'Redacted content. Your organization has removed sensitive data.',
        description: 'Aria label for redaction marker.'
    }
});

});


parcelRegister("4UPtj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2w0Qi").then(()=>parcelRequire('aUqM7'));

});


parcelRegister("iTHAq", function(module, exports) {
$parcel$export(module.exports, "getSyncRendererNodeOverrides", () => $b41b2562099174f2$export$137bebfd245dfe15);

var $LFmXM = parcelRequire("LFmXM");

var $gJPuF = parcelRequire("gJPuF");

var $fNJLN = parcelRequire("fNJLN");

var $7esWo = parcelRequire("7esWo");
const $b41b2562099174f2$export$137bebfd245dfe15 = (0, $LFmXM.default)(()=>({
        ...(0, $gJPuF.default),
        ...(0, $fNJLN.default),
        ...(0, $7esWo.default)
    }));

});
parcelRegister("gJPuF", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b94e3cd05b38822$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $9ug1Y = parcelRequire("9ug1Y");

var $1C1WZ = parcelRequire("1C1WZ");

var $hGXwD = parcelRequire("hGXwD");
/**
 * Synchronous renderer node mapping for card nodes
 *
 * WARNING: This is an EXPERIMENTAL entry point and may change without notice in the future. Use it only at your own risk!
 *
 * Context: https://hello.atlassian.net/wiki/spaces/JIE/pages/5342146338 (Atlassian-internal)
 */ const $4b94e3cd05b38822$var$nodeToReact = {
    blockCard: (0, $9ug1Y.default),
    embedCard: (0, $1C1WZ.default),
    inlineCard: (0, $hGXwD.default)
};
var $4b94e3cd05b38822$export$2e2bcd8739ae039 = $4b94e3cd05b38822$var$nodeToReact;

});
parcelRegister("9ug1Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $6209c8e9dcebd53a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $4cFYC = parcelRequire("4cFYC");

var $93FVZ = parcelRequire("93FVZ");
var $dfCRV = parcelRequire("dfCRV");
var $2bEPZ = parcelRequire("2bEPZ");

var $81LfQ = parcelRequire("81LfQ");

var $kL4gV = parcelRequire("kL4gV");

var $hGXwD = parcelRequire("hGXwD");

var $e2B2h = parcelRequire("e2B2h");

var $8KOSq = parcelRequire("8KOSq");

var $8YHJ2 = parcelRequire("8YHJ2");

var $eGOwo = parcelRequire("eGOwo");


var $bnh3n = parcelRequire("bnh3n");
var $7WlTe = parcelRequire("7WlTe");

var $jWNZR = parcelRequire("jWNZR");
const $6209c8e9dcebd53a$var$datasourceContainerStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    borderRadius: `${"var(--ds-radius-large, 8px)"}`,
    border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`}`,
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    marginBottom: `${"var(--ds-space-150, 0.75rem)"}`,
    transform: 'translateX(-50%)'
});
function $6209c8e9dcebd53a$export$2e2bcd8739ae039(props) {
    const { url: url, data: data, eventHandlers: eventHandlers, smartLinks: smartLinks, isNodeNested: isNodeNested, localId: localId } = props;
    const portal = (0, $jWNZR.usePortal)(props);
    const { actionOptions: actionOptions } = smartLinks || {};
    const onClick = (0, $kL4gV.getCardClickHandler)(eventHandlers, url);
    const platform = 'web';
    const cardProps = {
        url: url,
        data: data,
        onClick: onClick,
        container: portal,
        isDatasource: !!props.datasource,
        actionOptions: actionOptions,
        CompetitorPrompt: smartLinks?.CompetitorPrompt
    };
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    const onError = ({ err: err })=>{
        if (err) throw err;
    };
    if (props.datasource) {
        const views = props.datasource.views;
        const tableView = views.find((view)=>view.type === 'table');
        const shouldRenderDatasource = tableView && (0, $7WlTe.canRenderDatasource)(props.datasource.id);
        if (shouldRenderDatasource) {
            const columns = tableView.properties?.columns;
            const visibleColumnKeys = columns?.map(({ key: key })=>key);
            const columnCustomSizesEntries = columns?.filter((c)=>!!c.width).map(({ key: key, width: width })=>[
                    key,
                    width
                ]);
            const columnCustomSizes = columnCustomSizesEntries?.length ? Object.fromEntries(columnCustomSizesEntries) : undefined;
            const wrappedColumnKeys = columns?.filter((c)=>c.isWrapped).map((c)=>c.key);
            const { datasource: datasource, layout: layout } = props;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $81LfQ.CardErrorBoundary), {
                unsupportedComponent: (0, $dfCRV.default),
                datasourceId: props.datasource.id,
                ...cardProps
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                    css: $6209c8e9dcebd53a$var$datasourceContainerStyle,
                    "data-testid": "renderer-datasource-table",
                    "data-local-id": localId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        width: isNodeNested ? '100%' : (0, $bnh3n.calcBreakoutWidth)(layout, width)
                    }
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8KOSq.default), {
                    datasourceId: datasource.id,
                    parameters: datasource.parameters,
                    visibleColumnKeys: visibleColumnKeys,
                    columnCustomSizes: columnCustomSizes,
                    wrappedColumnKeys: wrappedColumnKeys && wrappedColumnKeys.length > 0 ? wrappedColumnKeys : undefined,
                    url: url
                })))));
        }
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $hGXwD.default), {
            data: data,
            url: url
        });
    }
    let cardComponent;
    if (smartLinks?.ssr && url && ((0, $eGOwo.fg)('platform_ssr_smartlink_cards') || (0, $eGOwo.fg)('jfp-magma-ssr-iv-editor-links'))) cardComponent = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8YHJ2.CardSSR), {
        appearance: "block",
        platform: platform,
        ...cardProps,
        url: url,
        onError: onError,
        hideIconLoadingSkeleton: true
    });
    else cardComponent = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4cFYC.Card), {
        appearance: "block",
        platform: platform,
        ...cardProps,
        onError: onError
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "blockCardView-content-wrap",
        "data-block-card": true,
        "data-card-data": data ? JSON.stringify(data) : undefined,
        "data-card-url": url,
        "data-local-id": localId
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $81LfQ.CardErrorBoundary), {
        unsupportedComponent: (0, $93FVZ.default),
        ...cardProps
    }, cardComponent)));
}

});
parcelRegister("4cFYC", function(module, exports) {
$parcel$export(module.exports, "Card", () => $67163b0d69104250$export$60332b2344f7fe41);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");

var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $b43DQ = parcelRequire("b43DQ");

var $8BtgY = parcelRequire("8BtgY");
class $67163b0d69104250$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8BtgY.CardWithURLRenderer), {
            ...this.props
        });
        return this.props.intl ? content : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
            locale: "en",
            children: content
        });
    }
}
const $67163b0d69104250$export$60332b2344f7fe41 = (0, $dUaMU.default)((0, $b43DQ.context))((0, $4J0ad.default)()((0, $6YFG2.default)($67163b0d69104250$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("8BtgY", function(module, exports) {
$parcel$export(module.exports, "CardWithURLRenderer", () => $6c611c6f38b38dd4$export$e00a7788e30dc998);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $aXKmr = parcelRequire("aXKmr");

var $bmWcp = parcelRequire("bmWcp");

var $1mLfK = parcelRequire("1mLfK");

var $FoFt2 = parcelRequire("FoFt2");

var $44bDi = parcelRequire("44bDi");

var $1YI3f = parcelRequire("1YI3f");

var $2QXr6 = parcelRequire("2QXr6");

var $k9P6L = parcelRequire("k9P6L");

const $6c611c6f38b38dd4$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(0, $FoFt2.importWithRetry)(()=>(parcelRequire("lqpyp"))));
function $6c611c6f38b38dd4$export$e00a7788e30dc998(props) {
    (0, $gRw8I.di)($6c611c6f38b38dd4$export$a7690c318cd6a95e);
    const [id] = (0, $eJOHy.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $2QXr6.clearMarks)(id);
            (0, $2QXr6.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, disablePreviewPanel: disablePreviewPanel } = props;
    const isFlexibleUi = (0, $1YI3f.isFlexibleUiCard)(children, ui);
    const analyticsContext = (0, $44bDi.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $eJOHy.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $1mLfK.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1mLfK.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1mLfK.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)(FallbackComponent, {});
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt,
        disablePreviewPanel: disablePreviewPanel
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
                ...cardWithUrlProps
            }),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($6c611c6f38b38dd4$export$a7690c318cd6a95e, {
                ...cardWithUrlProps,
                children: children
            })
        })
    });
}

});
parcelRegister("FoFt2", function(module, exports) {
$parcel$export(module.exports, "isSpecialEvent", () => $4836221d615e2d0d$export$efca2c4705678489);
$parcel$export(module.exports, "isSpecialKey", () => $4836221d615e2d0d$export$d8de0cd37d316fdf);
$parcel$export(module.exports, "isSpecialClick", () => $4836221d615e2d0d$export$5b1771037ab7c451);
$parcel$export(module.exports, "getIconForFileType", () => $4836221d615e2d0d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $4836221d615e2d0d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $4836221d615e2d0d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $4836221d615e2d0d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $4836221d615e2d0d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $4836221d615e2d0d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $4836221d615e2d0d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $4836221d615e2d0d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $4836221d615e2d0d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $4836221d615e2d0d$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $4836221d615e2d0d$export$6a4545d6b336c401);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $eGOwo = parcelRequire("eGOwo");

var $4CCpn = parcelRequire("4CCpn");

var $5NtHI = parcelRequire("5NtHI");

var $dyU3L = parcelRequire("dyU3L");
const $4836221d615e2d0d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($4836221d615e2d0d$export$e6c5ffa684aac4d7() || $4836221d615e2d0d$export$d8de0cd37d316fdf(evt) || $4836221d615e2d0d$export$5b1771037ab7c451(evt));
const $4836221d615e2d0d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $4836221d615e2d0d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $eGOwo.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $4836221d615e2d0d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $4836221d615e2d0d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $4836221d615e2d0d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label] = icon;
    return label;
};



























































































const $4836221d615e2d0d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $5NtHI.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9dPtp")))
        },
        [(0, $5NtHI.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("4Gz8O")))
        },
        [(0, $5NtHI.IconType).Audio]: {
            default: ()=>(parcelRequire("cesFU"))
        },
        [(0, $5NtHI.IconType).Code]: {
            default: ()=>(parcelRequire("2hxmV"))
        },
        [(0, $5NtHI.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Folder]: {
            default: ()=>(parcelRequire("2vlwA"))
        },
        [(0, $5NtHI.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Image]: {
            default: ()=>(parcelRequire("ka9UC"))
        },
        [(0, $5NtHI.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("lQKQC")))
        },
        [(0, $5NtHI.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("4VIPx")))
        },
        [(0, $5NtHI.IconType).Video]: {
            default: ()=>(parcelRequire("4FvfE"))
        },
        [(0, $5NtHI.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("lG2jM")))
        },
        [(0, $5NtHI.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("kSre2")))
        },
        [(0, $5NtHI.IconType).Forbidden]: {
            default: ()=>Promise.resolve((parcelRequire("eDFE1")))
        },
        [(0, $5NtHI.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("av9Of")))
        },
        [(0, $5NtHI.IconType).Error]: {
            default: ()=>Promise.resolve((parcelRequire("1NG86")))
        },
        [(0, $5NtHI.IconType).Archive]: {
            default: ()=>Promise.resolve((parcelRequire("8UJE5"))),
            large: ()=>Promise.resolve((parcelRequire("8ALRN")))
        },
        [(0, $5NtHI.IconType).Executable]: {
            default: ()=>(parcelRequire("2SUZV")),
            large: ()=>Promise.resolve((parcelRequire("gAsmN")))
        },
        [(0, $5NtHI.IconType).GIF]: {
            default: ()=>(parcelRequire("htCgV")),
            large: ()=>Promise.resolve((parcelRequire("2Pj0H")))
        },
        [(0, $5NtHI.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("3iL1Z")),
            large: ()=>Promise.resolve((parcelRequire("iqmbF")))
        },
        [(0, $5NtHI.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("dEWSV")),
            large: ()=>Promise.resolve((parcelRequire("hLw8T")))
        },
        [(0, $5NtHI.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("lGiQr")),
            large: ()=>Promise.resolve((parcelRequire("jpYYq")))
        },
        [(0, $5NtHI.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("1L06r")),
            large: ()=>Promise.resolve((parcelRequire("4SXVP")))
        },
        [(0, $5NtHI.IconType).MSExcel]: {
            default: ()=>(parcelRequire("hSMHC")),
            large: ()=>Promise.resolve((parcelRequire("91IX3")))
        },
        [(0, $5NtHI.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("1pcgz")),
            large: ()=>Promise.resolve((parcelRequire("jb8ZN")))
        },
        [(0, $5NtHI.IconType).MSWord]: {
            default: ()=>(parcelRequire("lt3XL")),
            large: ()=>Promise.resolve((parcelRequire("4w1Xx")))
        },
        [(0, $5NtHI.IconType).PDF]: {
            default: ()=>(parcelRequire("5H4a5")),
            large: ()=>Promise.resolve((parcelRequire("6OBnQ")))
        },
        [(0, $5NtHI.IconType).Sketch]: {
            default: ()=>(parcelRequire("j6e97")),
            large: ()=>Promise.resolve((parcelRequire("heBKY")))
        },
        // Bitbucket icons
        [(0, $5NtHI.IconType).Branch]: {
            default: ()=>Promise.resolve((parcelRequire("liS9g"))),
            large: ()=>(parcelRequire("bQ1N4"))
        },
        [(0, $5NtHI.IconType).Commit]: {
            default: ()=>Promise.resolve((parcelRequire("6wUJL"))),
            large: ()=>(parcelRequire("4OxG9"))
        },
        [(0, $5NtHI.IconType).PullRequest]: {
            default: ()=>Promise.resolve((parcelRequire("es92x"))),
            large: ()=>(parcelRequire("1JRRC"))
        },
        [(0, $5NtHI.IconType).Repo]: {
            default: ()=>Promise.resolve((parcelRequire("gSqCA"))),
            large: ()=>(parcelRequire("gjbfK"))
        },
        // Jira icons
        [(0, $5NtHI.IconType).Bug]: {
            default: ()=>Promise.resolve((parcelRequire("i3nvV"))),
            large: ()=>(parcelRequire("jVyke"))
        },
        [(0, $5NtHI.IconType).Change]: {
            default: ()=>Promise.resolve((parcelRequire("59W6U"))),
            large: ()=>(parcelRequire("70fC5"))
        },
        [(0, $5NtHI.IconType).Epic]: {
            default: ()=>Promise.resolve((parcelRequire("4VGMo"))),
            large: ()=>(parcelRequire("bUsl4"))
        },
        [(0, $5NtHI.IconType).Incident]: {
            default: ()=>Promise.resolve((parcelRequire("h6Xfo"))),
            large: ()=>Promise.resolve((parcelRequire("eHIwa")))
        },
        [(0, $5NtHI.IconType).Problem]: {
            default: ()=>Promise.resolve((parcelRequire("erbJ6"))),
            large: ()=>(parcelRequire("7MVkC"))
        },
        [(0, $5NtHI.IconType).ServiceRequest]: {
            default: ()=>Promise.resolve((parcelRequire("8WXuv"))),
            large: ()=>(parcelRequire("acF2K"))
        },
        [(0, $5NtHI.IconType).Story]: {
            default: ()=>Promise.resolve((parcelRequire("iaeCZ"))),
            large: ()=>(parcelRequire("5Z3lN"))
        },
        [(0, $5NtHI.IconType).SubTask]: {
            default: ()=>Promise.resolve((parcelRequire("dV8me"))),
            large: ()=>(parcelRequire("1wvhU"))
        },
        [(0, $5NtHI.IconType).Task]: {
            default: ()=>Promise.resolve((parcelRequire("cOjgE"))),
            large: ()=>(parcelRequire("dyxwG"))
        },
        // Confluence icons
        [(0, $5NtHI.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("ilCAi"))),
            large: ()=>Promise.resolve((parcelRequire("hB03j")))
        },
        // Provider icons
        [(0, $5NtHI.IconType).Confluence]: {
            default: ()=>(parcelRequire("8A134")).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $5NtHI.IconType).Jira]: {
            default: ()=>(parcelRequire("6cjQd")).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $5NtHI.IconType).Attachment]: {
            default: ()=>Promise.resolve((parcelRequire("4KX56")))
        },
        [(0, $5NtHI.IconType).CheckItem]: {
            default: ()=>Promise.resolve((parcelRequire("3Y0kU")))
        },
        [(0, $5NtHI.IconType).Component]: {
            default: ()=>(parcelRequire("bNgFX"))
        },
        [(0, $5NtHI.IconType).Comment]: {
            default: ()=>Promise.resolve((parcelRequire("amxqt")))
        },
        [(0, $5NtHI.IconType).View]: {
            default: ()=>Promise.resolve((parcelRequire("dtTJ9")))
        },
        [(0, $5NtHI.IconType).React]: {
            default: ()=>Promise.resolve((parcelRequire("6b4Xr")))
        },
        [(0, $5NtHI.IconType).Vote]: {
            default: ()=>(parcelRequire("bAVbi"))
        },
        [(0, $5NtHI.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("fOxQN"))
        },
        [(0, $5NtHI.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("ekbvS"))
        },
        [(0, $5NtHI.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("j0sW6"))
        },
        [(0, $5NtHI.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("75OGX"))
        },
        [(0, $5NtHI.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("3aNz8"))
        },
        [(0, $5NtHI.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("4MiqP"))
        },
        [(0, $5NtHI.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("1Azbr"))
        },
        [(0, $5NtHI.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("hxTO3"))
        },
        [(0, $5NtHI.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("lRlMN"))
        },
        [(0, $5NtHI.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("gdaQK"))
        },
        [(0, $5NtHI.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("cH3kb"))
        },
        [(0, $5NtHI.IconType).ProgrammingLanguage]: {
            default: ()=>Promise.resolve((parcelRequire("ka71P")))
        },
        [(0, $5NtHI.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("hMpZ8")))
        },
        [(0, $5NtHI.IconType).SubTasksProgress]: {
            default: ()=>Promise.resolve((parcelRequire("kmi1F")))
        }
    };
};
const $4836221d615e2d0d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $dyU3L.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $4836221d615e2d0d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $4836221d615e2d0d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $4836221d615e2d0d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $4836221d615e2d0d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $4836221d615e2d0d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $4836221d615e2d0d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $4836221d615e2d0d$export$e772c8ff12451969(interval);
            return $4836221d615e2d0d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $4836221d615e2d0d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $4836221d615e2d0d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $4836221d615e2d0d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $4CCpn.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $4836221d615e2d0d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $5NtHI.SmartLinkSize).Large,
        (0, $5NtHI.SmartLinkSize).XLarge
    ].includes(size);
const $4836221d615e2d0d$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});
parcelRegister("dyU3L", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aa425783d81a7e4$export$2e2bcd8739ae039);

var $5NtHI = parcelRequire("5NtHI");
const $9aa425783d81a7e4$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $5NtHI.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $5NtHI.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $5NtHI.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $5NtHI.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $5NtHI.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $5NtHI.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $5NtHI.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $5NtHI.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $5NtHI.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $5NtHI.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $5NtHI.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $5NtHI.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $5NtHI.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $5NtHI.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $5NtHI.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $5NtHI.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $5NtHI.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $9aa425783d81a7e4$export$2e2bcd8739ae039 = $9aa425783d81a7e4$var$extractFileFormatIcon;

});

parcelRegister("9dPtp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a49966ca6c4774bc$export$2e2bcd8739ae039);

var $lImMk = parcelRequire("lImMk");

var $gxCW9 = parcelRequire("gxCW9");

var $DtmfJ = parcelRequire("DtmfJ");

var $cPcks = parcelRequire("cPcks");
const $a49966ca6c4774bc$var$PageIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))), 'blueBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($lImMk))), (0, (/*@__PURE__*/$parcel$interopDefault($gxCW9)))));
$a49966ca6c4774bc$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $a49966ca6c4774bc$export$2e2bcd8739ae039 = $a49966ca6c4774bc$var$PageIconWithColor;

});
parcelRegister("lImMk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fcef605c5c3325f6$var$_react = $fcef605c5c3325f6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $fcef605c5c3325f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fcef605c5c3325f6$var$Document16Icon = (props)=>/*#__PURE__*/ $fcef605c5c3325f6$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fcef605c5c3325f6$var$Document16Icon.displayName = 'Document16Icon';
var $fcef605c5c3325f6$var$_default = module.exports.default = $fcef605c5c3325f6$var$Document16Icon;

});

parcelRegister("gxCW9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c0adee7b3af1dc62$var$_react = $c0adee7b3af1dc62$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c0adee7b3af1dc62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c0adee7b3af1dc62$var$Document24Icon = (props)=>/*#__PURE__*/ $c0adee7b3af1dc62$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c0adee7b3af1dc62$var$Document24Icon.displayName = 'Document24Icon';
var $c0adee7b3af1dc62$var$_default = module.exports.default = $c0adee7b3af1dc62$var$Document24Icon;

});

parcelRegister("DtmfJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a80f298c9d6e0d96eff1b09e3e1e4079>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $076a6a80fa08401a$var$_react = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $076a6a80fa08401a$var$_baseNew = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $076a6a80fa08401a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $076a6a80fa08401a$var$PageIcon = (props)=>/*#__PURE__*/ $076a6a80fa08401a$var$_react.default.createElement($076a6a80fa08401a$var$_baseNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$076a6a80fa08401a$var$PageIcon.displayName = 'PageIcon';
var $076a6a80fa08401a$var$_default = module.exports.default = $076a6a80fa08401a$var$PageIcon;

});

parcelRegister("cPcks", function(module, exports) {
$parcel$export(module.exports, "renderIconPerSize", () => $5c2d46cff1f07a26$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $5c2d46cff1f07a26$export$87c3646d0e299cfe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $5c2d46cff1f07a26$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $5c2d46cff1f07a26$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $FoFt2.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $gt9Am.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(IconSmall, {
            ...props
        });
    };
};
const $5c2d46cff1f07a26$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
            appearance: appearance,
            icon: Icon,
            size: $5c2d46cff1f07a26$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $gt9Am.jsx)(LegacyIcon, {
                ...props,
                size: size
            })
        });
    };
};

});
parcelRegister("6IK2z", function(module, exports) {
$parcel$export(module.exports, "default", () => $df1c2fc9df73f09d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $41qqA = parcelRequire("41qqA");

var $l77v2 = parcelRequire("l77v2");
// Color mapping for size 16 standalone icons that will no longer be tiles
const $df1c2fc9df73f09d$var$appearanceToIconColorMap = {
    blue: "var(--ds-icon-accent-blue, #1D7AFC)",
    blueBold: "var(--ds-icon-accent-blue, #1D7AFC)",
    gray: "var(--ds-icon-accent-gray, #758195)",
    grayBold: "var(--ds-icon-accent-gray, #758195)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E56910)",
    orangeBold: "var(--ds-icon-accent-orange, #E56910)",
    purple: "var(--ds-icon-accent-purple, #8270DB)",
    purpleBold: "var(--ds-icon-accent-purple, #8270DB)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
function $df1c2fc9df73f09d$export$2e2bcd8739ae039({ appearance: appearance, icon: Icon, label: label, size: size, testId: testId, shape: shape, LEGACY_fallbackComponent: LEGACY_fallbackComponent, UNSAFE_circleReplacementComponent: UNSAFE_circleReplacementComponent }) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $eGOwo.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    if (UNSAFE_circleReplacementComponent && shape === 'circle' && (0, $eGOwo.fg)('platform_dst_icon_tile_circle_replacement')) return UNSAFE_circleReplacementComponent;
    if (shape !== 'circle' && (0, $eGOwo.fg)('platform_dst_new_icon_tile')) {
        // Handle size 16 - render icon directly without Tile
        if (size === '16') return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            color: $df1c2fc9df73f09d$var$appearanceToIconColorMap[appearance],
            label: label,
            testId: testId
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $41qqA.default), {
            appearance: appearance,
            icon: Icon,
            label: label,
            shape: shape,
            size: size,
            testId: testId
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l77v2.default), {
        appearance: appearance,
        icon: Icon,
        label: label,
        shape: shape,
        size: size,
        testId: testId
    });
}

});
parcelRegister("41qqA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef39d2750ac3c535$export$2e2bcd8739ae039);
/* icon-tile-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ieO20 = parcelRequire("ieO20");
const $ef39d2750ac3c535$var$sizeCrossCompatibleMap = {
    // Size mapping from old pixel sizes to new t-shirt sizes
    '16': 'xsmall',
    // Not used
    '24': 'small',
    '32': 'medium',
    '40': 'large',
    '48': 'xlarge',
    xsmall: 'xsmall',
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
// Icon color mapping for Tile-based icons
const $ef39d2750ac3c535$var$iconColorMap = {
    blue: "_syaz1ov1",
    blueBold: "_syazwdcn",
    gray: "_syaz1oju",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syazwdcn",
    lime: "_syaz8645",
    limeBold: "_syazwdcn",
    magenta: "_syazv8hk",
    magentaBold: "_syazwdcn",
    orange: "_syaz7r97",
    orangeBold: "_syazwdcn",
    purple: "_syaz5yjc",
    purpleBold: "_syazwdcn",
    red: "_syaznbxb",
    redBold: "_syazwdcn",
    teal: "_syaz8uof",
    tealBold: "_syazwdcn",
    yellow: "_syaz1oqg",
    yellowBold: "_syazwdcn"
};
// Background color mapping for Tile component
const $ef39d2750ac3c535$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $ef39d2750ac3c535$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'small', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ieO20.default), {
        size: $ef39d2750ac3c535$var$sizeCrossCompatibleMap[size],
        backgroundColor: $ef39d2750ac3c535$var$backgroundColorMap[appearance],
        label: label,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $hcewu.default)([
                $ef39d2750ac3c535$var$iconColorMap[appearance]
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
                color: "currentColor",
                label: label,
                shouldScale: true
            })
        })
    });
}

});
parcelRegister("ieO20", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a27c3c406dff3d5$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9a27c3c406dff3d5$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6dmuej",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $9a27c3c406dff3d5$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $9a27c3c406dff3d5$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg"
};
const $9a27c3c406dff3d5$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.information': "_bfhk33gi",
    'color.background.information.bold': "_bfhk14wj"
};
function $9a27c3c406dff3d5$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hcewu.default)([
            $9a27c3c406dff3d5$var$styles.root,
            $9a27c3c406dff3d5$var$sizeMap[size],
            isInset ? $9a27c3c406dff3d5$var$styles.inset : $9a27c3c406dff3d5$var$styles.nonInset,
            isInset && $9a27c3c406dff3d5$var$insetSizeMap[size],
            $9a27c3c406dff3d5$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $9a27c3c406dff3d5$var$styles.border
        ]),
        children: children
    });
}

});


parcelRegister("l77v2", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd87b3d482b8dffc$export$2e2bcd8739ae039);
/* icon-tile-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bd87b3d482b8dffc$var$sizeCrossCompatibleMap = {
    // Size mapping from new t-shirt sizes to old pixel sizes
    xsmall: '20',
    small: '24',
    medium: '32',
    large: '40',
    xlarge: '48',
    '16': '16',
    '24': '24',
    '32': '32',
    '40': '40',
    '48': '48'
};
const $bd87b3d482b8dffc$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '20': "_1bsbgktf _4t3igktf",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $bd87b3d482b8dffc$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $bd87b3d482b8dffc$var$shapeMap = {
    square: "_2rko12b0",
    circle: "_2rko1rr0"
};
const $bd87b3d482b8dffc$var$iconTileStyles = null;
function $bd87b3d482b8dffc$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $bd87b3d482b8dffc$var$appearanceMap[appearance],
            $bd87b3d482b8dffc$var$sizeMap[$bd87b3d482b8dffc$var$sizeCrossCompatibleMap[size]],
            $bd87b3d482b8dffc$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});




parcelRegister("4Gz8O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1589456b7a180f6b$export$2e2bcd8739ae039);

var $ihwup = parcelRequire("ihwup");

var $ff2hw = parcelRequire("ff2hw");

var $cPcks = parcelRequire("cPcks");
const $1589456b7a180f6b$var$BlogIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ihwup.default), (0, $ff2hw.default));
$1589456b7a180f6b$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $1589456b7a180f6b$export$2e2bcd8739ae039 = $1589456b7a180f6b$var$BlogIconWithColor;

});
parcelRegister("ihwup", function(module, exports) {
$parcel$export(module.exports, "default", () => $6042983cb1b7627c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df367807ea3d749bb079b0e0d8d07e7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $amerd = parcelRequire("amerd");

var $37A7r = parcelRequire("37A7r");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $6042983cb1b7627c$var$Blog16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37A7r.default), {
            label: label,
            testId: testId
        })
    });
};
$6042983cb1b7627c$var$Blog16Icon.displayName = 'Blog16Icon';
var $6042983cb1b7627c$export$2e2bcd8739ae039 = $6042983cb1b7627c$var$Blog16Icon;

});
parcelRegister("amerd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b5ace82dd4a8965510da799b9153030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78a7288f6e3e8955$var$_react = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78a7288f6e3e8955$var$_baseNew = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78a7288f6e3e8955$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78a7288f6e3e8955$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $78a7288f6e3e8955$var$_react.default.createElement($78a7288f6e3e8955$var$_baseNew.default, Object.assign({
        name: "QuotationMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$78a7288f6e3e8955$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $78a7288f6e3e8955$var$_default = module.exports.default = $78a7288f6e3e8955$var$QuotationMarkIcon;

});

parcelRegister("37A7r", function(module, exports) {
$parcel$export(module.exports, "default", () => $def8fa9bf18a8fbf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d80695634b6b8633a6f9c3274d049f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $def8fa9bf18a8fbf$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$def8fa9bf18a8fbf$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$def8fa9bf18a8fbf$export$2e2bcd8739ae039 = $def8fa9bf18a8fbf$var$Blog16Icon;

});


parcelRegister("ff2hw", function(module, exports) {
$parcel$export(module.exports, "default", () => $674c38c84d40fa8d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86f59a5017849568e2461ddf2a97dfc3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $amerd = parcelRequire("amerd");

var $4HJXf = parcelRequire("4HJXf");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $674c38c84d40fa8d$var$Blog24Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4HJXf.default), {
            label: label,
            testId: testId
        })
    });
};
$674c38c84d40fa8d$var$Blog24Icon.displayName = 'Blog24Icon';
var $674c38c84d40fa8d$export$2e2bcd8739ae039 = $674c38c84d40fa8d$var$Blog24Icon;

});
parcelRegister("4HJXf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ddb48944e405ac0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76374a3eb2dfe12187bd06ac6f27bbbc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $2ddb48944e405ac0$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$2ddb48944e405ac0$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2ddb48944e405ac0$export$2e2bcd8739ae039 = $2ddb48944e405ac0$var$Blog24Icon;

});



parcelRegister("cesFU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lBret").then(()=>parcelRequire('lT9gU'));

});

parcelRegister("2hxmV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c4Piz").then(()=>parcelRequire('b9JjP'));

});

parcelRegister("2vlwA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fJRo2").then(()=>parcelRequire('3JiAU'));

});

parcelRegister("ka9UC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("68koG").then(()=>parcelRequire('htaza'));

});

parcelRegister("4FvfE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gfpt4").then(()=>parcelRequire('idFH3'));

});

parcelRegister("2SUZV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("43EiL").then(()=>parcelRequire('bKXd3'));

});

parcelRegister("htCgV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i35Uh").then(()=>parcelRequire('ccKWN'));

});

parcelRegister("3iL1Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9vjhq").then(()=>parcelRequire('aSnEf'));

});

parcelRegister("dEWSV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j5W60").then(()=>parcelRequire('ju9Zq'));

});

parcelRegister("lGiQr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gHrjT").then(()=>parcelRequire('4BqrB'));

});

parcelRegister("1L06r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hCGN9").then(()=>parcelRequire('cwxjA'));

});

parcelRegister("hSMHC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("igTGi").then(()=>parcelRequire('llYLq'));

});

parcelRegister("1pcgz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8A7Un").then(()=>parcelRequire('bxHzv'));

});

parcelRegister("lt3XL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fnRpB").then(()=>parcelRequire('FXbTY'));

});

parcelRegister("5H4a5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fMJrt").then(()=>parcelRequire('do41j'));

});

parcelRegister("j6e97", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cxAqh").then(()=>parcelRequire('gbtcZ'));

});

parcelRegister("bQ1N4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kvxvv").then(()=>parcelRequire('2j1uF'));

});

parcelRegister("4OxG9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5DW8N").then(()=>parcelRequire('8J7Hh'));

});

parcelRegister("1JRRC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("er5Rw").then(()=>parcelRequire('ktJB5'));

});

parcelRegister("gjbfK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a4ZTh").then(()=>parcelRequire('1O53N'));

});

parcelRegister("jVyke", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fVZub").then(()=>parcelRequire('jYfQG'));

});

parcelRegister("70fC5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("biRPG").then(()=>parcelRequire('gR3IA'));

});

parcelRegister("bUsl4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5PIwW").then(()=>parcelRequire('dmWJ4'));

});

parcelRegister("7MVkC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hy7F8").then(()=>parcelRequire('lR9WO'));

});

parcelRegister("acF2K", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5UA41").then(()=>parcelRequire('aozTf'));

});

parcelRegister("5Z3lN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jQGZH").then(()=>parcelRequire('3mwl5'));

});

parcelRegister("1wvhU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("55GNU").then(()=>parcelRequire('7lmhQ'));

});

parcelRegister("dyxwG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eiZZR").then(()=>parcelRequire('f8Y7f'));

});

parcelRegister("ilCAi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a3170ce3e9e98d41$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8fa2581f41832e0a548115f92f55c28e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $cruFS = parcelRequire("cruFS");

var $7KbsS = parcelRequire("7KbsS");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a3170ce3e9e98d41$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7KbsS.default), {
            label: label,
            testId: testId
        })
    });
};
$a3170ce3e9e98d41$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $a3170ce3e9e98d41$export$2e2bcd8739ae039 = $a3170ce3e9e98d41$var$PageLiveDoc16Icon;

});
parcelRegister("cruFS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90efccf3a3cdec59$var$_react = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90efccf3a3cdec59$var$_baseNew = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90efccf3a3cdec59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90efccf3a3cdec59$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $90efccf3a3cdec59$var$_react.default.createElement($90efccf3a3cdec59$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$90efccf3a3cdec59$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $90efccf3a3cdec59$var$_default = module.exports.default = $90efccf3a3cdec59$var$PageLiveDocIcon;

});

parcelRegister("7KbsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $49cedc712f457d93$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76bc4c9e55d4a44dbde1daaaa1edaeda>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $49cedc712f457d93$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$49cedc712f457d93$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$49cedc712f457d93$export$2e2bcd8739ae039 = $49cedc712f457d93$var$PageLiveDoc16Icon;

});


parcelRegister("hB03j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0bd6bb1ec7db3603$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::978b5bec26f69e0cf3172f4e29696166>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $cruFS = parcelRequire("cruFS");

var $kZFQQ = parcelRequire("kZFQQ");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $0bd6bb1ec7db3603$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kZFQQ.default), {
            label: label,
            testId: testId
        })
    });
};
$0bd6bb1ec7db3603$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $0bd6bb1ec7db3603$export$2e2bcd8739ae039 = $0bd6bb1ec7db3603$var$PageLiveDoc24Icon;

});
parcelRegister("kZFQQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6dc3d78982b295d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b32c11fa9a5f8f7be0a40d85ccb713f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $b6dc3d78982b295d$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m10.555-6.832a1 1 0 0 0-1.545.973l1 7a1 1 0 0 0 1.884.306L17.118 17H20a1 1 0 0 0 .555-1.832z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$b6dc3d78982b295d$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b6dc3d78982b295d$export$2e2bcd8739ae039 = $b6dc3d78982b295d$var$PageLiveDoc24Icon;

});


parcelRegister("8A134", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8qkPR").then(()=>parcelRequire('dci17'));

});

parcelRegister("6cjQd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fbn5L").then(()=>parcelRequire('C9929'));

});

parcelRegister("bNgFX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8ug3B").then(()=>parcelRequire('8BBLJ'));

});

parcelRegister("bAVbi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7eKSC").then(()=>parcelRequire('eHAfU'));

});

parcelRegister("fOxQN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Eivj").then(()=>parcelRequire('gbfWz'));

});

parcelRegister("ekbvS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jYxgH").then(()=>parcelRequire('dRjRH'));

});

parcelRegister("j0sW6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7Asrt").then(()=>parcelRequire('9Vj9G'));

});

parcelRegister("75OGX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lHw2B").then(()=>parcelRequire('eRvGI'));

});

parcelRegister("3aNz8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kjPUS").then(()=>parcelRequire('6l95m'));

});

parcelRegister("4MiqP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iNoMF").then(()=>parcelRequire('fuz0W'));

});

parcelRegister("1Azbr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4oVpa").then(()=>parcelRequire('dn2cU'));

});

parcelRegister("hxTO3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("66VwL").then(()=>parcelRequire('cAlmw'));

});

parcelRegister("lRlMN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("giNlE").then(()=>parcelRequire('9HReW'));

});

parcelRegister("gdaQK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8vZhS").then(()=>parcelRequire('8Pg2Y'));

});

parcelRegister("cH3kb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gLziw")
]).then(()=>parcelRequire('lrD2G'));

});


parcelRegister("44bDi", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$eaff10f7ec59c455);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $wq6W1 = parcelRequire("wq6W1");

var $9kfy2 = parcelRequire("9kfy2");

var $9NiLY = parcelRequire("9NiLY");

var $eGOwo = parcelRequire("eGOwo");

var $5TXKo = parcelRequire("5TXKo");

var $b43DQ = parcelRequire("b43DQ");
const $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $wq6W1.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $b43DQ.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $5c3f03a637d1ec7f$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const state = store ? (0, $9NiLY.getUrl)(store, url) : undefined;
    return (0, $eJOHy.useMemo)(()=>{
        return $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $5c3f03a637d1ec7f$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $5TXKo.useSmartCardState)(url);
    const data = $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("wq6W1", function(module, exports) {
$parcel$export(module.exports, "getResolvedAttributes", () => $05ccd9b6e0c82253$export$7243431f5325a7b);

var $4g7cp = parcelRequire("4g7cp");

var $6jgT3 = parcelRequire("6jgT3");

var $eGOwo = parcelRequire("eGOwo");
const $05ccd9b6e0c82253$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $4g7cp.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $6jgT3.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("6jgT3", function(module, exports) {
$parcel$export(module.exports, "getDisplayCategory", () => $e94b2157750adb74$export$28ddbae335bd80b5);
const $e94b2157750adb74$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});


parcelRegister("9NiLY", function(module, exports) {
$parcel$export(module.exports, "getUrl", () => $ab3ef581aa51838e$export$94df0e59ebebf4a7);
const $ab3ef581aa51838e$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});


parcelRegister("1YI3f", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiCard", () => $ec5109f5e7b621c7$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isStyleCacheProvider", () => $ec5109f5e7b621c7$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $ec5109f5e7b621c7$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $ec5109f5e7b621c7$export$c0547b4405cae584);

var $eJOHy = parcelRequire("eJOHy");

var $34CM9 = parcelRequire("34CM9");
var $fqBfo = parcelRequire("fqBfo");
var $8Rjtc = parcelRequire("8Rjtc");
var $lAF2k = parcelRequire("lAF2k");

var $4RG9i = parcelRequire("4RG9i");
const $ec5109f5e7b621c7$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children)?.length > 0 ? true : false;
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).some((child)=>$ec5109f5e7b621c7$export$df0092b19156b140(child))) return true;
    return false;
};
const $ec5109f5e7b621c7$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($34CM9).some((type)=>type === node.type)) return true;
    return false;
};
const $ec5109f5e7b621c7$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (Object.values($4RG9i).some((type)=>type === node.type)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $fqBfo.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $8Rjtc.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $lAF2k.default);

});
parcelRegister("34CM9", function(module, exports) {
$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("lAF2k")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gKsxm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("8Rjtc")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("5gb8b")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("fqBfo")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("bIdM1")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("3pcXQ")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("2qnEp")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("eMgzj")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("4cjOx")).default);

var $lAF2k = parcelRequire("lAF2k");

var $gKsxm = parcelRequire("gKsxm");

var $8Rjtc = parcelRequire("8Rjtc");

var $5gb8b = parcelRequire("5gb8b");

var $fqBfo = parcelRequire("fqBfo");

var $bIdM1 = parcelRequire("bIdM1");

var $3pcXQ = parcelRequire("3pcXQ");

var $2qnEp = parcelRequire("2qnEp");

var $eMgzj = parcelRequire("eMgzj");

var $4cjOx = parcelRequire("4cjOx");

});
parcelRegister("lAF2k", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b59a3b7a9f7670d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3pcXQ = parcelRequire("3pcXQ");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $9b59a3b7a9f7670d$var$FooterBlock = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $9b59a3b7a9f7670d$export$2e2bcd8739ae039 = $9b59a3b7a9f7670d$var$FooterBlock;

});
parcelRegister("5FRJ8", function(module, exports) {
$parcel$export(module.exports, "FlexibleCardContext", () => $26ead80b20537add$export$13dde4423ab71d62);
$parcel$export(module.exports, "useFlexibleCardContext", () => $26ead80b20537add$export$a8c4167e4e9f26ab);
$parcel$export(module.exports, "useFlexibleUiContext", () => $26ead80b20537add$export$61d7957a243df7aa);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $26ead80b20537add$export$e6b5ad18b56e8f51);

var $eJOHy = parcelRequire("eJOHy");
const $26ead80b20537add$export$13dde4423ab71d62 = (0, $eJOHy.createContext)(undefined);
const $26ead80b20537add$export$a8c4167e4e9f26ab = ()=>(0, $eJOHy.useContext)($26ead80b20537add$export$13dde4423ab71d62);
const $26ead80b20537add$export$61d7957a243df7aa = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.data;
const $26ead80b20537add$export$e6b5ad18b56e8f51 = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.ui;

});

parcelRegister("3pcXQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $462a2917906f3b08$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $6P8F3 = parcelRequire("6P8F3");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $462a2917906f3b08$var$actionGroupStyles = null;
const $462a2917906f3b08$var$safariStyles = null;
const $462a2917906f3b08$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5NtHI.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const hasActions = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                testId: "smart-element-group-actions",
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                className: (0, $hcewu.default)([
                    size === (0, $5NtHI.SmartLinkSize).XLarge && "_c71lxy5q",
                    safari && "_4t3i1osq"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $462a2917906f3b08$export$2e2bcd8739ae039 = $462a2917906f3b08$var$FooterBlockResolvedView;

});
parcelRegister("6l7Bk", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a8115736e8f2ac6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $2a8115736e8f2ac6$var$ProviderElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Provider
    }) : null;
};
var $2a8115736e8f2ac6$export$2e2bcd8739ae039 = $2a8115736e8f2ac6$var$ProviderElement;

});
parcelRegister("4XCp5", function(module, exports) {
$parcel$export(module.exports, "default", () => $e83b25175c466aed$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toBadgeProps", () => $e83b25175c466aed$export$a2fb457791942ba4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $e83b25175c466aed$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $e83b25175c466aed$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $e83b25175c466aed$var$messageMapper = {
    [(0, $5NtHI.IconType).PriorityBlocker]: (0, $19nmp.messages).priority_blocker,
    [(0, $5NtHI.IconType).PriorityCritical]: (0, $19nmp.messages).priority_critical,
    [(0, $5NtHI.IconType).PriorityHigh]: (0, $19nmp.messages).priority_high,
    [(0, $5NtHI.IconType).PriorityHighest]: (0, $19nmp.messages).priority_highest,
    [(0, $5NtHI.IconType).PriorityLow]: (0, $19nmp.messages).priority_low,
    [(0, $5NtHI.IconType).PriorityLowest]: (0, $19nmp.messages).priority_lowest,
    [(0, $5NtHI.IconType).PriorityMajor]: (0, $19nmp.messages).priority_major,
    [(0, $5NtHI.IconType).PriorityMedium]: (0, $19nmp.messages).priority_medium,
    [(0, $5NtHI.IconType).PriorityMinor]: (0, $19nmp.messages).priority_minor,
    [(0, $5NtHI.IconType).PriorityTrivial]: (0, $19nmp.messages).priority_trivial,
    [(0, $5NtHI.IconType).PriorityUndefined]: (0, $19nmp.messages).priority_undefined
};
const $e83b25175c466aed$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $e83b25175c466aed$var$messageMapper[icon];
        if (descriptor) return (0, $fQH39.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $e83b25175c466aed$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $e83b25175c466aed$var$renderImageIcon = (url, testId, hideLoadingSkeleton)=>{
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        testId: testId,
        url: url,
        hideLoadingSkeleton: (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideLoadingSkeleton
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BaseBadgeElementProps} BaseBadgeElementProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $e83b25175c466aed$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color }, ref)=>{
    const ui = (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FRJ8.useFlexibleUiOptionContext)() : undefined;
    const formattedMessageOrLabel = $e83b25175c466aed$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $e83b25175c466aed$var$renderAtlaskitIcon(icon, testId) || $e83b25175c466aed$var$renderImageIcon(url, testId, ui?.hideLoadingSkeleton);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $hcewu.default)([
            $e83b25175c466aed$var$styles.container,
            $e83b25175c466aed$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                xcss: $e83b25175c466aed$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $e83b25175c466aed$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
var $e83b25175c466aed$export$2e2bcd8739ae039 = (0, $9jYtV.withOverrideCss)($e83b25175c466aed$var$BaseBadgeRefreshNew);
const $e83b25175c466aed$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};

});
parcelRegister("b4zhV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6d5d1de8f417451$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $lgMTT = parcelRequire("lgMTT");

var $4Gz8O = parcelRequire("4Gz8O");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $d6d5d1de8f417451$var$getIconImportFn = (icon, size)=>{
    const item = (0, $FoFt2.getLazyIcons)()[icon];
    if ((0, $FoFt2.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $d6d5d1de8f417451$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $d6d5d1de8f417451$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $5NtHI.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $5NtHI.IconType).Document:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).Blog:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $d6d5d1de8f417451$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $d6d5d1de8f417451$var$importIcon(importFn);
    switch(icon){
        case (0, $5NtHI.IconType).Confluence:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5NtHI.IconType).Jira:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5NtHI.IconType).Error:
        case (0, $5NtHI.IconType).Forbidden:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                size: size
            });
    }
};
var $d6d5d1de8f417451$export$2e2bcd8739ae039 = $d6d5d1de8f417451$var$AtlaskitIcon;

});
parcelRegister("9020Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9e6bf288701895f$export$2e2bcd8739ae039);

var $ilCAi = parcelRequire("ilCAi");

var $hB03j = parcelRequire("hB03j");

var $cPcks = parcelRequire("cPcks");
const $d9e6bf288701895f$var$LiveDocumentIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ilCAi.default), (0, $hB03j.default));
$d9e6bf288701895f$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $d9e6bf288701895f$export$2e2bcd8739ae039 = $d9e6bf288701895f$var$LiveDocumentIconWithColor;

});


parcelRegister("67ulW", function(module, exports) {
$parcel$export(module.exports, "default", () => $78e2ae224831a17c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2HNHt = parcelRequire("2HNHt");

var $65mpR = parcelRequire("65mpR");
const $78e2ae224831a17c$var$styles = {
    roundImg: "_2rko1rr0"
};
const $78e2ae224831a17c$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If url changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton) return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: "",
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $hcewu.default)([
            appearance === 'round' && $78e2ae224831a17c$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: url,
        loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: "",
            style: {
                width: width,
                height: height
            },
            className: (0, $hcewu.default)([
                appearance === 'round' && $78e2ae224831a17c$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $78e2ae224831a17c$export$2e2bcd8739ae039 = $78e2ae224831a17c$var$ImageIcon;

});
parcelRegister("2HNHt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1f862656e4ed4164$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eJOHy = parcelRequire("eJOHy");
var $1f862656e4ed4164$var$React = $1f862656e4ed4164$var$_interopRequireWildcard($eJOHy);
function $1f862656e4ed4164$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1f862656e4ed4164$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1f862656e4ed4164$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1f862656e4ed4164$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $1f862656e4ed4164$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $1f862656e4ed4164$var$loaded() {
    return {
        isLoaded: true
    };
}
function $1f862656e4ed4164$var$errored() {
    return {
        isErrored: true
    };
}
function $1f862656e4ed4164$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $1f862656e4ed4164$var$ImageRenderer = function(_React$Component) {
    $1f862656e4ed4164$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $1f862656e4ed4164$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $1f862656e4ed4164$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $1f862656e4ed4164$var$_possibleConstructorReturn(_this, _ret);
    }
    $1f862656e4ed4164$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(this.props, nextProps)) this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($1f862656e4ed4164$var$React.Component);
module.exports.default = $1f862656e4ed4164$var$ImageRenderer;

});

parcelRegister("65mpR", function(module, exports) {
$parcel$export(module.exports, "LoadingSkeleton", () => $dc3223680a49307e$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dc3223680a49307e$var$animationNameStyles = null;
const $dc3223680a49307e$var$loadingSkeletonStyle = null;
const $dc3223680a49307e$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $hcewu.default)([
            "_2rkolb4i _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("9jYtV", function(module, exports) {
$parcel$export(module.exports, "withOverrideCss", () => $641d28b8590b444f$export$e0bdcacb944f1da6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $641d28b8590b444f$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $eJOHy.useRef)(null);
        (0, $eJOHy.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});

parcelRegister("fQH39", function(module, exports) {
$parcel$export(module.exports, "sizeToButtonSpacing", () => $18f1b25c1730b97c$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $18f1b25c1730b97c$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $18f1b25c1730b97c$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidth", () => $18f1b25c1730b97c$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $18f1b25c1730b97c$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $18f1b25c1730b97c$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $18f1b25c1730b97c$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $18f1b25c1730b97c$export$619e376a425cb759);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $joSn0 = parcelRequire("joSn0");

var $5NtHI = parcelRequire("5NtHI");
const $18f1b25c1730b97c$export$9d642f65a919fb93 = {
    [(0, $5NtHI.SmartLinkSize).Small]: 'none',
    [(0, $5NtHI.SmartLinkSize).Medium]: 'compact',
    [(0, $5NtHI.SmartLinkSize).Large]: 'compact',
    [(0, $5NtHI.SmartLinkSize).XLarge]: 'default'
};
const $18f1b25c1730b97c$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        });
    }
};
const $18f1b25c1730b97c$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $18f1b25c1730b97c$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $18f1b25c1730b97c$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $18f1b25c1730b97c$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1.75;
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $18f1b25c1730b97c$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $18f1b25c1730b97c$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5NtHI.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $18f1b25c1730b97c$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("6P8F3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6bccbbfb4f78611$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $48q59 = parcelRequire("48q59");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");

var $aMdh8 = parcelRequire("aMdh8");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $brTAh = parcelRequire("brTAh");

var $a86OV = parcelRequire("a86OV");
const $a6bccbbfb4f78611$var$styles = null;
const $a6bccbbfb4f78611$var$renderActionItems = (items = [], size = (0, $5NtHI.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $a86OV.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $a6bccbbfb4f78611$var$ActionGroup = ({ items: items = [], size: size = (0, $5NtHI.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gRw8I.di)((0, $7rjYb.default));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const renderableActionItems = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $eJOHy.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $eJOHy.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fQH39.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).more_actions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $48q59.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $a6bccbbfb4f78611$export$2e2bcd8739ae039 = $a6bccbbfb4f78611$var$ActionGroup;

});
parcelRegister("brTAh", function(module, exports) {
$parcel$export(module.exports, "filterActionItems", () => $a0fe758b77d980f4$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $a0fe758b77d980f4$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $a0fe758b77d980f4$export$9678d3ca18bd7526);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $1YI3f = parcelRequire("1YI3f");

var $4RG9i = parcelRequire("4RG9i");

var $6P8F3 = parcelRequire("6P8F3");

var $k8J0S = parcelRequire("k8J0S");
const $a0fe758b77d980f4$export$f942619ce67b1a41 = {
    [(0, $5NtHI.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Location]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Preview]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).State]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Title]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).VoteCount]: [
        'inline'
    ]
};
const $a0fe758b77d980f4$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1;
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 0.5;
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $a0fe758b77d980f4$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $6P8F3.default);
const $a0fe758b77d980f4$var$isElementDisplayValid = (name, display)=>{
    return $a0fe758b77d980f4$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $a0fe758b77d980f4$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $a0fe758b77d980f4$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && ((0, $1YI3f.isFlexibleUiElement)(node) || node.type === (0, $k8J0S.default));
const $a0fe758b77d980f4$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5NtHI.ActionName).DeleteAction:
            case (0, $5NtHI.ActionName).EditAction:
            case (0, $5NtHI.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5NtHI.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $a0fe758b77d980f4$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if ($a0fe758b77d980f4$var$isElementOrElementGroup(child) || $a0fe758b77d980f4$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $a0fe758b77d980f4$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $4RG9i[name];
        const typedProps = props;
        if (Element && $a0fe758b77d980f4$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $gt9Am.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$a0fe758b77d980f4$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("4RG9i", function(module, exports) {
$parcel$export(module.exports, "AssignedTo", () => (parcelRequire("9Xcvc")).default);
$parcel$export(module.exports, "AssignedToGroup", () => (parcelRequire("41Mwl")).default);
$parcel$export(module.exports, "AttachmentCount", () => (parcelRequire("lVTJZ")).default);
$parcel$export(module.exports, "AuthorGroup", () => (parcelRequire("gl0Fx")).default);
$parcel$export(module.exports, "ChecklistProgress", () => (parcelRequire("iCDdz")).default);
$parcel$export(module.exports, "CollaboratorGroup", () => (parcelRequire("cSuZU")).default);
$parcel$export(module.exports, "CommentCount", () => (parcelRequire("gA3VJ")).default);
$parcel$export(module.exports, "CreatedOn", () => (parcelRequire("aiy2i")).default);
$parcel$export(module.exports, "CreatedBy", () => (parcelRequire("k4xpX")).default);
$parcel$export(module.exports, "DueOn", () => (parcelRequire("kCe9K")).default);
$parcel$export(module.exports, "LatestCommit", () => (parcelRequire("kB4Nm")).default);
$parcel$export(module.exports, "LinkIcon", () => (parcelRequire("jPfaa")).default);
$parcel$export(module.exports, "Location", () => (parcelRequire("2Bqsd")).default);
$parcel$export(module.exports, "ModifiedBy", () => (parcelRequire("1FNi6")).default);
$parcel$export(module.exports, "ModifiedOn", () => (parcelRequire("81kl8")).default);
$parcel$export(module.exports, "OwnedBy", () => (parcelRequire("946bQ")).default);
$parcel$export(module.exports, "OwnedByGroup", () => (parcelRequire("4Nd99")).default);
$parcel$export(module.exports, "Preview", () => (parcelRequire("7Byzo")).default);
$parcel$export(module.exports, "Priority", () => (parcelRequire("5kUaD")).default);
$parcel$export(module.exports, "ProgrammingLanguage", () => (parcelRequire("8MxlB")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("6l7Bk")).default);
$parcel$export(module.exports, "ReactCount", () => (parcelRequire("lwvSM")).default);
$parcel$export(module.exports, "ReadTime", () => (parcelRequire("2ITMK")).default);
$parcel$export(module.exports, "SentOn", () => (parcelRequire("iw2r2")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("f7w3l")).default);
$parcel$export(module.exports, "SourceBranch", () => (parcelRequire("6Po2h")).default);
$parcel$export(module.exports, "State", () => (parcelRequire("4U5iq")).default);
$parcel$export(module.exports, "SubscriberCount", () => (parcelRequire("jJD7c")).default);
$parcel$export(module.exports, "SubTasksProgress", () => (parcelRequire("7mGkc")).default);
$parcel$export(module.exports, "StoryPoints", () => (parcelRequire("w1OaX")).default);
$parcel$export(module.exports, "TargetBranch", () => (parcelRequire("cwvSG")).default);
$parcel$export(module.exports, "TeamMemberCount", () => (parcelRequire("2j4b1")).default);
$parcel$export(module.exports, "Title", () => (parcelRequire("i6ktq")).default);
$parcel$export(module.exports, "UserAttributes", () => (parcelRequire("iQvIm")).default);
$parcel$export(module.exports, "ViewCount", () => (parcelRequire("bApaO")).default);
$parcel$export(module.exports, "VoteCount", () => (parcelRequire("1IQ2A")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("lJDNU")).default);
$parcel$export(module.exports, "CustomByAccessTypeElement", () => (parcelRequire("i4NpI")).default);
$parcel$export(module.exports, "CustomByStatusElement", () => (parcelRequire("5d1ks")).default);

var $9Xcvc = parcelRequire("9Xcvc");

var $41Mwl = parcelRequire("41Mwl");

var $lVTJZ = parcelRequire("lVTJZ");

var $gl0Fx = parcelRequire("gl0Fx");

var $iCDdz = parcelRequire("iCDdz");

var $cSuZU = parcelRequire("cSuZU");

var $gA3VJ = parcelRequire("gA3VJ");

var $aiy2i = parcelRequire("aiy2i");

var $k4xpX = parcelRequire("k4xpX");

var $kCe9K = parcelRequire("kCe9K");

var $kB4Nm = parcelRequire("kB4Nm");

var $jPfaa = parcelRequire("jPfaa");

var $2Bqsd = parcelRequire("2Bqsd");

var $1FNi6 = parcelRequire("1FNi6");

var $81kl8 = parcelRequire("81kl8");

var $946bQ = parcelRequire("946bQ");

var $4Nd99 = parcelRequire("4Nd99");

var $7Byzo = parcelRequire("7Byzo");

var $5kUaD = parcelRequire("5kUaD");

var $8MxlB = parcelRequire("8MxlB");

var $6l7Bk = parcelRequire("6l7Bk");

var $lwvSM = parcelRequire("lwvSM");

var $2ITMK = parcelRequire("2ITMK");

var $iw2r2 = parcelRequire("iw2r2");

var $f7w3l = parcelRequire("f7w3l");

var $6Po2h = parcelRequire("6Po2h");

var $4U5iq = parcelRequire("4U5iq");

var $jJD7c = parcelRequire("jJD7c");

var $7mGkc = parcelRequire("7mGkc");

var $w1OaX = parcelRequire("w1OaX");

var $cwvSG = parcelRequire("cwvSG");

var $2j4b1 = parcelRequire("2j4b1");

var $i6ktq = parcelRequire("i6ktq");

var $iQvIm = parcelRequire("iQvIm");

var $bApaO = parcelRequire("bApaO");

var $1IQ2A = parcelRequire("1IQ2A");

var $lJDNU = parcelRequire("lJDNU");

var $i4NpI = parcelRequire("i4NpI");

var $5d1ks = parcelRequire("5d1ks");

});
parcelRegister("9Xcvc", function(module, exports) {
$parcel$export(module.exports, "default", () => $68e65e4967ed5bbb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $68e65e4967ed5bbb$var$AssignedToElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedTo
    }) : null;
};
var $68e65e4967ed5bbb$export$2e2bcd8739ae039 = $68e65e4967ed5bbb$var$AssignedToElement;

});
parcelRegister("38cBa", function(module, exports) {
$parcel$export(module.exports, "default", () => $6311575d89bb2b6b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toFormattedTextProps", () => $6311575d89bb2b6b$export$b9738bf28fb14829);
$parcel$export(module.exports, "toTextProps", () => $6311575d89bb2b6b$export$f12aecc78be3c7bb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $fQH39 = parcelRequire("fQH39");
const $6311575d89bb2b6b$var$baseStyle = null;
const $6311575d89bb2b6b$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
const $6311575d89bb2b6b$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $fQH39.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && $6311575d89bb2b6b$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $awdRS.default)(maxLines)
        },
        children: formattedContent
    });
};
var $6311575d89bb2b6b$export$2e2bcd8739ae039 = $6311575d89bb2b6b$export$79422073c7118b5b;
const $6311575d89bb2b6b$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};
const $6311575d89bb2b6b$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};

});


parcelRegister("41Mwl", function(module, exports) {
$parcel$export(module.exports, "default", () => $54562c55fd1b3586$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $54562c55fd1b3586$var$AssignedToGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedToGroup
    }) : null;
};
var $54562c55fd1b3586$export$2e2bcd8739ae039 = $54562c55fd1b3586$var$AssignedToGroupElement;

});
parcelRegister("vUns3", function(module, exports) {
$parcel$export(module.exports, "default", () => $672b014d8429d73d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAvatarGroupProps", () => $672b014d8429d73d$export$91ba8651475968bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $gqBnP = parcelRequire("gqBnP");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $fQH39 = parcelRequire("fQH39");
const $672b014d8429d73d$var$styles = null;
const $672b014d8429d73d$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5NtHI.ElementName).AssignedToGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).assigned_to, personName);
        case (0, $5NtHI.ElementName).OwnedByGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).owned_by, personName);
        case (0, $5NtHI.ElementName).AuthorGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {BaseAvatarGroupElementProps} BaseAvatarGroupElementProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $672b014d8429d73d$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $lRq8t.default)();
    const data = (0, $eJOHy.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5NtHI.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $672b014d8429d73d$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...(0, $eGOwo.fg)('platform-linking-enable-avatar-data-separator') ? {
            ['data-separator']: true
        } : {},
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $672b014d8429d73d$export$2e2bcd8739ae039 = $672b014d8429d73d$var$BaseAvatarGroup;
const $672b014d8429d73d$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};

});


parcelRegister("lVTJZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca273e569a0c1d25$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $ca273e569a0c1d25$var$AttachmentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AttachmentCount
    }) : null;
};
var $ca273e569a0c1d25$export$2e2bcd8739ae039 = $ca273e569a0c1d25$var$AttachmentCountElement;

});

parcelRegister("gl0Fx", function(module, exports) {
$parcel$export(module.exports, "default", () => $5186dee07e48afde$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $5186dee07e48afde$var$AuthorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AuthorGroup
    }) : null;
};
var $5186dee07e48afde$export$2e2bcd8739ae039 = $5186dee07e48afde$var$AuthorGroupElement;

});

parcelRegister("iCDdz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e60145f3c4ab217$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $0e60145f3c4ab217$var$ChecklistProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }) : null;
};
var $0e60145f3c4ab217$export$2e2bcd8739ae039 = $0e60145f3c4ab217$var$ChecklistProgressElement;

});

parcelRegister("cSuZU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3e78c51e7c53936$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $b3e78c51e7c53936$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CollaboratorGroup
    }) : null;
};
var $b3e78c51e7c53936$export$2e2bcd8739ae039 = $b3e78c51e7c53936$var$CollaboratorGroupElement;

});

parcelRegister("gA3VJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $55e7c0307b507f46$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $55e7c0307b507f46$var$CommentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.commentCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).CommentCount
    }) : null;
};
var $55e7c0307b507f46$export$2e2bcd8739ae039 = $55e7c0307b507f46$var$CommentCountElement;

});

parcelRegister("aiy2i", function(module, exports) {
$parcel$export(module.exports, "default", () => $932490ed3e7f327b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $932490ed3e7f327b$var$CreatedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedOn
    }) : null;
};
var $932490ed3e7f327b$export$2e2bcd8739ae039 = $932490ed3e7f327b$var$CreatedOnElement;

});
parcelRegister("aKX5a", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb039ade903c50b2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateTimeProps", () => $cb039ade903c50b2$export$2d4384e6b150cbe3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6wSDf = parcelRequire("6wSDf");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $19nmp = parcelRequire("19nmp");
const $cb039ade903c50b2$var$styles = null;
const $cb039ade903c50b2$var$typeToDescriptorMap = {
    created: {
        relative: (0, $19nmp.messages).created_on_relative,
        absolute: (0, $19nmp.messages).created_on_absolute
    },
    modified: {
        relative: (0, $19nmp.messages).modified_on_relative,
        absolute: (0, $19nmp.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $19nmp.messages).sent_on_relative,
        absolute: (0, $19nmp.messages).sent_on_absolute
    }
};
const $cb039ade903c50b2$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {BaseDateTimeElementProps} BaseDateTimeElementProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $cb039ade903c50b2$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $lRq8t.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $6wSDf.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...$cb039ade903c50b2$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && $cb039ade903c50b2$var$fontOverrideStyleMap[fontSize],
            className
        ]),
        children: content
    });
};
var $cb039ade903c50b2$export$2e2bcd8739ae039 = $cb039ade903c50b2$var$BaseDateTimeElement;
const $cb039ade903c50b2$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};

});


parcelRegister("k4xpX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f3b49272a6afc71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $3f3b49272a6afc71$var$CreatedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedBy
    }) : null;
};
var $3f3b49272a6afc71$export$2e2bcd8739ae039 = $3f3b49272a6afc71$var$CreatedByElement;

});

parcelRegister("kCe9K", function(module, exports) {
$parcel$export(module.exports, "default", () => $805a1aa3004ae832$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $805a1aa3004ae832$var$DueOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $cmzNL.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).DueOn
    }) : null;
};
var $805a1aa3004ae832$export$2e2bcd8739ae039 = $805a1aa3004ae832$var$DueOnElement;

});
parcelRegister("cmzNL", function(module, exports) {
$parcel$export(module.exports, "default", () => $351b36f187c69d22$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateLozengeProps", () => $351b36f187c69d22$export$8f9f58f7bac50fbe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7qGN1 = parcelRequire("7qGN1");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4Frd9 = parcelRequire("4Frd9");
const $351b36f187c69d22$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $351b36f187c69d22$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Frd9.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
        appearance: appearance,
        ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $351b36f187c69d22$export$2e2bcd8739ae039 = $351b36f187c69d22$var$BaseLozengeElement;
const $351b36f187c69d22$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qGN1.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};

});
parcelRegister("4Frd9", function(module, exports) {
$parcel$export(module.exports, "default", () => $9074bb98cbadc69e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $EtcI0 = parcelRequire("EtcI0");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $CpyFM = parcelRequire("CpyFM");

var $b43DQ = parcelRequire("b43DQ");

var $hxkmu = parcelRequire("hxkmu");

var $e9seM = parcelRequire("e9seM");

var $5iuU7 = parcelRequire("5iuU7");

var $4dVhH = parcelRequire("4dVhH");

var $htuxE = parcelRequire("htuxE");

var $dsXZb = parcelRequire("dsXZb");
const $9074bb98cbadc69e$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $9074bb98cbadc69e$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $eJOHy.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [items, setItems] = (0, $eJOHy.useState)();
    const [errorMessage, setErrorMessage] = (0, $eJOHy.useState)();
    const reload = (0, $kbv8x.default)();
    const invoke = (0, $6O4ri.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $eJOHy.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $EtcI0.default));
                const validItems = typeof text === 'string' ? $9074bb98cbadc69e$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? (0, $4dVhH.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $4dVhH.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dsXZb.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $eJOHy.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $CpyFM.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $d0InI.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $eJOHy.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5iuU7.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $htuxE.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $9074bb98cbadc69e$export$2e2bcd8739ae039 = (0, $hxkmu.default)($9074bb98cbadc69e$var$LozengeAction);

});
parcelRegister("EtcI0", function(module, exports) {
$parcel$export(module.exports, "default", () => $377731e831492625$export$2e2bcd8739ae039);
const $377731e831492625$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $377731e831492625$export$2e2bcd8739ae039 = $377731e831492625$var$extractLozengeActionItems;

});

parcelRegister("6O4ri", function(module, exports) {
$parcel$export(module.exports, "default", () => $b69a1ac7b939ac3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $18BbB = parcelRequire("18BbB");

var $9kfy2 = parcelRequire("9kfy2");
const $b69a1ac7b939ac3b$var$useInvoke = ()=>{
    const { connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const clientExt = (0, $18BbB.useSmartLinkClientExtension)(connections.client);
    return (0, $eJOHy.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $b69a1ac7b939ac3b$export$2e2bcd8739ae039 = $b69a1ac7b939ac3b$var$useInvoke;

});
parcelRegister("18BbB", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkClientExtension", () => $365002b9ec3223b9$export$303ede4eed148855);

var $eJOHy = parcelRequire("eJOHy");

var $hhFie = parcelRequire("hhFie");

var $5CgrK = parcelRequire("5CgrK");

var $jAAbh = parcelRequire("jAAbh");
const $365002b9ec3223b9$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $jAAbh.useResolverUrl)(cardClient);
    const invoke = (0, $eJOHy.useCallback)(async (data)=>{
        try {
            return await (0, $hhFie.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $5CgrK.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("hhFie", function(module, exports) {
$parcel$export(module.exports, "NetworkError", () => $3c4f8f7f5313e518$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $3c4f8f7f5313e518$export$b5fe3f66a567bec0);
const $3c4f8f7f5313e518$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $3c4f8f7f5313e518$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $3c4f8f7f5313e518$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $3c4f8f7f5313e518$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $3c4f8f7f5313e518$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("5CgrK", function(module, exports) {
$parcel$export(module.exports, "SmartLinkActionType", () => $1ec6011516cb04bd$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $1ec6011516cb04bd$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $1ec6011516cb04bd$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $1ec6011516cb04bd$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("jAAbh", function(module, exports) {
$parcel$export(module.exports, "useResolverUrl", () => $248dfa90412a2e2f$export$d08617a365fbe694);

var $eJOHy = parcelRequire("eJOHy");

var $a5MXk = parcelRequire("a5MXk");
const $248dfa90412a2e2f$export$d08617a365fbe694 = (cardClient)=>(0, $eJOHy.useMemo)(()=>(0, $a5MXk.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});
parcelRegister("a5MXk", function(module, exports) {
$parcel$export(module.exports, "getBaseUrl", () => $b154de42c200dbd4$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $b154de42c200dbd4$export$dc37652c1696f231);
const $b154de42c200dbd4$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $b154de42c200dbd4$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $b154de42c200dbd4$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $b154de42c200dbd4$export$e2b040f052407032 = {
    dev: $b154de42c200dbd4$var$devBaseUrl,
    development: $b154de42c200dbd4$var$devBaseUrl,
    stg: $b154de42c200dbd4$var$stgBaseUrl,
    staging: $b154de42c200dbd4$var$stgBaseUrl,
    prd: $b154de42c200dbd4$var$prodBaseUrl,
    prod: $b154de42c200dbd4$var$prodBaseUrl,
    production: $b154de42c200dbd4$var$prodBaseUrl
};
const $b154de42c200dbd4$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? $b154de42c200dbd4$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $b154de42c200dbd4$export$e2b040f052407032 ? $b154de42c200dbd4$export$e2b040f052407032[envKey] : $b154de42c200dbd4$var$prodBaseUrl;
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $b154de42c200dbd4$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $b154de42c200dbd4$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $b154de42c200dbd4$export$2e2bcd8739ae039 = $b154de42c200dbd4$export$e2b040f052407032;

});




parcelRegister("d0InI", function(module, exports) {
$parcel$export(module.exports, "getInvokeFailureReason", () => $842afed3b5601c74$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $842afed3b5601c74$export$1694272377fa07d8);

var $b43DQ = parcelRequire("b43DQ");
const $842afed3b5601c74$export$65b3f792dff0bd60 = (err)=>{
    if (!$842afed3b5601c74$export$1694272377fa07d8(err)) return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $b43DQ.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    }
};
const $842afed3b5601c74$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("CpyFM", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cb2d7fc7fdf8041$export$2e2bcd8739ae039);
const $7cb2d7fc7fdf8041$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $7cb2d7fc7fdf8041$export$2e2bcd8739ae039 = $7cb2d7fc7fdf8041$var$createStatusUpdateRequest;

});

parcelRegister("hxkmu", function(module, exports) {
$parcel$export(module.exports, "default", () => $808be4e18c85f3f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $808be4e18c85f3f4$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: props?.appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props
            })
        });
    };
var $808be4e18c85f3f4$export$2e2bcd8739ae039 = $808be4e18c85f3f4$var$withErrorBoundary;

});

parcelRegister("e9seM", function(module, exports) {
$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$618660b8f2aa87e2);
const $20533813e4fe1916$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $20533813e4fe1916$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $20533813e4fe1916$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $20533813e4fe1916$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("5iuU7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bafe1b037124149$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $kDaaB = parcelRequire("kDaaB");

var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $1NG86 = parcelRequire("1NG86");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $7xssH = parcelRequire("7xssH");

var $fQH39 = parcelRequire("fQH39");
const $1bafe1b037124149$var$MAX_LINE_NUMBER = 8;
const $1bafe1b037124149$var$styles = {
    contentStyles: "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt",
    linkStyles: "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o",
    textStylesBase: "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
    dropdownItemGroupStyles: "_14hp1wdt _6pup1kw7 _1eo073ad",
    openIssueInJiraStyles: "_11c82smr _bfhk18uv _1bah1e5h _1e0c1kw7 _syaz14q2 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1 _30l316c2"
};
const $1bafe1b037124149$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $1bafe1b037124149$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const invoke = (0, $7xssH.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $eJOHy.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $1bafe1b037124149$var$styles.contentStyles
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $hcewu.default)([
                                $1bafe1b037124149$var$styles.textStylesBase,
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $awdRS.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fQH39.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1bafe1b037124149$var$styles.linkStyles
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                        testId: `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        xcss: $1bafe1b037124149$var$styles.openIssueInJiraStyles,
                        children: (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $hcewu.default)([
            $1bafe1b037124149$var$styles.dropdownItemGroupStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $1bafe1b037124149$export$2e2bcd8739ae039 = $1bafe1b037124149$var$LozengeActionError;

});
var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';


parcelRegister("4dVhH", function(module, exports) {
$parcel$export(module.exports, "LozengeActionErrorMessages", () => $d6614d1ef8f5be72$export$4f2e371a667ad688);

var $19nmp = parcelRequire("19nmp");
const $d6614d1ef8f5be72$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $19nmp.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $19nmp.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $19nmp.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $19nmp.messages)['status_change_update_error']
    }
};

});

parcelRegister("htuxE", function(module, exports) {
$parcel$export(module.exports, "default", () => $df529be6a716333d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aLJ1L = parcelRequire("aLJ1L");

var $aDuBe = parcelRequire("aDuBe");
const $df529be6a716333d$var$dropdownItemGroupStyles = null;
const $df529be6a716333d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $hcewu.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $eJOHy.createElement)((0, $aDuBe.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $df529be6a716333d$export$2e2bcd8739ae039 = $df529be6a716333d$var$LozengeActionItemsGroup;

});
parcelRegister("aDuBe", function(module, exports) {
$parcel$export(module.exports, "default", () => $f377c3a55bec1fd7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $f377c3a55bec1fd7$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        role: "presentation",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    });
};
var $f377c3a55bec1fd7$export$2e2bcd8739ae039 = $f377c3a55bec1fd7$var$LozengeActionItem;

});


parcelRegister("dsXZb", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d29b99195ec403c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $5lAAn = parcelRequire("5lAAn");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $8d29b99195ec403c$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rko12b0 _1dqonqa1 _189ee4h9 _1h6d3acm _bfhk18uv _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1p6i"
};
const $8d29b99195ec403c$var$triggerLozengeStyles = null;
const $8d29b99195ec403c$var$triggerButtonStyles = null;
const $8d29b99195ec403c$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isHovering, setIsHovering] = (0, $eJOHy.useState)(false);
    const [isPressing, setIsPressing] = (0, $eJOHy.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $eJOHy.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $eJOHy.useState)(undefined);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>setIsHovering(true), []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>setIsHovering(false), []);
    const onMouseOrKeyDown = (0, $eJOHy.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $eJOHy.useCallback)(()=>setIsPressing(false), []);
    (0, $eJOHy.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #85B8FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else if (isOpen) {
            if (isHovering) setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CCE0FF)");
            else setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen,
        isHovering
    ]);
    const lozenge = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: (0, $k0ahr.cx)($8d29b99195ec403c$var$styles.lozengeContainer, (isOpen || isPressing) && $8d29b99195ec403c$var$styles.lozengeContainerSelected),
            as: "span",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? true : isHovering,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    backgroundColor: lozengeBackgroundColor,
                    color: lozengeForegroundColor
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
                    className: (0, $hcewu.default)([
                        "_4cvr1h6o _1e0c1txw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            children: text
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $8d29b99195ec403c$var$styles.chevronDown,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                                color: "currentColor",
                                label: "options",
                                LEGACY_size: "medium",
                                LEGACY_margin: "-4px -8px -4px -7px",
                                size: "small",
                                ...(0, $eGOwo.fg)('navx-1842-hiding-unnecessary-image-descriptions') ? {
                                    'aria-hidden': true
                                } : {}
                            })
                        })
                    ]
                })
            })
        });
    }, [
        appearance,
        isHovering,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        className: (0, $hcewu.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189e1dm9 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas1qi0 _19h61qi0 _1d391qi0 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $8d29b99195ec403c$export$2e2bcd8739ae039 = $8d29b99195ec403c$var$LozengeActionTrigger;

});




parcelRegister("kB4Nm", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e36aa41e9ad3ded$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $9e36aa41e9ad3ded$var$LatestCommitElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Commit,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LatestCommit
    }) : null;
};
var $9e36aa41e9ad3ded$export$2e2bcd8739ae039 = $9e36aa41e9ad3ded$var$LatestCommitElement;

});

parcelRegister("jPfaa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3002c31f53401640$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $d6nZP = parcelRequire("d6nZP");
const $3002c31f53401640$var$LinkIconElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context) return null;
    const data = (0, $d6nZP.toLinkIconProps)(context?.linkIcon, context.type);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LinkIcon
    }) : null;
};
var $3002c31f53401640$export$2e2bcd8739ae039 = $3002c31f53401640$var$LinkIconElement;

});
parcelRegister("d6nZP", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a220f00187bff59$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toLinkIconProps", () => $7a220f00187bff59$export$6d33abd591a3f700);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $av9Of = parcelRequire("av9Of");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $fQH39 = parcelRequire("fQH39");
const $7a220f00187bff59$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $7a220f00187bff59$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $7a220f00187bff59$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym"
};
const $7a220f00187bff59$var$renderAtlaskitIcon = (icon, testId, size = (0, $5NtHI.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        size: size
    });
};
const $7a220f00187bff59$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $7a220f00187bff59$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5NtHI.SmartLinkSize).Medium, appearance, hideLoadingSkeleton)=>{
    const width = size === (0, $5NtHI.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param props - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $7a220f00187bff59$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $5NtHI.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const element = (0, $eJOHy.useMemo)(()=>{
        const defaultIcon = $7a220f00187bff59$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $7a220f00187bff59$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton) || $7a220f00187bff59$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon
    ]);
    const width = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7a220f00187bff59$var$styles.container,
            $7a220f00187bff59$var$positionStyleMap[position],
            render && $7a220f00187bff59$var$customRenderStyleMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $7a220f00187bff59$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        })
    });
};
var $7a220f00187bff59$export$2e2bcd8739ae039 = $7a220f00187bff59$var$IconElement;
const $7a220f00187bff59$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $FoFt2.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};

});


parcelRegister("2Bqsd", function(module, exports) {
$parcel$export(module.exports, "default", () => $684e70f9d4a0e20c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $684e70f9d4a0e20c$var$LocationElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        theme: (0, $5NtHI.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Location
    }) : null;
};
var $684e70f9d4a0e20c$export$2e2bcd8739ae039 = $684e70f9d4a0e20c$var$LocationElement;

});
parcelRegister("8ygPC", function(module, exports) {
$parcel$export(module.exports, "default", () => $adbc5d7a57662063$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $fQH39 = parcelRequire("fQH39");
const $adbc5d7a57662063$var$DEFAULT_MAX_LINES = 2;
const $adbc5d7a57662063$var$MAXIMUM_MAX_LINES = 2;
const $adbc5d7a57662063$var$MINIMUM_MAX_LINES = 1;
const $adbc5d7a57662063$var$containerStyles = null;
const $adbc5d7a57662063$var$getMaxLines = (maxLines)=>{
    if (maxLines > $adbc5d7a57662063$var$MAXIMUM_MAX_LINES) return $adbc5d7a57662063$var$DEFAULT_MAX_LINES;
    if (maxLines < $adbc5d7a57662063$var$MINIMUM_MAX_LINES) return $adbc5d7a57662063$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $adbc5d7a57662063$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $adbc5d7a57662063$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $adbc5d7a57662063$var$baseAnchorStyle = null;
const $adbc5d7a57662063$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $adbc5d7a57662063$var$anchorConstantsStyles = null;
const $adbc5d7a57662063$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $adbc5d7a57662063$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _c2wa8stv _4fpr8stv _1bnx8stv _1x288stv _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8h1gjq _f8pj1gjq _30l31gjq _10531gjq",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {BaseLinkElementProps} BaseLinkElementProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $adbc5d7a57662063$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $adbc5d7a57662063$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5NtHI.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const hasSpace = (0, $eJOHy.useMemo)(()=>text ? (0, $fQH39.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $adbc5d7a57662063$var$linkStyleSizeMap[size],
            $adbc5d7a57662063$var$anchorLineClampMap[$adbc5d7a57662063$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $adbc5d7a57662063$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 1 && $adbc5d7a57662063$var$anchorLinkLineHeight1Map[size],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 2 && $adbc5d7a57662063$var$anchorLinkLineHeight2Map[size],
            $adbc5d7a57662063$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $adbc5d7a57662063$var$withTooltip(anchor, text, testId)
    });
};
var $adbc5d7a57662063$export$2e2bcd8739ae039 = $adbc5d7a57662063$var$BaseLinkElement;
const $adbc5d7a57662063$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};

});


parcelRegister("1FNi6", function(module, exports) {
$parcel$export(module.exports, "default", () => $59cc5cb27d2f6980$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $59cc5cb27d2f6980$var$ModifiedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ModifiedBy
    }) : null;
};
var $59cc5cb27d2f6980$export$2e2bcd8739ae039 = $59cc5cb27d2f6980$var$ModifiedByElement;

});

parcelRegister("81kl8", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b4cff059a6d0796$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $5b4cff059a6d0796$var$ModifiedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ModifiedOn
    }) : null;
};
var $5b4cff059a6d0796$export$2e2bcd8739ae039 = $5b4cff059a6d0796$var$ModifiedOnElement;

});

parcelRegister("946bQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $36681a63387d26b9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $36681a63387d26b9$var$OwnedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages)[textPrefix], context?.ownedBy) : null;
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedBy
    }) : null;
};
var $36681a63387d26b9$export$2e2bcd8739ae039 = $36681a63387d26b9$var$OwnedByElement;

});

parcelRegister("4Nd99", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0ab17b3f9ac16f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $d0ab17b3f9ac16f4$var$OwnedByGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedByGroup
    }) : null;
};
var $d0ab17b3f9ac16f4$export$2e2bcd8739ae039 = $d0ab17b3f9ac16f4$var$OwnedByGroupElement;

});

parcelRegister("7Byzo", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cb8c392c94261f3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4YO5T = parcelRequire("4YO5T");
const $4cb8c392c94261f3$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5NtHI.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4YO5T.default), {
        ...rest,
        ...data
    });
};
var $4cb8c392c94261f3$export$2e2bcd8739ae039 = $4cb8c392c94261f3$var$PreviewElement;

});
parcelRegister("4YO5T", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7eb4202b966638f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cbSL1 = parcelRequire("cbSL1");

var $5FRJ8 = parcelRequire("5FRJ8");

var $67ulW = parcelRequire("67ulW");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $d7eb4202b966638f$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param props - The props necessary for the Media element.
 */ const $d7eb4202b966638f$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    const ui = (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FRJ8.useFlexibleUiOptionContext)() : undefined;
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
            hideLoadingSkeleton: ui?.hideLoadingSkeleton,
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $d7eb4202b966638f$export$2e2bcd8739ae039 = $d7eb4202b966638f$var$MediaElement;

});


parcelRegister("5kUaD", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb8efb6535893df$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $8cb8efb6535893df$var$PriorityElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Priority
    }) : null;
};
var $8cb8efb6535893df$export$2e2bcd8739ae039 = $8cb8efb6535893df$var$PriorityElement;

});

parcelRegister("8MxlB", function(module, exports) {
$parcel$export(module.exports, "default", () => $12bbc9fa6baf6ce0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ProgrammingLanguage
    }) : null;
};
var $12bbc9fa6baf6ce0$export$2e2bcd8739ae039 = $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement;

});

parcelRegister("lwvSM", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c70b57958761eec$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $1c70b57958761eec$var$ReactCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.reactCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).React,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ReactCount
    }) : null;
};
var $1c70b57958761eec$export$2e2bcd8739ae039 = $1c70b57958761eec$var$ReactCountElement;

});

parcelRegister("2ITMK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2d9d65227b56648$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b2d9d65227b56648$var$ReadTimeElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ReadTime
    }) : null;
};
var $b2d9d65227b56648$export$2e2bcd8739ae039 = $b2d9d65227b56648$var$ReadTimeElement;

});

parcelRegister("iw2r2", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e6bf42d4a97c401$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $0e6bf42d4a97c401$var$SentOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SentOn
    }) : null;
};
var $0e6bf42d4a97c401$export$2e2bcd8739ae039 = $0e6bf42d4a97c401$var$SentOnElement;

});

parcelRegister("f7w3l", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5970e5c744f439f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $b5970e5c744f439f$var$snippetBaseStyle = null;
const $b5970e5c744f439f$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $b5970e5c744f439f$export$2e2bcd8739ae039 = $b5970e5c744f439f$var$SnippetElement;

});

parcelRegister("6Po2h", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7164a95a609845f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $f7164a95a609845f$var$SourceBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SourceBranch
    }) : null;
};
var $f7164a95a609845f$export$2e2bcd8739ae039 = $f7164a95a609845f$var$SourceBranchElement;

});

parcelRegister("4U5iq", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd8773a8f5d6e97c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $cd8773a8f5d6e97c$var$StateElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.state ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).State
    }) : null;
};
var $cd8773a8f5d6e97c$export$2e2bcd8739ae039 = $cd8773a8f5d6e97c$var$StateElement;

});

parcelRegister("jJD7c", function(module, exports) {
$parcel$export(module.exports, "default", () => $e661b354f8faff8b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $e661b354f8faff8b$var$SubscriberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubscriberCount
    }) : null;
};
var $e661b354f8faff8b$export$2e2bcd8739ae039 = $e661b354f8faff8b$var$SubscriberCountElement;

});

parcelRegister("7mGkc", function(module, exports) {
$parcel$export(module.exports, "default", () => $da8be0e62ff3be52$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $da8be0e62ff3be52$var$SubTasksProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubTasksProgress
    }) : null;
};
var $da8be0e62ff3be52$export$2e2bcd8739ae039 = $da8be0e62ff3be52$var$SubTasksProgressElement;

});

parcelRegister("w1OaX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6da98c25506acfc3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hTi78 = parcelRequire("hTi78");
const $6da98c25506acfc3$var$StoryPointsElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $hTi78.toAtlaskitBadgeProps)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hTi78.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).StoryPoints
    }) : null;
};
var $6da98c25506acfc3$export$2e2bcd8739ae039 = $6da98c25506acfc3$var$StoryPointsElement;

});
parcelRegister("hTi78", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fb2764f8e50f778$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAtlaskitBadgeProps", () => $5fb2764f8e50f778$export$731812b93bd90554);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7q9BG = parcelRequire("7q9BG");
const $5fb2764f8e50f778$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $5fb2764f8e50f778$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7q9BG.default), {
            children: value
        })
    });
};
var $5fb2764f8e50f778$export$2e2bcd8739ae039 = $5fb2764f8e50f778$var$BaseAtlaskitElementBadge;
const $5fb2764f8e50f778$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};

});


parcelRegister("cwvSG", function(module, exports) {
$parcel$export(module.exports, "default", () => $44a8674c49925bc5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $44a8674c49925bc5$var$TargetBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TargetBranch
    }) : null;
};
var $44a8674c49925bc5$export$2e2bcd8739ae039 = $44a8674c49925bc5$var$TargetBranchElement;

});

parcelRegister("2j4b1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee83b62dd045c6fd$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $ee83b62dd045c6fd$var$TeamMemberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    const count = context?.teamMemberCount && context?.teamMemberCount > $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT ? `${$ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
    const data = count ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TeamMemberCount
    }) : null;
};
var $ee83b62dd045c6fd$export$2e2bcd8739ae039 = $ee83b62dd045c6fd$var$TeamMemberCountElement;

});

parcelRegister("i6ktq", function(module, exports) {
$parcel$export(module.exports, "default", () => $890c0338844dfde1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $890c0338844dfde1$var$TitleElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? context?.linkTitle : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Title
    }) : null;
};
var $890c0338844dfde1$export$2e2bcd8739ae039 = $890c0338844dfde1$var$TitleElement;

});

parcelRegister("iQvIm", function(module, exports) {
$parcel$export(module.exports, "default", () => $13574bab0abb9b76$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $13574bab0abb9b76$var$UserAttributesElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $5NtHI.ElementName).UserAttributes
                }, key));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: elements
    }) : null;
};
var $13574bab0abb9b76$export$2e2bcd8739ae039 = $13574bab0abb9b76$var$UserAttributesElement;

});

parcelRegister("bApaO", function(module, exports) {
$parcel$export(module.exports, "default", () => $32db5b76dc584a40$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $32db5b76dc584a40$var$ViewCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).View,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ViewCount
    }) : null;
};
var $32db5b76dc584a40$export$2e2bcd8739ae039 = $32db5b76dc584a40$var$ViewCountElement;

});

parcelRegister("1IQ2A", function(module, exports) {
$parcel$export(module.exports, "default", () => $49df200106082223$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $49df200106082223$var$VoteCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Vote,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).VoteCount
    }) : null;
};
var $49df200106082223$export$2e2bcd8739ae039 = $49df200106082223$var$VoteCountElement;

});

parcelRegister("lJDNU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b64afcea66b05029$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $b64afcea66b05029$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $19nmp.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Component,
        label: label,
        ...props
    });
};
var $b64afcea66b05029$export$2e2bcd8739ae039 = $b64afcea66b05029$var$AppliedToComponentsCountElement;

});

parcelRegister("i4NpI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e868f1df007f5c9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $7e868f1df007f5c9$var$baseStyle = null;
const $7e868f1df007f5c9$var$isMessageDescriptor = (x)=>!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(x);
const $7e868f1df007f5c9$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
const $7e868f1df007f5c9$var$maxLinesCss = null;
const $7e868f1df007f5c9$var$CustomElementByAccessType = ({ className: className, testId: testId = 'custom-by-access-type-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const accessType = context?.data?.meta?.accessType;
    const contentForAccessType = props[accessType] ?? props.fallback;
    if (!contentForAccessType) return null;
    const values = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]?.values;
    if ($7e868f1df007f5c9$var$isMessageDescriptor(contentForAccessType)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...props,
        message: {
            descriptor: contentForAccessType,
            values: values
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        testId: testId,
        hideFormat: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: props.color
        },
        "data-separator": true,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            props.fontSize !== undefined && $7e868f1df007f5c9$var$fontOverrideStyleMap[props.fontSize],
            "_1yyjkb7n _102k1j6v",
            className
        ]),
        children: contentForAccessType
    });
};
var $7e868f1df007f5c9$export$2e2bcd8739ae039 = $7e868f1df007f5c9$var$CustomElementByAccessType;

});

parcelRegister("5d1ks", function(module, exports) {
$parcel$export(module.exports, "default", () => $255ff319c604874a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");
const $255ff319c604874a$var$CustomByStatusElement = ({ className: className, testId: testId = 'custom-by-status-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const status = context?.status;
    if (!status) return null;
    const component = props[status];
    if (!component) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": "custom-element",
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        children: component
    });
};
var $255ff319c604874a$export$2e2bcd8739ae039 = $255ff319c604874a$var$CustomByStatusElement;

});


parcelRegister("k8J0S", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ef789dfa4e54c3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $7ef789dfa4e54c3c$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $7ef789dfa4e54c3c$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $7ef789dfa4e54c3c$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $7ef789dfa4e54c3c$var$baseStyles = null;
const $7ef789dfa4e54c3c$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $7ef789dfa4e54c3c$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $7ef789dfa4e54c3c$var$horizontalStyleBase = null;
const $7ef789dfa4e54c3c$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $7ef789dfa4e54c3c$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $7ef789dfa4e54c3c$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $7ef789dfa4e54c3c$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $7ef789dfa4e54c3c$var$ElementGroup = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5NtHI.SmartLinkWidth).FitToContent, position: position = (0, $5NtHI.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5NtHI.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7ef789dfa4e54c3c$var$baseStyleBySize[size],
            $7ef789dfa4e54c3c$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $7ef789dfa4e54c3c$var$alignmentStyleMap[align],
            "_1ul99by0",
            $7ef789dfa4e54c3c$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $7ef789dfa4e54c3c$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Left && $7ef789dfa4e54c3c$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Right && $7ef789dfa4e54c3c$var$gapStylesRight[size],
            $7ef789dfa4e54c3c$var$positionStyle[position],
            className
        ]),
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $7ef789dfa4e54c3c$export$2e2bcd8739ae039 = $7ef789dfa4e54c3c$var$ElementGroup;

});


parcelRegister("a86OV", function(module, exports) {
$parcel$export(module.exports, "default", () => $26c0c5c54b91a954$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lHA6U = parcelRequire("lHA6U");
const $26c0c5c54b91a954$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $lHA6U ? $lHA6U[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $26c0c5c54b91a954$export$2e2bcd8739ae039 = $26c0c5c54b91a954$var$ActionGroupItem;

});
parcelRegister("lHA6U", function(module, exports) {
$parcel$export(module.exports, "CustomAction", () => (parcelRequire("9hHCO")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("dckwx")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("c0FsA")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("dGv8r")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("lSW97")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("3MDCL")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("b1dbu")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("cLrUd")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("2fs4B")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("1EoLm")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("bKvNh")).default);
$parcel$export(module.exports, "CustomUnresolvedAction", () => (parcelRequire("fd4of")).default);

var $9hHCO = parcelRequire("9hHCO");

var $dckwx = parcelRequire("dckwx");

var $c0FsA = parcelRequire("c0FsA");

var $dGv8r = parcelRequire("dGv8r");

var $lSW97 = parcelRequire("lSW97");

var $3MDCL = parcelRequire("3MDCL");

var $b1dbu = parcelRequire("b1dbu");

var $cLrUd = parcelRequire("cLrUd");

var $2fs4B = parcelRequire("2fs4B");

var $1EoLm = parcelRequire("1EoLm");

var $bKvNh = parcelRequire("bKvNh");

var $fd4of = parcelRequire("fd4of");

});
parcelRegister("9hHCO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2469864747178fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $8ABAe = parcelRequire("8ABAe");

var $fh1oH = parcelRequire("fh1oH");

var $dQnV8 = parcelRequire("dQnV8");

var $cNUXI = parcelRequire("cNUXI");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $c2469864747178fa$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cNUXI.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fh1oH.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ABAe.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $c2469864747178fa$export$2e2bcd8739ae039 = $c2469864747178fa$var$Action;

});
parcelRegister("8ABAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $810b448b0b6757f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cA0Y2 = parcelRequire("cA0Y2");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");
var $5bY40 = parcelRequire("5bY40");
var $6K3F5 = parcelRequire("6K3F5");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $810b448b0b6757f9$var$IconOnlyLarge = null;
const $810b448b0b6757f9$var$SizeSmall = null;
const $810b448b0b6757f9$var$SizeSmallIconOnly = null;
const $810b448b0b6757f9$var$SizeSmallNotIconOnly = null;
const $810b448b0b6757f9$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $810b448b0b6757f9$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $810b448b0b6757f9$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $810b448b0b6757f9$var$ActionButtonRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $eJOHy.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6K3F5.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
const $810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss = (0, $9jYtV.withOverrideCss)($810b448b0b6757f9$var$ActionButtonRefresh);
const $810b448b0b6757f9$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            size === (0, $5NtHI.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5NtHI.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $5NtHI.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $5NtHI.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cA0Y2.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fQH39.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $810b448b0b6757f9$var$ActionButton = (props)=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonNew, {
        ...props
    });
};
var $810b448b0b6757f9$export$2e2bcd8739ae039 = $810b448b0b6757f9$var$ActionButton;

});

parcelRegister("fh1oH", function(module, exports) {
$parcel$export(module.exports, "default", () => $4141238200e2a86d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $FoFt2 = parcelRequire("FoFt2");
const $4141238200e2a86d$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $FoFt2.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $4141238200e2a86d$export$2e2bcd8739ae039 = $4141238200e2a86d$var$ActionDropdownItem;

});

parcelRegister("dQnV8", function(module, exports) {
$parcel$export(module.exports, "default", () => $182322eb34547fdc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
const $182322eb34547fdc$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$stackItemIconStylesOld = null;
const $182322eb34547fdc$var$stackItemIconStylesCompiled = null;
const $182322eb34547fdc$var$ActionIcon = ({ size: size, testId: testId, icon: icon, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap[$182322eb34547fdc$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $182322eb34547fdc$export$2e2bcd8739ae039 = $182322eb34547fdc$var$ActionIcon;

});

parcelRegister("cNUXI", function(module, exports) {
$parcel$export(module.exports, "default", () => $d23b94a27dbb965d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $e5DLq = parcelRequire("e5DLq");
const $d23b94a27dbb965d$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $d23b94a27dbb965d$export$2e2bcd8739ae039 = $d23b94a27dbb965d$var$ActionStackItem;

});
parcelRegister("e5DLq", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d6dc8e23eec4828$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");

var $7ep4S = parcelRequire("7ep4S");

var $fQH39 = parcelRequire("fQH39");

var $dQnV8 = parcelRequire("dQnV8");
const $0d6dc8e23eec4828$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $0d6dc8e23eec4828$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fQH39.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $0d6dc8e23eec4828$export$2e2bcd8739ae039 = $0d6dc8e23eec4828$var$ActionButton;

});



parcelRegister("dckwx", function(module, exports) {
$parcel$export(module.exports, "default", () => $3290b93af8be85b3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $6J9k6 = parcelRequire("6J9k6");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $3290b93af8be85b3$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        ...props
    });
var $3290b93af8be85b3$export$2e2bcd8739ae039 = $3290b93af8be85b3$var$DeleteAction;

});

parcelRegister("c0FsA", function(module, exports) {
$parcel$export(module.exports, "default", () => $920fde411498a771$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bp0jd = parcelRequire("bp0jd");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $920fde411498a771$var$EditAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bp0jd))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        ...props
    });
var $920fde411498a771$export$2e2bcd8739ae039 = $920fde411498a771$var$EditAction;

});
parcelRegister("bp0jd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5f964c14b35b4c00537c8ae369245e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84d244d8a31b5641$var$_react = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $84d244d8a31b5641$var$_edit = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("gTr6H")));

var $84d244d8a31b5641$var$_edit2 = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("dUYQ5")));
function $84d244d8a31b5641$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84d244d8a31b5641$var$EditIcon = (props)=>/*#__PURE__*/ $84d244d8a31b5641$var$_react.default.createElement($84d244d8a31b5641$var$_edit.default, Object.assign({
        name: "EditIcon",
        LEGACY_fallbackIcon: $84d244d8a31b5641$var$_edit2.default
    }, props));
$84d244d8a31b5641$var$EditIcon.displayName = 'EditIconMigration';
var $84d244d8a31b5641$var$_default = module.exports.default = $84d244d8a31b5641$var$EditIcon;

});
parcelRegister("dUYQ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a21fb2aec03ab384$var$_react = $a21fb2aec03ab384$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a21fb2aec03ab384$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a21fb2aec03ab384$var$EditIcon = (props)=>/*#__PURE__*/ $a21fb2aec03ab384$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props));
$a21fb2aec03ab384$var$EditIcon.displayName = 'EditIcon';
var $a21fb2aec03ab384$var$_default = module.exports.default = $a21fb2aec03ab384$var$EditIcon;

});



parcelRegister("dGv8r", function(module, exports) {
$parcel$export(module.exports, "default", () => $bea6a5d6049b9822$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $kHcBe = parcelRequire("kHcBe");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $bea6a5d6049b9822$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).DownloadAction];
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $19nmp.messages).download_file : (0, $19nmp.messages).download;
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).download_description : (0, $19nmp.messages).download;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHcBe))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $bea6a5d6049b9822$export$2e2bcd8739ae039 = $bea6a5d6049b9822$var$DownloadAction;

});
parcelRegister("kHcBe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c27208d6ab6791006597f11ce02c72b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f11198d3276cd080$var$_react = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f11198d3276cd080$var$_download = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("5Mb5i")));

var $f11198d3276cd080$var$_download2 = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("bRp3T")));
function $f11198d3276cd080$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f11198d3276cd080$var$DownloadIcon = (props)=>/*#__PURE__*/ $f11198d3276cd080$var$_react.default.createElement($f11198d3276cd080$var$_download.default, Object.assign({
        name: "DownloadIcon",
        LEGACY_fallbackIcon: $f11198d3276cd080$var$_download2.default
    }, props));
$f11198d3276cd080$var$DownloadIcon.displayName = 'DownloadIconMigration';
var $f11198d3276cd080$var$_default = module.exports.default = $f11198d3276cd080$var$DownloadIcon;

});
parcelRegister("5Mb5i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::856226f5e73dfc11c44d43d912e311e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $434a088e5f2bb7a6$var$_react = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $434a088e5f2bb7a6$var$_baseNew = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $434a088e5f2bb7a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $434a088e5f2bb7a6$var$DownloadIcon = (props)=>/*#__PURE__*/ $434a088e5f2bb7a6$var$_react.default.createElement($434a088e5f2bb7a6$var$_baseNew.default, Object.assign({
        name: "DownloadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$434a088e5f2bb7a6$var$DownloadIcon.displayName = 'DownloadIcon';
var $434a088e5f2bb7a6$var$_default = module.exports.default = $434a088e5f2bb7a6$var$DownloadIcon;

});

parcelRegister("bRp3T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a2815b0aa140afa$var$_react = $8a2815b0aa140afa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $8a2815b0aa140afa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a2815b0aa140afa$var$DownloadIcon = (props)=>/*#__PURE__*/ $8a2815b0aa140afa$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props));
$8a2815b0aa140afa$var$DownloadIcon.displayName = 'DownloadIcon';
var $8a2815b0aa140afa$var$_default = module.exports.default = $8a2815b0aa140afa$var$DownloadIcon;

});



parcelRegister("lSW97", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfe202eda411d4c1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $59rsN = parcelRequire("59rsN");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $5UiT3 = parcelRequire("5UiT3");

var $kxXL5 = parcelRequire("kxXL5");


const $dfe202eda411d4c1$var$importIconMapper = {
    goal: ()=>(parcelRequire("iqCse")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("DxrmM")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $dfe202eda411d4c1$var$getIcon = (stackIconType)=>{
    const importFn = $dfe202eda411d4c1$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fQH39.importIcon)(importFn);
};
const $dfe202eda411d4c1$var$FollowAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $19nmp.messages).follow : (0, $19nmp.messages).unfollow;
    const projectMessage = value ? (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).follow_projectGalaxia : (0, $19nmp.messages).follow_project : (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).unfollow_projectGalaxia : (0, $19nmp.messages).unfollow_project;
    const goalMessage = value ? (0, $19nmp.messages).follow_goal : (0, $19nmp.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).follow_project_descriptionGalaxia : (0, $19nmp.messages).follow_project_description : (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).unfollow_project_descriptionGalaxia : (0, $19nmp.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $19nmp.messages).follow_goal_description : (0, $19nmp.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $dfe202eda411d4c1$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $kxXL5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5UiT3.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $dfe202eda411d4c1$export$2e2bcd8739ae039 = $dfe202eda411d4c1$var$FollowAction;

});
parcelRegister("5UiT3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce9aaae704363155$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $1rn8a = parcelRequire("1rn8a");

var $9hHCO = parcelRequire("9hHCO");
const $ce9aaae704363155$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const invoke = (0, $6O4ri.default)();
    const reload = (0, $kbv8x.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleClick = (0, $eJOHy.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $1rn8a.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $d0InI.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $ce9aaae704363155$export$2e2bcd8739ae039 = $ce9aaae704363155$var$ServerAction;

});
parcelRegister("1rn8a", function(module, exports) {
$parcel$export(module.exports, "default", () => $6426c76052ace8de$export$2e2bcd8739ae039);
const $6426c76052ace8de$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $6426c76052ace8de$export$2e2bcd8739ae039 = $6426c76052ace8de$var$createInvokeRequest;

});


parcelRegister("kxXL5", function(module, exports) {
$parcel$export(module.exports, "getFollowActionErrorMessage", () => $b87644dc5deec150$export$49248678d3914625);

var $59rsN = parcelRequire("59rsN");

var $19nmp = parcelRequire("19nmp");
const $b87644dc5deec150$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).follow_project_errorGalaxia : (0, $19nmp.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).unfollow_project_errorGalaxia : (0, $19nmp.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $19nmp.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $19nmp.messages).unfollow_goal_error;
    return (0, $19nmp.messages).generic_error_message;
};

});

parcelRegister("iqCse", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3nUhw")
]).then(()=>parcelRequire('k96Yq'));

});

parcelRegister("DxrmM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("1877j")
]).then(()=>parcelRequire('c6wmU'));

});


parcelRegister("3MDCL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7238a60227ffb9b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1hBh4 = parcelRequire("1hBh4");

var $f4WMd = parcelRequire("f4WMd");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $a7238a60227ffb9b$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).PreviewAction];
    const hasPreviewPanel = data?.hasPreviewPanel;
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).preview_description : (0, $19nmp.messages).preview_improved;
    const actionIcon = (0, $eJOHy.useCallback)(()=>{
        // Only use panel icon if experiment is enabled and hasPreviewPanel is true
        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4WMd))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview panel"
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1hBh4))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        });
    }, [
        hasPreviewPanel
    ]);
    const actionLabel = (0, $eJOHy.useCallback)(()=>{
        // Only use panel message if experiment is enabled and hasPreviewPanel is true
        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_panel
        });
        // Fall back to modal message if experiment is enabled, otherwise use original preview message
        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_modal
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_improved
        });
    }, [
        hasPreviewPanel
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: actionLabel(),
        icon: actionIcon(),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $a7238a60227ffb9b$export$2e2bcd8739ae039 = $a7238a60227ffb9b$var$PreviewAction;

});
parcelRegister("1hBh4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2af12b1489cad8386543f983c1a67716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ef44ae728b7e983$var$_react = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0ef44ae728b7e983$var$_growDiagonal = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("XhTSt")));

var $0ef44ae728b7e983$var$_actualSize = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("2F5b6")));
function $0ef44ae728b7e983$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ef44ae728b7e983$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0ef44ae728b7e983$var$_react.default.createElement($0ef44ae728b7e983$var$_growDiagonal.default, Object.assign({
        name: "GrowDiagonalIcon",
        LEGACY_fallbackIcon: $0ef44ae728b7e983$var$_actualSize.default
    }, props));
$0ef44ae728b7e983$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIconMigration';
var $0ef44ae728b7e983$var$_default = module.exports.default = $0ef44ae728b7e983$var$GrowDiagonalIcon;

});
parcelRegister("XhTSt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98db7ecf7a88004ad911d912e316fd5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b23656b9dea9ae5$var$_react = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0b23656b9dea9ae5$var$_baseNew = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0b23656b9dea9ae5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b23656b9dea9ae5$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0b23656b9dea9ae5$var$_react.default.createElement($0b23656b9dea9ae5$var$_baseNew.default, Object.assign({
        name: "GrowDiagonalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$0b23656b9dea9ae5$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $0b23656b9dea9ae5$var$_default = module.exports.default = $0b23656b9dea9ae5$var$GrowDiagonalIcon;

});

parcelRegister("2F5b6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f036d580202d537$var$_react = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $1f036d580202d537$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f036d580202d537$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $1f036d580202d537$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props));
$1f036d580202d537$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $1f036d580202d537$var$_default = module.exports.default = $1f036d580202d537$var$MediaServicesActualSizeIcon;

});


parcelRegister("f4WMd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::24c85da433a7def76f682c2e482c8374>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afa4d2955554e918$var$_react = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $afa4d2955554e918$var$_baseNew = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $afa4d2955554e918$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afa4d2955554e918$var$PanelRightIcon = (props)=>/*#__PURE__*/ $afa4d2955554e918$var$_react.default.createElement($afa4d2955554e918$var$_baseNew.default, Object.assign({
        name: "PanelRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H9.5v11H14a.5.5 0 0 0 .5-.5zM13 10v1.5h-2V10zm0-3v1.5h-2V7zm0-3v1.5h-2V4zM1.5 13a.5.5 0 0 0 .5.5h6v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$afa4d2955554e918$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $afa4d2955554e918$var$_default = module.exports.default = $afa4d2955554e918$var$PanelRightIcon;

});


parcelRegister("b1dbu", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbc64436e41aec7f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $av9Of = parcelRequire("av9Of");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $cbc64436e41aec7f$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_url_to_clipboard);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $19nmp.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $cbc64436e41aec7f$export$2e2bcd8739ae039 = $cbc64436e41aec7f$var$CopyLinkAction;

});

parcelRegister("cLrUd", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c33132973d68a83$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $8c33132973d68a83$var$styles = {
    button: "_1e0c1bgi",
    padding: "_18zrutpp",
    message: "_1rjcze3t _18zrze3t"
};
const $8c33132973d68a83$var$UnresolvedAction = ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $6qaBj.cx)($8c33132973d68a83$var$styles.message, hasPadding && $8c33132973d68a83$var$styles.padding),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        })
    });
    return hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $8c33132973d68a83$var$styles.button,
        children: message
    }) : message;
};
var $8c33132973d68a83$export$2e2bcd8739ae039 = $8c33132973d68a83$var$UnresolvedAction;

});

parcelRegister("2fs4B", function(module, exports) {
$parcel$export(module.exports, "default", () => $b30a89f78a7b1395$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3IFDE = parcelRequire("3IFDE");
const $b30a89f78a7b1395$var$AISummaryAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3IFDE.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $b30a89f78a7b1395$export$2e2bcd8739ae039 = $b30a89f78a7b1395$var$AISummaryAction;

});
parcelRegister("3IFDE", function(module, exports) {
$parcel$export(module.exports, "AISummaryActionComponent", () => $f1effd59dd51917b$export$8eed96bc6d982595);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $4N9mw = parcelRequire("4N9mw");

var $9ljdO = parcelRequire("9ljdO");
const $f1effd59dd51917b$export$8eed96bc6d982595 = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $2LycE.default)(url);
    (0, $eJOHy.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ljdO.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4N9mw.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("2LycE", function(module, exports) {
$parcel$export(module.exports, "default", () => $442e3e8f06b649b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9R3Jd = parcelRequire("9R3Jd");
var $3seWH = parcelRequire("3seWH");

var $bmWcp = parcelRequire("bmWcp");

var $1mLfK = parcelRequire("1mLfK");

var $5TXKo = parcelRequire("5TXKo");

var $5sknP = parcelRequire("5sknP");

var $k2hJv = parcelRequire("k2hJv");
const $442e3e8f06b649b8$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $442e3e8f06b649b8$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $k2hJv.useAISummaryConfig)();
    const cardState = (0, $5TXKo.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $9R3Jd.extractAri)(data);
    const dataUrl = data && (0, $3seWH.extractLink)(data) || '';
    const onStart = (0, $eJOHy.useCallback)((id)=>{
        (0, $1mLfK.startUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $eJOHy.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1mLfK.succeedUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $eJOHy.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1mLfK.failUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $5sknP.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $442e3e8f06b649b8$export$2e2bcd8739ae039 = $442e3e8f06b649b8$var$useAISummaryAction;

});
parcelRegister("5sknP", function(module, exports) {
$parcel$export(module.exports, "useAISummary", () => $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bI4It = parcelRequire("bI4It");

var $64EXn = parcelRequire("64EXn");
const $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $eJOHy.useState)((0, $64EXn.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $64EXn.AISummariesStore).get(url)) (0, $64EXn.AISummariesStore).set(url, new (0, $bI4It.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $64EXn.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $64EXn.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("bI4It", function(module, exports) {
$parcel$export(module.exports, "AISummaryService", () => $ee3df5d12a847ac3$export$73e4b807d5bd74b6);

var $aXKmr = parcelRequire("aXKmr");

var $a5MXk = parcelRequire("a5MXk");

var $4NcaA = parcelRequire("4NcaA");

var $8hWqs = parcelRequire("8hWqs");

var $9ntiN = parcelRequire("9ntiN");
const $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $ee3df5d12a847ac3$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $a5MXk.getBaseUrl)(envKey);
                return (0, $9ntiN.addPath)(baseUrl, $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT);
            }
            return (0, $9ntiN.addPath)('/gateway/api/', $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $4NcaA.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $9ntiN.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.content;
                if (chunk.type === 'ERROR') throw new (0, $8hWqs.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $8hWqs.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("4NcaA", function(module, exports) {
$parcel$export(module.exports, "readStream", () => $3c1ef1a29697a261$export$e45226161c660403);

var $9ntiN = parcelRequire("9ntiN");
async function* $3c1ef1a29697a261$export$e45226161c660403(response) {
    const reader = (0, $9ntiN.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("9ntiN", function(module, exports) {
$parcel$export(module.exports, "getBufferReader", () => $75d74a4f0b187756$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $75d74a4f0b187756$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $75d74a4f0b187756$export$ff2962de2b2c930f);
const $75d74a4f0b187756$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $75d74a4f0b187756$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $75d74a4f0b187756$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $75d74a4f0b187756$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $75d74a4f0b187756$export$ff2962de2b2c930f = (product)=>{
    if ($75d74a4f0b187756$var$isJiraProduct(product)) return $75d74a4f0b187756$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("8hWqs", function(module, exports) {
$parcel$export(module.exports, "ChunkProcessingError", () => $424f983e1007104e$export$fcec967a4b7ebd84);
class $424f983e1007104e$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $424f983e1007104e$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("64EXn", function(module, exports) {
$parcel$export(module.exports, "AISummariesStore", () => $6b567d039eac44f3$export$6979339b6d41707e);

var $7xkt0 = parcelRequire("7xkt0");
const $6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE = 100;
const $6b567d039eac44f3$export$6979339b6d41707e = new (0, $7xkt0.LRUMap)($6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("k2hJv", function(module, exports) {
$parcel$export(module.exports, "useAISummaryConfig", () => $3042bebadd8b2921$export$4480af2c00aa7ebe);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $3042bebadd8b2921$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("4N9mw", function(module, exports) {
$parcel$export(module.exports, "AISummariseAction", () => $74950477f844069d$export$75a19de44af58722);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $fOqNz = parcelRequire("fOqNz");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $jeUcl = parcelRequire("jeUcl");

var $9hHCO = parcelRequire("9hHCO");

var $4XsCU = parcelRequire("4XsCU");
function $74950477f844069d$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onCompleted = (0, $eJOHy.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $4XsCU.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $jeUcl.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("fOqNz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2cff70d9276c693dca9eb8c1c54a9e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b830502683dea4c7$var$_react = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b830502683dea4c7$var$_baseNew = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b830502683dea4c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence apps or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b830502683dea4c7$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $b830502683dea4c7$var$_react.default.createElement($b830502683dea4c7$var$_baseNew.default, Object.assign({
        name: "AtlassianIntelligenceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 12v3h-1.5v-3zm-2.22-1.47-4 4-1.06-1.06 4-4zm8 2.94-1.06 1.06-4-4 1.06-1.06zM4 7.25v1.5H1v-1.5zm11 0v1.5h-3v-1.5zM6.53 5.47 5.47 6.53l-4-4 1.06-1.06zm8-2.94-4 4-1.06-1.06 4-4zM8.75 1v3h-1.5V1z"/>`
    }, props));
$b830502683dea4c7$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $b830502683dea4c7$var$_default = module.exports.default = $b830502683dea4c7$var$AtlassianIntelligenceIcon;

});

parcelRegister("jeUcl", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f62baba7cd68ce1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $9f62baba7cd68ce1$var$AiIcon = (props)=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $9f62baba7cd68ce1$export$2e2bcd8739ae039 = $9f62baba7cd68ce1$var$AiIcon;

});

parcelRegister("4XsCU", function(module, exports) {
$parcel$export(module.exports, "getErrorMessage", () => $97c2d7f54971c4db$export$82f46aa4e6535a45);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $7tQSx = parcelRequire("7tQSx");

var $2Q7aM = parcelRequire("2Q7aM");

var $hDtQ6 = parcelRequire("hDtQ6");
const $97c2d7f54971c4db$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $7tQSx.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Q7aM.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDtQ6.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("7tQSx", function(module, exports) {
$parcel$export(module.exports, "getIsAISummaryEnabled", () => $9b4bccd413fec8a7$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $9b4bccd413fec8a7$export$cd2e891d7f87074d);

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $9b4bccd413fec8a7$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $9b4bccd413fec8a7$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $19nmp.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5NtHI.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $19nmp.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $19nmp.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $19nmp.messages).ai_summary_error_generic,
                url: (0, $5NtHI.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("2Q7aM", function(module, exports) {
$parcel$export(module.exports, "default", () => $af835e3708ee9394$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $af835e3708ee9394$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $af835e3708ee9394$export$2e2bcd8739ae039 = $af835e3708ee9394$var$AIEventErrorViewed;

});

parcelRegister("hDtQ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $4df7b5a8aadcea38$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $5NtHI = parcelRequire("5NtHI");
const $4df7b5a8aadcea38$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
        href: (0, $5NtHI.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $4df7b5a8aadcea38$export$2e2bcd8739ae039 = $4df7b5a8aadcea38$var$AILearnMoreAnchor;

});



parcelRegister("9ljdO", function(module, exports) {
$parcel$export(module.exports, "CopySummaryAction", () => $d9ba8f475ac91e83$export$cfa1d3eed9a61059);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4TA31 = parcelRequire("4TA31");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
function $d9ba8f475ac91e83$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $eJOHy.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $19nmp.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4TA31))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_summary_action_description),
        ...props
    });
}

});
parcelRegister("4TA31", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c375ed2b41c84b45c85c51ed117e320a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $390842c9527311f0$var$_react = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $390842c9527311f0$var$_copy = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("lGr6J")));

var $390842c9527311f0$var$_copy2 = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("hZKKB")));
function $390842c9527311f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $390842c9527311f0$var$CopyIcon = (props)=>/*#__PURE__*/ $390842c9527311f0$var$_react.default.createElement($390842c9527311f0$var$_copy.default, Object.assign({
        name: "CopyIcon",
        LEGACY_fallbackIcon: $390842c9527311f0$var$_copy2.default
    }, props));
$390842c9527311f0$var$CopyIcon.displayName = 'CopyIconMigration';
var $390842c9527311f0$var$_default = module.exports.default = $390842c9527311f0$var$CopyIcon;

});
parcelRegister("hZKKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d19c65e3fa3f02f9$var$_react = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d19c65e3fa3f02f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d19c65e3fa3f02f9$var$CopyIcon = (props)=>/*#__PURE__*/ $d19c65e3fa3f02f9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props));
$d19c65e3fa3f02f9$var$CopyIcon.displayName = 'CopyIcon';
var $d19c65e3fa3f02f9$var$_default = module.exports.default = $d19c65e3fa3f02f9$var$CopyIcon;

});





parcelRegister("1EoLm", function(module, exports) {
$parcel$export(module.exports, "default", () => $807f9b07437985a7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $dtpha = parcelRequire("dtpha");

var $3cMgR = parcelRequire("3cMgR");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $4iE29 = parcelRequire("4iE29");

var $kkF5t = parcelRequire("kkF5t");

const $807f9b07437985a7$var$AutomationModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lCy2I")));
const $807f9b07437985a7$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const modal = (0, $fezTc.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5NtHI.ActionName).AutomationAction];
    const automationActionOnClick = (0, $eJOHy.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $kkF5t.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($807f9b07437985a7$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $19nmp.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $4iE29.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $807f9b07437985a7$export$2e2bcd8739ae039 = $807f9b07437985a7$var$AutomationAction;

});
parcelRegister("dtpha", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ee248cff197501222c434364c4f923a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf1970ee03bcd13$var$_react = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9cf1970ee03bcd13$var$_baseNew = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9cf1970ee03bcd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cf1970ee03bcd13$var$AutomationIcon = (props)=>/*#__PURE__*/ $9cf1970ee03bcd13$var$_react.default.createElement($9cf1970ee03bcd13$var$_baseNew.default, Object.assign({
        name: "AutomationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$9cf1970ee03bcd13$var$AutomationIcon.displayName = 'AutomationIcon';
var $9cf1970ee03bcd13$var$_default = module.exports.default = $9cf1970ee03bcd13$var$AutomationIcon;

});

parcelRegister("fezTc", function(module, exports) {
$parcel$export(module.exports, "SmartLinkModalProvider", () => $a8c10a96c4151b39$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $7JfLF = parcelRequire("7JfLF");
const $a8c10a96c4151b39$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $a8c10a96c4151b39$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($a8c10a96c4151b39$var$FALLBACK_API);
const $a8c10a96c4151b39$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $eJOHy.useState)(null);
    const api = (0, $eJOHy.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7JfLF.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $eJOHy.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $eJOHy.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8 = ()=>(0, $eJOHy.useContext)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c);

});
parcelRegister("7JfLF", function(module, exports) {
$parcel$export(module.exports, "StopPropagation", () => $7b6d8602f75ebf94$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $46R8N = parcelRequire("46R8N");
const $7b6d8602f75ebf94$var$styles = {
    pressable: "_c71lidpf _p12fidpf _kqswstnw"
};
const $7b6d8602f75ebf94$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: $7b6d8602f75ebf94$var$styles.pressable,
        onClick: onClick,
        children: children
    });
};

});


parcelRegister("4iE29", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fe410232594ccf2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $1fe410232594ccf2$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $1fe410232594ccf2$export$2e2bcd8739ae039 = $1fe410232594ccf2$var$AutomationManualTriggersGlyph;

});

parcelRegister("kkF5t", function(module, exports) {
$parcel$export(module.exports, "getModalContent", () => $c38c894acd6bcefe$export$93e707b363eaf5c8);

var $19nmp = parcelRequire("19nmp");
const $c38c894acd6bcefe$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $19nmp.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $19nmp.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("lCy2I", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kVzfx")
]).then(()=>parcelRequire('kczS3'));

});


parcelRegister("bKvNh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f8cb4fc04a0fca0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $8wmgQ = parcelRequire("8wmgQ");

const $1f8cb4fc04a0fca0$var$RelatedLinksModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("km9Nb")));
const $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $fezTc.useSmartLinkModal)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($1f8cb4fc04a0fca0$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).related_links_view_related_links
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wmgQ.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $1f8cb4fc04a0fca0$export$2e2bcd8739ae039 = $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction;

});
parcelRegister("8wmgQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c344254860ed9d13$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i5stJ = parcelRequire("i5stJ");
const $c344254860ed9d13$var$RelatedLinksActionIcon = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    });
var $c344254860ed9d13$export$2e2bcd8739ae039 = $c344254860ed9d13$var$RelatedLinksActionIcon;

});

parcelRegister("km9Nb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6ojIT").then(()=>parcelRequire('3cErl'));

});


parcelRegister("fd4of", function(module, exports) {
$parcel$export(module.exports, "default", () => $875ad99f72c777d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $875ad99f72c777d8$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $875ad99f72c777d8$var$validErrorStatuses = [
    (0, $5NtHI.SmartLinkStatus).Forbidden,
    (0, $5NtHI.SmartLinkStatus).Unauthorized
];
const $875ad99f72c777d8$var$validateErrorStatus = (status)=>{
    return status !== undefined && $875ad99f72c777d8$var$validErrorStatuses.includes(status);
};
const $875ad99f72c777d8$var$getMessageDescriptor = (status, accessType, props)=>{
    if (!$875ad99f72c777d8$var$validateErrorStatus(status)) return undefined;
    const message = props?.[status]?.[accessType ?? 'FALLBACK'];
    return message;
};
const $875ad99f72c777d8$var$CustomUnresolvedAction = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $875ad99f72c777d8$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $875ad99f72c777d8$var$styles.message,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...messageDescriptor,
            values: values
        })
    });
    const component = hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $875ad99f72c777d8$var$styles.button,
        children: message
    }) : message;
    return Container ? /*#__PURE__*/ (0, $gt9Am.jsx)(Container, {
        children: component
    }) : component;
};
var $875ad99f72c777d8$export$2e2bcd8739ae039 = $875ad99f72c777d8$var$CustomUnresolvedAction;

});




parcelRegister("bIdM1", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b32359b6ff0e19a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $2b32359b6ff0e19a$var$baseBlockStyles = null;
const $2b32359b6ff0e19a$var$highlightRemoveStyles = null;
const $2b32359b6ff0e19a$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $2b32359b6ff0e19a$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $2b32359b6ff0e19a$var$Block = ({ children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $eJOHy.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $2b32359b6ff0e19a$var$directionStyles[direction],
            $2b32359b6ff0e19a$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId,
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $2b32359b6ff0e19a$export$2e2bcd8739ae039 = $2b32359b6ff0e19a$var$Block;

});



parcelRegister("gKsxm", function(module, exports) {
$parcel$export(module.exports, "default", () => $948e354a880fdc81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $948e354a880fdc81$var$DEFAULT_MAX_LINES = 2;
const $948e354a880fdc81$var$MAXIMUM_MAX_LINES = 2;
const $948e354a880fdc81$var$MINIMUM_MAX_LINES = 1;
const $948e354a880fdc81$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $948e354a880fdc81$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $948e354a880fdc81$var$getMaxLines = (maxLines)=>{
    if (maxLines > $948e354a880fdc81$var$MAXIMUM_MAX_LINES) return $948e354a880fdc81$var$DEFAULT_MAX_LINES;
    if (maxLines < $948e354a880fdc81$var$MINIMUM_MAX_LINES) return $948e354a880fdc81$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $948e354a880fdc81$var$ElementItemRenderer = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $5NtHI.SmartLinkSize).Medium, maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $brTAh.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
        align: align,
        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
        width: (0, $5NtHI.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $hcewu.default)([
            $948e354a880fdc81$var$truncateStyles[maxLines],
            $948e354a880fdc81$var$sizeStyles[size]
        ]),
        children: elements
    });
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $948e354a880fdc81$var$MetadataBlock = ({ maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $5NtHI.SmartLinkSize).Medium;
    const maxLinesTotal = $948e354a880fdc81$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                items: primary,
                size: size,
                maxLines: maxLinesTotal
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                items: secondary,
                size: size,
                maxLines: maxLinesTotal
            })
        ]
    });
};
var $948e354a880fdc81$export$2e2bcd8739ae039 = $948e354a880fdc81$var$MetadataBlock;

});

parcelRegister("8Rjtc", function(module, exports) {
$parcel$export(module.exports, "default", () => $56e117ae59d9b928$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bgqs9 = parcelRequire("bgqs9");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $56e117ae59d9b928$var$PreviewBlock = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bgqs9.default), {
        ...blockProps,
        size: blockProps.size ?? ui?.size,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $56e117ae59d9b928$export$2e2bcd8739ae039 = $56e117ae59d9b928$var$PreviewBlock;

});
parcelRegister("bgqs9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7730cb1921d134f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $7Byzo = parcelRequire("7Byzo");

var $bIdM1 = parcelRequire("bIdM1");
const $7730cb1921d134f4$var$previewBlockStyleCommon = null;
const $7730cb1921d134f4$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $7730cb1921d134f4$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)(style ?? {});
    const updateStyles = (0, $eJOHy.useCallback)(()=>{
        if (placement === (0, $5NtHI.MediaPlacement).Left || placement === (0, $5NtHI.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $5NtHI.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $5NtHI.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    // Should be useLayoutEffect to avoid flicker.
    // Styles should be set before paint.
    (0, $eJOHy.useLayoutEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $eJOHy.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $eJOHy.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Byzo.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $7730cb1921d134f4$export$2e2bcd8739ae039 = $7730cb1921d134f4$var$PreviewBlockResolvedView;

});


parcelRegister("5gb8b", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbe48527b965b005$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $5MmSu = parcelRequire("5MmSu");

var $f7w3l = parcelRequire("f7w3l");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
const $fbe48527b965b005$var$DEFAULT_MAX_LINES = 3;
const $fbe48527b965b005$var$MAXIMUM_MAX_LINES = 6;
const $fbe48527b965b005$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $fbe48527b965b005$var$SnippetBlock = ({ maxLines: maxLines = $fbe48527b965b005$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    const context = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5FRJ8.useFlexibleUiContext)() : undefined;
    const renderers = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5MmSu.useSmartLinkRenderers)() : undefined;
    const enableSnippetRenderer = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5FRJ8.useFlexibleUiOptionContext)()?.enableSnippetRenderer : undefined;
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fQH39.getMaxLines)(maxLines, $fbe48527b965b005$var$DEFAULT_MAX_LINES, $fbe48527b965b005$var$MAXIMUM_MAX_LINES, $fbe48527b965b005$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7w3l.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!(0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') || !enableSnippetRenderer) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: snippet
    });
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: SnippetReplacement ? /*#__PURE__*/ (0, $gt9Am.jsx)(SnippetReplacement, {
            fallbackText: (text || context?.snippet) ?? '',
            fallbackComponent: snippet,
            contentId: context?.meta?.objectId ?? '',
            contentType: context?.meta?.resourceType ?? '',
            cloudId: context?.meta?.tenantId ?? '',
            maxLines: snippetMaxLines,
            isHidden: isHidden,
            showFooter: showFooter
        }) : snippet
    });
};
var $fbe48527b965b005$export$2e2bcd8739ae039 = $fbe48527b965b005$var$SnippetBlock;

});
parcelRegister("5MmSu", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkRenderers", () => $8065e50e2bfb34aa$export$c3514c024fefef57);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $8065e50e2bfb34aa$export$c3514c024fefef57 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $eJOHy.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});


parcelRegister("fqBfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0af5d75f753a471$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $5FRJ8 = parcelRequire("5FRJ8");

var $i6ktq = parcelRequire("i6ktq");

var $6P8F3 = parcelRequire("6P8F3");

var $gjoE0 = parcelRequire("gjoE0");

var $haRRg = parcelRequire("haRRg");

var $1Ub5D = parcelRequire("1Ub5D");
const $a0af5d75f753a471$var$actionStyles = null;
const $a0af5d75f753a471$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return 0, $1Ub5D.default;
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return 0, $haRRg.default;
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return 0, $gjoE0.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $a0af5d75f753a471$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const { status: status = (0, $5NtHI.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $eJOHy.useState)(false);
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i6ktq.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: ui?.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $a0af5d75f753a471$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? ui?.size,
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $a0af5d75f753a471$export$2e2bcd8739ae039 = $a0af5d75f753a471$var$TitleBlock;

});
parcelRegister("gjoE0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9925dc77e1d9b77$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cLrUd = parcelRequire("cLrUd");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $e9925dc77e1d9b77$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position
            }),
            title,
            showRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cLrUd.default), {
                    testId: testId
                })
            }),
            actionGroup
        ]
    });
};
var $e9925dc77e1d9b77$export$2e2bcd8739ae039 = $e9925dc77e1d9b77$var$TitleBlockErroredView;

});

parcelRegister("haRRg", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bf1e0846d3cab95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $3bf1e0846d3cab95$var$style = null;
const $3bf1e0846d3cab95$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $3bf1e0846d3cab95$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $brTAh.renderElementItems)(metadata);
    const subtitleElements = (0, $brTAh.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position,
                size: size,
                hideLoadingSkeleton: hideIconLoadingSkeleton
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Vertical,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $hcewu.default)([
                    "_zulp1b66"
                ]),
                children: [
                    CompetitorPrompt && url && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        xcss: $3bf1e0846d3cab95$var$styles.titleBox,
                        children: [
                            title,
                            /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
                                sourceUrl: url,
                                linkType: 'card'
                            })
                        ]
                    }) : title,
                    subtitleElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $5NtHI.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $3bf1e0846d3cab95$export$2e2bcd8739ae039 = $3bf1e0846d3cab95$var$TitleBlockResolvedView;

});

parcelRegister("1Ub5D", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9eea7741f2cb919$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $65mpR = parcelRequire("65mpR");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $f9eea7741f2cb919$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5NtHI.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                style: {
                    width: iconWidth,
                    height: iconWidth
                },
                "data-testid": `${testId}-icon`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                    width: iconWidth,
                    height: iconWidth,
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $f9eea7741f2cb919$export$2e2bcd8739ae039 = $f9eea7741f2cb919$var$TitleBlockResolvingView;

});


parcelRegister("2qnEp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4a63c55a864af4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $gxvmf = parcelRequire("gxvmf");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $d4a63c55a864af4f$var$AISummaryBlock = ({ testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gxvmf.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
};
var $d4a63c55a864af4f$export$2e2bcd8739ae039 = $d4a63c55a864af4f$var$AISummaryBlock;

});
parcelRegister("gxvmf", function(module, exports) {
$parcel$export(module.exports, "default", () => $5839dd28b40ea23d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $2LycE = parcelRequire("2LycE");

var $4zxv7 = parcelRequire("4zxv7");

var $ei710 = parcelRequire("ei710");

var $bIdM1 = parcelRequire("bIdM1");

var $cQU20 = parcelRequire("cQU20");
const $5839dd28b40ea23d$var$styles = null;
const $5839dd28b40ea23d$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $4zxv7.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $2LycE.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $eJOHy.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        direction: (0, $5NtHI.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $hcewu.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cQU20.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4zxv7.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $5839dd28b40ea23d$export$2e2bcd8739ae039 = $5839dd28b40ea23d$var$AISummaryBlockResolvedView;

});
parcelRegister("4zxv7", function(module, exports) {
$parcel$export(module.exports, "default", () => $50e0b0d82c1c1601$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gzZ1I = parcelRequire("gzZ1I");

var $3JG7o = parcelRequire("3JG7o");
const $50e0b0d82c1c1601$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $50e0b0d82c1c1601$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gzZ1I.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $3JG7o.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $50e0b0d82c1c1601$export$2e2bcd8739ae039 = $50e0b0d82c1c1601$var$AISummary;

});
parcelRegister("gzZ1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $031d6845af3014cc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $031d6845af3014cc$var$t() {
    return $031d6845af3014cc$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $031d6845af3014cc$var$t.apply(this, arguments);
}
const $031d6845af3014cc$var$n = [
    "children",
    "options"
], $031d6845af3014cc$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $031d6845af3014cc$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($031d6845af3014cc$var$i || ($031d6845af3014cc$var$i = {}));
const $031d6845af3014cc$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $031d6845af3014cc$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $031d6845af3014cc$var$o = [
    "style",
    "script"
], $031d6845af3014cc$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $031d6845af3014cc$var$s = /mailto:/i, $031d6845af3014cc$var$d = /\n{2,}$/, $031d6845af3014cc$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $031d6845af3014cc$var$u = /^ *> ?/gm, $031d6845af3014cc$var$f = /^ {2,}\n/, $031d6845af3014cc$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $031d6845af3014cc$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $031d6845af3014cc$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $031d6845af3014cc$var$k = /^(?:\n *)*\n/, $031d6845af3014cc$var$x = /\r\n?/g, $031d6845af3014cc$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $031d6845af3014cc$var$v = /^\[\^([^\]]+)]/, $031d6845af3014cc$var$S = /\f/g, $031d6845af3014cc$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $031d6845af3014cc$var$C = /^\s*?\[(x|\s)\]/, $031d6845af3014cc$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $031d6845af3014cc$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $031d6845af3014cc$var$T = /^<!--[\s\S]*?(?:-->)/, $031d6845af3014cc$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $031d6845af3014cc$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $031d6845af3014cc$var$M = /^\{.*\}$/, $031d6845af3014cc$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $031d6845af3014cc$var$I = /^<([^ >]+@[^ >]+)>/, $031d6845af3014cc$var$U = /^<([^ >]+:\/[^ >]+)>/, $031d6845af3014cc$var$D = /-([a-z])?/gi, $031d6845af3014cc$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $031d6845af3014cc$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $031d6845af3014cc$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $031d6845af3014cc$var$_ = /\t/g, $031d6845af3014cc$var$G = /(^ *\||\| *$)/g, $031d6845af3014cc$var$W = /^ *:-+: *$/, $031d6845af3014cc$var$Z = /^ *:-+ *$/, $031d6845af3014cc$var$q = /^ *-+: *$/, $031d6845af3014cc$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $031d6845af3014cc$var$V = new RegExp(`^([*_])\\1${$031d6845af3014cc$var$Q}\\1\\1(?!\\1)`), $031d6845af3014cc$var$X = new RegExp(`^([*_])${$031d6845af3014cc$var$Q}\\1(?!\\1|\\w)`), $031d6845af3014cc$var$J = new RegExp(`^==${$031d6845af3014cc$var$Q}==`), $031d6845af3014cc$var$K = new RegExp(`^~~${$031d6845af3014cc$var$Q}~~`), $031d6845af3014cc$var$Y = /^\\([^0-9A-Za-z\s])/, $031d6845af3014cc$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $031d6845af3014cc$var$te = /^\n+/, $031d6845af3014cc$var$ne = /^([ \t]*)/, $031d6845af3014cc$var$re = /\\([^\\])/g, $031d6845af3014cc$var$ie = / *\n+$/, $031d6845af3014cc$var$le = /(?:^|\n)( *)$/, $031d6845af3014cc$var$ae = "(?:\\d+\\.)", $031d6845af3014cc$var$oe = "(?:[*+-])";
function $031d6845af3014cc$var$ce(e) {
    return "( *)(" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + ") +";
}
const $031d6845af3014cc$var$se = $031d6845af3014cc$var$ce(1), $031d6845af3014cc$var$de = $031d6845af3014cc$var$ce(2);
function $031d6845af3014cc$var$pe(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de));
}
const $031d6845af3014cc$var$ue = $031d6845af3014cc$var$pe(1), $031d6845af3014cc$var$fe = $031d6845af3014cc$var$pe(2);
function $031d6845af3014cc$var$he(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $031d6845af3014cc$var$me = $031d6845af3014cc$var$he(1), $031d6845af3014cc$var$ge = $031d6845af3014cc$var$he(2);
function $031d6845af3014cc$var$ye(e) {
    const t = 1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $031d6845af3014cc$var$ke = $031d6845af3014cc$var$ye(1), $031d6845af3014cc$var$xe = $031d6845af3014cc$var$ye(2);
function $031d6845af3014cc$var$be(e, t) {
    const n = 1 === t, i = n ? $031d6845af3014cc$var$ke : $031d6845af3014cc$var$xe, l = n ? $031d6845af3014cc$var$me : $031d6845af3014cc$var$ge, a = n ? $031d6845af3014cc$var$ue : $031d6845af3014cc$var$fe;
    return {
        match (e, t) {
            const n = $031d6845af3014cc$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($031d6845af3014cc$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($031d6845af3014cc$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($031d6845af3014cc$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $031d6845af3014cc$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $031d6845af3014cc$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $031d6845af3014cc$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $031d6845af3014cc$var$Ee = [
    $031d6845af3014cc$var$p,
    $031d6845af3014cc$var$m,
    $031d6845af3014cc$var$g,
    $031d6845af3014cc$var$$,
    $031d6845af3014cc$var$z,
    $031d6845af3014cc$var$w,
    $031d6845af3014cc$var$T,
    $031d6845af3014cc$var$j,
    $031d6845af3014cc$var$me,
    $031d6845af3014cc$var$ke,
    $031d6845af3014cc$var$ge,
    $031d6845af3014cc$var$xe
], $031d6845af3014cc$var$Ce = [
    ...$031d6845af3014cc$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $031d6845af3014cc$var$L,
    $031d6845af3014cc$var$B
];
function $031d6845af3014cc$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $031d6845af3014cc$var$we(e) {
    return $031d6845af3014cc$var$q.test(e) ? "right" : $031d6845af3014cc$var$W.test(e) ? "center" : $031d6845af3014cc$var$Z.test(e) ? "left" : null;
}
function $031d6845af3014cc$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $031d6845af3014cc$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $031d6845af3014cc$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($031d6845af3014cc$var$G, "").split("|").map($031d6845af3014cc$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $031d6845af3014cc$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $031d6845af3014cc$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.paragraph
    };
}
function $031d6845af3014cc$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $031d6845af3014cc$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $031d6845af3014cc$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $031d6845af3014cc$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$031d6845af3014cc$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $031d6845af3014cc$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $031d6845af3014cc$var$Ue(e) {
    return e.replace($031d6845af3014cc$var$re, "$1");
}
function $031d6845af3014cc$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $031d6845af3014cc$var$He = (e, t, n)=>({
        children: $031d6845af3014cc$var$De(t, e[1], n)
    });
function $031d6845af3014cc$var$Fe() {
    return {};
}
function $031d6845af3014cc$var$Pe() {
    return null;
}
function $031d6845af3014cc$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $031d6845af3014cc$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $031d6845af3014cc$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $031d6845af3014cc$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $031d6845af3014cc$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $031d6845af3014cc$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $031d6845af3014cc$var$t({}, n, l, {
            className: $031d6845af3014cc$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($031d6845af3014cc$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $031d6845af3014cc$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($031d6845af3014cc$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $eJOHy.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($031d6845af3014cc$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($031d6845af3014cc$var$O) && (e = e.replace($031d6845af3014cc$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $031d6845af3014cc$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($031d6845af3014cc$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($031d6845af3014cc$var$L.test(p) || $031d6845af3014cc$var$B.test(p)) && (n[d] = $eJOHy.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$031d6845af3014cc$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $031d6845af3014cc$export$3e2338ea76b578c9, i.slugify = i.slugify || $031d6845af3014cc$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $031d6845af3014cc$var$t({}, $031d6845af3014cc$var$a, i.namedCodesToUnicode) : $031d6845af3014cc$var$a, i.createElement = i.createElement || $eJOHy.createElement;
    const Z = [], q = {}, Q = {
        [$031d6845af3014cc$export$e0aa44767d8750d5.blockQuote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($031d6845af3014cc$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakLine]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$f),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakThematic]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$h),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeBlock]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $031d6845af3014cc$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeFenced]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeInline]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnoteReference]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $031d6845af3014cc$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.gfmTask]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.heading]: {
            match: $031d6845af3014cc$var$Be(i.enforceAtxHeadings ? $031d6845af3014cc$var$w : $031d6845af3014cc$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[2], n),
                    id: i.slugify(e[2], $031d6845af3014cc$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.headingSetext]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.heading
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($031d6845af3014cc$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $031d6845af3014cc$var$Ce.some((e)=>e.test(c)) ? $031d6845af3014cc$var$Ne : $031d6845af3014cc$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $031d6845af3014cc$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlComment]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$T),
            order: 1,
            parse: ()=>({}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.image]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.link]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$je(t, e[1], n),
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $031d6845af3014cc$var$Te($031d6845af3014cc$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $031d6845af3014cc$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                };
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.orderedList]: $031d6845af3014cc$var$be(d, 1),
        [$031d6845af3014cc$export$e0aa44767d8750d5.unorderedList]: $031d6845af3014cc$var$be(d, 2),
        [$031d6845af3014cc$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$k),
            order: 3,
            parse: $031d6845af3014cc$var$Fe,
            render: ()=>"\n"
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.paragraph]: {
            match: $031d6845af3014cc$var$Re,
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.ref]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refImage]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refLink]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.table]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$j),
            order: 1,
            parse: $031d6845af3014cc$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $031d6845af3014cc$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $031d6845af3014cc$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.text]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($031d6845af3014cc$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textBolded]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEmphasized]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEscaped]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textMarked]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$J),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$K),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock], delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($031d6845af3014cc$var$x, "\n").replace($031d6845af3014cc$var$S, "").replace($031d6845af3014cc$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $031d6845af3014cc$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $031d6845af3014cc$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $031d6845af3014cc$var$n);
    return $eJOHy.cloneElement($031d6845af3014cc$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("3JG7o", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f398c5c3f3cb7e7$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $8f398c5c3f3cb7e7$var$listStyles = null;
const $8f398c5c3f3cb7e7$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        ...props,
        className: (0, $hcewu.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $8f398c5c3f3cb7e7$export$2e2bcd8739ae039 = $8f398c5c3f3cb7e7$var$UList;

});


parcelRegister("ei710", function(module, exports) {
$parcel$export(module.exports, "default", () => $fda5b98323afadf3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $fda5b98323afadf3$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $eJOHy.useState)(0);
    const ref = (0, $eJOHy.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $eJOHy.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $fda5b98323afadf3$export$2e2bcd8739ae039 = $fda5b98323afadf3$export$6118ed0013927eb2;

});

parcelRegister("cQU20", function(module, exports) {
$parcel$export(module.exports, "default", () => $f73e03b62ddf95ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $f73e03b62ddf95ac$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $f73e03b62ddf95ac$export$2e2bcd8739ae039 = $f73e03b62ddf95ac$var$AIEventSummaryViewed;

});



parcelRegister("eMgzj", function(module, exports) {
$parcel$export(module.exports, "default", () => $a57421ef9d4f6376$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $37K19 = parcelRequire("37K19");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $a57421ef9d4f6376$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37K19.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $a57421ef9d4f6376$export$2e2bcd8739ae039 = $a57421ef9d4f6376$var$AIFooterBlock;

});
parcelRegister("37K19", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a90281cb091ec71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $bIdM1 = parcelRequire("bIdM1");

var $kopBz = parcelRequire("kopBz");
const $3a90281cb091ec71$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopBz.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $3a90281cb091ec71$export$2e2bcd8739ae039 = $3a90281cb091ec71$var$AIFooterBlockResolvedView;

});
parcelRegister("kopBz", function(module, exports) {
$parcel$export(module.exports, "AIFooterMetadata", () => $bf118c10e8951921$export$175228cc2c92b3b6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $fOqNz = parcelRequire("fOqNz");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $k71qx = parcelRequire("k71qx");

var $19nmp = parcelRequire("19nmp");

var $2LycE = parcelRequire("2LycE");

var $jeUcl = parcelRequire("jeUcl");

var $bB163 = parcelRequire("bB163");
const $bf118c10e8951921$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bB163.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $jeUcl.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("bB163", function(module, exports) {
$parcel$export(module.exports, "InfoIcon", () => $ebe2ee8525f34821$export$2957fc44b3d2481);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2R0ne = parcelRequire("2R0ne");

var $klVDP = parcelRequire("klVDP");
const $ebe2ee8525f34821$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $klVDP.default),
        ...props
    });

});
parcelRegister("klVDP", function(module, exports) {
$parcel$export(module.exports, "default", () => $95f050f94233fcee$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $95f050f94233fcee$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $95f050f94233fcee$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $95f050f94233fcee$var$InfoIconGlyph
    });
var $95f050f94233fcee$export$2e2bcd8739ae039 = $95f050f94233fcee$var$InfoIcon;

});





parcelRegister("4cjOx", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a174909684ab758$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $lHA6U = parcelRequire("lHA6U");

var $1dIgp = parcelRequire("1dIgp");
const $3a174909684ab758$var$ignoreContainerPaddingStyles = null;
const $3a174909684ab758$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $3a174909684ab758$var$sort = (a, b)=>{
    let idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $3a174909684ab758$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $3a174909684ab758$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gRw8I.di)((0, $1dIgp.ActionFooter));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const onLoadingChange = (0, $eJOHy.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $3a174909684ab758$export$1af10e3728e3a644(ui?.size || (0, $5NtHI.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $eJOHy.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $eJOHy.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $eJOHy.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($3a174909684ab758$var$sort);
        return arr.map((name)=>{
            const Action = name in $lHA6U ? $lHA6U[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || ui?.size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick
    ]);
    return actions ? /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dIgp.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $3a174909684ab758$export$2e2bcd8739ae039 = $3a174909684ab758$var$ActionBlock;

});
parcelRegister("1dIgp", function(module, exports) {
$parcel$export(module.exports, "ActionFooter", () => $495d2943b4977c6a$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1NG86 = parcelRequire("1NG86");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $ei710 = parcelRequire("ei710");
const $495d2943b4977c6a$var$styles = {
    containerStyles: "_kkk2n7od _2rko12b0 _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $495d2943b4977c6a$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                size: "small"
            });
        default:
            return null;
    }
};
const $495d2943b4977c6a$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $495d2943b4977c6a$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $495d2943b4977c6a$var$styles.errorContentStyles,
                children: [
                    message.icon || $495d2943b4977c6a$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        xcss: $495d2943b4977c6a$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});




parcelRegister("k9P6L", function(module, exports) {
$parcel$export(module.exports, "LoadingCardLink", () => $9acebe3c2480723a$export$1ca0544321134ad6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kj3Kk = parcelRequire("kj3Kk");

const $9acebe3c2480723a$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6ed49f57481afa45$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
parcelRegister("kj3Kk", function(module, exports) {
$parcel$export(module.exports, "CardLinkView", () => $c60e87c9a02f8e5e$export$ce508304ed2dd145);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bu0pj = parcelRequire("bu0pj");
class $c60e87c9a02f8e5e$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("bu0pj", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $a33467e63cbde9e1$export$b89a827e9254211a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e3qu2 = parcelRequire("e3qu2");

var $hFjcp = parcelRequire("hFjcp");
const $a33467e63cbde9e1$export$b89a827e9254211a = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $hFjcp.WrapperAnchor) : (0, $hFjcp.WrapperSpan);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("hFjcp", function(module, exports) {
$parcel$export(module.exports, "WrapperSpan", () => $410d9f0a7ea732a2$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $410d9f0a7ea732a2$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $410d9f0a7ea732a2$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rko12b0 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19it1x13 _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw71x13 _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rko12b0 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19it1x13 _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw71x13 _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$var$baseWrapperStyles = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $410d9f0a7ea732a2$var$interactiveStyles = null;
const $410d9f0a7ea732a2$var$hoveredStyles = null;
const $410d9f0a7ea732a2$var$hoveredWithBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withoutBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withBackgroundStyles = null;
const $410d9f0a7ea732a2$var$truncateStyles = null;
const $410d9f0a7ea732a2$var$notSelectedStyle = null;
const $410d9f0a7ea732a2$var$selectedStyles = null;

});



const $6ed49f57481afa45$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("lqpyp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("6nRbC")
]).then(()=>parcelRequire('kzwZ8'));

});



parcelRegister("81LfQ", function(module, exports) {
$parcel$export(module.exports, "CardErrorBoundary", () => $6d47cca45f4926d8$export$7f923465a27f725b);

var $gt9Am = parcelRequire("gt9Am");

var $eJ9f5 = parcelRequire("eJ9f5");

var $eGOwo = parcelRequire("eGOwo");

var $eJOHy = parcelRequire("eJOHy");

var $lOeyo = parcelRequire("lOeyo");

var $iKozC = parcelRequire("iKozC");

var $d2DmH = parcelRequire("d2DmH");
class $6d47cca45f4926d8$export$7f923465a27f725b extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static getDerivedStateFromError(error) {
        return {
            isError: true,
            error: error
        };
    }
    render() {
        if (this.state.isError) {
            const { url: url, isDatasource: isDatasource, unsupportedComponent: UnsupportedComponent, datasourceId: datasourceId } = this.props;
            if (url) {
                const fallback = (0, $eGOwo.fg)('dst-a11y__replace-anchor-with-link__editor') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                    href: url,
                    onClick: this.onClickFallback,
                    children: url
                }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                    href: url,
                    onClick: this.onClickFallback,
                    children: url
                });
                if (isDatasource) {
                    if ((0, $iKozC.isSafeUrl)(url)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2DmH.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                        datasourceId: datasourceId,
                        error: this.state.error,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lOeyo.InlineCard), {
                            ...this.props
                        })
                    });
                    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2DmH.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                        datasourceId: datasourceId,
                        error: this.state.error,
                        children: fallback
                    });
                } else return fallback;
            } else return /*#__PURE__*/ (0, $gt9Am.jsx)(UnsupportedComponent, {});
        }
        return this.props.children;
    }
    componentDidCatch(_error) {
        this.setState({
            isError: true,
            error: _error
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isError: false,
            error: null
        }, this.onClickFallback = (e)=>{
            const { onClick: onClick, url: url } = this.props;
            e.preventDefault();
            if (onClick) onClick(e, url);
        };
    }
}

});
parcelRegister("d2DmH", function(module, exports) {
$parcel$export(module.exports, "LazyLoadedDatasourceRenderFailedAnalyticsWrapper", () => $e573d4ac9205d05d$export$f386473e8f104bcb);

var $eJOHy = parcelRequire("eJOHy");

const $e573d4ac9205d05d$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("15L9S")));
const $e573d4ac9205d05d$export$f386473e8f104bcb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e573d4ac9205d05d$var$LazyDatasourceRenderFailedAnalyticsWrapper, props));

});
parcelRegister("15L9S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jQLsm").then(()=>parcelRequire('kpPKM'));

});



parcelRegister("kL4gV", function(module, exports) {
$parcel$export(module.exports, "getCardClickHandler", () => $c69b503f8fa01e3e$export$c168b9c5078297ed);

var $g9wjI = parcelRequire("g9wjI");
const $c69b503f8fa01e3e$export$c168b9c5078297ed = (eventHandlers, url)=>{
    const handler = (0, $g9wjI.getEventHandler)(eventHandlers, 'smartCard');
    return handler ? (e)=>handler(e, url) : undefined;
};

});

parcelRegister("hGXwD", function(module, exports) {
$parcel$export(module.exports, "default", () => $71f260d63f3a536e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $9kfy2 = parcelRequire("9kfy2");

var $4cFYC = parcelRequire("4cFYC");
var $03JM4 = parcelRequire("03JM4");

var $bRvMX = parcelRequire("bRvMX");

var $8YHJ2 = parcelRequire("8YHJ2");

var $etjvQ = parcelRequire("etjvQ");
var $dfCRV = parcelRequire("dfCRV");

var $eGOwo = parcelRequire("eGOwo");

var $e2B2h = parcelRequire("e2B2h");

var $AIyOt = parcelRequire("AIyOt");

var $92xoS = parcelRequire("92xoS");

var $cbSL1 = parcelRequire("cbSL1");

var $81LfQ = parcelRequire("81LfQ");

var $dZ1mQ = parcelRequire("dZ1mQ");

var $kL4gV = parcelRequire("kL4gV");

var $8KqmO = parcelRequire("8KqmO");

var $jWNZR = parcelRequire("jWNZR");
const $71f260d63f3a536e$var$HoverLinkOverlayNoop = (props)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, props.children);
const $71f260d63f3a536e$var$HoverLinkOverlayWithCondition = (0, $AIyOt.componentWithCondition)(()=>(0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
        exposure: true
    }), (0, $etjvQ.default), $71f260d63f3a536e$var$HoverLinkOverlayNoop);
const $71f260d63f3a536e$var$OverlayWithCardContext = ({ rendererAppearance: rendererAppearance, isResolvedViewRendered: isResolvedViewRendered, url: url, children: children })=>{
    const cardContext = (0, $9kfy2.useSmartCardContext)();
    // Note: useSmartLinkActions throws without smart card context. Using it here is safe
    // because we checked cardContext availability in the parent component
    const actions = (0, $bRvMX.useSmartLinkActions)({
        url: url,
        appearance: 'inline'
    });
    const preview = (0, $eJOHy.useMemo)(()=>actions.find((action)=>action.id === 'preview-content'), [
        actions
    ]);
    const cardState = cardContext?.value?.store?.getState()[url || ''];
    const ari = (0, $03JM4.getObjectAri)(cardState?.details);
    const name = (0, $03JM4.getObjectName)(cardState?.details);
    const iconUrl = (0, $03JM4.getObjectIconUrl)(cardState?.details);
    // Get resolved URL from card state, fallback to original URL if not available
    let resolvedUrl = url;
    if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
        const cardStateUrl = cardState?.details?.data && 'url' in cardState.details.data ? cardState.details.data.url : undefined;
        resolvedUrl = cardStateUrl || url;
    }
    const isPanelAvailable = ari && cardContext?.value?.isPreviewPanelAvailable?.({
        ari: ari
    });
    const openPreviewPanel = cardContext?.value?.openPreviewPanel;
    const isPreviewPanelAvailable = Boolean(openPreviewPanel && isPanelAvailable);
    const isPreviewModalAvailable = Boolean(preview);
    const isPreviewAvailable = isPreviewModalAvailable || isPreviewPanelAvailable;
    const showPanelButtonIcon = isPreviewPanelAvailable ? 'panel' : isPreviewModalAvailable ? 'modal' : undefined;
    const Overlay = isPreviewAvailable ? $71f260d63f3a536e$var$HoverLinkOverlayWithCondition : $71f260d63f3a536e$var$HoverLinkOverlayNoop;
    return /*#__PURE__*/ (0, $1NIU8.jsx)(Overlay, {
        isVisible: isResolvedViewRendered,
        url: url,
        compactPadding: rendererAppearance === 'comment',
        showPanelButton: isPreviewAvailable,
        showPanelButtonIcon: showPanelButtonIcon,
        onClick: (event)=>{
            if (isPreviewPanelAvailable) {
                // Prevent anchor default behaviour(click to open the anchor link)
                // When glance panel is available, let openPreviewPanel handle it
                event.preventDefault();
                openPreviewPanel?.({
                    url: resolvedUrl || '',
                    ari: ari || '',
                    name: name || '',
                    iconUrl: iconUrl
                });
            } else if (isPreviewModalAvailable) {
                event.preventDefault();
                if (preview) preview.invoke();
            }
        }
    }, children);
};
const $71f260d63f3a536e$var$InlineCard = (props)=>{
    const { url: url, data: data, eventHandlers: eventHandlers, smartLinks: smartLinks, rendererAppearance: rendererAppearance } = props;
    const portal = (0, $jWNZR.usePortal)(props);
    const cardContext = (0, $9kfy2.useSmartCardContext)();
    const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $eJOHy.useState)(false);
    const onClick = (0, $kL4gV.getCardClickHandler)(eventHandlers, url);
    const cardProps = {
        url: url,
        data: data,
        onClick: onClick,
        container: portal
    };
    const { hideHoverPreview: hideHoverPreview, actionOptions: actionOptions, ssr: ssr } = smartLinks || {};
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    const inlineAnnotationProps = (0, $8KqmO.useInlineAnnotationProps)(props);
    const CompetitorPrompt = smartLinks?.CompetitorPrompt;
    const CompetitorPromptComponent = CompetitorPrompt && url && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $1NIU8.jsx)(CompetitorPrompt, {
        sourceUrl: url,
        linkType: "inline"
    }) : null;
    const onError = ({ err: err })=>{
        if (err) throw err;
    };
    const MaybeOverlay = cardContext?.value ? $71f260d63f3a536e$var$OverlayWithCardContext : $71f260d63f3a536e$var$HoverLinkOverlayNoop;
    if (ssr && url && !(0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
        exposure: true
    })) {
        if (// eslint-disable-next-line @atlaskit/platform/no-invalid-feature-flag-usage
        (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            "data-inline-card": true,
            "data-card-data": data ? JSON.stringify(data) : undefined,
            "data-card-url": url,
            ...inlineAnnotationProps
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
            data: analyticsData
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8YHJ2.CardSSR), {
            appearance: "inline",
            url: url,
            showHoverPreview: !hideHoverPreview,
            actionOptions: actionOptions,
            onClick: onClick
        })));
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
            data: analyticsData
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8YHJ2.CardSSR), {
            appearance: "inline",
            url: url,
            showHoverPreview: !hideHoverPreview,
            actionOptions: actionOptions,
            onClick: onClick
        }));
    } else if (ssr && url && (0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
        exposure: true
    })) {
        if (// eslint-disable-next-line @atlaskit/platform/no-invalid-feature-flag-usage
        (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            "data-inline-card": true,
            "data-card-data": data ? JSON.stringify(data) : undefined,
            "data-card-url": url,
            "data-renderer-mark": inlineAnnotationProps['data-renderer-mark'],
            "data-annotation-draft-mark": inlineAnnotationProps['data-annotation-draft-mark'],
            "data-annotation-inline-node": inlineAnnotationProps['data-annotation-inline-node'],
            "data-renderer-start-pos": inlineAnnotationProps['data-renderer-start-pos'],
            "data-annotation-mark": inlineAnnotationProps['data-annotation-mark']
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
            data: analyticsData
        }, /*#__PURE__*/ (0, $1NIU8.jsx)(MaybeOverlay, {
            url: url || '',
            rendererAppearance: rendererAppearance,
            isResolvedViewRendered: isResolvedViewRendered
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8YHJ2.CardSSR), {
            appearance: "inline",
            url: url,
            showHoverPreview: !hideHoverPreview,
            actionOptions: actionOptions,
            onClick: onClick,
            onResolve: (data)=>{
                if (!data.url || !data.title) return;
                props.smartCardStorage.set(data.url, data.title);
                if (data.title) setIsResolvedViewRendered(true);
            },
            onError: onError,
            disablePreviewPanel: true
        }))));
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
            data: analyticsData
        }, /*#__PURE__*/ (0, $1NIU8.jsx)(MaybeOverlay, {
            url: url || '',
            rendererAppearance: rendererAppearance,
            isResolvedViewRendered: isResolvedViewRendered
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8YHJ2.CardSSR), {
            appearance: "inline",
            url: url,
            showHoverPreview: !hideHoverPreview,
            actionOptions: actionOptions,
            onClick: onClick,
            onResolve: (data)=>{
                if (!data.url || !data.title) return;
                props.smartCardStorage.set(data.url, data.title);
                if (data.title) setIsResolvedViewRendered(true);
            },
            onError: onError,
            disablePreviewPanel: true
        })));
    }
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        "data-inline-card": true,
        "data-card-data": data ? JSON.stringify(data) : undefined,
        "data-card-url": url,
        ...inlineAnnotationProps
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $81LfQ.CardErrorBoundary), {
        unsupportedComponent: (0, $dfCRV.default),
        ...cardProps
    }, /*#__PURE__*/ (0, $1NIU8.jsx)(MaybeOverlay, {
        url: url || '',
        rendererAppearance: rendererAppearance,
        isResolvedViewRendered: isResolvedViewRendered
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4cFYC.Card), {
        appearance: "inline",
        showHoverPreview: !hideHoverPreview,
        actionOptions: actionOptions,
        ...cardProps,
        onResolve: (data)=>{
            if (!data.url || !data.title) return;
            props.smartCardStorage.set(data.url, data.title);
            if (data.title) setIsResolvedViewRendered(true);
        },
        onError: onError,
        disablePreviewPanel: (0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        })
    })), CompetitorPromptComponent)));
};
var $71f260d63f3a536e$export$2e2bcd8739ae039 = (0, $dZ1mQ.withSmartCardStorage)($71f260d63f3a536e$var$InlineCard);

});
parcelRegister("bRvMX", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkActions", () => $323ca68ef5d54cb2$export$a95296ded9241771);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $9kfy2 = parcelRequire("9kfy2");

var $cbSL1 = parcelRequire("cbSL1");

var $bmWcp = parcelRequire("bmWcp");

var $ccFJO = parcelRequire("ccFJO");

var $5O37S = parcelRequire("5O37S");

var $el1MG = parcelRequire("el1MG");

var $19nmp = parcelRequire("19nmp");

var $8ilna = parcelRequire("8ilna");

var $7xssH = parcelRequire("7xssH");

var $kbv8x = parcelRequire("kbv8x");

var $5TXKo = parcelRequire("5TXKo");
function $323ca68ef5d54cb2$export$a95296ded9241771({ url: url, appearance: appearance, origin: origin, actionOptions: actionOptions, prefetch: prefetch }) {
    const id = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))(), []);
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const invokeClientAction = (0, $7xssH.default)({
        fireEvent: fireEvent
    });
    const resolve = (0, $kbv8x.default)();
    if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && prefetch && !linkState.details) resolve(url);
    if (linkState.details && !actionOptions?.hide) {
        const actions = [];
        const invokeParam = {
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: linkState.details
        };
        const downloadActionProps = (0, $ccFJO.extractInvokeDownloadAction)(invokeParam);
        if (downloadActionProps) actions.push((0, $8ilna.toAction)(downloadActionProps, invokeClientAction, (0, $19nmp.messages).download, 'download-content'));
        const viewActionProps = (0, $el1MG.extractInvokeViewAction)(invokeParam);
        if (viewActionProps) actions.push((0, $8ilna.toAction)(viewActionProps, invokeClientAction, (0, $19nmp.messages).view, 'view-content'));
        const previewActionProps = (0, $5O37S.extractInvokePreviewAction)({
            ...invokeParam,
            fireEvent: fireEvent,
            origin: origin,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        });
        if (previewActionProps) actions.push((0, $8ilna.toAction)(previewActionProps.invokeAction, invokeClientAction, (0, $19nmp.messages).preview_improved, 'preview-content'));
        return actions;
    }
    return [];
}

});
parcelRegister("ccFJO", function(module, exports) {
$parcel$export(module.exports, "extractInvokeDownloadAction", () => $0aeada01337c8e80$export$ea97cd34c2ca86de);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");
const $0aeada01337c8e80$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $hy9OT.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $FoFt2.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5NtHI.ActionName).DownloadAction,
            definitionId: (0, $03JM4.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $03JM4.getExtensionKey)(response),
            id: id,
            resourceType: (0, $03JM4.getResourceType)(response)
        };
    }
};

});
parcelRegister("18DG7", function(module, exports) {
$parcel$export(module.exports, "CardAction", () => $ff948bb743384c72$export$f40b7e0b762b928b);
var $ff948bb743384c72$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("2fsAU", function(module, exports) {
$parcel$export(module.exports, "canShowAction", () => $2264131ee11f6725$export$2487b058456cca75);
const $2264131ee11f6725$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});

parcelRegister("blyJR", function(module, exports) {
$parcel$export(module.exports, "getActionsFromJsonLd", () => $a3fe6b36e98c43c2$export$8f031784a3a03b23);
const $a3fe6b36e98c43c2$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});


parcelRegister("5O37S", function(module, exports) {
$parcel$export(module.exports, "extractInvokePreviewAction", () => $5a058ee1f9e9b538$export$caf83f49e52ac0bb);

var $6OR2o = parcelRequire("6OR2o");
var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $6SOgA = parcelRequire("6SOgA");

var $aNEbu = parcelRequire("aNEbu");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");

var $8z78z = parcelRequire("8z78z");

var $ccFJO = parcelRequire("ccFJO");

var $el1MG = parcelRequire("el1MG");
const $5a058ee1f9e9b538$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $hy9OT.extractSmartLinkAri)(response);
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    const name = (0, $hy9OT.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $6SOgA.isModalWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).PreviewAction, actionOptions)) return;
    /* Analytics UI event for preview action created to support tracking of preview actions as the experiment rolls out */ const firePreviewActionUIEvent = ({ previewType: previewType })=>{
        if (!(0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') || origin !== 'smartLinkPreviewHoverCard' || !fireEvent) return;
        fireEvent('ui.smartLink.clicked.previewHoverCard', {
            id: id || '',
            display: 'hoverCardPreview',
            previewType: previewType
        });
    };
    const src = (0, $6OR2o.extractPreview)(data, 'web')?.src;
    if (src) {
        const extensionKey = (0, $03JM4.getExtensionKey)(response);
        return {
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        let resolvedUrl = url;
                        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined
                        });
                        (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'panel'
                        });
                    } else {
                        await (0, $aNEbu.openEmbedModal)({
                            fireEvent: fireEvent,
                            extensionKey: extensionKey,
                            id: id,
                            invokeDownloadAction: (0, $ccFJO.extractInvokeDownloadAction)(param),
                            invokeViewAction: (0, $el1MG.extractInvokeViewAction)(param, true),
                            isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
                            isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
                            linkIcon: (0, $8z78z.extractLinkIcon)(response),
                            providerName: (0, $hy9OT.extractSmartLinkProvider)(response)?.text,
                            onClose: onClose,
                            origin: origin,
                            src: (0, $hy9OT.extractSmartLinkEmbed)(response)?.src,
                            title: (0, $hy9OT.extractSmartLinkTitle)(response),
                            url: url,
                            isBlanketHidden: (0, $eGOwo.fg)('linking_platform_hide_preview_action_blanket_prop') ? actionOptions?.previewAction?.hideBlanket : undefined,
                            size: (0, $eGOwo.fg)('platform_linking_enable_card_preview_action_size') ? actionOptions?.previewAction?.size : undefined,
                            ...(0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                                isInPreviewPanel: isInPreviewPanel
                            }
                        });
                        (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'modal'
                        });
                    }
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $5NtHI.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            },
            hasPreviewPanel: hasPreviewPanel
        };
    }
};

});
parcelRegister("6SOgA", function(module, exports) {
$parcel$export(module.exports, "isModalWithinPreviewPanelIFrame", () => $2428f63511c08cb4$export$11948954f57ec572);
$parcel$export(module.exports, "openEmbedModalInParent", () => $2428f63511c08cb4$export$bf3b8a5d11107cf4);
const $2428f63511c08cb4$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $2428f63511c08cb4$export$f274fcef361fe59d = ()=>{
    try {
        const params = new URLSearchParams(window.location.search);
        return params.has('previewPanels') || params.get('embeddedConfluenceSource') === 'confluence-page-preview-panel';
    } catch  {
        return false;
    }
};
const $2428f63511c08cb4$export$11948954f57ec572 = ()=>{
    return $2428f63511c08cb4$export$9f140ed41af5108c() && $2428f63511c08cb4$export$f274fcef361fe59d();
};
const $2428f63511c08cb4$export$bf3b8a5d11107cf4 = (modalProps)=>{
    if (!$2428f63511c08cb4$export$9f140ed41af5108c()) return;
    window.parent.postMessage({
        type: 'OPEN_EMBED_MODAL',
        payload: {
            modal: {
                url: modalProps?.url || ''
            }
        }
    }, '*');
};

});

parcelRegister("aNEbu", function(module, exports) {
$parcel$export(module.exports, "openEmbedModal", () => $2e72cab05fd02eba$export$7859f96cd8cff034);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");

var $cbSL1 = parcelRequire("cbSL1");

var $6SOgA = parcelRequire("6SOgA");
const $2e72cab05fd02eba$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $2e72cab05fd02eba$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    // If the modal trigger is in an iframe and the user has preview panels enabled, send a message to open modal to the parent product
    if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel_modal', 'cohort', 'test')) {
        if (props.isInPreviewPanel) {
            (0, $6SOgA.openEmbedModalInParent)({
                onClose: onClose,
                ...props
            });
            return;
        }
    }
    let popupMountPoint;
    popupMountPoint = document.getElementById($2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("3nRTS"));
    (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).render(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Modal.default, {
            ...props,
            iframeName: $2e72cab05fd02eba$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("3nRTS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("16B8C")
]).then(()=>parcelRequire('lJ0K6'));

});


parcelRegister("b5GVx", function(module, exports) {
$parcel$export(module.exports, "extractIsSupportTheming", () => $d6879f4d400478b0$export$38d755f52cdf4acb);

var $3DgO9 = parcelRequire("3DgO9");
const $d6879f4d400478b0$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $3DgO9.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("3DgO9", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $a195a16b307c9ed2$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $a195a16b307c9ed2$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $a195a16b307c9ed2$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $a195a16b307c9ed2$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $a195a16b307c9ed2$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $a195a16b307c9ed2$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $a195a16b307c9ed2$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $a195a16b307c9ed2$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $a195a16b307c9ed2$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $a195a16b307c9ed2$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $a195a16b307c9ed2$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $a195a16b307c9ed2$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $a195a16b307c9ed2$export$fe44ce30fd8d131b);
const $a195a16b307c9ed2$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $a195a16b307c9ed2$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $a195a16b307c9ed2$export$84a73a0383f58180 = 'JiraTask';
const $a195a16b307c9ed2$export$c6c83963a9378a67 = 'JiraSubTask';
const $a195a16b307c9ed2$export$58af3c426c111a6d = 'JiraStory';
const $a195a16b307c9ed2$export$ac9898a63417219e = 'JiraBug';
const $a195a16b307c9ed2$export$54db5e3fb12e39cd = 'JiraEpic';
const $a195a16b307c9ed2$export$2f54a5a217202c85 = 'JiraIncident';
const $a195a16b307c9ed2$export$d097371052bfc411 = 'JiraServiceRequest';
const $a195a16b307c9ed2$export$efd9452ad16c6676 = 'JiraChange';
const $a195a16b307c9ed2$export$2e7e70abb5d81f67 = 'JiraProblem';
const $a195a16b307c9ed2$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $a195a16b307c9ed2$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider'
];

});


parcelRegister("1jpb6", function(module, exports) {
$parcel$export(module.exports, "extractIsTrusted", () => $ec58a694a8b15740$export$4f3ffbb500daac5a);
const $ec58a694a8b15740$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("8z78z", function(module, exports) {
$parcel$export(module.exports, "extractLinkIcon", () => $908dbe215fe49acc$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $908dbe215fe49acc$export$bdd29be9b0395931);
$parcel$export(module.exports, "extractSmartLinkIcon", () => $908dbe215fe49acc$export$35040aed9264b11c);

var $3jSKi = parcelRequire("3jSKi");

var $5NtHI = parcelRequire("5NtHI");

var $1zbM5 = parcelRequire("1zbM5");

var $lBR2D = parcelRequire("lBR2D");

var $kYbGg = parcelRequire("kYbGg");
const $908dbe215fe49acc$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $1zbM5.default)(data, renderers);
    return {
        ...(0, $lBR2D.default)(data),
        render: render
    };
};
const $908dbe215fe49acc$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $kYbGg.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5NtHI.IconType).Forbidden
            };
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5NtHI.IconType).Error
            };
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5NtHI.IconType).Default
            };
    }
};
const $908dbe215fe49acc$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityIcon)(response);
    return $908dbe215fe49acc$export$43612bed147eae48(response, renderers);
};

});
parcelRegister("1zbM5", function(module, exports) {
$parcel$export(module.exports, "default", () => $006269c1cd396984$export$2e2bcd8739ae039);
const $006269c1cd396984$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $006269c1cd396984$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $006269c1cd396984$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $006269c1cd396984$export$2e2bcd8739ae039 = $006269c1cd396984$var$extractIconRenderer;

});

parcelRegister("lBR2D", function(module, exports) {
$parcel$export(module.exports, "default", () => $294e9df0fd90b4dc$export$2e2bcd8739ae039);

var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");

var $l5kRv = parcelRequire("l5kRv");

var $3DgO9 = parcelRequire("3DgO9");

var $3LiRd = parcelRequire("3LiRd");

var $dyU3L = parcelRequire("dyU3L");

var $imtUu = parcelRequire("imtUu");

var $kYbGg = parcelRequire("kYbGg");

var $6LWK3 = parcelRequire("6LWK3");
const $294e9df0fd90b4dc$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $l5kRv.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $294e9df0fd90b4dc$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0] : type;
};
const $294e9df0fd90b4dc$var$isJiraProvider = (provider)=>provider === (0, $3DgO9.JIRA_GENERATOR_ID);
function $294e9df0fd90b4dc$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $dyU3L.default)(fileFormat);
    const documentTypeIcon = $294e9df0fd90b4dc$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $3LiRd.default)(type, label, providerId);
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $294e9df0fd90b4dc$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $5NtHI.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $5NtHI.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $5NtHI.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $5NtHI.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $5NtHI.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $5NtHI.IconType).Task,
                label: taskLabel
            };
            if ($294e9df0fd90b4dc$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $294e9df0fd90b4dc$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $imtUu.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $294e9df0fd90b4dc$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $8T839.extractTitle)(data);
    const type = $294e9df0fd90b4dc$var$extractType(data);
    const urlIcon = (0, $6LWK3.default)(data.icon, label);
    const providerIcon = (0, $kYbGg.default)(data);
    return $294e9df0fd90b4dc$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $294e9df0fd90b4dc$export$2e2bcd8739ae039 = $294e9df0fd90b4dc$var$extractJsonldDataIcon;

});
parcelRegister("abbo9", function(module, exports) {
$parcel$export(module.exports, "prioritiseIcon", () => $2e5b1fff8f67610f$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $2e5b1fff8f67610f$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("aDkpj", function(module, exports) {
$parcel$export(module.exports, "extractorPriorityMap", () => $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4);
const $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("l5kRv", function(module, exports) {
$parcel$export(module.exports, "extractTaskType", () => $30b3c63f6ca4244d$export$ed3fd59180514d27);

var $4moW4 = parcelRequire("4moW4");
const $30b3c63f6ca4244d$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $4moW4.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("3LiRd", function(module, exports) {
$parcel$export(module.exports, "default", () => $75b1006362800173$export$2e2bcd8739ae039);

var $9Thyx = parcelRequire("9Thyx");

var $5NtHI = parcelRequire("5NtHI");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $75b1006362800173$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $5NtHI.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $9Thyx.isConfluenceGenerator)(providerId)) return {
                icon: (0, $5NtHI.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else return {
                icon: (0, $5NtHI.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $5NtHI.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $75b1006362800173$export$2e2bcd8739ae039 = $75b1006362800173$var$extractDocumentTypeIcon;

});

parcelRegister("imtUu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebe1a8cda0f126bd$export$2e2bcd8739ae039);

var $5NtHI = parcelRequire("5NtHI");
const $ebe1a8cda0f126bd$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $5NtHI.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $5NtHI.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $5NtHI.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $5NtHI.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $5NtHI.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $5NtHI.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $5NtHI.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $5NtHI.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label
            };
    }
};
var $ebe1a8cda0f126bd$export$2e2bcd8739ae039 = $ebe1a8cda0f126bd$var$extractJiraTaskIcon;

});

parcelRegister("kYbGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bccbab21d09288f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkProviderIcon", () => $1bccbab21d09288f$export$5def189f04eea025);

var $3jSKi = parcelRequire("3jSKi");
var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $3DgO9 = parcelRequire("3DgO9");

var $6LWK3 = parcelRequire("6LWK3");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $1bccbab21d09288f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $8T839.extractTitle)(data);
    if (provider === (0, $3DgO9.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $3DgO9.JIRA_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $6LWK3.default)(icon, label);
};
var $1bccbab21d09288f$export$2e2bcd8739ae039 = $1bccbab21d09288f$var$extractProviderIcon;
const $1bccbab21d09288f$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $3DgO9.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $3DgO9.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $3jSKi.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $1bccbab21d09288f$var$extractProviderIcon(response.data);
};

});
parcelRegister("6LWK3", function(module, exports) {
$parcel$export(module.exports, "default", () => $500a210ebb43c155$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $500a210ebb43c155$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $4moW4.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $500a210ebb43c155$export$2e2bcd8739ae039 = $500a210ebb43c155$var$extractUrlIcon;

});




parcelRegister("el1MG", function(module, exports) {
$parcel$export(module.exports, "extractInvokeViewAction", () => $8933c20370529de6$export$88c5813cfbbe4e4c);

var $3seWH = parcelRequire("3seWH");

var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");
const $8933c20370529de6$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $3seWH.extractLink)(data);
    const viewActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $FoFt2.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});


parcelRegister("8ilna", function(module, exports) {
$parcel$export(module.exports, "toAction", () => $7564a7d3bd8b0f5e$export$9d52be0dab870c7);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
const $7564a7d3bd8b0f5e$export$9d52be0dab870c7 = (action, invokeClientAction, message, id)=>{
    return {
        id: id,
        text: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...message
        }),
        invoke: ()=>invokeClientAction(action)
    };
};

});


parcelRegister("8YHJ2", function(module, exports) {
$parcel$export(module.exports, "CardSSR", () => $265c0be3b7df6739$export$7b5e1b7f9a325b6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $aXKmr = parcelRequire("aXKmr");

var $e2B2h = parcelRequire("e2B2h");

var $eGOwo = parcelRequire("eGOwo");

var $b43DQ = parcelRequire("b43DQ");

var $4oATR = parcelRequire("4oATR");

var $k9P6L = parcelRequire("k9P6L");
const $265c0be3b7df6739$export$7b5e1b7f9a325b6 = (props)=>{
    const [id] = (0, $eJOHy.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
    const cardProps = {
        ...props,
        id: id
    };
    const ErrorFallbackComponent = cardProps.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorFallbackComponent, {});
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
            ...cardProps
        });
    };
    if ((0, $eGOwo.fg)('platform_editor_inline_card_selected_state_fix')) {
        const Component = cardProps.appearance === 'inline' ? 'span' : 'div';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: (0, $b43DQ.context),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                FallbackComponent: errorBoundaryFallbackComponent,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    className: "loader-wrapper",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                        ...cardProps
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: (0, $b43DQ.context),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            FallbackComponent: errorBoundaryFallbackComponent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                ...cardProps
            })
        })
    });
};

});
parcelRegister("4oATR", function(module, exports) {
$parcel$export(module.exports, "CardWithUrlContent", () => $e563c8affb3daadf$export$7598f5d7c597dd32);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $iT7eO = parcelRequire("iT7eO");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $fezTc = parcelRequire("fezTc");

var $FoFt2 = parcelRequire("FoFt2");

var $88ISi = parcelRequire("88ISi");

var $liquj = parcelRequire("liquj");

var $44bDi = parcelRequire("44bDi");

var $1YI3f = parcelRequire("1YI3f");

var $2QXr6 = parcelRequire("2QXr6");

var $3u14o = parcelRequire("3u14o");

var $9uyEx = parcelRequire("9uyEx");

var $19G04 = parcelRequire("19G04");

var $6J1DL = parcelRequire("6J1DL");

var $ettNQ = parcelRequire("ettNQ");
const $e563c8affb3daadf$var$thirdPartyARIPrefix = 'ari:third-party';
function $e563c8affb3daadf$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, disablePreviewPanel: disablePreviewPanel }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $iT7eO.useSmartLink)(id, url);
    const ari = (0, $03JM4.getObjectAri)(state.details);
    const name = (0, $03JM4.getObjectName)(state.details);
    const definitionId = (0, $03JM4.getDefinitionId)(state.details);
    const extensionKey = (0, $03JM4.getExtensionKey)(state.details);
    const resourceType = (0, $03JM4.getResourceType)(state.details);
    const services = (0, $03JM4.getServices)(state.details);
    const thirdPartyARI = (0, $03JM4.getThirdPartyARI)(state.details);
    const firstPartyIdentifier = (0, $03JM4.getFirstPartyIdentifier)();
    let isFlexibleUi = (0, $eJOHy.useMemo)(()=>(0, $1YI3f.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    const actionOptions = (0, $88ISi.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    const fire3PClickEvent = (0, $eGOwo.fg)('platform_smartlink_3pclick_analytics') ? (0, $ettNQ.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    // Setup UI handlers.
    const handleClickWrapper = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialKey)(event) || (0, $FoFt2.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $5NtHI.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if ((0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) {
            if (thirdPartyARI && thirdPartyARI.startsWith($e563c8affb3daadf$var$thirdPartyARIPrefix)) {
                const clickURL = (0, $03JM4.getClickUrl)(url, state.details);
                if (clickURL === url && fire3PClickEvent) // For questions or concerns about this event,
                // please reach out to the 3P Workflows Team via Slack in #help-3p-connector-workflow
                fire3PClickEvent();
            }
        }
        const isDisablePreviewPanel = disablePreviewPanel && (0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        });
        // If preview panel is available and the user clicked on the link,
        // delegate the click to the preview panel handler
        if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
            ari: ari
        }) && !isDisablePreviewPanel) {
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $03JM4.getObjectIconUrl)(state.details)
            });
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
            return;
        } else if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $03JM4.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isSpecialEvent` be true.
            const target = (0, $FoFt2.isSpecialEvent)(event) ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        onClick,
        url,
        state.details,
        ari,
        name,
        fire3PClickEvent,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent,
        thirdPartyARI,
        disablePreviewPanel
    ]);
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $eJOHy.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $eJOHy.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $eJOHy.useEffect)(()=>{
        $2QXr6.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $2QXr6.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $2QXr6.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $03JM4.isFinalState)(state.status)) {
            (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $eJOHy.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $19G04.default), {
            id: id,
            cardState: cardState,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6J1DL.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'block':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3u14o.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9uyEx.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
    }
}
const $e563c8affb3daadf$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $1YI3f.isFlexibleUiCard)(props.children, props?.ui) ? (0, $5NtHI.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: props.url,
            id: props.id,
            display: display,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($e563c8affb3daadf$var$Component, {
                ...props
            })
        })
    });
};

});
parcelRegister("92xoS", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $19fb77b8a89e4410$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $19fb77b8a89e4410$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $59rsN = parcelRequire("59rsN");

var $4iJGP = parcelRequire("4iJGP");

var $dpRNR = parcelRequire("dpRNR");

var $bfW07 = parcelRequire("bfW07");
function $19fb77b8a89e4410$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $dpRNR.editorExperimentsConfig)[experimentName];
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $bfW07._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $bfW07._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $dpRNR.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $59rsN.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $4iJGP.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, experimentValue);
    return expectedExperimentValue === experimentValue;
}
function $19fb77b8a89e4410$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $bfW07._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});

parcelRegister("iT7eO", function(module, exports) {
$parcel$export(module.exports, "useSmartLink", () => $509c107b2b076848$export$9f4e486b1dc3e700);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $bde0S = parcelRequire("bde0S");

var $2vJUc = parcelRequire("2vJUc");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");
function $509c107b2b076848$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $5TXKo.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const actions = (0, $bde0S.useSmartCardActions)(id, url);
    const config = (0, $2vJUc.useSmartLinkConfig)();
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $eJOHy.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
}

});
parcelRegister("2vJUc", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkConfig", () => $42e17606dc58a0f1$export$5d10838c1e539409);

var $9kfy2 = parcelRequire("9kfy2");
const $42e17606dc58a0f1$export$5d10838c1e539409 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});


parcelRegister("88ISi", function(module, exports) {
$parcel$export(module.exports, "combineActionOptions", () => $8dae431f81ca4538$export$2ae4cf79c720146a);
const $8dae431f81ca4538$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("3u14o", function(module, exports) {
$parcel$export(module.exports, "BlockCard", () => $5cab8467edf2e496$export$d18ccd25c0d2c6b0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $9gzoR = parcelRequire("9gzoR");

var $4UV7R = parcelRequire("4UV7R");

var $dDP8i = parcelRequire("dDP8i");

var $kj3Kk = parcelRequire("kj3Kk");

var $fQuyl = parcelRequire("fQuyl");

var $1uPx2 = parcelRequire("1uPx2");

var $eB1dU = parcelRequire("eB1dU");

var $8jMdw = parcelRequire("8jMdw");

var $4fOPS = parcelRequire("4fOPS");
const $5cab8467edf2e496$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-block-card"
            }),
            children
        ]
    }) : children;
};
const $5cab8467edf2e496$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $dDP8i.handleClickCommon)(event, handleFrameClick),
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($5cab8467edf2e496$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    ...blockCardProps,
                    testId: "smart-block-resolving-view"
                })
            });
        case 'resolved':
            if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                ...blockCardProps
            });
        case 'unauthorized':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1uPx2.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eB1dU.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fQuyl.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("9gzoR", function(module, exports) {
$parcel$export(module.exports, "useControlDataExportConfig", () => $99508fe9399992b6$export$f93c47f1b2b3f55b);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $99508fe9399992b6$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("4UV7R", function(module, exports) {
$parcel$export(module.exports, "getIsDataExportEnabled", () => $12a2b77c03a84659$export$a019611f39785186);
const $12a2b77c03a84659$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));

});

parcelRegister("dDP8i", function(module, exports) {
$parcel$export(module.exports, "handleClickCommon", () => $b32501177a2ef5a6$export$9759a67e215c4598);
const $b32501177a2ef5a6$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("fQuyl", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee7e07d7b1d98a1b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jkYbX = parcelRequire("jkYbX");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dX77y = parcelRequire("dX77y");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $ee7e07d7b1d98a1b$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $eJOHy.useMemo)(()=>props.onAuthorize ? [
            (0, $dX77y.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
                label: "errored-warning-icon",
                color: "var(--ds-icon-warning, #E56910)",
                LEGACY_size: "small",
                testId: `${testId}-warning-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $19nmp.messages).could_not_load_link
                }
            })
        ]
    });
};
var $ee7e07d7b1d98a1b$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($ee7e07d7b1d98a1b$var$ErroredView);

});
parcelRegister("dX77y", function(module, exports) {
$parcel$export(module.exports, "RetryAction", () => $bcb724787f99bc8f$export$c527d977b53f7537);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $bcb724787f99bc8f$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).try_again
        }),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("dXXLc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ae672cf08406695$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $3pcXQ = parcelRequire("3pcXQ");
var $8Rjtc = parcelRequire("8Rjtc");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");
const $2ae672cf08406695$var$customBlockStyles = null;
const $2ae672cf08406695$var$titleBlockCss = null;
const $2ae672cf08406695$var$footerBlockCss = null;
const $2ae672cf08406695$var$footerBlockSafariStyles = null;
const $2ae672cf08406695$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $g7toL.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                hideIcon: !!title,
                text: title,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc01fxt"
                ]),
                children: children
            }),
            showPreview && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
                actions: actions,
                testId: "smart-block-card-footer",
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $2ae672cf08406695$export$2e2bcd8739ae039 = $2ae672cf08406695$var$UnresolvedView;

});
parcelRegister("19G04", function(module, exports) {
$parcel$export(module.exports, "default", () => $b72b0d53d138fc6a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $k2hJv = parcelRequire("k2hJv");

var $kbv8x = parcelRequire("kbv8x");

var $dpCTw = parcelRequire("dpCTw");

var $025st = parcelRequire("025st");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $b72b0d53d138fc6a$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $k2hJv.useAISummaryConfig)();
    const resolve = (0, $kbv8x.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $eJOHy.useMemo)(()=>(0, $025st.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        aiSummaryConfig,
        appearance,
        fireEvent,
        details,
        id,
        onAuthorize,
        onClick,
        origin,
        renderers,
        resolve,
        actionOptions,
        status,
        url,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    const flexibleCardContext = (0, $eJOHy.useMemo)(()=>({
            data: context,
            status: status,
            ui: ui
        }), [
        context,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5FRJ8.FlexibleCardContext).Provider, {
        value: flexibleCardContext,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dpCTw.default), {
            testId: testId,
            ...ui,
            onClick: onClick,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            status: status,
            retry: retry,
            children: children
        })
    });
};
var $b72b0d53d138fc6a$export$2e2bcd8739ae039 = $b72b0d53d138fc6a$var$FlexibleCard;

});
parcelRegister("dpCTw", function(module, exports) {
$parcel$export(module.exports, "default", () => $2113f7140aee1e4f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hq0iR = parcelRequire("hq0iR");

var $1YI3f = parcelRequire("1YI3f");

var $fqBfo = parcelRequire("fqBfo");

var $hjkWh = parcelRequire("hjkWh");

var $59hpa = parcelRequire("59hpa");
const $2113f7140aee1e4f$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $hq0iR.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
            if ((0, $1YI3f.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $5NtHI.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $5NtHI.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $2113f7140aee1e4f$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) && (0, $1YI3f.isFlexibleUiBlock)(child) ? child : undefined);
};
const $2113f7140aee1e4f$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return undefined;
    if (node.type === (0, $fqBfo.default)) return node;
    if ((0, $1YI3f.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $2113f7140aee1e4f$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $2113f7140aee1e4f$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).map((child)=>$2113f7140aee1e4f$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(block)) return block.props;
};
const $2113f7140aee1e4f$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $2113f7140aee1e4f$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59hpa.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || linkTitle?.text,
        url: url
    });
};
const $2113f7140aee1e4f$var$baseStyleCommon = null;
const $2113f7140aee1e4f$var$backgroundStyles = null;
const $2113f7140aee1e4f$var$elevationStyles = null;
const $2113f7140aee1e4f$var$clickableContainerStyles = null;
const $2113f7140aee1e4f$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $2113f7140aee1e4f$var$getPadding = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $2113f7140aee1e4f$var$getGap = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $2113f7140aee1e4f$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $2113f7140aee1e4f$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $2113f7140aee1e4f$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $5NtHI.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container' })=>{
    (0, $gRw8I.di)((0, $hjkWh.default));
    const padding = hidePadding ? '0px' : $2113f7140aee1e4f$var$getPadding(size);
    const gap = $2113f7140aee1e4f$var$getGap(size);
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $2113f7140aee1e4f$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $2113f7140aee1e4f$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $2113f7140aee1e4f$var$previewOnLeftStyleMap[size],
            previewOnRight && $2113f7140aee1e4f$var$previewOnRightStyleMap[size],
            !hideElevation && "_19it7r9e _2rkopb1k _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $awdRS.default)(padding),
            "--_73mooq": (0, $awdRS.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $awdRS.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $2113f7140aee1e4f$var$getLayeredLink(testId, context, children, onClick) : null,
            $2113f7140aee1e4f$var$filterChildren(children, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hjkWh.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $2113f7140aee1e4f$export$2e2bcd8739ae039 = $2113f7140aee1e4f$var$Container;

});
parcelRegister("hq0iR", function(module, exports) {
$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $0488d9459cc3a179$export$783c1bf8fee63f80);
const $0488d9459cc3a179$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("hjkWh", function(module, exports) {
$parcel$export(module.exports, "default", () => $68910ca9bc088568$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $3S6ja = parcelRequire("3S6ja");
const $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $68910ca9bc088568$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $eJOHy.useState)(true);
    const mouseStopTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $eJOHy.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $5NtHI.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            role: 'presentation',
            children: children
        })
    });
};
var $68910ca9bc088568$export$2e2bcd8739ae039 = $68910ca9bc088568$var$HoverCardControl;

});
parcelRegister("3S6ja", function(module, exports) {
$parcel$export(module.exports, "HoverCard", () => $4672c7a0b9a7b840$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $4J0ad = parcelRequire("4J0ad");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $fezTc = parcelRequire("fezTc");

var $44bDi = parcelRequire("44bDi");

var $ct5r8 = parcelRequire("ct5r8");
const $4672c7a0b9a7b840$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $gRw8I.di)((0, $ct5r8.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $44bDi.useSmartLinkAnalyticsContext)({
        display: (0, $5NtHI.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $ct5r8.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $eJOHy.useCallback)((error, info)=>{
        (0, $1mLfK.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ct5r8.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext = (0, $4J0ad.default)()($4672c7a0b9a7b840$var$HoverCardWithErrorBoundary);
const $4672c7a0b9a7b840$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("ct5r8", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $bcd82f075ee4a70e$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $bcd82f075ee4a70e$export$e2173dafa6a751bb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kJsb4 = parcelRequire("kJsb4");

var $92xoS = parcelRequire("92xoS");

var $5NtHI = parcelRequire("5NtHI");

var $bde0S = parcelRequire("bde0S");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");

var $44bDi = parcelRequire("44bDi");

var $dNwAf = parcelRequire("dNwAf");

var $awu5s = parcelRequire("awu5s");

var $kj7DC = parcelRequire("kj7DC");
const $bcd82f075ee4a70e$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $bcd82f075ee4a70e$var$FADE_IN_DELAY = 500;
const $bcd82f075ee4a70e$var$FADE_OUT_DELAY = 300;
const $bcd82f075ee4a70e$var$RESOLVE_DELAY = 100;
const $bcd82f075ee4a70e$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $kj7DC.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, label: label, titleId: titleId })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $bcd82f075ee4a70e$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const fadeOutTimeoutId = (0, $eJOHy.useRef)();
    const fadeInTimeoutId = (0, $eJOHy.useRef)();
    const resolveTimeOutId = (0, $eJOHy.useRef)();
    const mousePos = (0, $eJOHy.useRef)();
    const popupOffset = (0, $eJOHy.useRef)();
    const parentSpan = (0, $eJOHy.useRef)(null);
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const { loadMetadata: loadMetadata } = (0, $bde0S.useSmartCardActions)(id, url);
    const setMousePosition = (0, $eJOHy.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $kj7DC.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $kj7DC.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $eJOHy.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $bcd82f075ee4a70e$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $eJOHy.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $bcd82f075ee4a70e$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $eJOHy.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay
    ]);
    const onActionClick = (0, $eJOHy.useCallback)((actionId)=>{
        if (actionId === (0, $5NtHI.ActionName).PreviewAction || actionId === (0, $5NtHI.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eJOHy.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id,
            source: $bcd82f075ee4a70e$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $awu5s.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $eJOHy.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER,
                ...(0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true) ? {
                    className: $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $dNwAf.default)
    });
};

});
parcelRegister("dNwAf", function(module, exports) {
$parcel$export(module.exports, "default", () => $540bc4e78d228f2e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $540bc4e78d228f2e$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
var $540bc4e78d228f2e$export$2e2bcd8739ae039 = $540bc4e78d228f2e$var$CustomPopupContainer;

});

parcelRegister("awu5s", function(module, exports) {
$parcel$export(module.exports, "hoverCardClassName", () => $28757f6aaca5ab4f$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $28757f6aaca5ab4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $9kfy2 = parcelRequire("9kfy2");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $03JM4 = parcelRequire("03JM4");

var $5TXKo = parcelRequire("5TXKo");

var $FoFt2 = parcelRequire("FoFt2");

var $7tQSx = parcelRequire("7tQSx");

var $liquj = parcelRequire("liquj");

var $kj7DC = parcelRequire("kj7DC");

var $gpl3i = parcelRequire("gpl3i");

var $2bxQs = parcelRequire("2bxQs");

var $8Oxy9 = parcelRequire("8Oxy9");

var $hG20o = parcelRequire("hG20o");

var $1klMO = parcelRequire("1klMO");

var $jwqmr = parcelRequire("jwqmr");
const $28757f6aaca5ab4f$export$34883cbaea18402d = 'smart-links-hover-preview';
const $28757f6aaca5ab4f$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const extensionKey = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $7tQSx.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $03JM4.getServices)(linkState.details);
    const statusRef = (0, $eJOHy.useRef)(linkStatus);
    const fireEventRef = (0, $eJOHy.useRef)(fireEvent);
    const definitionIdRef = (0, $eJOHy.useRef)(definitionId);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $gpl3i.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $5NtHI.SmartLinkSize).Large,
        position: (0, $5NtHI.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const uiOptions = (0, $kj7DC.flexibleUiOptions);
    if ((0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $5NtHI.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $eJOHy.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1klMO.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jwqmr.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Oxy9.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hG20o.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bxQs.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $28757f6aaca5ab4f$export$2e2bcd8739ae039 = $28757f6aaca5ab4f$var$HoverCardContent;

});
parcelRegister("kj7DC", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $0426ea3ec103c831$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $0426ea3ec103c831$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $0426ea3ec103c831$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $0426ea3ec103c831$export$e7cae8c75d768024);

var $IW7jS = parcelRequire("IW7jS");

var $5NtHI = parcelRequire("5NtHI");
const $0426ea3ec103c831$export$8245b0eaabf3440c = (0, $IW7jS.layers).modal();
const $0426ea3ec103c831$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $5NtHI.SmartLinkSize).Medium,
    zIndex: $0426ea3ec103c831$export$8245b0eaabf3440c + 1
};
const $0426ea3ec103c831$export$a0a37c997fbcd678 = 24;
const $0426ea3ec103c831$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("gpl3i", function(module, exports) {
$parcel$export(module.exports, "getMetadata", () => $76d8fd2bfb093db5$export$8548546c0aa631e6);

var $dpM2S = parcelRequire("dpM2S");

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");
const $76d8fd2bfb093db5$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $dpM2S.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $5NtHI.ElementName).AuthorGroup,
            (0, $5NtHI.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).SubscriberCount,
                    (0, $5NtHI.ElementName).State
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).SourceBranch,
                    (0, $5NtHI.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $5NtHI.ElementName).LatestCommit,
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $1UXt3.extractOwnedBy)(data) ? (0, $5NtHI.ElementName).OwnedByGroup : (0, $5NtHI.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $5NtHI.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $5NtHI.ElementName).AssignedToGroup,
                        (0, $5NtHI.ElementName).State,
                        (0, $5NtHI.ElementName).StoryPoints,
                        (0, $5NtHI.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ],
                secondary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).AttachmentCount,
                    (0, $5NtHI.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).SentOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix = [
    (0, $5NtHI.ElementName).AssignedToGroup,
    (0, $5NtHI.ElementName).OwnedByGroup,
    (0, $5NtHI.ElementName).AuthorGroup
];
const $76d8fd2bfb093db5$var$toElementItem = (name)=>{
    const showNamePrefix = $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $76d8fd2bfb093db5$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $5NtHI.ElementName)).map($76d8fd2bfb093db5$var$toElementItem);
};
const $76d8fd2bfb093db5$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $76d8fd2bfb093db5$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $76d8fd2bfb093db5$var$toElementItems(metadata.subtitle),
        primary: $76d8fd2bfb093db5$var$toElementItems(primary),
        secondary: $76d8fd2bfb093db5$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("1UXt3", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkCommentCount", () => $72576417d80bd61c$export$fb0960a89fb9c17b);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $72576417d80bd61c$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $72576417d80bd61c$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $72576417d80bd61c$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractSmartLinkReactCount", () => $72576417d80bd61c$export$bb52c21c67a309ca);
$parcel$export(module.exports, "extractVoteCount", () => $72576417d80bd61c$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $72576417d80bd61c$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $72576417d80bd61c$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $72576417d80bd61c$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $72576417d80bd61c$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $72576417d80bd61c$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $72576417d80bd61c$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractTeamMemberCount", () => $72576417d80bd61c$export$9fc8706c6cb5343a);
$parcel$export(module.exports, "extractAttachmentCount", () => $72576417d80bd61c$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $72576417d80bd61c$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $72576417d80bd61c$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $72576417d80bd61c$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $72576417d80bd61c$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractUserAttributes", () => $72576417d80bd61c$export$6052f26bb463e370);
$parcel$export(module.exports, "extractReadTime", () => $72576417d80bd61c$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSmartLinkSentOn", () => $72576417d80bd61c$export$5c05c5b7ca37e36e);
$parcel$export(module.exports, "extractStoryPoints", () => $72576417d80bd61c$export$bdcea84d1550eb9d);
$parcel$export(module.exports, "extractMetaObjectId", () => $72576417d80bd61c$export$bec1443e3e33b166);
$parcel$export(module.exports, "extractMetaResourceType", () => $72576417d80bd61c$export$11d1314ebbee594e);
$parcel$export(module.exports, "extractMetaTenantId", () => $72576417d80bd61c$export$92037aea7f27bf7f);

var $3jSKi = parcelRequire("3jSKi");
var $fGP6b = parcelRequire("fGP6b");
var $aHgka = parcelRequire("aHgka");
var $3a3fF = parcelRequire("3a3fF");
var $hdxEk = parcelRequire("hdxEk");
const $72576417d80bd61c$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $72576417d80bd61c$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $72576417d80bd61c$export$b68822b76d5d51d5 = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:commentCount');
const $72576417d80bd61c$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
    }
    return response?.data && $72576417d80bd61c$export$b68822b76d5d51d5(response?.data);
};
const $72576417d80bd61c$export$4356c594f5c138d6 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $72576417d80bd61c$export$ac56bd7a37249b48 = (data)=>$72576417d80bd61c$var$extractValue(data, 'endTime');
const $72576417d80bd61c$export$e57334ce4738e29d = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:viewCount');
const $72576417d80bd61c$export$44130aa92252501 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:reactCount');
const $72576417d80bd61c$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
    }
    return response?.data && $72576417d80bd61c$export$44130aa92252501(response?.data);
};
const $72576417d80bd61c$export$c8bef3d5e550a3a = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:voteCount');
const $72576417d80bd61c$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $3a3fF.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$5546969a505305 = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $72576417d80bd61c$export$69b10d653f96288b = (data)=>{
    const persons = (0, $aHgka.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $hdxEk.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$43e54589935a1ff = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:programmingLanguage');
const $72576417d80bd61c$export$949ac6a8325b3fdb = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeSource']);
const $72576417d80bd61c$export$8bd03a7beb5badf1 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:subscriberCount');
const $72576417d80bd61c$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $72576417d80bd61c$export$65362ff78a97fd8 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:attachmentCount');
const $72576417d80bd61c$export$29b0ac5d2f9890cf = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeDestination']);
const $72576417d80bd61c$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $72576417d80bd61c$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $72576417d80bd61c$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $72576417d80bd61c$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $72576417d80bd61c$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $72576417d80bd61c$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $72576417d80bd61c$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $72576417d80bd61c$export$cc4028b2878d0675 = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $72576417d80bd61c$export$b592ddecae70b61d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'dateSent');
};
const $72576417d80bd61c$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdAt;
    return response?.data && $72576417d80bd61c$export$b592ddecae70b61d(response?.data);
};
const $72576417d80bd61c$export$bdcea84d1550eb9d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:storyPoints');
};
const $72576417d80bd61c$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $72576417d80bd61c$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $72576417d80bd61c$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});
parcelRegister("fGP6b", function(module, exports) {
$parcel$export(module.exports, "extractPersonAssignedTo", () => $5046cec7bbb70f2b$export$38a0979ebf273662);

var $9JeZK = parcelRequire("9JeZK");
const $5046cec7bbb70f2b$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9JeZK.extractPersonFromJsonLd)(assignedTo);
};

});

parcelRegister("3a3fF", function(module, exports) {
$parcel$export(module.exports, "extractPersonOwnedBy", () => $acd7880777d9e468$export$19ee667f3f7a6ec3);

var $9JeZK = parcelRequire("9JeZK");
const $acd7880777d9e468$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9JeZK.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9JeZK.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});



parcelRegister("2bxQs", function(module, exports) {
$parcel$export(module.exports, "default", () => $cef1c4bd3f25f5fc$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $gEJiH = parcelRequire("gEJiH");

var $awu5s = parcelRequire("awu5s");
const $cef1c4bd3f25f5fc$var$NEW_CARD_WIDTH_REM = 25;
const $cef1c4bd3f25f5fc$var$HoverCardContainerStyle = null;
const $cef1c4bd3f25f5fc$var$popupContainerStyles = null;
const $cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $gEJiH.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    const [showPrism, setShowPrism] = (0, $eJOHy.useState)(status === 'loading');
    (0, $eJOHy.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rko1mok _bfhk1bhr _16qs1e6u",
            (0, $awu5s.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gEJiH.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $cef1c4bd3f25f5fc$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)($cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $cef1c4bd3f25f5fc$export$2e2bcd8739ae039 = $cef1c4bd3f25f5fc$var$ContentContainer;

});
parcelRegister("gEJiH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ac4bb0b0e3771c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $58yRG = parcelRequire("58yRG");

var $ic0QK = parcelRequire("ic0QK");

var $aIqUw = parcelRequire("aIqUw");
const $6ac4bb0b0e3771c8$var$contentStyles = null;
const $6ac4bb0b0e3771c8$var$contentStylesPrismVisible = null;
const $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $6ac4bb0b0e3771c8$var$popupContainerStyles = null;
const $6ac4bb0b0e3771c8$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $58yRG.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ic0QK.default), {
        palette: (0, $aIqUw.AI_BORDER_PALETTE)[colorMode] ?? (0, $aIqUw.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $hcewu.default)([
            $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_2rko1mok _bfhk1bhr _16qs1e6u",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $6ac4bb0b0e3771c8$export$2e2bcd8739ae039 = $6ac4bb0b0e3771c8$var$AIPrism;

});
parcelRegister("ic0QK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c556e491b590659$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4gixb = parcelRequire("4gixb");
const $1c556e491b590659$var$borderContainerStyles = null;
const $1c556e491b590659$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $1c556e491b590659$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_2rkoftgi _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $1c556e491b590659$export$2e2bcd8739ae039 = $1c556e491b590659$var$AIGlowingBorder;

});
parcelRegister("4gixb", function(module, exports) {
$parcel$export(module.exports, "default", () => $915978962937a033$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
let $915978962937a033$var$namespaceUUID = 0;
const $915978962937a033$var$svgStyles = null;
const $915978962937a033$var$blurredStyles = null;
const $915978962937a033$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $915978962937a033$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $915978962937a033$var$namespaceUUID;
        $915978962937a033$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $915978962937a033$export$2e2bcd8739ae039 = $915978962937a033$var$AnimatedSvgContainer;

});


parcelRegister("aIqUw", function(module, exports) {
$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $668726bbe5390a04$export$23b7b83c7063ccfe);
const $668726bbe5390a04$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $668726bbe5390a04$export$23b7b83c7063ccfe = {
    dark: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue800,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal500,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue600,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal300,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("8Oxy9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ec0240a00cb7a69$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $ftN6c = parcelRequire("ftN6c");

var $5CSKW = parcelRequire("5CSKW");

var $hy9OT = parcelRequire("hy9OT");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $8Rjtc = parcelRequire("8Rjtc");
const $7ec0240a00cb7a69$var$titleBlockStyles = null;
const $7ec0240a00cb7a69$var$mainTextStyles = null;
const $7ec0240a00cb7a69$var$connectButtonStyles = null;
const $7ec0240a00cb7a69$var$basePreviewStyles = null;
const $7ec0240a00cb7a69$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
        children: (0, $4Qxcv.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $7r0tl.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ignoreContainerPadding: true,
                testId: testId,
                className: (0, $hcewu.default)([
                    "_13li1mok _qrwq1mok _otyru2gc"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $7ec0240a00cb7a69$export$2e2bcd8739ae039 = $7ec0240a00cb7a69$var$HoverCardForbiddenView;

});
parcelRegister("7r0tl", function(module, exports) {
$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $acbd55282a01ac89$export$846c1540a86749e6);

var $19nmp = parcelRequire("19nmp");

var $b43DQ = parcelRequire("b43DQ");

var $5OkN2 = parcelRequire("5OkN2");

var $4Qxcv = parcelRequire("4Qxcv");
const $acbd55282a01ac89$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $4Qxcv.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $19nmp.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $19nmp.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $5OkN2.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $19nmp.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $19nmp.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("5OkN2", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $1cf8e394dba29dd6$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");
const $1cf8e394dba29dd6$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $19nmp.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("4Qxcv", function(module, exports) {
$parcel$export(module.exports, "default", () => $37283c298b2f6d8f$export$2e2bcd8739ae039);
const $37283c298b2f6d8f$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $37283c298b2f6d8f$export$2e2bcd8739ae039 = $37283c298b2f6d8f$var$extractHostname;

});



parcelRegister("hG20o", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7d163d2cd5927fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $19G04 = parcelRequire("19G04");

var $4cjOx = parcelRequire("4cjOx");
var $eMgzj = parcelRequire("eMgzj");
var $2qnEp = parcelRequire("2qnEp");
var $gKsxm = parcelRequire("gKsxm");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $gpl3i = parcelRequire("gpl3i");

var $33eto = parcelRequire("33eto");
const $f7d163d2cd5927fd$var$hiddenSnippetStyles = null;
const $f7d163d2cd5927fd$var$titleBlockStyles = null;
const $f7d163d2cd5927fd$var$snippetBlockCss = null;
const $f7d163d2cd5927fd$var$actionBlockCss = null;
const $f7d163d2cd5927fd$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $eJOHy.useMemo)(()=>{
        return (0, $gpl3i.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(0);
    const snippetBlockRef = (0, $eJOHy.useRef)(null);
    const onSnippetRender = (0, $eJOHy.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $33eto.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
        className: (0, $hcewu.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...titleBlockProps,
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $5NtHI.SmartLinkSize).Medium
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qnEp.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet
            }) : snippet,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                isHidden: true,
                className: (0, $hcewu.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cjOx.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $hcewu.default)([
                    "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eMgzj.default), {})
        ]
    });
};
var $f7d163d2cd5927fd$export$2e2bcd8739ae039 = $f7d163d2cd5927fd$var$HoverCardResolvedView;

});
parcelRegister("33eto", function(module, exports) {
$parcel$export(module.exports, "default", () => $114e5090f71be87e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $71sLJ = parcelRequire("71sLJ");

var $8Rjtc = parcelRequire("8Rjtc");
const $114e5090f71be87e$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $eJOHy.useRef)(false);
    const previewBlockRef = (0, $eJOHy.useRef)(null);
    const [showPreview, setShowPreview] = (0, $eJOHy.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $eJOHy.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-radius-large, 8px)",
                borderTopRightRadius: "var(--ds-radius-large, 8px)",
                marginBottom: "var(--ds-space-100, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $eJOHy.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $eJOHy.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $71sLJ.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $114e5090f71be87e$export$2e2bcd8739ae039 = $114e5090f71be87e$var$ImagePreview;

});
parcelRegister("71sLJ", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $5db4479b590c898b$export$a79836076066b8b6);

var $3jSKi = parcelRequire("3jSKi");
var $GcYFq = parcelRequire("GcYFq");

var $5NtHI = parcelRequire("5NtHI");
const $5db4479b590c898b$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $GcYFq.extractImage)(data);
    return url ? {
        type: (0, $5NtHI.MediaType).Image,
        url: url
    } : undefined;
};
var $5db4479b590c898b$export$2e2bcd8739ae039 = $5db4479b590c898b$var$extractPreview;
const $5db4479b590c898b$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        return url ? {
            type: (0, $5NtHI.MediaType).Image,
            url: url
        } : undefined;
    }
    return $5db4479b590c898b$var$extractPreview(response.data);
};

});
parcelRegister("GcYFq", function(module, exports) {
$parcel$export(module.exports, "extractImage", () => $d2101dc0ce9c996b$export$4c753a1297cb9805);

var $jo2Je = parcelRequire("jo2Je");
const $d2101dc0ce9c996b$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});




parcelRegister("1klMO", function(module, exports) {
$parcel$export(module.exports, "default", () => $208dcc57b264b5f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $65mpR = parcelRequire("65mpR");

var $d6nZP = parcelRequire("d6nZP");

var $kj7DC = parcelRequire("kj7DC");
const $208dcc57b264b5f9$var$loadingViewContainer = null;
const $208dcc57b264b5f9$var$skeletonContainer = null;
const $208dcc57b264b5f9$var$titleStyle = null;
const $208dcc57b264b5f9$var$titleBlockStyles = null;
const $208dcc57b264b5f9$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $kj7DC.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1e9d _u5f31e9d _n3td1e9d _19bv1e9d"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $hcewu.default)([
                        "_zulpcxkx _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
                            render: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $hcewu.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                                height: `${lineHeightRem}rem`
                            })
                        }),
                        actionGroup
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                })
            ]
        })
    });
};
var $208dcc57b264b5f9$export$2e2bcd8739ae039 = $208dcc57b264b5f9$var$HoverCardLoadingView;

});

parcelRegister("jwqmr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a30e9762e9a1caf4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $bde0S = parcelRequire("bde0S");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $jPfaa = parcelRequire("jPfaa");
const $a30e9762e9a1caf4$var$connectButtonStyles = null;
const $a30e9762e9a1caf4$var$titleBlockStyles = null;
const $a30e9762e9a1caf4$var$mainTextStyles = null;
const $a30e9762e9a1caf4$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $bde0S.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5NtHI.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_link_account_card_name,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-button`,
                className: (0, $hcewu.default)([
                    "_1bahesu3 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $a30e9762e9a1caf4$export$2e2bcd8739ae039 = $a30e9762e9a1caf4$var$HoverCardUnauthorisedView;

});
parcelRegister("5z6NJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b17ec2d366022be$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $eGOwo = parcelRequire("eGOwo");

var $lc0OY = parcelRequire("lc0OY");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $4b17ec2d366022be$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).learn_more_about_connecting_account_appify : (0, $19nmp.messages).learn_more_about_connecting_account : (0, $19nmp.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).connect_unauthorised_account_description_appify : (0, $19nmp.messages).connect_unauthorised_account_description,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).connect_unauthorised_account_description_no_provider_appify : (0, $19nmp.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                href: isProductIntegrationSupported ? (0, $5NtHI.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5NtHI.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $4b17ec2d366022be$export$2e2bcd8739ae039 = $4b17ec2d366022be$var$UnauthorisedViewContent;

});






parcelRegister("59hpa", function(module, exports) {
$parcel$export(module.exports, "default", () => $059fbcc0253de40e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $e3qu2 = parcelRequire("e3qu2");
const $059fbcc0253de40e$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $059fbcc0253de40e$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1,
        "aria-hidden": (0, $eGOwo.fg)('navx-1706-smart-link-layered-link-a11y-update'),
        children: text
    });
};
var $059fbcc0253de40e$export$2e2bcd8739ae039 = $059fbcc0253de40e$var$LayeredLink;

});


parcelRegister("025st", function(module, exports) {
$parcel$export(module.exports, "getContextByStatus", () => $78d5204a1babb283$export$e68aec76e359e401);

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $4ho8r = parcelRequire("4ho8r");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $19nmp = parcelRequire("19nmp");

var $FoFt2 = parcelRequire("FoFt2");

var $gA511 = parcelRequire("gA511");
const $78d5204a1babb283$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                url: url
            };
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return (0, $4ho8r.default)(params);
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $8z78z.extractErrorIcon)(response, status),
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
                provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $5NtHI.InternalActionName).UnresolvedAction]: $78d5204a1babb283$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response?.meta?.requestAccess?.accessType
                }
            };
    }
};
const $78d5204a1babb283$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $78d5204a1babb283$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $hy9OT.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const access = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $78d5204a1babb283$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $19nmp.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $FoFt2.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $19nmp.messages).connect_link_account_card_name,
                onClick: (0, $FoFt2.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $19nmp.messages).cannot_find_link
            };
    }
};

});
parcelRegister("4ho8r", function(module, exports) {
$parcel$export(module.exports, "default", () => $4044cb6e4b021061$export$2e2bcd8739ae039);

var $3a3fF = parcelRequire("3a3fF");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $eGOwo = parcelRequire("eGOwo");

var $3SqDE = parcelRequire("3SqDE");

var $2YDTG = parcelRequire("2YDTG");

var $jIa7q = parcelRequire("jIa7q");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $2LW3F = parcelRequire("2LW3F");

var $96cCi = parcelRequire("96cCi");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $krByh = parcelRequire("krByh");

var $1UXt3 = parcelRequire("1UXt3");
const $4044cb6e4b021061$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    return {
        actions: (0, $2YDTG.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        appliedToComponentsCount: (0, $1UXt3.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $1UXt3.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $1UXt3.extractAttachmentCount)(data),
        authorGroup: (0, $hy9OT.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $3a3fF.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $jIa7q.extractPersonsUpdatedBy)(data),
        commentCount: (0, $1UXt3.extractSmartLinkCommentCount)(response),
        viewCount: (0, $1UXt3.extractViewCount)(data),
        reactCount: (0, $1UXt3.extractSmartLinkReactCount)(response),
        voteCount: (0, $1UXt3.extractVoteCount)(data),
        checklistProgress: (0, $1UXt3.extractChecklistProgress)(data),
        createdBy: (0, $hy9OT.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $1UXt3.extractOwnedBy)(data),
        assignedTo: (0, $1UXt3.extractAssignedTo)(data),
        createdOn: (0, $hy9OT.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $1UXt3.extractDueOn)(data),
        latestCommit: (0, $krByh.extractLatestCommit)(data),
        linkIcon: (0, $8z78z.extractSmartLinkIcon)(response),
        linkTitle: (0, $13x9L.default)(status, props.url, response, onClick),
        location: (0, $1UXt3.extractLocation)(data),
        modifiedBy: (0, $hy9OT.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $hy9OT.extractSmartLinkModifiedOn)(response),
        preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
        priority: (0, $2LW3F.default)(data),
        provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $1UXt3.extractProgrammingLanguage)(data),
        readTime: (0, $1UXt3.extractReadTime)(data),
        sentOn: (0, $1UXt3.extractSmartLinkSentOn)(response),
        snippet: (0, $3SqDE.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $1UXt3.extractSourceBranch)(data),
        state: (0, $96cCi.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel),
        subscriberCount: (0, $1UXt3.extractSubscriberCount)(data),
        subTasksProgress: (0, $1UXt3.extractSubTasksProgress)(data),
        storyPoints: (0, $1UXt3.extractStoryPoints)(data),
        targetBranch: (0, $1UXt3.extractTargetBranch)(data),
        ...(0, $eGOwo.fg)('platform-linking-user-attributes-component') && {
            userAttributes: (0, $1UXt3.extractUserAttributes)(data)
        },
        ...(0, $eGOwo.fg)('platform-linking-team-member-count-component') && {
            teamMemberCount: (0, $1UXt3.extractTeamMemberCount)(data)
        },
        url: url,
        ari: (0, $hy9OT.extractSmartLinkAri)(response),
        type: (0, $dpM2S.extractType)(data),
        ...(0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') && {
            meta: {
                objectId: (0, $1UXt3.extractMetaObjectId)(meta),
                resourceType: (0, $1UXt3.extractMetaResourceType)(meta),
                tenantId: (0, $1UXt3.extractMetaTenantId)(meta)
            }
        }
    };
};
var $4044cb6e4b021061$export$2e2bcd8739ae039 = $4044cb6e4b021061$var$extractFlexibleUiContext;

});
parcelRegister("3SqDE", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkSummary", () => $f7e45c18a3795a6b$export$8c6b9b49f358840);

var $3jSKi = parcelRequire("3jSKi");
const $f7e45c18a3795a6b$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $f7e45c18a3795a6b$export$8c6b9b49f358840 = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.description;
    return response?.data && $f7e45c18a3795a6b$export$db5a8500f6b6286e(response.data);
};

});

parcelRegister("2YDTG", function(module, exports) {
$parcel$export(module.exports, "extractFlexibleCardActions", () => $df0887593ff7101f$export$abe8d0ca1daa1755);

var $5NtHI = parcelRequire("5NtHI");

var $4DFm3 = parcelRequire("4DFm3");

var $glHkX = parcelRequire("glHkX");

var $71e7e = parcelRequire("71e7e");

var $9ZYEf = parcelRequire("9ZYEf");

var $7xgpC = parcelRequire("7xgpC");

var $l3lcT = parcelRequire("l3lcT");

var $iJBt4 = parcelRequire("iJBt4");
const $df0887593ff7101f$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $5NtHI.ActionName).CopyLinkAction]: (0, $71e7e.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).DownloadAction]: (0, $9ZYEf.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).FollowAction]: (0, $7xgpC.default)(response, actionOptions, id),
        [(0, $5NtHI.ActionName).PreviewAction]: (0, $l3lcT.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        [(0, $5NtHI.ActionName).AutomationAction]: (0, $glHkX.extractAutomationAction)(response),
        [(0, $5NtHI.InternalActionName).AISummaryAction]: (0, $4DFm3.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $5NtHI.InternalActionName).ViewRelatedLinksAction]: (0, $iJBt4.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("4DFm3", function(module, exports) {
$parcel$export(module.exports, "extractAISummaryAction", () => $3a123960ee44ec9b$export$e7f7a50a8b8932df);

var $2fsAU = parcelRequire("2fsAU");

var $7tQSx = parcelRequire("7tQSx");

var $18DG7 = parcelRequire("18DG7");
const $3a123960ee44ec9b$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).AISummaryAction, actionOptions) || !(0, $7tQSx.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});

parcelRegister("glHkX", function(module, exports) {
$parcel$export(module.exports, "extractAutomationAction", () => $26db5af86415f15e$export$f913cc6abf3ec084);

var $5NtHI = parcelRequire("5NtHI");
const $26db5af86415f15e$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $5NtHI.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("71e7e", function(module, exports) {
$parcel$export(module.exports, "extractCopyLinkClientAction", () => $c1fb7cacddedb674$export$31ddd5c40039ce53);

var $kGroK = parcelRequire("kGroK");
const $c1fb7cacddedb674$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $kGroK.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("kGroK", function(module, exports) {
$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $944dc4c637fc31a2$export$5ec86886067a062d);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");
const $944dc4c637fc31a2$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $5NtHI.ActionName).CopyLinkAction,
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});


parcelRegister("9ZYEf", function(module, exports) {
$parcel$export(module.exports, "extractDownloadClientAction", () => $8b4fa13cd6f1b67f$export$f6c386869a352b1f);

var $ccFJO = parcelRequire("ccFJO");
const $8b4fa13cd6f1b67f$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $ccFJO.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});

parcelRegister("7xgpC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d7e2884a85971c9$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");
var $dpM2S = parcelRequire("dpM2S");

var $5CgrK = parcelRequire("5CgrK");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $bT52P = parcelRequire("bT52P");
const $2d7e2884a85971c9$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    const type = (0, $dpM2S.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $5CgrK.SmartLinkActionType).FollowEntityAction || actionName === (0, $5CgrK.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $3seWH.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $5CgrK.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $2d7e2884a85971c9$export$2e2bcd8739ae039 = $2d7e2884a85971c9$var$extractFollowAction;

});
parcelRegister("bT52P", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb63d54723b1798$export$2e2bcd8739ae039);
const $bfb63d54723b1798$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $bfb63d54723b1798$export$2e2bcd8739ae039 = $bfb63d54723b1798$var$extractServerAction;

});


parcelRegister("l3lcT", function(module, exports) {
$parcel$export(module.exports, "extractPreviewClientAction", () => $be48c7ee2c64cc3a$export$9f0d9100b079448);

var $5O37S = parcelRequire("5O37S");
const $be48c7ee2c64cc3a$export$9f0d9100b079448 = (param)=>{
    const result = (0, $5O37S.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};

});

parcelRegister("iJBt4", function(module, exports) {
$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $30a13f343fd23d01$export$debae7424a0231b9);

var $hy9OT = parcelRequire("hy9OT");
const $30a13f343fd23d01$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $hy9OT.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("jIa7q", function(module, exports) {
$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $afd980b8f5408674$export$216e4f6aa7c169b8);

var $8pdx9 = parcelRequire("8pdx9");
var $9JeZK = parcelRequire("9JeZK");
const $afd980b8f5408674$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $8pdx9.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $9JeZK.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("8pdx9", function(module, exports) {
$parcel$export(module.exports, "extractMembers", () => $491ba0064e87a086$export$6281d080d62a0719);

var $9JeZK = parcelRequire("9JeZK");
const $491ba0064e87a086$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9JeZK.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9JeZK.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("13x9L", function(module, exports) {
$parcel$export(module.exports, "default", () => $f77867f4004a4594$export$2e2bcd8739ae039);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
const $f77867f4004a4594$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const responseUrl = (0, $hy9OT.extractSmartLinkUrl)(response);
    const url = status === (0, $5NtHI.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $hy9OT.extractSmartLinkTitle)(response);
    const text = status === (0, $5NtHI.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $f77867f4004a4594$export$2e2bcd8739ae039 = $f77867f4004a4594$var$extractLinkTitle;

});

parcelRegister("2LW3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $46aad986c1287f3b$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");

var $5NtHI = parcelRequire("5NtHI");
const $46aad986c1287f3b$var$priorityMapper = {
    blocker: (0, $5NtHI.IconType).PriorityBlocker,
    critical: (0, $5NtHI.IconType).PriorityCritical,
    high: (0, $5NtHI.IconType).PriorityHigh,
    highest: (0, $5NtHI.IconType).PriorityHighest,
    low: (0, $5NtHI.IconType).PriorityLow,
    lowest: (0, $5NtHI.IconType).PriorityLowest,
    major: (0, $5NtHI.IconType).PriorityMajor,
    medium: (0, $5NtHI.IconType).PriorityMedium,
    minor: (0, $5NtHI.IconType).PriorityMinor,
    trivial: (0, $5NtHI.IconType).PriorityTrivial,
    undefined: (0, $5NtHI.IconType).PriorityUndefined
};
const $46aad986c1287f3b$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $46aad986c1287f3b$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $4moW4.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $46aad986c1287f3b$export$2e2bcd8739ae039 = $46aad986c1287f3b$var$extractPriority;

});

parcelRegister("96cCi", function(module, exports) {
$parcel$export(module.exports, "default", () => $599db3951a68070c$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $5O37S = parcelRequire("5O37S");

var $bpSSH = parcelRequire("bpSSH");

var $bT52P = parcelRequire("bT52P");
const $599db3951a68070c$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $599db3951a68070c$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $3seWH.extractLink)(data);
    const invokePreviewAction = response ? (0, $5O37S.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    })?.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $599db3951a68070c$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $bpSSH.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $599db3951a68070c$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel);
    return {
        ...lozenge,
        action: action
    };
};
var $599db3951a68070c$export$2e2bcd8739ae039 = $599db3951a68070c$var$extractState;

});
parcelRegister("bpSSH", function(module, exports) {
$parcel$export(module.exports, "extractLozenge", () => $c2b51845c5984a0b$export$e5da155556a77bca);

var $dpM2S = parcelRequire("dpM2S");

var $8haf8 = parcelRequire("8haf8");

var $1Kr9e = parcelRequire("1Kr9e");

var $7ncIg = parcelRequire("7ncIg");

var $l5kRv = parcelRequire("l5kRv");
const $c2b51845c5984a0b$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $dpM2S.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $1Kr9e.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $7ncIg.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $c2b51845c5984a0b$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $8haf8.extractState)(jsonLd);
    }
};
const $c2b51845c5984a0b$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $l5kRv.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("8haf8", function(module, exports) {
$parcel$export(module.exports, "extractState", () => $76dc1be10470e17b$export$5e4074cbce6574c7);

var $9tSQF = parcelRequire("9tSQF");
// Maps accent color short names to their corresponding background and text colors
const $76dc1be10470e17b$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $76dc1be10470e17b$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $9tSQF.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $9tSQF.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $76dc1be10470e17b$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("9tSQF", function(module, exports) {
$parcel$export(module.exports, "isValidAppearance", () => $ae66787404c6b4b4$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $ae66787404c6b4b4$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $ae66787404c6b4b4$export$772610da74ddbc07);
const $ae66787404c6b4b4$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $ae66787404c6b4b4$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $ae66787404c6b4b4$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $ae66787404c6b4b4$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $ae66787404c6b4b4$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("1Kr9e", function(module, exports) {
$parcel$export(module.exports, "extractTag", () => $00d711d353e3bb83$export$962a8da34cf78a4f);

var $9tSQF = parcelRequire("9tSQF");
const $00d711d353e3bb83$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($00d711d353e3bb83$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $00d711d353e3bb83$var$extractTagItem(tag);
    }
};
const $00d711d353e3bb83$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $9tSQF.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("7ncIg", function(module, exports) {
$parcel$export(module.exports, "extractTaskStatus", () => $7aa28bf1d699e3b1$export$7698df1946deda72);
const $7aa28bf1d699e3b1$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("krByh", function(module, exports) {
$parcel$export(module.exports, "extractLatestCommit", () => $ce13437708ceefb0$export$f222392162cff0d8);
const $ce13437708ceefb0$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("g7toL", function(module, exports) {
$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $e227bf38409b8990$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $e227bf38409b8990$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $e227bf38409b8990$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $e227bf38409b8990$export$9671929f11bd4ad8);

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");

var $03JM4 = parcelRequire("03JM4");
const $e227bf38409b8990$var$baseTopMetadata = [
    {
        name: (0, $5NtHI.ElementName).ModifiedOn
    },
    {
        name: (0, $5NtHI.ElementName).AttachmentCount
    },
    {
        name: (0, $5NtHI.ElementName).SubscriberCount
    },
    {
        name: (0, $5NtHI.ElementName).VoteCount
    },
    {
        name: (0, $5NtHI.ElementName).DueOn
    },
    {
        name: (0, $5NtHI.ElementName).ReadTime
    }
];
const $e227bf38409b8990$var$baseBottomMetaData = [
    {
        name: (0, $5NtHI.ElementName).ReactCount
    },
    {
        name: (0, $5NtHI.ElementName).CommentCount
    },
    {
        name: (0, $5NtHI.ElementName).ViewCount
    },
    {
        name: (0, $5NtHI.ElementName).Priority
    },
    {
        name: (0, $5NtHI.ElementName).SubTasksProgress
    },
    {
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }
];
const $e227bf38409b8990$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $5NtHI.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $5NtHI.ElementName).AuthorGroup
        },
        {
            name: (0, $5NtHI.ElementName).CreatedBy
        },
        ...$e227bf38409b8990$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $e227bf38409b8990$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $5NtHI.ElementName).LatestCommit
                    },
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AppliedToComponentsCount
                    },
                    ...$e227bf38409b8990$var$baseBottomMetaData
                ]
            };
        case 'integration-passionfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AppliedToComponentsCount
                    },
                    ...$e227bf38409b8990$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AuthorGroup
                },
                {
                    name: (0, $5NtHI.ElementName).CreatedBy
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AssignedToGroup
                },
                {
                    name: (0, $5NtHI.ElementName).AssignedTo
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).OwnedByGroup
                },
                {
                    name: (0, $5NtHI.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).StoryPoints
                    },
                    {
                        name: (0, $5NtHI.ElementName).Priority
                    },
                    {
                        name: (0, $5NtHI.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).ReactCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).UserAttributes
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $e227bf38409b8990$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $e227bf38409b8990$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $5NtHI.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $5NtHI.SmartLinkSize).Large
};
const $e227bf38409b8990$export$9671929f11bd4ad8 = {
    placement: (0, $5NtHI.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("lc1jH", function(module, exports) {
$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $c6261e336be0cca4$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c6261e336be0cca4$var$flexibleBlockCardStyle = null;
const $c6261e336be0cca4$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_1g961mok _1qo31x13"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(FlexibleBlockCardView, {
                ...props
            })
        });
    };

});


parcelRegister("1uPx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5e11d03c412e160$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $gA511 = parcelRequire("gA511");

var $38cBa = parcelRequire("38cBa");

var $fPNY3 = parcelRequire("fPNY3");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $c5e11d03c412e160$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $c5e11d03c412e160$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $lRq8t.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
    const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
    const providerName = provider?.text || '';
    const messageContext = (0, $eJOHy.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
            children: (0, $4Qxcv.default)(url)
        });
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $eJOHy.useMemo)(()=>{
        return (0, $7r0tl.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $eJOHy.useMemo)(()=>{
        const descriptor = (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $fPNY3.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $fPNY3.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "forbidden-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
                    values: messageContext
                },
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $c5e11d03c412e160$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($c5e11d03c412e160$var$ForbiddenView);

});
parcelRegister("9QgTI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b170729cb10fdaa6c208ecbe5722b466>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a613e9f42e1e21$var$_react = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72a613e9f42e1e21$var$_baseNew = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72a613e9f42e1e21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72a613e9f42e1e21$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72a613e9f42e1e21$var$_react.default.createElement($72a613e9f42e1e21$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72a613e9f42e1e21$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72a613e9f42e1e21$var$_default = module.exports.default = $72a613e9f42e1e21$var$LockLockedIcon;

});

parcelRegister("jFH1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e523377710580c71$var$_react = $e523377710580c71$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e523377710580c71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e523377710580c71$var$LockIcon = (props)=>/*#__PURE__*/ $e523377710580c71$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props));
$e523377710580c71$var$LockIcon.displayName = 'LockIcon';
var $e523377710580c71$var$_default = module.exports.default = $e523377710580c71$var$LockIcon;

});

parcelRegister("idDkX", function(module, exports) {
$parcel$export(module.exports, "toMessage", () => $d5f398015422946e$export$d14c2a6dee946f52);

var $19nmp = parcelRequire("19nmp");
const $d5f398015422946e$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $19nmp.messages)) return (0, $19nmp.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("fPNY3", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $f4b684ab7f00a73c$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $f4b684ab7f00a73c$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("eB1dU", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa49cd5b8f02fcca$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $aa49cd5b8f02fcca$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $aa49cd5b8f02fcca$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $lRq8t.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $eJOHy.useMemo)(()=>{
        const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $eJOHy.useMemo)(()=>intl.formatMessage((0, $19nmp.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $eJOHy.useMemo)(()=>({
            descriptor: (0, $19nmp.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "not-found-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                message: description,
                testId: `${testId}-message`,
                maxLines: 3,
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $aa49cd5b8f02fcca$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($aa49cd5b8f02fcca$var$NotFoundView);

});

parcelRegister("8jMdw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d529b5b9d214a4cd$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $19G04 = parcelRequire("19G04");

var $lAF2k = parcelRequire("lAF2k");
var $gKsxm = parcelRequire("gKsxm");
var $8Rjtc = parcelRequire("8Rjtc");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");

var $lc1jH = parcelRequire("lc1jH");
const $d529b5b9d214a4cd$var$titleBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockSafariStyles = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $d529b5b9d214a4cd$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $eJOHy.useState)(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    (0, $eJOHy.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $g7toL.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const uiOptions = (0, $g7toL.FlexibleCardUiOptions);
    if ((0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) uiOptions.hideLoadingSkeleton = hideIconLoadingSkeleton;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                metadata: titleMetadata,
                subtitle: [
                    {
                        name: (0, $5NtHI.ElementName).Location
                    }
                ],
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                CompetitorPrompt: CompetitorPrompt,
                url: url,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: topMetadata,
                maxLines: 1
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: bottomMetadata,
                maxLines: 1
            }),
            !isPreviewBlockErrored ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions),
                onError: ()=>{
                    setIsPreviewBlockErrored(true);
                }
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lAF2k.default), {
                actions: footerActions,
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $d529b5b9d214a4cd$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($d529b5b9d214a4cd$var$ResolvedView);

});

parcelRegister("4fOPS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1855e7f6748dd65c$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $6Xgel = parcelRequire("6Xgel");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $1855e7f6748dd65c$var$contentStyles = null;
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $1855e7f6748dd65c$var$UnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>onAuthorize ? [
            (0, $6Xgel.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-content`,
            className: (0, $hcewu.default)([
                "_11c8dcr7 _syaz1fxt _19pku2gc"
            ]),
            children: content
        })
    });
};
var $1855e7f6748dd65c$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($1855e7f6748dd65c$var$UnauthorisedView);

});
parcelRegister("6Xgel", function(module, exports) {
$parcel$export(module.exports, "AuthorizeAction", () => $3bad804239ca8758$export$34cef2b72294bd84);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $3bad804239ca8758$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $5NtHI.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_link_account_card
        }),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});



parcelRegister("9uyEx", function(module, exports) {
$parcel$export(module.exports, "EmbedCard", () => $05d9abb62f80e331$export$6789d7ecdc77631b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $7r0tl = parcelRequire("7r0tl");

var $7AKPz = parcelRequire("7AKPz");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $9gzoR = parcelRequire("9gzoR");

var $gA511 = parcelRequire("gA511");

var $4UV7R = parcelRequire("4UV7R");

var $8jMdw = parcelRequire("8jMdw");

var $eIvWj = parcelRequire("eIvWj");

var $hFl6W = parcelRequire("hFl6W");

var $i53U1 = parcelRequire("i53U1");

var $5RX8x = parcelRequire("5RX8x");

var $h9g6U = parcelRequire("h9g6U");

var $iUsXM = parcelRequire("iUsXM");
const $05d9abb62f80e331$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-embed-card"
            }),
            children
        ]
    }) : children;
};
const $05d9abb62f80e331$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($05d9abb62f80e331$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
                })
            });
        case 'resolved':
            const resolvedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio
            });
            if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                const unauthViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                    context: unauthViewProps.context,
                    extensionKey: extensionKey,
                    frameStyle: frameStyle,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    inheritDimensions: inheritDimensions,
                    isSelected: isSelected,
                    onAuthorize: handleAuthorize,
                    onClick: handleFrameClick,
                    testId: testId,
                    url: unauthViewProps.link
                });
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                extensionKey: extensionKey
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $aRZRK.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                extensionKey: extensionKey
            });
            const forbiddenAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i53U1.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5RX8x.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hFl6W.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("7AKPz", function(module, exports) {
$parcel$export(module.exports, "extractEmbedProps", () => $bddb5ab530f782ff$export$d6cf81ca6e68bcc3);

var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $gA511 = parcelRequire("gA511");

var $9xgNQ = parcelRequire("9xgNQ");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");
const $bddb5ab530f782ff$export$d6cf81ca6e68bcc3 = (response, platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response) || '',
        title: (0, $hy9OT.extractSmartLinkTitle)(response),
        context: (0, $9xgNQ.extractSmartLinkContext)(response),
        preview: (0, $hy9OT.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
        isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("9xgNQ", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkContext", () => $81938710ecd918a9$export$6ec4b6b24dec9156);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $4moW4 = parcelRequire("4moW4");

var $gA511 = parcelRequire("gA511");

var $abbo9 = parcelRequire("abbo9");

var $7r0tl = parcelRequire("7r0tl");
function $81938710ecd918a9$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $9Thyx.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $81938710ecd918a9$export$6ec4b6b24dec9156(response) {
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityProvider)(response);
    return $81938710ecd918a9$export$8dcb07487061d3c1(response?.data || (0, $gA511.getEmptyJsonLd)());
}

});


parcelRegister("aRZRK", function(module, exports) {
$parcel$export(module.exports, "extractInlineProps", () => $56b7d71381ad586c$export$68e1703c529dc7e0);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $gA511 = parcelRequire("gA511");

var $k4P1T = parcelRequire("k4P1T");

var $bpSSH = parcelRequire("bpSSH");

var $7BqfG = parcelRequire("7BqfG");

var $gxXx6 = parcelRequire("gxXx6");

var $3DgO9 = parcelRequire("3DgO9");
const $56b7d71381ad586c$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $3DgO9.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $3DgO9.JIRA_GENERATOR_ID)) return (0, $k4P1T.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $k4P1T.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $56b7d71381ad586c$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (provider) return provider.icon;
    // We don't need this for design entities,
    // but we can add it back when we support more entities
    // it requires extractInlineIcon to be moved to the smart link extractor package.
    // see: https://product-fabric.atlassian.net/browse/EDM-12375
    // return extractSmartLinkIcon(response);
    }
    return $56b7d71381ad586c$var$extractInlineIcon(response?.data || (0, $gA511.getEmptyJsonLd)(), showLabel);
};
const $56b7d71381ad586c$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response),
        title: (0, $hy9OT.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: $56b7d71381ad586c$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $bpSSH.extractLozenge)(jsonLd),
        titleTextColor: (0, $7BqfG.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $gxXx6.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("k4P1T", function(module, exports) {
$parcel$export(module.exports, "extractIcon", () => $0a1959a1b48f0e49$export$64bdf1f5e49e8626);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $liS9g = parcelRequire("liS9g");

var $gSqCA = parcelRequire("gSqCA");

var $6wUJL = parcelRequire("6wUJL");

var $es92x = parcelRequire("es92x");

var $cOjgE = parcelRequire("cOjgE");

var $lG2jM = parcelRequire("lG2jM");

var $9Thyx = parcelRequire("9Thyx");
var $8T839 = parcelRequire("8T839");
var $4moW4 = parcelRequire("4moW4");

var $FoFt2 = parcelRequire("FoFt2");

var $l5kRv = parcelRequire("l5kRv");

var $ip2tE = parcelRequire("ip2tE");

var $l8s0O = parcelRequire("l8s0O");

var $1yraT = parcelRequire("1yraT");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");
const $0a1959a1b48f0e49$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $8T839.extractTitle)(jsonLd),
        provider: (0, $9Thyx.extractProvider)(jsonLd),
        fileFormat: (0, $ip2tE.extractFileFormat)(jsonLd),
        taskType: (0, $l5kRv.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        return $0a1959a1b48f0e49$var$extractIconByType(highestPriorityType, opts);
    } else return $0a1959a1b48f0e49$var$extractIconByType(type, opts);
};
function $0a1959a1b48f0e49$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6wUJL.default), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
                label: opts.title || 'project',
                LEGACY_size: "small",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $es92x.default), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $liS9g.default), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gSqCA.default), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $1yraT.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $0a1959a1b48f0e49$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $FoFt2.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $0a1959a1b48f0e49$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $l8s0O.extractIconFromDocument)(type, opts);
        default:
            return $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("liS9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $fba6d3a5fd6972fb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6c7dfca668b0d6e6a39983940ea2c14>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $awZZu = parcelRequire("awZZu");

var $cBTRt = parcelRequire("cBTRt");
/**
 * __16px `branch` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $fba6d3a5fd6972fb$var$Branch16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($awZZu))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cBTRt.default), {
            label: label,
            testId: testId
        })
    });
};
$fba6d3a5fd6972fb$var$Branch16Icon.displayName = 'Branch16Icon';
var $fba6d3a5fd6972fb$export$2e2bcd8739ae039 = $fba6d3a5fd6972fb$var$Branch16Icon;

});
parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d8d971bf9def65ea3fd98a53d2a797b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("cBTRt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3462a9699ad70391$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::625730c3236ac1826cad47b39a1764d5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $3462a9699ad70391$var$Branch16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 0 1 8.002 11l-.004 2A3.995 3.995 0 0 0 12 9.007v-.274a2 2 0 1 0-2 0m-4-3a2 2 0 1 0-2 0v4.536a2 2 0 1 0 2 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$3462a9699ad70391$var$Branch16Icon.displayName = 'Branch16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3462a9699ad70391$export$2e2bcd8739ae039 = $3462a9699ad70391$var$Branch16Icon;

});


parcelRegister("gSqCA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $978ab5b169d02f01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e19cdb2fbb79f1a0f8b1ce6841b27f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $8lO5P = parcelRequire("8lO5P");

var $j8Au4 = parcelRequire("j8Au4");
/**
 * __16px `code` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $978ab5b169d02f01$var$Code16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j8Au4.default), {
            label: label,
            testId: testId
        })
    });
};
$978ab5b169d02f01$var$Code16Icon.displayName = 'Code16Icon';
var $978ab5b169d02f01$export$2e2bcd8739ae039 = $978ab5b169d02f01$var$Code16Icon;

});
parcelRegister("8lO5P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1091d7b3916e42e9c126eb0a1ee5598a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6147244ca1278d21$var$_react = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6147244ca1278d21$var$_baseNew = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6147244ca1278d21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6147244ca1278d21$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $6147244ca1278d21$var$_react.default.createElement($6147244ca1278d21$var$_baseNew.default, Object.assign({
        name: "AngleBracketsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$6147244ca1278d21$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $6147244ca1278d21$var$_default = module.exports.default = $6147244ca1278d21$var$AngleBracketsIcon;

});

parcelRegister("j8Au4", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a6502744a03af16$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d003ccf13a9ed7b17e1f0e343e52054d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $7a6502744a03af16$var$Code16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L4.46 8.006l1.873-1.871A1 1 0 1 0 4.92 4.72m4.792 0a1 1 0 0 0 0 1.415l1.874 1.87-1.873 1.87a1 1 0 1 0 1.414 1.416l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292 1 1 0 0 0-.708.293"/></svg>`,
        ...props,
        size: "small"
    });
$7a6502744a03af16$var$Code16Icon.displayName = 'Code16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a6502744a03af16$export$2e2bcd8739ae039 = $7a6502744a03af16$var$Code16Icon;

});


parcelRegister("6wUJL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c727218f2343b747$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d25686ccdc8d521025822e9e785ed3f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $7XCnf = parcelRequire("7XCnf");

var $1OiKX = parcelRequire("1OiKX");
/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c727218f2343b747$var$Commit16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1OiKX.default), {
            label: label,
            testId: testId
        })
    });
};
$c727218f2343b747$var$Commit16Icon.displayName = 'Commit16Icon';
var $c727218f2343b747$export$2e2bcd8739ae039 = $c727218f2343b747$var$Commit16Icon;

});
parcelRegister("7XCnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ab489d2a38e8a0acc1962f05ff04e40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cbbcf5690c6b367$var$_react = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5cbbcf5690c6b367$var$_baseNew = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5cbbcf5690c6b367$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cbbcf5690c6b367$var$CommitIcon = (props)=>/*#__PURE__*/ $5cbbcf5690c6b367$var$_react.default.createElement($5cbbcf5690c6b367$var$_baseNew.default, Object.assign({
        name: "CommitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$5cbbcf5690c6b367$var$CommitIcon.displayName = 'CommitIcon';
var $5cbbcf5690c6b367$var$_default = module.exports.default = $5cbbcf5690c6b367$var$CommitIcon;

});

parcelRegister("1OiKX", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd5ceb37ab40bc73$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14dd3b796d1706ede7eb831d28deffaa>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $bd5ceb37ab40bc73$var$Commit16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.986 1.834a3.001 3.001 0 0 1 0-5.668A1 1 0 0 1 7 5V3a1 1 0 1 1 2 0v2q0 .085-.014.166a3.001 3.001 0 0 1 0 5.668Q9 10.915 9 11v2a1 1 0 0 1-2 0v-2q0-.085.014-.166"/></svg>`,
        ...props,
        size: "small"
    });
$bd5ceb37ab40bc73$var$Commit16Icon.displayName = 'Commit16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd5ceb37ab40bc73$export$2e2bcd8739ae039 = $bd5ceb37ab40bc73$var$Commit16Icon;

});


parcelRegister("es92x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $44741c921c28f10f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f733519753e7d034f81ba5d46eeaf436>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $MUJuW = parcelRequire("MUJuW");

var $3xtgM = parcelRequire("3xtgM");
/**
 * __16px `pull-request` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $44741c921c28f10f$var$PullRequest16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3xtgM.default), {
            label: label,
            testId: testId
        })
    });
};
$44741c921c28f10f$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $44741c921c28f10f$export$2e2bcd8739ae039 = $44741c921c28f10f$var$PullRequest16Icon;

});
parcelRegister("MUJuW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::baa34f3217bb36f9859c9b6bddb020ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09307dc51f4f46f2$var$_react = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $09307dc51f4f46f2$var$_baseNew = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $09307dc51f4f46f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09307dc51f4f46f2$var$PullRequestIcon = (props)=>/*#__PURE__*/ $09307dc51f4f46f2$var$_react.default.createElement($09307dc51f4f46f2$var$_baseNew.default, Object.assign({
        name: "PullRequestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$09307dc51f4f46f2$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $09307dc51f4f46f2$var$_default = module.exports.default = $09307dc51f4f46f2$var$PullRequestIcon;

});

parcelRegister("3xtgM", function(module, exports) {
$parcel$export(module.exports, "default", () => $38a04956c9fd4802$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a228b6a8cc996f7aacfdd22dc7d2cc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $38a04956c9fd4802$var$PullRequest16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M6.417 6H9a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V7a3 3 0 0 0-3-3H6.415l.294-.295a1 1 0 1 0-1.413-1.414l-2.003 2a1 1 0 0 0 .001 1.415l2.002 2.001a1 1 0 0 0 1.414-.002 1 1 0 0 0-.001-1.413zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`,
        ...props,
        size: "small"
    });
$38a04956c9fd4802$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$38a04956c9fd4802$export$2e2bcd8739ae039 = $38a04956c9fd4802$var$PullRequest16Icon;

});


parcelRegister("cOjgE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $442ecc1a7897d80c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35a1e8327b725c502efb3e09f798fa84>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $bwM92 = parcelRequire("bwM92");

var $dSbyY = parcelRequire("dSbyY");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $442ecc1a7897d80c$var$Task16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dSbyY.default), {
            label: label,
            testId: testId
        })
    });
};
$442ecc1a7897d80c$var$Task16Icon.displayName = 'Task16Icon';
var $442ecc1a7897d80c$export$2e2bcd8739ae039 = $442ecc1a7897d80c$var$Task16Icon;

});
parcelRegister("bwM92", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::511501585faa18257c05d7a2687e12c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8648076de2cded56$var$_react = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8648076de2cded56$var$_baseNew = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8648076de2cded56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8648076de2cded56$var$TaskIcon = (props)=>/*#__PURE__*/ $8648076de2cded56$var$_react.default.createElement($8648076de2cded56$var$_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$8648076de2cded56$var$TaskIcon.displayName = 'TaskIcon';
var $8648076de2cded56$var$_default = module.exports.default = $8648076de2cded56$var$TaskIcon;

});

parcelRegister("dSbyY", function(module, exports) {
$parcel$export(module.exports, "default", () => $7143582d1b645e3c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c287ed46a4f0bca8d14d4f24a4bb3c80>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $7143582d1b645e3c$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$7143582d1b645e3c$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7143582d1b645e3c$export$2e2bcd8739ae039 = $7143582d1b645e3c$var$Task16Icon;

});


parcelRegister("lG2jM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68ed51f9e1612abe38768085b9e3fc4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc7f518425e4bcf9$var$_react = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc7f518425e4bcf9$var$_peopleGroup = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $fc7f518425e4bcf9$var$_peopleGroup2 = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hh8BY")));
function $fc7f518425e4bcf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc7f518425e4bcf9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $fc7f518425e4bcf9$var$_react.default.createElement($fc7f518425e4bcf9$var$_peopleGroup.default, Object.assign({
        name: "PeopleGroupIcon",
        LEGACY_fallbackIcon: $fc7f518425e4bcf9$var$_peopleGroup2.default
    }, props));
$fc7f518425e4bcf9$var$PeopleGroupIcon.displayName = 'PeopleGroupIconMigration';
var $fc7f518425e4bcf9$var$_default = module.exports.default = $fc7f518425e4bcf9$var$PeopleGroupIcon;

});
parcelRegister("hh8BY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c93ab4407be6cde9$var$_react = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c93ab4407be6cde9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c93ab4407be6cde9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c93ab4407be6cde9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props));
$c93ab4407be6cde9$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c93ab4407be6cde9$var$_default = module.exports.default = $c93ab4407be6cde9$var$PeopleGroupIcon;

});


parcelRegister("ip2tE", function(module, exports) {
$parcel$export(module.exports, "extractFileFormat", () => $733ec07b82674776$export$f2d65f02f6888b60);
const $733ec07b82674776$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("l8s0O", function(module, exports) {
$parcel$export(module.exports, "extractIconFromDocument", () => $f67edadeb7739c7c$export$25c24c7f577936d3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kSre2 = parcelRequire("kSre2");

var $9Thyx = parcelRequire("9Thyx");

var $4Gz8O = parcelRequire("4Gz8O");

var $lQKQC = parcelRequire("lQKQC");

var $iOphm = parcelRequire("iOphm");

var $4VIPx = parcelRequire("4VIPx");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $FoFt2 = parcelRequire("FoFt2");

var $abbo9 = parcelRequire("abbo9");
const $f67edadeb7739c7c$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $f67edadeb7739c7c$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $f67edadeb7739c7c$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f67edadeb7739c7c$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $FoFt2.getIconForFileType)(opts.fileFormat);
};
const $f67edadeb7739c7c$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: opts.showIconLabel ? opts.title || 'blog' : '',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return $f67edadeb7739c7c$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'document' : '',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lQKQC.default), {
                label: opts.showIconLabel ? opts.title || 'presentation' : '',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VIPx.default), {
                label: opts.showIconLabel ? opts.title || 'spreadsheet' : '',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kSre2))), {
                color: "currentColor",
                label: opts.showIconLabel ? opts.title || 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'undefinedLink' : '',
                testId: "document-icon"
            });
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $f67edadeb7739c7c$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $9Thyx.isConfluenceGenerator)(opts.provider.id)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
        label: "live-doc",
        testId: "live-doc-icon"
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iOphm.default), {
        label: opts.showIconLabel ? opts.title || 'file' : '',
        testId: "file-icon"
    });
};

});
parcelRegister("kSre2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a76a3f4404ba59acd822415adfff8b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f32df82c412cc2b2$var$_react = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f32df82c412cc2b2$var$_file = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("jvbqF")));

var $f32df82c412cc2b2$var$_documentFilled = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("ePbAf")));
function $f32df82c412cc2b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f32df82c412cc2b2$var$FileIcon = (props)=>/*#__PURE__*/ $f32df82c412cc2b2$var$_react.default.createElement($f32df82c412cc2b2$var$_file.default, Object.assign({
        name: "FileIcon",
        LEGACY_fallbackIcon: $f32df82c412cc2b2$var$_documentFilled.default
    }, props));
$f32df82c412cc2b2$var$FileIcon.displayName = 'FileIconMigration';
var $f32df82c412cc2b2$var$_default = module.exports.default = $f32df82c412cc2b2$var$FileIcon;

});
parcelRegister("jvbqF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::51c2fad80696a752d051082f1f9faaf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e329c724a11ab833$var$_react = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e329c724a11ab833$var$_baseNew = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e329c724a11ab833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e329c724a11ab833$var$FileIcon = (props)=>/*#__PURE__*/ $e329c724a11ab833$var$_react.default.createElement($e329c724a11ab833$var$_baseNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e329c724a11ab833$var$FileIcon.displayName = 'FileIcon';
var $e329c724a11ab833$var$_default = module.exports.default = $e329c724a11ab833$var$FileIcon;

});

parcelRegister("ePbAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acaed063c693be85$var$_react = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $acaed063c693be85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $acaed063c693be85$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $acaed063c693be85$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props));
$acaed063c693be85$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $acaed063c693be85$var$_default = module.exports.default = $acaed063c693be85$var$DocumentFilledIcon;

});


parcelRegister("lQKQC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $457cf0e778e4e077$export$2e2bcd8739ae039);

var $5cEyJ = parcelRequire("5cEyJ");

var $1TONM = parcelRequire("1TONM");

var $amDP4 = parcelRequire("amDP4");

var $cPcks = parcelRequire("cPcks");
const $457cf0e778e4e077$var$ChartBarIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($amDP4))), 'purpleBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($5cEyJ))), (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))));
$457cf0e778e4e077$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $457cf0e778e4e077$export$2e2bcd8739ae039 = $457cf0e778e4e077$var$ChartBarIconWithColor;

});
parcelRegister("5cEyJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3c9d88f73aaa21a0$var$_react = $3c9d88f73aaa21a0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $3c9d88f73aaa21a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c9d88f73aaa21a0$var$Presentation16Icon = (props)=>/*#__PURE__*/ $3c9d88f73aaa21a0$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$3c9d88f73aaa21a0$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $3c9d88f73aaa21a0$var$_default = module.exports.default = $3c9d88f73aaa21a0$var$Presentation16Icon;

});

parcelRegister("1TONM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $162255ae7d5921b9$var$_react = $162255ae7d5921b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $162255ae7d5921b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162255ae7d5921b9$var$Presentation24Icon = (props)=>/*#__PURE__*/ $162255ae7d5921b9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$162255ae7d5921b9$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $162255ae7d5921b9$var$_default = module.exports.default = $162255ae7d5921b9$var$Presentation24Icon;

});

parcelRegister("amDP4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25c5fc21ffe3de28c11b1ff576772f32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78bad9690aef89d2$var$_react = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78bad9690aef89d2$var$_baseNew = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78bad9690aef89d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78bad9690aef89d2$var$ChartBarIcon = (props)=>/*#__PURE__*/ $78bad9690aef89d2$var$_react.default.createElement($78bad9690aef89d2$var$_baseNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$78bad9690aef89d2$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $78bad9690aef89d2$var$_default = module.exports.default = $78bad9690aef89d2$var$ChartBarIcon;

});


parcelRegister("iOphm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d1a6648d509434f8$export$2e2bcd8739ae039);

var $hLSBq = parcelRequire("hLSBq");

var $btZ6J = parcelRequire("btZ6J");

var $jvbqF = parcelRequire("jvbqF");

var $cPcks = parcelRequire("cPcks");
const $d1a6648d509434f8$var$FileIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($jvbqF))), 'grayBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($hLSBq))), (0, (/*@__PURE__*/$parcel$interopDefault($btZ6J)))));
$d1a6648d509434f8$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $d1a6648d509434f8$export$2e2bcd8739ae039 = $d1a6648d509434f8$var$FileIconWithColor;

});
parcelRegister("hLSBq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cf012e6694ca1348$var$_react = $cf012e6694ca1348$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $cf012e6694ca1348$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cf012e6694ca1348$var$Generic16Icon = (props)=>/*#__PURE__*/ $cf012e6694ca1348$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$cf012e6694ca1348$var$Generic16Icon.displayName = 'Generic16Icon';
var $cf012e6694ca1348$var$_default = module.exports.default = $cf012e6694ca1348$var$Generic16Icon;

});

parcelRegister("btZ6J", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $85c1cdd5f70b300c$var$_react = $85c1cdd5f70b300c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $85c1cdd5f70b300c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85c1cdd5f70b300c$var$Generic24Icon = (props)=>/*#__PURE__*/ $85c1cdd5f70b300c$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$85c1cdd5f70b300c$var$Generic24Icon.displayName = 'Generic24Icon';
var $85c1cdd5f70b300c$var$_default = module.exports.default = $85c1cdd5f70b300c$var$Generic24Icon;

});


parcelRegister("4VIPx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $261b25b77463fadb$export$2e2bcd8739ae039);

var $avN5P = parcelRequire("avN5P");

var $i9oSq = parcelRequire("i9oSq");

var $hJIkn = parcelRequire("hJIkn");

var $cPcks = parcelRequire("cPcks");
const $261b25b77463fadb$var$ListBulletedIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), 'greenBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($avN5P))), (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))));
$261b25b77463fadb$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $261b25b77463fadb$export$2e2bcd8739ae039 = $261b25b77463fadb$var$ListBulletedIconWithColor;

});
parcelRegister("avN5P", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a72e175f7c6772a$var$_react = $7a72e175f7c6772a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $7a72e175f7c6772a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a72e175f7c6772a$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $7a72e175f7c6772a$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$7a72e175f7c6772a$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $7a72e175f7c6772a$var$_default = module.exports.default = $7a72e175f7c6772a$var$Spreadsheet16Icon;

});

parcelRegister("i9oSq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36c5d4aab250180$var$_react = $d36c5d4aab250180$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d36c5d4aab250180$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36c5d4aab250180$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d36c5d4aab250180$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36c5d4aab250180$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d36c5d4aab250180$var$_default = module.exports.default = $d36c5d4aab250180$var$Spreadsheet24Icon;

});

parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94ba737f8eb536b5803fd14d2e86416d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});



parcelRegister("1yraT", function(module, exports) {
$parcel$export(module.exports, "extractIconFromTask", () => $4555066ff891e98a$export$321256ed044e3100);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i3nvV = parcelRequire("i3nvV");

var $59W6U = parcelRequire("59W6U");

var $4VGMo = parcelRequire("4VGMo");

var $h6Xfo = parcelRequire("h6Xfo");

var $8WXuv = parcelRequire("8WXuv");

var $erbJ6 = parcelRequire("erbJ6");

var $iaeCZ = parcelRequire("iaeCZ");

var $dV8me = parcelRequire("dV8me");

var $cOjgE = parcelRequire("cOjgE");

var $3DgO9 = parcelRequire("3DgO9");
const $4555066ff891e98a$var$TaskIcon = (0, $cOjgE.default);
const $4555066ff891e98a$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, $gt9Am.jsx)($4555066ff891e98a$var$TaskIcon, {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $3DgO9.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $3DgO9.JIRA_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $3DgO9.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dV8me.default), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $3DgO9.JIRA_STORY:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iaeCZ.default), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $3DgO9.JIRA_BUG:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3nvV.default), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $3DgO9.JIRA_EPIC:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VGMo.default), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $3DgO9.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h6Xfo.default), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $3DgO9.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8WXuv.default), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $3DgO9.JIRA_CHANGE:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59W6U.default), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $3DgO9.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $erbJ6.default), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $3DgO9.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("i3nvV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $7757e0f556678002$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3d74468e21dbaaa99b904c972830ea6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $9UdpB = parcelRequire("9UdpB");

var $ePICl = parcelRequire("ePICl");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7757e0f556678002$var$Bug16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9UdpB))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ePICl.default), {
            label: label,
            testId: testId
        })
    });
};
$7757e0f556678002$var$Bug16Icon.displayName = 'Bug16Icon';
var $7757e0f556678002$export$2e2bcd8739ae039 = $7757e0f556678002$var$Bug16Icon;

});
parcelRegister("9UdpB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1c065f0aa91b3c3f089345b7ec72ae8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7363bf5e9aa00467$var$_react = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7363bf5e9aa00467$var$_baseNew = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7363bf5e9aa00467$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7363bf5e9aa00467$var$BugIcon = (props)=>/*#__PURE__*/ $7363bf5e9aa00467$var$_react.default.createElement($7363bf5e9aa00467$var$_baseNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$7363bf5e9aa00467$var$BugIcon.displayName = 'BugIcon';
var $7363bf5e9aa00467$var$_default = module.exports.default = $7363bf5e9aa00467$var$BugIcon;

});

parcelRegister("ePICl", function(module, exports) {
$parcel$export(module.exports, "default", () => $c67568ee10eb7c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6b2aaa54dc8ca05673d473e302061ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $c67568ee10eb7c6c$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$c67568ee10eb7c6c$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c67568ee10eb7c6c$export$2e2bcd8739ae039 = $c67568ee10eb7c6c$var$Bug16Icon;

});


parcelRegister("59W6U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b85119f148eef897$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6b35f8ed9b8dcf23ac8137637f8695f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $4aDUk = parcelRequire("4aDUk");

var $bqSXM = parcelRequire("bqSXM");
/**
 * __16px `changes` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $b85119f148eef897$var$Changes16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4aDUk))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bqSXM.default), {
            label: label,
            testId: testId
        })
    });
};
$b85119f148eef897$var$Changes16Icon.displayName = 'Changes16Icon';
var $b85119f148eef897$export$2e2bcd8739ae039 = $b85119f148eef897$var$Changes16Icon;

});
parcelRegister("4aDUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c248cb8ff46f92a14313d2de4318df80>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30970d602f267700$var$_react = $30970d602f267700$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $30970d602f267700$var$_baseNew = $30970d602f267700$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $30970d602f267700$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30970d602f267700$var$ChangesIcon = (props)=>/*#__PURE__*/ $30970d602f267700$var$_react.default.createElement($30970d602f267700$var$_baseNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$30970d602f267700$var$ChangesIcon.displayName = 'ChangesIcon';
var $30970d602f267700$var$_default = module.exports.default = $30970d602f267700$var$ChangesIcon;

});

parcelRegister("bqSXM", function(module, exports) {
$parcel$export(module.exports, "default", () => $5517f3f5f4a6b147$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43edfd1c3679c7345c2a442459999c85>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $5517f3f5f4a6b147$var$Changes16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 1 0 4.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L5.456 9h5.134l-.877.876a1 1 0 1 0 1.414 1.415l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292.999.999 0 0 0-.707 1.707zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$5517f3f5f4a6b147$var$Changes16Icon.displayName = 'Changes16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5517f3f5f4a6b147$export$2e2bcd8739ae039 = $5517f3f5f4a6b147$var$Changes16Icon;

});


parcelRegister("4VGMo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $adbcbb4e84b923ab$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cfb78393191d034d3ff60b0c05249072>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $gtN4u = parcelRequire("gtN4u");

var $3zPlh = parcelRequire("3zPlh");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $adbcbb4e84b923ab$var$Epic16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtN4u))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3zPlh.default), {
            label: label,
            testId: testId
        })
    });
};
$adbcbb4e84b923ab$var$Epic16Icon.displayName = 'Epic16Icon';
var $adbcbb4e84b923ab$export$2e2bcd8739ae039 = $adbcbb4e84b923ab$var$Epic16Icon;

});
parcelRegister("gtN4u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27415f759dcf84731b49eedf76030531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bff56b51666b12d4$var$_react = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bff56b51666b12d4$var$_baseNew = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bff56b51666b12d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bff56b51666b12d4$var$EpicIcon = (props)=>/*#__PURE__*/ $bff56b51666b12d4$var$_react.default.createElement($bff56b51666b12d4$var$_baseNew.default, Object.assign({
        name: "EpicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$bff56b51666b12d4$var$EpicIcon.displayName = 'EpicIcon';
var $bff56b51666b12d4$var$_default = module.exports.default = $bff56b51666b12d4$var$EpicIcon;

});

parcelRegister("3zPlh", function(module, exports) {
$parcel$export(module.exports, "default", () => $07e901c858f1e000$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::142d10bfd50eb509af7927d7baa82685>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $07e901c858f1e000$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$07e901c858f1e000$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07e901c858f1e000$export$2e2bcd8739ae039 = $07e901c858f1e000$var$Epic16Icon;

});


parcelRegister("h6Xfo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $10b82fbbd3c25549$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0d158114ff18c0f147993eebee111e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $ljmsu = parcelRequire("ljmsu");

var $ewxpd = parcelRequire("ewxpd");
/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $10b82fbbd3c25549$var$Incident16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ljmsu))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewxpd.default), {
            label: label,
            testId: testId
        })
    });
};
$10b82fbbd3c25549$var$Incident16Icon.displayName = 'Incident16Icon';
var $10b82fbbd3c25549$export$2e2bcd8739ae039 = $10b82fbbd3c25549$var$Incident16Icon;

});
parcelRegister("ljmsu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f39860ce7f984391648fef01b18ffad3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f83ccb209af59fed$var$_react = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f83ccb209af59fed$var$_baseNew = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f83ccb209af59fed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f83ccb209af59fed$var$IncidentIcon = (props)=>/*#__PURE__*/ $f83ccb209af59fed$var$_react.default.createElement($f83ccb209af59fed$var$_baseNew.default, Object.assign({
        name: "IncidentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$f83ccb209af59fed$var$IncidentIcon.displayName = 'IncidentIcon';
var $f83ccb209af59fed$var$_default = module.exports.default = $f83ccb209af59fed$var$IncidentIcon;

});

parcelRegister("ewxpd", function(module, exports) {
$parcel$export(module.exports, "default", () => $629cf392ad3aaa3f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b29b882c898f601323f622b31bfeccd>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $629cf392ad3aaa3f$var$Incident16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499zM4 11a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1zm1.856-4h4.288L8.942 3.632a1 1 0 0 0-1.884 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$629cf392ad3aaa3f$var$Incident16Icon.displayName = 'Incident16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$629cf392ad3aaa3f$export$2e2bcd8739ae039 = $629cf392ad3aaa3f$var$Incident16Icon;

});


parcelRegister("8WXuv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $67922ee1ec2953f7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2450a0e3991eedcad5b6141f9bf1f77b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $c59mr = parcelRequire("c59mr");

var $28xc1 = parcelRequire("28xc1");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67922ee1ec2953f7$var$Issue16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $28xc1.default), {
            label: label,
            testId: testId
        })
    });
};
$67922ee1ec2953f7$var$Issue16Icon.displayName = 'Issue16Icon';
var $67922ee1ec2953f7$export$2e2bcd8739ae039 = $67922ee1ec2953f7$var$Issue16Icon;

});
parcelRegister("c59mr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5af16ea80f1d58312eb2e017eb04c22b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cbd368cf037dfb6$var$_react = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8cbd368cf037dfb6$var$_baseNew = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8cbd368cf037dfb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cbd368cf037dfb6$var$WorkItemIcon = (props)=>/*#__PURE__*/ $8cbd368cf037dfb6$var$_react.default.createElement($8cbd368cf037dfb6$var$_baseNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$8cbd368cf037dfb6$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $8cbd368cf037dfb6$var$_default = module.exports.default = $8cbd368cf037dfb6$var$WorkItemIcon;

});

parcelRegister("28xc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $26d0d6c17f6a21a0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe2288302fb4009a8dfaa99b181ad17d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $26d0d6c17f6a21a0$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$26d0d6c17f6a21a0$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$26d0d6c17f6a21a0$export$2e2bcd8739ae039 = $26d0d6c17f6a21a0$var$Issue16Icon;

});


parcelRegister("erbJ6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a57d8898cb2acd54$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2d3c6c74dbb172b2f2c6a5048c50392>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $gNXvC = parcelRequire("gNXvC");

var $kFcVs = parcelRequire("kFcVs");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a57d8898cb2acd54$var$Problem16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNXvC))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFcVs.default), {
            label: label,
            testId: testId
        })
    });
};
$a57d8898cb2acd54$var$Problem16Icon.displayName = 'Problem16Icon';
var $a57d8898cb2acd54$export$2e2bcd8739ae039 = $a57d8898cb2acd54$var$Problem16Icon;

});
parcelRegister("gNXvC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c3166f2fe0f47ea82d95571c4b7ab84>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf622d2894843f$var$_react = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c3bf622d2894843f$var$_baseNew = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c3bf622d2894843f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf622d2894843f$var$ProblemIcon = (props)=>/*#__PURE__*/ $c3bf622d2894843f$var$_react.default.createElement($c3bf622d2894843f$var$_baseNew.default, Object.assign({
        name: "ProblemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343a8 8 0 1 1 11.314 11.315A8 8 0 0 1 2.343 2.343m.561 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.693-.562a6.5 6.5 0 0 0-8.632-.499l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$c3bf622d2894843f$var$ProblemIcon.displayName = 'ProblemIcon';
var $c3bf622d2894843f$var$_default = module.exports.default = $c3bf622d2894843f$var$ProblemIcon;

});

parcelRegister("kFcVs", function(module, exports) {
$parcel$export(module.exports, "default", () => $a016a8b27712b47b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::22fd64be1230cdfa956ed09821e612ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $a016a8b27712b47b$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$a016a8b27712b47b$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a016a8b27712b47b$export$2e2bcd8739ae039 = $a016a8b27712b47b$var$Problem16Icon;

});


parcelRegister("iaeCZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5d125ca7430036a6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a47f46d0e9a1129d1600aede0da730e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $hVZow = parcelRequire("hVZow");

var $ayExB = parcelRequire("ayExB");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $5d125ca7430036a6$var$Story16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hVZow))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayExB.default), {
            label: label,
            testId: testId
        })
    });
};
$5d125ca7430036a6$var$Story16Icon.displayName = 'Story16Icon';
var $5d125ca7430036a6$export$2e2bcd8739ae039 = $5d125ca7430036a6$var$Story16Icon;

});
parcelRegister("hVZow", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c7bb68234d60992450ed6f02b59a5e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0e76235a9209c86$var$_react = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d0e76235a9209c86$var$_baseNew = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d0e76235a9209c86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0e76235a9209c86$var$StoryIcon = (props)=>/*#__PURE__*/ $d0e76235a9209c86$var$_react.default.createElement($d0e76235a9209c86$var$_baseNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$d0e76235a9209c86$var$StoryIcon.displayName = 'StoryIcon';
var $d0e76235a9209c86$var$_default = module.exports.default = $d0e76235a9209c86$var$StoryIcon;

});

parcelRegister("ayExB", function(module, exports) {
$parcel$export(module.exports, "default", () => $a03bb463cddb9827$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::888e49ac8aee51ec38f43bede32963e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $a03bb463cddb9827$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$a03bb463cddb9827$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a03bb463cddb9827$export$2e2bcd8739ae039 = $a03bb463cddb9827$var$Story16Icon;

});


parcelRegister("dV8me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $462b7112313631bd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8946e13fcda32d22acc9ed69bd1fcc6c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $d67Vm = parcelRequire("d67Vm");

var $kqL94 = parcelRequire("kqL94");
/**
 * __16px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $462b7112313631bd$var$Subtask16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d67Vm))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kqL94.default), {
            label: label,
            testId: testId
        })
    });
};
$462b7112313631bd$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $462b7112313631bd$export$2e2bcd8739ae039 = $462b7112313631bd$var$Subtask16Icon;

});
parcelRegister("d67Vm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c160a9f26591f77220765c2e9d99939c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9891fb7b92d506c5$var$_react = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9891fb7b92d506c5$var$_baseNew = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9891fb7b92d506c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9891fb7b92d506c5$var$SubtasksIcon = (props)=>/*#__PURE__*/ $9891fb7b92d506c5$var$_react.default.createElement($9891fb7b92d506c5$var$_baseNew.default, Object.assign({
        name: "SubtasksIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$9891fb7b92d506c5$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $9891fb7b92d506c5$var$_default = module.exports.default = $9891fb7b92d506c5$var$SubtasksIcon;

});

parcelRegister("kqL94", function(module, exports) {
$parcel$export(module.exports, "default", () => $602f9b1db5d82f1d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d77b8a2607635762876eadf6c30777eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $602f9b1db5d82f1d$var$Subtask16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M9 7V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM9 9h2v2H9zM5 5h2v2H5z"/></svg>`,
        ...props,
        size: "small"
    });
$602f9b1db5d82f1d$var$Subtask16Icon.displayName = 'Subtask16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$602f9b1db5d82f1d$export$2e2bcd8739ae039 = $602f9b1db5d82f1d$var$Subtask16Icon;

});




parcelRegister("7BqfG", function(module, exports) {
$parcel$export(module.exports, "extractTitleTextColor", () => $33546c004f5f4832$export$a2afc198e9dada1);


var $aDkpj = parcelRequire("aDkpj");
const $33546c004f5f4832$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $7bb4c1736002a04a$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});

parcelRegister("gxXx6", function(module, exports) {
$parcel$export(module.exports, "extractTitlePrefix", () => $c5f184c1c3b70b36$export$58d9bc37318dfb32);
const $c5f184c1c3b70b36$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $c5f184c1c3b70b36$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $c5f184c1c3b70b36$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("eIvWj", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvedView", () => $f516ef55418d7e1c$export$6d5912cb4b56390e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $3S6ja = parcelRequire("3S6ja");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
class $f516ef55418d7e1c$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
            children: lozenge.text
        });
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            truncateInline: truncateInline,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                    emoji: titlePrefix,
                    icon: icon,
                    title: title,
                    titleTextColor: titleTextColor,
                    type: type,
                    hideIconLoadingSkeleton: (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton
                }),
                this.renderLozenge()
            ]
        });
        if (showHoverPreview && link) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions,
            children: inlineCardResolvedView
        });
        return inlineCardResolvedView;
    }
}

});
parcelRegister("k6uZC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e6c0fa079b82f37$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");
const $7e6c0fa079b82f37$var$wrapperStyles = null;
const $7e6c0fa079b82f37$var$InlineLozenge = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
            ...props
        })
    });
var $7e6c0fa079b82f37$export$2e2bcd8739ae039 = $7e6c0fa079b82f37$var$InlineLozenge;

});

parcelRegister("3KRDe", function(module, exports) {
$parcel$export(module.exports, "IconAndTitleLayout", () => $5d532ff440b5b275$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $5d532ff440b5b275$export$c73a53738ef9e3f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2HNHt = parcelRequire("2HNHt");

var $av9Of = parcelRequire("av9Of");

var $8IeH1 = parcelRequire("8IeH1");

var $cbSL1 = parcelRequire("cbSL1");

var $FoFt2 = parcelRequire("FoFt2");

var $3aPI4 = parcelRequire("3aPI4");
const $5d532ff440b5b275$var$iconWrapperStyle = null;
const $5d532ff440b5b275$var$iconImageStyle = null;
const $5d532ff440b5b275$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkolb4i",
    noLinkAppearanceStyle: "_syaz131l _18u01b66",
    roundImageStyle: "_2rko1rr0"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/design-system/no-html-anchor -- Ignored via go/DSP-18766
const $5d532ff440b5b275$var$LinkAppearance = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1y58 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $5d532ff440b5b275$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (emoji) return emoji;
        if (!icon || typeof icon === 'string') return null;
        return icon;
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $FoFt2.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((errored, testId)=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))));
        if (!icon || typeof icon !== 'string') return null;
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton) {
            if (hasImageErrored) return errored;
            return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                onError: ()=>setHasImageErrored(true),
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $5d532ff440b5b275$var$styles.roundImageStyle
                ])
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $5d532ff440b5b275$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3aPI4.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType,
        hideIconLoadingSkeleton,
        hasImageErrored
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
                // We cannot set the fix font because inline is taking the parent container font size into account.
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                style: {
                    lineHeight: `1`
                },
                xcss: $5d532ff440b5b275$var$styles.iconOuterWrapperStyle,
                testId: "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $5d532ff440b5b275$var$styles.iconEmptyStyle,
                            testId: "icon-empty-wrapper"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testId": "icon-wrapper",
                            className: (0, $hcewu.default)([
                                "_11c81o8v _2rkolb4i _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
                            ]),
                            children: renderIcon(testId)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                style: {
                    color: titleTextColor
                },
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)($5d532ff440b5b275$export$c73a53738ef9e3f, {
            style: {
                color: titleColor
            },
            testId: testId,
            children: [
                link ? /*#__PURE__*/ (0, $gt9Am.jsx)($5d532ff440b5b275$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    className: (0, $hcewu.default)([
                        $5d532ff440b5b275$var$styles.linkStyle
                    ]),
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $5d532ff440b5b275$var$styles.noLinkAppearanceStyle,
                    children: rightSide
                }) : null
            ]
        })
    });
};
const $5d532ff440b5b275$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $5d532ff440b5b275$var$styles.iconTitleWrapperStyle,
        ...props
    });
};

});
parcelRegister("3aPI4", function(module, exports) {
$parcel$export(module.exports, "Shimmer", () => $4025455d45ae9834$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $klP06 = parcelRequire("klP06");
const $4025455d45ae9834$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $4025455d45ae9834$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $klP06.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("klP06", function(module, exports) {
$parcel$export(module.exports, "SpanSkeleton", () => $e1fe181bedc556ac$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $e1fe181bedc556ac$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $e1fe181bedc556ac$var$placeholderShimmer = null;
const $e1fe181bedc556ac$var$appearanceValues = {
    darkGray: {
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $7bb4c1736002a04a$export$c2e91cbeada39b8b)})`
    },
    gray: {
        animation: `var(--ds-skeleton, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
const $e1fe181bedc556ac$var$spanSkeletonStyles = null;
const $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk1cs6",
    blue: "_bfhk1hdx",
    darkGray: "_bfhk1gk7"
};
const $e1fe181bedc556ac$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $e1fe181bedc556ac$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $e1fe181bedc556ac$export$2e2bcd8739ae039 = $e1fe181bedc556ac$export$8f31e4c4a37b8e9c;

});




parcelRegister("hFl6W", function(module, exports) {
$parcel$export(module.exports, "EmbedCardErroredView", () => $35d1688af0eea2fa$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $1NG86 = parcelRequire("1NG86");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");


var $19nmp = parcelRequire("19nmp");

var $05blM = parcelRequire("05blM");
const $35d1688af0eea2fa$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $35d1688af0eea2fa$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $05blM.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
                label: "error-icon"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $35d1688af0eea2fa$var$styles.boxStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).could_not_load_link
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                testId: "err-view-retry",
                spacing: "compact",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).try_again
                })
            })
        ]
    });

});
parcelRegister("05blM", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $5e19ca37647e9fa5$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $5e19ca37647e9fa5$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$f862a410248f4f00, {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$7b360cd785b6c366, {
        ...props
    });
const $5e19ca37647e9fa5$var$sharedBaseFrameStyles = null;
const $5e19ca37647e9fa5$var$sharedFrameStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightTrueStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightFalseStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameStyles = null;
const $5e19ca37647e9fa5$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3k6hx _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rkofajl _1h6d1can _1dqonqa1 _189e1dm9" : "_2rkolb4i _1h6d3acm _1dqonqa1 _189e1dm9",
            "_1reo15vq _18m915vq _1bah1yb4 _16qs1os1",
            className
        ]),
        "data-trello-do-not-use-override": testId,
        children: children
    });
};
const $5e19ca37647e9fa5$var$compactFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsTrueStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsFalseStyles = null;
const $5e19ca37647e9fa5$var$compactFrameAlignStyles = null;
const $5e19ca37647e9fa5$var$compactFrameStyles = null;
const $5e19ca37647e9fa5$var$compactFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3yw9d",
            isSelected && "_2rkofajl _1h6d1can _1dqonqa1 _189e1dm9",
            !isSelected && "_2rkolb4i",
            "_1bah1h6o _4cvr1h6o _bfhkiw92",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("i53U1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cede8882a7ef616$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $hVxRW = parcelRequire("hVxRW");
const $1cede8882a7ef616$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: hostname
            })
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $eJOHy.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $idDkX.toMessage)((0, $19nmp.messages).try_another_account, callToActionMessageKey),
                values: values
            })
        });
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hVxRW.ForbiddenSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $1cede8882a7ef616$export$2e2bcd8739ae039 = $1cede8882a7ef616$var$ForbiddenView;

});
parcelRegister("l22Ft", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe0a8b05351117ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $av9Of = parcelRequire("av9Of");

var $2l8bu = parcelRequire("2l8bu");

var $gegRH = parcelRequire("gegRH");
const $fe0a8b05351117ab$var$containerStyles = null;
const $fe0a8b05351117ab$var$contentStyles = null;
const $fe0a8b05351117ab$var$descriptionStyles = null;
const $fe0a8b05351117ab$var$imageStyles = null;
const $fe0a8b05351117ab$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $eJOHy.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $eJOHy.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": imageTestId,
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ]),
            children: imageUrlOrElement
        });
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-unresolved-container`,
            className: (0, $hcewu.default)([
                "_1e0c11p5 _4t3i1kw7"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
                ]),
                children: [
                    image,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "large",
                        testId: `${testId}-unresolved-title`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        "data-testid": `${testId}-unresolved-description`,
                        className: (0, $hcewu.default)([
                            "_11c82smr _y3gn1h6o"
                        ]),
                        children: description
                    }),
                    button
                ]
            })
        })
    });
};
var $fe0a8b05351117ab$export$2e2bcd8739ae039 = $fe0a8b05351117ab$var$UnresolvedView;

});
parcelRegister("2l8bu", function(module, exports) {
$parcel$export(module.exports, "ExpandedFrame", () => $5f28b71e696600f5$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $k71qx = parcelRequire("k71qx");

var $e3qu2 = parcelRequire("e3qu2");

var $dDP8i = parcelRequire("dDP8i");

var $65oSX = parcelRequire("65oSX");
const $5f28b71e696600f5$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $dDP8i.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    // Note: cleanup fg based on results of prompt_whiteboard_competitor_link experiment
    const CompetitorPromptComponent = CompetitorPrompt && href && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $5f28b71e696600f5$var$styles.leftSection
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.headerIcon
                            ]),
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.tooltipWrapper
                            ]),
                            children: !isPlaceholder && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                                content: text,
                                hideTooltipOnMouseDown: true,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                                    href: href,
                                    onClick: handleClick,
                                    onMouseDown: handleMouseDown,
                                    className: (0, $hcewu.default)([
                                        $5f28b71e696600f5$var$styles.headerAnchor
                                    ]),
                                    children: text
                                })
                            })
                        })
                    ]
                }),
                CompetitorPromptComponent
            ]
        });
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.contentStyle,
                setOverflow && allowScrollBar && $5f28b71e696600f5$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $5f28b71e696600f5$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $5f28b71e696600f5$var$styles.linkWrapper,
            inheritDimensions && $5f28b71e696600f5$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $5f28b71e696600f5$var$styles.linkWrapperSelected,
            showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperInteractiveNotHidden,
            (0, $65oSX.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $5f28b71e696600f5$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mjpb1k _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk18uv _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u92p9",
    linkWrapperBorderAndBackground: "_1tqz7r9e _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgv7r9e _4tpuhp5a _x148kb7n",
    header: "_11c8140y _zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3igktf _1pbykb7n",
    leftSection: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c8140y _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik18uv _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c8140y _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19ity6g5 _2rko12b0 _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1ips",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};

});
parcelRegister("65oSX", function(module, exports) {
$parcel$export(module.exports, "className", () => $11f8274f575811f3$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $11f8274f575811f3$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "Image", () => $11f8274f575811f3$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $11f8274f575811f3$export$2913c0c0b5623090 = 'media-card-frame';
const $11f8274f575811f3$export$8f5a73ba0d077b01 = 32;
const $11f8274f575811f3$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $11f8274f575811f3$export$3e431a229df88919 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $awdRS.default)($11f8274f575811f3$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $11f8274f575811f3$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $awdRS.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gegRH", function(module, exports) {
$parcel$export(module.exports, "ImageIcon", () => $28cc40acfaa5a547$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $2HNHt = parcelRequire("2HNHt");

var $cbSL1 = parcelRequire("cbSL1");

var $65oSX = parcelRequire("65oSX");
const $28cc40acfaa5a547$var$styles = {
    roundedImage: "_2rko1rr0"
};
const $28cc40acfaa5a547$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If url changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) setHasImageErrored(false);
    }, [
        src
    ]);
    const handleError = (0, $eJOHy.useCallback)(()=>{
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) setHasImageErrored(true);
    }, []);
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hasImageErrored) return defaultIcon;
    const LoadedImageComponent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65oSX.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            appearance === 'round' && $28cc40acfaa5a547$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title,
        ...hideLoadingSkeleton && (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? {
            onError: handleError
        } : undefined
    });
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideLoadingSkeleton) return LoadedImageComponent;
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("hVxRW", function(module, exports) {
$parcel$export(module.exports, "ForbiddenSVG", () => $d57be4b9de9beae3$export$f51768a4e7ff128);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $d57be4b9de9beae3$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "49.4199",
                x2: "122.662",
                y1: "59.7673",
                y2: "59.7673",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "0",
                        stopColor: "#0065ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".2188",
                        stopColor: "#0b6cff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".5999",
                        stopColor: "#2780ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "1",
                        stopColor: "#4c9aff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
                fill: "#ff7452"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
                fill: "#344563"
            })
        ]
    });

});


parcelRegister("5RX8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fc831c55b9e606a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $KprKQ = parcelRequire("KprKQ");
const $9fc831c55b9e606a$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $KprKQ.NotFoundSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $9fc831c55b9e606a$export$2e2bcd8739ae039 = $9fc831c55b9e606a$var$NotFoundView;

});
parcelRegister("KprKQ", function(module, exports) {
$parcel$export(module.exports, "NotFoundSVG", () => $8c23d6ed0b92caba$export$80542c1714a314c8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $8c23d6ed0b92caba$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "1316.98",
                        y1: "230.66",
                        x2: "1396.36",
                        y2: "230.66",
                        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6c798f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "170.3",
                        y1: "897.49",
                        x2: "365.15",
                        y2: "897.49",
                        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("title", {
                children: "Search error"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    id: "Objects",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cfd4db",
                            d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_",
                            "data-name": "<Path>",
                            fill: "url(#linear-gradient)",
                            d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#091e42",
                            opacity: 0.1,
                            d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#344563",
                            d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Clipping_Path_",
                            "data-name": "<Clipping Path>",
                            fill: "#deebff",
                            d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_2",
                            "data-name": "<Path>",
                            fill: "#b2d4ff",
                            d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cce0ff",
                            d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "url(#linear-gradient-2)",
                            d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("polygon", {
                            id: "_Path_3",
                            "data-name": "<Path>",
                            fill: "#5e6c84",
                            points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#344563",
                            d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("h9g6U", function(module, exports) {
$parcel$export(module.exports, "EmbedCardResolvedView", () => $367ff287c16eda7a$export$30f3c6c32b384a8b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $av9Of = parcelRequire("av9Of");

var $eGOwo = parcelRequire("eGOwo");

var $58yRG = parcelRequire("58yRG");

var $FoFt2 = parcelRequire("FoFt2");

var $2l8bu = parcelRequire("2l8bu");

var $e3qHE = parcelRequire("e3qHE");

var $gegRH = parcelRequire("gegRH");

var $diXta = parcelRequire("diXta");
const $367ff287c16eda7a$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, extensionKey: extensionKey }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: src,
            default: linkGlyph,
            appearance: (0, $FoFt2.isProfileType)(type) ? 'round' : 'square',
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type,
        hideIconLoadingSkeleton
    ]);
    if ((0, $eGOwo.fg)('ptc-enable-embed-team-smart-links')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $diXta.useEmbedResolvePostMessageListener)({
        url: link,
        embedIframeRef: embedIframeRef
    });
    const themeState = (0, $58yRG.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $FoFt2.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e3qHE.Frame), {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            title: text,
            extensionKey: extensionKey
        })
    });
});

});
parcelRegister("e3qHE", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $32febd87e387ddae$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $FoFt2 = parcelRequire("FoFt2");

var $hprWR = parcelRequire("hprWR");

var $RCgNH = parcelRequire("RCgNH");
function $32febd87e387ddae$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $32febd87e387ddae$var$iframeStyles = null;
const $32febd87e387ddae$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title, extensionKey: extensionKey }, iframeRef)=>{
    (0, $gRw8I.di)((0, $hprWR.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $eJOHy.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $eJOHy.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $eJOHy.useState)(true);
    const ref = (0, $eJOHy.useRef)();
    const mergedRef = $32febd87e387ddae$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $eJOHy.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $eJOHy.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $RCgNH.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: isMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hprWR.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $FoFt2.getIframeSandboxAttribute)(isTrusted),
                title: title,
                extensionKey: extensionKey,
                className: (0, $hcewu.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rkofajl _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});

});
parcelRegister("hprWR", function(module, exports) {
$parcel$export(module.exports, "IFrame", () => $0dab6c672ddaa5a8$export$b32b5f1ee4493319);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3Gkc1 = parcelRequire("3Gkc1");

var $eGOwo = parcelRequire("eGOwo");

var $dxRkJ = parcelRequire("dxRkJ");
const $0dab6c672ddaa5a8$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? (0, $dxRkJ.useConfluencePageData)(props.src || '', extensionKey || '') : undefined;
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Gkc1.Page), {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};

});
parcelRegister("3Gkc1", function(module, exports) {
$parcel$export(module.exports, "Page", () => $a2bc0e1a0c33c2da$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jyZeU = parcelRequire("jyZeU");

var $lWsis = parcelRequire("lWsis");

var $gc6HS = parcelRequire("gc6HS");
const $a2bc0e1a0c33c2da$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lWsis.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gc6HS.Page), {
            ...props
        })
    });

});
parcelRegister("jyZeU", function(module, exports) {
$parcel$export(module.exports, "I18nProvider", () => $bad023223c621c92$export$a54013f0d02a8f82);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");

var $axNrS = parcelRequire("axNrS");
const $bad023223c621c92$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $axNrS.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $eJOHy.useState)();
    const locale = (0, $eJOHy.useMemo)(()=>(0, $axNrS.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $axNrS.DEFAULT_LOCALE),
        children: children
    });
};

});
parcelRegister("axNrS", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $e8050c0da9fad76c$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "normalizeLocale", () => $e8050c0da9fad76c$export$dca0327c9b9c6498);
const $e8050c0da9fad76c$var$DEFAULT_LANGUAGE = 'en';
const $e8050c0da9fad76c$var$DEFAULT_REGION = 'US';
const $e8050c0da9fad76c$export$1af4c7e47ad72f44 = `${$e8050c0da9fad76c$var$DEFAULT_LANGUAGE}-${$e8050c0da9fad76c$var$DEFAULT_REGION}`;
const $e8050c0da9fad76c$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $e8050c0da9fad76c$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $e8050c0da9fad76c$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $e8050c0da9fad76c$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $e8050c0da9fad76c$export$1af4c7e47ad72f44;
};

});


parcelRegister("lWsis", function(module, exports) {
$parcel$export(module.exports, "default", () => $abece4116087a64f$export$2e2bcd8739ae039);

var $3i9VW = parcelRequire("3i9VW");

var $57But = parcelRequire("57But");
const $abece4116087a64f$var$fetchTranslations = async (locale)=>{
    switch(locale){
        case 'en-GB':
            return 0, $3i9VW.default;
        case 'en-US':
        default:
            return 0, $57But.default;
    }
};
var $abece4116087a64f$export$2e2bcd8739ae039 = $abece4116087a64f$var$fetchTranslations;

});
parcelRegister("3i9VW", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a8a32cb4963d4eb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $9a8a32cb4963d4eb$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("57But", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f988a238c590e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $22f988a238c590e1$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});


parcelRegister("gc6HS", function(module, exports) {
$parcel$export(module.exports, "Page", () => $85e32b2256736ca0$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5Mh3y = parcelRequire("5Mh3y");

var $lRq8t = parcelRequire("lRq8t");

var $4eSmy = parcelRequire("4eSmy");

var $6ijO8 = parcelRequire("6ijO8");
const $85e32b2256736ca0$var$ViewComponent = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4eSmy.ViewPage), {
        locale: locale,
        ...props
    });
};
const $85e32b2256736ca0$var$EditComponent = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6ijO8.EditPage), {
        locale: locale,
        ...props
    });
};
const $85e32b2256736ca0$export$6955bcca4cd3539f = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5Mh3y.Page), {
        locale: locale,
        ...props,
        viewComponent: $85e32b2256736ca0$var$ViewComponent,
        editComponent: $85e32b2256736ca0$var$EditComponent
    });
};

});
parcelRegister("5Mh3y", function(module, exports) {
$parcel$export(module.exports, "Page", () => $e1e42838b53dfae8$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $5NuS5 = parcelRequire("5NuS5");

var $7oRxl = parcelRequire("7oRxl");

var $jyZeU = parcelRequire("jyZeU");

var $lzAG1 = parcelRequire("lzAG1");
const $e1e42838b53dfae8$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lzAG1.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {}),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5NuS5.Page), {
                ...props
            })
        })
    });

});
parcelRegister("5NuS5", function(module, exports) {
$parcel$export(module.exports, "Page", () => $b83dd449ca0b36bb$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");

var $9fAcm = parcelRequire("9fAcm");

var $52WL7 = parcelRequire("52WL7");

var $6DF4T = parcelRequire("6DF4T");

var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");
const $b83dd449ca0b36bb$var$EDIT_PAGE_CLOSE = 'edit-page/close';
const $b83dd449ca0b36bb$var$EDIT_PAGE_PUBLISH = 'edit-page/publish';
const $b83dd449ca0b36bb$export$6955bcca4cd3539f = (props)=>{
    const { viewComponent: ViewComponent, editComponent: EditComponent } = props;
    const { mode: mode, allowedFeatures: allowedFeatures, draftShareId: draftShareId, navigationPolicy: navigationPolicy, spaceKey: spaceKey, showFooter: showFooter, ...passThroughProps } = (0, $9fAcm.parsePageProps)(props);
    const { onModeChange: onModeChange } = props;
    const [currentMode, setCurrentMode] = (0, $eJOHy.useState)(mode);
    (0, $eJOHy.useEffect)(()=>{
        setCurrentMode(mode);
    }, [
        mode
    ]);
    const [currentSpaceKey, setCurrentSpaceKey] = (0, $eJOHy.useState)(spaceKey);
    const switchToViewPage = (0, $eJOHy.useCallback)(()=>{
        setCurrentMode((0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
    }, [
        setCurrentMode
    ]);
    const pageNavigationPolicy = (0, $eJOHy.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                /**
				 * Below is for switching from View to Edit and we assume parent product doesn't have this situation in their navigationPolicy.
				 */ if (currentMode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE && (modifiers.routeName === 'EDIT_PAGE_EMBED' || url?.includes('/edit-embed/') && passThroughProps.contentId === modifiers.contentId) && ((0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? passThroughProps.contentId === modifiers.contentId : true)) {
                    setCurrentMode((0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    onModeChange?.((0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        currentMode,
        passThroughProps.contentId,
        navigationPolicy,
        onModeChange
    ]);
    const experienceTracker = (0, $52WL7.useExperienceTracker)();
    (0, $eJOHy.useEffect)(()=>experienceTracker.subscribe((event)=>{
            const { name: name, action: action, attributes: attributes } = event;
            /**
				 * Using experienceTracker, we can switch from Edit to View page.
				 * 1. When the user clicks the Publish button and task success, it can switch to the View page.
				 *    a. If the `publish-modal` is added to the allowedFeatures, the Publish Modal may be used to
				 *          change the spaceKey during publish.
				 *          In that case, a new spaceKey will be added to the success event and tracked here.
				 * 2. If the page is not unpublished draft, when the user clicks Close button and task success, it can switch to the View page.
				 */ const isClosingPublishedEditPage = !draftShareId && name === $b83dd449ca0b36bb$var$EDIT_PAGE_CLOSE;
            const isPublishingDraft = name === $b83dd449ca0b36bb$var$EDIT_PAGE_PUBLISH;
            if (action === 'taskSuccess' && (isClosingPublishedEditPage || isPublishingDraft)) {
                if (allowedFeatures.edit?.includes('publish-modal')) {
                    const newSpaceKey = attributes?.newSpaceKey;
                    setCurrentSpaceKey(newSpaceKey || spaceKey);
                }
                switchToViewPage();
            }
        }), [
        draftShareId,
        experienceTracker,
        switchToViewPage,
        allowedFeatures.edit,
        spaceKey
    ]);
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40f0Z.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: currentMode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE ? /*#__PURE__*/ (0, $gt9Am.jsx)(ViewComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.view,
            locale: locale,
            spaceKey: currentSpaceKey,
            showFooter: showFooter,
            ...passThroughProps
        }) : currentMode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? /*#__PURE__*/ (0, $gt9Am.jsx)(EditComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.edit,
            draftShareId: draftShareId,
            locale: locale,
            spaceKey: currentSpaceKey,
            ...passThroughProps
        }) : null
    });
};

});
parcelRegister("9fAcm", function(module, exports) {
$parcel$export(module.exports, "parsePageProps", () => $e9b8e0d00fbd3627$export$41eb0a358b69a9df);
$parcel$export(module.exports, "parseUrl", () => $e9b8e0d00fbd3627$export$7a5253c0f62e0150);
parcelRequire("dtqUA");
var $ddbcJ = parcelRequire("ddbcJ");

var $4CCpn = parcelRequire("4CCpn");

var $8HgDC = parcelRequire("8HgDC");

var $6DF4T = parcelRequire("6DF4T");

var $3V5nR = parcelRequire("3V5nR");
function $e9b8e0d00fbd3627$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, showFooter: showFooter, ...passThroughProps } = props;
    const parsedAllowedFeatures = $e9b8e0d00fbd3627$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const parsedProps = $e9b8e0d00fbd3627$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $4CCpn.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    const previewPanels = $e9b8e0d00fbd3627$var$parseQueryParam(parsedProps.query, 'previewPanels');
    // Override with URL-extracted props
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct || '';
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $3V5nR.VIEW_PAGE).name:
        case (0, $3V5nR.VIEW_BLOG).name:
        case (0, $3V5nR.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $3V5nR.EDIT_PAGE_EMBED).name:
        case (0, $3V5nR.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
            break;
        case (0, $3V5nR.WHITEBOARD).name:
    }
    const contentSlug = parsedProps.route === (0, $3V5nR.VIEW_BLOG_DATE_LEGACY).name ? undefined : parsedProps.contentSlug;
    return {
        allowedFeatures: parsedAllowedFeatures,
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        contentSlug: contentSlug,
        showFooter: showFooter,
        previewPanels: previewPanels,
        ...passThroughProps
    };
}
function $e9b8e0d00fbd3627$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $e9b8e0d00fbd3627$var$findAndMatchRoute((0, $3V5nR.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    const { year: year, month: month, day: day, contentId: contentId } = match.params;
    // Validate date parameters
    const isValidYear = /^\d+$/.test(year || '');
    const isValidMonth = /^\d+$/.test(month || '');
    const isValidDay = /^\d+$/.test(day || '');
    const isValidContentId = /^\d+$/.test(contentId || '');
    // If route requires validation, and any parameter is invalid, return null
    if (routeName === (0, $3V5nR.VIEW_BLOG_DATE_LEGACY).name && (!isValidYear || !isValidMonth || !isValidDay || !isValidContentId)) return null;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash || '',
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState,
        contentSlug: match.params.contentSlug || undefined,
        query: match.query
    };
}
function $e9b8e0d00fbd3627$var$findAndMatchRoute(routes, url) {
    for (const routeKey of Object.keys(routes)){
        const route = routes[routeKey];
        const match = $e9b8e0d00fbd3627$var$matchUrl(route.pattern, url);
        if (match) return {
            routeName: route.name,
            ...match
        };
    }
    return null;
}
function $e9b8e0d00fbd3627$var$isValidURL(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch  {
        return false;
    }
}
function $e9b8e0d00fbd3627$var$matchUrl(pattern, url) {
    if (!$e9b8e0d00fbd3627$var$isValidURL(url)) return null;
    const parsed = new URL(url, window.location.origin);
    const pathname = parsed.pathname || '';
    const search = parsed.search || '';
    let match = (0, $ddbcJ.matchPath)({
        path: pattern,
        end: true
    }, pathname);
    // If initial match fails and the route requires query parameters, attempt to match including search
    // some of our routes need query params to match
    if (!match && search) match = (0, $ddbcJ.matchPath)({
        path: pattern,
        end: true
    }, `${pathname}${search}`);
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) {
        for (const [key, value] of Object.entries(match.params))if (value !== undefined) decodedParams[key] = value;
    }
    return {
        url: url,
        protocol: parsed.protocol,
        host: parsed.host,
        pathname: pathname,
        search: parsed.search,
        hash: parsed.hash,
        pattern: pattern,
        params: decodedParams,
        query: Object.fromEntries(parsed.searchParams.entries())
    };
}
function $e9b8e0d00fbd3627$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $8HgDC.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}
function $e9b8e0d00fbd3627$var$parseQueryParam(query, keyName) {
    for (const [key, value] of Object.entries(query)){
        if (key === keyName) return Array.isArray(value) ? value.join(',') : value;
    }
    return undefined;
}

});
parcelRegister("dtqUA", function(module, exports) {
$parcel$export(module.exports, "matchPath", () => (parcelRequire("ddbcJ")).matchPath);
/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ddbcJ = parcelRequire("ddbcJ");
function $9cf2dbeb7d470256$var$_extends() {
    $9cf2dbeb7d470256$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9cf2dbeb7d470256$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $9cf2dbeb7d470256$export$3add0d5dce533e2e = /*#__PURE__*/ $eJOHy.createContext(null);
const $9cf2dbeb7d470256$export$145dfa71566a64dc = /*#__PURE__*/ $eJOHy.createContext(null);
const $9cf2dbeb7d470256$var$AwaitContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $9cf2dbeb7d470256$export$26749e8557646306 = /*#__PURE__*/ $eJOHy.createContext(null);
const $9cf2dbeb7d470256$export$c7914228fb69b0f5 = /*#__PURE__*/ $eJOHy.createContext(null);
const $9cf2dbeb7d470256$export$9072aa6dd1f93057 = /*#__PURE__*/ $eJOHy.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $9cf2dbeb7d470256$var$RouteErrorContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $9cf2dbeb7d470256$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $9cf2dbeb7d470256$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $ddbcJ.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $9cf2dbeb7d470256$export$9c954a9d03d32f4a() {
    return $eJOHy.useContext($9cf2dbeb7d470256$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $9cf2dbeb7d470256$export$45d76561a5302f2b() {
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    return $eJOHy.useContext($9cf2dbeb7d470256$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $9cf2dbeb7d470256$export$1b3f31771c5d07c() {
    return $eJOHy.useContext($9cf2dbeb7d470256$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $9cf2dbeb7d470256$export$6c330e8992e8a295(pattern) {
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { pathname: pathname } = $9cf2dbeb7d470256$export$45d76561a5302f2b();
    return $eJOHy.useMemo(()=>(0, $ddbcJ.matchPath)(pattern, (0, $ddbcJ.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $9cf2dbeb7d470256$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $9cf2dbeb7d470256$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eJOHy.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $9cf2dbeb7d470256$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $9cf2dbeb7d470256$var$useNavigateStable() : $9cf2dbeb7d470256$var$useNavigateUnstable();
}
function $9cf2dbeb7d470256$var$useNavigateUnstable() {
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let dataRouterContext = $eJOHy.useContext($9cf2dbeb7d470256$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9cf2dbeb7d470256$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $eJOHy.useRef(false);
    $9cf2dbeb7d470256$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eJOHy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $ddbcJ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ddbcJ.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $9cf2dbeb7d470256$var$OutletContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $9cf2dbeb7d470256$export$4138103a3ae699cc() {
    return $eJOHy.useContext($9cf2dbeb7d470256$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $9cf2dbeb7d470256$export$a3be3530d8e40d0b(context) {
    let outlet = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $9cf2dbeb7d470256$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $9cf2dbeb7d470256$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9cf2dbeb7d470256$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $eJOHy.useMemo(()=>(0, $ddbcJ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $9cf2dbeb7d470256$export$5d3fca4a98652595(routes, locationArg) {
    return $9cf2dbeb7d470256$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $9cf2dbeb7d470256$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { navigator: navigator } = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306);
    let { matches: parentMatches } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $9cf2dbeb7d470256$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $ddbcJ.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $ddbcJ.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $ddbcJ.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $9cf2dbeb7d470256$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $ddbcJ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $ddbcJ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $9cf2dbeb7d470256$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $ddbcJ.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $9cf2dbeb7d470256$var$DefaultErrorComponent() {
    let error = $9cf2dbeb7d470256$export$ed527bf60f6e05f2();
    let message = (0, $ddbcJ.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, /*#__PURE__*/ $eJOHy.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eJOHy.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eJOHy.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $9cf2dbeb7d470256$var$defaultErrorElement = /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$DefaultErrorComponent, null);
class $9cf2dbeb7d470256$var$RenderErrorBoundary extends $eJOHy.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $9cf2dbeb7d470256$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eJOHy.useContext($9cf2dbeb7d470256$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $9cf2dbeb7d470256$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $ddbcJ.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $9cf2dbeb7d470256$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $9cf2dbeb7d470256$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eJOHy.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $9cf2dbeb7d470256$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($9cf2dbeb7d470256$var$DataRouterHook || {});
var $9cf2dbeb7d470256$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($9cf2dbeb7d470256$var$DataRouterStateHook || {});
function $9cf2dbeb7d470256$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $9cf2dbeb7d470256$var$useDataRouterContext(hookName) {
    let ctx = $eJOHy.useContext($9cf2dbeb7d470256$export$3add0d5dce533e2e);
    !ctx && (0, $ddbcJ.UNSAFE_invariant)(false);
    return ctx;
}
function $9cf2dbeb7d470256$var$useDataRouterState(hookName) {
    let state = $eJOHy.useContext($9cf2dbeb7d470256$export$145dfa71566a64dc);
    !state && (0, $ddbcJ.UNSAFE_invariant)(false);
    return state;
}
function $9cf2dbeb7d470256$var$useRouteContext(hookName) {
    let route = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    !route && (0, $ddbcJ.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $9cf2dbeb7d470256$var$useCurrentRouteId(hookName) {
    let route = $9cf2dbeb7d470256$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $ddbcJ.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $9cf2dbeb7d470256$export$5fc8298006ad9e58() {
    return $9cf2dbeb7d470256$var$useCurrentRouteId($9cf2dbeb7d470256$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $9cf2dbeb7d470256$export$d0fd4b7106de2769() {
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $9cf2dbeb7d470256$export$600dc272ed516c15() {
    let dataRouterContext = $9cf2dbeb7d470256$var$useDataRouterContext($9cf2dbeb7d470256$var$DataRouterHook.UseRevalidator);
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseRevalidator);
    return $eJOHy.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $9cf2dbeb7d470256$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseMatches);
    return $eJOHy.useMemo(()=>matches.map((m)=>(0, $ddbcJ.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $9cf2dbeb7d470256$export$1448a5050d252c4d() {
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseLoaderData);
    let routeId = $9cf2dbeb7d470256$var$useCurrentRouteId($9cf2dbeb7d470256$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $9cf2dbeb7d470256$export$fd5d37484eab868d(routeId) {
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $9cf2dbeb7d470256$export$fdc00f3f26066d5e() {
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseActionData);
    let routeId = $9cf2dbeb7d470256$var$useCurrentRouteId($9cf2dbeb7d470256$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $9cf2dbeb7d470256$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eJOHy.useContext($9cf2dbeb7d470256$var$RouteErrorContext);
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseRouteError);
    let routeId = $9cf2dbeb7d470256$var$useCurrentRouteId($9cf2dbeb7d470256$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $9cf2dbeb7d470256$export$78a72ddb39bdd145() {
    let value = $eJOHy.useContext($9cf2dbeb7d470256$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $9cf2dbeb7d470256$export$17f53340677d5831() {
    let value = $eJOHy.useContext($9cf2dbeb7d470256$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $9cf2dbeb7d470256$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $9cf2dbeb7d470256$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $9cf2dbeb7d470256$var$useDataRouterContext($9cf2dbeb7d470256$var$DataRouterHook.UseBlocker);
    let state = $9cf2dbeb7d470256$var$useDataRouterState($9cf2dbeb7d470256$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $eJOHy.useState("");
    let blockerFunction = $eJOHy.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $9cf2dbeb7d470256$var$_extends({}, currentLocation, {
                pathname: (0, $ddbcJ.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $9cf2dbeb7d470256$var$_extends({}, nextLocation, {
                pathname: (0, $ddbcJ.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eJOHy.useEffect(()=>{
        let key = String(++$9cf2dbeb7d470256$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eJOHy.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $ddbcJ.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $9cf2dbeb7d470256$var$useNavigateStable() {
    let { router: router } = $9cf2dbeb7d470256$var$useDataRouterContext($9cf2dbeb7d470256$var$DataRouterHook.UseNavigateStable);
    let id = $9cf2dbeb7d470256$var$useCurrentRouteId($9cf2dbeb7d470256$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $eJOHy.useRef(false);
    $9cf2dbeb7d470256$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eJOHy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $9cf2dbeb7d470256$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $9cf2dbeb7d470256$var$alreadyWarned$1 = {};
function $9cf2dbeb7d470256$var$warningOnce(key, cond, message) {
    if (!cond && !$9cf2dbeb7d470256$var$alreadyWarned$1[key]) $9cf2dbeb7d470256$var$alreadyWarned$1[key] = true;
}
const $9cf2dbeb7d470256$var$alreadyWarned = {};
function $9cf2dbeb7d470256$var$warnOnce(key, message) {
    if (!$9cf2dbeb7d470256$var$alreadyWarned[message]) {
        $9cf2dbeb7d470256$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $9cf2dbeb7d470256$var$logDeprecation = (flag, msg, link)=>$9cf2dbeb7d470256$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $9cf2dbeb7d470256$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $9cf2dbeb7d470256$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $9cf2dbeb7d470256$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $9cf2dbeb7d470256$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $9cf2dbeb7d470256$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $9cf2dbeb7d470256$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $9cf2dbeb7d470256$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $9cf2dbeb7d470256$var$START_TRANSITION = "startTransition";
const $9cf2dbeb7d470256$var$startTransitionImpl = $eJOHy[$9cf2dbeb7d470256$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $9cf2dbeb7d470256$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eJOHy.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eJOHy.useCallback((newState)=>{
        if (v7_startTransition && $9cf2dbeb7d470256$var$startTransitionImpl) $9cf2dbeb7d470256$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eJOHy.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eJOHy.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eJOHy.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eJOHy.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $eJOHy.useEffect(()=>$9cf2dbeb7d470256$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $9cf2dbeb7d470256$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $9cf2dbeb7d470256$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $9cf2dbeb7d470256$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $eJOHy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ddbcJ.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eJOHy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eJOHy.useCallback((newState)=>{
        v7_startTransition && $9cf2dbeb7d470256$var$startTransitionImpl ? $9cf2dbeb7d470256$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eJOHy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eJOHy.useEffect(()=>$9cf2dbeb7d470256$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $9cf2dbeb7d470256$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $eJOHy.useContext($9cf2dbeb7d470256$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($9cf2dbeb7d470256$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9cf2dbeb7d470256$export$45d76561a5302f2b();
    let navigate = $9cf2dbeb7d470256$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $ddbcJ.resolveTo)(to, (0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eJOHy.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $9cf2dbeb7d470256$export$910ae8079b2c2852(props) {
    return $9cf2dbeb7d470256$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $9cf2dbeb7d470256$export$e7b0ac011bb776c6(_props) {
    (0, $ddbcJ.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $9cf2dbeb7d470256$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $ddbcJ.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$9cf2dbeb7d470256$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eJOHy.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $9cf2dbeb7d470256$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $ddbcJ.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eJOHy.useMemo(()=>{
        let trailingPathname = (0, $ddbcJ.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $9cf2dbeb7d470256$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $9cf2dbeb7d470256$export$5d3fca4a98652595($9cf2dbeb7d470256$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $9cf2dbeb7d470256$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$ResolveAwait, null, children));
}
var $9cf2dbeb7d470256$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($9cf2dbeb7d470256$var$AwaitRenderStatus || {});
const $9cf2dbeb7d470256$var$neverSettledPromise = new Promise(()=>{});
class $9cf2dbeb7d470256$var$AwaitErrorBoundary extends $eJOHy.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $9cf2dbeb7d470256$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $9cf2dbeb7d470256$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $9cf2dbeb7d470256$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $9cf2dbeb7d470256$var$AwaitRenderStatus.error : "_data" in promise ? $9cf2dbeb7d470256$var$AwaitRenderStatus.success : $9cf2dbeb7d470256$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $9cf2dbeb7d470256$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $9cf2dbeb7d470256$var$AwaitRenderStatus.error && promise._error instanceof (0, $ddbcJ.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $9cf2dbeb7d470256$var$neverSettledPromise;
        if (status === $9cf2dbeb7d470256$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $9cf2dbeb7d470256$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $9cf2dbeb7d470256$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eJOHy.createElement($9cf2dbeb7d470256$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $9cf2dbeb7d470256$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $9cf2dbeb7d470256$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $9cf2dbeb7d470256$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eJOHy.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eJOHy.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eJOHy.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $9cf2dbeb7d470256$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $9cf2dbeb7d470256$export$e7b0ac011bb776c6) && (0, $ddbcJ.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $ddbcJ.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $9cf2dbeb7d470256$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $9cf2dbeb7d470256$export$daf73786167a7f72(matches) {
    return $9cf2dbeb7d470256$var$_renderMatches(matches);
}
function $9cf2dbeb7d470256$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $eJOHy.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $eJOHy.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $eJOHy.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $9cf2dbeb7d470256$export$f30f7e456d254e83(routes, opts) {
    return (0, $ddbcJ.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $9cf2dbeb7d470256$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ddbcJ.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $9cf2dbeb7d470256$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("ddbcJ", function(module, exports) {
$parcel$export(module.exports, "Action", () => $99e52e32e89932ac$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $99e52e32e89932ac$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $99e52e32e89932ac$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $99e52e32e89932ac$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "UNSAFE_invariant", () => $99e52e32e89932ac$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $99e52e32e89932ac$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $99e52e32e89932ac$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $99e52e32e89932ac$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $99e52e32e89932ac$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $99e52e32e89932ac$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $99e52e32e89932ac$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $99e52e32e89932ac$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $99e52e32e89932ac$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $99e52e32e89932ac$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "isRouteErrorResponse", () => $99e52e32e89932ac$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $99e52e32e89932ac$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $99e52e32e89932ac$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $99e52e32e89932ac$var$_extends() {
    $99e52e32e89932ac$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $99e52e32e89932ac$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $99e52e32e89932ac$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($99e52e32e89932ac$export$e19cd5f9376f8cee || ($99e52e32e89932ac$export$e19cd5f9376f8cee = {}));
const $99e52e32e89932ac$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $99e52e32e89932ac$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $99e52e32e89932ac$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $99e52e32e89932ac$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $99e52e32e89932ac$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $99e52e32e89932ac$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
    }
    return $99e52e32e89932ac$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $99e52e32e89932ac$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $99e52e32e89932ac$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $99e52e32e89932ac$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $99e52e32e89932ac$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $99e52e32e89932ac$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $99e52e32e89932ac$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $99e52e32e89932ac$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $99e52e32e89932ac$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $99e52e32e89932ac$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $99e52e32e89932ac$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $99e52e32e89932ac$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $99e52e32e89932ac$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $99e52e32e89932ac$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $99e52e32e89932ac$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $99e52e32e89932ac$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($99e52e32e89932ac$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        let location = $99e52e32e89932ac$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $99e52e32e89932ac$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        let location = $99e52e32e89932ac$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $99e52e32e89932ac$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $99e52e32e89932ac$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($99e52e32e89932ac$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($99e52e32e89932ac$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $99e52e32e89932ac$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($99e52e32e89932ac$var$ResultType || ($99e52e32e89932ac$var$ResultType = {}));
const $99e52e32e89932ac$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $99e52e32e89932ac$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $99e52e32e89932ac$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $99e52e32e89932ac$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $99e52e32e89932ac$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($99e52e32e89932ac$var$isIndexRoute(route)) {
            let indexRoute = $99e52e32e89932ac$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $99e52e32e89932ac$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $99e52e32e89932ac$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $99e52e32e89932ac$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $99e52e32e89932ac$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $99e52e32e89932ac$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $99e52e32e89932ac$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $99e52e32e89932ac$var$flattenRoutes(routes);
    $99e52e32e89932ac$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $99e52e32e89932ac$export$30d21fd6d7295f52(pathname);
        matches = $99e52e32e89932ac$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $99e52e32e89932ac$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $99e52e32e89932ac$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $99e52e32e89932ac$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $99e52e32e89932ac$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $99e52e32e89932ac$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $99e52e32e89932ac$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $99e52e32e89932ac$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $99e52e32e89932ac$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $99e52e32e89932ac$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $99e52e32e89932ac$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $99e52e32e89932ac$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $99e52e32e89932ac$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $99e52e32e89932ac$var$paramRe = /^:[\w-]+$/;
const $99e52e32e89932ac$var$dynamicSegmentValue = 3;
const $99e52e32e89932ac$var$indexRouteValue = 2;
const $99e52e32e89932ac$var$emptySegmentValue = 1;
const $99e52e32e89932ac$var$staticSegmentValue = 10;
const $99e52e32e89932ac$var$splatPenalty = -2;
const $99e52e32e89932ac$var$isSplat = (s)=>s === "*";
function $99e52e32e89932ac$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($99e52e32e89932ac$var$isSplat)) initialScore += $99e52e32e89932ac$var$splatPenalty;
    if (index) initialScore += $99e52e32e89932ac$var$indexRouteValue;
    return segments.filter((s)=>!$99e52e32e89932ac$var$isSplat(s)).reduce((score, segment)=>score + ($99e52e32e89932ac$var$paramRe.test(segment) ? $99e52e32e89932ac$var$dynamicSegmentValue : segment === "" ? $99e52e32e89932ac$var$emptySegmentValue : $99e52e32e89932ac$var$staticSegmentValue), initialScore);
}
function $99e52e32e89932ac$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $99e52e32e89932ac$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $99e52e32e89932ac$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $99e52e32e89932ac$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $99e52e32e89932ac$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $99e52e32e89932ac$export$a5c6d149b50c1d86($99e52e32e89932ac$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $99e52e32e89932ac$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $99e52e32e89932ac$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $99e52e32e89932ac$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $99e52e32e89932ac$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $99e52e32e89932ac$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $99e52e32e89932ac$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $99e52e32e89932ac$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $99e52e32e89932ac$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $99e52e32e89932ac$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $99e52e32e89932ac$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $99e52e32e89932ac$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $99e52e32e89932ac$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $99e52e32e89932ac$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $99e52e32e89932ac$var$normalizeSearch(search),
        hash: $99e52e32e89932ac$var$normalizeHash(hash)
    };
}
function $99e52e32e89932ac$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $99e52e32e89932ac$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $99e52e32e89932ac$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $99e52e32e89932ac$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $99e52e32e89932ac$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $99e52e32e89932ac$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $99e52e32e89932ac$export$8ccf933b0513f8d0(toArg);
    else {
        to = $99e52e32e89932ac$var$_extends({}, toArg);
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $99e52e32e89932ac$var$getInvalidPathError("?", "pathname", "search", to));
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $99e52e32e89932ac$var$getInvalidPathError("#", "pathname", "hash", to));
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $99e52e32e89932ac$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $99e52e32e89932ac$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $99e52e32e89932ac$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $99e52e32e89932ac$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $99e52e32e89932ac$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $99e52e32e89932ac$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $99e52e32e89932ac$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $99e52e32e89932ac$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $99e52e32e89932ac$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $99e52e32e89932ac$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $99e52e32e89932ac$export$4051a07651545597(data, init) {
    return new $99e52e32e89932ac$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $99e52e32e89932ac$export$42a99a7a4bc0e76a extends Error {
}
class $99e52e32e89932ac$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $99e52e32e89932ac$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $99e52e32e89932ac$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $99e52e32e89932ac$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $99e52e32e89932ac$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $99e52e32e89932ac$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $99e52e32e89932ac$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $99e52e32e89932ac$var$unwrapTrackedPromise(value) {
    if (!$99e52e32e89932ac$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $99e52e32e89932ac$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $99e52e32e89932ac$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $99e52e32e89932ac$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $99e52e32e89932ac$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $99e52e32e89932ac$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $99e52e32e89932ac$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $99e52e32e89932ac$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $99e52e32e89932ac$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $99e52e32e89932ac$var$validMutationMethods = new Set($99e52e32e89932ac$var$validMutationMethodsArr);
const $99e52e32e89932ac$var$validRequestMethodsArr = [
    "get",
    ...$99e52e32e89932ac$var$validMutationMethodsArr
];
const $99e52e32e89932ac$var$validRequestMethods = new Set($99e52e32e89932ac$var$validRequestMethodsArr);
const $99e52e32e89932ac$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $99e52e32e89932ac$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $99e52e32e89932ac$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $99e52e32e89932ac$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $99e52e32e89932ac$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $99e52e32e89932ac$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $99e52e32e89932ac$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $99e52e32e89932ac$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $99e52e32e89932ac$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $99e52e32e89932ac$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $99e52e32e89932ac$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $99e52e32e89932ac$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$99e52e32e89932ac$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$99e52e32e89932ac$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $99e52e32e89932ac$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $99e52e32e89932ac$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $99e52e32e89932ac$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $99e52e32e89932ac$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$99e52e32e89932ac$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($99e52e32e89932ac$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $99e52e32e89932ac$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $99e52e32e89932ac$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $99e52e32e89932ac$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $99e52e32e89932ac$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $99e52e32e89932ac$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($99e52e32e89932ac$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $99e52e32e89932ac$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $99e52e32e89932ac$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $99e52e32e89932ac$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $99e52e32e89932ac$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $99e52e32e89932ac$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $99e52e32e89932ac$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $99e52e32e89932ac$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $99e52e32e89932ac$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $99e52e32e89932ac$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $99e52e32e89932ac$var$findNearestBoundary(matches).route.id,
            {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $99e52e32e89932ac$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($99e52e32e89932ac$var$isErrorResult(result) && $99e52e32e89932ac$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $99e52e32e89932ac$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $99e52e32e89932ac$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $99e52e32e89932ac$var$_extends({
            matches: updatedMatches || matches
        }, $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $99e52e32e89932ac$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $99e52e32e89932ac$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $99e52e32e89932ac$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $99e52e32e89932ac$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $99e52e32e89932ac$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($99e52e32e89932ac$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $99e52e32e89932ac$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($99e52e32e89932ac$var$isDeferredResult(result)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $99e52e32e89932ac$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $99e52e32e89932ac$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($99e52e32e89932ac$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $99e52e32e89932ac$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $99e52e32e89932ac$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $99e52e32e89932ac$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $99e52e32e89932ac$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $99e52e32e89932ac$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $99e52e32e89932ac$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $99e52e32e89932ac$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$99e52e32e89932ac$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $99e52e32e89932ac$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $99e52e32e89932ac$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $99e52e32e89932ac$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $99e52e32e89932ac$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $99e52e32e89932ac$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $99e52e32e89932ac$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($99e52e32e89932ac$var$isRedirectResult(actionResult) || $99e52e32e89932ac$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($99e52e32e89932ac$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $99e52e32e89932ac$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($99e52e32e89932ac$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($99e52e32e89932ac$var$isDeferredResult(actionResult)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $99e52e32e89932ac$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $99e52e32e89932ac$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $99e52e32e89932ac$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $99e52e32e89932ac$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $99e52e32e89932ac$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $99e52e32e89932ac$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $99e52e32e89932ac$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $99e52e32e89932ac$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $99e52e32e89932ac$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $99e52e32e89932ac$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($99e52e32e89932ac$var$isDeferredResult(result)) result = await $99e52e32e89932ac$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($99e52e32e89932ac$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $99e52e32e89932ac$export$3e9cee6b33872309(!$99e52e32e89932ac$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $99e52e32e89932ac$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $99e52e32e89932ac$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $99e52e32e89932ac$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $99e52e32e89932ac$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace : $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $99e52e32e89932ac$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($99e52e32e89932ac$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $99e52e32e89932ac$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $99e52e32e89932ac$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $99e52e32e89932ac$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $99e52e32e89932ac$var$ResultType.redirect,
                response: $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $99e52e32e89932ac$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: $99e52e32e89932ac$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $99e52e32e89932ac$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $99e52e32e89932ac$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $99e52e32e89932ac$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $99e52e32e89932ac$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $99e52e32e89932ac$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $99e52e32e89932ac$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $99e52e32e89932ac$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $99e52e32e89932ac$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $99e52e32e89932ac$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $99e52e32e89932ac$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$99e52e32e89932ac$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $99e52e32e89932ac$export$4d0306f8f6a4585b = Symbol("deferred");
function $99e52e32e89932ac$export$3336b097a6fbc59a(routes, opts) {
    $99e52e32e89932ac$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $99e52e32e89932ac$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $99e52e32e89932ac$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $99e52e32e89932ac$var$createLocation("", $99e52e32e89932ac$export$fe53371bee54353d(url), null, "default");
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$99e52e32e89932ac$var$isValidMethod(method) && method !== "HEAD") {
            let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($99e52e32e89932ac$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $99e52e32e89932ac$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $99e52e32e89932ac$var$createLocation("", $99e52e32e89932ac$export$fe53371bee54353d(url), null, "default");
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$99e52e32e89932ac$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $99e52e32e89932ac$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $99e52e32e89932ac$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $99e52e32e89932ac$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($99e52e32e89932ac$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$99e52e32e89932ac$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $99e52e32e89932ac$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($99e52e32e89932ac$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $99e52e32e89932ac$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $99e52e32e89932ac$var$isResponse(result) ? result : $99e52e32e89932ac$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($99e52e32e89932ac$var$isDataStrategyResult(e) && $99e52e32e89932ac$var$isResponse(e.result)) {
                if (e.type === $99e52e32e89932ac$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($99e52e32e89932ac$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($99e52e32e89932ac$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($99e52e32e89932ac$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $99e52e32e89932ac$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $99e52e32e89932ac$var$_extends({}, context, {
                statusCode: $99e52e32e89932ac$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $99e52e32e89932ac$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $99e52e32e89932ac$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $99e52e32e89932ac$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategy || $99e52e32e89932ac$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($99e52e32e89932ac$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $99e52e32e89932ac$export$fec11da027c70692(routes, context, error) {
    let newContext = $99e52e32e89932ac$var$_extends({}, context, {
        statusCode: $99e52e32e89932ac$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $99e52e32e89932ac$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $99e52e32e89932ac$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $99e52e32e89932ac$export$cae722b0cc860f13(to ? to : ".", $99e52e32e89932ac$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $99e52e32e89932ac$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $99e52e32e89932ac$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $99e52e32e89932ac$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $99e52e32e89932ac$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $99e52e32e89932ac$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$99e52e32e89932ac$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$99e52e32e89932ac$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $99e52e32e89932ac$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $99e52e32e89932ac$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $99e52e32e89932ac$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$99e52e32e89932ac$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$99e52e32e89932ac$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $99e52e32e89932ac$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $99e52e32e89932ac$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $99e52e32e89932ac$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $99e52e32e89932ac$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $99e52e32e89932ac$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $99e52e32e89932ac$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $99e52e32e89932ac$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $99e52e32e89932ac$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($99e52e32e89932ac$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $99e52e32e89932ac$var$shouldRevalidateLoader(match, $99e52e32e89932ac$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $99e52e32e89932ac$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $99e52e32e89932ac$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $99e52e32e89932ac$var$shouldRevalidateLoader(fetcherMatch, $99e52e32e89932ac$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $99e52e32e89932ac$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $99e52e32e89932ac$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $99e52e32e89932ac$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $99e52e32e89932ac$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $99e52e32e89932ac$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$99e52e32e89932ac$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $99e52e32e89932ac$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$99e52e32e89932ac$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $99e52e32e89932ac$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $99e52e32e89932ac$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $99e52e32e89932ac$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$99e52e32e89932ac$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $99e52e32e89932ac$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $99e52e32e89932ac$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $99e52e32e89932ac$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $99e52e32e89932ac$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $99e52e32e89932ac$var$ResultType.data,
                result: undefined
            });
        };
        return $99e52e32e89932ac$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $99e52e32e89932ac$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $99e52e32e89932ac$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $99e52e32e89932ac$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $99e52e32e89932ac$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($99e52e32e89932ac$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: e
            };
        }
        if (type === $99e52e32e89932ac$var$ResultType.error) return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: new $99e52e32e89932ac$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $99e52e32e89932ac$var$ResultType.error) {
        if ($99e52e32e89932ac$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $99e52e32e89932ac$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: result,
            statusCode: $99e52e32e89932ac$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($99e52e32e89932ac$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $99e52e32e89932ac$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($99e52e32e89932ac$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $99e52e32e89932ac$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $99e52e32e89932ac$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $99e52e32e89932ac$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $99e52e32e89932ac$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $99e52e32e89932ac$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $99e52e32e89932ac$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($99e52e32e89932ac$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $99e52e32e89932ac$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $99e52e32e89932ac$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $99e52e32e89932ac$export$3e9cee6b33872309(!$99e52e32e89932ac$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $99e52e32e89932ac$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $99e52e32e89932ac$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $99e52e32e89932ac$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($99e52e32e89932ac$var$isErrorResult(result)) {
            let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $99e52e32e89932ac$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($99e52e32e89932ac$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $99e52e32e89932ac$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($99e52e32e89932ac$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $99e52e32e89932ac$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $99e52e32e89932ac$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $99e52e32e89932ac$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $99e52e32e89932ac$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $99e52e32e89932ac$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $99e52e32e89932ac$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $99e52e32e89932ac$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $99e52e32e89932ac$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($99e52e32e89932ac$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $99e52e32e89932ac$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(path) : path;
    return $99e52e32e89932ac$export$fe53371bee54353d($99e52e32e89932ac$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $99e52e32e89932ac$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $99e52e32e89932ac$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $99e52e32e89932ac$var$ResultType.data || result.type === $99e52e32e89932ac$var$ResultType.error);
}
function $99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result) {
    return $99e52e32e89932ac$var$isResponse(result.result) && $99e52e32e89932ac$var$redirectStatusCodes.has(result.result.status);
}
function $99e52e32e89932ac$var$isDeferredResult(result) {
    return result.type === $99e52e32e89932ac$var$ResultType.deferred;
}
function $99e52e32e89932ac$var$isErrorResult(result) {
    return result.type === $99e52e32e89932ac$var$ResultType.error;
}
function $99e52e32e89932ac$var$isRedirectResult(result) {
    return (result && result.type) === $99e52e32e89932ac$var$ResultType.redirect;
}
function $99e52e32e89932ac$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $99e52e32e89932ac$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $99e52e32e89932ac$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $99e52e32e89932ac$var$isRedirectResponse(result) {
    if (!$99e52e32e89932ac$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $99e52e32e89932ac$var$isValidMethod(method) {
    return $99e52e32e89932ac$var$validRequestMethods.has(method.toLowerCase());
}
function $99e52e32e89932ac$var$isMutationMethod(method) {
    return $99e52e32e89932ac$var$validMutationMethods.has(method.toLowerCase());
}
async function $99e52e32e89932ac$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$99e52e32e89932ac$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($99e52e32e89932ac$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $99e52e32e89932ac$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $99e52e32e89932ac$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $99e52e32e89932ac$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $99e52e32e89932ac$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $99e52e32e89932ac$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $99e52e32e89932ac$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $99e52e32e89932ac$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $99e52e32e89932ac$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $99e52e32e89932ac$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $99e52e32e89932ac$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $99e52e32e89932ac$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $99e52e32e89932ac$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $99e52e32e89932ac$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $99e52e32e89932ac$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $99e52e32e89932ac$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $99e52e32e89932ac$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $99e52e32e89932ac$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $99e52e32e89932ac$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $99e52e32e89932ac$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("8HgDC", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", () => $d50d7663dcde671e$export$a33327ada3a6ee4a);
$parcel$export(module.exports, "getAllowedFeatures", () => $d50d7663dcde671e$export$3207c60940c4a9b0);

var $fzBRQ = parcelRequire("fzBRQ");
var $6DF4T = parcelRequire("6DF4T");
var $d50d7663dcde671e$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $d50d7663dcde671e$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments',
        'disable-publish-close-buttons'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $d50d7663dcde671e$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $d50d7663dcde671e$var$pageAllowedFeatures = {
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.edit,
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.view
};
const $d50d7663dcde671e$var$blogPostAllowedFeatures = {
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.edit,
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.view
};
const $d50d7663dcde671e$var$whiteboardAllowedFeatures = {
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $d50d7663dcde671e$export$a3fda3dcee62e1cc.whiteboard
};
const $d50d7663dcde671e$var$contentTypeAllowedFeatures = {
    [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $d50d7663dcde671e$var$pageAllowedFeatures,
    [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $d50d7663dcde671e$var$blogPostAllowedFeatures,
    [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $d50d7663dcde671e$var$whiteboardAllowedFeatures
};
const $d50d7663dcde671e$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$d50d7663dcde671e$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];

});
parcelRegister("fzBRQ", function(module, exports) {
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", () => $35899afc70d2fea8$export$942a5fac9b8c9dc2);
var $35899afc70d2fea8$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});

});

parcelRegister("6DF4T", function(module, exports) {
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $0203ec221428541d$export$816ef638e478449a);
var $0203ec221428541d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});

});


parcelRegister("3V5nR", function(module, exports) {
$parcel$export(module.exports, "EDIT_PAGE_EMBED", () => $38df13a66e61ed85$export$e63a462ee45b57cf);
$parcel$export(module.exports, "EDIT_PAGE_V2", () => $38df13a66e61ed85$export$7b1285e36c635f1f);
$parcel$export(module.exports, "VIEW_PAGE", () => $38df13a66e61ed85$export$9257b5b55c8e2555);
$parcel$export(module.exports, "VIEW_BLOG", () => $38df13a66e61ed85$export$91f49e7b30a9d34);
$parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", () => $38df13a66e61ed85$export$bd2c9bb170b3681d);
$parcel$export(module.exports, "WHITEBOARD", () => $38df13a66e61ed85$export$fbefbcc1445e8d74);
$parcel$export(module.exports, "namedRoutes", () => $38df13a66e61ed85$export$d4971375353d0454);
$parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", () => $38df13a66e61ed85$export$5c59aa0922e65f1a);
const $38df13a66e61ed85$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-embed/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-v2/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $38df13a66e61ed85$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year/:month/:day/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$fbefbcc1445e8d74 = {
    name: 'WHITEBOARD',
    pattern: '/wiki/spaces/:spaceKey/whiteboard/:contentId/:contentSlug?'
};
const $38df13a66e61ed85$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $38df13a66e61ed85$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $38df13a66e61ed85$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $38df13a66e61ed85$export$65b723bb995d4fb6,
    VIEW_PAGE: $38df13a66e61ed85$export$9257b5b55c8e2555,
    VIEW_BLOG: $38df13a66e61ed85$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $38df13a66e61ed85$export$bd2c9bb170b3681d,
    WHITEBOARD: $38df13a66e61ed85$export$fbefbcc1445e8d74
};
const $38df13a66e61ed85$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};

});


parcelRegister("52WL7", function(module, exports) {
$parcel$export(module.exports, "useExperienceTracker", () => $61f00e7f38957a02$export$cdefb2a8b53f879f);

var $eJOHy = parcelRequire("eJOHy");

var $87Obl = parcelRequire("87Obl");
var $40f0Z = parcelRequire("40f0Z");

var $9g7u4 = parcelRequire("9g7u4");

var $5ZujZ = parcelRequire("5ZujZ");
function $61f00e7f38957a02$export$cdefb2a8b53f879f() {
    const embeddedConfluenceETRef = (0, $eJOHy.useRef)();
    if (!embeddedConfluenceETRef.current) embeddedConfluenceETRef.current = new (0, $87Obl.ExperienceTracker)();
    (0, $9g7u4.useAnalytics)(embeddedConfluenceETRef.current);
    $61f00e7f38957a02$var$useExperiencesForwarding(embeddedConfluenceETRef.current);
    return embeddedConfluenceETRef.current;
}
const $61f00e7f38957a02$var$useExperiencesForwarding = (experienceTracker)=>{
    const unsubscribeRef = (0, $eJOHy.useRef)();
    // Make sure the Embeddable Pages ExperienceTrackerAPI instance forwards experence events to the embedding product.
    const embeddingProductETRef = (0, $eJOHy.useRef)();
    const embeddingProductET = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    if (embeddingProductETRef.current !== embeddingProductET) {
        // Cancel the old forwarding on embedding product ExperienceTrackerAPI instance change.
        if (unsubscribeRef.current) unsubscribeRef.current();
        embeddingProductETRef.current = embeddingProductET;
        // Set the new forwarding up.
        unsubscribeRef.current = (0, $5ZujZ.setExperiencesForwarding)(experienceTracker, embeddingProductETRef.current);
    }
    // Cancel the forwarding on unmount.
    (0, $eJOHy.useEffect)(()=>unsubscribeRef.current, []);
};

});
parcelRegister("9g7u4", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $9b6e4424e97e8f9e$export$e955abb82869dc84);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $j2zMY = parcelRequire("j2zMY");

var $8NHBs = parcelRequire("8NHBs");

var $fnLem = parcelRequire("fnLem");
const $9b6e4424e97e8f9e$export$e955abb82869dc84 = (experienceTracker)=>{
    const unsubscribeRef = (0, $eJOHy.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (!unsubscribeRef.current && experienceTracker) unsubscribeRef.current = experienceTracker.subscribe((event)=>{
        if (event.name.startsWith((0, $j2zMY.EXPERIENCE_NAME_PREFIX))) // Fire the analytic event to dedicated ANALYTICS_CHANNEL channel for EP analytics.
        createAnalyticsEvent((0, $8NHBs.createExperienceTrackerAnalyticsEventPayload)(event)).fire((0, $fnLem.ANALYTICS_CHANNEL));
    });
    (0, $eJOHy.useEffect)(()=>unsubscribeRef.current, []);
};

});
parcelRegister("j2zMY", function(module, exports) {
$parcel$export(module.exports, "EXPERIENCE_NAME_PREFIX", () => $a22062b7ca04dc2f$export$b9fadc635fed6276);
$parcel$export(module.exports, "ExperienceNames", () => $a22062b7ca04dc2f$export$312b1a9f1141bdaa);
$parcel$export(module.exports, "ExperienceReasons", () => $a22062b7ca04dc2f$export$db5add30a8721c38);
$parcel$export(module.exports, "SupportedExperienceNames", () => $a22062b7ca04dc2f$export$ce9b20b2ad3e7bc6);
const $a22062b7ca04dc2f$export$b9fadc635fed6276 = 'embedded-confluence/';
var $a22062b7ca04dc2f$export$312b1a9f1141bdaa = /*#__PURE__*/ function(ExperienceNames) {
    ExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    ExperienceNames["CC_VIEW_PAGE"] = "view-page";
    ExperienceNames["EDIT_PAGE"] = "embedded-confluence/edit-page";
    ExperienceNames["CC_EDIT_PAGE_EMBED"] = "edit-page-embed";
    ExperienceNames["WHITEBOARD"] = "embedded-confluence/whiteboard";
    ExperienceNames["CC_WHITEBOARD"] = "whiteboard-page";
    ExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    ExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    ExperienceNames["PAGE_NOT_FOUND"] = "not-found";
    return ExperienceNames;
}({});
var $a22062b7ca04dc2f$export$db5add30a8721c38 = /*#__PURE__*/ function(ExperienceReasons) {
    ExperienceReasons["UNABLE_TO_DISPLAY_CONTENT"] = "Unable to display page content";
    ExperienceReasons["STORAGE_ACCESS_ERROR"] = "Error when obtaining Storage access";
    ExperienceReasons["STORAGE_ACCESS_NOT_SUPPORTED"] = "Storage access API is not supported";
    ExperienceReasons["STORAGE_ACCESS_REJECTED"] = "Storage access is rejected";
    return ExperienceReasons;
}({});
var $a22062b7ca04dc2f$export$ce9b20b2ad3e7bc6 = /*#__PURE__*/ function(SupportedExperienceNames) {
    SupportedExperienceNames["ADD_COMMENT"] = "add-page-comment";
    SupportedExperienceNames["DELETE_COMMENT"] = "delete-page-comment";
    SupportedExperienceNames["DELETE_PAGE"] = "delete-page";
    SupportedExperienceNames["DELETE_DRAFT"] = "edit-page/revert-draft";
    SupportedExperienceNames["EDIT_CLOSE"] = "edit-page/close";
    SupportedExperienceNames["EDIT_LOAD"] = "edit-page/load";
    SupportedExperienceNames["EDIT_PAGE_EMBED"] = "embedded-confluence/edit-page";
    SupportedExperienceNames["EDIT_PUBLISH"] = "edit-page/publish";
    SupportedExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    SupportedExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    SupportedExperienceNames["VIEW_CONTENT"] = "view-content";
    SupportedExperienceNames["VIEW_EDIT"] = "view-page/edit";
    SupportedExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    return SupportedExperienceNames;
}({});

});

parcelRegister("8NHBs", function(module, exports) {
$parcel$export(module.exports, "createExperienceTrackerAnalyticsEventPayload", () => $55d79b53e5470d85$export$9c05e7ef9f2c8895);
const $55d79b53e5470d85$export$9c05e7ef9f2c8895 = (event)=>({
        // Events should match the schema defined here:
        // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
        source: 'ui',
        actionSubject: 'ui',
        action: event.action,
        eventType: 'operational',
        attributes: $55d79b53e5470d85$var$createExperienceTrackerAnalyticsAttributes(event)
    });
function $55d79b53e5470d85$var$createExperienceTrackerAnalyticsAttributes(event) {
    const { action: action, name: name, id: id, attributes: experienceAttributes, ...rest } = event;
    const attributes = {
        ...experienceAttributes,
        ...rest,
        task: name,
        taskId: id
    };
    if (attributes.error) {
        let error;
        if (typeof attributes.error === 'string') error = new Error(attributes.error);
        else error = attributes.error;
        delete attributes.error;
        attributes.errorName = error.name;
        if (!attributes.traceId && error.traceId) attributes.traceId = error.traceId;
        attributes.errorMessage = error.message;
    }
    attributes.browserInfo = window.navigator.userAgent;
    // Matches the analytics-web-client's apdex event
    attributes.isActiveTab = document.visibilityState === 'visible';
    return attributes;
}

});

parcelRegister("fnLem", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $4e744db00984a860$export$85183a312807388d);

var $9g7u4 = parcelRequire("9g7u4");
const $4e744db00984a860$export$85183a312807388d = 'embeddedConfluence';

});


parcelRegister("5ZujZ", function(module, exports) {
$parcel$export(module.exports, "setExperiencesForwarding", () => $08d63358f56f2fa7$export$7ecf150f65423c3f);
function $08d63358f56f2fa7$export$7ecf150f65423c3f(fromExperienceTracker, toExperienceTracker) {
    if (!fromExperienceTracker || !toExperienceTracker) return;
    const cancelExperiencesForwarding = fromExperienceTracker.subscribe(({ action: action, ...options })=>{
        switch(action){
            case 'taskAbort':
                toExperienceTracker.abort({
                    ...options,
                    checkForTimeout: false
                });
                break;
            case 'taskFail':
                toExperienceTracker.fail(options);
                break;
            case 'taskStart':
                toExperienceTracker.start(options);
                break;
            case 'taskSuccess':
                toExperienceTracker.succeed(options);
                break;
        }
    });
    return cancelExperiencesForwarding;
}

});



parcelRegister("7oRxl", function(module, exports) {
$parcel$export(module.exports, "PageNotFoundEmptyState", () => $9a8674d2e142bed1$export$d3ec4d3c4e3e468c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $lRq8t = parcelRequire("lRq8t");

var $Ov5I7 = parcelRequire("Ov5I7");

var $2XnNJ = parcelRequire("2XnNJ");
const $9a8674d2e142bed1$export$d3ec4d3c4e3e468c = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6MnLl.default), {
        header: formatMessage((0, $Ov5I7.default).emptyStateHeader),
        description: formatMessage((0, $Ov5I7.default).emptyStateDescription),
        renderImage: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2XnNJ.PageNotFoundSVG), {})
    });
};

});
parcelRegister("Ov5I7", function(module, exports) {
$parcel$export(module.exports, "default", () => $e921b67742a22da0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e921b67742a22da0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyStateHeader: {
        defaultMessage: "We couldn't find what you're looking for",
        id: 'embedded-confluence-common.src.content.empty-state-header',
        description: 'The header message in the empty state error screen shown to the user when there is no page to render'
    },
    emptyStateDescription: {
        defaultMessage: "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
        id: 'embedded-confluence-common.src.content.empty-state-description',
        description: 'The description message in the empty state error screen shown to the user when there is no page to render'
    }
});

});

parcelRegister("2XnNJ", function(module, exports) {
$parcel$export(module.exports, "PageNotFoundSVG", () => $608c538d98081b3b$export$7cd49dc959d58823);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $608c538d98081b3b$var$styles = `{
  cls4: { fill: '#b3f5ff' },
  cls50: { fill: '#79e2f2' },
  cls228: { fill: 'url(#radial-gradient-7)' },
  cls230: { fill: 'url(#radial-gradient-9)' },
  cls240: { fill: '#c1c7d0' },
  cls242: { fill: '#dfe1e5' },
  cls245: { fill: '#172b4d' },
  cls247: { fill: '#00c7e5' },
  cls249: { fill: 'none' },
  cls250: { fill: '#72594b' },
  cls261: { opacity: 0.6 },
  cls262: { fill: '#ff8b00' },
  cls263: { fill: '#ecc19c' },
}`;
const $608c538d98081b3b$export$7cd49dc959d58823 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "476.06",
        height: "482.63",
        viewBox: "0 0 476.06 482.63",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "319.98",
                        y1: "322.55",
                        x2: "426.85",
                        y2: "215.68",
                        gradientTransform: "translate(-227.29)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".06",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".27",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".45",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".67"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".6",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".72",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".96"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "7261.66",
                        y1: "168.49",
                        x2: "7391.94",
                        y2: "38.21",
                        gradientTransform: "matrix(-1 0 0 1 7632.29 0)",
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-3",
                        x1: "146.17",
                        y1: "164.89",
                        x2: "239.99",
                        y2: "71.07",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00c7e5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-4",
                        x1: "782.51",
                        y1: "-1187.31",
                        x2: "790.62",
                        y2: "-1204.87",
                        gradientTransform: "rotate(-24.78 3495.39 868.508)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".25",
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-5",
                        x1: "5.81",
                        y1: "472.52",
                        x2: "5.81",
                        y2: "284.67",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".43",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-6",
                        x1: "8.47",
                        y1: "472.52",
                        x2: "8.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-7",
                        x1: "69.15",
                        y1: "472.52",
                        x2: "69.15",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-8",
                        x1: "63.61",
                        y1: "472.52",
                        x2: "63.61",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-9",
                        x1: "67.33",
                        y1: "472.52",
                        x2: "67.33",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-10",
                        x1: "68.21",
                        y1: "472.52",
                        x2: "68.21",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-11",
                        x1: "68.78",
                        y1: "472.52",
                        x2: "68.78",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-12",
                        x1: "69.36",
                        y1: "472.52",
                        x2: "69.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-13",
                        x1: "52.51",
                        y1: "472.52",
                        x2: "52.51",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-14",
                        x1: "56.67",
                        y1: "472.52",
                        x2: "56.67",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-15",
                        x1: "54.47",
                        y1: "472.52",
                        x2: "54.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-16",
                        x1: "60.3",
                        y1: "472.52",
                        x2: "60.3",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-17",
                        x1: "62.16",
                        y1: "472.52",
                        x2: "62.16",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-18",
                        x1: "58.5",
                        y1: "472.52",
                        x2: "58.5",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-19",
                        x1: "66.35",
                        y1: "472.52",
                        x2: "66.35",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-20",
                        x1: "3.23",
                        y1: "472.52",
                        x2: "3.23",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-21",
                        x1: "160.2",
                        y1: "472.52",
                        x2: "160.2",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-22",
                        x1: "71.2",
                        y1: "472.52",
                        x2: "71.2",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-23",
                        x1: "271.02",
                        y1: "472.52",
                        x2: "271.02",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-24",
                        x1: "4.82",
                        y1: "472.52",
                        x2: "4.82",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-25",
                        x1: "69.36",
                        y1: "472.52",
                        x2: "69.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-26",
                        x1: "195.3",
                        y1: "472.52",
                        x2: "195.3",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-27",
                        x1: "3.53",
                        y1: "472.52",
                        x2: "3.53",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-28",
                        x1: "3.37",
                        y1: "472.52",
                        x2: "3.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-29",
                        x1: "4.07",
                        y1: "472.52",
                        x2: "4.07",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-30",
                        x1: "273.13",
                        y1: "472.52",
                        x2: "273.13",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-31",
                        x1: "273.13",
                        y1: "462.4",
                        x2: "273.13",
                        y2: "337.02",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-32",
                        x1: "220.7",
                        y1: "472.52",
                        x2: "220.7",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-33",
                        x1: "220.7",
                        y1: "462.4",
                        x2: "220.7",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-34",
                        x1: "185.46",
                        y1: "472.52",
                        x2: "185.46",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-35",
                        x1: "185.46",
                        y1: "402.18",
                        x2: "185.46",
                        y2: "337.02",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".05",
                                stopColor: "#abf2fd"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".22",
                                stopColor: "#95ebf8"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".4",
                                stopColor: "#85e6f5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".61",
                                stopColor: "#7ce3f3"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".91",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-36",
                        x1: "148.26",
                        y1: "472.52",
                        x2: "148.26",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-37",
                        x1: "148.26",
                        y1: "402.18",
                        x2: "148.26",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-38",
                        x1: "186.02",
                        y1: "472.52",
                        x2: "186.02",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-39",
                        x1: "186.02",
                        y1: "462.4",
                        x2: "186.02",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-40",
                        x1: "186.02",
                        y1: "402.18",
                        x2: "186.02",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-41",
                        x1: "214.14",
                        y1: "472.52",
                        x2: "214.14",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-42",
                        x1: "214.14",
                        y1: "462.4",
                        x2: "214.14",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-43",
                        x1: "214.14",
                        y1: "402.18",
                        x2: "214.14",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-44",
                        x1: "185.54",
                        y1: "402.18",
                        x2: "185.54",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-45",
                        x1: "338.36",
                        y1: "472.52",
                        x2: "338.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-46",
                        x1: "338.36",
                        y1: "402.18",
                        x2: "338.36",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-47",
                        x1: "283.93",
                        y1: "472.52",
                        x2: "283.93",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-48",
                        x1: "283.93",
                        y1: "462.4",
                        x2: "283.93",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-49",
                        x1: "283.93",
                        y1: "402.18",
                        x2: "283.93",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-50",
                        x1: "403.38",
                        y1: "472.52",
                        x2: "403.38",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-51",
                        x1: "396.98",
                        y1: "411.33",
                        x2: "409.97",
                        y2: "305.52",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".96"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".02",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".78"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".05",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".61"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".07",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".47"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".1",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".34"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".13",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".23"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".17",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".15"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".21",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".26",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".03"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".33",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".01"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".52",
                                stopColor: "#b3f5ff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".67",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".01"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".74",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".04"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".09"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".83",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".16"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".86",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".25"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".9",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".36"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".93",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".49"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".95",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".65"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".98",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".82"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-52",
                        x1: "2.42",
                        y1: "362.88",
                        x2: "15.41",
                        y2: "257.07",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-53",
                        x1: "3.3",
                        y1: "362.99",
                        x2: "16.29",
                        y2: "257.18",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-54",
                        x1: "4.38",
                        y1: "363.12",
                        x2: "17.37",
                        y2: "257.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-55",
                        x1: "1.14",
                        y1: "362.72",
                        x2: "14.13",
                        y2: "256.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-56",
                        x1: "5.69",
                        y1: "363.28",
                        x2: "18.68",
                        y2: "257.47",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-57",
                        x1: "1.05",
                        y1: "362.71",
                        x2: "14.04",
                        y2: "256.9",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-58",
                        x1: "10.57",
                        y1: "363.88",
                        x2: "11.95",
                        y2: "352.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-59",
                        x1: "1.74",
                        y1: "362.79",
                        x2: "14.73",
                        y2: "256.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-60",
                        x1: "171.14",
                        y1: "472.52",
                        x2: "171.14",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-61",
                        x1: "165.11",
                        y1: "382.85",
                        x2: "178.1",
                        y2: "277.05",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-62",
                        x1: "251.72",
                        y1: "472.52",
                        x2: "251.72",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-63",
                        x1: "251.72",
                        y1: "462.4",
                        x2: "251.72",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-64",
                        x1: "249.31",
                        y1: "393.2",
                        x2: "262.3",
                        y2: "287.39",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-65",
                        x1: "237.87",
                        y1: "472.52",
                        x2: "237.87",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-66",
                        x1: "237.87",
                        y1: "462.4",
                        x2: "237.87",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-67",
                        x1: "235.86",
                        y1: "391.55",
                        x2: "248.85",
                        y2: "285.74",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-68",
                        x1: "153.84",
                        y1: "472.52",
                        x2: "153.84",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-69",
                        x1: "153.84",
                        y1: "402.18",
                        x2: "153.84",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-70",
                        x1: "152.5",
                        y1: "381.31",
                        x2: "165.5",
                        y2: "275.5",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-71",
                        x1: "172.27",
                        y1: "472.52",
                        x2: "172.27",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-72",
                        x1: "172.27",
                        y1: "462.4",
                        x2: "172.27",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-73",
                        x1: "172.27",
                        y1: "402.18",
                        x2: "172.27",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-74",
                        x1: "168.95",
                        y1: "383.33",
                        x2: "181.94",
                        y2: "277.52",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-75",
                        x1: "221.37",
                        y1: "472.52",
                        x2: "221.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-76",
                        x1: "221.37",
                        y1: "462.4",
                        x2: "221.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-77",
                        x1: "221.37",
                        y1: "402.18",
                        x2: "221.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-78",
                        x1: "218.94",
                        y1: "389.47",
                        x2: "231.93",
                        y2: "283.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-79",
                        x1: "187.52",
                        y1: "472.52",
                        x2: "187.52",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-80",
                        x1: "187.52",
                        y1: "462.4",
                        x2: "187.52",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-81",
                        x1: "187.52",
                        y1: "402.18",
                        x2: "187.52",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-82",
                        x1: "184.77",
                        y1: "385.27",
                        x2: "197.76",
                        y2: "279.47",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-83",
                        x1: "180.43",
                        y1: "402.18",
                        x2: "180.43",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-84",
                        x1: "178.58",
                        y1: "384.51",
                        x2: "191.57",
                        y2: "278.7",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-85",
                        x1: "193.4",
                        y1: "402.18",
                        x2: "193.4",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-86",
                        x1: "191.37",
                        y1: "386.08",
                        x2: "204.37",
                        y2: "280.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-87",
                        x1: "240.98",
                        y1: "392.17",
                        x2: "253.97",
                        y2: "286.37",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-88",
                        x1: "333.44",
                        y1: "472.52",
                        x2: "333.44",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-89",
                        x1: "333.44",
                        y1: "402.18",
                        x2: "333.44",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-90",
                        x1: "329.79",
                        y1: "403.08",
                        x2: "342.78",
                        y2: "297.27",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-91",
                        x1: "283.96",
                        y1: "472.52",
                        x2: "283.96",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-92",
                        x1: "283.96",
                        y1: "462.4",
                        x2: "283.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-93",
                        x1: "283.96",
                        y1: "402.18",
                        x2: "283.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-94",
                        x1: "279.87",
                        y1: "396.95",
                        x2: "292.86",
                        y2: "291.14",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-95",
                        x1: "204.11",
                        y1: "472.52",
                        x2: "204.11",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-96",
                        x1: "184.3",
                        y1: "387.71",
                        x2: "228.81",
                        y2: "265.4",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-97",
                        x1: "197.55",
                        y1: "386.84",
                        x2: "210.54",
                        y2: "281.03",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-98",
                        x1: "375.18",
                        y1: "472.52",
                        x2: "375.18",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-99",
                        x1: "339.82",
                        y1: "444.31",
                        x2: "384.34",
                        y2: "322.01",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-100",
                        x1: "367.74",
                        y1: "407.74",
                        x2: "380.74",
                        y2: "301.93",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-101",
                        x1: "154.96",
                        y1: "472.52",
                        x2: "154.96",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-102",
                        x1: "154.96",
                        y1: "402.18",
                        x2: "154.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-103",
                        x1: "148.01",
                        y1: "374.5",
                        x2: "192.52",
                        y2: "252.19",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-104",
                        x1: "151.79",
                        y1: "381.22",
                        x2: "164.78",
                        y2: "275.42",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-105",
                        x1: "202.83",
                        y1: "472.52",
                        x2: "202.83",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-106",
                        x1: "202.83",
                        y1: "462.4",
                        x2: "202.83",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-107",
                        x1: "202.83",
                        y1: "402.18",
                        x2: "202.83",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-108",
                        x1: "190.53",
                        y1: "389.97",
                        x2: "235.04",
                        y2: "267.67",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-109",
                        x1: "199.1",
                        y1: "387.03",
                        x2: "212.09",
                        y2: "281.22",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-110",
                        x1: "170.79",
                        y1: "472.52",
                        x2: "170.79",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-111",
                        x1: "170.79",
                        y1: "462.4",
                        x2: "170.79",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-112",
                        x1: "170.79",
                        y1: "402.18",
                        x2: "170.79",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-113",
                        x1: "161.27",
                        y1: "379.33",
                        x2: "205.79",
                        y2: "257.02",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-114",
                        x1: "166.95",
                        y1: "383.08",
                        x2: "179.94",
                        y2: "277.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-115",
                        x1: "188.51",
                        y1: "472.52",
                        x2: "188.51",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-116",
                        x1: "188.51",
                        y1: "462.4",
                        x2: "188.51",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-117",
                        x1: "188.51",
                        y1: "402.18",
                        x2: "188.51",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-118",
                        x1: "177.1",
                        y1: "385.09",
                        x2: "221.61",
                        y2: "262.78",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-119",
                        x1: "184.49",
                        y1: "385.24",
                        x2: "197.49",
                        y2: "279.43",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-120",
                        x1: "181.55",
                        y1: "402.18",
                        x2: "181.55",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-121",
                        x1: "171.4",
                        y1: "383.01",
                        x2: "215.92",
                        y2: "260.71",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-122",
                        x1: "178.12",
                        y1: "384.46",
                        x2: "191.11",
                        y2: "278.65",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-123",
                        x1: "195.05",
                        y1: "402.18",
                        x2: "195.05",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-124",
                        x1: "183.47",
                        y1: "387.41",
                        x2: "227.99",
                        y2: "265.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-125",
                        x1: "191.39",
                        y1: "386.09",
                        x2: "204.38",
                        y2: "280.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-126",
                        x1: "227.14",
                        y1: "403.3",
                        x2: "271.66",
                        y2: "281",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-127",
                        x1: "240.77",
                        y1: "392.15",
                        x2: "253.76",
                        y2: "286.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-128",
                        x1: "334.77",
                        y1: "472.52",
                        x2: "334.77",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-129",
                        x1: "334.77",
                        y1: "402.18",
                        x2: "334.77",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-130",
                        x1: "306.53",
                        y1: "432.19",
                        x2: "351.04",
                        y2: "309.89",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-131",
                        x1: "328.83",
                        y1: "402.96",
                        x2: "341.82",
                        y2: "297.15",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-132",
                        x1: "305.41",
                        y1: "472.52",
                        x2: "305.41",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-133",
                        x1: "305.41",
                        y1: "462.4",
                        x2: "305.41",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-134",
                        x1: "305.41",
                        y1: "402.18",
                        x2: "305.41",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-135",
                        x1: "280.29",
                        y1: "422.65",
                        x2: "324.81",
                        y2: "300.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-136",
                        x1: "299.79",
                        y1: "399.4",
                        x2: "312.78",
                        y2: "293.59",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-137",
                        x1: "237.39",
                        y1: "472.52",
                        x2: "237.39",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-138",
                        x1: "94.24",
                        y1: "336.36",
                        x2: "382.66",
                        y2: "336.36",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-139",
                        x1: "215.63",
                        y1: "399.11",
                        x2: "260.14",
                        y2: "276.81",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-140",
                        x1: "231.06",
                        y1: "390.96",
                        x2: "244.05",
                        y2: "285.15",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-141",
                        x1: "154.66",
                        y1: "472.52",
                        x2: "154.66",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-142",
                        x1: "154.66",
                        y1: "402.18",
                        x2: "154.66",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-143",
                        x1: "94.24",
                        y1: "347.55",
                        x2: "382.66",
                        y2: "347.55",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-144",
                        x1: "146.2",
                        y1: "373.84",
                        x2: "190.71",
                        y2: "251.53",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-145",
                        x1: "150.91",
                        y1: "381.12",
                        x2: "163.9",
                        y2: "275.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-146",
                        x1: "168.62",
                        y1: "472.52",
                        x2: "168.62",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-147",
                        x1: "168.62",
                        y1: "462.4",
                        x2: "168.62",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-148",
                        x1: "168.62",
                        y1: "402.18",
                        x2: "168.62",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-149",
                        x1: "94.24",
                        y1: "348.31",
                        x2: "382.66",
                        y2: "348.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-150",
                        x1: "157.53",
                        y1: "377.96",
                        x2: "202.04",
                        y2: "255.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-151",
                        x1: "164.09",
                        y1: "382.73",
                        x2: "177.09",
                        y2: "276.93",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-152",
                        x1: "188.58",
                        y1: "472.52",
                        x2: "188.58",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-153",
                        x1: "188.58",
                        y1: "462.4",
                        x2: "188.58",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-154",
                        x1: "188.58",
                        y1: "402.18",
                        x2: "188.58",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-155",
                        x1: "94.24",
                        y1: "350.99",
                        x2: "382.66",
                        y2: "350.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-156",
                        x1: "176.21",
                        y1: "384.76",
                        x2: "220.72",
                        y2: "262.46",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-157",
                        x1: "184.32",
                        y1: "385.22",
                        x2: "197.31",
                        y2: "279.41",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-158",
                        x1: "181.71",
                        y1: "402.18",
                        x2: "181.71",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-159",
                        x1: "94.24",
                        y1: "349.53",
                        x2: "382.66",
                        y2: "349.53",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-160",
                        x1: "170.01",
                        y1: "382.51",
                        x2: "214.52",
                        y2: "260.2",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-161",
                        x1: "177.73",
                        y1: "384.41",
                        x2: "190.72",
                        y2: "278.6",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-162",
                        x1: "193.08",
                        y1: "402.18",
                        x2: "193.08",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-163",
                        x1: "94.24",
                        y1: "352.21",
                        x2: "382.66",
                        y2: "352.21",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-164",
                        x1: "180.71",
                        y1: "386.4",
                        x2: "225.23",
                        y2: "264.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-165",
                        x1: "189.02",
                        y1: "385.79",
                        x2: "202.01",
                        y2: "279.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-166",
                        x1: "94.24",
                        y1: "349.07",
                        x2: "382.66",
                        y2: "349.07",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-167",
                        x1: "225.04",
                        y1: "402.53",
                        x2: "269.55",
                        y2: "280.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-168",
                        x1: "240.19",
                        y1: "392.08",
                        x2: "253.18",
                        y2: "286.27",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-169",
                        x1: "335.09",
                        y1: "472.52",
                        x2: "335.09",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-170",
                        x1: "335.09",
                        y1: "402.18",
                        x2: "335.09",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-171",
                        x1: "94.24",
                        y1: "346.43",
                        x2: "382.66",
                        y2: "346.43",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-172",
                        x1: "305.17",
                        y1: "431.7",
                        x2: "349.68",
                        y2: "309.4",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-173",
                        x1: "328.53",
                        y1: "402.92",
                        x2: "341.52",
                        y2: "297.12",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-174",
                        x1: "314.18",
                        y1: "472.52",
                        x2: "314.18",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-175",
                        x1: "314.18",
                        y1: "462.4",
                        x2: "314.18",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-176",
                        x1: "314.18",
                        y1: "402.18",
                        x2: "314.18",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-177",
                        x1: "94.24",
                        y1: "347.82",
                        x2: "382.66",
                        y2: "347.82",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-178",
                        x1: "286.17",
                        y1: "424.78",
                        x2: "330.68",
                        y2: "302.48",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-179",
                        x1: "307.73",
                        y1: "400.37",
                        x2: "320.72",
                        y2: "294.56",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-180",
                        x1: "238.45",
                        y1: "472.52",
                        x2: "238.45",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-181",
                        x1: "94.24",
                        y1: "336.66",
                        x2: "382.66",
                        y2: "336.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-182",
                        x1: "120.57",
                        y1: "336.66",
                        x2: "356.32",
                        y2: "336.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-183",
                        x1: "216.19",
                        y1: "399.31",
                        x2: "260.7",
                        y2: "277.01",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-184",
                        x1: "231.95",
                        y1: "391.07",
                        x2: "244.94",
                        y2: "285.26",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-185",
                        x1: "154.01",
                        y1: "472.52",
                        x2: "154.01",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-186",
                        x1: "154.01",
                        y1: "402.18",
                        x2: "154.01",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-187",
                        x1: "94.24",
                        y1: "340.77",
                        x2: "382.66",
                        y2: "340.77",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-188",
                        x1: "120.57",
                        y1: "340.77",
                        x2: "356.32",
                        y2: "340.77",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-189",
                        x1: "143.55",
                        y1: "372.88",
                        x2: "188.07",
                        y2: "250.57",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-190",
                        x1: "149.49",
                        y1: "380.94",
                        x2: "162.48",
                        y2: "275.13",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-191",
                        x1: "164.37",
                        y1: "472.52",
                        x2: "164.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-192",
                        x1: "164.37",
                        y1: "462.4",
                        x2: "164.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-193",
                        x1: "164.37",
                        y1: "402.18",
                        x2: "164.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-194",
                        x1: "94.24",
                        y1: "341.24",
                        x2: "382.66",
                        y2: "341.24",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-195",
                        x1: "120.57",
                        y1: "341.24",
                        x2: "356.32",
                        y2: "341.24",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-196",
                        x1: "151.77",
                        y1: "375.87",
                        x2: "196.28",
                        y2: "253.56",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-197",
                        x1: "159.34",
                        y1: "382.15",
                        x2: "172.34",
                        y2: "276.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-198",
                        x1: "94.24",
                        y1: "341.91",
                        x2: "382.66",
                        y2: "341.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-199",
                        x1: "120.57",
                        y1: "341.91",
                        x2: "356.32",
                        y2: "341.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-200",
                        x1: "221.5",
                        y1: "401.25",
                        x2: "266.01",
                        y2: "278.94",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-201",
                        x1: "238.15",
                        y1: "391.83",
                        x2: "251.14",
                        y2: "286.02",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-202",
                        x1: "335.78",
                        y1: "472.52",
                        x2: "335.78",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-203",
                        x1: "335.78",
                        y1: "402.18",
                        x2: "335.78",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-204",
                        x1: "94.24",
                        y1: "340.23",
                        x2: "382.66",
                        y2: "340.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-205",
                        x1: "120.57",
                        y1: "340.23",
                        x2: "356.32",
                        y2: "340.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-206",
                        x1: "303.69",
                        y1: "431.16",
                        x2: "348.2",
                        y2: "308.86",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-207",
                        x1: "328.42",
                        y1: "402.91",
                        x2: "341.41",
                        y2: "297.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-208",
                        x1: "326.47",
                        y1: "472.52",
                        x2: "326.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-209",
                        x1: "326.47",
                        y1: "462.4",
                        x2: "326.47",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-210",
                        x1: "326.47",
                        y1: "402.18",
                        x2: "326.47",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-211",
                        x1: "94.24",
                        y1: "340.83",
                        x2: "382.66",
                        y2: "340.83",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-212",
                        x1: "120.57",
                        y1: "340.83",
                        x2: "356.32",
                        y2: "340.83",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-213",
                        x1: "294.77",
                        y1: "427.92",
                        x2: "339.28",
                        y2: "305.61",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-214",
                        x1: "318.99",
                        y1: "401.75",
                        x2: "331.98",
                        y2: "295.94",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-215",
                        x1: "105.04",
                        y1: "472.52",
                        x2: "105.04",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-216",
                        x1: "134.74",
                        y1: "472.52",
                        x2: "134.74",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-217",
                        x1: "134.74",
                        y1: "402.18",
                        x2: "134.74",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-218",
                        x1: "115.09",
                        y1: "282.96",
                        x2: "376",
                        y2: "282.96",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3bac5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".85",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".95",
                                stopColor: "#edeef1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".98",
                                stopColor: "#f4f5f7"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-219",
                        x1: "163.83",
                        y1: "347.6",
                        x2: "279.38",
                        y2: "232.05",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".14",
                                stopColor: "#c9ced6"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".68",
                                stopColor: "#e2e4e9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#ebecf0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-220",
                        x1: "291.34",
                        y1: "337.73",
                        x2: "291.34",
                        y2: "198.21",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".21",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-221",
                        x1: "219.34",
                        y1: "215.53",
                        x2: "331.33",
                        y2: "215.53",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".18",
                                stopColor: "#091e42",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".5",
                                stopColor: "#091e42",
                                stopOpacity: ".45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#091e42",
                                stopOpacity: ".2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-222",
                        x1: "4697.25",
                        y1: "308.96",
                        x2: "4793.78",
                        y2: "308.96",
                        gradientTransform: "matrix(-1 0 0 1 4935.69 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".88",
                                stopColor: "#091e42"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-223",
                        x1: "-10103.77",
                        y1: "-1179.29",
                        x2: "-10103.77",
                        y2: "-1247.52",
                        gradientTransform: "matrix(.99 -.11 .11 .99 10362.66 390.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".37",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".88",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-224",
                        x1: "197.02",
                        y1: "184.01",
                        x2: "293.47",
                        y2: "87.57",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".13",
                                stopColor: "#091e42",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".36",
                                stopColor: "#091e42",
                                stopOpacity: ".45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".48",
                                stopColor: "#091e42",
                                stopOpacity: ".2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-225",
                        x1: "294.7",
                        y1: "238.16",
                        x2: "334.79",
                        y2: "238.16",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".12",
                                stopColor: "#0d6eff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".49",
                                stopColor: "#2f86ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".8",
                                stopColor: "#4495ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4c9aff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-226",
                        x1: "245.55",
                        y1: "299.49",
                        x2: "376",
                        y2: "299.49",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".47",
                                stopColor: "#f5f6f8"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-227",
                        x1: "153.96",
                        y1: "321.19",
                        x2: "337.13",
                        y2: "321.19",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#dfe1e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-228",
                        x1: "115.09",
                        y1: "299.49",
                        x2: "245.55",
                        y2: "299.49",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#edeef1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".9",
                                stopColor: "#f4f5f7"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-229",
                        x1: "251.12",
                        y1: "196.75",
                        x2: "347.56",
                        y2: "100.3",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ff991f"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".08",
                                stopColor: "#ffa219"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".33",
                                stopColor: "#ffbb07"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".48",
                                stopColor: "#ffc400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-230",
                        x1: "-2946.9",
                        y1: "-501.86",
                        x2: "-2929.95",
                        y2: "-501.86",
                        gradientTransform: "matrix(-.75 .66 .66 .75 -1698.92 2528.01)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".54",
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#00bddd"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-231",
                        x1: "913.18",
                        y1: "236.51",
                        x2: "936.34",
                        y2: "213.36",
                        gradientTransform: "matrix(-1 0 0 1 1111.25 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".62",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-232",
                        x1: "2869.84",
                        y1: "1497.87",
                        x2: "2882.64",
                        y2: "1491.62",
                        gradientTransform: "matrix(-.9 -.43 -.43 .9 3435.48 110.98)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".26",
                                stopColor: "#00a8c5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".6",
                                stopColor: "#00b8d5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".84",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13",
                        x1: "-6136.21",
                        y1: "5146.38",
                        x2: "-6130.92",
                        y2: "5141.09",
                        gradientTransform: "matrix(1 0 0 1.52 6291.96 -7637.21)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-2",
                        x1: "-6135.75",
                        y1: "5139.64",
                        x2: "-6131.37",
                        y2: "5135.26",
                        gradientTransform: "matrix(1 0 0 1.52 6301.53 -7627.42)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-3",
                        x1: "-6135.24",
                        y1: "5133.66",
                        x2: "-6131.89",
                        y2: "5130.31",
                        gradientTransform: "matrix(1 0 0 1.52 6309.67 -7619.1)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-233",
                        x1: "177.32",
                        y1: "462.13",
                        x2: "177.32",
                        y2: "382.62",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#79e2f2",
                                stopOpacity: ".3"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2",
                                stopOpacity: ".6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-234",
                        x1: "303.59",
                        y1: "388.02",
                        x2: "303.59",
                        y2: "380.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-235",
                        x1: "310.94",
                        y1: "133.6",
                        x2: "337.06",
                        y2: "186.14",
                        gradientTransform: "matrix(1 0 0 -1 0 582.59)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#79e2f2",
                                stopOpacity: ".2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2",
                                stopOpacity: ".6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "radial-gradient",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        gradientTransform: "matrix(1 0 0 .19 0 315.55)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".11",
                                stopColor: "#e6fcff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#e6fcff",
                                stopOpacity: ".73"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".56",
                                stopColor: "#e6fcff",
                                stopOpacity: ".42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".77",
                                stopColor: "#e6fcff",
                                stopOpacity: ".19"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".92",
                                stopColor: "#e6fcff",
                                stopOpacity: ".05"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#e6fcff",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-2",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-3",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-4",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-5",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-6",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-7",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-8",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-9",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-10",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-12",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-13",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-15",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("style", {
                        children: $608c538d98081b3b$var$styles
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                    id: "Layer_2",
                    "data-name": "Layer 2",
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                        id: "Layer_1-2",
                        "data-name": "Layer 1",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M166.11 212.89a42.69 42.69 0 00-23.17 17.18 32 32 0 00-19.06 0c-12.17 3.89-17.61 14-18.68 16.07a27.91 27.91 0 00-12.7-.75c-11.75 2.16-15.82 11.61-28.77 19.43a62.31 62.31 0 01-20.93 7.85h199.54c.21-1.14 2-11.54-5.62-19.8-8.13-8.86-19.65-7.25-20.55-7.1-.24-2.07-2.67-20.34-19.14-29.79-13.75-7.89-27.59-4.07-30.92-3.09z",
                                fill: "url(#linear-gradient)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M281.14 34.8a52.1 52.1 0 0128.24 21 39 39 0 0123.23 0c14.84 4.75 21.47 17 22.77 19.59a34 34 0 0115.49-.91c14.31 2.63 19.27 14.11 35.07 23.68a75.76 75.76 0 0025.5 9.57H188.21c-.26-1.39-2.41-14.07 6.84-24.14 9.92-10.8 24-8.83 25-8.66.3-2.52 3.26-24.78 23.34-36.3 16.82-9.63 33.68-5.02 37.75-3.83z",
                                fill: "url(#linear-gradient-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M118.71 264.49l-2.65-2.66a509.36 509.36 0 0070.25-87.4 509.23 509.23 0 0057.44-125.07l3.6 1.1a513.26 513.26 0 01-57.87 126 513.28 513.28 0 01-70.77 88.03z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z",
                                fill: "url(#linear-gradient-3)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M149.52 159.55a91.75 91.75 0 01-.5-82.63l81.91-.32a91.72 91.72 0 00.17 82.63z",
                                fill: "#e6fcff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M152 139.06a217.27 217.27 0 0116.17-19.35 270.57 270.57 0 0021.13 19.19z",
                                fill: "url(#linear-gradient-4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M165.12 139a226.29 226.29 0 0121.82-25.16 264.7 264.7 0 0026.61 25z",
                                fill: "#0052cc"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.27 99.13c-.75 3.6-4 6.57-7.49 6.58a5.26 5.26 0 01-5.28-6.53 8.62 8.62 0 018-6.5c3.5-.02 5.5 2.84 4.77 6.45z",
                                fill: "#ffab00"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z",
                                opacity: ".4",
                                fill: "#79e2f2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M6.25 358.05z",
                                fill: "url(#linear-gradient-5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M10.57 363.88a34.13 34.13 0 01-4.19-5.61 34.13 34.13 0 004.19 5.61z",
                                fill: "url(#linear-gradient-6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.18 403.31c0-.11 0-.21-.05-.32.02.11.03.21.05.32z",
                                fill: "url(#linear-gradient-7)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.81 392.36l-.39-.3z",
                                fill: "url(#linear-gradient-8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M67.44 397l-.22-.43z",
                                fill: "url(#linear-gradient-9)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.24 399l-.06-.19z",
                                fill: "url(#linear-gradient-10)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.83 401.28c0-.17-.07-.33-.1-.5.03.22.07.33.1.5z",
                                fill: "url(#linear-gradient-11)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.62z",
                                fill: "url(#linear-gradient-12)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M52.78 387.47l-.54-.15z",
                                fill: "url(#linear-gradient-13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M56.85 388.76l-.36-.12z",
                                fill: "url(#linear-gradient-14)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M54.69 388l-.45-.13z",
                                fill: "url(#linear-gradient-15)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M60.44 390.25l-.28-.13z",
                                fill: "url(#linear-gradient-16)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M62.35 391.32l-.38-.23z",
                                fill: "url(#linear-gradient-17)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M58.76 389.5l-.51-.21z",
                                fill: "url(#linear-gradient-18)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M66.5 395.35l-.3-.44z",
                                fill: "url(#linear-gradient-19)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.16 347.11a20.58 20.58 0 00.13 2.24 20.58 20.58 0 01-.13-2.24z",
                                fill: "url(#linear-gradient-20)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M261.42 301.27a609.78 609.78 0 00-90.77-6.5c-46.73 0-84 4.81-111.68 12.89 51-4.09 112.85-6.49 179.48-6.49q11.55 0 22.97.1z",
                                fill: "url(#linear-gradient-21)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M72.61 389.43c13.52 1.46 23-7.28 24.46-8.66a31.57 31.57 0 0018.2 9.25 28.77 28.77 0 006.33.13L131.82 373c-46.35-1.93-87.72-5.09-121.25-9.13a59.82 59.82 0 0010.28 8.71 120.25 120.25 0 0022.79 12.05 68.6 68.6 0 006.89 2.19 39.55 39.55 0 006.15-4.29 30.07 30.07 0 0015.93 6.9z",
                                fill: "url(#linear-gradient-22)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M155.07 392.74c2.57 1.87 4.48 3.74 4.48 5.61a412.84 412.84 0 01-90.34 11.72 28.54 28.54 0 01-1.91 7.77 16 16 0 00-1.3 6.21c0 26.77 37.45 48.47 124.94 48.47s158.43-21.7 158.43-48.47v-.78c63.6-3.54 113.92-18.7 126.69-38-.21-7.4-5.85-14.4-15.75-20.65-29.28 3.34-64.08 6-102.68 7.86l17.73 29.73L301.4 385l-56.53 77.4-48.33-66.17.86-13.31z",
                                fill: "url(#linear-gradient-23)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M5.12 355.81q-.33-.71-.6-1.44.27.74.6 1.44z",
                                fill: "url(#linear-gradient-24)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.37 407.61v.37c-.01-.13-.01-.25 0-.37z",
                                fill: "url(#linear-gradient-25)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M192.24 426.24a32 32 0 004.63-3.2 31.16 31.16 0 003.95-3.93q-1.92-3.23-3.81-6.79c-.87-1.64-1.68-3.25-2.46-4.83-.25.51-.53 1.05-.88 1.63-.56.89-1.11 1.81-1.67 2.75q-1.16 2-2.22 3.85a33.81 33.81 0 011.82 5.95 34.18 34.18 0 01.64 4.57z",
                                fill: "url(#linear-gradient-26)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.67 351.54q-.17-.74-.27-1.5.11.77.27 1.5z",
                                fill: "url(#linear-gradient-27)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.31 344.19c0-.32.08-.63.12-.95-.04.32-.09.63-.12.95z",
                                fill: "url(#linear-gradient-28)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M4.27 353.68c-.15-.46-.29-.92-.41-1.39.14.47.26.93.41 1.39z",
                                fill: "url(#linear-gradient-29)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z",
                                fill: "url(#linear-gradient-30)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z",
                                fill: "url(#linear-gradient-31)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z",
                                fill: "url(#linear-gradient-32)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z",
                                fill: "url(#linear-gradient-33)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z",
                                fill: "url(#linear-gradient-34)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z",
                                fill: "url(#linear-gradient-35)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z",
                                fill: "url(#linear-gradient-36)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z",
                                fill: "url(#linear-gradient-37)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-38)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-39)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-40)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-41)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-42)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-43)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z",
                                fill: "url(#linear-gradient-44)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z",
                                fill: "url(#linear-gradient-45)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z",
                                fill: "url(#linear-gradient-46)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-48)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-49)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z",
                                fill: "url(#linear-gradient-50)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z",
                                fill: "url(#linear-gradient-51)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.86 352.29c-.07-.25-.14-.5-.19-.75.05.25.12.46.19.75z",
                                fill: "url(#linear-gradient-52)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M4.52 354.37z",
                                fill: "url(#linear-gradient-53)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M5.36 356.36l-.24-.55z",
                                fill: "url(#linear-gradient-54)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.16 347.11z",
                                fill: "url(#linear-gradient-55)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M6.38 358.27c0-.08-.08-.15-.13-.22s.08.14.13.22z",
                                fill: "url(#linear-gradient-56)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.44 343.18v.06a.64.64 0 000-.07z",
                                fill: "url(#linear-gradient-57)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-58)",
                                opacity: ".9",
                                d: "M10.57 363.88z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.4 350c0-.22-.08-.45-.11-.68.03.27.07.5.11.68z",
                                fill: "url(#linear-gradient-59)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z",
                                fill: "url(#linear-gradient-60)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z",
                                fill: "url(#linear-gradient-61)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-62)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-63)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-64)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-65)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-66)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-67)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-68)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-69)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-70)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-71)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-72)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-73)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-74)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-75)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-76)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-77)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-78)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-79)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-80)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-81)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-82)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z",
                                fill: "url(#linear-gradient-83)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z",
                                fill: "url(#linear-gradient-84)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z",
                                fill: "url(#linear-gradient-85)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z",
                                fill: "url(#linear-gradient-86)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z",
                                fill: "url(#linear-gradient-87)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-88)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-89)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-90)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-91)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-92)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-93)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-94)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-95)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-96)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-97)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-98)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-99)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-100)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-101)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-102)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-103)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-104)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-105)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-106)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-107)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-108)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-109)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-110)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-111)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-112)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-113)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-114)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-115)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-116)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-117)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-118)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-119)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-120)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-121)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-122)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-123)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-124)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-125)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z",
                                fill: "url(#linear-gradient-126)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z",
                                fill: "url(#linear-gradient-127)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-128)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-129)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-130)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-131)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-132)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-133)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-134)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-135)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-136)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-137)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-138)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-139)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-140)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-141)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-142)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-143)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-144)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-145)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-146)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-147)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-148)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-149)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-150)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-151)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-152)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-153)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-154)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-155)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-156)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-157)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-158)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-159)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-160)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-161)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-162)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-163)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-164)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-165)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-166)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-167)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-168)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-169)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-170)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-171)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-172)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-173)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-174)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-175)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-176)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-177)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-178)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-179)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-180)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-181)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-182)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-183)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-184)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-185)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-186)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-187)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-188)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-189)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-190)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-191)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-192)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-193)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-194)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-195)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-196)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-197)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-198)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-199)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-200)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-201)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-202)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-203)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-204)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-205)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-206)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-207)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-208)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-209)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-210)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-211)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-212)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-213)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-214)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.73 400.78z",
                                fill: "url(#radial-gradient)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.21 410.07z",
                                fill: "url(#radial-gradient-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.46c0-.72-.09-1.44-.18-2.15.09.69.15 1.43.18 2.15z",
                                fill: "url(#radial-gradient-3)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.13 403q-.12-.87-.3-1.71.17.83.3 1.71z",
                                fill: "url(#radial-gradient-4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.62v2c.03-.68.03-1.34 0-2z",
                                fill: "url(#radial-gradient-5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.81 392.36a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45 13.64 13.64 0 00-1.2-1.45 12.87 12.87 0 00-1.19-1.1z",
                                fill: "url(#radial-gradient-6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-228",
                                d: "M56.49 388.64z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M50.53 386.83l1.71.49-1.71-.49z",
                                fill: "url(#radial-gradient-8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-230",
                                d: "M62 391.09q-.73-.45-1.53-.84.77.39 1.53.84z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M60.16 390.12z",
                                fill: "url(#radial-gradient-10)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-230",
                                d: "M58.25 389.29l-1.4-.53z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.18 398.84a15.81 15.81 0 00-.74-1.8 15.81 15.81 0 01.74 1.8z",
                                fill: "url(#radial-gradient-12)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M67.22 396.61a14.16 14.16 0 00-.72-1.26 14.16 14.16 0 01.72 1.26z",
                                fill: "url(#radial-gradient-13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-228",
                                d: "M54.24 387.91l-1.46-.44z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.42 392.06z",
                                fill: "url(#radial-gradient-15)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M159.55 398.35c0-1.87-1.91-3.74-4.48-5.61l-40.65 9.44 7.18-12a28.77 28.77 0 01-6.33-.13 31.57 31.57 0 01-18.2-9.25c-1.46 1.38-10.94 10.12-24.46 8.66a30.07 30.07 0 01-15.93-6.89 39.55 39.55 0 01-6.15 4.29l1.71.49.54.15 1.46.44.45.13c.6.19 1.21.39 1.8.6l.36.12 1.4.53.51.21c.48.2.94.4 1.4.62l.28.13q.8.39 1.53.84l.38.23c.37.24.73.49 1.07.74l.39.3a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45l.3.44a14.16 14.16 0 01.72 1.26l.22.43a15.81 15.81 0 01.74 1.8l.06.19c.18.57.35 1.15.49 1.75 0 .17.07.33.1.5q.18.84.3 1.71c0 .11 0 .21.05.32.09.71.15 1.43.18 2.15V408.02c0 .7-.07 1.4-.14 2.09a412.84 412.84 0 0090.33-11.76z",
                                fill: "url(#linear-gradient-215)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z",
                                fill: "url(#linear-gradient-216)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z",
                                fill: "url(#linear-gradient-217)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-230",
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-218)",
                                d: "M245.54 265.79l-130.45-4.54 130.46 43.41L376 261.25l-130.46 4.54z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M239.61 200.11L154 337.73h91.59V198.21H243a4 4 0 00-3.39 1.9z",
                                fill: "url(#linear-gradient-219)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-240",
                                d: "M205.28 255.28l-3.12 5h43.39v-5h-40.27zM199.08 265.23l-3.11 5h49.58v-5h-46.47zM245.55 275.18h-52.66l-3.12 5h55.78v-5z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M251.49 200.11a4 4 0 00-3.41-1.9h-2.53v139.52h91.58z",
                                fill: "url(#linear-gradient-220)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M245.55 255.28h20.27v5.01h-20.27zM245.55 265.23h20.27v5.01h-20.27zM245.55 275.18h4.98v5.01h-4.98z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M246.9 226.91a41 41 0 0120.1 4.17 34.66 34.66 0 004.89 1.76l-20.36-32.73a4 4 0 00-3.41-1.9h-2.53V227c.41 0 .85-.06 1.31-.09z",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: {
                                    mixBlendMode: 'multiply'
                                },
                                fill: "url(#linear-gradient-221)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("ellipse", {
                                cx: "190.18",
                                cy: "308.96",
                                rx: "48.27",
                                ry: "5.8",
                                fill: "url(#linear-gradient-222)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M185.7 301.74a14 14 0 01.43 3.35 14.28 14.28 0 01-.31 3l-1.61.68-.34-.66-.57 1.09a14.39 14.39 0 01-3.08 1.26 8.93 8.93 0 01-2.56.42c-1.39 0-3.44-.35-3.53-1.06-.06-.44.67-.68 2.25-1.89a15.9 15.9 0 002.73-2.66 11.3 11.3 0 001.8-3.36l.3-.87z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M174.84 236.19c0 1.93-.39 5.85-.31 9.29.3 12.41.56 19.91 2 30.32.89 6.27 2.08 15.42 3.16 26.77a8.92 8.92 0 006.88-1c-.18-1.82-.4-4.76-.41-8.4 0-6.72.73-9.48.3-14.85a45.06 45.06 0 00-1.57-8.63q1.4-9.27 2.78-18.54a11.6 11.6 0 007-6.47 11.37 11.37 0 00-2.1-11.53z",
                                fill: "url(#linear-gradient-223)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                d: "M196.05 302a13.43 13.43 0 00-.57 3.33 14 14 0 00.19 3l1.57.75.37-.65c.18.37.36.74.53 1.11a14.08 14.08 0 003 1.38 9.27 9.27 0 002.55.53c1.39.07 3.45-.21 3.57-.91.08-.44-.64-.71-2.18-2a16.49 16.49 0 01-2.62-2.77 11.21 11.21 0 01-1.65-3.44l-.27-.88zM192.04 238.74l-.09 4.58-8.74-4.11 8.83-.47zM191.79 237.53l1.88-.45 1.62-.19-1.63 2.37-1.87-1.73z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                d: "M177.85 236.91q1.92 5.47 3.8 11.05 3.84 11.43 7.23 22.54l5.25 32.69 6.81-.95q-1.2-16.9-2.41-33.8c-.2-3.54-1.43-25.55-2-28.67-.1-.56-.25-1.09-.25-1.09a16.4 16.4 0 00-1.92-4.36l-1.25.63z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M201.33 28.18l-16.94.27a13.73 13.73 0 00-13.51 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.82v.09c0 .06.11.06.12 0v-.09a8.28 8.28 0 017.9-6.08 13.71 13.71 0 0013.56-13.94 13.74 13.74 0 00-13.94-13.52zM384.25 141.53l-16.93.26a13.74 13.74 0 00-13.52 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.83v.08a.07.07 0 00.13 0v-.09a8.26 8.26 0 017.9-6.07A13.73 13.73 0 00398.19 155a13.73 13.73 0 00-13.94-13.47z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M228.71 128.46a89.94 89.94 0 00-10.59 37.28l20.12-.08c1.83 0 2.47-1.38 1.5-3.1a91.86 91.86 0 01-11.03-34.1z",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: {
                                    mixBlendMode: 'multiply'
                                },
                                fill: "url(#linear-gradient-224)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-249",
                                d: "M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M192.09 291.26l-3.44-1.53a612 612 0 0040.22-125.5A612.62 612.62 0 00241.27 45H245a615.38 615.38 0 01-12.47 120 615.64 615.64 0 01-40.44 126.26z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M342.5 235.7c.15-.74.44-1 1.47-2.24l.88-1c2-2.42 2.53-3.68 3.34-3.68.57 0 .92 1 2 2.06 1.33 1.24 1.26 2 1.14 2.62-.18.85-2.92 4.06-4.43 4.51-.45.13-3 1.24-3.43 1-.93-.5-1.19-2.08-1-3.24"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M299.43 243.7c.3.22.77.55 1.34.92 1.68 1.08 8.57 2.84 10.74 3.75s12.52 3.33 14.57 3.06a6.65 6.65 0 001.78-.49l16.46-11.48-1.32-4.81c-7 3.08-11.64 5.5-18.65 8.58l-22.71-6.32-2.13 3.22z",
                                fill: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M308.31 220.59c.57-.87 1.3-2.19.83-2.85s-1.42-.18-3.85-.08c-3.5.13-3.88-.47-5.65.09a6.82 6.82 0 00-3.52 2.44c-1.68 2.39-.9 5.38-.66 6.28a10 10 0 004.55 5.8l1.9 1.21 5.37-9.24z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M302.16 236.73h7.25a13.5 13.5 0 01-.78-8.17l-4.42-.21c-.06.26-.14.63-.27 1.08a3.75 3.75 0 01-.48 1.23 2.58 2.58 0 01-1.94.84c.21 1.74.42 3.49.64 5.23",
                                fill: "#543e36"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M302.9 314.33c0-.14-2.25-.5-2.26-.65-.29-4.21-1-23.6-1.6-28.34-.89-7.08-1.73-13.77-1.27-16.81.12-.84.81-4 1.21-5.72a13.39 13.39 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.58.64.19a14.22 14.22 0 001.59.4c.45.09.82.14 1.09.17h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08 24.5 24.5 0 013.11 7.49c4.6 18.9 5.37 21.45 5.48 21.76v.2c.3 1.71 2.17 11.12 2.46 12.86-2.31 1.89-4.35 1.51-7.73 1.29-1.63-3.1-6.21-12.94-7.84-16.07l-3.58-6.91c0 5.11.16 22.38.13 27.49-3.05 1.27-4.25 4.1-7.41 3.55",
                                fill: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M300.94 274.09a11.32 11.32 0 01-2.37-5 15 15 0 01.41-6.31 14.78 14.78 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.59.64.2c.52.16 1 .3 1.59.41s.82.13 1.09.16h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08c2.66 4.2 3.58 9.74 4.87 14.53q1.46 5.37 2.73 10.79c.21.9 2.63 8.75 1.94 9.31-2.31 1.9-5.73 2.44-9.12 2.22-1.62-3.1-3.25-6.19-4.88-9.32-2-3.78-3.64-7.36-6.79-10.31a57.06 57.06 0 01-6-5.8",
                                fill: "#253858"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M308.31 220.59c.35.8.69 1.59 1 2.39l3.09 1.9c-.25.44-.5.88-.76 1.32l.27 4.75a11.78 11.78 0 01-3 1.6c-.42.14-.6.14-4.32.27-1.59.06-2.39.08-2.75-.36a2.08 2.08 0 01-.13-2c.24-.59.54-.54.82-1.12.43-.9-.11-1.42.17-2.27s.91-.67 1.9-1.71.9-1.95 2-3.35a6.5 6.5 0 011.69-1.45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M311.67 226.2a1.23 1.23 0 01.4.53 1.14 1.14 0 010 .73 4.73 4.73 0 01-1.2.42 4.66 4.66 0 01-.92.09c0 .24.06.57.11 1 .14 1 .22 1.13.31 1.18.33.18 1-.2 1.28-.75a1.45 1.45 0 00.14-.64 2.26 2.26 0 01.7 1.13 2.29 2.29 0 01-.28 1.63 3 3 0 01-2.26 1.29h-.15c-4 .2-4.31.2-4.56.13-2.28-.69-2.12-7.66-2.12-8l2.54-1.52a3.32 3.32 0 00-.32 2.85c.09.21.55 1.39 1.5 1.58s1.5-.89 3.4-1.42a6.35 6.35 0 011.4-.24"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M343 230.84s1.53 1.69.62 3.1c-.64 1 1.8 1.33 1.8 1.33a2.2 2.2 0 00.24-3.06c-1.29-1.77-2.66-2.34-2.66-1.37"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M372.38 264.49a513.32 513.32 0 01-70.76-88 512.55 512.55 0 01-57.87-126l3.59-1.1a508.92 508.92 0 0057.45 125.07A509.3 509.3 0 00375 261.83z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M348 228.66s-1.78 3.06-1.21 3.71 1.21-.08 1.21-.08-.73 1-.4 1.45 1.12-.32 1.12-.32-.64 1 0 1.37 1.05-.49 1.05-.49-.56 2.1 0 1.86 1.21-1 1.61-2.74-2-5.32-3.38-4.76M330.15 211.75c.29-.72-.1-1.12 0-3.88v-.51c0-1.44-.95-2-3.35-4.71-.59-.66-1.52-1.73-1.9-1.53a.67.67 0 00-.28.37c-.08.26.06.42 0 .53s-.55-.09-.73 0 .18 1.12.62 2.24c.8 2 .82 2.67.69 3.21 0 .13-.24.93-.7 1-.13 0-.3 0-.7-.34a8 8 0 01-1.14-1.27c-.52-.6-1.3-1.16-1.5-1s.13.53.27 1.39a13.9 13.9 0 010 1.62c.08.62.44 1 2.56 2.79a9.87 9.87 0 002.38 1.73 3.49 3.49 0 003.74-1.69"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M325.44 212.82c1.91 6.66 1 18.09 1 18.09s-13.3 3.32-16.49 3.61c0 0-6.81.64-10.54 2.5-.88.44-1.74.95-1.74.95-.47.28-.77.48-.77.48l-.1.06a4.93 4.93 0 00-1.9 5.56c.37 1.21.72 2.47 1.05 3.79a74.38 74.38 0 012.19 16.19 30.77 30.77 0 0021.17-1.62 99.26 99.26 0 01-1.49-11.3c-.18-2.33-.26-4.56-.28-6.67 2.38-.56 9.65-4.62 14.18-7.35a6.26 6.26 0 002.93-6.54c-1.15-6.13-2.93-16.42-4.23-19.47-3.12 1.12-4.98 1.72-4.98 1.72z",
                                fill: "url(#linear-gradient-225)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-226)",
                                d: "M376 261.25l-38.87 76.48-91.58-33.07L376 261.25z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M318.63 280.34l-5 1.67v35.67h5v-37.34zM328.59 277.03l-5.01 1.66v38.99h5.01v-40.65zM338.54 273.72l-5.01 1.66v27h5.01v-28.66z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-227)",
                                d: "M337.13 337.73H153.96l91.59-33.07 91.58 33.07z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-228)",
                                d: "M245.55 304.66l-91.59 33.07-38.87-76.48 130.46 43.41z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M245.55 0a5 5 0 015 5v201.67h-5V0z",
                                fill: "#fafbfc"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-242",
                                d: "M245.54 0v206.67h-5V5a5 5 0 015-5z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M250 101.43a90.13 90.13 0 000 94.19h98.7a90.13 90.13 0 010-94.19z",
                                fill: "url(#linear-gradient-229)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M306.75 128.62a6.3 6.3 0 01-5.66-3.1c-.89-1.2-1.45-2-3.23-2s-2.81.78-4.33 2c-1.75 1.38-3.86 3.1-7.17 3.1a6.29 6.29 0 01-5.66-3.1c-.89-1.2-1.45-2-3.24-2s-2.8.78-4.32 2c-1.75 1.38-3.86 3.1-7.18 3.1a6.28 6.28 0 01-5.65-3.1c-.89-1.2-1.45-2-3.23-2 .37-1.27.76-2.52 1.18-3.77 3.31 0 4.46 1.68 5.44 3 .85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3s4.47 1.68 5.45 3c.85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3a5.86 5.86 0 015.45 3c.85 1.19 1.44 2 3.22 2s2.79-.79 4.35-2c1.78-1.37 4.07-3 7.38-3-.42 1.25-.81 2.5-1.17 3.77-1.78 0-2.82.78-4.34 2-1.74 1.38-3.85 3.1-7.17 3.1z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M304.88 140.51a7.32 7.32 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.7.8-4.05 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.69.8-4 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1-1.22-1.72-2-3.5-2 .19-1.3.41-2.58.66-3.87 3.31 0 4.7 1.73 5.86 3.13 1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.59-1.4 3.64-3.13 7-3.13s4.7 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.6-1.4 3.64-3.13 7-3.13s4.71 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.69-.81 4.08-2c1.6-1.4 3.64-3.13 7-3.13-.24 1.29-.46 2.57-.65 3.87-1.78 0-2.71.8-4.06 2-1.73 1.4-3.61 3.15-6.93 3.15z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M304.61 152.52c-3.31 0-5.11-1.75-6.5-3.16-1.21-1.23-2-2-3.78-2s-2.58.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.22-1.23-2-2-3.78-2s-2.59.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.21-1.23-2-2-3.77-2 0-1.3.06-2.61.14-3.91 3.31 0 4.93 1.76 6.28 3.17 1.18 1.23 2 2 3.76 2s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.93 1.76 6.29 3.16c1.18 1.24 2 2.05 3.76 2.05s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.94 1.76 6.29 3.16c1.18 1.24 2 2.05 3.77 2.05s2.57-.81 3.8-2.05c1.41-1.41 3.22-3.16 6.54-3.16-.07 1.3-.12 2.61-.13 3.91-1.78 0-2.6.81-3.79 2-1.37 1.45-3.02 3.2-6.34 3.2z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M306 164.48c-3.32 0-5.35-1.74-6.92-3.13-1.38-1.23-2.27-2-4.06-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.13c-1.38-1.23-2.27-2-4.05-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.14c-1.38-1.22-2.26-2-4-2-.16-1.29-.29-2.59-.38-3.89 3.31 0 5.16 1.75 6.7 3.16 1.34 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16s5.17 1.75 6.71 3.16c1.34 1.22 2.25 2 4 2s2.46-.81 3.54-2a7.4 7.4 0 016.11-3.16c3.32 0 5.17 1.75 6.71 3.16 1.35 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16.1 1.3.23 2.6.38 3.89-1.78 0-2.48.81-3.51 2-1.18 1.38-2.59 3.12-5.85 3.12z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M297.21 171.16c-1.78 0-2.37.8-3.24 2-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.35-3.06c-1.54-1.19-2.53-2-4.32-2s-2.37.8-3.24 2c-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.34-3.06c-1.55-1.19-2.54-2-4.32-2-.33-1.27-.63-2.54-.91-3.82 3.32 0 5.4 1.72 7.14 3.1 1.5 1.2 2.52 2 4.3 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1c3.31 0 5.4 1.73 7.13 3.1 1.51 1.2 2.53 2 4.31 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M182.26 189.82c-3.63 5.16 4.34 17.38 9.25 16.82 3.35-.38 5.2-6.62 5.37-7.19.51-1.71 1.53-5.17-.43-8.4a8.93 8.93 0 00-5.3-3.83c-3.29-.83-7.22.24-8.89 2.6z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M183 208.52l4.17 1 2.6-10.5-8.24-2.02c-.79.44-4 2.37-4.69 6-.18.92-.55 2.8.6 4.25s3.33 1.91 5.56 1.27z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M185 214.79c-3.72 1.33-6.9 2.27-9.32 2.92a48.24 48.24 0 01-6.84 1.37c-2.58.33-3.87.5-4.44.12-1.92-1.27-.92-5.22.43-16 .35-2.79.6-5.06.75-6.44.08-.62.17-1.24.25-1.86l4.48.28c-.36.73-.73 1.45-1.09 2.17q.09 7.35.17 14.7l11.43-4.33a6.71 6.71 0 011.79.42 5 5 0 012.6 2.17 5.08 5.08 0 01-.21 4.48z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M170.77 211.15l12.4-4.57a5.61 5.61 0 014 3.4 5.46 5.46 0 01-.66 4.76l-14 3.69a7.85 7.85 0 00-1.74-7.28z",
                                fill: "url(#linear-gradient-230)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175 217c.55-2.31 1.68-1.93 3.36-5.75a8.35 8.35 0 011.9-3.26 6.41 6.41 0 012.65-1.45h5.5a4.58 4.58 0 001.57 1.64c1.52.92 2.8.45 4.8.91h.1a6 6 0 012.88 1.68 5.09 5.09 0 011.45 3 15.48 15.48 0 01-1.72 8.3 33.5 33.5 0 00-2.49 10.49c.45 1.24 1 4.27 1.48 5.52a34.78 34.78 0 01-22.07.15c2-9.74 1.61-13.49 1.16-15.16-1.11-4.31-.89-4.72-.57-6.07z",
                                fill: "url(#linear-gradient-231)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M183.33 208.07a10.5 10.5 0 003.56.61 10.74 10.74 0 004.19-.87 8.4 8.4 0 01-1-2.18 7.87 7.87 0 01-.26-2.87l-6.77.9z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M183.82 190.38a22.9 22.9 0 00-1.07 2.16 22.06 22.06 0 00-1.08 3c-.11.14-.31.4-.58.71-.83.92-1.62 1.41-1.47 1.7 0 0 .75.45.87.58s-.3 2.64.09 3.7c.79 2.16 7.2 3.64 9.76 1a4.13 4.13 0 001.07-2.3 3.3 3.3 0 00-.32-.18 3.38 3.38 0 00-2.45-.1 4.19 4.19 0 00.05-2.92c-.35-.86-.82-.95-2.89-3.07a6.6 6.6 0 01-1.62-2.1 5.08 5.08 0 01-.36-2.18z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M191 210.05a4.52 4.52 0 004.83-.1 4.18 4.18 0 001.41-3c.12-1.79-.95-2.42-1.07-4.33a6.26 6.26 0 01.73-3.2 19.22 19.22 0 01-3.22-.73 20.07 20.07 0 01-4.09-1.86 5.26 5.26 0 01-.24 2.62c-1 2.6-3.62 2.62-4.52 5a4.53 4.53 0 00.6 4.25c1.11 1.49 3.31 1.99 5.57 1.35z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M200.34 250.5c-.18 1.21-.3 2.37-.43 3.57s-.23 2.66-.47 3.74a1.2 1.2 0 01-.67.84c-.22.1-.05-.37-.18-.24s0 .54-.24.73a.16.16 0 01-.17.07c-.13 0-.19-.43-.31-.42s-.17.38-.26.48-.21.31-.4.31-.11-.31-.32-.31-.2.69-.41.65-.29-.36-.31-.77c-.08-1.29.37-2.64.42-4.14a13.93 13.93 0 00-.26-2.58 7.75 7.75 0 00-.91 1.73 3.64 3.64 0 01-.74 1.27.89.89 0 01-.66.31c-.19 0-.46 0-.45-.14a14.18 14.18 0 01.73-2.6c.51-1.55 1.32-4.23 2.95-4.6s2.28 1.16 3.09 2.1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M199.33 214.4c.9 4.85 1.91 8.62 2.45 14.62a80.48 80.48 0 01-1.44 21.89 21 21 0 01-3-.27c.2-6.68.5-13.68-1.15-20.08-1.24-4.83-3.2-9.14-4.74-13.52-.84-2.4-.6-3.89 1-5.53a2.41 2.41 0 011.84-.89c2.56.08 4.42.49 5.04 3.78z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M192.31 211.52a4.9 4.9 0 011.81-.94 4.37 4.37 0 015.16 3.47l1.82 8.67a8.3 8.3 0 00-3.41.68 9 9 0 00-3.26 1.74c-1-2.44-1.82-4.9-2.8-7.34a6 6 0 01-.45-4.56 4 4 0 011.13-1.72z",
                                fill: "url(#linear-gradient-232)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M156.83 188.77H160a.49.49 0 01.49.49v9.65h-4.14v-9.65a.49.49 0 01.48-.49z",
                                transform: "rotate(91.28 158.41 193.83)",
                                fill: "url(#New_Gradient_Swatch_13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M166.94 189.54H169a.5.5 0 01.5.5v8.51h-3.08V190a.5.5 0 01.52-.46z",
                                transform: "rotate(91.28 167.981 194.045)",
                                fill: "url(#New_Gradient_Swatch_13-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                transform: "rotate(91.28 176.118 194.226)",
                                fill: "url(#New_Gradient_Swatch_13-3)",
                                d: "M175.15 190.6h1.92v7.27h-1.92z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                x: "178.59",
                                y: "193.96",
                                width: "3.06",
                                height: ".74",
                                rx: ".3",
                                transform: "rotate(91.28 180.12 194.325)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                x: "150.26",
                                y: "193.12",
                                width: "4.96",
                                height: "1.2",
                                rx: ".49",
                                transform: "rotate(91.28 152.736 193.71)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M168 194.23h1.47a.73.73 0 00.73-.73V192a1 1 0 00-.21-.52 1 1 0 00-.64-.36l-1.35-.02a.76.76 0 00-.56.24.85.85 0 00-.18.69v1.47a.74.74 0 00.74.73z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                x: "166.04",
                                y: "191.29",
                                width: "1.47",
                                height: "2.35",
                                rx: ".73",
                                transform: "rotate(180 166.77 192.47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                x: "169.9",
                                y: "191.29",
                                width: "1.47",
                                height: "2.35",
                                rx: ".73",
                                transform: "rotate(-180 170.63 192.47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-249",
                                d: "M186.39 387.41l.65-2.09-.93.22c.1.62.19 1.24.28 1.87zM197.57 400.68c-.29 4.12-.58 7.54-.79 8.63-.1.55-.25 1.09-.25 1.09l-.14.48.38.12c-.45 1.24-1 4.28-1.48 5.52.14 1.52.35 2.89.59 4.14.22-.71.43-1.42.61-2.14 1.46-5.69 1.4-11.84 1.22-17.83zM344.22 423.89c-6-2.63-10-4.71-16-7.35l-2.05.57c2.65 1.35 6 3.24 8.38 4.69a5.4 5.4 0 012.52 5.62c-.48 2.55-1.08 5.92-1.7 9q4.68-5.9 9.55-11.63v-.06c-.31-.35-.54-.62-.7-.84z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M200.61 398.16h-.05c-.15-1.06-.26-2.09-.38-3.15s-.23-2.66-.47-3.74a1.2 1.2 0 00-.67-.84c-.22-.1 0 .36-.18.24s0-.55-.24-.73a.14.14 0 00-.17-.07c-.09 0-.14.19-.2.31.18-3 .33-5.72.44-7.56l-1.29.3-10.4 2.4-.65 2.09c-.09-.63-.18-1.25-.28-1.87L175.36 388c-.27 4.63-.41 9.51-.56 15.57-.05 2.44.1 5.11.21 7.15l-.31.09c2.05 9.75 1.61 13.5 1.16 15.17-.84 3.19-.93 4.24-.8 5.11a49.27 49.27 0 00-5.92-1.13c-2.58-.33-3.87-.49-4.44-.12-1.92 1.28-.92 5.23.43 16.05.35 2.79.6 5.06.75 6.43.05.4.11.79.16 1.19h-2.31a.5.5 0 00-.5-.48l-9.65.22a.47.47 0 00-.48-.43h-.23a.5.5 0 00-.48.5l.09 4a.49.49 0 00.5.47h.23a.48.48 0 00.46-.44l9.64-.21a.5.5 0 00.48-.51l2.51-.06v.44a.73.73 0 00.73.73.69.69 0 00.55-.26.9.9 0 00.14.22.81.81 0 00.56.24l1.35-.05a1 1 0 00.64-.36l.05-.09a.7.7 0 00.57.3.73.73 0 00.74-.73v-.56h.65a.52.52 0 00.49-.52v-.07l7.26-.16v.3a.3.3 0 00.3.29h.14a.31.31 0 00.3-.31l-.06-2.46a.29.29 0 00-.3-.29h-.14a.3.3 0 00-.3.31v.27l-7.27.17v1-1a.5.5 0 00-.51-.49h-1.86l-.84-1.68q.09-7.35.17-14.69l1.57.59a2.88 2.88 0 01-.22.27l7.91 2.91a3.91 3.91 0 00-1.24 1c-1.15 1.44-.78 3.32-.6 4.25a8.52 8.52 0 003 4.84l-.25.16c-.15.28.64.78 1.47 1.7.27.3.47.56.58.71-.53 2.19-.45 4.27.59 5.76 1.67 2.36 5.6 3.43 8.89 2.59a8.85 8.85 0 005.3-3.82c2-3.23.94-6.69.43-8.41-.05-.17-.26-.86-.61-1.75a5.53 5.53 0 01-.12-1.44c.12-1.91 1.19-2.55 1.08-4.33a4.5 4.5 0 00-1.1-2.67 6.4 6.4 0 001.63-1.21 5.13 5.13 0 001.44-2.92c0-.09.06-.18.08-.28l1.82-8.67h-.15c.33-1.89.62-3.93.83-6.32a80.51 80.51 0 00-1.38-21.92zm-4.12 20.36c-.18.72-.39 1.43-.61 2.14-.24-1.25-.45-2.62-.59-4.14.45-1.24 1-4.28 1.48-5.52l-.38-.12c.05-.17.11-.34.14-.48s.15-.54.25-1.09c.21-1.09.5-4.51.79-8.63h.14c.18 6 .29 12.15-1.22 17.84z",
                                fill: "url(#linear-gradient-233)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-234)",
                                d: "M301.4 385.02l4.39 1.02"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M327.83 451.92c.16.11.51-.12.63 0s0 .23 0 .45a.61.61 0 00.24.32c.32.17 1.12-.75 1.63-1.31 2.06-2.31 2.85-2.82 2.88-4.05v-.44a18.86 18.86 0 01.07-2.53q6.66-8.68 13.75-17c.64.85 1 1.38 1.39 1.56l.08.14c1 .4 2.55-1.6 2.88-3.17a1.68 1.68 0 000-.91 4.62 4.62 0 00-.76-1.83q9.87-11.32 20.49-21.94l-3.69-.86q-10.01 10.16-19.42 20.93a2 2 0 00-.41-.18c-.29-.09-1.56-.63-2.35-.82l.13-.5-14.14-9.86a5.44 5.44 0 00-1.53-.42c-1-.14-4.17.44-7.13 1.13 0-.3 0-.58.05-.88a85.6 85.6 0 011.28-9.71l-.86-.37a21.52 21.52 0 002.58-6.27c.11-.48.23-.94.34-1.4l.3-1.21-20.47-4.79a41.87 41.87 0 00-.41 8.76c.09.56.46 2.3.78 3.74l-.43.11a63.72 63.72 0 01-1.88 13.92c-.28 1.12-.58 2.21-.91 3.25a4.26 4.26 0 001.64 4.78h.09l.66.41s.73.44 1.5.82a14.06 14.06 0 002.25.86l-.27 2.27-1.49.95a8.58 8.58 0 00-3.91 5c-.21.78-.88 3.35.56 5.4a5.72 5.72 0 003 2.09c1.52.49 1.85 0 4.85.09 2.09.08 2.95.43 3.31-.07s-.22-1.71-.71-2.45c.29-.69.59-1.37.88-2.06l2.66-1.63c-.22-.38-.44-.76-.65-1.14a1.06 1.06 0 00.34-.45 1 1 0 000-.63l-.29-.13v-1a1.82 1.82 0 00.6-1 1.9 1.9 0 00-.24-1.4 2.56 2.56 0 00-1.94-1.11h-.13l-1.22-.06a12.75 12.75 0 01.27-1.55l1.08.12c2.74.26 14.17 3.11 14.17 3.11s.75 9.78-.88 15.51l-1.22 1c-1.82 1.5-2.13 1.86-2.2 2.4a9.91 9.91 0 010 1.39c-.12.73-.36 1.1-.23 1.2s.62-.21 1-.62q-5.31 7.17-10.32 14.54 3-1.26 5.7-2.58 2.89-4.12 5.86-8.2a.26.26 0 00.17.28zm-1.62-34.81l2.05-.57c6 2.64 10 4.72 16 7.35.16.22.39.49.72.87v.06q-4.87 5.73-9.55 11.63c.62-3.11 1.22-6.48 1.7-9a5.4 5.4 0 00-2.52-5.62c-2.43-1.48-5.75-3.37-8.4-4.72z",
                                fill: "url(#linear-gradient-235)"
                            })
                        ]
                    })
                })
            })
        ]
    });

});


parcelRegister("lzAG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $2be71cde816260d0$export$2e2bcd8739ae039);

var $gVn2t = parcelRequire("gVn2t");
var $gF2uJ = parcelRequire("gF2uJ");
var $jIu2u = parcelRequire("jIu2u");
var $hOHHh = parcelRequire("hOHHh");
var $kbWAD = parcelRequire("kbWAD");
var $8VV1g = parcelRequire("8VV1g");
var $3RELU = parcelRequire("3RELU");
var $2GLVw = parcelRequire("2GLVw");
var $cyCkO = parcelRequire("cyCkO");
var $2kuK5 = parcelRequire("2kuK5");
var $ec4Zm = parcelRequire("ec4Zm");
var $adxPR = parcelRequire("adxPR");
var $7iSe8 = parcelRequire("7iSe8");
var $aRmqS = parcelRequire("aRmqS");
var $bSlng = parcelRequire("bSlng");
var $kZZGF = parcelRequire("kZZGF");
var $cZnHy = parcelRequire("cZnHy");
var $hmXBb = parcelRequire("hmXBb");
var $d39bX = parcelRequire("d39bX");
var $7em2L = parcelRequire("7em2L");
var $fbSjx = parcelRequire("fbSjx");
var $fazBu = parcelRequire("fazBu");
var $4lHnX = parcelRequire("4lHnX");
var $j9BMn = parcelRequire("j9BMn");
var $9CxAQ = parcelRequire("9CxAQ");
const $2be71cde816260d0$var$localeToTranslations = {
    'cs-CZ': $gVn2t.default,
    'da-DK': $gF2uJ.default,
    'de-DE': $jIu2u.default,
    'en-US': $hOHHh.default,
    'en-GB': $kbWAD.default,
    'en-ZZ': $8VV1g.default,
    'es-ES': $3RELU.default,
    'fi-FI': $2GLVw.default,
    'fr-FR': $cyCkO.default,
    'hu-HU': $2kuK5.default,
    'it-IT': $ec4Zm.default,
    'ja-JP': $adxPR.default,
    'ko-KR': $7iSe8.default,
    'no-NO': $aRmqS.default,
    'nl-NL': $bSlng.default,
    'pl-PL': $kZZGF.default,
    'pt-BR': $cZnHy.default,
    'ru-RU': $hmXBb.default,
    'sv-SE': $d39bX.default,
    'tr-TR': $fbSjx.default,
    'th-TH': $7em2L.default,
    'uk-UA': $fazBu.default,
    'vi-VN': $4lHnX.default,
    'zh-TW': $9CxAQ.default,
    'zh-CN': $j9BMn.default
};
const $2be71cde816260d0$var$fetchTranslations = async (locale)=>$2be71cde816260d0$var$localeToTranslations[locale] ?? $hOHHh.default;
var $2be71cde816260d0$export$2e2bcd8739ae039 = $2be71cde816260d0$var$fetchTranslations;

});
parcelRegister("gVn2t", function(module, exports) {
$parcel$export(module.exports, "default", () => $de84e86711535e87$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $86zeU = parcelRequire("86zeU");
var $de84e86711535e87$export$2e2bcd8739ae039 = (0, $86zeU.default);

});
parcelRegister("86zeU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8813ea85494e9a0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $f8813ea85494e9a0$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hledali jsme v\u0161ude, ale tato polo\u017Eka neexistuje. Mohla b\xfdt odstran\u011Bna. Pokud ov\u0161em nem\xe1te p\u0159eklep v\xa0adrese URL.",
    'embedded-confluence-common.src.content.empty-state-header': "Nem\u016F\u017Eeme naj\xedt, co hled\xe1te",
    'embedded.confluence.already-logged-in-paragraph': "Jste ji\u017E p\u0159ihl\xe1\u0161eni? Zkuste obnovit str\xe1nku.",
    'embedded.confluence.footer.hover.text': "Zobrazit v\xa0Confluence",
    'embedded.confluence.footer.prefix': "Pou\u017E\xedv\xe1 technologii",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "P\u0159ihlaste se do Confluence",
    'embedded.confluence.login-page.login-button': "P\u0159ihl\xe1sit se do Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Tla\u010D\xedtko p\u0159ihl\xe1\u0161en\xed",
    'embedded.confluence.login-page.login-text': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.login-page.refresh-page-banner': "Po p\u0159ihl\xe1\u0161en\xed by se tato str\xe1nka m\u011Bla automaticky obnovit. Pokud ne, m\u016F\u017Eete ji obnovit kliknut\xedm zde.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Obnovit str\xe1nku",
    'embedded.confluence.need-to-log-in-paragraph': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.still-having-trouble-paragraph': "Po\u0159\xe1d m\xe1te pot\xed\u017Ee? Ujist\u011Bte se, \u017Ee jsou povoleny soubory cookies t\u0159et\xedch stran, nebo {link}",
    'embedded.confluence.troubleshooting-link-text': "se pod\xedvejte se do pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F.",
    'embedded.confluence.troubleshooting-link.aria-label': "odkaz na pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F"
};

});


parcelRegister("gF2uJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4151db95aa266f6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iCo1l = parcelRequire("iCo1l");
var $d4151db95aa266f6$export$2e2bcd8739ae039 = (0, $iCo1l.default);

});
parcelRegister("iCo1l", function(module, exports) {
$parcel$export(module.exports, "default", () => $e04985d3e12bc10d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $e04985d3e12bc10d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har ledt overalt, men den eksisterer ikke. Den er muligvis blevet slettet. Medmindre der er en sl\xe5fejl i webadressen, selvf\xf8lgelig \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi kunne ikke finde det, du leder efter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget ind? Pr\xf8v at genindl\xe6se.",
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Drevet af',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Log p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Log ind p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Loginknap',
    'embedded.confluence.login-page.login-text': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.login-page.refresh-page-banner': "N\xe5r du har logget ind, b\xf8r denne side genindl\xe6ses automatisk. Hvis ikke, kan du klikke her for at genindl\xe6se",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Genindl\xe6s siden",
    'embedded.confluence.need-to-log-in-paragraph': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.still-having-trouble-paragraph': "Har du stadig problemer? S\xf8rg for, at tredjepartscookies er aktiveret, eller {link}",
    'embedded.confluence.troubleshooting-link-text': 'se denne fejlfindingsvejledning.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link til fejlfindingsvejledning'
};

});


parcelRegister("jIu2u", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae8fd2519722df33$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $OKt1m = parcelRequire("OKt1m");
var $ae8fd2519722df33$export$2e2bcd8739ae039 = (0, $OKt1m.default);

});
parcelRegister("OKt1m", function(module, exports) {
$parcel$export(module.exports, "default", () => $4268ac55a57b7b64$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $4268ac55a57b7b64$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Wir haben \xfcberall gesucht, aber sie existiert nicht. Sie k\xf6nnte gel\xf6scht worden sein. Es sei denn, in der URL ist ein Tippfehler enthalten \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Wir konnten nicht finden, wonach Sie suchen',
    'embedded.confluence.already-logged-in-paragraph': 'Bereits eingeloggt? Aktualisieren Sie die Seite.',
    'embedded.confluence.footer.hover.text': 'In Confluence anzeigen',
    'embedded.confluence.footer.prefix': 'Bereitgestellt von',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button.aria-label': "Login-Schaltfl\xe4che",
    'embedded.confluence.login-page.login-text': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.login-page.refresh-page-banner': "Nach dem Einloggen sollte diese Seite automatisch aktualisiert werden. Wenn dies nicht der Fall ist, k\xf6nnen Sie zum Aktualisieren hier klicken.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Seite aktualisieren',
    'embedded.confluence.need-to-log-in-paragraph': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.still-having-trouble-paragraph': 'Besteht das Problem weiterhin? Vergewissern Sie sich, dass Cookies von Drittanbietern aktiviert sind, oder {link}',
    'embedded.confluence.troubleshooting-link-text': 'lesen Sie den Leitfaden zur Fehlerbehebung.',
    'embedded.confluence.troubleshooting-link.aria-label': 'Link zum Leitfaden zur Fehlerbehebung'
};

});


parcelRegister("hOHHh", function(module, exports) {
$parcel$export(module.exports, "default", () => $35aac9ab42f58e18$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fa9oE = parcelRequire("fa9oE");
var $35aac9ab42f58e18$export$2e2bcd8739ae039 = (0, $fa9oE.default);

});
parcelRegister("fa9oE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e00759fdb5dd3dbf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $e00759fdb5dd3dbf$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};

});


parcelRegister("kbWAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $2722a1e3e6a2d193$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $4SI1O = parcelRequire("4SI1O");
var $2722a1e3e6a2d193$export$2e2bcd8739ae039 = (0, $4SI1O.default);

});
parcelRegister("4SI1O", function(module, exports) {
$parcel$export(module.exports, "default", () => $9591cf622278f558$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $9591cf622278f558$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};

});


parcelRegister("8VV1g", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fde875848e0e1d3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iUxRF = parcelRequire("iUxRF");
var $5fde875848e0e1d3$export$2e2bcd8739ae039 = (0, $iUxRF.default);

});
parcelRegister("iUxRF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2695162625fbad9d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2695162625fbad9d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u2063\u2062We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09\u206A\x81\u206C\u2061\u200D\u2060\u061C\u206E\u2061\x9d\u2061\u2061\u206F\x8f\u206F\u206A\u2061\u206E\u206E\u206B\u2060\u2061\u061C\u206B\x9d\x8f\u206E\x9d\x81\u200D\x8d\u206F\u2063\u2064",
    'embedded-confluence-common.src.content.empty-state-header': "\u2063\u2062We couldn't find what you're looking for\u2061\u200C\u206E\x81\x8f\u206E\u206C\u206A\u206C\u061C\u206B\u206B\u200C\u206D\x8d\x8f\u206A\u200D\u2061\u2061\x8d\u200C\u200D\u2061\u206C\x8f\u206F\u206D\u206F\u2061\u206D\u206D\u2063\u2064",
    'embedded.confluence.already-logged-in-paragraph': "\u2063\u2062Already logged in? Try refreshing.\x90\x90\u206A\x8f\u200D\u206C\u200D\x9d\u206A\x8f\x81\x8f\u200C\x9d\x8d\u206C\x8f\u2060\x90\x90\u206D\x81\u061C\x8d\u2061\x81\u206E\u206D\x90\u2060\u200D\u206F\u2063\u2064",
    'embedded.confluence.footer.hover.text': "\u2063\u2062View in Confluence\u200C\u206D\u200D\x90\u200D\u2061\u206C\u206D\x9d\u2060\x9d\x9d\u206A\u2061\u2061\u061C\u2060\u2060\u2060\u200D\u206E\x90\x81\u200C\x8f\u2060\u2060\u206D\u2060\u2060\u206C\u206F\u2063\u2064",
    'embedded.confluence.footer.prefix': "\u2063\u2062Powered by\u206C\x8f\u206B\u206E\u206B\u200C\x8d\x90\u206C\x81\x8f\u206C\x8f\u200C\x8d\x9d\u206F\u061C\u206E\x9d\u206D\x9d\u206F\x90\u061C\u061C\u200C\x8f\u200C\u206B\u206F\u200C\u2063\u2064",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u2063\u2062Log in to Confluence\u061C\u2060\u2060\u206F\x8d\u2061\u206E\x81\x9d\x90\x8f\u206E\x81\x8d\x8f\x90\u206F\u2061\u061C\x8d\u206C\u206D\u206A\x81\u206D\x9d\u206A\x8f\u206E\x81\u206E\u206D\u2063\u2064",
    'embedded.confluence.login-page.login-button': "\u2063\u2062Log in to Confluence\u206D\u206A\u206A\x8d\u206F\u061C\u200C\u061C\u206C\u206B\u2061\u061C\u200C\x90\u206A\u206D\u206A\u206B\u200D\u061C\u206B\x8f\x90\u200C\u206B\u206E\u206C\u206A\u2061\x81\u206A\x90\u2063\u2064",
    'embedded.confluence.login-page.login-button.aria-label': "\u2063\u2062Login Button\x8d\x90\u206E\x90\u206D\x8d\u061C\u200C\u206E\x90\x8d\u061C\u2060\u200D\u206F\x8d\u206D\u2061\x81\u200D\x90\x8d\x90\x90\x9d\u061C\u206F\x81\u206E\u200C\x9d\x90\u2063\u2064",
    'embedded.confluence.login-page.login-text': "\u2063\u2062You need to be logged in to view this page\u206F\u206A\u200C\x8d\u206E\x81\x81\u2061\x81\x90\u206F\u2060\x8d\u206E\x8f\x9d\x90\u2061\u2061\u206F\u200D\x81\x90\u206C\u206D\u206B\x90\u206A\u206E\u2060\u2061\x90\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner': "\u2063\u2062After logging in, this page should refresh automatically. If not, you can click here to refresh\u200C\x81\u200D\u200D\u206F\u206D\x90\u200C\u206D\x81\u2060\u206A\u2061\x8d\u206C\u200C\x90\x8d\x8f\x8f\u2061\x9d\u206E\x9d\u2060\u2061\u2060\u061C\x8f\u206C\u206D\u2061\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u2063\u2062Refresh page\u2060\x90\u2061\u061C\u200D\u206E\x8d\x90\u200D\x9d\u2060\u206A\u2061\x90\x8d\x8f\u206E\x8d\x9d\u206A\x9d\u061C\u206B\x8f\u206B\u200D\u061C\u206E\u206A\u206C\u206A\x90\u2063\u2064",
    'embedded.confluence.need-to-log-in-paragraph': "\u2063\u2062You need to be logged in to view this page\u200D\u061C\u206D\u206C\u206E\u206D\u206F\x8d\u206F\x8d\u061C\u206E\u206A\u206F\u206E\u206C\u206F\u200D\x90\u2061\x81\x90\x81\u206E\x8d\x8f\x8f\x90\u206D\x90\u206C\u206F\u2063\u2064",
    'embedded.confluence.still-having-trouble-paragraph': "\u2063\u2062Still having trouble? Make sure 3rd party cookies are enabled, or {link}\x90\x90\u061C\u206E\x90\u206D\x90\x8f\u200D\x8d\x8d\u061C\u206D\x9d\x9d\x90\u061C\u206D\x8d\x8f\u061C\u200C\u2061\u206E\u206A\x9d\x9d\u206F\x81\u206F\u2061\u206F\u2063\u2064",
    'embedded.confluence.troubleshooting-link-text': "\u2063\u2062refer to this troubleshooting guide.\u206C\u206A\x90\u206D\u2061\x81\x8d\x8f\u206F\x9d\u206B\u206C\x81\u206A\u206B\u206C\u200D\u200C\x8d\u206B\u200C\x90\u206C\u061C\u061C\x8f\u2061\x9d\u2060\u206A\u2060\u061C\u2063\u2064",
    'embedded.confluence.troubleshooting-link.aria-label': "\u2063\u2062troubleshooting guide link\u200C\x90\u206C\u206D\u206E\x9d\u206D\u200D\x90\x8f\u200D\x8f\x90\u206A\u206D\x90\u206D\u200C\u200D\u206F\u206A\x90\u206F\x90\u200C\u2061\x90\u206E\u200D\x8d\u206C\u206A\u2063\u2064"
};

});


parcelRegister("3RELU", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd33c96d2c6a3b38$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $OyaMN = parcelRequire("OyaMN");
var $bd33c96d2c6a3b38$export$2e2bcd8739ae039 = (0, $OyaMN.default);

});
parcelRegister("OyaMN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8002adc7390303d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $d8002adc7390303d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hemos buscado en todas partes, pero no existe. Puede que se haya borrado. A no ser que la URL contenga un error \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'No hemos podido encontrar lo que buscas.',
    'embedded.confluence.already-logged-in-paragraph': "\xbfHas iniciado sesi\xf3n? Prueba a actualizar.",
    'embedded.confluence.footer.hover.text': 'Ver en Confluence',
    'embedded.confluence.footer.prefix': "Con tecnolog\xeda de",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xf3n de inicio de sesi\xf3n",
    'embedded.confluence.login-page.login-text': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Tras iniciar sesi\xf3n, esta p\xe1gina deber\xeda actualizarse autom\xe1ticamente. Si no, puedes hacer clic aqu\xed para actualizar.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Actualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "\xbfSigues teniendo problemas? Aseg\xfarate de que las cookies de terceros est\xe1n habilitadas o {link}",
    'embedded.confluence.troubleshooting-link-text': "consulta esta gu\xeda de soluci\xf3n de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "enlace a la gu\xeda de soluci\xf3n de problemas"
};

});


parcelRegister("2GLVw", function(module, exports) {
$parcel$export(module.exports, "default", () => $79757001bdda6d20$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $k8GmK = parcelRequire("k8GmK");
var $79757001bdda6d20$export$2e2bcd8739ae039 = (0, $k8GmK.default);

});
parcelRegister("k8GmK", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf006fcc6db4a0c7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $bf006fcc6db4a0c7$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Etsimme kaikkialta, mutta sit\xe4 ei ole olemassa. Se on saatettu poistaa. Paitsi tietenkin jos URL-osoitteessa on kirjoitusvirhe \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Emme l\xf6yt\xe4neet etsim\xe4\xe4si",
    'embedded.confluence.already-logged-in-paragraph': "Oletko jo kirjautuneena sis\xe4\xe4n? Kokeile p\xe4ivitt\xe4\xe4.",
    'embedded.confluence.footer.hover.text': "N\xe4yt\xe4 Confluencessa",
    'embedded.confluence.footer.prefix': 'Palvelun tarjoaa',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button.aria-label': 'Kirjautumispainike',
    'embedded.confluence.login-page.login-text': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit tarkastella t\xe4t\xe4 sivua",
    'embedded.confluence.login-page.refresh-page-banner': "T\xe4m\xe4n sivun tulisi p\xe4ivitty\xe4 automaattisesti sis\xe4\xe4nkirjautumisen j\xe4lkeen. Jos n\xe4in ei tapahdu, voit p\xe4ivitt\xe4\xe4 sivun napsauttamalla t\xe4t\xe4.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "P\xe4ivit\xe4 sivu",
    'embedded.confluence.need-to-log-in-paragraph': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit katsoa t\xe4t\xe4 sivua",
    'embedded.confluence.still-having-trouble-paragraph': "Onko sinulla viel\xe4 ongelmia? Varmista, ett\xe4 kolmansien osapuolten ev\xe4steet ovat k\xe4yt\xf6ss\xe4, tai {link}",
    'embedded.confluence.troubleshooting-link-text': "katso t\xe4m\xe4 ongelmanratkaisuopas.",
    'embedded.confluence.troubleshooting-link.aria-label': 'ongelmanratkaisuoppaan linkki'
};

});


parcelRegister("cyCkO", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d1b75c40aca6111$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $97WrX = parcelRequire("97WrX");
var $6d1b75c40aca6111$export$2e2bcd8739ae039 = (0, $97WrX.default);

});
parcelRegister("97WrX", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad3ccc23c0718289$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $ad3ccc23c0718289$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Nous avons cherch\xe9 partout, mais ce contenu n'existe pas. Il a peut-\xeatre \xe9t\xe9 supprim\xe9. Il est possible que l'URL contienne une faute de frappe. V\xe9rifiez bien \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Impossible de trouver ce que vous recherchez',
    'embedded.confluence.already-logged-in-paragraph': "D\xe9j\xe0 connect\xe9\xa0? Essayez d'actualiser.",
    'embedded.confluence.footer.hover.text': 'Afficher dans Confluence',
    'embedded.confluence.footer.prefix': "Optimis\xe9 par",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Bouton de connexion',
    'embedded.confluence.login-page.login-text': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.login-page.refresh-page-banner': "Apr\xe8s la connexion, cette page devrait s'actualiser automatiquement. Si ce n'est pas le cas, cliquez ici pour l'actualiser.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Actualiser la page',
    'embedded.confluence.need-to-log-in-paragraph': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.still-having-trouble-paragraph': "Vous rencontrez toujours des probl\xe8mes\xa0? Assurez-vous que les cookies tiers sont activ\xe9s, ou {link}.",
    'embedded.confluence.troubleshooting-link-text': "reportez-vous \xe0 ce guide de d\xe9pannage",
    'embedded.confluence.troubleshooting-link.aria-label': "lien vers le guide de d\xe9pannage"
};

});


parcelRegister("2kuK5", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b0a53f3901ee842$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1uArQ = parcelRequire("1uArQ");
var $5b0a53f3901ee842$export$2e2bcd8739ae039 = (0, $1uArQ.default);

});
parcelRegister("1uArQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e95b01e8c12f0776$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $e95b01e8c12f0776$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Megpr\xf3b\xe1ltuk megkeresni, de nincs ilyen oldal. Lehet, hogy t\xf6r\xf6lt\xe9k. Az is lehet, hogy csak el\xedrtad az URL-t \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nem tal\xe1ltuk meg, amit keresel",
    'embedded.confluence.already-logged-in-paragraph': "M\xe1r bejelentkezt\xe9l? Pr\xf3b\xe1lj meg friss\xedteni.",
    'embedded.confluence.footer.hover.text': "Megtekint\xe9s a Confluence-ben",
    'embedded.confluence.footer.prefix': "Szolg\xe1ltat\xf3:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button.aria-label': "Bejelentkez\xe9s gomb",
    'embedded.confluence.login-page.login-text': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.login-page.refresh-page-banner': "Bejelentkez\xe9s ut\xe1n az oldal automatikusan friss\xfcl. Ha nem, kattints ide a friss\xedt\xe9shez.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Oldal friss\xedt\xe9se",
    'embedded.confluence.need-to-log-in-paragraph': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.still-having-trouble-paragraph': "M\xe9g mindig probl\xe9m\xe1ba \xfctk\xf6z\xf6l? Gy\u0151z\u0151dj meg r\xf3la, hogy enged\xe9lyezted a harmadik felekt\u0151l sz\xe1rmaz\xf3 s\xfctiket, vagy {link}",
    'embedded.confluence.troubleshooting-link-text': "olvasd el ezt a hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3t.",
    'embedded.confluence.troubleshooting-link.aria-label': "hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3 linkje"
};

});


parcelRegister("ec4Zm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5d40f2dbcf6c2db$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $7MLET = parcelRequire("7MLET");
var $e5d40f2dbcf6c2db$export$2e2bcd8739ae039 = (0, $7MLET.default);

});
parcelRegister("7MLET", function(module, exports) {
$parcel$export(module.exports, "default", () => $08a304e9615ca1cb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $08a304e9615ca1cb$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Abbiamo cercato ovunque, ma la pagina non esiste. Potrebbe essere stata eliminata, o forse hai sbagliato a scrivere l'URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Non siamo riusciti a trovare la pagina cercata',
    'embedded.confluence.already-logged-in-paragraph': "Hai gi\xe0 effettuato l'accesso? Prova ad aggiornare la pagina.",
    'embedded.confluence.footer.hover.text': 'Visualizza in Confluence',
    'embedded.confluence.footer.prefix': 'Offerto da',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Pulsante di accesso',
    'embedded.confluence.login-page.login-text': "Per visualizzare questa pagina devi avere effettuato l'accesso.",
    'embedded.confluence.login-page.refresh-page-banner': "Dopo l'accesso, questa pagina dovrebbe aggiornarsi automaticamente. In caso contrario, clicca qui per aggiornarla",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Aggiorna la pagina',
    'embedded.confluence.need-to-log-in-paragraph': "Deve avere effettuato l'accesso per visualizzare questa pagina",
    'embedded.confluence.still-having-trouble-paragraph': 'Riscontri ancora problemi? Assicurati che i cookie di terze parti siano abilitati, oppure {link}',
    'embedded.confluence.troubleshooting-link-text': 'consulta questa guida alla risoluzione dei problemi.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link alla guida alla risoluzione dei problemi'
};

});


parcelRegister("adxPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $090a54f256654417$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fRbOB = parcelRequire("fRbOB");
var $090a54f256654417$export$2e2bcd8739ae039 = (0, $fRbOB.default);

});
parcelRegister("fRbOB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e13736617ad05247$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $e13736617ad05247$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002\u524A\u9664\u3055\u308C\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002URL \u306B\u5165\u529B\u30DF\u30B9\u304C\u306A\u3044\u304B\u3001\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u304A\u63A2\u3057\u306E\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'embedded.confluence.already-logged-in-paragraph': "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u3044\u307E\u3059\u304B?\u66F4\u65B0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.footer.hover.text': "Confluence \u3067\u8868\u793A",
    'embedded.confluence.footer.prefix': "\u4F7F\u7528\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3: ",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button.aria-label': "\u30ED\u30B0\u30A4\u30F3 \u30DC\u30BF\u30F3",
    'embedded.confluence.login-page.login-text': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner': "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u3068\u3001\u3053\u306E\u30DA\u30FC\u30B8\u306F\u81EA\u52D5\u3067\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u66F4\u65B0\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001\u3053\u3053\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u66F4\u65B0\u3067\u304D\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0",
    'embedded.confluence.need-to-log-in-paragraph': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    'embedded.confluence.still-having-trouble-paragraph': "\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3 Cookie \u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u307E\u305F\u306F\u3001{link}",
    'embedded.confluence.troubleshooting-link-text': "\u3053\u306E\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u306E\u30EA\u30F3\u30AF"
};

});


parcelRegister("7iSe8", function(module, exports) {
$parcel$export(module.exports, "default", () => $3175ea772765cd21$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $bZXf1 = parcelRequire("bZXf1");
var $3175ea772765cd21$export$2e2bcd8739ae039 = (0, $bZXf1.default);

});
parcelRegister("bZXf1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ef766d79add86b1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $1ef766d79add86b1$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\uC790\uC138\uD788 \uB458\uB7EC\uBCF4\uC558\uC9C0\uB9CC \uCC3E\uC744 \uC218\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uC0AD\uC81C\uB418\uC5C8\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. URL\uC5D0 \uC785\uB825 \uC624\uB958\uAC00 \uC788\uB294\uC9C0 \uD655\uC778\uD574\uBCF4\uC138\uC694 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\uC6D0\uD558\uB294 \uD56D\uBAA9\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.already-logged-in-paragraph': "\uC774\uBBF8 \uB85C\uADF8\uC778\uD558\uC168\uC2B5\uB2C8\uAE4C? \uC0C8\uB85C \uACE0\uCCD0 \uBCF4\uC138\uC694.",
    'embedded.confluence.footer.hover.text': "Confluence\uC5D0\uC11C \uBCF4\uAE30",
    'embedded.confluence.footer.prefix': "\uC81C\uACF5:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button.aria-label': "\uB85C\uADF8\uC778 \uBC84\uD2BC",
    'embedded.confluence.login-page.login-text': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner': "\uB85C\uADF8\uC778\uD558\uBA74 \uC774 \uD398\uC774\uC9C0\uAC00 \uC790\uB3D9\uC73C\uB85C \uC0C8\uB85C \uACE0\uCCD0\uC9D1\uB2C8\uB2E4. \uADF8\uB807\uC9C0 \uC54A\uC740 \uACBD\uC6B0 \uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uC0C8\uB85C \uACE0\uCE60 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\uD398\uC774\uC9C0 \uC0C8\uB85C \uACE0\uCE58\uAE30",
    'embedded.confluence.need-to-log-in-paragraph': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.still-having-trouble-paragraph': "\uC544\uC9C1 \uBB38\uC81C\uAC00 \uC788\uC2B5\uB2C8\uAE4C? \uD0C0\uC0AC \uCFE0\uD0A4\uB97C \uC0AC\uC6A9\uC73C\uB85C \uC124\uC815\uD588\uB294\uC9C0 \uD655\uC778\uD558\uAC70\uB098 {link}",
    'embedded.confluence.troubleshooting-link-text': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC\uB97C \uCC38\uC870\uD558\uC138\uC694.",
    'embedded.confluence.troubleshooting-link.aria-label': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC \uB9C1\uD06C"
};

});


parcelRegister("aRmqS", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7176f6091fac65c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6njdR = parcelRequire("6njdR");
var $b7176f6091fac65c$export$2e2bcd8739ae039 = (0, $6njdR.default);

});
parcelRegister("6njdR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebcf052d0bd9e2ed$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $ebcf052d0bd9e2ed$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har sett overalt, men dette innholdet eksisterer ikke. Det kan ha blitt slettet. Med mindre nettadressen har en skrivefeil \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi finner ikke det du leter etter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget p\xe5? Pr\xf8v \xe5 oppdatere.",
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Levert av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "P\xe5loggingsknapp",
    'embedded.confluence.login-page.login-text': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.login-page.refresh-page-banner': "Etter p\xe5logging skal denne siden oppdateres automatisk. Hvis ikke, kan du klikke her for \xe5 oppdatere",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Oppdater siden',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.still-having-trouble-paragraph': 'Har du fortsatt problemer? Kontroller at tredjeparts informasjonskapsler er aktivert, eller {link}',
    'embedded.confluence.troubleshooting-link-text': "se denne feils\xf8kingsveiledningen.",
    'embedded.confluence.troubleshooting-link.aria-label': "kobling til feils\xf8kingsveiledning"
};

});


parcelRegister("bSlng", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1c106f196b16ae8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3lN6l = parcelRequire("3lN6l");
var $c1c106f196b16ae8$export$2e2bcd8739ae039 = (0, $3lN6l.default);

});
parcelRegister("3lN6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $758a1d2aec1019fe$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $758a1d2aec1019fe$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We hebben overal gezocht, maar de pagina bestaat niet. Het kan zijn dat deze verwijderd is. Tenzij de URL een typefout bevat \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'We konden niet vinden wat je zocht',
    'embedded.confluence.already-logged-in-paragraph': 'Al ingelogd? Probeer te vernieuwen.',
    'embedded.confluence.footer.hover.text': 'Weergeven in Confluence',
    'embedded.confluence.footer.prefix': 'Mogelijk gemaakt door',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login-knop',
    'embedded.confluence.login-page.login-text': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.login-page.refresh-page-banner': 'Nadat je bent ingelogd, moet deze pagina automatisch vernieuwen. Als dit niet gebeurt, kun je hier klikken om te vernieuwen',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Pagina vernieuwen',
    'embedded.confluence.need-to-log-in-paragraph': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.still-having-trouble-paragraph': 'Nog steeds niet gelukt? Zorg ervoor dat cookies van derden zijn ingeschakeld of {link}',
    'embedded.confluence.troubleshooting-link-text': 'raadpleeg deze handleiding voor probleemoplossing.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link naar handleiding voor probleemoplossing'
};

});


parcelRegister("kZZGF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7970253c953659f7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3eKOc = parcelRequire("3eKOc");
var $7970253c953659f7$export$2e2bcd8739ae039 = (0, $3eKOc.default);

});
parcelRegister("3eKOc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4da433e029a4a52$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $c4da433e029a4a52$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Szukali\u015Bmy tej strony wsz\u0119dzie, ale nigdzie jej nie ma. Mo\u017Cliwe, \u017Ce\xa0zosta\u0142a usuni\u0119ta. O\xa0ile, oczywi\u015Bcie, do\xa0adresu URL nie wkrad\u0142a si\u0119 liter\xf3wka \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nie mo\u017Cna znale\u017A\u0107 tego, czego szukasz",
    'embedded.confluence.already-logged-in-paragraph': "Ju\u017C przeprowadzono logowanie? Spr\xf3buj od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.footer.hover.text': "Wy\u015Bwietl w Confluence",
    'embedded.confluence.footer.prefix': "Obs\u0142ugiwane przez",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Zaloguj si\u0119 w Confluence",
    'embedded.confluence.login-page.login-button': "Zaloguj si\u0119 w systemie Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Przycisk logowania',
    'embedded.confluence.login-page.login-text': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.login-page.refresh-page-banner': "Po zalogowaniu ta strona powinna od\u015Bwie\u017Cy\u0107 si\u0119 automatycznie. Je\u015Bli tak si\u0119 nie stanie, kliknij tutaj, aby od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Od\u015Bwie\u017C stron\u0119",
    'embedded.confluence.need-to-log-in-paragraph': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.still-having-trouble-paragraph': "Nadal masz problem? Upewnij si\u0119, \u017Ce obs\u0142uga plik\xf3w cookie innych firm jest w\u0142\u0105czona lub {link}.",
    'embedded.confluence.troubleshooting-link-text': "zapoznaj si\u0119 z tym przewodnikiem rozwi\u0105zywania problem\xf3w",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0142\u0105cze do przewodnika rozwi\u0105zywania problem\xf3w"
};

});


parcelRegister("cZnHy", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cd3d203e236cba1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $Z01Pj = parcelRequire("Z01Pj");
var $1cd3d203e236cba1$export$2e2bcd8739ae039 = (0, $Z01Pj.default);

});
parcelRegister("Z01Pj", function(module, exports) {
$parcel$export(module.exports, "default", () => $f98b0e2c7a5a4e37$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $f98b0e2c7a5a4e37$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "A gente procurou em todo lugar, mas ela n\xe3o existe. Talvez tenha sido exclu\xedda. A menos, \xe9 claro, que o URL contenha um erro de digita\xe7\xe3o \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "N\xe3o foi poss\xedvel encontrar o que voc\xea est\xe1 procurando",
    'embedded.confluence.already-logged-in-paragraph': "J\xe1 entrou? Experimente atualizar.",
    'embedded.confluence.footer.hover.text': 'Visualizar no Confluence',
    'embedded.confluence.footer.prefix': "Distribu\xeddo por",
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xe3o Entrar",
    'embedded.confluence.login-page.login-text': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Depois do login, a atualiza\xe7\xe3o da p\xe1gina \xe9 autom\xe1tica. Se isso n\xe3o acontecer, voc\xea pode clicar aqui para atualizar",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Atualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "Ainda est\xe1 tendo problemas? Verifique se os cookies de terceiros est\xe3o habilitados ou {link}",
    'embedded.confluence.troubleshooting-link-text': "consulte este guia de solu\xe7\xe3o de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "link do guia de solu\xe7\xe3o de problemas"
};

});


parcelRegister("hmXBb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4515fc80428e0f3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $5ak3O = parcelRequire("5ak3O");
var $e4515fc80428e0f3$export$2e2bcd8739ae039 = (0, $5ak3O.default);

});
parcelRegister("5ak3O", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d90428c652fb203$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $4d90428c652fb203$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041C\u044B \u0438\u0441\u043A\u0430\u043B\u0438 \u043F\u043E\u0432\u0441\u044E\u0434\u0443, \u043D\u043E \u0442\u0430\u043A\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043E\u043D\u0430 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430. \u0415\u0441\u043B\u0438, \u043A\u043E\u043D\u0435\u0447\u043D\u043E, URL-\u0430\u0434\u0440\u0435\u0441 \u0443\u043A\u0430\u0437\u0430\u043D \u0432\u0435\u0440\u043D\u043E \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u0442\u043E, \u0447\u0442\u043E \u0432\u044B \u0438\u0449\u0435\u0442\u0435",
    'embedded.confluence.already-logged-in-paragraph': "\u0412\u044B \u0443\u0436\u0435 \u0432\u043E\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
    'embedded.confluence.footer.hover.text': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041F\u0440\u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0435",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0432\u0445\u043E\u0434\u0430",
    'embedded.confluence.login-page.login-text': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u043E\u0441\u043B\u0435 \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u044F. \u0415\u0441\u043B\u0438 \u044D\u0442\u043E\u0433\u043E \u043D\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0435\u0442, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C, \u0447\u0442\u043E\u0431\u044B \u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043D\u0435 \u0438\u0441\u0447\u0435\u0437\u043B\u0430? \u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u044B cookie \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B, \u0438\u043B\u0438 {link}",
    'embedded.confluence.troubleshooting-link-text': "\u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0443 \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A.",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};

});


parcelRegister("d39bX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3deeb5c49f5203b2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $eiLYJ = parcelRequire("eiLYJ");
var $3deeb5c49f5203b2$export$2e2bcd8739ae039 = (0, $eiLYJ.default);

});
parcelRegister("eiLYJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d587b136dfe8dd7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $4d587b136dfe8dd7$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi tittade \xf6verallt, men den finns bara inte. Den kan ha raderats. S\xe5vida webbadressen inte inneh\xe5ller n\xe5got stavfel \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi hittar inte det du letar efter',
    'embedded.confluence.already-logged-in-paragraph': "\xc4r du redan inloggad? Uppdatera sidan.",
    'embedded.confluence.footer.hover.text': 'Visa i Confluence',
    'embedded.confluence.footer.prefix': 'Drivs av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Inloggningsknapp',
    'embedded.confluence.login-page.login-text': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.login-page.refresh-page-banner': "Den h\xe4r sidan b\xf6r uppdateras automatiskt efter inloggningen. Annars kan du klicka h\xe4r f\xf6r att uppdatera den",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Uppdatera sidan',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.still-having-trouble-paragraph': "Har du fortfarande problem? Se till att cookies f\xf6r tredje parter \xe4r aktiverade, eller {link}",
    'embedded.confluence.troubleshooting-link-text': "kolla in den h\xe4r fels\xf6kningsguiden.",
    'embedded.confluence.troubleshooting-link.aria-label': "l\xe4nk till fels\xf6kningsguide"
};

});


parcelRegister("7em2L", function(module, exports) {
$parcel$export(module.exports, "default", () => $27e7b432d02653a9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $aT0sX = parcelRequire("aT0sX");
var $27e7b432d02653a9$export$2e2bcd8739ae039 = (0, $aT0sX.default);

});
parcelRegister("aT0sX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b61e557bbfdc46d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $9b61e557bbfdc46d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u0E40\u0E23\u0E32\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E17\u0E38\u0E01\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E32\u0E08\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E32\u0E08\u0E21\u0E35\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E1C\u0E34\u0E14\u0E43\u0E19 URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'embedded.confluence.already-logged-in-paragraph': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E25\u0E2D\u0E07\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32",
    'embedded.confluence.footer.hover.text': "\u0E14\u0E39\u0E43\u0E19 Confluence",
    'embedded.confluence.footer.prefix': "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E42\u0E14\u0E22",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    'embedded.confluence.login-page.login-text': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.login-page.refresh-page-banner': "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E35\u0E49\u0E04\u0E27\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E2B\u0E32\u0E01\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'embedded.confluence.need-to-log-in-paragraph': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.still-having-trouble-paragraph': "\u0E22\u0E31\u0E07\u0E04\u0E07\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E2D\u0E22\u0E39\u0E48 \u0E2B\u0E23\u0E37\u0E2D {link}",
    'embedded.confluence.troubleshooting-link-text': "\u0E14\u0E39\u0E17\u0E35\u0E48\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32"
};

});


parcelRegister("fbSjx", function(module, exports) {
$parcel$export(module.exports, "default", () => $01a67694ba155303$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fx6jl = parcelRequire("fx6jl");
var $01a67694ba155303$export$2e2bcd8739ae039 = (0, $fx6jl.default);

});
parcelRegister("fx6jl", function(module, exports) {
$parcel$export(module.exports, "default", () => $695eab6677f02e30$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $695eab6677f02e30$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Her yere bakt\u0131k fakat bulamad\u0131k. Silinmi\u015F olabilir. Tabii e\u011Fer URL'de bir yaz\u0131m hatas\u0131 yoksa \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Arad\u0131\u011F\u0131n\u0131z bulunamad\u0131",
    'embedded.confluence.already-logged-in-paragraph': "Oturumunuz zaten a\xe7\u0131k m\u0131? Sayfay\u0131 yenilemeyi deneyin.",
    'embedded.confluence.footer.hover.text': "Confluence'ta g\xf6r\xfcnt\xfcleyin",
    'embedded.confluence.footer.prefix': "Sa\u011Flayan:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button.aria-label': "Oturum A\xe7ma D\xfc\u011Fmesi",
    'embedded.confluence.login-page.login-text': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.login-page.refresh-page-banner': "Oturum a\xe7t\u0131ktan sonra bu sayfa otomatik olarak yenilenmelidir. Yenilenmezse buraya t\u0131klayarak yenileyebilirsiniz",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Sayfay\u0131 yenile",
    'embedded.confluence.need-to-log-in-paragraph': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.still-having-trouble-paragraph': "Sorun ya\u015Famaya devam m\u0131 ediyorsunuz? \xdc\xe7\xfcnc\xfc taraf \xe7erezlerinin etkinle\u015Ftirildi\u011Finden emin olun ya da {link}",
    'embedded.confluence.troubleshooting-link-text': "bu sorun giderme k\u0131lavuzuna ba\u015Fvurun",
    'embedded.confluence.troubleshooting-link.aria-label': "sorun giderme k\u0131lavuzu ba\u011Flant\u0131s\u0131"
};

});


parcelRegister("fazBu", function(module, exports) {
$parcel$export(module.exports, "default", () => $1029988d2fbab422$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $ll0mb = parcelRequire("ll0mb");
var $1029988d2fbab422$export$2e2bcd8739ae039 = (0, $ll0mb.default);

});
parcelRegister("ll0mb", function(module, exports) {
$parcel$export(module.exports, "default", () => $bca0ed95888e2625$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $bca0ed95888e2625$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E. \u041C\u043E\u0436\u043B\u0438\u0432\u043E, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E. \u042F\u043A\u0449\u043E, \u0437\u0432\u0456\u0441\u043D\u043E, \u0432 URL-\u0430\u0434\u0440\u0435\u0441\u0456 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u043C\u0438\u043B\u043A\u0438 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u0437\u0430 \u0432\u0430\u0448\u0438\u043C \u0437\u0430\u043F\u0438\u0442\u043E\u043C \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'embedded.confluence.already-logged-in-paragraph': "\u0423\u0436\u0435 \u0432\u0432\u0456\u0439\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.",
    'embedded.confluence.footer.hover.text': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443",
    'embedded.confluence.login-page.login-text': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u0456\u0441\u043B\u044F \u0432\u0445\u043E\u0434\u0443 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0446\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E. \u042F\u043A\u0449\u043E \u043D\u0456, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0442\u0438\u0441\u043D\u0443\u0442\u0438 \u0442\u0443\u0442, \u0449\u043E\u0431 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0457\u0457",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u0414\u043E\u0441\u0456 \u0432\u0438\u043D\u0438\u043A\u0430\u044E\u0442\u044C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438? \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0456 \u0444\u0430\u0439\u043B\u0438 cookie \u0432\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E, \u0430\u0431\u043E {link}.",
    'embedded.confluence.troubleshooting-link-text': "\u0441\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0439\u0442\u0435\u0441\u044F \u0446\u0438\u043C \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A\u043E\u043C \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A",
    'embedded.confluence.troubleshooting-link.aria-label': "\u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};

});


parcelRegister("4lHnX", function(module, exports) {
$parcel$export(module.exports, "default", () => $276bc4890ca504b9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $b6xoa = parcelRequire("b6xoa");
var $276bc4890ca504b9$export$2e2bcd8739ae039 = (0, $b6xoa.default);

});
parcelRegister("b6xoa", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6d3e0f1c67bfee9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $d6d3e0f1c67bfee9$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Ch\xfang t\xf4i \u0111\xe3 t\xecm kh\u1EAFp n\u01A1i nh\u01B0ng n\u1ED9i dung n\xe0y kh\xf4ng t\u1ED3n t\u1EA1i. N\u1ED9i dung n\xe0y c\xf3 th\u1EC3 \u0111\xe3 b\u1ECB x\xf3a. Tr\u1EEB phi c\xf3 l\u1ED7i \u0111\xe1nh m\xe1y trong URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Ch\xfang t\xf4i kh\xf4ng t\xecm \u0111\u01B0\u1EE3c nh\u1EEFng g\xec b\u1EA1n mu\u1ED1n",
    'embedded.confluence.already-logged-in-paragraph': "B\u1EA1n \u0111\xe3 \u0111\u0103ng nh\u1EADp? H\xe3y th\u1EED l\xe0m m\u1EDBi.",
    'embedded.confluence.footer.hover.text': 'Xem trong Confluence',
    'embedded.confluence.footer.prefix': "\u0110\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "N\xfat \u0110\u0103ng nh\u1EADp",
    'embedded.confluence.login-page.login-text': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.login-page.refresh-page-banner': "Sau khi \u0111\u0103ng nh\u1EADp, trang n\xe0y s\u1EBD t\u1EF1 \u0111\u1ED9ng l\xe0m m\u1EDBi. N\u1EBFu kh\xf4ng, b\u1EA1n c\xf3 th\u1EC3 b\u1EA5m v\xe0o \u0111\xe2y \u0111\u1EC3 l\xe0m m\u1EDBi",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "L\xe0m m\u1EDBi trang",
    'embedded.confluence.need-to-log-in-paragraph': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.still-having-trouble-paragraph': "B\u1EA1n v\u1EABn g\u1EB7p s\u1EF1 c\u1ED1? \u0110\u1EA3m b\u1EA3o b\u1EA1n \u0111\xe3 b\u1EADt c\xe1c cookie c\u1EE7a b\xean th\u1EE9 3 ho\u1EB7c {link}",
    'embedded.confluence.troubleshooting-link-text': "tham kh\u1EA3o h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1 n\xe0y.",
    'embedded.confluence.troubleshooting-link.aria-label': "li\xean k\u1EBFt h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1"
};

});


parcelRegister("j9BMn", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4ad23d78b1003b5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $d1LQj = parcelRequire("d1LQj");
var $c4ad23d78b1003b5$export$2e2bcd8739ae039 = (0, $d1LQj.default);

});
parcelRegister("d1LQj", function(module, exports) {
$parcel$export(module.exports, "default", () => $de006bcaad3f1476$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $de006bcaad3f1476$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u4EEC\u5DF2\u56DB\u5904\u5BFB\u627E\uFF0C\u4F46\u5B83\u5E76\u4E0D\u5B58\u5728\u3002\u5B83\u53EF\u80FD\u5DF2\u88AB\u5220\u9664\u3002\u9664\u975E\u60A8\u7684 URL \u5305\u542B\u9519\u522B\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u672A\u627E\u5230\u60A8\u8981\u67E5\u627E\u7684\u9875\u9762",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u767B\u5F55\uFF1F\u8BF7\u5C1D\u8BD5\u5237\u65B0\u3002",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u67E5\u770B",
    'embedded.confluence.footer.prefix': "\u6280\u672F\u652F\u6301\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5F55\u5230 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5F55 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5F55\u6309\u94AE",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5F55\u540E\uFF0C\u6B64\u9875\u9762\u5E94\u4F1A\u81EA\u52A8\u5237\u65B0\u3002\u5982\u679C\u672A\u5237\u65B0\uFF0C\u60A8\u53EF\u4EE5\u70B9\u51FB\u6B64\u5904\u8FDB\u884C\u5237\u65B0",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u5237\u65B0\u9875\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u6709\u95EE\u9898\uFF1F\u8BF7\u786E\u4FDD\u5DF2\u542F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C2\u9605\u6B64\u6545\u969C\u6392\u9664\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u6545\u969C\u6392\u9664\u6307\u5357\u94FE\u63A5"
};

});


parcelRegister("9CxAQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $55cf7277abe54f0f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $8sNnA = parcelRequire("8sNnA");
var $55cf7277abe54f0f$export$2e2bcd8739ae039 = (0, $8sNnA.default);

});
parcelRegister("8sNnA", function(module, exports) {
$parcel$export(module.exports, "default", () => $986beac2870673da$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $986beac2870673da$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u5011\u5DF2\u627E\u904D\u56DB\u8655\uFF0C\u4F46\u8A72\u7DB2\u9801\u4F3C\u4E4E\u4E0D\u5B58\u5728\uFF0C\u53EF\u80FD\u5DF2\u906D\u5230\u522A\u9664\u3002\u7576\u7136\uFF0C\u9664\u975E URL \u4E2D\u6709\u932F\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u6211\u5011\u627E\u4E0D\u5230\u60A8\u8981\u5C0B\u627E\u7684\u5167\u5BB9",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u7D93\u767B\u5165\u4E86\u55CE\uFF1F\u8ACB\u5617\u8A66\u91CD\u65B0\u6574\u7406\u3002",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u6AA2\u8996",
    'embedded.confluence.footer.prefix': "\u7531\u4EE5\u4E0B\u6280\u8853\u652F\u63F4\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5165\u6309\u9215",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5165\u5F8C\uFF0C\u6B64\u9801\u9762\u61C9\u8A72\u6703\u81EA\u52D5\u91CD\u65B0\u6574\u7406\u3002\u5982\u679C\u6C92\u6709\uFF0C\u60A8\u53EF\u4EE5\u6309\u4E00\u4E0B\u9019\u88E1\u9032\u884C\u91CD\u65B0\u6574\u7406",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u91CD\u65B0\u6574\u7406\u9801\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u7136\u6709\u554F\u984C\u55CE\uFF1F\u8ACB\u78BA\u5B9A\u60A8\u5DF2\u555F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C3\u95B1\u6B64\u7591\u96E3\u6392\u89E3\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u7591\u96E3\u6392\u89E3\u6307\u5357\u9023\u7D50"
};

});




parcelRegister("4eSmy", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $0e0b16901c3f6e75$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jyZeU = parcelRequire("jyZeU");

var $lWsis = parcelRequire("lWsis");

var $hEWmq = parcelRequire("hEWmq");
const $0e0b16901c3f6e75$export$767e3006bdbb424a = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lWsis.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hEWmq.ViewPage), {
            ...props
        })
    });

});
parcelRegister("hEWmq", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $84f48369079b110f$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $35jyw = parcelRequire("35jyw");

var $lRq8t = parcelRequire("lRq8t");
const $84f48369079b110f$export$767e3006bdbb424a = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $35jyw.ViewPage), {
        locale: locale,
        ...props
    });
};

});
parcelRegister("35jyw", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $a8eed96c071859b9$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $dqJsX = parcelRequire("dqJsX");

var $7oRxl = parcelRequire("7oRxl");

var $jyZeU = parcelRequire("jyZeU");

var $lzAG1 = parcelRequire("lzAG1");

var $4nJ3E = parcelRequire("4nJ3E");

var $8edRS = parcelRequire("8edRS");
const $a8eed96c071859b9$export$767e3006bdbb424a = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lzAG1.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8edRS.UniqueKeyProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {}),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dqJsX.ViewPage), {
                    ...props
                })
            })
        })
    });
};

});
parcelRegister("dqJsX", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $c7ae8fd93015352f$export$767e3006bdbb424a);
/* ViewPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j2zMY = parcelRequire("j2zMY");

var $fzBRQ = parcelRequire("fzBRQ");
var $6DF4T = parcelRequire("6DF4T");
var $27wdK = parcelRequire("27wdK");

var $jWzbc = parcelRequire("jWzbc");

var $lCbi5 = parcelRequire("lCbi5");

var $8edRS = parcelRequire("8edRS");
const $c7ae8fd93015352f$var$embeddedPageContainerSytles = null;
const $c7ae8fd93015352f$var$StyledEmbeddedPageContainer = ({ children: children, containerHeight: containerHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testId": "styled-embedded-page-container-id",
        style: {
            height: containerHeight
        },
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: children
    });
};
const $c7ae8fd93015352f$export$767e3006bdbb424a = (props)=>{
    const { hasFooterLogo: shouldShowFooter, isHeightSetFromContent: isHeightSetFromContent, showFooter: showFooter = true } = props;
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const { height: height } = (0, $27wdK.useContentSize)(uniqueKey);
    (0, $lCbi5.useGetCurrentScrollPosition)(isHeightSetFromContent);
    const contentConfiguration = (0, $eJOHy.useMemo)(()=>({
            experiences: {
                experience: (0, $j2zMY.ExperienceNames).VIEW_PAGE,
                ccExperience: (0, $j2zMY.ExperienceNames).CC_VIEW_PAGE
            },
            getWrapperElement: (children)=>/*#__PURE__*/ (0, $gt9Am.jsx)($c7ae8fd93015352f$var$StyledEmbeddedPageContainer, {
                    containerHeight: isHeightSetFromContent ? `${height}px` : '100%',
                    children: children
                }),
            hasFooter: showFooter
        }), [
        isHeightSetFromContent,
        height,
        showFooter
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jWzbc.Content), {
        ...props,
        contentType: (0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        contentConfiguration: contentConfiguration,
        isHeightSetFromContent: isHeightSetFromContent,
        shouldShowFooter: shouldShowFooter
    });
};

});
parcelRegister("27wdK", function(module, exports) {
$parcel$export(module.exports, "useContentSize", () => $135b10d553c176e1$export$7e7123f55b1139c9);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $8qtes = parcelRequire("8qtes");

var $fSqCk = parcelRequire("fSqCk");
const $135b10d553c176e1$var$MESSAGE_TYPE = 'contentSize';
const $135b10d553c176e1$export$7e7123f55b1139c9 = (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [height, setHeight] = (0, $eJOHy.useState)(1000);
    /* This visible height refers to the portion of the confluence page that is visible within the iframe without having to scroll.
		When isHeightSetFromContent is true, the embedded page container height toggles between the visible height and the content height
		depending on whether media viewer is open or close.
		This updated was added as a resolution to the bug explained in this ticket: https://hello.jira.atlassian.cloud/browse/CBT-3636
	*/ const { isMediaOpen: isMediaOpen } = (0, $8qtes.useMediaViewerListener)();
    const { visibleHeight: visibleHeight } = (0, $fSqCk.useIframeVisibleHeight)(uniqueKey);
    (0, $eJOHy.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $135b10d553c176e1$var$MESSAGE_TYPE && data?.height && (uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? data?.uniqueKey === uniqueKey : true)) setHeight(data.height);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        height: isMediaOpen ? visibleHeight : height
    };
};

});
parcelRegister("8qtes", function(module, exports) {
$parcel$export(module.exports, "useMediaViewerListener", () => $77826dd02e2a6e26$export$6d8905296959d5f5);

var $eJOHy = parcelRequire("eJOHy");
const $77826dd02e2a6e26$export$6d8905296959d5f5 = ()=>{
    const [isMediaOpen, setIsMediaOpen] = (0, $eJOHy.useState)(false);
    const mediaMessageListener = (0, $eJOHy.useCallback)((messageEvent)=>{
        const { source: source, event: event } = messageEvent.data ?? {};
        if (!source || !event) return;
        if (source === 'media') switch(event){
            case 'mediaViewerOpened':
                setIsMediaOpen(true);
                break;
            case 'mediaViewerClosed':
                setIsMediaOpen(false);
                break;
            default:
                return;
        }
    }, [
        setIsMediaOpen
    ]);
    (0, $eJOHy.useEffect)(()=>{
        window.addEventListener('message', mediaMessageListener);
        return ()=>window.removeEventListener('message', mediaMessageListener);
    }, [
        mediaMessageListener
    ]);
    return {
        isMediaOpen: isMediaOpen
    };
};

});

parcelRegister("fSqCk", function(module, exports) {
$parcel$export(module.exports, "useIframeVisibleHeight", () => $fd2a92adc4bbbe65$export$4b9c38587bbe6e8b);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $fd2a92adc4bbbe65$var$MESSAGE_TYPE = 'embeddedConfluenceVisibleHeight';
const $fd2a92adc4bbbe65$export$4b9c38587bbe6e8b = (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [visibleHeight, setVisibleHeight] = (0, $eJOHy.useState)(1000);
    (0, $eJOHy.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $fd2a92adc4bbbe65$var$MESSAGE_TYPE && data?.value && (uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? data?.uniqueKey === uniqueKey : true)) setVisibleHeight(data.value);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        visibleHeight: visibleHeight
    };
};

});


parcelRegister("jWzbc", function(module, exports) {
$parcel$export(module.exports, "Content", () => $dc9eb7549e787e58$export$7c6e2c02157bb7d2);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5XSQP = parcelRequire("5XSQP");
var $40f0Z = parcelRequire("40f0Z");

var $52WL7 = parcelRequire("52WL7");
var $7LOUI = parcelRequire("7LOUI");

var $kUYZz = parcelRequire("kUYZz");

var $fuXvj = parcelRequire("fuXvj");
var $73Fae = parcelRequire("73Fae");
var $27wdK = parcelRequire("27wdK");
var $jgJaV = parcelRequire("jgJaV");
var $bbc8b = parcelRequire("bbc8b");

var $8edRS = parcelRequire("8edRS");

var $7oRxl = parcelRequire("7oRxl");

var $3ca9m = parcelRequire("3ca9m");

var $lRq8t = parcelRequire("lRq8t");
const $dc9eb7549e787e58$var$IframeWrapper = ({ children: children, wrapper: wrapper })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: wrapper?.(children) ?? children
    });
// helper to merge iframe refs
function $dc9eb7549e787e58$var$mergeIframeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (!ref) return;
            if (typeof ref === 'function') ref(value);
            else ref.current = value;
        });
    };
}
const $dc9eb7549e787e58$export$7c6e2c02157bb7d2 = (props)=>{
    const { spaceKey: spaceKey, contentId: contentId, contentConfiguration: contentConfiguration, navigationPolicy: navigationPolicy, iframeRef: externalIframeRef, onLoad: onLoad, ...passThroughProps } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const experienceTracker = (0, $52WL7.useExperienceTracker)();
    const { experience: experience, ccExperience: ccExperience } = contentConfiguration.experiences;
    (0, $7LOUI.useSetUpExperience)({
        experienceTracker: experienceTracker,
        contentId: contentId,
        spaceKey: spaceKey,
        experience: experience,
        ccExperience: ccExperience
    });
    const { embeddedConfluenceUrl: embeddedConfluenceUrl, standaloneConfluenceUrl: standaloneConfluenceUrl } = (0, $bbc8b.useUrl)(props);
    /**
	 * The difference between hasFooter and hasFooterLogo can be found here
	 * https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/40212/cbt-2587-docs-changeset-ux-add-embedded#comment-428798112
	 *
	 * EDIT 7/17: hasFooterLogo property has been renamed internally for clarity as is now aliased as shouldShowFooter when used internally. Externally, the API remains unchanged.
	 */ const shouldShowFooter = props.hasFooterLogo ?? true;
    const { showFooter: showFooter, footerUrl: footerUrl } = (0, $jgJaV.useFooter)({
        experienceTracker: experienceTracker,
        hasFooter: contentConfiguration.hasFooter,
        shouldShowFooter: shouldShowFooter,
        parentProduct: props.parentProduct,
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
    const { height: height } = (0, $27wdK.useContentSize)(uniqueKey);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40f0Z.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5XSQP.Experience), {
            name: experience,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $73Fae.PageLoadValidation), {
                ...props,
                children: ({ iframeRef: iframeRef, handleIframeOnLoad: handleIframeOnLoad, handleContentLoadStarted: handleContentLoadStarted, navigationPolicy: navigationPolicy, handleIframeUnload: handleIframeUnload, redirectedToLogin: redirectedToLogin })=>/*#__PURE__*/ (0, $gt9Am.jsxs)($dc9eb7549e787e58$var$IframeWrapper, {
                        wrapper: contentConfiguration.getWrapperElement,
                        children: [
                            embeddedConfluenceUrl ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kUYZz.Iframe), {
                                ref: $dc9eb7549e787e58$var$mergeIframeRefs(iframeRef, externalIframeRef),
                                // https://hello.atlassian.net/wiki/spaces/~142157567/pages/2224394268/Spike+on+CBT-1814
                                src: redirectedToLogin ? '' : embeddedConfluenceUrl,
                                ...passThroughProps,
                                navigationPolicy: navigationPolicy,
                                style: {
                                    flex: passThroughProps.isHeightSetFromContent ? `1 0 ${height}px` : '0 1 100%'
                                },
                                uniqueKey: uniqueKey,
                                onLoad: (e)=>{
                                    handleIframeOnLoad();
                                    onLoad?.(e);
                                },
                                onUnload: handleIframeUnload,
                                onContentLoadStarted: handleContentLoadStarted
                            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {}),
                            showFooter && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fuXvj.Footer), {
                                url: footerUrl,
                                linkTooltip: formatMessage((0, $3ca9m.default).viewInConfluence),
                                label: formatMessage((0, $3ca9m.default).poweredBy)
                            })
                        ]
                    })
            })
        })
    });
};

});
parcelRegister("5XSQP", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $34f6e829880f545b$export$c90b54e658fc4d7c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $boRG7 = parcelRequire("boRG7");
function $34f6e829880f545b$export$c90b54e658fc4d7c({ children: children, name: name }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $boRG7.ExperienceContext).Provider, {
        value: name,
        children: children
    });
}

});
parcelRegister("boRG7", function(module, exports) {
$parcel$export(module.exports, "ExperienceContext", () => $1a24cfa7a9df9c2e$export$fb99266658f5da06);

var $eJOHy = parcelRequire("eJOHy");
const $1a24cfa7a9df9c2e$var$defaultExperienceContextValue = undefined;
const $1a24cfa7a9df9c2e$export$fb99266658f5da06 = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($1a24cfa7a9df9c2e$var$defaultExperienceContextValue);

});


parcelRegister("7LOUI", function(module, exports) {
$parcel$export(module.exports, "useSetUpExperience", () => $249484d1e0a88b58$export$48d5d434479c259e);

var $eJOHy = parcelRequire("eJOHy");

var $bq2fr = parcelRequire("bq2fr");
const $249484d1e0a88b58$export$48d5d434479c259e = ({ experienceTracker: experienceTracker, contentId: contentId, spaceKey: spaceKey, experience: experience, ccExperience: ccExperience })=>{
    const idRef = (0, $eJOHy.useRef)();
    const ccExperienceStartedRef = (0, $eJOHy.useRef)(false);
    const id = `${spaceKey}-${contentId}`;
    /**
	 * Start experience as close to the user action as possible.
	 * Our approximation is component's first render.
	 *
	 * Addition to starting experience on first render, embedding products may do SPA transition e.g. view different contents without remounting component.
	 * We need to re-start experience if `contentId` or `spaceKey` has changed.
	 * In this case, experience will abort the current ongoing one and start a new experience (by checking experience id)
	 */ if (idRef.current !== id) {
        experienceTracker.start({
            name: experience,
            id: id,
            collect (events, experience) {
                if (events.find((event)=>event.action === 'taskStart' && event.name === ccExperience && event.id === contentId)) ccExperienceStartedRef.current = true;
                /**
				 * We have experience forwarding from confluence-frontend
				 * With the forwarding experience set up, EP experience will be concluded following CC experience, either "succeed", "fail" or "abort"
				 */ experience.stopOn(events.find((event)=>(0, $bq2fr.isStop)(event) && event.name === ccExperience && event.id === contentId));
            }
        });
        idRef.current = id;
    }
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            /**
			 * User can navigates away (EP component unmount) before CC experience started
			 * In this case, we want to abort EP experience as the conclusion.
			 */ if (idRef.current && !ccExperienceStartedRef.current) experienceTracker.abort({
                name: experience,
                reason: 'User navigated away before starting to load'
            });
        };
    }, [
        experienceTracker,
        experience
    ]);
};

});
parcelRegister("bq2fr", function(module, exports) {
$parcel$export(module.exports, "isStop", () => $9cb259e8198ec504$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $9cb259e8198ec504$export$57069f5b2ecc9128);
const $9cb259e8198ec504$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $9cb259e8198ec504$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});


parcelRegister("kUYZz", function(module, exports) {
$parcel$export(module.exports, "Iframe", () => $addf700416df7c9f$export$5137ec99f248330b);
/* Iframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eaiF1 = parcelRequire("eaiF1");

var $huqaB = parcelRequire("huqaB");

var $4nJ3E = parcelRequire("4nJ3E");
const $addf700416df7c9f$var$iframeStyles = null;
const $addf700416df7c9f$export$5137ec99f248330b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ src: src, onLoad: onLoad, onUnload: onUnload, onContentLoadStarted: onContentLoadStarted, ...passThroughProps }, ref)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('common-load-end');
        markIframeLoadMetrics('iframe-content-initialized-start');
    }, [
        markIframeLoadMetrics
    ]);
    const iframeOnLoad = (0, $eJOHy.useCallback)((event)=>{
        onLoad && onLoad(event);
    }, [
        onLoad
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const handler = (e)=>{
            if (e.data.type === 'windowUnload') onUnload?.();
        };
        window.addEventListener('message', handler);
        return ()=>{
            window.removeEventListener('message', handler);
        };
    }, [
        onUnload
    ]);
    (0, $huqaB.useHostOffsetOverride)();
    const channel = (0, $eaiF1.useIframeCommunicationChannel)(src, {
        ...passThroughProps,
        onContentLoadStarted: onContentLoadStarted
    });
    // implementation because cleaner index export is not possible with forwardRef
    return /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        ref: ref,
        title: "confluence-article-iframe",
        "data-testid": "confluence-page-iframe",
        name: channel.name,
        src: src,
        onLoad: iframeOnLoad,
        // Grant features to iframe (Currently the same as smart card iframe's granted features)
        allow: "autoplay; fullscreen; encrypted-media; clipboard-write",
        // Same as "fullscreen" in "allow" attribute but it's considered a legacy attribute. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-allowfullscreen
        // Need it in case the browser doesn't support "fullscreen" feature policy.
        allowFullScreen: true,
        ...passThroughProps,
        className: (0, $hcewu.default)([
            "_19itglyw _1bsb1osq _4t3i1osq"
        ])
    });
});

});
parcelRegister("eaiF1", function(module, exports) {
$parcel$export(module.exports, "useIframeCommunicationChannel", () => $cd35ea78faffb064$export$c745b3af35ea8585);

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");

var $8FR7r = parcelRequire("8FR7r");

var $eGOwo = parcelRequire("eGOwo");
let $cd35ea78faffb064$var$host = null;

// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') $cd35ea78faffb064$var$host = (parcelRequire("818E2"));
function $cd35ea78faffb064$var$defineModule(name, module) {
    $cd35ea78faffb064$var$host.defineModule(name, module);
}
const $cd35ea78faffb064$var$useExperienceForwardingModule = ()=>{
    const experienceTrackerRef = (0, $eJOHy.useRef)();
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    if (experienceTrackerRef.current !== experienceTracker) {
        $cd35ea78faffb064$var$defineModule((0, $8FR7r.EXPERIENCE_FORWARDING_MODULE_NAME), {
            start (options) {
                experienceTracker.start(options);
            },
            abort (options) {
                experienceTracker.abort(options);
            },
            succeed (options) {
                experienceTracker.succeed(options);
            },
            fail (options) {
                experienceTracker.fail(options);
            }
        });
        experienceTrackerRef.current = experienceTracker;
    }
};
const $cd35ea78faffb064$var$usePassThroughPropsModule = (props)=>{
    const { onContentLoadStarted: onContentLoadStarted, ...passThroughProps } = props;
    const dispatchPropsUpdated = (0, $eJOHy.useCallback)(()=>{
        $cd35ea78faffb064$var$host.dispatch((0, $8FR7r.PROPS_UPDATED), {
            addon_key: (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? passThroughProps.uniqueKey ?? (0, $8FR7r.CHANNEL_NAME) : (0, $8FR7r.CHANNEL_NAME),
            ...(0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') && {
                key: passThroughProps.uniqueKey ?? (0, $8FR7r.CHANNEL_NAME)
            }
        }, {
            message: JSON.stringify(passThroughProps)
        });
    /**
		 * Disable react-hooks/exhaustive-deps linting, the dependency has passThroughProps spreading on its keys and values
		 * This should be able to handle any changes to the `passThroughProps` would recall the effect function.
		 **/ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.keys(passThroughProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.values(passThroughProps),
        passThroughProps.uniqueKey
    ]);
    const dispatchPropsUpdatedRef = (0, $eJOHy.useRef)();
    if (dispatchPropsUpdatedRef.current !== dispatchPropsUpdated) {
        $cd35ea78faffb064$var$defineModule((0, $8FR7r.PASSTHROUGH_PROPS_MODULE_NAME), {
            getProps: ()=>{
                onContentLoadStarted?.();
                dispatchPropsUpdated();
            },
            navigationPolicyNavigate: passThroughProps.navigationPolicy?.navigate,
            onPublish: passThroughProps?.onPublish
        });
        dispatchPropsUpdatedRef.current = dispatchPropsUpdated;
    }
    (0, $eJOHy.useEffect)(dispatchPropsUpdated, [
        dispatchPropsUpdated
    ]);
};
function $cd35ea78faffb064$export$c745b3af35ea8585(iframeSrc, passThroughProps) {
    const channelRef = (0, $eJOHy.useRef)();
    const uniqueKey = passThroughProps.uniqueKey ?? (0, $8FR7r.CHANNEL_NAME);
    $cd35ea78faffb064$var$useExperienceForwardingModule();
    $cd35ea78faffb064$var$usePassThroughPropsModule(passThroughProps);
    if (channelRef.current?.src !== iframeSrc) channelRef.current = $cd35ea78faffb064$var$host.create({
        addon_key: (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? uniqueKey : (0, $8FR7r.CHANNEL_NAME),
        key: (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? uniqueKey : (0, $8FR7r.CHANNEL_NAME),
        url: iframeSrc,
        options: {
            globalOptions: {},
            // `hostFrameOffset` - Offset number specified to find iframe's host frame, it will be `window.top` if not specified.
            // Since EP frame can be embedded by middle layer frame(s), we set `hostFrameOffset` to 1 to ensure EP iframe's direct parent is the host frame.
            hostFrameOffset: 1,
            hostOrigin: window.location.origin
        }
    });
    return channelRef.current;
}

});
parcelRegister("8FR7r", function(module, exports) {
$parcel$export(module.exports, "CHANNEL_NAME", () => $0b197a18be2c51cd$export$ab9998995666ebe3);
$parcel$export(module.exports, "createUniqueKey", () => $0b197a18be2c51cd$export$f2fe03976fe13de);
$parcel$export(module.exports, "PASSTHROUGH_PROPS_MODULE_NAME", () => $0b197a18be2c51cd$export$45b0adb7f9689286);
$parcel$export(module.exports, "PROPS_UPDATED", () => $0b197a18be2c51cd$export$78cada8c8749e264);
$parcel$export(module.exports, "EXPERIENCE_FORWARDING_MODULE_NAME", () => $0b197a18be2c51cd$export$b75934a6b56fd9ba);

var $aXKmr = parcelRequire("aXKmr");
const $0b197a18be2c51cd$export$ab9998995666ebe3 = 'embedded-confluence-iframe';
const $0b197a18be2c51cd$export$f2fe03976fe13de = ()=>{
    return `${$0b197a18be2c51cd$export$ab9998995666ebe3}-${(0, $aXKmr.v4)()}`;
};
const $0b197a18be2c51cd$export$45b0adb7f9689286 = 'passThroughProps';
const $0b197a18be2c51cd$export$78cada8c8749e264 = 'propsUpdated';
const $0b197a18be2c51cd$export$b75934a6b56fd9ba = 'experienceForwarding';

});

parcelRegister("818E2", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_("./util");
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var PostMessage = function() {
                    function PostMessage(data) {
                        _classCallCheck(this, PostMessage);
                        var d = data || {};
                        this._registerListener(d.listenOn);
                    }
                    _createClass(PostMessage, [
                        {
                            key: "_registerListener",
                            value: function _registerListener(listenOn) {
                                if (!listenOn || !listenOn.addEventListener) listenOn = window;
                                listenOn.addEventListener("message", _util2.default._bind(this, this._receiveMessage), false);
                            }
                        },
                        {
                            key: "_receiveMessage",
                            value: function _receiveMessage(event) {
                                var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg = void 0;
                                if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
                                if (!handler || !this._checkOrigin(event, reg)) return false;
                                handler.call(this, event, reg);
                            }
                        }
                    ]);
                    return PostMessage;
                }();
                exports.default = PostMessage;
                module1.exports = exports["default"];
            },
            {
                "./util": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var LOG_PREFIX = "[Simple-XDM] ";
                var nativeBind = Function.prototype.bind;
                var util = {
                    locationOrigin: function locationOrigin() {
                        if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                        else return window.location.origin;
                    },
                    randomString: function randomString() {
                        return Math.floor(Math.random() * 1000000000).toString(16);
                    },
                    isString: function isString(str) {
                        return typeof str === "string" || str instanceof String;
                    },
                    argumentsToArray: function argumentsToArray(arrayLike) {
                        return Array.prototype.slice.call(arrayLike);
                    },
                    argumentNames: function argumentNames(fn) {
                        return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, '') // strip comments
                        .replace(/[^(]+\(([^)]*)[^]+/, '$1') // get signature
                        .match(/([^\s,]+)/g) || [];
                    },
                    hasCallback: function hasCallback(args) {
                        var length = args.length;
                        return length > 0 && typeof args[length - 1] === 'function';
                    },
                    error: function error(msg) {
                        if (window.console && window.console.error) {
                            var outputError = [];
                            if (typeof msg === "string") {
                                outputError.push(LOG_PREFIX + msg);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                            } else {
                                outputError.push(LOG_PREFIX);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments));
                            }
                            window.console.error.apply(null, outputError);
                        }
                    },
                    warn: function warn(msg) {
                        if (window.console) console.warn(LOG_PREFIX + msg);
                    },
                    log: function log(msg) {
                        if (window.console) window.console.log(LOG_PREFIX + msg);
                    },
                    _bind: function _bind(thisp, fn) {
                        if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
                        return function() {
                            return fn.apply(thisp, arguments);
                        };
                    },
                    throttle: function throttle(func, wait, context) {
                        var previous = 0;
                        return function() {
                            var now = Date.now();
                            if (now - previous > wait) {
                                previous = now;
                                func.apply(context, arguments);
                            }
                        };
                    },
                    each: function each(list, iteratee) {
                        var length;
                        var key;
                        if (list) {
                            length = list.length;
                            if (length != null && typeof list !== 'function') {
                                key = 0;
                                while(key < length){
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                    key += 1;
                                }
                            } else {
                                for(key in list)if (list.hasOwnProperty(key)) {
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                }
                            }
                        }
                    },
                    extend: function extend(dest) {
                        var args = arguments;
                        var srcs = [].slice.call(args, 1, args.length);
                        srcs.forEach(function(source) {
                            if ((typeof source === "undefined" ? "undefined" : _typeof(source)) === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                                dest[name] = source[name];
                            });
                        });
                        return dest;
                    },
                    sanitizeStructuredClone: function sanitizeStructuredClone(object) {
                        var whiteList = [
                            Boolean,
                            String,
                            Date,
                            RegExp,
                            Blob,
                            File,
                            FileList,
                            ArrayBuffer
                        ];
                        var blackList = [
                            Error,
                            Node
                        ];
                        var warn = util.warn;
                        var visitedObjects = [];
                        function _clone(value) {
                            if (typeof value === 'function') {
                                warn("A function was detected and removed from the message.");
                                return null;
                            }
                            if (blackList.some(function(t) {
                                if (value instanceof t) {
                                    warn(t.name + " object was detected and removed from the message.");
                                    return true;
                                }
                                return false;
                            })) return {};
                            if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && whiteList.every(function(t) {
                                return !(value instanceof t);
                            })) {
                                var newValue = void 0;
                                if (Array.isArray(value)) newValue = value.map(function(element) {
                                    return _clone(element);
                                });
                                else {
                                    if (visitedObjects.indexOf(value) > -1) {
                                        warn("A circular reference was detected and removed from the message.");
                                        return null;
                                    }
                                    visitedObjects.push(value);
                                    newValue = {};
                                    for(var name in value)if (value.hasOwnProperty(name)) {
                                        var clonedValue = _clone(value[name]);
                                        if (clonedValue !== null) newValue[name] = clonedValue;
                                    }
                                    visitedObjects.pop();
                                }
                                return newValue;
                            }
                            return value;
                        }
                        return _clone(object);
                    },
                    getOrigin: function getOrigin(url, base) {
                        // everything except IE11
                        if (typeof URL === 'function') try {
                            return new URL(url, base).origin;
                        } catch (e) {}
                        // ie11 + safari 10
                        var doc = document.implementation.createHTMLDocument('');
                        if (base) {
                            var baseElement = doc.createElement('base');
                            baseElement.href = base;
                            doc.head.appendChild(baseElement);
                        }
                        var anchorElement = doc.createElement('a');
                        anchorElement.href = url;
                        doc.body.appendChild(anchorElement);
                        var origin = anchorElement.protocol + '//' + anchorElement.hostname;
                        //ie11, only include port if referenced in initial URL
                        if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
                        return origin;
                    }
                };
                exports.default = util;
                module1.exports = exports["default"];
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _xdmrpc = _dereq_('./xdmrpc');
                var _xdmrpc2 = _interopRequireDefault(_xdmrpc);
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var Connect = function() {
                    function Connect() {
                        _classCallCheck(this, Connect);
                        this._xdm = new _xdmrpc2.default();
                    }
                    /**
   * Send a message to iframes matching the targetSpec. This message is added to
   *  a message queue for delivery to ensure the message is received if an iframe
   *  has not yet loaded
   *
   * @param type The name of the event type
   * @param targetSpec The spec to match against extensions when sending this event
   * @param event The event payload
   * @param callback A callback to be executed when the remote iframe calls its callback
   */ _createClass(Connect, [
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback) {
                                this._xdm.queueEvent(type, targetSpec, event, callback);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: 'broadcast',
                            value: function broadcast(type, targetSpec, event) {
                                this._xdm.dispatch(type, targetSpec, event, null, null);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: '_createId',
                            value: function _createId(extension) {
                                if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
                                return extension.addon_key + '__' + extension.key + '__' + _util2.default.randomString();
                            }
                        },
                        {
                            key: 'create',
                            value: function create(extension, initCallback, unloadCallback) {
                                var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
                                var options = extension.options || {};
                                var data = {
                                    extension_id: extension_id,
                                    api: this._xdm.getApiSpec(extension.addon_key),
                                    origin: _util2.default.locationOrigin(),
                                    options: options
                                };
                                return {
                                    id: extension_id,
                                    name: JSON.stringify(data),
                                    src: extension.url
                                };
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(callback) {
                                this._xdm.registerRequestNotifier(callback);
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension, initCallback, unloadCallback) {
                                var extension_id = this._createId(extension);
                                this._xdm.registerExtension(extension_id, {
                                    extension: extension,
                                    initCallback: initCallback,
                                    unloadCallback: unloadCallback
                                });
                                return extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                this._xdm.registerClickHandler(callback);
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._xdm.unregisterClickHandler();
                            }
                        },
                        {
                            key: 'defineModule',
                            value: function defineModule(moduleName, module1, options) {
                                this._xdm.defineAPIModule(module1, moduleName, options);
                            }
                        },
                        {
                            key: 'isModuleDefined',
                            value: function isModuleDefined(moduleName) {
                                return this._xdm.isAPIModuleDefined(moduleName);
                            }
                        },
                        {
                            key: 'defineGlobals',
                            value: function defineGlobals(module1) {
                                this._xdm.defineAPIModule(module1);
                            }
                        },
                        {
                            key: 'getExtensions',
                            value: function getExtensions(filter) {
                                return this._xdm.getRegisteredExtensions(filter);
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                return this._xdm.unregisterExtension(filter);
                            }
                        },
                        {
                            key: 'returnsPromise',
                            value: function returnsPromise(wrappedMethod) {
                                wrappedMethod.returnsPromise = true;
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
                            }
                        },
                        {
                            key: 'registerExistingExtension',
                            value: function registerExistingExtension(extension_id, data) {
                                return this._xdm.registerExtension(extension_id, data);
                            }
                        }
                    ]);
                    return Connect;
                }();
                exports.default = Connect;
                module1.exports = exports['default'];
            },
            {
                "../common/util": 2,
                "./xdmrpc": 5
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _connect = _dereq_('./connect');
                var _connect2 = _interopRequireDefault(_connect);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                exports.default = new _connect2.default();
                module1.exports = exports['default'];
            },
            {
                "./connect": 3
            }
        ],
        5: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                var _postmessage = _dereq_('../common/postmessage');
                var _postmessage2 = _interopRequireDefault(_postmessage);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _possibleConstructorReturn(self, call) {
                    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                } /**
  * Postmessage format:
  *
  * Initialization
  * --------------
  * {
  *   type: 'init',
  *   eid: 'my-addon__my-module-xyz'  // the extension identifier, unique across iframes
  * }
  *
  * Request
  * -------
  * {
  *   type: 'req',
  *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
  *   mid: 'xyz',  // a unique message identifier, required for callbacks
  *   mod: 'cookie',  // the module name
  *   fn: 'read',  // the method name
  *   args: [arguments]  // the method arguments
  * }
  *
  * Response
  * --------
  * {
  *   type: 'resp'
  *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
  *   mid: 'xyz',  // a unique message identifier, obtained from the request
  *   args: [arguments]  // the callback arguments
  * }
  *
  * Event
  * -----
  * {
  *   type: 'evt',
  *   etyp: 'some-event',
  *   evnt: { ... }  // the event data
  *   mid: 'xyz', // a unique message identifier for the event
  * }
  **/ 
                var VALID_EVENT_TIME_MS = 30000; //30 seconds
                var XDMRPC = function(_PostMessage) {
                    _inherits(XDMRPC, _PostMessage);
                    _createClass(XDMRPC, [
                        {
                            key: '_padUndefinedArguments',
                            value: function _padUndefinedArguments(array, length) {
                                return array.length >= length ? array : array.concat(new Array(length - array.length));
                            }
                        }
                    ]);
                    function XDMRPC(config) {
                        _classCallCheck(this, XDMRPC);
                        config = config || {};
                        var _this = _possibleConstructorReturn(this, (XDMRPC.__proto__ || Object.getPrototypeOf(XDMRPC)).call(this, config));
                        _this._registeredExtensions = config.extensions || {};
                        _this._registeredAPIModules = {};
                        _this._registeredAPIModules._globals = {};
                        _this._pendingCallbacks = {};
                        _this._keycodeCallbacks = {};
                        _this._clickHandler = null;
                        _this._pendingEvents = {};
                        _this._messageHandlers = {
                            init: _this._handleInit,
                            req: _this._handleRequest,
                            resp: _this._handleResponse,
                            broadcast: _this._handleBroadcast,
                            event_query: _this._handleEventQuery,
                            key_triggered: _this._handleKeyTriggered,
                            addon_clicked: _this._handleAddonClick,
                            get_host_offset: _this._getHostOffset,
                            unload: _this._handleUnload,
                            sub: _this._handleSubInit
                        };
                        return _this;
                    }
                    _createClass(XDMRPC, [
                        {
                            key: '_verifyAPI',
                            value: function _verifyAPI(event, reg) {
                                var untrustedTargets = event.data.targets;
                                if (!untrustedTargets) return;
                                var trustedSpec = this.getApiSpec();
                                var tampered = false;
                                function check(trusted, untrusted) {
                                    Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                                        if (_typeof(untrusted[name]) === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                                        else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
                                    });
                                }
                                check(trustedSpec, untrustedTargets);
                                event.source.postMessage({
                                    type: 'api_tamper',
                                    tampered: tampered
                                }, reg.extension.url);
                            }
                        },
                        {
                            key: '_handleInit',
                            value: function _handleInit(event, reg) {
                                event.source.postMessage({
                                    type: 'init_received'
                                }, reg.extension.url);
                                this._registeredExtensions[reg.extension_id].source = event.source;
                                if (reg.initCallback) {
                                    reg.initCallback(event.data.eid);
                                    delete reg.initCallback;
                                }
                                if (event.data.targets) this._verifyAPI(event, reg);
                            }
                        },
                        {
                            key: '_handleSubInit',
                            value: function _handleSubInit(event, reg) {
                                var blocked = reg.extension.options.noSub || this._getBooleanFeatureFlag && this._getBooleanFeatureFlag('com.atlassian.connect.resolve_inner_iframe_url');
                                var data = event.data;
                                if (blocked) _util2.default.error("Sub-Extension requested by [" + reg.extension.addon_key + "] but feature is disabled");
                                else this.registerExtension(data.ext.id, {
                                    extension: data.ext
                                });
                                if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                    sub: data.ext,
                                    type: data.type,
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id,
                                    blocked: blocked
                                });
                            }
                        },
                        {
                            key: '_getHostOffset',
                            value: function _getHostOffset(event, _window) {
                                var hostWindow = event.source;
                                var hostFrameOffset = null;
                                var windowReference = _window || window; // For testing
                                if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
                                if (typeof hostFrameOffset !== 'number') {
                                    hostFrameOffset = 0;
                                    // Find the closest frame that has the same origin as event source
                                    while(!this._hasSameOrigin(hostWindow)){
                                        // Climb up the iframe tree 1 layer
                                        hostFrameOffset++;
                                        hostWindow = hostWindow.parent;
                                    }
                                }
                                event.source.postMessage({
                                    hostFrameOffset: hostFrameOffset
                                }, event.origin);
                            }
                        },
                        {
                            key: '_hasSameOrigin',
                            value: function _hasSameOrigin(window1) {
                                if (window1 === window1.top) return true;
                                try {
                                    // Try set & read a variable on the given window
                                    // If we can successfully read the value then it means the given window has the same origin
                                    // as the window that is currently executing the script
                                    var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
                                    window1[testVariableName] = true;
                                    return window1[testVariableName];
                                } catch (e) {
                                // A exception will be thrown if the windows doesn't have the same origin
                                }
                                return false;
                            }
                        },
                        {
                            key: '_handleResponse',
                            value: function _handleResponse(event) {
                                var data = event.data;
                                var pendingCallback = this._pendingCallbacks[data.mid];
                                if (pendingCallback) {
                                    delete this._pendingCallbacks[data.mid];
                                    pendingCallback.apply(window, data.args);
                                }
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(cb) {
                                this._registeredRequestNotifier = cb;
                            }
                        },
                        {
                            key: '_handleRequest',
                            value: function _handleRequest(event, reg) {
                                function sendResponse() {
                                    var args = _util2.default.sanitizeStructuredClone(_util2.default.argumentsToArray(arguments));
                                    event.source.postMessage({
                                        mid: event.data.mid,
                                        type: 'resp',
                                        forPlugin: true,
                                        args: args
                                    }, reg.extension.url);
                                }
                                var data = event.data;
                                var module1 = this._registeredAPIModules[data.mod];
                                var extension = this.getRegisteredExtensions(reg.extension)[0];
                                if (module1) {
                                    var fnName = data.fn;
                                    if (data._cls) {
                                        var Cls = module1[data._cls];
                                        var ns = data.mod + '-' + data._cls + '-';
                                        sendResponse._id = data._id;
                                        if (fnName === 'constructor') {
                                            if (!Cls._construct) {
                                                Cls.constructor.prototype._destroy = function() {
                                                    delete this._context._proxies[ns + this._id];
                                                };
                                                Cls._construct = function() {
                                                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                                    var inst = new (Function.prototype.bind.apply(Cls.constructor, [
                                                        null
                                                    ].concat(args)))();
                                                    var callback = args[args.length - 1];
                                                    inst._id = callback._id;
                                                    inst._context = callback._context;
                                                    inst._context._proxies[ns + inst._id] = inst;
                                                    return inst;
                                                };
                                            }
                                            module1 = Cls;
                                            fnName = '_construct';
                                        } else module1 = extension._proxies[ns + data._id];
                                    }
                                    var method = module1[fnName];
                                    if (method) {
                                        var methodArgs = data.args;
                                        var padLength = method.length - 1;
                                        if (fnName === '_construct') padLength = module1.constructor.length - 1;
                                        sendResponse._context = extension;
                                        methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                                        methodArgs.push(sendResponse);
                                        var promiseResult = method.apply(module1, methodArgs);
                                        if (method.returnsPromise) {
                                            if (!((typeof promiseResult === 'undefined' ? 'undefined' : _typeof(promiseResult)) === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                                            else promiseResult.then(function(result) {
                                                sendResponse(undefined, result);
                                            }).catch(function(err) {
                                                err = err instanceof Error ? err.message : err;
                                                sendResponse(err);
                                            });
                                        }
                                        if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                            module: data.mod,
                                            fn: data.fn,
                                            type: data.type,
                                            addon_key: reg.extension.addon_key,
                                            key: reg.extension.key,
                                            extension_id: reg.extension_id
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: '_handleBroadcast',
                            value: function _handleBroadcast(event, reg) {
                                var event_data = event.data;
                                var targetSpec = function targetSpec(r) {
                                    return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
                                };
                                this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
                            }
                        },
                        {
                            key: '_handleKeyTriggered',
                            value: function _handleKeyTriggered(event, reg) {
                                var eventData = event.data;
                                var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
                                var listeners = this._keycodeCallbacks[keycodeEntry];
                                if (listeners) listeners.forEach(function(listener) {
                                    listener.call(null, {
                                        addon_key: reg.extension.addon_key,
                                        key: reg.extension.key,
                                        extension_id: reg.extension_id,
                                        keycode: eventData.keycode,
                                        modifiers: eventData.modifiers
                                    });
                                }, this);
                            }
                        },
                        {
                            key: 'defineAPIModule',
                            value: function defineAPIModule(module1, moduleName) {
                                moduleName = moduleName || '_globals';
                                this._registeredAPIModules[moduleName] = _util2.default.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
                                return this._registeredAPIModules;
                            }
                        },
                        {
                            key: 'isAPIModuleDefined',
                            value: function isAPIModuleDefined(moduleName) {
                                return typeof this._registeredAPIModules[moduleName] !== 'undefined';
                            }
                        },
                        {
                            key: '_pendingEventKey',
                            value: function _pendingEventKey(targetSpec, time) {
                                var key = targetSpec.addon_key || 'global';
                                if (targetSpec.key) key = key + '@@' + targetSpec.key;
                                key = key + '@@' + time;
                                return key;
                            }
                        },
                        {
                            key: 'queueEvent',
                            value: function queueEvent(type, targetSpec, event, callback) {
                                var loaded_frame, targets = this._findRegistrations(targetSpec);
                                loaded_frame = targets.some(function(target) {
                                    return target.registered_events !== undefined;
                                }, this);
                                if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
                                else {
                                    this._cleanupInvalidEvents();
                                    var time = new Date().getTime();
                                    this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                                        type: type,
                                        targetSpec: targetSpec,
                                        event: event,
                                        callback: callback,
                                        time: time,
                                        uid: _util2.default.randomString()
                                    };
                                }
                            }
                        },
                        {
                            key: '_cleanupInvalidEvents',
                            value: function _cleanupInvalidEvents() {
                                var _this2 = this;
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this2._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    if (!eventIsValid) delete _this2._pendingEvents[index];
                                });
                            }
                        },
                        {
                            key: '_handleEventQuery',
                            value: function _handleEventQuery(message, extension) {
                                var _this3 = this;
                                var executed = {};
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this3._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                                    if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                                    if (eventIsValid && isSameTarget) {
                                        executed[index] = element;
                                        element.targetSpec = element.targetSpec || {};
                                        _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                                    } else if (!eventIsValid) delete _this3._pendingEvents[index];
                                });
                                this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
                                return executed;
                            }
                        },
                        {
                            key: '_handleUnload',
                            value: function _handleUnload(event, reg) {
                                if (!reg) return;
                                if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
                                if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
                            }
                        },
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback, source) {
                                function sendEvent(reg, evnt) {
                                    if (reg.source && reg.source.postMessage) {
                                        var mid;
                                        if (callback) {
                                            mid = _util2.default.randomString();
                                            this._pendingCallbacks[mid] = callback;
                                        }
                                        reg.source.postMessage({
                                            type: 'evt',
                                            mid: mid,
                                            etyp: type,
                                            evnt: evnt
                                        }, reg.extension.url);
                                    }
                                }
                                var registrations = this._findRegistrations(targetSpec || {});
                                registrations.forEach(function(reg) {
                                    if (source && !reg.source) reg.source = source;
                                    if (reg.source) _util2.default._bind(this, sendEvent)(reg, event);
                                }, this);
                            }
                        },
                        {
                            key: '_findRegistrations',
                            value: function _findRegistrations(targetSpec) {
                                var _this4 = this;
                                if (this._registeredExtensions.length === 0) {
                                    _util2.default.error('no registered extensions', this._registeredExtensions);
                                    return [];
                                }
                                var keys = Object.getOwnPropertyNames(targetSpec);
                                var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                                    return _this4._registeredExtensions[key];
                                });
                                if (targetSpec instanceof Function) return registrations.filter(targetSpec);
                                else return registrations.filter(function(reg) {
                                    return keys.every(function(key) {
                                        return reg.extension[key] === targetSpec[key];
                                    });
                                });
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension_id, data) {
                                data._proxies = {};
                                data.extension_id = extension_id;
                                this._registeredExtensions[extension_id] = data;
                            }
                        },
                        {
                            key: '_keycodeKey',
                            value: function _keycodeKey(key, modifiers, extension_id) {
                                var code = key;
                                if (modifiers) {
                                    if (typeof modifiers === "string") modifiers = [
                                        modifiers
                                    ];
                                    modifiers.sort();
                                    modifiers.forEach(function(modifier) {
                                        code += '$$' + modifier;
                                    }, this);
                                }
                                return code + '__' + extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                if (typeof modifiers === "string") modifiers = [
                                    modifiers
                                ];
                                var reg = this._registeredExtensions[extension_id];
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                if (!this._keycodeCallbacks[keycodeEntry]) {
                                    this._keycodeCallbacks[keycodeEntry] = [];
                                    reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'add'
                                    }, reg.extension.url);
                                }
                                this._keycodeCallbacks[keycodeEntry].push(callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
                                var reg = this._registeredExtensions[extension_id];
                                if (potentialCallbacks) {
                                    if (callback) {
                                        var index = potentialCallbacks.indexOf(callback);
                                        this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                                    } else delete this._keycodeCallbacks[keycodeEntry];
                                    if (reg.source && reg.source.postMessage) reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'remove'
                                    }, reg.extension.url);
                                }
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                if (typeof callback !== 'function') throw new Error('callback must be a function');
                                if (this._clickHandler !== null) throw new Error('ClickHandler already registered');
                                this._clickHandler = callback;
                            }
                        },
                        {
                            key: '_handleAddonClick',
                            value: function _handleAddonClick(event, reg) {
                                if (typeof this._clickHandler === 'function') this._clickHandler({
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id
                                });
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._clickHandler = null;
                            }
                        },
                        {
                            key: 'getApiSpec',
                            value: function getApiSpec(addonKey) {
                                var _this5 = this;
                                function getModuleDefinition(mod) {
                                    return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                                        var member = mod[memberName];
                                        switch(typeof member === 'undefined' ? 'undefined' : _typeof(member)){
                                            case 'function':
                                                accumulator[memberName] = {
                                                    args: _util2.default.argumentNames(member),
                                                    returnsPromise: member.returnsPromise || false
                                                };
                                                break;
                                            case 'object':
                                                if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                                                break;
                                        }
                                        return accumulator;
                                    }, {});
                                }
                                return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                                    var module1 = _this5._registeredAPIModules[moduleName];
                                    if (typeof module1.addonKey === 'undefined' || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                                    return accumulator;
                                }, {});
                            }
                        },
                        {
                            key: '_originEqual',
                            value: function _originEqual(url, origin) {
                                function strCheck(str) {
                                    return typeof str === 'string' && str.length > 0;
                                }
                                var urlOrigin = _util2.default.getOrigin(url);
                                // check strings are strings and they contain something
                                if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
                                return origin === urlOrigin;
                            }
                        },
                        {
                            key: '_checkOrigin',
                            value: function _checkOrigin(event, reg) {
                                var no_source_types = [
                                    'init'
                                ];
                                var isNoSourceType = reg && !reg.source && no_source_types.indexOf(event.data.type) > -1;
                                var sourceTypeMatches = reg && event.source === reg.source;
                                var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
                                var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches);
                                // get_host_offset fires before init
                                if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
                                // check undefined for chromium (Issue 395010)
                                if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
                                return isValidOrigin;
                            }
                        },
                        {
                            key: 'getRegisteredExtensions',
                            value: function getRegisteredExtensions(filter) {
                                if (filter) return this._findRegistrations(filter);
                                return this._registeredExtensions;
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                var registrations = this._findRegistrations(filter);
                                if (registrations.length !== 0) registrations.forEach(function(registration) {
                                    var _this6 = this;
                                    var keys = Object.keys(this._pendingEvents);
                                    keys.forEach(function(index) {
                                        var element = _this6._pendingEvents[index];
                                        var targetSpec = element.targetSpec || {};
                                        if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                                    });
                                    delete this._registeredExtensions[registration.extension_id];
                                }, this);
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._getBooleanFeatureFlag = getBooleanFeatureFlag;
                            }
                        }
                    ]);
                    return XDMRPC;
                }(_postmessage2.default);
                exports.default = XDMRPC;
                module1.exports = exports['default'];
            },
            {
                "../common/postmessage": 1,
                "../common/util": 2
            }
        ]
    }, {}, [
        4
    ])(4);
});

});


parcelRegister("huqaB", function(module, exports) {
$parcel$export(module.exports, "useHostOffsetOverride", () => $2eb8a60db06bd239$export$db5957f3934e2c38);

var $eJOHy = parcelRequire("eJOHy");
function $2eb8a60db06bd239$var$isSameOrigin(targetWindow, currentWindow = window) {
    let isSameOrigin1;
    try {
        isSameOrigin1 = targetWindow?.location.origin === currentWindow?.location.origin;
    } catch (e) {
        // catch the DOM exception, mark the resolution to "false"
        isSameOrigin1 = false;
    }
    return isSameOrigin1;
}
const $2eb8a60db06bd239$export$28f1b4bd74242643 = (hostWindow, offset = 0)=>{
    let currentWindow = hostWindow;
    let hostFrameOffset = 0;
    while(currentWindow && currentWindow !== window.top){
        hostFrameOffset += 1;
        currentWindow = currentWindow.parent;
    }
    return hostFrameOffset - offset;
};
const $2eb8a60db06bd239$var$attachHostOffsetOverride = (window1)=>{
    if (window1.top) {
        if ($2eb8a60db06bd239$var$isSameOrigin(window1.top)) {
            const containerDepth = $2eb8a60db06bd239$export$28f1b4bd74242643(window1);
            // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
            window1.top.getHostOffsetFunctionOverride = (hostWindow)=>$2eb8a60db06bd239$export$28f1b4bd74242643(hostWindow, containerDepth + 1);
        }
    }
};
const $2eb8a60db06bd239$var$detachHostOffsetOverride = ()=>{
    if (window.top) {
        if ($2eb8a60db06bd239$var$isSameOrigin(window.top)) // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
        delete window.top.getHostOffsetFunctionOverride;
    }
};
function $2eb8a60db06bd239$export$db5957f3934e2c38() {
    (0, $eJOHy.useEffect)(()=>{
        $2eb8a60db06bd239$var$attachHostOffsetOverride(window);
        return ()=>{
            $2eb8a60db06bd239$var$detachHostOffsetOverride();
        };
    }, []);
}

});

parcelRegister("4nJ3E", function(module, exports) {
$parcel$export(module.exports, "usePerformanceMetrics", () => $212d532a1326c787$export$865423e6f8e2e839);
$parcel$export(module.exports, "PerformanceMetricsProvider", () => $212d532a1326c787$export$c6f19d9afc6c86c8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5P7sD = parcelRequire("5P7sD");


var $eGOwo = parcelRequire("eGOwo");
// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $212d532a1326c787$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $212d532a1326c787$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $212d532a1326c787$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $eJOHy.useState)(contentType);
    const isInitialized = (0, $eJOHy.useRef)(true);
    const iframeLoadMetrics = (0, $eJOHy.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $5P7sD.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            switch(e.data.type){
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$e5b04c2a3cc97ddc):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$9f8bbf62fac57d48):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$e08d2ab8ef653595):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$73b982309451f084):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $5P7sD.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $eJOHy.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $eJOHy.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($212d532a1326c787$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $212d532a1326c787$export$865423e6f8e2e839 = ()=>{
    return (0, $eJOHy.useContext)($212d532a1326c787$var$PerformanceMetricsContext);
};
const $212d532a1326c787$export$2ba0c6357609a3dd = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $212d532a1326c787$export$865423e6f8e2e839();
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $gt9Am.jsx)($212d532a1326c787$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
const $212d532a1326c787$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>(0, $eGOwo.fg)('embedded-confluence-performance-markers') ? /*#__PURE__*/ (0, $gt9Am.jsx)($212d532a1326c787$export$2ba0c6357609a3dd, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });

});
parcelRegister("5P7sD", function(module, exports) {
$parcel$export(module.exports, "embeddedViewToEditTransitionMetric", () => $e30bbd423029a7b8$export$4de078c3b9971f9b);
$parcel$export(module.exports, "embeddedConfluenceIframeLoadMetrics", () => $e30bbd423029a7b8$export$a23245993532c751);

var $hqYEY = parcelRequire("hqYEY");

var $cXQfL = parcelRequire("cXQfL");
const $e30bbd423029a7b8$export$4de078c3b9971f9b = ()=>(0, $hqYEY.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $e30bbd423029a7b8$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $e30bbd423029a7b8$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e30bbd423029a7b8$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e30bbd423029a7b8$var$timings
    }
};
const $e30bbd423029a7b8$export$a23245993532c751 = (contentType)=>(0, $hqYEY.metrics).pageSegmentLoad($e30bbd423029a7b8$var$loadingMetricsConfig[contentType]);

});

const $e5befacaa387021d$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $e5befacaa387021d$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $e5befacaa387021d$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $e5befacaa387021d$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $e5befacaa387021d$export$73b982309451f084 = 'embedded-iframe-content-initialized';



parcelRegister("fuXvj", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $aa643ac6d9a3565e$export$a06f1c675e846f6f);
/* Footer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-html-anchor */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ftN6c = parcelRequire("ftN6c");

var $lgMTT = parcelRequire("lgMTT");

var $k71qx = parcelRequire("k71qx");

var $fnLem = parcelRequire("fnLem");
const $aa643ac6d9a3565e$var$FOOTER_CONTENT_HEIGHT = 52;
const $aa643ac6d9a3565e$var$FOOTER_BORDER_PX = 2;
const $aa643ac6d9a3565e$export$a2dd5f25b5a4e5d2 = $aa643ac6d9a3565e$var$FOOTER_CONTENT_HEIGHT + $aa643ac6d9a3565e$var$FOOTER_BORDER_PX;
const $aa643ac6d9a3565e$var$containerStyles = null;
const $aa643ac6d9a3565e$var$contentWrapperStyles = null;
const $aa643ac6d9a3565e$var$logoWrapperSyles = null;
const $aa643ac6d9a3565e$var$linkStyles = null;
const $aa643ac6d9a3565e$export$a06f1c675e846f6f = ({ url: url, linkTooltip: linkTooltip, label: label })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": "footer-container",
        className: (0, $hcewu.default)([
            "_11c8dcr7 _16jlidpf _1o9zidpf _i0dl1ex1 _x3dowsm2 _4t3i1ex1 _syaz1n3s _1e0c1txw _4cvr1h6o _1bah1h6o"
        ]),
        children: url ? /*#__PURE__*/ (0, $gt9Am.jsx)($aa643ac6d9a3565e$var$ContentAction, {
            tooltipText: linkTooltip,
            href: url,
            children: ({ isHovered: isHovered })=>/*#__PURE__*/ (0, $gt9Am.jsx)($aa643ac6d9a3565e$var$Content, {
                    isHovered: isHovered,
                    label: label
                })
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)($aa643ac6d9a3565e$var$Content, {
            label: label
        })
    });
const $aa643ac6d9a3565e$var$Content = ({ isHovered: isHovered, label: label })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            "_4t3i7vkz _1e0c1txw _1bah1h6o _4cvresu3"
        ]),
        children: [
            label,
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _19pkidpf _2hwxidpf _otyridpf _18u0u2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceLogo), {
                    appearance: isHovered ? 'brand' : 'neutral',
                    size: "xxsmall"
                })
            })
        ]
    });
const $aa643ac6d9a3565e$var$ContentAction = ({ children: children, tooltipText: tooltipText, href: href })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'confluenceFooter',
            source: 'embeddedConfluenceViewPageScreen',
            eventType: 'ui'
        }).fire((0, $fnLem.ANALYTICS_CHANNEL));
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipText,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
            href: href,
            target: "_blank",
            onMouseEnter: ()=>{
                setIsHovered(true);
            },
            onMouseLeave: ()=>{
                setIsHovered(false);
            },
            onClick: handleClick,
            "data-testid": "link",
            className: (0, $hcewu.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1kw7 _16qsglyw _1q5t1r31 _nt751r31 _1dit1r31 _1ohyglyw _49pcglyw _ksodglyw _1r9x1o36 _1hvw1o36 _4hz81o36 _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7 _180dglyw _7ehiglyw _1dbzglyw"
            ]),
            children: children({
                isHovered: isHovered
            })
        })
    });
};

});

parcelRegister("73Fae", function(module, exports) {
$parcel$export(module.exports, "PageLoadValidation", () => $8aa4abb0dea40b7c$export$3b0759108d92fe77);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $drmS4 = parcelRequire("drmS4");

var $e5FZ0 = parcelRequire("e5FZ0");

var $bQ7Jf = parcelRequire("bQ7Jf");

var $ftN6c = parcelRequire("ftN6c");

var $bbc8b = parcelRequire("bbc8b");

var $d5di2 = parcelRequire("d5di2");

var $fnLem = parcelRequire("fnLem");
const $8aa4abb0dea40b7c$var$noop = ()=>{};
const $8aa4abb0dea40b7c$export$3b0759108d92fe77 = (props)=>{
    const { standaloneConfluenceUrl: standaloneConfluenceUrl, embeddedConfluenceUrl: embeddedConfluenceUrl } = (0, $bbc8b.useUrl)(props);
    const isEmbeddedUrlOnSameDomain = embeddedConfluenceUrl ? window.location.origin === new URL(embeddedConfluenceUrl).origin : false;
    const unusedIframeRef = (0, $eJOHy.useRef)(null);
    return isEmbeddedUrlOnSameDomain ? props.children({
        iframeRef: unusedIframeRef,
        handleIframeOnLoad: $8aa4abb0dea40b7c$var$noop,
        handleContentLoadStarted: $8aa4abb0dea40b7c$var$noop,
        handleIframeUnload: $8aa4abb0dea40b7c$var$noop,
        navigationPolicy: props.navigationPolicy
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($8aa4abb0dea40b7c$var$CrossDomainErrorValidation, {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl,
        allowedFeatures: props.allowedFeatures,
        ...props
    }, embeddedConfluenceUrl || props.contentId);
};
const $8aa4abb0dea40b7c$var$CrossDomainErrorValidation = ({ allowedFeatures: allowedFeatures, children: children, contentId: contentId, embeddedConfluenceUrl: embeddedConfluenceUrl, navigationPolicy: navigationPolicy, parentProduct: parentProduct, spaceKey: spaceKey, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const { state: state, dispatch: dispatch } = (0, $d5di2.useValidationState)();
    const { iframeLoaded: iframeLoaded, contentLoadStarted: contentLoadStarted, shouldAskStorageAccess: shouldAskStorageAccess, shouldAskToLogin: shouldAskToLogin, redirectedToLogin: redirectedToLogin, iframeUnloaded: iframeUnloaded } = state;
    const iframeRef = (0, $eJOHy.useRef)(null);
    /* This ref is specifically used for the purpose of recoding whether or not a delayed dispatch of the iframe occured.
		This recorded value is later used to fire analytics if contentLoadStarted arrives after the delayed dispatch, and reset
		once the event has fired or if the users needs to go through login flow.
	*/ const iframeLoadedWithDelayRef = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isLoginFlowDisabled = (0, $eJOHy.useMemo)(()=>allowedFeatures?.includes('disable-login-flow') ?? false, [
        allowedFeatures
    ]);
    const reloadEP = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $d5di2.Subjects).CONTENT_LOAD,
            status: (0, $d5di2.LoadingStatus).RELOAD_EP
        });
    }, [
        dispatch
    ]);
    const failToLoad = (0, $eJOHy.useMemo)(()=>iframeLoaded && !contentLoadStarted || /*
      If anonymous access is permitted globally but restricted on a content's parent space,
      the iframe will attempt a login redirect which we intercept.
      To avoid an error in the iframe, we need to wait for the iframe window to unload
      before unmouting the Iframe component.
    */ iframeUnloaded && redirectedToLogin, [
        contentLoadStarted,
        iframeLoaded,
        iframeUnloaded,
        redirectedToLogin
    ]);
    const pageNavigationPolicy = (0, $eJOHy.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                // modifiy the navigationPolicy to intercept login redirects
                // so that login can be handled outside of the iframe
                if (url.includes('/login?application=confluence')) {
                    dispatch({
                        subject: (0, $d5di2.Subjects).CONTENT_LOAD,
                        status: (0, $d5di2.LoadingStatus).REDIRECTED_TO_LOGIN
                    });
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        navigationPolicy,
        dispatch
    ]);
    const handleIframeOnLoad = (0, $eJOHy.useCallback)(()=>{
        const dispatchNow = ()=>{
            dispatch({
                subject: (0, $d5di2.Subjects).CONTENT_LOAD,
                status: (0, $d5di2.LoadingStatus).IFRAME_LOADED
            });
        };
        const totalNumberOfTries = 2;
        const iframeOfDispatch = iframeRef.current;
        const iframeSrcOfDispatch = iframeOfDispatch?.src;
        let tries = 0;
        const dispatchWithDelay = ()=>{
            /* We verify whether the iframeRef is current, as our intent is to invoke this only for the Iframe component created within the Content component (embedded-confluence-common/src/content/Content.tsx).
			It's important to note that the same Iframe component is also used by the StorageAccessPage component; however, we do not need to perform that check in this context.
			Additionally, the src of the iframe may change during transitions between view/edit modes or other redirects. Therefore, we must ensure that our invocation is limited to the current src of the iframe.
			*/ if (iframeRef.current !== iframeOfDispatch || iframeOfDispatch?.src !== iframeSrcOfDispatch) return;
            ++tries;
            if (contentLoadStarted || tries > totalNumberOfTries) {
                // If content load arrived after a timeout, failure to load was prevented by the delay
                if (contentLoadStarted && iframeLoadedWithDelayRef.current) {
                    createAnalyticsEvent({
                        action: 'delayedDispatch',
                        actionSubject: 'iframeOnLoad',
                        actionSubjectId: 'crossDomainErrorValidation',
                        source: 'pageLoadValidation',
                        eventType: 'track'
                    }).fire((0, $fnLem.ANALYTICS_CHANNEL));
                    //reset the ref for now. If the delayed dispatch is triggered again, the event will get fired too
                    iframeLoadedWithDelayRef.current = false;
                }
                dispatchNow();
            } else {
                /* This determines whether to fire a track analytics event
				to log instances where iframe load is delayed to wait for the confluence content to load.*/ if (!iframeLoadedWithDelayRef.current) iframeLoadedWithDelayRef.current = true;
                setTimeout(dispatchWithDelay, 1000);
            }
        };
        dispatchWithDelay();
    }, [
        contentLoadStarted,
        createAnalyticsEvent,
        dispatch
    ]);
    const handleContentLoadStarted = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $d5di2.Subjects).CONTENT_LOAD,
            status: (0, $d5di2.LoadingStatus).CONTENT_LOAD_STARTED
        });
    }, [
        dispatch
    ]);
    const handleIframeUnload = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $d5di2.Subjects).CONTENT_LOAD,
            status: (0, $d5di2.LoadingStatus).IFRAME_UNLOADED
        });
    }, [
        dispatch
    ]);
    if (!failToLoad) return children({
        iframeRef: iframeRef,
        handleIframeOnLoad: handleIframeOnLoad,
        handleContentLoadStarted: handleContentLoadStarted,
        handleIframeUnload: handleIframeUnload,
        navigationPolicy: pageNavigationPolicy,
        redirectedToLogin: redirectedToLogin
    });
    if (!isLoginFlowDisabled) {
        if (shouldAskStorageAccess) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQ7Jf.StorageAccessPage), {
            url: embeddedConfluenceUrl,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct
        });
        if (shouldAskToLogin) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5FZ0.LoginPage), {
            contentId: contentId,
            reloadEP: reloadEP,
            spaceKey: spaceKey,
            url: embeddedConfluenceUrl
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $drmS4.ErrorScreen), {
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
};

});
parcelRegister("drmS4", function(module, exports) {
$parcel$export(module.exports, "ErrorScreen", () => $2d64f4bf7c30dace$export$42f84e610f279c31);
/* ErrorScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $5bY40 = parcelRequire("5bY40");

var $806LH = parcelRequire("806LH");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lgMTT = parcelRequire("lgMTT");

var $9itkV = parcelRequire("9itkV");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $boRG7 = parcelRequire("boRG7");
var $40f0Z = parcelRequire("40f0Z");

var $j2zMY = parcelRequire("j2zMY");

var $lKjnT = parcelRequire("lKjnT");

var $ijVIe = parcelRequire("ijVIe");

var $4nJ3E = parcelRequire("4nJ3E");
const $2d64f4bf7c30dace$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';
const $2d64f4bf7c30dace$var$styles = {
    loginButtonWrapper: "_19pkxy5q _otyrpxbi",
    mainWrapper: "_1e0c1n7u _4cvr1h6o _6a6z1h6o _y3gn1h6o"
};
const $2d64f4bf7c30dace$export$42f84e610f279c31 = ({ standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    const experience = (0, $eJOHy.useContext)((0, $boRG7.ExperienceContext));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    (0, $eJOHy.useEffect)(()=>{
        experienceTracker.abort({
            name: experience,
            reason: (0, $j2zMY.ExperienceReasons).UNABLE_TO_DISPLAY_CONTENT
        });
    }, [
        experience,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "error-screen-container",
        className: (0, $hcewu.default)([
            $2d64f4bf7c30dace$var$styles.mainWrapper
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.250",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceLogo), {
                        size: "large",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lKjnT.LoginToConfluenceIcon), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        as: "h2",
                        size: "large",
                        children: formatMessage((0, $ijVIe.default).paragraphLogin)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $2d64f4bf7c30dace$var$styles.loginButtonWrapper,
                // data tag for JSM KB to target for excluding LinkButton from global styles
                // used instead of className as the className prop is not allowed
                // suggested by #help-design-system https://atlassian.slack.com/archives/CFJ9DU39U/p1746963980938489
                "data-embedded-confluence-no-global-styles-link-button": "true",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                    appearance: "primary",
                    "aria-label": formatMessage((0, $ijVIe.default).buttonLoginToConfluenceNewTab),
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($9itkV))),
                    href: standaloneConfluenceUrl ?? '',
                    target: "_blank",
                    children: formatMessage((0, $ijVIe.default).buttonLoginToConfluenceNewTab)
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "p",
                        children: formatMessage((0, $ijVIe.default).paragraphAlreadyLoggedIn)
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "p",
                        children: formatMessage((0, $ijVIe.default).paragraphStillHavingTrouble, {
                            link: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                                href: $2d64f4bf7c30dace$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
                                target: "_blank",
                                "aria-label": formatMessage((0, $ijVIe.default).linkAriaLabel),
                                children: formatMessage((0, $ijVIe.default).linkTroubleshootingText)
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("lKjnT", function(module, exports) {
$parcel$export(module.exports, "LoginToConfluenceIcon", () => $449669a96dd7ddb7$export$ae31f6824db63a1c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $449669a96dd7ddb7$export$ae31f6824db63a1c = ({ className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        width: "148",
        height: "160",
        viewBox: "0 0 148 160",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_499_12980)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "147.652",
                        height: "160",
                        transform: "translate(0.174194)",
                        fill: "var(--ds-icon-inverse, white)",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.3627 138.196C90.4862 138.281 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.931 92.713 137.99L93.1281 138.45C93.1796 138.504 93.1796 138.59 93.1281 138.642Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M132.434 20.5211L60.2655 23.3826V136.799L132.434 139.664V44.1953V20.5211Z",
                        fill: "url(#paint0_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M147.826 44.9982H121.774V46.1167H147.826V44.9982Z",
                            fill: "url(#paint1_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M147.826 47.9763H121.774V49.0948H147.826V47.9763Z",
                            fill: "url(#paint2_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M141.564 50.951H121.774V52.0696H141.564V50.951Z",
                            fill: "url(#paint3_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M82.238 0H56.186V1.11852H82.238V0Z",
                            fill: "url(#paint4_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M82.238 2.97815H56.186V4.09667H82.238V2.97815Z",
                            fill: "url(#paint5_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M75.9763 5.95288H56.186V7.0714H75.9763V5.95288Z",
                            fill: "url(#paint6_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M138.058 26.0039L65.889 22.6929V136.11L138.058 132.799V47.2249V26.0039Z",
                        fill: "url(#paint7_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M139.286 108.401L118.151 103.576C117.746 103.484 117.485 103.052 117.571 102.609L122.052 79.5694C122.138 79.1268 122.536 78.8455 122.94 78.9381L144.076 83.7622C144.481 83.8548 144.741 84.2871 144.656 84.7297L140.175 107.769C140.089 108.208 139.691 108.493 139.286 108.401Z",
                        fill: "url(#paint8_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M119.791 101.72L123.75 81.3536L142.436 85.6149L138.476 105.985L119.791 101.72Z",
                        fill: "var(--ds-icon-inverse, white)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M122.813 97.2153L128.169 93.4069L131.652 99.2328L122.813 97.2153Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M125.912 97.9221L132.866 92.978L137.389 100.54L125.912 97.9221Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #CCE0FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M130.421 88.2318C130.435 87.3034 129.754 86.5407 128.902 86.5283C128.049 86.5158 127.347 87.2583 127.333 88.1868C127.32 89.1152 128 89.8779 128.853 89.8903C129.705 89.9028 130.407 89.1603 130.421 88.2318Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M46.2531 49.0468L28.5798 55.9261C28.2401 56.0564 27.8421 55.8712 27.6878 55.5109L19.6248 36.6264C19.4704 36.2627 19.6179 35.8647 19.9576 35.7309L37.6309 28.8517C37.9706 28.7213 38.3686 28.9066 38.523 29.2668L46.586 48.1513C46.7404 48.515 46.5928 48.9164 46.2531 49.0468Z",
                        fill: "url(#paint9_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M28.8577 53.7782L21.728 37.0862L37.353 31.0029L44.4827 47.6984L28.8577 53.7782Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFFAE5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.4488 43.9346H31.2698V48.1136H35.4488V43.9346Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M34.8141 35.8716L33.4142 40.6099L38.7254 38.7983L34.8141 35.8716Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M29.6298 42.0365C30.4614 41.1853 30.4147 39.7911 29.5256 38.9225C28.6364 38.0538 27.2415 38.0397 26.4099 38.8909C25.5783 39.7421 25.625 41.1363 26.5141 42.005C27.4033 42.8736 28.7982 42.8878 29.6298 42.0365Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M124.872 12.64L49.6259 22.6929V136.11L124.872 146.163V39.1722V12.64Z",
                        fill: "url(#paint10_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M94.0374 10.6705L42.3109 22.6929V136.11L117.557 153.292V34.6295L94.0374 10.6705Z",
                        fill: "url(#paint11_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.1715 90.5898L79.1198 91.8823L109.851 93.1125L109.903 91.82L79.1715 90.5898Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.6972 89.3282L47.6455 90.6207L79.1207 91.8807L79.1725 90.5882L47.6972 89.3282Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.704 92.8613L47.6342 94.1528L109.838 97.5169L109.908 96.2253L47.704 92.8613Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M71.0629 97.9737L70.9751 99.2642L109.831 101.909L109.919 100.618L71.0629 97.9737Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.7211 96.3936L47.6332 97.6841L70.9859 99.2758L71.0739 97.9853L47.7211 96.3936Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.723 99.9274L47.6171 101.216L94.2916 105.052L94.3976 103.763L47.723 99.9274Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M42.3109 91.2761L60.2759 95.7056C61.4664 96.0006 62.7291 95.8257 63.7961 95.2184C64.8632 94.6111 66.1224 94.4395 67.3164 94.7312L67.7899 94.8478L67.8791 94.4807L69.7078 94.9302C69.9514 94.9919 70.1813 94.786 70.147 94.5356L70.0098 93.4754C69.9892 93.3279 69.8828 93.2078 69.7387 93.1735L68.2839 92.8166L68.3594 92.5147L67.7178 92.3569C66.6267 92.0892 65.6661 91.4442 65.0004 90.5384L64.9181 90.4286C64.2525 89.5228 63.2918 88.8812 62.2007 88.6102L45.2033 84.4209L42.9148 83.8547C42.9148 83.8547 42.9148 83.8547 42.9148 83.8582L42.3109 83.7106V91.2761Z",
                        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.5989 27.5788L47.6736 32.9175V28.5326L75.5989 22.7067V27.5788Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M84.4022 32.8103L47.093 38.827L47.2989 40.1039L84.6082 34.0873L84.4022 32.8103Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M84.4182 36.8671L47.1039 42.3507L47.292 43.6305L84.6063 38.1469L84.4182 36.8671Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.6704 42.0758L47.1106 45.8759L47.2812 47.1582L75.8411 43.3581L75.6704 42.0758Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 75.4418V84.1979L47.6702 83.9851V75.6614L60.7905 75.4418Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 66.6859V75.4419L47.6702 75.6615V67.3412L60.7905 66.6859Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 57.9298V66.6858L47.6702 67.3412V59.0209L60.7905 57.9298Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 49.1772V57.9298L47.6702 59.0209V50.7006L60.7905 49.1772Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.3519 47.4857V56.7221L60.7905 57.9298V49.1772L75.3519 47.4857Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.6115 45.5986V55.3737L75.3518 56.7221V47.4857L91.6115 45.5986Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.878 43.4748V53.8571L91.6116 55.3737V45.5986L109.878 43.4748Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 53.8571V84.9939L60.7905 84.1979V57.9298L109.879 53.8571Z",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 74.6116L91.6116 74.9204L75.3519 75.1948L60.7905 75.4419",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 64.2326L91.6116 65.1453L75.3519 65.9584L60.7905 66.6858",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.6116 84.6954V74.9203V65.1453V55.3737",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.3518 84.4312V75.1948V65.9584V56.722",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M94.0374 10.6705L101.28 46.024L117.557 34.6295L94.0374 10.6705Z",
                        fill: "url(#paint12_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M53.8528 13.7208L47.2858 15.1858C46.4829 15.3642 45.8345 16.3043 45.8345 17.2822V23.6262C45.8345 24.604 46.4864 25.2525 47.2858 25.0741L48.9087 24.7138L50.1267 26.5288C50.3429 26.8514 50.7958 26.7519 51.0119 26.3298L52.2299 23.9727L53.8528 23.6125C54.6557 23.434 55.3042 22.4939 55.3042 21.5161V15.1687C55.3042 14.1908 54.6557 13.5423 53.8528 13.7208Z",
                        fill: "url(#paint13_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M53.1976 13.8683L46.6305 15.3333C45.8277 15.5117 45.1792 16.4518 45.1792 17.4297V23.7737C45.1792 24.7516 45.8311 25.4 46.6305 25.2216L48.2534 24.8613L49.4714 26.6764C49.6876 26.9989 50.1405 26.8994 50.3566 26.4774L51.5747 24.1202L53.1976 23.76C54.0004 23.5816 54.6489 22.6415 54.6489 21.6636V15.3127C54.6523 14.3349 54.0004 13.6864 53.1976 13.8683Z",
                        fill: "url(#paint14_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M105.302 76.9652L98.5595 77.4181C97.7361 77.473 97.067 78.3102 97.067 79.2881V85.6321C97.067 86.6099 97.7361 87.3579 98.5595 87.303L100.224 87.1898L101.476 89.1901C101.699 89.5469 102.162 89.516 102.385 89.1283L103.637 86.9599L105.302 86.8467C106.125 86.7918 106.794 85.9546 106.794 84.9767V78.6327C106.794 77.6583 106.125 76.9103 105.302 76.9652Z",
                        fill: "url(#paint15_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M104.632 77.0099L97.8904 77.4628C97.067 77.5177 96.3979 78.3548 96.3979 79.3327V85.6767C96.3979 86.6545 97.067 87.4025 97.8904 87.3476L99.5545 87.2344L100.807 89.2347C101.03 89.5915 101.493 89.5606 101.716 89.1729L102.968 87.0045L104.632 86.8913C105.456 86.8364 106.125 85.9992 106.125 85.0214V78.6773C106.122 77.7029 105.456 76.955 104.632 77.0099Z",
                        fill: "url(#paint16_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M94.1334 142.388L113.55 146.139V119.318L94.1334 117.369V142.388Z",
                        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M48.1231 128.537L63.8029 131.564C64.1461 131.629 64.4617 131.368 64.4617 131.018V107.313C64.4617 107.028 64.2456 106.788 63.9608 106.76L48.2809 105.189C47.9549 105.155 47.6702 105.412 47.6702 105.741V127.992C47.6736 128.259 47.8623 128.486 48.1231 128.537ZM49.1078 106.942L63.0275 108.339V123.501V129.728L58.1314 128.784L49.5641 127.131L49.1078 127.041V106.942Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M66.4312 132.071L84.7392 135.605C85.0823 135.67 85.398 135.41 85.398 135.06V109.413C85.398 109.128 85.1818 108.888 84.8971 108.86L66.589 107.025C66.2631 106.99 65.9783 107.248 65.9783 107.577V131.526C65.9817 131.793 66.1704 132.02 66.4312 132.071ZM67.4159 118.766V108.781L83.9638 110.442V121.332V133.773L69.2103 130.925L67.4159 130.579V118.766Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
                        fill: "url(#paint17_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
                        fill: "url(#paint18_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.5641 127.131L58.1314 128.784L49.5641 127.131Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M59.6514 127.141L54.92 121.349L49.5641 127.131L58.1314 128.784L59.6514 127.141Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2103 130.922L67.4159 130.575L69.2103 130.922Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L67.7453 118.409L67.4159 118.766V130.575L69.2103 130.922L73.8628 125.902Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M58.1315 128.784L63.0276 129.728L58.1315 128.784Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M58.1315 128.784L63.0276 129.728V123.501L59.6514 127.141L58.1315 128.784Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2103 130.922L83.9638 133.77L69.2103 130.922Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L69.2103 130.922L83.9638 133.77V121.325L81.219 117.966L73.8628 125.902Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M87.3125 129.824C87.4464 129.8 87.9404 129.694 88.1429 129.292C88.2389 129.1 88.2355 128.908 88.2286 128.644C88.2218 128.301 88.1497 128.023 88.0914 127.837L88.8565 127.343C88.9148 127.306 88.9492 127.234 88.9354 127.165C88.9114 127.059 88.8016 127.007 88.7056 127.045L87.8855 127.398C87.8238 127.426 87.7723 127.474 87.7449 127.535L87.3812 128.301L86.8837 129.398L87.3125 129.824Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M88.5614 127.402L88.9937 127.244C89.0726 127.213 89.1653 127.247 89.2099 127.319C89.2613 127.402 89.2373 127.508 89.1584 127.559L88.2492 128.187L88.0262 128.863L87.7277 128.438L87.9781 127.755L88.5614 127.402Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.45 127.704C89.4843 127.786 89.45 127.879 89.3711 127.92C89.1549 128.002 88.9354 128.084 88.7192 128.167C88.4859 128.383 88.2526 128.599 88.0193 128.815L87.834 128.52L88.5305 127.827L89.2407 127.604C89.3265 127.58 89.4191 127.621 89.45 127.704Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.3333 128.359C89.3368 128.424 89.2887 128.479 89.2235 128.489L88.6505 128.561C88.4962 128.654 88.3418 128.75 88.1874 128.846C88.1462 128.76 88.105 128.675 88.0638 128.589C88.2628 128.462 88.4653 128.338 88.6643 128.211L89.2167 128.239C89.2784 128.239 89.3299 128.294 89.3333 128.359Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.4398 136.71C79.7779 136.213 81.2052 135.739 82.7183 135.31C83.2536 135.159 83.7785 135.019 84.3001 134.888C84.5848 134.247 84.825 133.728 84.9863 133.379C85.4597 132.363 85.7171 131.872 86.3106 130.63C86.568 130.088 86.7738 129.649 86.9042 129.368C87.1581 129.491 87.412 129.615 87.6659 129.738C87.4841 130.96 87.1238 132.486 86.393 134.126C86.0602 134.878 85.6965 135.544 85.3397 136.123C84.8524 136.47 83.3634 137.509 81.9772 138.031C81.7233 138.127 81.3322 138.257 80.8278 138.288C80.399 138.316 79.8568 138.347 79.3422 138.031C78.6079 137.578 78.4604 136.83 78.4398 136.71Z",
                        fill: "url(#paint19_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.0009 111.708L86.5851 136.686C86.5062 137.132 86.7979 137.561 87.2439 137.647L107.563 141.637C108.019 141.726 108.461 141.424 108.54 140.965L113.296 114.069C113.382 113.592 113.042 113.146 112.558 113.098L91.9033 111.025C91.471 110.981 91.0764 111.279 91.0009 111.708ZM107.298 139.867L106.598 139.729L88.1188 136.099L89.4501 128.565L92.2498 112.727L111.748 114.683L107.298 139.867Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
                        fill: "url(#paint20_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M106.598 139.729L88.1222 136.103L106.598 139.729Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2413 134.36L89.4534 128.568L88.1222 136.103L106.598 139.729L99.4584 128.805L93.2413 134.36Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "url(#paint21_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "url(#paint22_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M28.1132 148.904C43.5435 148.904 56.0522 147.858 56.0522 146.567C56.0522 145.277 43.5435 144.231 28.1132 144.231C12.6829 144.231 0.174194 145.277 0.174194 146.567C0.174194 147.858 12.6829 148.904 28.1132 148.904Z",
                        fill: "url(#paint23_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M43.3951 146.149C43.1481 146.149 42.9147 145.998 42.8221 145.754L29.6435 111.015C29.5234 110.699 29.6812 110.346 30.0003 110.226C30.3159 110.106 30.6693 110.264 30.7894 110.579L43.9681 145.319C44.0882 145.634 43.9303 145.988 43.6112 146.108C43.5426 146.135 43.4671 146.149 43.3951 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.8514 146.149C54.6044 146.149 54.371 145.998 54.2784 145.754L41.0998 111.015C40.9797 110.699 41.1375 110.346 41.4566 110.226C41.7722 110.106 42.1256 110.264 42.2457 110.579L55.4244 145.319C55.5445 145.634 55.3866 145.988 55.0675 146.108C54.9989 146.135 54.9234 146.149 54.8514 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M43.3642 115.866H31.908C31.5717 115.866 31.2972 115.592 31.2972 115.256C31.2972 114.92 31.5717 114.645 31.908 114.645H43.3642C43.7005 114.645 43.975 114.92 43.975 115.256C43.975 115.592 43.7005 115.866 43.3642 115.866Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M45.265 120.879H33.8087C33.4725 120.879 33.198 120.605 33.198 120.269C33.198 119.932 33.4725 119.658 33.8087 119.658H45.265C45.6012 119.658 45.8757 119.932 45.8757 120.269C45.8757 120.605 45.6047 120.879 45.265 120.879Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.1659 125.892H35.7096C35.3734 125.892 35.0989 125.618 35.0989 125.281C35.0989 124.945 35.3734 124.671 35.7096 124.671H47.1659C47.5021 124.671 47.7766 124.945 47.7766 125.281C47.7766 125.618 47.5055 125.892 47.1659 125.892Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.07 130.905H37.6138C37.2775 130.905 37.0031 130.63 37.0031 130.294C37.0031 129.958 37.2775 129.683 37.6138 129.683H49.07C49.4063 129.683 49.6808 129.958 49.6808 130.294C49.6808 130.63 49.4063 130.905 49.07 130.905Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M50.9709 135.918H39.5147C39.1784 135.918 38.9039 135.643 38.9039 135.307C38.9039 134.971 39.1784 134.696 39.5147 134.696H50.9709C51.3072 134.696 51.5816 134.971 51.5816 135.307C51.5816 135.643 51.3072 135.918 50.9709 135.918Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M52.8717 140.927H41.4154C41.0792 140.927 40.8047 140.652 40.8047 140.316C40.8047 139.98 41.0792 139.705 41.4154 139.705H52.8717C53.2079 139.705 53.4824 139.98 53.4824 140.316C53.4824 140.652 53.2114 140.927 52.8717 140.927Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M24.5484 146.149C24.4763 146.149 24.4043 146.135 24.3322 146.108C24.0166 145.988 23.8587 145.634 23.9754 145.319L37.154 110.579C37.2741 110.264 37.6275 110.106 37.9432 110.226C38.2588 110.346 38.4167 110.699 38.3 111.015L25.1214 145.754C25.0253 145.998 24.7954 146.149 24.5484 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M13.0921 146.149C13.02 146.149 12.948 146.135 12.8759 146.108C12.5603 145.988 12.4024 145.634 12.5191 145.319L25.6978 110.579C25.8178 110.264 26.1712 110.106 26.4869 110.226C26.8026 110.346 26.9604 110.699 26.8437 111.015L13.6616 145.754C13.569 145.998 13.3391 146.149 13.0921 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M42.6025 111.283H25.5536C24.8091 111.283 24.2052 110.679 24.2052 109.934C24.2052 109.19 24.8091 108.586 25.5536 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M42.6025 111.283H39.2915C38.547 111.283 37.9431 110.679 37.9431 109.934C37.9431 109.19 38.547 108.586 39.2915 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.0355 115.866H24.5792C24.243 115.866 23.9685 115.592 23.9685 115.256C23.9685 114.92 24.243 114.645 24.5792 114.645H36.0355C36.3717 114.645 36.6462 114.92 36.6462 115.256C36.6462 115.592 36.3717 115.866 36.0355 115.866Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M34.1347 120.879H22.6785C22.3422 120.879 22.0677 120.605 22.0677 120.269C22.0677 119.932 22.3422 119.658 22.6785 119.658H34.1347C34.471 119.658 34.7455 119.932 34.7455 120.269C34.7455 120.605 34.471 120.879 34.1347 120.879Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M32.2339 125.892H20.7742C20.4379 125.892 20.1635 125.618 20.1635 125.281C20.1635 124.945 20.4379 124.671 20.7742 124.671H32.2304C32.5667 124.671 32.8412 124.945 32.8412 125.281C32.8412 125.618 32.5701 125.892 32.2339 125.892Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M30.3297 130.905H18.8734C18.5372 130.905 18.2627 130.63 18.2627 130.294C18.2627 129.958 18.5372 129.683 18.8734 129.683H30.3297C30.6659 129.683 30.9404 129.958 30.9404 130.294C30.9404 130.63 30.6694 130.905 30.3297 130.905Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M28.4288 135.918H16.9725C16.6363 135.918 16.3618 135.643 16.3618 135.307C16.3618 134.971 16.6363 134.696 16.9725 134.696H28.4288C28.765 134.696 29.0395 134.971 29.0395 135.307C29.0395 135.643 28.7685 135.918 28.4288 135.918Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M26.528 140.927H15.0718C14.7355 140.927 14.4611 140.652 14.4611 140.316C14.4611 139.98 14.7355 139.705 15.0718 139.705H26.528C26.8643 139.705 27.1388 139.98 27.1388 140.316C27.1388 140.652 26.8643 140.927 26.528 140.927Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M40.2832 79.2538C42.033 79.6003 43.7829 79.9503 45.5327 80.2968C47.5605 80.4787 49.5882 80.6571 51.616 80.8389C51.6125 81.1443 51.6057 81.4497 51.6022 81.755C49.8558 81.906 47.8967 81.9815 45.7626 81.9197C43.4158 81.8511 41.2851 81.6246 39.4152 81.3296C39.7034 80.6365 39.9916 79.9434 40.2832 79.2538Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M67.5497 93.7637L67.9408 94.0553L69.3784 92.1339L68.8501 91.7394C67.9511 91.0669 67.3164 90.0993 67.0556 89.0048L67.0247 88.871C66.764 87.7765 66.1292 86.8124 65.2303 86.1365L30.6248 60.2492C29.0019 59.0346 26.6996 59.3674 25.4851 60.9903C24.2705 62.6132 24.6033 64.9154 26.2262 66.13L60.6876 91.9143C61.6723 92.6486 62.8972 92.9814 64.1186 92.8407C65.3401 92.6966 66.5684 93.0294 67.5497 93.7637Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.7216 82.2113C47.104 80.3311 46.4281 77.775 45.9066 75.8158C45.3679 73.7778 44.8979 72.052 44.4724 70.611L41.7825 68.5969C42.5579 70.7585 43.4294 74.0386 44.0298 76.3133C44.4278 77.8127 44.7778 79.1199 45.0969 80.2488L47.7216 82.2113Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M31.8119 61.1344C34.9513 71.3349 36.6531 73.3455 38.3 73.1053C39.7754 72.8892 40.1631 70.9129 40.5748 68.8234C40.6297 68.5386 40.6983 68.1886 40.7772 67.8421L39.0857 66.576C38.9279 67.1387 38.8009 67.7769 38.6671 68.446C38.5196 69.2008 38.2588 70.5217 37.9878 71.057C37.552 70.6418 36.461 69.0636 34.495 63.1416L31.8119 61.1344Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.324 74.2376C49.1525 78.8249 48.8849 81.4257 48.6378 82.8941L50.3533 84.1774C50.7239 82.6094 51.019 79.9949 51.2145 75.6512L49.324 74.2376Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M70.2362 94.6901L70.5209 93.6608C70.5621 93.5201 70.5072 93.3657 70.3905 93.2765L69.1931 92.381L68.1672 93.75L69.6769 94.8788C69.8793 95.0332 70.1675 94.9337 70.2362 94.6901Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M29.1598 105.645C28.9573 105.711 28.6828 105.824 28.3946 106.023C28.103 106.218 27.8971 106.431 27.7599 106.596C27.8045 106.719 27.856 106.846 27.9143 106.973C28.2368 107.673 28.676 108.198 29.0774 108.572C29.5852 108.575 30.093 108.579 30.6008 108.582C30.6077 108.538 30.6077 108.493 30.6008 108.459C30.5356 108.068 29.846 107.92 29.8048 107.913C29.7327 107.759 29.6195 107.467 29.6229 107.083C29.6229 106.706 29.7362 106.417 29.8082 106.266C29.5921 106.061 29.3759 105.851 29.1598 105.645Z",
                        fill: "var(--ds-icon, #344563)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.1091 84.3146C36.7729 84.3146 38.1216 82.9659 38.1216 81.3021C38.1216 79.6384 36.7729 78.2897 35.1091 78.2897C33.4454 78.2897 32.0967 79.6384 32.0967 81.3021C32.0967 82.9659 33.4454 84.3146 35.1091 84.3146Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.0046 85.6938C37.0202 84.8429 39.3739 85.2409 40.0842 86.4521C40.8253 87.7147 39.7548 89.8145 38.4784 92.2814C38.125 92.9608 37.5863 93.9558 35.1572 97.8329C33.8088 99.9841 33.5309 100.382 32.68 101.768C31.4585 103.755 30.515 105.391 29.918 106.448C29.4822 106.242 29.0465 106.04 28.6073 105.834C29.242 104.348 29.7087 103.124 30.014 102.29C30.6591 100.526 30.9233 99.5758 31.6163 98.0696C32.0727 97.078 32.505 96.2992 32.7897 95.8085C33.0608 95.0057 33.3319 94.1891 33.596 93.3622C34.1107 91.753 34.591 90.1679 35.0337 88.6171C35.0028 88.2705 34.9993 87.6907 35.2224 87.0319C35.3047 86.778 35.538 86.0815 36.0046 85.6938Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00B8D9)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.523 106.716C38.4646 106.929 38.4098 107.155 38.3617 107.399C38.3 107.725 38.2588 108.033 38.2382 108.315C38.2279 108.459 38.3411 108.582 38.4852 108.582C39.5351 108.579 40.585 108.572 41.6349 108.569C41.6452 108.442 41.6349 108.274 41.532 108.15C41.4051 108.003 41.2163 108.013 40.9933 107.975C40.9933 107.975 40.3414 107.869 39.8233 107.361C39.6964 107.237 39.518 107.025 39.3842 106.685C39.096 106.695 38.8078 106.706 38.523 106.716Z",
                        fill: "var(--ds-icon, #344563)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M37.902 84.4107C38.0015 84.3832 39.0857 84.1156 39.9538 84.7126C40.7258 85.241 41.086 86.2771 41.0345 90.1577C41.0071 92.0893 40.887 94.1823 40.5508 97.3217C40.2969 99.6822 40.1768 100.235 39.9881 102.334C39.8131 104.283 39.7273 105.882 39.6827 106.942C39.1612 106.973 38.6362 107.004 38.1147 107.032C37.7716 105.083 37.5452 103.436 37.3976 102.17C37.2432 100.869 37.1815 100.08 37.2913 99.1093C37.4217 97.9667 37.7682 96.8105 37.8025 96.6972C37.878 96.4502 37.9535 96.2203 38.0255 96.0145C37.9294 95.4895 37.7716 94.6729 37.5452 93.6779C37.2673 92.4393 37.0202 91.3482 36.6222 89.9792C35.9532 87.677 35.6787 87.4368 35.8434 86.682C36.0458 85.7659 36.7663 84.7092 37.902 84.4107Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M41.2335 76.1109C41.3399 76.4231 41.5595 77.0613 41.2918 77.8161C41.2164 78.0289 40.9659 78.6396 40.3963 78.9518C40.3071 78.9999 40.1081 79.1096 39.8199 79.144C39.7273 79.1543 39.4253 79.192 39.2641 79.1028C38.6431 78.7665 39.3464 76.1212 40.2419 75.459C40.4684 75.2943 40.6228 75.3115 40.6605 75.3183C40.9796 75.3767 41.1374 75.8399 41.2335 76.1109Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.1091 87.2653C35.4419 87.5226 36.7663 88.497 38.6706 88.3838C40.2866 88.2877 41.3674 87.4677 41.7276 87.1692C41.5904 86.9565 41.3948 86.6202 41.2404 86.1776C41.134 85.8654 40.7463 84.6302 41.1787 83.275C41.3845 82.6265 41.5869 82.5544 41.5972 82.0535C41.6007 81.827 41.5595 81.7241 41.261 80.6365C41.0414 79.8405 41.0345 79.789 40.9591 79.6861C40.887 79.5866 40.5439 79.1646 39.271 79.1028C37.854 79.0307 36.6325 79.5077 35.8468 79.9194C35.936 80.8801 36.0733 81.6521 36.183 82.1942C36.4267 83.3985 36.6428 83.9097 36.4061 84.6233C36.2928 84.963 36.1968 84.9905 35.8159 85.711C35.4728 86.356 35.2464 86.9016 35.1091 87.2653Z",
                        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M41.1684 77.106C41.1547 77.13 41.117 77.1574 41.0449 77.2158C40.9831 77.2638 40.9282 77.2981 40.8871 77.3221C40.8871 77.4285 40.8836 77.5417 40.8768 77.6584C40.8631 77.8848 40.8356 78.0907 40.8013 78.2794C40.6435 78.3206 40.4239 78.3686 40.1563 78.396C39.8818 78.4235 39.4666 78.4647 38.9794 78.348C38.7804 78.3 38.4888 78.2313 38.228 78.0495C37.6996 77.679 37.2364 76.7869 37.5864 75.9394C37.9501 75.0611 39.1167 74.6836 39.8372 74.9993C39.9298 75.0405 40.3999 75.2463 40.5954 75.6992C40.6812 75.8948 40.6366 75.9188 40.7739 76.2516C40.8082 76.3306 40.8493 76.4335 40.918 76.5639C41.0861 76.8727 41.2199 76.9996 41.1684 77.106Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.1216 77.4971C38.2074 77.6412 38.3515 77.9362 38.372 78.3377C38.3961 78.77 38.2657 79.0959 38.1936 79.2503C38.4853 79.4425 38.7838 79.6483 39.0857 79.8576C39.518 80.163 39.9297 80.4649 40.3243 80.7669C40.1493 80.3208 39.9778 79.8782 39.8028 79.4322C39.7994 79.2881 39.8062 79.1303 39.8199 78.9621C39.8405 78.7494 39.8714 78.5573 39.9092 78.3891C39.3122 78.0906 38.7186 77.7921 38.1216 77.4971Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.8777 69.9248C35.9772 69.8424 36.3409 69.5165 36.3238 69.0807C36.3135 68.8714 36.2174 68.7136 36.087 68.494C35.9155 68.2092 35.7233 68.0068 35.5861 67.8799L35.9944 67.101C36.0253 67.0393 36.0218 66.9638 35.9738 66.9157C35.9052 66.8368 35.7851 66.8471 35.7233 66.926L35.2018 67.6122C35.1606 67.6637 35.1435 67.7289 35.1469 67.7941L35.315 69.7738L35.8777 69.9248Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.7714 67.2897L36.0596 66.9501C36.1145 66.8883 36.2037 66.8711 36.2758 66.9089C36.3581 66.9535 36.389 67.053 36.3478 67.1353L35.8812 68.096L36.015 68.7719L35.5587 68.5592L35.442 67.8627L35.7714 67.2897Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.6669 67.1182C36.7321 67.1697 36.7492 67.2657 36.7012 67.3378C36.5571 67.5128 36.4164 67.6843 36.2723 67.8593C36.1797 68.1509 36.087 68.446 35.9944 68.7377L35.6993 68.5764L35.9532 67.6603L36.4473 67.1354C36.5022 67.0702 36.5983 67.0633 36.6669 67.1182Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.8762 67.7254C36.9105 67.7803 36.8968 67.849 36.8453 67.8867L36.3993 68.2229C36.3135 68.3773 36.2277 68.5283 36.1454 68.6827C36.0699 68.6312 35.9944 68.5763 35.9189 68.5249C36.0287 68.3224 36.1351 68.12 36.2449 67.921L36.7218 67.6808C36.7733 67.65 36.8453 67.6705 36.8762 67.7254Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.5587 68.9949C35.5072 68.9949 35.3116 69.3346 35.2773 69.29L34.7421 68.0651C34.6837 67.9896 34.6975 67.8833 34.7695 67.825C34.845 67.7666 34.9514 67.7804 35.0097 67.8524L35.6925 68.717C35.7508 68.7925 35.7371 68.8989 35.665 68.9572C35.6341 68.9847 35.5964 68.9949 35.5587 68.9949Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M40.0224 76.5982C39.8474 76.8143 39.7548 76.7079 39.5867 76.9001C39.2298 77.3015 39.5901 77.8162 39.2573 78.1867C39.0995 78.3651 38.9416 78.2416 38.8113 78.4132C38.6225 78.6671 38.9245 78.9518 38.8113 79.391C38.7255 79.7204 38.4407 80.0223 38.125 80.1081C37.7442 80.2145 37.5726 79.94 37.2879 80.0464C36.8796 80.2008 37.0546 80.8664 36.6531 81.2644C36.1247 81.7893 34.8964 81.8339 34.0936 81.182C33.2907 80.5301 33.2495 79.4596 33.4245 78.8009C33.5961 78.1456 34.0661 77.5794 34.5945 77.2706C35.14 76.9516 35.4694 77.0716 35.9944 76.6359C36.2311 76.4403 36.2551 76.4403 36.6806 75.785C36.8761 75.4796 37.2295 74.9375 37.7854 74.6287C38.4235 74.2753 39.0754 74.3645 39.3499 74.3989C39.693 74.4469 40.3484 74.5327 40.5714 74.9821C40.592 75.0233 40.7395 75.339 40.6091 75.5929C40.5679 75.6752 40.5268 75.6855 40.4479 75.7713C40.1631 76.0663 40.2489 76.3202 40.0224 76.5982Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.1216 80.7943C37.7236 79.0548 37.3256 77.3152 36.9276 75.5757C36.6909 73.5548 36.4507 71.5339 36.2139 69.5096C35.9086 69.5233 35.6032 69.537 35.3013 69.5508C35.2018 71.3006 35.1812 73.2597 35.3047 75.3904C35.442 77.7338 35.7267 79.8576 36.0767 81.7207C36.756 81.4119 37.4388 81.1031 38.1216 80.7943Z",
                        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M72.9364 160C81.113 160 87.7414 159.161 87.7414 158.127C87.7414 157.092 81.113 156.253 72.9364 156.253C64.7599 156.253 58.1315 157.092 58.1315 158.127C58.1315 159.161 64.7599 160 72.9364 160Z",
                        fill: "url(#paint24_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M77.5306 136.604C78.5198 136.604 79.3216 135.802 79.3216 134.813C79.3216 133.824 78.5198 133.022 77.5306 133.022C76.5415 133.022 75.7396 133.824 75.7396 134.813C75.7396 135.802 76.5415 136.604 77.5306 136.604Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2892 157.228C71.5571 157.444 74.9333 157.66 77.2012 157.876C77.3865 157.866 78.2271 157.794 78.7417 157.125C79.0848 156.682 79.1191 156.192 79.1397 155.872C79.1877 155.176 78.9613 154.534 78.8412 154.202C78.8103 154.112 78.7829 154.04 78.7623 153.992C77.9217 151.889 77.5237 151.144 77.0948 150.026C76.4086 148.235 76.6659 148.307 76.2096 147.384C75.7258 146.406 74.8509 145.229 73.1491 144.159C72.933 144.461 72.655 144.907 72.4011 145.483C72.209 145.919 71.9757 146.451 71.9105 147.137C71.8762 147.497 71.8796 147.981 72.1061 148.842C72.2193 149.275 72.583 150.537 73.6981 152.284C74.0858 152.891 74.645 153.68 75.4136 154.538C74.5524 154.332 73.6432 154.14 72.6859 153.972C71.9585 153.841 70.1401 153.735 69.4607 153.649C69.4024 154.84 69.3441 156.034 69.2892 157.228Z",
                        fill: "url(#paint25_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.3208 143.932C73.0634 144.245 72.7272 144.715 72.4356 145.336C72.0582 146.145 71.5847 147.164 71.8969 148.348C71.9484 148.547 72.1679 149.71 73.2419 150.252C73.5644 150.414 73.8526 150.554 74.1957 150.681C74.1957 150.681 74.8716 150.928 75.6642 151.059C77.3179 151.333 79.7883 151.021 79.9496 151C79.4315 151.446 78.8894 151.951 78.3404 152.524C77.6062 153.285 76.9851 154.03 76.4636 154.723C77.5684 155.402 78.6732 156.082 79.778 156.765C80.5534 155.941 81.3597 155.015 82.1729 153.982C83.1164 152.781 83.9261 151.618 84.6158 150.527C84.6741 150.328 84.7908 149.844 84.6055 149.299C84.2727 148.324 83.2811 148.015 83.1747 147.984C81.9567 147.659 80.7387 147.333 79.5207 147.01C78.6183 146.773 77.7125 146.537 76.8101 146.3C76.1617 145.936 75.472 145.511 74.7618 145.017C74.2403 144.656 73.76 144.289 73.3208 143.932Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.2805 143.325C78.8585 143.747 78.4433 144.166 78.0796 144.619C77.7434 145.041 77.3591 145.61 77.0263 146.358C76.3881 146.169 75.623 145.885 74.7995 145.449C74.0962 145.078 73.5129 144.68 73.0428 144.317C73.4752 143.562 73.7908 142.917 74.0035 142.443C74.4358 141.486 74.5422 141.061 74.9368 140.296C75.3211 139.544 75.7225 138.964 76.021 138.577C76.021 138.577 76.8513 137.345 77.4483 136.885C77.4689 136.868 77.86 136.569 77.86 136.569L79.6888 138.264C79.8535 138.415 79.9701 138.607 80.0319 138.824C80.0593 139.218 80.1245 139.829 80.3167 140.556C80.5019 141.27 80.6323 141.431 80.574 141.785C80.4951 142.234 80.2172 142.388 79.2805 143.325Z",
                        fill: "url(#paint26_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.6201 138.748C79.6201 138.669 79.6098 138.57 79.5824 138.456C79.5481 138.319 79.5 138.209 79.4554 138.131C79.4486 137.829 79.4863 137.352 79.7299 136.851C79.8123 136.686 79.9015 136.545 79.9907 136.425L78.7315 135.626L77.86 136.569L78.2992 137.091C78.5805 137.427 78.8104 137.805 79.0231 138.185C79.0609 138.254 79.1089 138.323 79.1672 138.395C79.3285 138.59 79.5103 138.693 79.6201 138.748Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M82.8796 158.734C82.8796 158.734 82.6257 158.226 81.9258 157.962C81.2705 157.715 80.9033 158.013 80.0867 157.705C79.8603 157.619 79.3182 157.413 79.2873 157.053C79.2702 156.864 79.404 156.696 79.5069 156.596C78.9682 156.264 78.4295 155.931 77.8909 155.598C77.8909 155.598 77.4723 156.089 77.2458 157.077C77.016 158.065 77.1052 159.033 77.1052 159.033L82.8796 158.734Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.4128 154.562C69.2 154.486 68.9015 154.407 68.5378 154.387C68.109 154.363 67.7556 154.428 67.5154 154.493C67.6286 155.643 67.7418 156.792 67.8585 157.941C67.8585 157.979 67.8516 158.24 68.0575 158.429C68.2153 158.573 68.3972 158.586 68.4486 158.59C68.9804 158.542 69.5123 158.49 70.0406 158.442C70.0029 158.37 69.9343 158.257 69.821 158.147C69.4574 157.794 69.0696 157.886 68.8981 157.574C68.8055 157.406 68.826 157.217 68.8363 157.152C68.8569 156.967 68.9393 156.84 69.0045 156.737C69.0628 156.648 69.1623 156.511 69.327 156.384C69.3579 155.776 69.3853 155.169 69.4128 154.562Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.7624 135.694L80.2823 136.655C80.4916 136.786 80.7421 136.834 80.9857 136.782C81.195 136.738 81.3837 136.621 81.5209 136.456L82.0905 135.76L82.3066 135.918C82.389 135.979 82.5056 135.918 82.5022 135.815L82.4782 135.125L82.6017 134.758C82.7595 134.288 82.8144 133.787 82.7664 133.293C82.7012 132.641 82.3512 132.047 81.8126 131.673C81.2224 131.265 80.4745 131.162 79.7951 131.395L79.6613 131.443C79.5138 131.495 79.3765 131.577 79.2564 131.68C78.6148 132.253 78.3609 133.142 78.5977 133.969L78.7383 134.452L78.7624 135.694Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.3627 138.196C90.4862 138.282 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.932 92.713 137.99L93.1281 138.45C93.1796 138.505 93.1796 138.59 93.1281 138.642Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M77.8566 136.58C79.3114 137.249 80.8176 138.01 82.3616 138.879C82.9071 139.184 83.4355 139.493 83.9502 139.801C84.6844 139.52 85.2883 139.301 85.6966 139.153C86.8803 138.728 87.4738 138.546 88.9355 138.031C89.5702 137.808 90.0849 137.623 90.4108 137.506C90.5137 137.805 90.6167 138.107 90.7196 138.405C89.6011 139.228 88.1017 140.148 86.2181 140.869C85.3569 141.198 84.5403 141.435 83.7923 141.61C83.4629 141.555 82.7939 141.435 82.0219 141.243C81.4283 141.095 80.5809 140.872 79.6133 140.443C78.9168 140.134 77.9527 139.623 76.9165 138.782C77.2253 138.048 77.541 137.314 77.8566 136.58Z",
                        fill: "url(#paint27_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.2649 132.733C78.1757 133.317 78.4845 133.619 78.5908 134.799C78.6286 135.2 78.6251 135.533 78.6183 135.749C79.0677 135.458 79.3525 135.135 79.5138 134.919C79.6819 134.693 79.7986 134.538 79.8878 134.288C80.073 133.766 79.9427 133.368 80.2 133.217C80.224 133.204 80.3269 133.142 80.4196 133.18C80.6735 133.282 80.4127 133.948 80.7078 134.226C80.9994 134.5 81.6547 134.233 81.9944 134.096C82.3856 133.938 82.7767 133.78 82.9071 133.413C83.0512 133.011 82.7973 132.596 82.6841 132.408C82.1694 131.56 80.8141 130.665 79.5618 131.2C78.9579 131.454 78.3712 132.044 78.2649 132.733Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.4519 33.2228L117.557 34.6295L94.0374 10.6705L90.4519 33.2228Z",
                        fill: "url(#paint28_linear_499_12980)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_499_12980",
                        x1: "50.6701",
                        y1: "127.204",
                        x2: "144.895",
                        y2: "32.9795",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2415",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFF)",
                                stopOpacity: "0.7585"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4317",
                                stopColor: "var(--ds-background-accent-blue-bolder, #59A1FF)",
                                stopOpacity: "0.5683"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6043",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AABFF)",
                                stopOpacity: "0.3957"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7666",
                                stopColor: "var(--ds-background-accent-blue-subtle, #81B8FF)",
                                stopOpacity: "0.2334"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9202",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #9FC9FF)",
                                stopOpacity: "0.0798"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_499_12980",
                        x1: "121.776",
                        y1: "45.5575",
                        x2: "147.826",
                        y2: "45.5575",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_499_12980",
                        x1: "121.776",
                        y1: "48.5346",
                        x2: "147.826",
                        y2: "48.5346",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_499_12980",
                        x1: "121.776",
                        y1: "51.5113",
                        x2: "141.565",
                        y2: "51.5113",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint4_linear_499_12980",
                        x1: "56.1854",
                        y1: "0.55854",
                        x2: "82.2361",
                        y2: "0.55854",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_499_12980",
                        x1: "56.1854",
                        y1: "3.53525",
                        x2: "82.2361",
                        y2: "3.53525",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_499_12980",
                        x1: "56.1854",
                        y1: "6.51231",
                        x2: "75.9746",
                        y2: "6.51231",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_499_12980",
                        x1: "54.7482",
                        y1: "124.969",
                        x2: "145.885",
                        y2: "33.833",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #2684FF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3613",
                                stopColor: "var(--ds-background-accent-blue-subtle, #2986FF)",
                                stopOpacity: "0.6387"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6457",
                                stopColor: "var(--ds-background-accent-blue-subtle, #338CFF)",
                                stopOpacity: "0.3543"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9031",
                                stopColor: "var(--ds-background-accent-blue-subtle, #4495FF)",
                                stopOpacity: "0.0969"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_499_12980",
                        x1: "132.434",
                        y1: "109.023",
                        x2: "129.764",
                        y2: "78.307",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7911",
                                stopColor: "var(--ds-background-accent-blue-subtle, #66A3FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_499_12980",
                        x1: "23.785",
                        y1: "51.7314",
                        x2: "42.402",
                        y2: "33.1132",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2089",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_499_12980",
                        x1: "42.596",
                        y1: "129.08",
                        x2: "141.953",
                        y2: "29.7225",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_499_12980",
                        x1: "37.0626",
                        y1: "130.862",
                        x2: "125.647",
                        y2: "42.2776",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DEEBFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6383",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #EBF1FA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_499_12980",
                        x1: "94.0388",
                        y1: "28.347",
                        x2: "117.556",
                        y2: "28.347",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-gray-subtle, #6E7C93)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtle, #6C798F)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_499_12980",
                        x1: "50.5705",
                        y1: "26.7136",
                        x2: "49.861",
                        y2: "13.9285",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2629",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6568",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7051",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7745",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8568",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9483",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_499_12980",
                        x1: "45.5246",
                        y1: "24.8807",
                        x2: "54.0025",
                        y2: "13.9733",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.321",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_499_12980",
                        x1: "101.929",
                        y1: "89.445",
                        x2: "103.151",
                        y2: "76.738",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2629",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6568",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7051",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7745",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8568",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9483",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_499_12980",
                        x1: "96.7524",
                        y1: "86.8327",
                        x2: "105.46",
                        y2: "77.236",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.321",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_499_12980",
                        x1: "46.7436",
                        y1: "124.678",
                        x2: "85.5786",
                        y2: "85.843",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_499_12980",
                        x1: "55.645",
                        y1: "135.098",
                        x2: "94.1816",
                        y2: "96.5612",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint19_linear_499_12980",
                        x1: "82.9016",
                        y1: "129.529",
                        x2: "83.3365",
                        y2: "138.118",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint20_linear_499_12980",
                        x1: "66.7271",
                        y1: "153.359",
                        x2: "112.794",
                        y2: "115.971",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint21_linear_499_12980",
                        x1: "64.8985",
                        y1: "150.541",
                        x2: "110.859",
                        y2: "113.239",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint22_linear_499_12980",
                        x1: "99.6982",
                        y1: "120.33",
                        x2: "103.749",
                        y2: "121.161",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint23_linear_499_12980",
                        x1: "0.174194",
                        y1: "146.568",
                        x2: "56.0521",
                        y2: "146.568",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-icon, #091E42)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-icon, #091E42)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint24_linear_499_12980",
                        x1: "58.1309",
                        y1: "158.125",
                        x2: "87.7433",
                        y2: "158.125",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-icon, #091E42)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-icon, #091E42)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint25_linear_499_12980",
                        x1: "78.6253",
                        y1: "150.658",
                        x2: "68.697",
                        y2: "151.584",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.452",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint26_linear_499_12980",
                        x1: "79.3893",
                        y1: "142.265",
                        x2: "75.8395",
                        y2: "140.601",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3539",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFB500)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7017",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint27_linear_499_12980",
                        x1: "76.9238",
                        y1: "139.183",
                        x2: "90.7241",
                        y2: "138.741",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7262",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint28_linear_499_12980",
                        x1: "90.4515",
                        y1: "22.6491",
                        x2: "117.556",
                        y2: "22.6491",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.0346",
                                stopColor: "var(--ds-icon-inverse, white)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3965",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #F7F7F8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9604",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #E1E3E6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_499_12980",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "147.652",
                            height: "160",
                            fill: "var(--ds-icon-inverse, white)",
                            transform: "translate(0.174194)"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("ijVIe", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a66953f9d62b484$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1a66953f9d62b484$var$messages = (0, $7qGN1.defineMessages)({
    buttonLoginToConfluenceNewTab: {
        id: 'embedded.confluence.generic-error-page.login-to-confluence-button',
        description: 'The text inside the login to Confluence button',
        defaultMessage: 'Log in to Confluence'
    },
    paragraphLogin: {
        id: 'embedded.confluence.need-to-log-in-paragraph',
        description: 'The text inside embedded confluence that tell user they need to be logged in to view this page',
        defaultMessage: 'You need to be logged in to view this page'
    },
    paragraphAlreadyLoggedIn: {
        id: 'embedded.confluence.already-logged-in-paragraph',
        description: 'The text inside embedded confluence that asks the user if they have logged in and refresh if so.',
        defaultMessage: 'Already logged in? Try refreshing.'
    },
    paragraphStillHavingTrouble: {
        id: 'embedded.confluence.still-having-trouble-paragraph',
        description: 'The text inside embedded confluence that asks the user if still having trouble and how they can enable third party cookies if so.',
        defaultMessage: 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}'
    },
    linkTroubleshootingText: {
        id: 'embedded.confluence.troubleshooting-link-text',
        description: 'the name of the placeholder {link} used in embedded.confluence.still-having-trouble-paragraph. Please translate these two as a single sentence',
        defaultMessage: 'refer to this troubleshooting guide.'
    },
    linkAriaLabel: {
        id: 'embedded.confluence.troubleshooting-link.aria-label',
        description: 'The aria label for troubleshooting link.',
        defaultMessage: 'troubleshooting guide link'
    },
    loginAriaLabel: {
        id: 'embedded.confluence.login-page.login-button.aria-label',
        description: 'The aria label for login button',
        defaultMessage: 'Login Button'
    },
    loginText: {
        id: 'embedded.confluence.login-page.login-text',
        description: 'Text to display before login button',
        defaultMessage: 'You need to be logged in to view this page'
    },
    loginButton: {
        id: 'embedded.confluence.login-page.login-button',
        description: 'The label for login button',
        defaultMessage: 'Log in to Confluence'
    },
    refreshBanner: {
        id: 'embedded.confluence.login-page.refresh-page-banner',
        description: 'The banner displayed prompting a user to refresh the page',
        defaultMessage: 'After logging in, this page should refresh automatically. If not, you can click here to refresh'
    },
    refreshBannerLink: {
        id: 'embedded.confluence.login-page.refresh-page-banner-refresh-link',
        description: 'A link to refresh the page',
        defaultMessage: 'Refresh page'
    }
});
var $1a66953f9d62b484$export$2e2bcd8739ae039 = $1a66953f9d62b484$var$messages;

});


parcelRegister("e5FZ0", function(module, exports) {
$parcel$export(module.exports, "LoginPage", () => $46ab436a36e209ea$export$f14c0e3f98d164c0);
/* LoginPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $lRq8t = parcelRequire("lRq8t");

var $806LH = parcelRequire("806LH");

var $5CSKW = parcelRequire("5CSKW");

var $lgMTT = parcelRequire("lgMTT");

var $kopi2 = parcelRequire("kopi2");

var $lKjnT = parcelRequire("lKjnT");

var $j2zMY = parcelRequire("j2zMY");

var $4AWDd = parcelRequire("4AWDd");

var $ijVIe = parcelRequire("ijVIe");

var $4nJ3E = parcelRequire("4nJ3E");
const $46ab436a36e209ea$var$fadeIn = null;
const $46ab436a36e209ea$var$styles = {
    loginButtonWrapper: "_19pkxy5q",
    parentDiv: "_1e0c1n7u _4cvr1h6o _6a6z1h6o",
    refreshBannerFade: "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _j7hq1wwu _5sagi11n"
};
const $46ab436a36e209ea$var$SUCCESS_URL_SUFFIX = '/wiki/embed/login-confirmation';
const $46ab436a36e209ea$export$f14c0e3f98d164c0 = ({ contentId: contentId, reloadEP: reloadEP, spaceKey: spaceKey, url: url })=>{
    const { locale: locale, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const loginUrl = (0, $eJOHy.useMemo)(()=>{
        const origin = url ? new URL(url).origin : window?.location?.origin;
        return `${origin}/login?application=confluence&dest-url=${encodeURIComponent(`${$46ab436a36e209ea$var$SUCCESS_URL_SUFFIX}?locale=${locale}`)}`;
    }, [
        url,
        locale
    ]);
    const handleClick = ()=>{
        $46ab436a36e209ea$var$openLoginPopup(loginUrl);
        setDisplayRefreshBanner(!displayRefreshBanner);
    };
    const [displayRefreshBanner, setDisplayRefreshBanner] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "login-page-test-id",
        className: (0, $hcewu.default)([
            $46ab436a36e209ea$var$styles.parentDiv
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopi2.ExperienceStart), {
                name: (0, $j2zMY.ExperienceNames).LOGIN_PAGE,
                id: `${spaceKey}-${contentId}`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.250",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceLogo), {
                        size: "large",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lKjnT.LoginToConfluenceIcon), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        as: "h2",
                        size: "large",
                        children: formatMessage((0, $ijVIe.default).loginText)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $46ab436a36e209ea$var$styles.loginButtonWrapper,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    testId: "login-button",
                    "aria-label": formatMessage((0, $ijVIe.default).loginAriaLabel),
                    appearance: "primary",
                    onClick: handleClick,
                    children: formatMessage((0, $ijVIe.default).loginButton)
                })
            }),
            displayRefreshBanner && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $46ab436a36e209ea$var$styles.refreshBannerFade
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4AWDd.default), {
                    reloadEP: reloadEP,
                    title: formatMessage((0, $ijVIe.default).refreshBanner),
                    actionLabel: formatMessage((0, $ijVIe.default).refreshBannerLink)
                })
            })
        ]
    });
};
function $46ab436a36e209ea$var$openLoginPopup(loginUrl) {
    const windowFeatures = 'popup=yes,left=100,top=100,width=640,height=640';
    window.open(loginUrl, '_blank', windowFeatures);
}

});
parcelRegister("kopi2", function(module, exports) {
$parcel$export(module.exports, "ExperienceStart", () => $80a280f19a7661a1$export$f20b867e738a222c);

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");
function $80a280f19a7661a1$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    const wasCalledRef = (0, $eJOHy.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}

});

parcelRegister("4AWDd", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fd4c0eb9ad4557e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $h0TP6 = parcelRequire("h0TP6");

var $3wl9L = parcelRequire("3wl9L");

const $4fd4c0eb9ad4557e$var$RefreshBanner = ({ reloadEP: reloadEP, title: title, actionLabel: actionLabel })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $h0TP6.default), {
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
            spacing: "spacious",
            color: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`,
            label: "Info"
        }),
        id: "refreshBanner",
        title: title,
        actions: [
            {
                content: actionLabel,
                onClick: reloadEP
            }
        ]
    });
var $4fd4c0eb9ad4557e$export$2e2bcd8739ae039 = $4fd4c0eb9ad4557e$var$RefreshBanner;

});


parcelRegister("bQ7Jf", function(module, exports) {
$parcel$export(module.exports, "StorageAccessPage", () => $ed3c22dd93ae1fa7$export$64a8a56a2c35628c);
/* StorageAccessPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $kopi2 = parcelRequire("kopi2");

var $j2zMY = parcelRequire("j2zMY");

var $lRq8t = parcelRequire("lRq8t");

var $4nJ3E = parcelRequire("4nJ3E");
const $ed3c22dd93ae1fa7$var$iframeStyles = null;
const $ed3c22dd93ae1fa7$export$64a8a56a2c35628c = ({ contentId: contentId, spaceKey: spaceKey, url: url, parentProduct: parentProduct })=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const iframeRef = (0, $eJOHy.useRef)(null);
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const src = (0, $eJOHy.useMemo)(()=>{
        const path = `/wiki/embed/storage-access?parentProduct=${parentProduct}&locale=${locale}`;
        const origin = url ? new URL(url).origin : window.location.origin;
        return [
            origin,
            path
        ].join('');
    }, [
        locale,
        parentProduct,
        url
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopi2.ExperienceStart), {
                name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                id: `${spaceKey}-${contentId}`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
                "data-testid": "storage-access-page-iframe",
                title: "storage-access-iframe",
                src: src,
                ref: iframeRef,
                className: (0, $hcewu.default)([
                    "_19itglyw _1bsb1osq _4t3i1osq"
                ])
            })
        ]
    });
};

});

parcelRegister("bbc8b", function(module, exports) {
$parcel$export(module.exports, "themeStateObjectToQueryString", () => $05685c35af67dcaf$export$6e43e60d51b79331);
$parcel$export(module.exports, "useUrl", () => $05685c35af67dcaf$export$305222dff575c4e3);

var $eJOHy = parcelRequire("eJOHy");

var $4CCpn = parcelRequire("4CCpn");

var $fzBRQ = parcelRequire("fzBRQ");
var $6DF4T = parcelRequire("6DF4T");

var $8HgDC = parcelRequire("8HgDC");

var $lRq8t = parcelRequire("lRq8t");

var $944VV = parcelRequire("944VV");
const $05685c35af67dcaf$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $4CCpn.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $05685c35af67dcaf$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $05685c35af67dcaf$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $05685c35af67dcaf$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $eJOHy.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $eJOHy.useMemo)(()=>allowedFeatures === 'all' ? (0, $8HgDC.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$05685c35af67dcaf$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $944VV.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $944VV.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $lRq8t.default)();
    const queryParams = (0, $eJOHy.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $05685c35af67dcaf$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            ...$05685c35af67dcaf$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $05685c35af67dcaf$var$CONTEXT_PATH = '/wiki/spaces';
const $05685c35af67dcaf$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $05685c35af67dcaf$var$constructUrl(mode = (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $05685c35af67dcaf$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $05685c35af67dcaf$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$05685c35af67dcaf$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$05685c35af67dcaf$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$05685c35af67dcaf$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $05685c35af67dcaf$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}

});
parcelRegister("944VV", function(module, exports) {
$parcel$export(module.exports, "isRedirectionEnabled", () => $96d0b9880a83dcb1$export$51abd16148027412);
$parcel$export(module.exports, "getCrossSiteTenantIdFromAllowedFeature", () => $96d0b9880a83dcb1$export$243fbba563b8aa8e);
const $96d0b9880a83dcb1$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch (error) {
        return false;
    }
    return false;
};
const $96d0b9880a83dcb1$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch (error) {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};

});


parcelRegister("d5di2", function(module, exports) {
$parcel$export(module.exports, "Subjects", () => $5039f3b5eeec03e2$export$29953e2fb702813a);
$parcel$export(module.exports, "LoadingStatus", () => $5039f3b5eeec03e2$export$19d37de7e9a4af59);
$parcel$export(module.exports, "useValidationState", () => $5039f3b5eeec03e2$export$1faa35b5a06780c0);

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");

var $j2zMY = parcelRequire("j2zMY");
var $5039f3b5eeec03e2$export$29953e2fb702813a = /*#__PURE__*/ function(Subjects) {
    Subjects["STORAGE_ACCESS"] = "storage-access";
    Subjects["LOGIN_CONFIRMATION"] = "login-confirmation";
    Subjects["CONTENT_LOAD"] = "content-load";
    return Subjects;
}({});
var $5039f3b5eeec03e2$export$19d37de7e9a4af59 = /*#__PURE__*/ function(LoadingStatus) {
    LoadingStatus["IFRAME_LOADED"] = "iframe-loaded";
    LoadingStatus["IFRAME_UNLOADED"] = "iframe-unloaded";
    LoadingStatus["CONTENT_LOAD_STARTED"] = "content-load-started";
    LoadingStatus["REDIRECTED_TO_LOGIN"] = "redirected-to-login";
    LoadingStatus["RELOAD_EP"] = "reload-ep";
    return LoadingStatus;
}({});
var $5039f3b5eeec03e2$export$12bf62de6f1fdb01 = /*#__PURE__*/ function(StorageAccessStatus) {
    StorageAccessStatus["GRANTED"] = "granted";
    StorageAccessStatus["REJECTED"] = "rejected";
    StorageAccessStatus["NOT_SUPPORTED"] = "not-supported";
    StorageAccessStatus["ERROR"] = "error";
    return StorageAccessStatus;
}({});
var $5039f3b5eeec03e2$export$889a6bd688f4360e = /*#__PURE__*/ function(UserLoginStatus) {
    UserLoginStatus["SUCCESS"] = "success";
    return UserLoginStatus;
}({});
/* NOTE: (Refer this table for understanding the behavior
  on different browsers: https://hello.atlassian.net/wiki/spaces/~288141084/pages/2154391293/Conditions+to+load+EP)
*/ function $5039f3b5eeec03e2$var$pageLoadValidationReducer(state, action) {
    //NOTE: We assume that storage access and user login is required at the load of the PageLoadValidation component
    switch(action.subject){
        case "storage-access":
            switch(action.status){
                case "granted":
                    /*If storage access is granted, refresh app, if user is logged in, try to load EP. If not, load Login CTA
					 */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false
                    };
                case "rejected":
                    /*If storage access is reject, it could mean either of the two things:
          1. (For Safari): User has storage access but may not be logged in, Try loggin user in
          2. (For Firefox, Edge): User may be logged in but storage access is not yet granted by the browser
          In both these case, ask user to login.
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false,
                        shouldAskToLogin: true
                    };
                case "not-supported":
                    /* This case is specific for Chrome where storage access is not supported. 
          So we can skip asking for storage access and direct user to the Login CTA. 
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: true,
                        shouldAskStorageAccess: false
                    };
                case "error":
                    /** To catch any other errors while requesting storage access */ return {
                        ...state
                    };
            }
            break;
        case "login-confirmation":
            switch(action.status){
                case "success":
                    /*
          If user has logged in, it means that storage access is granted. Refresh app, Try loading EP
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: false,
                        iframeUnloaded: false,
                        redirectedToLogin: false
                    };
            }
            break;
        case "content-load":
            //These states are set only when the user has navigated throught the storage access and login flows. So try to load EP
            switch(action.status){
                case "iframe-loaded":
                    return {
                        ...state,
                        iframeLoaded: true
                    };
                case "content-load-started":
                    return {
                        ...state,
                        contentLoadStarted: true
                    };
                case "iframe-unloaded":
                    return {
                        ...state,
                        iframeUnloaded: true
                    };
                case "redirected-to-login":
                    return {
                        ...state,
                        redirectedToLogin: true
                    };
                case "reload-ep":
                    return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false
                    };
            }
            break;
    }
}
const $5039f3b5eeec03e2$export$1faa35b5a06780c0 = ()=>{
    const initialState = {
        iframeLoaded: false,
        contentLoadStarted: false,
        shouldAskStorageAccess: true,
        shouldAskToLogin: true,
        redirectedToLogin: false,
        iframeUnloaded: false
    };
    const [state, dispatch] = (0, $eJOHy.useReducer)($5039f3b5eeec03e2$var$pageLoadValidationReducer, initialState);
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    const messageListener = (0, $eJOHy.useCallback)((messageEvent)=>{
        const { subject: subject, result: result } = messageEvent.data ?? {};
        if (!subject || !result) return;
        switch(subject){
            case "storage-access":
                switch(result){
                    case "granted":
                        experienceTracker.succeed({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "granted"
                        });
                        break;
                    case "rejected":
                        experienceTracker.abort({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $j2zMY.ExperienceReasons).STORAGE_ACCESS_REJECTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "rejected"
                        });
                        break;
                    case "not-supported":
                        experienceTracker.abort({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $j2zMY.ExperienceReasons).STORAGE_ACCESS_NOT_SUPPORTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "not-supported"
                        });
                        break;
                    case "error":
                        experienceTracker.fail({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                            error: new Error((0, $j2zMY.ExperienceReasons).STORAGE_ACCESS_ERROR)
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "error"
                        });
                        break;
                }
                break;
            case "login-confirmation":
                switch(result){
                    case "success":
                        experienceTracker.succeed({
                            name: (0, $j2zMY.ExperienceNames).LOGIN_PAGE
                        });
                        dispatch({
                            subject: "login-confirmation",
                            status: "success"
                        });
                        break;
                }
                break;
        }
    }, [
        experienceTracker
    ]);
    (0, $eJOHy.useEffect)(()=>{
        window.addEventListener('message', messageListener);
        return ()=>window.removeEventListener('message', messageListener);
    }, [
        messageListener
    ]);
    return {
        state: state,
        dispatch: dispatch
    };
};

});


parcelRegister("jgJaV", function(module, exports) {
$parcel$export(module.exports, "useFooter", () => $ccc878979acefb1a$export$d07da6ac6fc160b0);

var $eJOHy = parcelRequire("eJOHy");

var $j2zMY = parcelRequire("j2zMY");

var $3V5nR = parcelRequire("3V5nR");
const $ccc878979acefb1a$export$d07da6ac6fc160b0 = ({ experienceTracker: experienceTracker, hasFooter: hasFooter, shouldShowFooter: shouldShowFooter, parentProduct: parentProduct, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const [footerUrl, setFooterUrl] = (0, $eJOHy.useState)(standaloneConfluenceUrl);
    (0, $eJOHy.useEffect)(()=>{
        setFooterUrl(standaloneConfluenceUrl);
    }, [
        standaloneConfluenceUrl
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = experienceTracker.subscribe((event)=>{
            const { name: name, action: action } = event;
            if (name === (0, $j2zMY.ExperienceNames).PAGE_NOT_FOUND && action === 'taskStart') setFooterUrl(standaloneConfluenceUrl ? `${new URL(standaloneConfluenceUrl).origin}/wiki/home` : standaloneConfluenceUrl);
        });
        return ()=>unsubscribe();
    }, [
        experienceTracker,
        standaloneConfluenceUrl
    ]);
    /**
	 * Currently footer is hidden for the JSM Portal view which passes
	 * shouldShowFooter (externally, showFooterLogo) prop as false and shown for all other views
	 *
	 * JSM portal view will provide "JSM-Portal" as the parent product eventually
	 * However, team is still testing this product type for Atlassian and anonymous users so the "JSM-Portal" parentProduct is being feature-flagged
	 * We need to support these two parent product keys to keep backward compatible for the time being.
	 *
	 * Clean-up task in backlog: https://hello.atlassian.net/browse/CBT-1278 to remove "JSM" from the logic
	 *
	 * EDIT 7/17: showFooterLogo has been renamed internally for clarity and is now aliased as shouldShowFooter when used internally.
	 * External API remains unchanged.
	 */ const showFooter = (0, $eJOHy.useMemo)(()=>{
        const parentProducts = [
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JSM_PORTAL,
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JSM,
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JSW,
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JWM
        ];
        return !!hasFooter && !(parentProducts.includes(parentProduct) && !shouldShowFooter);
    }, [
        parentProduct,
        shouldShowFooter,
        hasFooter
    ]);
    return {
        showFooter: showFooter,
        footerUrl: footerUrl
    };
};

});

parcelRegister("8edRS", function(module, exports) {
$parcel$export(module.exports, "UniqueKeyProvider", () => $ac62a64a0b58e7a2$export$71829d27b87a2006);
$parcel$export(module.exports, "useUniqueKey", () => $ac62a64a0b58e7a2$export$cef64a0cfb90e369);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8FR7r = parcelRequire("8FR7r");
const $ac62a64a0b58e7a2$var$UniqueKeyContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    uniqueKey: undefined
});
const $ac62a64a0b58e7a2$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $eJOHy.useMemo)(()=>(0, $8FR7r.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ac62a64a0b58e7a2$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $ac62a64a0b58e7a2$export$cef64a0cfb90e369 = ()=>{
    return (0, $eJOHy.useContext)($ac62a64a0b58e7a2$var$UniqueKeyContext);
};

});

parcelRegister("3ca9m", function(module, exports) {
$parcel$export(module.exports, "default", () => $72ddffc24222dbaf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $72ddffc24222dbaf$var$messages = (0, $7qGN1.defineMessages)({
    viewInConfluence: {
        id: 'embedded.confluence.footer.hover.text',
        description: 'Hover text on Confluence Footer Content',
        defaultMessage: 'View in Confluence'
    },
    poweredBy: {
        id: 'embedded.confluence.footer.prefix',
        description: 'Prefix label on Confluence Logo',
        defaultMessage: 'Powered by'
    }
});
var $72ddffc24222dbaf$export$2e2bcd8739ae039 = $72ddffc24222dbaf$var$messages;

});


parcelRegister("lCbi5", function(module, exports) {
$parcel$export(module.exports, "useGetCurrentScrollPosition", () => $8510204e3c256619$export$4d8f561c32665bbe);

var $eJOHy = parcelRequire("eJOHy");

var $8qtes = parcelRequire("8qtes");
// Add debounce to the scroll handler to ensure that it is executed only once after X ms of delay
const $8510204e3c256619$var$handleScrollDeboubced = (scrollHandler, delay)=>{
    let timeoutId;
    return (...args)=>{
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            scrollHandler(...args);
        }, delay);
    };
};
const $8510204e3c256619$export$4d8f561c32665bbe = (isHeightSetFromContent)=>{
    const [scrollPosition, setScrollPosition] = (0, $eJOHy.useState)(0);
    const defaultScrollPosition = (0, $eJOHy.useRef)(0); // mutable ref to 0 - return this value when the media is open
    const prevScrollPosition = (0, $eJOHy.useRef)(0);
    const { isMediaOpen: isMediaOpen } = (0, $8qtes.useMediaViewerListener)();
    (0, $eJOHy.useEffect)(()=>{
        const handleScroll = $8510204e3c256619$var$handleScrollDeboubced(()=>{
            if (!isMediaOpen) {
                /*
					Saving the previous scroll position is essential because, by the time we receive the state of the media viewer,
					it may already have been opened or closed, and we do not have control over the actions that occur
					just before the media viewer is activated (which happens in a different package that we do not manage).
					Consequently, it is possible for the variable isMediaOpen to be false even when the media viewer is indeed open.
					This situation results in saving of an incorrect value for the scroll position when the media viewer is already active,
					which is misleading since the container height will have been reduced at this point.
					To mitigate this inaccuracy, we continuously track the scroll position when the media viewer is not open.
					When the media is subsequently clicked to open, retrieving the previous scroll position helps to offset the
					inaccuracies associated with saving the scroll position under the conditions of a condensed height.
				*/ prevScrollPosition.current = scrollPosition;
                setScrollPosition(window.scrollY);
            }
        }, 100); // Call the handler only once scroll event has stopped firing for a delay of 100ms.
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, [
        isMediaOpen,
        scrollPosition
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isHeightSetFromContent) // Restore the scroll position back to the value saved before any media file was open
        window.scrollTo(0, isMediaOpen ? defaultScrollPosition.current : prevScrollPosition.current);
    }, [
        isHeightSetFromContent,
        isMediaOpen
    ]);
};

});





parcelRegister("6ijO8", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $8212e0b78a96b746$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jyZeU = parcelRequire("jyZeU");

var $lWsis = parcelRequire("lWsis");

var $gWqMk = parcelRequire("gWqMk");
const $8212e0b78a96b746$export$1fea75498367c4ac = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lWsis.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gWqMk.EditPage), {
            ...props
        })
    });

});
parcelRegister("gWqMk", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $1919213bb3817aab$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6q6x9 = parcelRequire("6q6x9");

var $lRq8t = parcelRequire("lRq8t");
const $1919213bb3817aab$export$1fea75498367c4ac = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6q6x9.EditPage), {
        locale: locale,
        ...props
    });
};

});
parcelRegister("6q6x9", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $e16a2d7d4327cedc$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $TJJ14 = parcelRequire("TJJ14");

var $7oRxl = parcelRequire("7oRxl");

var $jyZeU = parcelRequire("jyZeU");

var $lzAG1 = parcelRequire("lzAG1");

var $4nJ3E = parcelRequire("4nJ3E");

var $8edRS = parcelRequire("8edRS");
const $e16a2d7d4327cedc$export$1fea75498367c4ac = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lzAG1.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8edRS.UniqueKeyProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {}),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $TJJ14.EditPage), {
                    ...props
                })
            })
        })
    });
};

});
parcelRegister("TJJ14", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $2003a24730d7f067$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j2zMY = parcelRequire("j2zMY");

var $fzBRQ = parcelRequire("fzBRQ");
var $6DF4T = parcelRequire("6DF4T");

var $jWzbc = parcelRequire("jWzbc");
const $2003a24730d7f067$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED = 'auto_closed';
const $2003a24730d7f067$export$1fea75498367c4ac = (props)=>{
    const { allowedFeatures: allowedFeatures } = props;
    const contentConfiguration = (0, $eJOHy.useMemo)(()=>{
        const isTemplateBrowserEnabled = allowedFeatures === 'all' || allowedFeatures?.find((feature)=>feature === 'template-browser' || feature.hasOwnProperty('template-browser')) !== undefined;
        const queryParams = isTemplateBrowserEnabled ? {
            inEditorTemplatesPanel: $2003a24730d7f067$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED
        } : undefined;
        return {
            experiences: {
                experience: (0, $j2zMY.ExperienceNames).EDIT_PAGE,
                ccExperience: (0, $j2zMY.ExperienceNames).CC_EDIT_PAGE_EMBED
            },
            queryParams: queryParams
        };
    }, [
        allowedFeatures
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jWzbc.Content), {
        ...props,
        contentType: (0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE,
        contentConfiguration: contentConfiguration
    });
};

});






parcelRegister("dxRkJ", function(module, exports) {
$parcel$export(module.exports, "useConfluencePageData", () => $069cdb8482617006$export$10fb2803bc7b79fc);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $7y92E = parcelRequire("7y92E");
var $4CCpn = parcelRequire("4CCpn");
var $069cdb8482617006$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $069cdb8482617006$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $069cdb8482617006$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $069cdb8482617006$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $eJOHy.useMemo)(()=>{
        if (!(0, $eGOwo.fg)('platform_deprecate_lp_cc_embed')) return undefined;
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($069cdb8482617006$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $4CCpn.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $eJOHy.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $7y92E.default)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};

});


parcelRegister("RCgNH", function(module, exports) {
$parcel$export(module.exports, "IframeDwellTracker", () => $069958df693c5c51$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $069958df693c5c51$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $069958df693c5c51$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $eJOHy.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $eJOHy.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $eJOHy.useEffect)(()=>{
        if (dwell.time > 0 && $069958df693c5c51$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $eJOHy.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});


parcelRegister("diXta", function(module, exports) {
$parcel$export(module.exports, "useEmbedResolvePostMessageListener", () => $b1c14f9c00d049d7$export$50ac35a9a8f2ebaa);

var $eJOHy = parcelRequire("eJOHy");

var $kbv8x = parcelRequire("kbv8x");
const $b1c14f9c00d049d7$export$50ac35a9a8f2ebaa = ({ url: url, embedIframeRef: embedIframeRef })=>{
    const resolve = (0, $kbv8x.default)();
    (0, $eJOHy.useEffect)(()=>{
        const messageCallback = (event)=>{
            if (typeof embedIframeRef === 'function') return;
            const isFromExpectedIframe = embedIframeRef && event.source === embedIframeRef.current?.contentWindow;
            if (event.data === 'force-resolve-smart-link' && isFromExpectedIframe) resolve(url, true);
        };
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        resolve,
        url,
        embedIframeRef
    ]);
};

});


parcelRegister("iUsXM", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5z6NJ = parcelRequire("5z6NJ");

var $l22Ft = parcelRequire("l22Ft");

var $5x724 = parcelRequire("5x724");
const $9a8ffe7d7e8e9c62$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_unauthorised_account_action,
                        values: values
                    })
                })
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name_no_provider
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description_no_provider
            })
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5x724.UnauthorizedSVG), {}),
        testId: testId,
        text: context?.text
    });
};
var $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039 = $9a8ffe7d7e8e9c62$var$UnauthorizedView;

});
parcelRegister("5x724", function(module, exports) {
$parcel$export(module.exports, "UnauthorizedSVG", () => $f913a8b5e191dd5f$export$6526edaac83a8c90);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $f913a8b5e191dd5f$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_1375_267)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "563.88",
                        height: "265.81",
                        transform: "translate(0.870117 0.509766)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
                        stroke: "url(#paint0_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
                        fill: "#403294"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
                        fill: "url(#paint1_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
                        fill: "url(#paint2_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
                        stroke: "url(#paint3_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.38",
                        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
                        fill: "url(#paint4_radial_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
                        fill: "url(#paint5_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
                        fill: "url(#paint6_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
                        fill: "url(#paint7_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
                        fill: "url(#paint8_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
                        fill: "url(#paint9_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
                        fill: "url(#paint10_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
                        fill: "url(#paint11_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
                        fill: "url(#paint12_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
                        fill: "#172B4D"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
                        fill: "url(#paint13_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
                        fill: "url(#paint14_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
                        fill: "url(#paint15_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
                        fill: "url(#paint16_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
                        fill: "#6554C0"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
                        fill: "url(#paint17_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
                        fill: "#5243AA"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
                        fill: "url(#paint18_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
                        fill: "#B3BAC5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_1375_267",
                        x1: "141.994",
                        y1: "181.192",
                        x2: "0.870117",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C1C7D0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_1375_267",
                        x1: "208.292",
                        y1: "264.428",
                        x2: "0.870117",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_1375_267",
                        x1: "357.327",
                        y1: "264.428",
                        x2: "564.748",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_1375_267",
                        x1: "423.624",
                        y1: "181.192",
                        x2: "564.748",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1724",
                                stopColor: "#076AFF",
                                stopOpacity: "0.8007"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4145",
                                stopColor: "#1976FF",
                                stopOpacity: "0.5208"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6966",
                                stopColor: "#378BFF",
                                stopOpacity: "0.1947"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8651",
                                stopColor: "#4C9AFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "paint4_radial_1375_267",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(285 99.0229) scale(96.5182)",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1584",
                                stopColor: "#FFE587",
                                stopOpacity: "0.8416"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3589",
                                stopColor: "#FFDA57",
                                stopOpacity: "0.6411"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5498",
                                stopColor: "#FFD031",
                                stopOpacity: "0.4502"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7256",
                                stopColor: "#FFC916",
                                stopOpacity: "0.2744"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8811",
                                stopColor: "#FFC506",
                                stopOpacity: "0.1189"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_1375_267",
                        x1: "346.074",
                        y1: "98.8386",
                        x2: "423.624",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_1375_267",
                        x1: "237.087",
                        y1: "120.044",
                        x2: "276.412",
                        y2: "120.044",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_1375_267",
                        x1: "237.087",
                        y1: "75.0106",
                        x2: "276.412",
                        y2: "75.0106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_1375_267",
                        x1: "335.969",
                        y1: "146.593",
                        x2: "335.969",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B2D4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_1375_267",
                        x1: "219.544",
                        y1: "98.8386",
                        x2: "141.994",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_1375_267",
                        x1: "229.65",
                        y1: "146.593",
                        x2: "229.65",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F4F5F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_1375_267",
                        x1: "402.858",
                        y1: "216.64",
                        x2: "421.684",
                        y2: "223.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8134",
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8713",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_1375_267",
                        x1: "376.968",
                        y1: "157.139",
                        x2: "433.936",
                        y2: "157.139",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_1375_267",
                        x1: "289.638",
                        y1: "45.0027",
                        x2: "289.638",
                        y2: "0.510323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_1375_267",
                        x1: "262.238",
                        y1: "36.2259",
                        x2: "272.592",
                        y2: "36.2259",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_1375_267",
                        x1: "259.6",
                        y1: "180.859",
                        x2: "259.6",
                        y2: "141.017",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_1375_267",
                        x1: "284.971",
                        y1: "171.613",
                        x2: "284.971",
                        y2: "149.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_1375_267",
                        x1: "157.982",
                        y1: "221.995",
                        x2: "188.627",
                        y2: "221.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3435",
                                stopColor: "#6554C0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#998DD9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_1375_267",
                        x1: "163.185",
                        y1: "155.517",
                        x2: "213.758",
                        y2: "155.517",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#5243AA"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8777D9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_1375_267",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "563.88",
                            height: "265.81",
                            fill: "white",
                            transform: "translate(0.870117 0.509766)"
                        })
                    })
                ]
            })
        ]
    });

});



parcelRegister("6J1DL", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $71d51cdd37301ec2$export$aff6291803939b05);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $gA511 = parcelRequire("gA511");

var $kj3Kk = parcelRequire("kj3Kk");

var $3sgI9 = parcelRequire("3sgI9");

var $6kw7n = parcelRequire("6kw7n");

var $eIvWj = parcelRequire("eIvWj");

var $4dnWW = parcelRequire("4dnWW");

var $kFkj1 = parcelRequire("kFkj1");
const $71d51cdd37301ec2$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-inline-card"
            }),
            children
        ]
    }) : children;
};
const $71d51cdd37301ec2$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $5NtHI.SmartLinkStatus).Resolved ? (0, $aRZRK.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($71d51cdd37301ec2$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4dnWW.InlineCardResolvingView), {
                    url: url,
                    isSelected: isSelected,
                    onClick: handleFrameClick,
                    testId: testIdWithStatus,
                    inlinePreloaderStyle: inlinePreloaderStyle,
                    resolvingPlaceholder: resolvingPlaceholder,
                    truncateInline: truncateInline
                })
            });
        case 'resolved':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton
            });
        case 'unauthorized':
            const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFkj1.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $hy9OT.extractSmartLinkProvider)(details);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6kw7n.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3sgI9.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline
            });
    }
};

});
parcelRegister("3sgI9", function(module, exports) {
$parcel$export(module.exports, "InlineCardErroredView", () => $f78d8ca0def2e8b6$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1NG86 = parcelRequire("1NG86");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $f78d8ca0def2e8b6$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_size: "small",
        testId: "errored-view-default-icon"
    });
};
const $f78d8ca0def2e8b6$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleRetry,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).try_again
            })
        });
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon || $f78d8ca0def2e8b6$var$fallbackIcon(),
                link: hashAction ? url : undefined,
                title: url,
                onClick: hashAction ? onClick : undefined,
                rightSide: message
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});

parcelRegister("6kw7n", function(module, exports) {
$parcel$export(module.exports, "InlineCardForbiddenView", () => $5783739fd5be2c19$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");


var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $5783739fd5be2c19$var$styles = {
    actionButtonLozengeStyle: "_2rkolb4i _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $5783739fd5be2c19$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small",
        testId: "forbidden-view-fallback-icon"
    });
};
const $5783739fd5be2c19$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).invalid_permissions,
            children: (formattedMessage)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: formattedMessage
                })
        });
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account",
                children: renderForbiddenAccessMessage()
            });
        }
        if (onAuthorise) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            xcss: $5783739fd5be2c19$var$styles.actionButtonLozengeStyle,
            onClick: handleRetry,
            style: {
                font: `inherit`
            },
            testId: "button-connect-other-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
                appearance: "moved",
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: renderForbiddenAccessMessage()
            })
        });
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $5783739fd5be2c19$var$fallbackForbiddenIcon(),
                link: url,
                title: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("kKPzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1c01b17c1604b90$var$_react = $f1c01b17c1604b90$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $f1c01b17c1604b90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1c01b17c1604b90$var$LockFilledIcon = (props)=>/*#__PURE__*/ $f1c01b17c1604b90$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props));
$f1c01b17c1604b90$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $f1c01b17c1604b90$var$_default = module.exports.default = $f1c01b17c1604b90$var$LockFilledIcon;

});


parcelRegister("4dnWW", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvingView", () => $7b3077a1d4f02d91$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");

var $8a4B6 = parcelRequire("8a4B6");
const $7b3077a1d4f02d91$var$styles = {
    spinnerWrapper: "_11c81o8v _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $7b3077a1d4f02d91$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            xcss: $7b3077a1d4f02d91$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: 14
            })
        }), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3KRDe.IconTitleWrapper), {
            children: [
                url,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8a4B6.RightIconPositionWrapper), {
                    children: renderSpinner()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
            icon: renderSpinner(),
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor
        })
    });
};

});
parcelRegister("8a4B6", function(module, exports) {
$parcel$export(module.exports, "RightIconPositionWrapper", () => $9116d903068768cf$export$91b164375b8037b5);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9116d903068768cf$export$91b164375b8037b5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kFkj1", function(module, exports) {
$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $38c365e1bf03afe8$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $38c365e1bf03afe8$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small"
    });
};
const $38c365e1bf03afe8$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        });
    }, [
        handleConnectAccount,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $38c365e1bf03afe8$var$fallbackUnauthorizedIcon(),
                title: url,
                link: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        id: id,
        children: inlineCardUnauthenticatedView
    });
    return inlineCardUnauthenticatedView;
};

});




parcelRegister("etjvQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7997b7b805f50047$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
                                                                                                                              * @jsxRuntime classic
                                                                                                                              * @jsx jsx
                                                                                                                              */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $3lIcL = parcelRequire("3lIcL");

var $XhTSt = parcelRequire("XhTSt");

var $9itkV = parcelRequire("9itkV");

var $f4WMd = parcelRequire("f4WMd");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $92xoS = parcelRequire("92xoS");

var $97Qim = parcelRequire("97Qim");
var $bMFKb = parcelRequire("bMFKb");

var $6dRXt = parcelRequire("6dRXt");
function $7997b7b805f50047$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7997b7b805f50047$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $7997b7b805f50047$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $7997b7b805f50047$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $7997b7b805f50047$var$linkStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    left: 'space.025',
    top: '-1px',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $7997b7b805f50047$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $7997b7b805f50047$var$ICON_WIDTH = 16;
const $7997b7b805f50047$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $7997b7b805f50047$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $3lIcL.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $97Qim.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $7997b7b805f50047$var$HoverLinkOverlay = ({ children: children, isVisible: isVisible = false, url: url, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const containerRef = (0, $eJOHy.useRef)(null);
    const hoverLinkButtonRef = (0, $eJOHy.useRef)(null);
    const hiddenTextRef = (0, $eJOHy.useRef)(null);
    const [showLabel, setShowLabel] = (0, $eJOHy.useState)(true);
    const [isHovered, setHovered] = (0, $eJOHy.useState)(false);
    const openTextWidthRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = hoverLinkButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $7997b7b805f50047$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $7997b7b805f50047$var$DEFAULT_OPEN_TEXT_WIDTH;
        const canShowLabel = cardWidth - openTextWidth > $7997b7b805f50047$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $7997b7b805f50047$var$ICON_WIDTH;
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $7997b7b805f50047$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $bMFKb.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open(url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $bMFKb.INPUT_METHOD).BUTTON);
    };
    const isPreivewButton = showPanelButton && (0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true);
    const label = isPreivewButton ? formatMessage((0, $6dRXt.messages).previewButtonTitle) : formatMessage((0, $6dRXt.messages).openButtonTitle);
    let icon = null;
    if (isPreivewButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4WMd))), {
        label: ""
    });
    else if (isPreivewButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($XhTSt))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
        label: ""
    });
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        ref: containerRef,
        css: $7997b7b805f50047$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false)
    }, children, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $7997b7b805f50047$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5qJVF.default), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lL4G9.default), {
        ref: hoverLinkButtonRef,
        xcss: $7997b7b805f50047$var$linkStyles,
        href: url,
        target: "_blank",
        style: {
            paddingBlock: compactPadding ? '1px' : "var(--ds-space-025, 2px)"
        },
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
        xcss: $7997b7b805f50047$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), showLabel && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5qJVF.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label))));
};
var $7997b7b805f50047$export$2e2bcd8739ae039 = $7997b7b805f50047$var$HoverLinkOverlay;

});
parcelRegister("97Qim", function(module, exports) {
$parcel$export(module.exports, "buildEditLinkPayload", () => $7d7b4d8beeabc390$export$7f3c24765adf61f0);
$parcel$export(module.exports, "buildVisitedLinkPayload", () => $7d7b4d8beeabc390$export$e81ec2390acfc152);
$parcel$export(module.exports, "buildVisitedNonHyperLinkPayload", () => $7d7b4d8beeabc390$export$4c5e2a0406e7eae8);
$parcel$export(module.exports, "buildOpenedSettingsPayload", () => $7d7b4d8beeabc390$export$96aa8ae974c8591a);
$parcel$export(module.exports, "unlinkPayload", () => $7d7b4d8beeabc390$export$aab75a08bdd88be4);

var $bMFKb = parcelRequire("bMFKb");
const $7d7b4d8beeabc390$export$7f3c24765adf61f0 = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).CLICKED,
        actionSubject: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? (0, $bMFKb.ACTION_SUBJECT).HYPERLINK : (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).EDIT_LINK,
        attributes: type !== (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? {
            // @ts-ignore
            display: type
        } : {},
        eventType: (0, $bMFKb.EVENT_TYPE).UI
    };
};
const $7d7b4d8beeabc390$var$mapLinkTypeToCardAppearance = (type)=>{
    switch(type){
        case (0, $bMFKb.ACTION_SUBJECT_ID).CARD_INLINE:
            return 'inline';
        case (0, $bMFKb.ACTION_SUBJECT_ID).CARD_BLOCK:
            return 'block';
        case (0, $bMFKb.ACTION_SUBJECT_ID).EMBEDS:
            return 'embed';
        default:
            return 'url';
    }
};
const $7d7b4d8beeabc390$export$e81ec2390acfc152 = (type)=>{
    return type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? $7d7b4d8beeabc390$var$buildVisitedHyperLinkPayload() : $7d7b4d8beeabc390$export$4c5e2a0406e7eae8(type, (0, $bMFKb.INPUT_METHOD).TOOLBAR);
};
const $7d7b4d8beeabc390$var$buildVisitedHyperLinkPayload = ()=>{
    return {
        action: (0, $bMFKb.ACTION).VISITED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).HYPERLINK,
        actionSubjectId: undefined,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};
const $7d7b4d8beeabc390$export$4c5e2a0406e7eae8 = (type, inputMethod)=>{
    return {
        action: (0, $bMFKb.ACTION).VISITED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};
const $7d7b4d8beeabc390$export$96aa8ae974c8591a = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).CLICKED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
        attributes: {
            // @ts-ignore
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR,
            display: $7d7b4d8beeabc390$var$mapLinkTypeToCardAppearance(type)
        },
        eventType: (0, $bMFKb.EVENT_TYPE).UI
    };
};
const $7d7b4d8beeabc390$export$aab75a08bdd88be4 = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).UNLINK,
        actionSubject: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? (0, $bMFKb.ACTION_SUBJECT).HYPERLINK : (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};

});


parcelRegister("8KqmO", function(module, exports) {
$parcel$export(module.exports, "useInlineAnnotationProps", () => $2bda144e58b3ea3a$export$11564cda945bb3c9);

var $eGOwo = parcelRequire("eGOwo");

var $e2m7L = parcelRequire("e2m7L");
function $2bda144e58b3ea3a$export$11564cda945bb3c9(props) {
    const { selectionDraftDocumentPosition: draftPosition } = (0, $e2m7L.useAnnotationRangeState)();
    if (!(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}

});


parcelRegister("8KOSq", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fcd2e2af5104151$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $2fcd2e2af5104151$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("krFFO")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $2fcd2e2af5104151$var$DatasourceTableViewWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'datasource-table-view-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2fcd2e2af5104151$var$LazyDatasourceTableView, props));
};
var $2fcd2e2af5104151$export$2e2bcd8739ae039 = $2fcd2e2af5104151$var$DatasourceTableViewWithWrappers;

});
parcelRegister("krFFO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("exQGw")
]).then(()=>parcelRequire('hadck'));

});


parcelRegister("7WlTe", function(module, exports) {
$parcel$export(module.exports, "getDatasourceType", () => $735e61d500130c4c$export$19af9860957ca153);
$parcel$export(module.exports, "canRenderDatasource", () => $735e61d500130c4c$export$1974047c293dd52e);

var $k9y0J = parcelRequire("k9y0J");
var $7BBxG = parcelRequire("7BBxG");
var $7KhEE = parcelRequire("7KhEE");

var $eGOwo = parcelRequire("eGOwo");
const $735e61d500130c4c$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $7KhEE.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $k9y0J.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $7BBxG.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};
const $735e61d500130c4c$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = $735e61d500130c4c$export$19af9860957ca153(datasourceId);
    switch(datasourceType){
        case 'jira':
            return true;
        case 'assets':
            if ((0, $eGOwo.fg)('linking_platform_datasource_assets_objects')) return true;
            return false;
        default:
            return defaultValue;
    }
};

});
parcelRegister("k9y0J", function(module, exports) {
$parcel$export(module.exports, "ASSETS_LIST_OF_LINKS_DATASOURCE_ID", () => $16f3892d5aa02916$export$34a6fbdd67f09ff6);
$parcel$export(module.exports, "default", () => $16f3892d5aa02916$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $16f3892d5aa02916$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';

const $16f3892d5aa02916$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("azbF7")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $16f3892d5aa02916$var$AssetsConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f3892d5aa02916$var$LazyAssetsConfigModal, props));
};
var $16f3892d5aa02916$export$2e2bcd8739ae039 = $16f3892d5aa02916$var$AssetsConfigModalWithWrappers;

});
parcelRegister("azbF7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gxPBZ")
]).then(()=>parcelRequire('i1bWW'));

});


parcelRegister("7BBxG", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_SEARCH_DATASOURCE_ID", () => $aaf2311a623c98ee$export$d9788d6cf1867282);
$parcel$export(module.exports, "default", () => $aaf2311a623c98ee$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $aaf2311a623c98ee$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';

const $aaf2311a623c98ee$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dPmx0")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $aaf2311a623c98ee$var$ConfluenceSearchConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aaf2311a623c98ee$var$LazyConfluenceSearchConfigModal, props));
};
var $aaf2311a623c98ee$export$2e2bcd8739ae039 = $aaf2311a623c98ee$var$ConfluenceSearchConfigModalWithWrappers;

});
parcelRegister("dPmx0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lLdNy")
]).then(()=>parcelRequire('a1XeP'));

});


parcelRegister("7KhEE", function(module, exports) {
$parcel$export(module.exports, "JIRA_LIST_OF_LINKS_DATASOURCE_ID", () => $b6adaf62d6e1c249$export$8ce19958117ece5c);
$parcel$export(module.exports, "default", () => $b6adaf62d6e1c249$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $b6adaf62d6e1c249$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

const $b6adaf62d6e1c249$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cQoqQ")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $b6adaf62d6e1c249$var$JiraIssuesConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'jira-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6adaf62d6e1c249$var$LazyJiraIssuesConfigModal, props));
};
var $b6adaf62d6e1c249$export$2e2bcd8739ae039 = $b6adaf62d6e1c249$var$JiraIssuesConfigModalWithWrappers;

});
parcelRegister("cQoqQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("fliVL"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("7FotB")
]).then(()=>parcelRequire('fjaM1'));

});




parcelRegister("1C1WZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $94b650125906c273$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $4cFYC = parcelRequire("4cFYC");
var $6PcbG = parcelRequire("6PcbG");

var $8YHJ2 = parcelRequire("8YHJ2");

var $9kfy2 = parcelRequire("9kfy2");

var $jYx9G = parcelRequire("jYx9G");
var $93FVZ = parcelRequire("93FVZ");
var $2bEPZ = parcelRequire("2bEPZ");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $AIyOt = parcelRequire("AIyOt");

var $92xoS = parcelRequire("92xoS");

var $81LfQ = parcelRequire("81LfQ");


var $kL4gV = parcelRequire("kL4gV");

var $e2B2h = parcelRequire("e2B2h");

var $jWNZR = parcelRequire("jWNZR");

var $9ug1Y = parcelRequire("9ug1Y");
function $94b650125906c273$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $94b650125906c273$var$embedCardWrapperStyles = {
    name: "yjftov",
    styles: "width:100%;height:100%;> div{height:100%;}.loader-wrapper{height:100%;}margin:0 auto"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $94b650125906c273$var$uIMediaSingleLayoutStyles = {
    name: "1abqfmo",
    styles: "margin-left:50%;transform:translateX(-50%)"
};
function $94b650125906c273$var$EmbedCardInternal(props) {
    const { url: url, data: data, eventHandlers: eventHandlers, layout: layout, width: width, isInsideOfBlockNode: isInsideOfBlockNode, rendererAppearance: rendererAppearance, smartLinks: smartLinks, isInsideOfInlineExtension: isInsideOfInlineExtension } = props;
    const portal = (0, $jWNZR.usePortal)(props);
    const embedIframeRef = (0, $eJOHy.useRef)(null);
    const onClick = (0, $kL4gV.getCardClickHandler)(eventHandlers, url);
    const { actionOptions: actionOptions } = smartLinks || {};
    const platform = 'web';
    const cardProps = {
        url: url,
        onClick: onClick,
        container: portal,
        platform: platform,
        frameStyle: smartLinks?.frameStyle ?? 'show',
        actionOptions: actionOptions,
        CompetitorPrompt: smartLinks?.CompetitorPrompt
    };
    const [liveHeight, setLiveHeight] = (0, $eJOHy.useState)(null);
    const [aspectRatio, setAspectRatio] = (0, $eJOHy.useState)();
    const height = liveHeight || props.originalHeight;
    // We start with height and width defined with default values
    let originalHeight = (0, $7yBx7.DEFAULT_EMBED_CARD_HEIGHT);
    let originalWidth = (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH);
    // Then can override height and width with values from ADF if available
    if (props.originalHeight && props.originalWidth) {
        originalHeight = props.originalHeight;
        originalWidth = props.originalWidth;
    }
    // Then we can override it with aspectRatio that is comming from iframely via `resolve()`
    if (aspectRatio) {
        originalHeight = 1;
        originalWidth = aspectRatio;
    }
    // And finally if iframe sends live `height` events we use that as most precise measure.
    const isHeightOnlyMode = !(props.originalHeight && props.originalWidth) || liveHeight;
    if (height && isHeightOnlyMode) {
        originalHeight = height;
        originalWidth = undefined;
    }
    const padding = rendererAppearance === 'full-page' ? (0, $9a762f515f769003$export$12fd658e5eef0d79) * 2 : 0;
    const [hasPreview, setPreviewAvailableState] = (0, $eJOHy.useState)(true);
    const cardContext = (0, $eJOHy.useContext)((0, $9kfy2.SmartCardContext));
    const onResolve = ({ aspectRatio: resolvedAspectRatio })=>{
        const hasPreviewOnResolve = !!(cardContext && url && cardContext.extractors.getPreview(url, platform));
        if (!hasPreviewOnResolve) setPreviewAvailableState(false);
        setAspectRatio(resolvedAspectRatio);
    };
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthConsumer), null, ({ width: documentWidth })=>{
        const isFullWidth = rendererAppearance === 'full-width';
        let containerWidth = documentWidth;
        if (smartLinks?.ssr && !containerWidth) // EDM-8114: When we are rendering on SSR, we have no idea what the width is.
        containerWidth = isFullWidth ? (0, $7yBx7.akEditorFullWidthLayoutWidth) : (0, $7yBx7.akEditorDefaultLayoutWidth);
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $7yBx7.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $7yBx7.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const lineLength = isFullWidth ? Math.min((0, $7yBx7.akEditorFullWidthLayoutWidth), containerWidth - padding) : nonFullWidthSize;
        const uiMediaSingleStyles = layout === 'full-width' || layout === 'wide' ? $94b650125906c273$var$uIMediaSingleLayoutStyles : '';
        const onError = ({ err: err })=>{
            if (err) throw err;
        };
        let cardComponent;
        if (smartLinks?.ssr && url && ((0, $eGOwo.fg)('platform_ssr_smartlink_embeds') || (0, $eGOwo.fg)('jfp-magma-ssr-iv-editor-links'))) {
            const ssrCardProps = {
                url: url,
                onClick: onClick,
                container: portal,
                platform: platform,
                frameStyle: smartLinks?.frameStyle ?? 'show',
                actionOptions: actionOptions
            };
            cardComponent = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8YHJ2.CardSSR), {
                appearance: "embed",
                ...ssrCardProps,
                onResolve: onResolve,
                inheritDimensions: true,
                embedIframeRef: embedIframeRef,
                onError: onError
            });
        } else cardComponent = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4cFYC.Card), {
            appearance: "embed",
            ...cardProps,
            onResolve: onResolve,
            inheritDimensions: true,
            embedIframeRef: embedIframeRef,
            onError: onError
        });
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $1NIU8.jsx)((0, $81LfQ.CardErrorBoundary), {
            unsupportedComponent: (0, $93FVZ.default),
            ...cardProps
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6PcbG.EmbedResizeMessageListener), {
            embedIframeRef: embedIframeRef,
            onHeightUpdate: setLiveHeight
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jYx9G.default), {
            css: uiMediaSingleStyles,
            layout: layout,
            width: originalWidth,
            containerWidth: containerWidth,
            pctWidth: width,
            height: originalHeight,
            fullWidthMode: isFullWidth,
            nodeType: "embedCard",
            lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
            hasFallbackContainer: hasPreview,
            isInsideOfInlineExtension: isInsideOfInlineExtension
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $94b650125906c273$var$embedCardWrapperStyles
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "embedCardView-content-wrap",
            "data-embed-card": true,
            "data-layout": layout,
            "data-width": width,
            "data-card-data": data ? JSON.stringify(data) : undefined,
            "data-card-url": url,
            "data-card-original-height": originalHeight
        }, cardComponent))))));
    }));
}
const $94b650125906c273$export$1135f3b0aac4c4ec = ({ url: url, data: data, eventHandlers: eventHandlers, portal: portal, originalHeight: originalHeight, originalWidth: originalWidth, width: embedWidth, layout: layout, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, smartLinks: smartLinks, isInsideOfInlineExtension: isInsideOfInlineExtension })=>{
    const { width: width } = (0, $eJOHy.useContext)((0, $2bEPZ.WidthContext));
    const viewAsBlockCard = width && width <= (0, $7yBx7.akEditorFullPageNarrowBreakout);
    return viewAsBlockCard ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9ug1Y.default), {
        url: url,
        data: data,
        eventHandlers: eventHandlers,
        portal: portal,
        layout: layout,
        rendererAppearance: rendererAppearance,
        smartLinks: smartLinks
    }) : /*#__PURE__*/ (0, $1NIU8.jsx)($94b650125906c273$var$EmbedCardInternal, {
        url: url,
        data: data,
        eventHandlers: eventHandlers,
        portal: portal,
        originalHeight: originalHeight,
        originalWidth: originalWidth,
        width: embedWidth,
        layout: layout,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        smartLinks: smartLinks,
        isInsideOfInlineExtension: isInsideOfInlineExtension
    });
};
const $94b650125906c273$var$EmbedCardWithCondition = (0, $AIyOt.componentWithCondition)(()=>(0, $92xoS.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }), $94b650125906c273$export$1135f3b0aac4c4ec, $94b650125906c273$var$EmbedCardInternal);
var $94b650125906c273$export$2e2bcd8739ae039 = $94b650125906c273$var$EmbedCardWithCondition;

});
parcelRegister("6PcbG", function(module, exports) {
$parcel$export(module.exports, "EmbedResizeMessageListener", () => $70e409de76fcb943$export$3482036c37e627f4);

var $eJOHy = parcelRequire("eJOHy");

var $65oSX = parcelRequire("65oSX");
class $70e409de76fcb943$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        }, this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + (0, $65oSX.embedHeaderHeight);
            onHeightUpdate(height);
        };
    }
}

});

parcelRegister("jYx9G", function(module, exports) {
$parcel$export(module.exports, "default", () => $209fa0d68bd3a102$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $k9JrM = parcelRequire("k9JrM");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $jgJtD = parcelRequire("jgJtD");

var $1I3aa = parcelRequire("1I3aa");

var $2zJxT = parcelRequire("2zJxT");

var $19zEl = parcelRequire("19zEl");

var $jhKIq = parcelRequire("jhKIq");
function $209fa0d68bd3a102$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $19zEl.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $2zJxT.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $7yBx7.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH) - (0, $7yBx7.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $jhKIq.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            nodeType: nodeType
        }),
        ...(0, $eGOwo.fg)('platform_editor_fix_image_size_diff_during_ssr') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $jgJtD.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jhKIq.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});
parcelRegister("k9JrM", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("7yBx7", function(module, exports) {
$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $12e0df67293c076b$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $12e0df67293c076b$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $12e0df67293c076b$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $12e0df67293c076b$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $12e0df67293c076b$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $12e0df67293c076b$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $12e0df67293c076b$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $12e0df67293c076b$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $12e0df67293c076b$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $12e0df67293c076b$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $12e0df67293c076b$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $12e0df67293c076b$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $12e0df67293c076b$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $12e0df67293c076b$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBoldBoxShadow", () => $12e0df67293c076b$export$37e178ca41c198ca);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $12e0df67293c076b$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $12e0df67293c076b$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $12e0df67293c076b$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $12e0df67293c076b$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $12e0df67293c076b$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $12e0df67293c076b$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $12e0df67293c076b$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $12e0df67293c076b$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $12e0df67293c076b$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $12e0df67293c076b$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $12e0df67293c076b$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $12e0df67293c076b$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $12e0df67293c076b$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $12e0df67293c076b$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $12e0df67293c076b$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $12e0df67293c076b$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $12e0df67293c076b$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $12e0df67293c076b$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $12e0df67293c076b$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $12e0df67293c076b$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $12e0df67293c076b$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $12e0df67293c076b$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $12e0df67293c076b$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorGutterPaddingReduced", () => $12e0df67293c076b$export$aae87d25ced827bb);
$parcel$export(module.exports, "akEditorFullPageNarrowBreakout", () => $12e0df67293c076b$export$cccda66937c91e4c);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $12e0df67293c076b$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $12e0df67293c076b$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $12e0df67293c076b$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $12e0df67293c076b$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $12e0df67293c076b$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $12e0df67293c076b$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $12e0df67293c076b$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $12e0df67293c076b$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $12e0df67293c076b$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $12e0df67293c076b$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $12e0df67293c076b$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $12e0df67293c076b$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $12e0df67293c076b$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $12e0df67293c076b$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $12e0df67293c076b$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $12e0df67293c076b$export$de3cef07cda55645);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $12e0df67293c076b$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $12e0df67293c076b$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $12e0df67293c076b$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $12e0df67293c076b$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $12e0df67293c076b$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $12e0df67293c076b$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $12e0df67293c076b$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $12e0df67293c076b$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $12e0df67293c076b$export$59733a9f61449b25);
$parcel$export(module.exports, "VIEWPORT_SIZES", () => $12e0df67293c076b$export$96b72b7f243fa693);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $12e0df67293c076b$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $12e0df67293c076b$export$42608c013398a830);

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");
const $12e0df67293c076b$export$fe6b0b821a0e9067 = 16;
const $12e0df67293c076b$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $12e0df67293c076b$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $12e0df67293c076b$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $12e0df67293c076b$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $12e0df67293c076b$export$f0e953d95429ca1 = '12px';
const $12e0df67293c076b$export$a309dbdeca0adb1a = '2px 4px';
const $12e0df67293c076b$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $12e0df67293c076b$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $12e0df67293c076b$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $12e0df67293c076b$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $12e0df67293c076b$export$d2715266dd4a1fd1 = 20;
const $12e0df67293c076b$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $12e0df67293c076b$export$8dac549e32469ac4 = 1;
const $12e0df67293c076b$export$befaaae517e3d864 = 2;
const $12e0df67293c076b$export$6e1e1996c4e8cc51 = `${$12e0df67293c076b$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $12e0df67293c076b$export$b6a59ac3a19b6343 = `0 0 0 ${$12e0df67293c076b$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $12e0df67293c076b$export$37e178ca41c198ca = `0 0 0 ${$12e0df67293c076b$export$befaaae517e3d864}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $12e0df67293c076b$export$4a007c22e25e31f6 = 0.3;
const $12e0df67293c076b$export$f35cc48f3398ab79 = 1;
const $12e0df67293c076b$export$b46cda584c619451 = 2;
const $12e0df67293c076b$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $12e0df67293c076b$export$321ddd2f049dd12 = $12e0df67293c076b$export$6bed85de54b5de42 + 1;
const $12e0df67293c076b$export$daeac9b8422ac3c2 = 2;
const $12e0df67293c076b$export$501d46e11ed5bf73 = 500;
const $12e0df67293c076b$export$6817b4b6a5ef78f1 = 400;
const $12e0df67293c076b$export$93768eb72dec48ce = $12e0df67293c076b$export$501d46e11ed5bf73 + 10;
const $12e0df67293c076b$export$c0aec4e0896849a0 = $12e0df67293c076b$export$93768eb72dec48ce - 5;
const $12e0df67293c076b$export$5886f057e4f21fe4 = $12e0df67293c076b$export$6817b4b6a5ef78f1 + 5;
const $12e0df67293c076b$export$6e85faa46d537a3f = 11;
const $12e0df67293c076b$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $12e0df67293c076b$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $12e0df67293c076b$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $12e0df67293c076b$export$95e9a0285b97474d = '#2C333A';
const $12e0df67293c076b$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $12e0df67293c076b$export$76b5e653883e5290 = '3px';
const $12e0df67293c076b$export$6d85fe8177a50c0c = 0.5;
const $12e0df67293c076b$export$fad19f16d3f953a3 = 680;
const $12e0df67293c076b$export$9db045950eedb49f = 760;
const $12e0df67293c076b$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $12e0df67293c076b$export$f580e3d28d0986de = 1800;
const $12e0df67293c076b$export$9d5488b5afad62bf = 1792;
const $12e0df67293c076b$export$37df10057d36a0e5 = 42;
const $12e0df67293c076b$export$437293c5e9fc2703 = 96;
const $12e0df67293c076b$export$6e0f4d52efd3d2d = 32;
const $12e0df67293c076b$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $eGOwo.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $12e0df67293c076b$export$aae87d25ced827bb = 24;
const $12e0df67293c076b$export$cccda66937c91e4c = 600;
const $12e0df67293c076b$export$efe8561bbd3f74d2 = 720;
const $12e0df67293c076b$export$e4d39a9e8607c1d3 = 48;
const $12e0df67293c076b$export$43946f2400ab6f1f = 128;
const $12e0df67293c076b$export$558438ae7fd4b8ce = 12;
const $12e0df67293c076b$export$6beb98d32d4ca149 = 4;
const $12e0df67293c076b$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $12e0df67293c076b$export$5edb4f38c3eacb1a = 1024;
const $12e0df67293c076b$export$e60820063058ed59 = 1.33;
const $12e0df67293c076b$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $12e0df67293c076b$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $12e0df67293c076b$export$fb15fade89f67217 = $12e0df67293c076b$export$f35cc48f3398ab79 * 99;
const $12e0df67293c076b$export$847030921e9d5a40 = 12;
const $12e0df67293c076b$export$40eb41ab799f0329 = 1.714;
const $12e0df67293c076b$export$e271312fc7124aec = '1px';
const $12e0df67293c076b$export$d29cb2c31fcbb7c5 = 2;
const $12e0df67293c076b$export$688a6dc01e760755 = 320;
const $12e0df67293c076b$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $12e0df67293c076b$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $12e0df67293c076b$export$e88f6c898960b391 = $12e0df67293c076b$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $12e0df67293c076b$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $12e0df67293c076b$export$1d0d506416d457f1 = '0.75rem';
const $12e0df67293c076b$export$e683ef42725d1713 = 680;
const $12e0df67293c076b$export$226c784ba04bd04b = 480;
const $12e0df67293c076b$export$214ff00e5618d86c = 20;
const $12e0df67293c076b$export$c82675fa56f2eefd = '56px';
const $12e0df67293c076b$var$DEFAULT_FONT_SIZE = 14;
const $12e0df67293c076b$export$d7726a000ae2d7c = ()=>{
    // eslint-disable-next-line no-constant-condition
    if ((0, $92xoS.editorExperiment)('platform_editor_toolbar_aifc', true, {
        exposure: true
    }) && (0, $cbSL1.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true)) return '44px';
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    return "var(--ds-space-500, 40px)";
};
const $12e0df67293c076b$export$d1343597f3b52d83 = 40;
const $12e0df67293c076b$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $12e0df67293c076b$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $12e0df67293c076b$var$DEFAULT_FONT_SIZE;
const $12e0df67293c076b$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$12e0df67293c076b$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $12e0df67293c076b$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $12e0df67293c076b$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $12e0df67293c076b$export$9369fd010fa0ddd6 = 0;
const $12e0df67293c076b$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$12e0df67293c076b$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $12e0df67293c076b$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $12e0df67293c076b$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];
const $12e0df67293c076b$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
        svgBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)",
        svgBackgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    }
];

});

parcelRegister("1I3aa", function(module, exports) {
$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $63e3275bb42d0987$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $63e3275bb42d0987$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $63e3275bb42d0987$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $63e3275bb42d0987$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $63e3275bb42d0987$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $63e3275bb42d0987$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $63e3275bb42d0987$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $63e3275bb42d0987$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $63e3275bb42d0987$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $63e3275bb42d0987$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $63e3275bb42d0987$export$b4b560efd3c61856);
const $63e3275bb42d0987$export$5937600f4cc784f0 = 24;
const $63e3275bb42d0987$export$71d660e8ca5b8f73 = 320;
const $63e3275bb42d0987$export$cd11d7d46412c89b = 3;
const $63e3275bb42d0987$export$71482734bb54ac3 = 10;
const $63e3275bb42d0987$export$fd2b09475ada41cc = 12;
const $63e3275bb42d0987$export$8c5ac0b0c62a3d21 = 8;
const $63e3275bb42d0987$export$68d0abe4f03863fb = $63e3275bb42d0987$export$fd2b09475ada41cc * 2;
const $63e3275bb42d0987$export$d722b7527b1834a8 = 250;
const $63e3275bb42d0987$export$da894f7669b4e67c = 200;
const $63e3275bb42d0987$export$e13825c38da2ce1 = 100;
var $63e3275bb42d0987$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $63e3275bb42d0987$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $63e3275bb42d0987$export$4d41d008e9cd4f34 = 0.5;
const $63e3275bb42d0987$export$b4b560efd3c61856 = 'caption-placeholder';

});

parcelRegister("2zJxT", function(module, exports) {
$parcel$export(module.exports, "getMediaSinglePixelWidth", () => $80b986ec0541becf$export$a6f4ec2edd25b07e);
$parcel$export(module.exports, "calcMediaSinglePixelWidth", () => $80b986ec0541becf$export$5091b2c0d1cd2361);
$parcel$export(module.exports, "calcMediaSingleMaxWidth", () => $80b986ec0541becf$export$a2e7f6320d796a21);
$parcel$export(module.exports, "getMediaSingleInitialWidth", () => $80b986ec0541becf$export$4ab195f543459515);
$parcel$export(module.exports, "calculateOffsetLeft", () => $80b986ec0541becf$export$ab1f1890e4428242);
$parcel$export(module.exports, "roundToNearest", () => $80b986ec0541becf$export$f72673597dacfcfa);
$parcel$export(module.exports, "calcMinWidth", () => $80b986ec0541becf$export$c7eaa4d46a45395);
$parcel$export(module.exports, "getMaxWidthForNestedNode", () => $80b986ec0541becf$export$4147ff5cc31ec064);
$parcel$export(module.exports, "getMaxWidthForNestedNodeNext", () => $80b986ec0541becf$export$bcefe8f1d5d7bbf3);
$parcel$export(module.exports, "currentMediaNodeWithPos", () => $80b986ec0541becf$export$22e4c8c04f58169d);

var $3lIcL = parcelRequire("3lIcL");

var $7yBx7 = parcelRequire("7yBx7");

var $92xoS = parcelRequire("92xoS");

var $19zEl = parcelRequire("19zEl");

var $1I3aa = parcelRequire("1I3aa");
function $80b986ec0541becf$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $80b986ec0541becf$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $80b986ec0541becf$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $80b986ec0541becf$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $1I3aa.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $80b986ec0541becf$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $80b986ec0541becf$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $7yBx7.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $80b986ec0541becf$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullPagePadding = editorAppearance === 'full-page' && containerWidth <= (0, $7yBx7.akEditorFullPageNarrowBreakout) && (0, $92xoS.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7yBx7.akEditorGutterPaddingReduced) : (0, $7yBx7.akEditorGutterPaddingDynamic)();
    const fullWidthPadding = editorAppearance === 'full-page' ? fullPagePadding * 2 : (0, $7yBx7.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $7yBx7.akEditorFullWidthLayoutWidth));
};
const $80b986ec0541becf$export$4ab195f543459515 = (origWidth = (0, $1I3aa.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $7yBx7.akEditorDefaultLayoutWidth), minWidth = (0, $1I3aa.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $80b986ec0541becf$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $80b986ec0541becf$export$f72673597dacfcfa = (value, interval = (0, $1I3aa.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $80b986ec0541becf$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $1I3aa.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $1I3aa.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $80b986ec0541becf$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $19zEl.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $19zEl.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $80b986ec0541becf$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $80b986ec0541becf$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $80b986ec0541becf$export$7cc71489edfd26f8($pos, view) : $80b986ec0541becf$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $80b986ec0541becf$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $19zEl.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $80b986ec0541becf$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $80b986ec0541becf$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $80b986ec0541becf$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $80b986ec0541becf$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $3lIcL.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};

});
parcelRegister("19zEl", function(module, exports) {
$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $b3204125fc08effb$export$7cd5aab2c4f1fb1e);
$parcel$export(module.exports, "nonWrappedLayouts", () => $b3204125fc08effb$export$607795ead6e50626);
$parcel$export(module.exports, "floatingLayouts", () => $b3204125fc08effb$export$7c0073a4d21b222d);
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $b3204125fc08effb$export$55fb9d6810f2e04b);
$parcel$export(module.exports, "alignAttributes", () => $b3204125fc08effb$export$b2258912a400ba32);
$parcel$export(module.exports, "calculateSnapPoints", () => $b3204125fc08effb$export$de65085e667b4bf1);

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $24wSW = parcelRequire("24wSW");
const $b3204125fc08effb$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $24wSW.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $b3204125fc08effb$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $b3204125fc08effb$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $b3204125fc08effb$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $BmspC.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $b3204125fc08effb$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $b3204125fc08effb$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $b3204125fc08effb$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $24wSW.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $24wSW.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $b3204125fc08effb$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $b3204125fc08effb$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $24wSW.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $24wSW.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $7yBx7.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("24wSW", function(module, exports) {
$parcel$export(module.exports, "calcPxFromColumns", () => $41c0bcab9a8da41b$export$1e3701608f0cee80);
$parcel$export(module.exports, "calcColumnsFromPx", () => $41c0bcab9a8da41b$export$10912f14d8d54640);
$parcel$export(module.exports, "calcPctFromPx", () => $41c0bcab9a8da41b$export$55ddb36b3404ec6d);
$parcel$export(module.exports, "wrappedLayouts", () => $41c0bcab9a8da41b$export$405baca3d8bc263d);
$parcel$export(module.exports, "calcMediaPxWidth", () => $41c0bcab9a8da41b$export$5e51fc02b9ada5af);

var $7yBx7 = parcelRequire("7yBx7");

var $1I3aa = parcelRequire("1I3aa");
const $41c0bcab9a8da41b$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $41c0bcab9a8da41b$export$adfc02948d64a4f2 = (layout)=>$41c0bcab9a8da41b$var$validWidthModes.indexOf(layout) > -1;
function $41c0bcab9a8da41b$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
}
function $41c0bcab9a8da41b$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $41c0bcab9a8da41b$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
}
function $41c0bcab9a8da41b$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $41c0bcab9a8da41b$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $41c0bcab9a8da41b$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($41c0bcab9a8da41b$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $41c0bcab9a8da41b$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $41c0bcab9a8da41b$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $41c0bcab9a8da41b$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $7yBx7.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $7yBx7.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($41c0bcab9a8da41b$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $41c0bcab9a8da41b$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $41c0bcab9a8da41b$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $41c0bcab9a8da41b$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($41c0bcab9a8da41b$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $41c0bcab9a8da41b$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});



parcelRegister("jhKIq", function(module, exports) {
$parcel$export(module.exports, "MediaSingleDimensionHelper", () => $4e85bca9ec1dc949$export$2b2737a2ef2f5b46);
$parcel$export(module.exports, "MediaWrapper", () => $4e85bca9ec1dc949$export$542000db99cecf28);
$parcel$export(module.exports, "MediaBorderGapFiller", () => $4e85bca9ec1dc949$export$e18e95249d813157);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $fNh22 = parcelRequire("fNh22");

var $19zEl = parcelRequire("19zEl");

var $bnh3n = parcelRequire("bnh3n");
function $4e85bca9ec1dc949$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $4e85bca9ec1dc949$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7yBx7.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $7yBx7.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7yBx7.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $4e85bca9ec1dc949$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7yBx7.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $7yBx7.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7yBx7.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $4e85bca9ec1dc949$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $bnh3n.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $4e85bca9ec1dc949$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $4e85bca9ec1dc949$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(width, containerWidth) : $4e85bca9ec1dc949$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $4e85bca9ec1dc949$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $4e85bca9ec1dc949$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $4e85bca9ec1dc949$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $4e85bca9ec1dc949$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $4e85bca9ec1dc949$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.nodeType
 * @example
 */ var $4e85bca9ec1dc949$var$_ref = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $4e85bca9ec1dc949$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, nodeType: nodeType })=>{
    const calculatedWidth = $4e85bca9ec1dc949$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $4e85bca9ec1dc949$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $4e85bca9ec1dc949$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $4e85bca9ec1dc949$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $4e85bca9ec1dc949$var$calcMaxWidth(layout, containerWidth));
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $1NIU8.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $4e85bca9ec1dc949$var$_ref, "max-width:", (0, $fNh22.isSSR)() && !calculatedMaxWidth.endsWith('%') && (0, $eGOwo.fg)('platform_editor_fix_image_size_diff_during_ssr') ? Math.max(parseInt(calculatedWidth.replace('px', '')), parseInt(calculatedMaxWidth.replace('px', ''))) + 'px' : calculatedMaxWidth, ";", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $19zEl.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $4e85bca9ec1dc949$var$float(layout), ";margin:", $4e85bca9ec1dc949$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $19zEl.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $4e85bca9ec1dc949$var$isImageAligned(layout), ";");
};
const $4e85bca9ec1dc949$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $1NIU8.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $4e85bca9ec1dc949$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $1NIU8.css)("position:relative;", $4e85bca9ec1dc949$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-comment-badge='true'], [data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
const $4e85bca9ec1dc949$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $4e85bca9ec1dc949$export$9e3fd9f6215dd7b6(rest)
    }, children);
$4e85bca9ec1dc949$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $4e85bca9ec1dc949$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '1px'
        }
    });
};

});


const $9a762f515f769003$export$12fd658e5eef0d79 = 32;
const $9a762f515f769003$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';



parcelRegister("fNJLN", function(module, exports) {
$parcel$export(module.exports, "default", () => $183325db1cca8eeb$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6Tw9l = parcelRequire("6Tw9l");

var $2FwjZ = parcelRequire("2FwjZ");

var $dHHKP = parcelRequire("dHHKP");

var $5KYHN = parcelRequire("5KYHN");
/**
 * Synchronous renderer node mapping for media nodes
 *
 * WARNING: This is an EXPERIMENTAL entry point and may change without notice in the future. Use it only at your own risk!
 *
 * Context: https://hello.atlassian.net/wiki/spaces/JIE/pages/5342146338 (Atlassian-internal)
 */ const $183325db1cca8eeb$var$nodeToReact = {
    media: (0, $6Tw9l.default),
    mediaGroup: (0, $2FwjZ.default),
    mediaInline: (0, $dHHKP.default),
    mediaSingle: (0, $5KYHN.default)
};
var $183325db1cca8eeb$export$2e2bcd8739ae039 = $183325db1cca8eeb$var$nodeToReact;

});
parcelRegister("6Tw9l", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb7f1ffdadcf9370$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $e2B2h = parcelRequire("e2B2h");

var $eUaD0 = parcelRequire("eUaD0");

var $4sxxB = parcelRequire("4sxxB");

var $jhKIq = parcelRequire("jhKIq");

var $jMtSb = parcelRequire("jMtSb");

var $jxPcD = parcelRequire("jxPcD");

var $9Ybet = parcelRequire("9Ybet");

var $g9wjI = parcelRequire("g9wjI");

var $bMFKb = parcelRequire("bMFKb");
var $9XXFf = parcelRequire("9XXFf");

var $eGOwo = parcelRequire("eGOwo");

var $7ueoK = parcelRequire("7ueoK");

var $fpMtm = parcelRequire("fpMtm");

var $11jfh = parcelRequire("11jfh");
var $a61Rj = parcelRequire("a61Rj");
var $avOy4 = parcelRequire("avOy4");
var $88noB = parcelRequire("88noB");

var $6YFG2 = parcelRequire("6YFG2");

var $8QIFO = parcelRequire("8QIFO");

var $eq5No = parcelRequire("eq5No");

var $4Fc33 = parcelRequire("4Fc33");

var $e2m7L = parcelRequire("e2m7L");
function $cb7f1ffdadcf9370$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cb7f1ffdadcf9370$var$linkStyle = {
    name: "14m5vmv",
    styles: "position:absolute;background:transparent;top:0;right:0;bottom:0;left:0;cursor:pointer;width:100% !important;height:100% !important"
};
const $cb7f1ffdadcf9370$var$borderStyle = {
    name: "10uwk9w",
    styles: "position:absolute;width:100% !important;height:100% !important"
};
const $cb7f1ffdadcf9370$var$MediaBorder = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    const borderColor = mark?.attrs.color ?? '';
    const borderWidth = mark?.attrs.size ?? 0;
    const paletteColorValue = (0, $9Ybet.hexToEditorBorderPaletteColor)(borderColor) || borderColor;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-mark-type": "border",
        "data-color": borderColor,
        "data-size": borderWidth,
        css: $cb7f1ffdadcf9370$var$borderStyle,
        style: {
            borderRadius: `${borderWidth}px`,
            boxShadow: `0 0 0 ${borderWidth}px ${paletteColorValue}`
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jhKIq.MediaBorderGapFiller), {
        borderColor: borderColor
    }), children);
};
const $cb7f1ffdadcf9370$var$MediaLink = ({ mark: mark, children: children, onClick: onClick })=>{
    if (!mark) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    const linkHref = mark?.attrs.href;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $1NIU8.jsx)("a", {
        href: linkHref,
        rel: "noreferrer noopener",
        onClick: onClick,
        "data-block-link": linkHref,
        css: $cb7f1ffdadcf9370$var$linkStyle
    }, children));
};
const $cb7f1ffdadcf9370$var$MediaAnnotation = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fpMtm.default), {
        id: mark.attrs.id,
        annotationType: mark.attrs.annotationType,
        dataAttributes: {
            'data-renderer-mark': true,
            'data-block-mark': true
        },
        // This should be fine being empty [] since the serializer serializeFragmentChild getMarkProps call always passes
        annotationParentIds: [],
        allowAnnotations: true,
        useBlockLevel: true
    }, children);
};
const $cb7f1ffdadcf9370$var$MediaAnnotations = ({ marks: marks = [], children: children })=>{
    // Early Exit
    if (marks.length === 0) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    // Recursive marks
    const currentMark = marks[0];
    const otherMarks = marks.slice(1);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaAnnotation, {
        key: currentMark.attrs.id,
        mark: currentMark
    }, otherMarks.length ? /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaAnnotations, {
        marks: otherMarks
    }, children) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children)));
};
const $cb7f1ffdadcf9370$var$CommentBadge = (0, $6YFG2.default)((0, $11jfh.CommentBadge));
const $cb7f1ffdadcf9370$var$CommentBadgeWrapper = ({ marks: marks, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false, ...rest })=>{
    const [status, setStatus] = (0, $eJOHy.useState)('default');
    const [entered, setEntered] = (0, $eJOHy.useState)(false);
    const updateSubscriber = (0, $eq5No.useInlineCommentSubscriberContext)();
    const activeParentIds = (0, $8QIFO.useInlineCommentsFilter)({
        annotationIds: marks?.map((mark)=>mark.attrs.id) ?? [
            ''
        ],
        filter: {
            state: (0, $jxPcD.AnnotationMarkStates).ACTIVE
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        const observer = new MutationObserver((mutationList)=>{
            mutationList.forEach((mutation)=>{
                const parentNode = mutation.target.parentNode;
                if (mutation.attributeName === 'data-has-focus') {
                    const isMediaCaption = parentNode?.closest('[data-media-caption="true"]');
                    const elementHasFocus = parentNode?.querySelector('[data-has-focus="true"]') && !isMediaCaption;
                    elementHasFocus ? setStatus('active') : setStatus('default');
                }
            });
        });
        if (mediaSingleElement) observer.observe(mediaSingleElement, {
            attributes: true,
            subtree: true,
            attributeFilter: [
                'data-has-focus'
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement,
        setStatus
    ]);
    if (!isDrafting && !activeParentIds.length) return null;
    const onClick = (e)=>{
        e.preventDefault();
        if (updateSubscriber) updateSubscriber.emit((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeParentIds,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            eventTarget: e.target,
            // use mediaSingle here to align with annotation viewed event dispatched in editor
            eventTargetType: 'mediaSingle',
            viewMethod: (0, $9XXFf.VIEW_METHOD).BADGE
        });
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$CommentBadge, {
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        status: entered ? 'entered' : status,
        onClick: onClick,
        ...rest
    });
};
const $cb7f1ffdadcf9370$var$CommentBadgeNextWrapper = ({ marks: marks, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false, ...rest })=>{
    const [status, setStatus] = (0, $eJOHy.useState)('default');
    const [entered, setEntered] = (0, $eJOHy.useState)(false);
    const updateSubscriber = (0, $eq5No.useInlineCommentSubscriberContext)();
    const activeParentIds = (0, $8QIFO.useInlineCommentsFilter)({
        annotationIds: marks?.map((mark)=>mark.attrs.id) ?? [
            ''
        ],
        filter: {
            state: (0, $jxPcD.AnnotationMarkStates).ACTIVE
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        const observer = new MutationObserver((mutationList)=>{
            mutationList.forEach((mutation)=>{
                const parentNode = mutation.target.parentNode;
                if (mutation.attributeName === 'data-has-focus') {
                    const isMediaCaption = parentNode?.closest('[data-media-caption="true"]');
                    const elementHasFocus = parentNode?.querySelector('[data-has-focus="true"]') && !isMediaCaption;
                    elementHasFocus ? setStatus('active') : setStatus('default');
                }
            });
        });
        if (mediaSingleElement) observer.observe(mediaSingleElement, {
            attributes: true,
            subtree: true,
            attributeFilter: [
                'data-has-focus'
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement,
        setStatus
    ]);
    if (!isDrafting && !activeParentIds.length) return null;
    const onClick = (e)=>{
        e.preventDefault();
        if (updateSubscriber) updateSubscriber.emit((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeParentIds,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            eventTarget: e.target,
            // use mediaSingle here to align with annotation viewed event dispatched in editor
            eventTargetType: 'mediaSingle',
            viewMethod: (0, $9XXFf.VIEW_METHOD).BADGE
        });
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $a61Rj.CommentBadgeNext), {
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        status: entered ? 'entered' : status,
        onClick: onClick,
        mediaSingleElement: mediaSingleElement,
        ...rest
    });
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $cb7f1ffdadcf9370$var$Media extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.renderCard = (providers = {})=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { allowAltTextOnImages: allowAltTextOnImages, alt: alt, featureFlags: featureFlags, shouldOpenMediaViewer: allowMediaViewer, enableDownloadButton: enableDownloadButton, ssr: ssr, width: width, height: height, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false } = this.props;
            const annotationMarks = this.props.isAnnotationMark ? this.props.marks.filter(this.props.isAnnotationMark) : undefined;
            const borderMark = this.props.marks.find(this.props.isBorderMark);
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const eventHandlers = linkHref ? undefined : this.props.eventHandlers;
            const shouldOpenMediaViewer = !linkHref && allowMediaViewer;
            const isInPageInclude = mediaSingleElement?.closest('[data-node-type="include"]');
            const isIncludeExcerpt = !!mediaSingleElement?.closest('.ak-excerpt-include');
            const showCommentBadge = !!annotationMarks && !isInPageInclude && !isIncludeExcerpt;
            return /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaLink, {
                mark: linkMark,
                onClick: this.handleMediaLinkClickFn
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaAnnotations, {
                marks: annotationMarks
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$MediaBorder, {
                mark: borderMark
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
                data: {
                    [(0, $eUaD0.MEDIA_CONTEXT)]: {
                        border: !!borderMark
                    }
                }
            }, (0, $eGOwo.fg)('platform_editor_add_media_from_url_rollout') && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $88noB.MediaBadges), {
                mediaElement: mediaSingleElement,
                mediaWidth: width,
                mediaHeight: height,
                useMinimumZIndex: true
            }, ({ visible: visible })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, visible && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avOy4.ExternalImageBadge), {
                    type: this.props.type,
                    url: this.props.type === 'external' ? this.props.url : undefined
                }), showCommentBadge && /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$CommentBadgeNextWrapper, {
                    marks: annotationMarks,
                    mediaSingleElement: mediaSingleElement,
                    isDrafting: isDrafting
                }))), !(0, $eGOwo.fg)('platform_editor_add_media_from_url_rollout') && showCommentBadge && /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$CommentBadgeWrapper, {
                marks: annotationMarks,
                mediaSingleElement: mediaSingleElement,
                width: width,
                height: height,
                isDrafting: isDrafting
            }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jMtSb.MediaCard), {
                contextIdentifierProvider: contextIdentifierProvider,
                ...this.props,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                eventHandlers: eventHandlers,
                alt: allowAltTextOnImages ? alt : undefined,
                featureFlags: featureFlags,
                shouldEnableDownloadButton: enableDownloadButton,
                ssr: ssr
            })))));
        }, this.handleMediaLinkClick = (event)=>{
            const { fireAnalyticsEvent: fireAnalyticsEvent, isLinkMark: isLinkMark, marks: marks } = this.props;
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).VISITED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).LINK,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB,
                    mode: (0, $7ueoK.MODE).RENDERER
                }
            });
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const handler = (0, $g9wjI.getEventHandler)(this.props.eventHandlers, 'link');
            if (handler) {
                const linkMark = marks.find(isLinkMark);
                handler(event, linkMark && linkHref);
            }
        };
        this.handleMediaLinkClickFn = this.handleMediaLinkClick.bind(this);
    }
    render() {
        const { providers: providers } = this.props;
        if (!providers) return this.renderCard();
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4sxxB.WithProviders), {
            providers: [
                'mediaProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: providers,
            renderNode: this.renderCard
        });
    }
}
const $cb7f1ffdadcf9370$var$MediaWithDraftAnnotation = (props)=>{
    const { hoverDraftDocumentPosition: draftPosition } = (0, $e2m7L.useAnnotationRangeState)();
    const { dataAttributes: dataAttributes } = props;
    const pos = dataAttributes && dataAttributes['data-renderer-start-pos'];
    const [position, setPosition] = (0, $eJOHy.useState)();
    const [shouldApplyDraftAnnotation, setShouldApplyDraftAnnotation] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (pos === undefined) return;
        const posToCheck = (draftPosition?.from ?? 0) + 1;
        if (draftPosition !== null && posToCheck === pos) {
            setShouldApplyDraftAnnotation(true);
            setPosition(posToCheck);
        } else if (draftPosition === null && shouldApplyDraftAnnotation) {
            setShouldApplyDraftAnnotation(false);
            setPosition(undefined);
        }
    }, [
        draftPosition,
        pos,
        shouldApplyDraftAnnotation
    ]);
    const applyDraftAnnotation = props.allowAnnotationsDraftMode && shouldApplyDraftAnnotation && position !== undefined;
    const dataAttributesWithDraftAnnotation = (0, $eJOHy.useMemo)(()=>applyDraftAnnotation ? {
            ...dataAttributes,
            'data-annotation-draft-mark': true,
            'data-renderer-mark': true
        } : dataAttributes, [
        applyDraftAnnotation,
        dataAttributes
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($cb7f1ffdadcf9370$var$Media, {
        ...props,
        dataAttributes: dataAttributesWithDraftAnnotation,
        isDrafting: shouldApplyDraftAnnotation
    });
};
var $cb7f1ffdadcf9370$export$2e2bcd8739ae039 = $cb7f1ffdadcf9370$var$MediaWithDraftAnnotation;

});
parcelRegister("jMtSb", function(module, exports) {
$parcel$export(module.exports, "mediaIdentifierMap", () => $82c3186f94959555$export$7da2d00ddd5627a6);
$parcel$export(module.exports, "getClipboardAttrs", () => $82c3186f94959555$export$92bef806f5be5d7c);
$parcel$export(module.exports, "MediaCard", () => $82c3186f94959555$export$a6543a2e3828db2c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fpoq4 = parcelRequire("fpoq4");

var $eGOwo = parcelRequire("eGOwo");

var $dcbV5 = parcelRequire("dcbV5");
var $5Ittp = parcelRequire("5Ittp");
var $bmpmu = parcelRequire("bmpmu");
var $lMEDC = parcelRequire("lMEDC");

var $93R6D = parcelRequire("93R6D");

var $5s6bt = parcelRequire("5s6bt");
const $82c3186f94959555$export$7da2d00ddd5627a6 = new Map();
const $82c3186f94959555$export$e689a46890560dbd = (doc)=>{
    if (!doc) return [];
    return (0, $fpoq4.filter)(doc, (node)=>node.type === 'media').reduce((identifierList, mediaNode)=>{
        if (mediaNode.attrs) {
            const { type: type, url: dataURI, id: id } = mediaNode.attrs;
            if (type === 'file' && id) identifierList.push({
                mediaItemType: 'file',
                id: id
            });
            else if (type === 'external' && dataURI) identifierList.push({
                mediaItemType: 'external-image',
                dataURI: dataURI,
                name: dataURI
            });
        }
        return identifierList;
    }, []);
};
class $82c3186f94959555$export$cfff5eb155a82d30 extends (0, $eJOHy.Component) {
    async componentDidMount() {
        const { rendererContext: rendererContext, contextIdentifierProvider: contextIdentifierProvider, id: id, url: url, collection: collectionName } = this.props;
        if (contextIdentifierProvider) this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        const nodeIsInCache = id && $82c3186f94959555$export$7da2d00ddd5627a6.has(id) || url && $82c3186f94959555$export$7da2d00ddd5627a6.has(url);
        if (rendererContext && rendererContext.adDoc && !nodeIsInCache) $82c3186f94959555$export$e689a46890560dbd(rendererContext.adDoc).forEach((identifier)=>{
            if (identifier.mediaItemType === 'file' && identifier.id === id) $82c3186f94959555$export$7da2d00ddd5627a6.set(identifier.id, {
                ...identifier,
                collectionName: collectionName
            });
            else if (identifier.mediaItemType === 'external-image') $82c3186f94959555$export$7da2d00ddd5627a6.set(identifier.dataURI, identifier);
        });
        if (id) this.saveFileState(id);
    }
    componentDidUpdate(prevProps) {
        const { id: oldId } = prevProps;
        if (this.props.id && oldId !== this.props.id) this.saveFileState(this.props.id);
    }
    componentWillUnmount() {
        const { id: id, url: dataURI } = this.props;
        if (id) $82c3186f94959555$export$7da2d00ddd5627a6.delete(id);
        else if (dataURI) $82c3186f94959555$export$7da2d00ddd5627a6.delete(dataURI);
    }
    renderExternal(shouldOpenMediaViewer) {
        const { cardDimensions: cardDimensions, resizeMode: resizeMode, appearance: appearance, url: url, imageStatus: imageStatus, disableOverlay: disableOverlay, alt: alt, featureFlags: featureFlags, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes, enableSyncMediaCard: enableSyncMediaCard, localId: localId } = this.props;
        if (imageStatus === 'loading' || !url) return this.renderLoadingCard();
        const identifier = {
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        };
        // we need this statement for the mandatory mediaClientConfig below
        const mediaClientConfig = mediaClient?.mediaClientConfig;
        const Card = enableSyncMediaCard && (0, $eGOwo.fg)('jfp-magma-ssr-iv-editor-media') ? (0, $lMEDC.default) : (0, $dcbV5.default);
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ...dataAttributes,
            "data-node-type": "media",
            "data-local-id": localId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Card, {
                // TODO: MPT-315 - clean up after we move mediaClientConfig into FileIdentifier
                // context is not really used when the type is external and we want to render the component asap
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mediaClientConfig: mediaClientConfig,
                alt: alt,
                identifier: identifier,
                dimensions: cardDimensions,
                appearance: appearance,
                resizeMode: resizeMode,
                disableOverlay: disableOverlay,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($82c3186f94959555$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                ssr: ssr?.mode,
                shouldHideTooltip: false
            })
        }));
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, fileState: fileState } = this.state;
        const { id: id, alt: alt, type: type, collection: collection, occurrenceKey: occurrenceKey, cardDimensions: cardDimensions, resizeMode: resizeMode, disableOverlay: disableOverlay, useInlinePlayer: useInlinePlayer, originalDimensions: originalDimensions, shouldOpenMediaViewer: forceOpenMediaViewer, featureFlags: featureFlags, shouldEnableDownloadButton: shouldEnableDownloadButton, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes, enableSyncMediaCard: enableSyncMediaCard, localId: localId } = this.props;
        const isMobile = false;
        const shouldPlayInline = useInlinePlayer !== undefined ? useInlinePlayer : true;
        const isInlinePlayer = isMobile ? false : shouldPlayInline;
        const onCardClick = this.getOnCardClickCallback(isInlinePlayer);
        const shouldOpenMediaViewer = typeof forceOpenMediaViewer === 'boolean' ? forceOpenMediaViewer : !isMobile && !onCardClick;
        if (type === 'external') return this.renderExternal(shouldOpenMediaViewer);
        if (type === 'link') return null;
        const mediaClientConfig = !!ssr ? ssr.config : mediaClient?.mediaClientConfig;
        if (!mediaClientConfig || !id) return this.renderLoadingCard();
        if (!id || type !== 'file') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5Ittp.CardError), {
            dimensions: cardDimensions
        });
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = {
            id: id,
            mediaItemType: 'file',
            collectionName: collection,
            occurrenceKey: occurrenceKey
        };
        const Card = enableSyncMediaCard && (0, $eGOwo.fg)('jfp-magma-ssr-iv-editor-media') ? (0, $lMEDC.default) : (0, $dcbV5.default);
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ...$82c3186f94959555$export$92bef806f5be5d7c({
                id: id,
                alt: alt,
                collection: collection,
                contextIdentifierProvider: contextIdentifierProvider,
                originalDimensions: originalDimensions,
                fileState: fileState
            }),
            ...dataAttributes,
            "data-local-id": localId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Card, {
                identifier: identifier,
                alt: alt,
                contextId: contextId,
                mediaClientConfig: mediaClientConfig,
                dimensions: cardDimensions,
                originalDimensions: originalDimensions,
                onClick: onCardClick,
                resizeMode: resizeMode,
                isLazy: !isMobile,
                disableOverlay: disableOverlay,
                useInlinePlayer: isInlinePlayer,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($82c3186f94959555$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                shouldEnableDownloadButton: shouldEnableDownloadButton,
                ssr: ssr?.mode,
                shouldHideTooltip: isMobile
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {}, this.saveFileState = async (id)=>{
            const { collection: collectionName, mediaClient: mediaClient } = this.props;
            const options = {
                collectionName: collectionName
            };
            try {
                if (mediaClient) {
                    const fileState = await mediaClient.file.getCurrentState(id, options);
                    this.setState({
                        fileState: fileState
                    });
                }
            } catch (error) {
            // do not set state on error
            }
        }, this.renderLoadingCard = ()=>{
            const { cardDimensions: cardDimensions } = this.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmpmu.CardLoading), {
                dimensions: cardDimensions,
                interactionName: "renderer-media-card-loading"
            });
        }, /**
	 * We want to call provided `eventHandlers.media.onClick` when it's provided,
	 * but we also don't want to call it when it's a video and inline video player is enabled.
	 * This is due to consumers normally process this onClick call by opening media viewer and
	 * we don't want that to happened described above text.
	 */ this.getOnCardClickCallback = (isInlinePlayer)=>{
            const { eventHandlers: eventHandlers } = this.props;
            if (eventHandlers && eventHandlers.media && eventHandlers.media.onClick) return (result, analyticsEvent)=>{
                const isVideo = result.mediaItemDetails && result.mediaItemDetails.mediaType === 'video';
                const isVideoWithInlinePlayer = isInlinePlayer && isVideo;
                if (!isVideoWithInlinePlayer && eventHandlers && eventHandlers.media && eventHandlers.media.onClick) eventHandlers.media.onClick(result, analyticsEvent);
            };
            return undefined;
        };
    }
}
const $82c3186f94959555$export$92bef806f5be5d7c = ({ id: id, alt: alt, collection: collection, contextIdentifierProvider: contextIdentifierProvider, originalDimensions: originalDimensions, fileState: fileState })=>{
    const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
    const width = originalDimensions && originalDimensions.width;
    const height = originalDimensions && originalDimensions.height;
    let fileName = 'file'; // default name is needed for Confluence
    let fileSize = 1;
    let fileMimeType = '';
    if (fileState && fileState.status !== 'error') {
        fileSize = fileState.size;
        fileName = fileState.name;
        fileMimeType = fileState.mimeType;
    }
    return {
        'data-context-id': contextId,
        'data-type': 'file',
        'data-node-type': 'media',
        'data-width': width,
        'data-height': height,
        'data-id': id,
        'data-collection': collection,
        'data-file-name': fileName,
        'data-file-size': fileSize,
        'data-file-mime-type': fileMimeType,
        'data-alt': alt
    };
};
const $82c3186f94959555$export$fae4803d1ca121c8 = (props)=>{
    const mediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)($82c3186f94959555$export$cfff5eb155a82d30, {
        ...props,
        mediaClient: mediaClient
    });
};
const $82c3186f94959555$export$a6543a2e3828db2c = (0, $5s6bt.withImageLoader)($82c3186f94959555$export$fae4803d1ca121c8);

});
parcelRegister("fpoq4", function(module, exports) {
$parcel$export(module.exports, "filter", () => $01d8b182e291a8c9$export$3dea766d36a8935f);

var $0mclG = parcelRequire("0mclG");
function $01d8b182e291a8c9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $0mclG.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});

parcelRegister("dcbV5", function(module, exports) {
$parcel$export(module.exports, "default", () => $440702c4dbb2b839$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $bmpmu = parcelRequire("bmpmu");

var $6FOAB = parcelRequire("6FOAB");
const $440702c4dbb2b839$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
const $440702c4dbb2b839$var$CardLoadingWithContext = ()=>{
    const props = (0, $eJOHy.useContext)($440702c4dbb2b839$var$MediaCardContext);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmpmu.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

const $440702c4dbb2b839$var$MediaCardWithMediaClientProvider = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>Promise.resolve((parcelRequire("a7bVf"))).then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($440702c4dbb2b839$var$CardLoadingWithContext, {})
});
const $440702c4dbb2b839$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6FOAB.default), {
        name: "media-card",
        mode: "list",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($440702c4dbb2b839$var$MediaCardContext.Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($440702c4dbb2b839$var$MediaCardWithMediaClientProvider, {
                ...props
            })
        })
    });
};
$440702c4dbb2b839$var$CardLoader.preload = ()=>$440702c4dbb2b839$var$MediaCardWithMediaClientProvider.preload();
var $440702c4dbb2b839$export$2e2bcd8739ae039 = $440702c4dbb2b839$var$CardLoader;

});
parcelRegister("bmpmu", function(module, exports) {
$parcel$export(module.exports, "CardLoading", () => $db1ec8ca7bffe853$export$5d25853fd6bdf402);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $28sr0 = parcelRequire("28sr0");

var $lWr6W = parcelRequire("lWr6W");

var $7ep4S = parcelRequire("7ep4S");
class $db1ec8ca7bffe853$export$5d25853fd6bdf402 extends (0, $eJOHy.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = this.props;
        const dimensions = (0, $28sr0.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lWr6W.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                interactionName: interactionName || 'media-card-loading'
            })
        });
    }
}

});
parcelRegister("28sr0", function(module, exports) {
$parcel$export(module.exports, "getDimensionsWithDefault", () => $61071ab5121234d6$export$36acad525b1fb57b);
const $61071ab5121234d6$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("lWr6W", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $e9eebb219ee337c1$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $5Jy1o = parcelRequire("5Jy1o");
const $e9eebb219ee337c1$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $5Jy1o.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("5Jy1o", function(module, exports) {
$parcel$export(module.exports, "wrapperStyles", () => $f348d9bfdd9d67d9$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $iYfp4 = parcelRequire("iYfp4");

const $f348d9bfdd9d67d9$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $iYfp4.center), {
        background: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$export$8754fc7e6d8b3000)})`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $iYfp4.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("iYfp4", function(module, exports) {
$parcel$export(module.exports, "ellipsis", () => $63bf6031dd7cc765$export$a5b94313d6908893);
$parcel$export(module.exports, "size", () => $63bf6031dd7cc765$export$346677f925de839c);
$parcel$export(module.exports, "center", () => $63bf6031dd7cc765$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $63bf6031dd7cc765$export$7a57f79000377ca2);
const $63bf6031dd7cc765$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $63bf6031dd7cc765$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $63bf6031dd7cc765$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $63bf6031dd7cc765$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $63bf6031dd7cc765$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $63bf6031dd7cc765$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $63bf6031dd7cc765$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});





parcelRegister("5Ittp", function(module, exports) {
$parcel$export(module.exports, "CardError", () => $ab93af2b85cbe70e$export$f7f7efdefcc02999);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $s1DYz = parcelRequire("s1DYz");

var $lWr6W = parcelRequire("lWr6W");

var $28sr0 = parcelRequire("28sr0");
class $ab93af2b85cbe70e$export$f7f7efdefcc02999 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            size: 'medium'
        };
    }
    render() {
        const dimensions = (0, $28sr0.getDimensionsWithDefault)(this.props.dimensions);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lWr6W.Wrapper), {
            dimensions: dimensions,
            children: this.icon
        });
    }
    get icon() {
        const { size: size } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $s1DYz.ErrorIcon), {
            size: size
        });
    }
}

});
parcelRegister("s1DYz", function(module, exports) {
$parcel$export(module.exports, "ErrorIcon", () => $1bf51cf07c3bbe77$export$19bc16ee58e19b3d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $88oIq = parcelRequire("88oIq");

var $fetIp = parcelRequire("fetIp");
class $1bf51cf07c3bbe77$export$19bc16ee58e19b3d extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            size: 'small'
        };
    }
    render() {
        const { size: size } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: (0, $fetIp.errorIconWrapperStyles)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($88oIq))), {
            color: "currentColor",
            label: "Error",
            LEGACY_size: size
        })));
    }
}

});
parcelRegister("88oIq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::010e4a044c21a644c0b907c418c4e39c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ec23e149a3635ad$var$_react = $5ec23e149a3635ad$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5ec23e149a3635ad$var$_statusWarning = $5ec23e149a3635ad$var$_interopRequireDefault((parcelRequire("d8UFE")));

var $5ec23e149a3635ad$var$_warning = $5ec23e149a3635ad$var$_interopRequireDefault((parcelRequire("78Hx3")));
function $5ec23e149a3635ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ec23e149a3635ad$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $5ec23e149a3635ad$var$_react.default.createElement($5ec23e149a3635ad$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $5ec23e149a3635ad$var$_warning.default
    }, props));
$5ec23e149a3635ad$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $5ec23e149a3635ad$var$_default = module.exports.default = $5ec23e149a3635ad$var$StatusWarningIcon;

});
parcelRegister("78Hx3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $532b0c56cbaaba87$var$_react = $532b0c56cbaaba87$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $532b0c56cbaaba87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $532b0c56cbaaba87$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $532b0c56cbaaba87$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props));
$532b0c56cbaaba87$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $532b0c56cbaaba87$var$_default = module.exports.default = $532b0c56cbaaba87$var$EditorWarningIcon;

});


parcelRegister("fetIp", function(module, exports) {
$parcel$export(module.exports, "errorIconWrapperStyles", () => $0802496f61d134d4$export$8dcf6b831a37de79);
function $0802496f61d134d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0802496f61d134d4$export$8dcf6b831a37de79 = {
    name: "1fo963f",
    styles: "display:flex;color:var(--ds-icon-warning, #ff991f)"
};

});



parcelRegister("lMEDC", function(module, exports) {
$parcel$export(module.exports, "default", () => $adda7dd1446fd649$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6FOAB = parcelRequire("6FOAB");

var $a7bVf = parcelRequire("a7bVf");
const $adda7dd1446fd649$var$CardSync = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6FOAB.default), {
        name: "media-card-sync",
        mode: "list",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $a7bVf.CardWithMediaClient), {
            ...props
        })
    });
};
var $adda7dd1446fd649$export$2e2bcd8739ae039 = $adda7dd1446fd649$var$CardSync;

});
parcelRegister("a7bVf", function(module, exports) {
$parcel$export(module.exports, "CardWithMediaClient", () => $56700534e45de74d$export$91b1a6414631318a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cu5Ae = parcelRequire("cu5Ae");
var $4grWi = parcelRequire("4grWi");

var $bmp3w = parcelRequire("bmp3w");

var $8c47P = parcelRequire("8c47P");

var $eGOwo = parcelRequire("eGOwo");
const $56700534e45de74d$export$91b1a6414631318a = (props)=>{
    const { dimensions: dimensions, onClick: onClick } = props;
    const Card = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if ((0, $eGOwo.fg)('platform_media_video_captions')) return (0, $4grWi.withMediaClientAndSettings)((0, $8c47P.Card));
        return (0, $cu5Ae.withMediaClient)((0, $8c47P.Card));
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bmp3w.default), {
        dimensions: dimensions,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Card, {
            ...props
        })
    });
};

});
parcelRegister("cu5Ae", function(module, exports) {
$parcel$export(module.exports, "withMediaClient", () => $5bfc4058bddc627f$export$9f7977d4a2561bee);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");
const $5bfc4058bddc627f$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        });

});
parcelRegister("93R6D", function(module, exports) {
$parcel$export(module.exports, "MediaClientContext", () => $c470ce77068e97aa$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $c470ce77068e97aa$export$5bff351c86f56d97);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");
const $c470ce77068e97aa$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $c470ce77068e97aa$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($c470ce77068e97aa$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});
parcelRegister("aRuva", function(module, exports) {
$parcel$export(module.exports, "getMediaClient", () => $3430d7925e0b0890$export$c9ecbc1b719fd417);

var $e33YM = parcelRequire("e33YM");
const $3430d7925e0b0890$export$f92e83e86b03c398 = new Map();
const $3430d7925e0b0890$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $e33YM.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $3430d7925e0b0890$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $e33YM.MediaClient)(mediaClientConfig);
        $3430d7925e0b0890$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});



parcelRegister("4grWi", function(module, exports) {
$parcel$export(module.exports, "withMediaClientAndSettings", () => $e7827314b7ac3ee1$export$ea8f1b8e2d843039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");

var $f7iZ0 = parcelRequire("f7iZ0");

var $lMkQs = parcelRequire("lMkQs");
const $e7827314b7ac3ee1$var$MediaContextConsumer = ({ Component: Component, otherProps: otherProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7iZ0.MediaContext).Consumer, {
        children: (mediaProviderValue)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...otherProps,
                mediaClient: mediaProviderValue?.mediaClient,
                mediaSettings: mediaProviderValue?.settings
            })
    });
const $e7827314b7ac3ee1$export$ea8f1b8e2d843039 = (Component)=>({ mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings, ...otherProps })=>{
        const parsedSettings = (0, $lMkQs.useMediaParsedSettings)(mediaSettings);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7iZ0.MediaContext).Consumer, {
            children: (outterMediaProviderValue)=>{
                // If there is a MediaProvider up in the tree, use the top mediaClient and merge settings
                if (outterMediaProviderValue) {
                    const mergedParsedSettings = {
                        ...outterMediaProviderValue.settings,
                        ...parsedSettings
                    };
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7iZ0.MediaContext).Provider, {
                        value: {
                            mediaClient: outterMediaProviderValue.mediaClient,
                            settings: mergedParsedSettings
                        },
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)($e7827314b7ac3ee1$var$MediaContextConsumer, {
                            Component: Component,
                            otherProps: otherProps
                        })
                    });
                }
                // Otherwise, check if there is a MediaClientProvider up in the tree
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
                    children: (mediaClientProviderValue)=>// If there is a MediaClientProvider, we reinject the mediaClient and mediaSettings into a new MediaProvider
                        mediaClientProviderValue ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7iZ0.MediaContext).Provider, {
                            value: {
                                mediaClient: mediaClientProviderValue,
                                settings: parsedSettings
                            },
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)($e7827314b7ac3ee1$var$MediaContextConsumer, {
                                Component: Component,
                                otherProps: otherProps
                            })
                        }) : // If no poviders found, we mount a MediaProvider and inject the given props mediaClientConfig and mediaSettings
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7iZ0.MediaProvider), {
                            mediaClientConfig: mediaClientConfig,
                            mediaSettings: mediaSettings,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)($e7827314b7ac3ee1$var$MediaContextConsumer, {
                                Component: Component,
                                otherProps: otherProps
                            })
                        })
                });
            }
        });
    };

});
parcelRegister("f7iZ0", function(module, exports) {
$parcel$export(module.exports, "MediaContext", () => $b977b15c2bc7301b$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $b977b15c2bc7301b$export$57164260bc1f1218);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");

var $lMkQs = parcelRequire("lMkQs");
const $b977b15c2bc7301b$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $b977b15c2bc7301b$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $lMkQs.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b977b15c2bc7301b$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("lMkQs", function(module, exports) {
$parcel$export(module.exports, "useMediaParsedSettings", () => $e0ef7db6f81da61d$export$d54af28440a5efc0);

var $eJOHy = parcelRequire("eJOHy");

var $4iDQM = parcelRequire("4iDQM");
const $e0ef7db6f81da61d$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $eJOHy.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $4iDQM.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("4iDQM", function(module, exports) {
$parcel$export(module.exports, "defaultMediaUserPreferences", () => $fd3af50559080092$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $fd3af50559080092$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $fd3af50559080092$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($fd3af50559080092$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $fd3af50559080092$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $fd3af50559080092$export$2d23ed2854ac1650 = $fd3af50559080092$export$7e209e67b965bc63($fd3af50559080092$var$defaultUserPreferences);

});




parcelRegister("bmp3w", function(module, exports) {
$parcel$export(module.exports, "default", () => $9557304c21bcbe9e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aV4Nu = parcelRequire("aV4Nu");

var $QseaA = parcelRequire("QseaA");

var $4J0ad = parcelRequire("4J0ad");

var $dUG6w = parcelRequire("dUG6w");
class $9557304c21bcbe9e$var$WrappedMediaCardAnalyticsErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props), this.fireOperationalEvent = (error, info)=>{
            const { data: data = {}, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const payload = {
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'mediaCardRender',
                attributes: {
                    browserInfo: window?.navigator?.userAgent ? window.navigator.userAgent : 'unknown',
                    error: error,
                    info: info,
                    failReason: 'unexpected-error',
                    ...data
                }
            };
            (0, $dUG6w.fireMediaCardEvent)(payload, createAnalyticsEvent);
        }, this.handleOnClick = (event)=>{
            try {
                this.props.onClick?.({
                    event: event
                });
            } catch (e) {}
        };
        this.state = {
            hasError: false
        };
    }
    static{
        this.displayName = 'MediaCardAnalyticsErrorBoundary';
    }
    componentDidCatch(error, info) {
        try {
            this.fireOperationalEvent(error, info);
        } catch (e) {}
        this.setState({
            hasError: true
        });
    }
    render() {
        const { hasError: hasError } = this.state;
        const { dimensions: dimensions, children: children } = this.props;
        if (hasError) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $QseaA.UnhandledErrorCard), {
            dimensions: dimensions,
            onClick: this.handleOnClick
        });
        return children;
    }
}
const $9557304c21bcbe9e$var$packageName = "platform-pkg";
const $9557304c21bcbe9e$var$packageVersion = "0.0.0-use.local";
// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
const $9557304c21bcbe9e$var$MediaCardAnalyticsErrorBoundary = (0, $aV4Nu.withMediaAnalyticsContext)({
    packageVersion: $9557304c21bcbe9e$var$packageVersion,
    packageName: $9557304c21bcbe9e$var$packageName,
    componentName: 'mediaCard',
    component: 'mediaCard'
})((0, $4J0ad.default)()($9557304c21bcbe9e$var$WrappedMediaCardAnalyticsErrorBoundary));
var $9557304c21bcbe9e$export$2e2bcd8739ae039 = $9557304c21bcbe9e$var$MediaCardAnalyticsErrorBoundary;

});
parcelRegister("aV4Nu", function(module, exports) {
$parcel$export(module.exports, "withMediaAnalyticsContext", () => $f184895fb87e0335$export$ba0fb5f6ba6ce56c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

const $f184895fb87e0335$export$ba0fb5f6ba6ce56c = (contextPublicAttributes)=>(WrappedComponent)=>{
        // forwardRef() allows passing React refs to the wrapped component WithMediaAnalyticsContext
        const WithMediaAnalyticsContext = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
            const { featureFlags: featureFlags } = props;
            const contextData = (0, $eJOHy.useMemo)(()=>{
                const contextPrivateAttributes = {
                    featureFlags: featureFlags
                };
                return {
                    ...contextPublicAttributes,
                    [(0, $5bf02ef989474068$export$70df29c238ba7306)]: {
                        ...contextPrivateAttributes
                    }
                };
            }, [
                featureFlags
            ]);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
                data: contextData,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                    ...props,
                    ref: ref
                })
            });
        });
        WithMediaAnalyticsContext.displayName = `WithMediaAnalyticsContext(${// @ts-ignore displayName doesn't exist on type
        WrappedComponent.displayName || WrappedComponent.name})`;
        return WithMediaAnalyticsContext;
    };

});
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $5bf02ef989474068$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx


parcelRegister("QseaA", function(module, exports) {
$parcel$export(module.exports, "UnhandledErrorCard", () => $5ced6a216e0452ba$export$b5dd0a6175f5992c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $Nbf1r = parcelRequire("Nbf1r");

var $49cuj = parcelRequire("49cuj");
const $5ced6a216e0452ba$export$b5dd0a6175f5992c = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Nbf1r.UnhandledErrorCard), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $49cuj.UnhandledErrorCard), {
        ...props
    });

});
parcelRegister("Nbf1r", function(module, exports) {
$parcel$export(module.exports, "UnhandledErrorCard", () => $d9ad568ab2c4bf6c$export$b5dd0a6175f5992c);
/* unhandledErrorCard-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $88oIq = parcelRequire("88oIq");


var $1n5AE = parcelRequire("1n5AE");

var $1Jvgi = parcelRequire("1Jvgi");
const $d9ad568ab2c4bf6c$var$isPercentage = (value)=>/^\d+(\.\d+)?%$/.test(value);
const $d9ad568ab2c4bf6c$var$shouldShowText = ({ width: width, height: height })=>{
    if ($d9ad568ab2c4bf6c$var$isPercentage(width) || $d9ad568ab2c4bf6c$var$isPercentage(height)) return false;
    return parseInt(width, 10) >= 240 && parseInt(height, 10) >= 90;
};
const $d9ad568ab2c4bf6c$var$normalizeDimension = (value, defaultValue)=>{
    const sValue = value.toString();
    return $d9ad568ab2c4bf6c$var$isPercentage(sValue) ? sValue : isNaN(parseInt(sValue, 10)) ? defaultValue + 'px' : parseInt(sValue, 10) + 'px';
};
const $d9ad568ab2c4bf6c$var$getConvertedDimension = (dimensions)=>{
    const { width: width = (0, $1n5AE.defaultImageCardDimensions).width, height: height = (0, $1n5AE.defaultImageCardDimensions).height } = dimensions;
    return {
        width: $d9ad568ab2c4bf6c$var$normalizeDimension(width, (0, $1n5AE.defaultImageCardDimensions).width),
        height: $d9ad568ab2c4bf6c$var$normalizeDimension(height, (0, $1n5AE.defaultImageCardDimensions).height)
    };
};
const $d9ad568ab2c4bf6c$var$wrapperStyle = null;
class $d9ad568ab2c4bf6c$export$b5dd0a6175f5992c extends (0, $eJOHy.Component) {
    render() {
        const { dimensions: dimensions = (0, $1n5AE.defaultImageCardDimensions), onClick: onClick } = this.props;
        const convertedDimensions = $d9ad568ab2c4bf6c$var$getConvertedDimension(dimensions);
        const hideText = !$d9ad568ab2c4bf6c$var$shouldShowText($d9ad568ab2c4bf6c$var$getConvertedDimension(dimensions));
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            style: convertedDimensions,
            onClick: onClick,
            className: (0, $hcewu.default)([
                "_2rkofajl _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1s4m _syaz1aqp _c71l1osq _p12f1osq _2lx21bp4 _1i7v2smr _31ku1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($88oIq))), {
                    label: "Error",
                    color: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$874739ea9e379ab6)})`,
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1Jvgi.ContentLoadingErrorMessage), {
                    isHidden: hideText
                })
            ]
        });
    }
}

});
parcelRegister("1n5AE", function(module, exports) {
$parcel$export(module.exports, "defaultImageCardDimensions", () => $c1e5df8e84d43a31$export$d87a47989c00f322);
$parcel$export(module.exports, "getDefaultCardDimensions", () => $c1e5df8e84d43a31$export$ed7b8a4728e9c63);
const $c1e5df8e84d43a31$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $c1e5df8e84d43a31$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $c1e5df8e84d43a31$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $c1e5df8e84d43a31$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $c1e5df8e84d43a31$export$d87a47989c00f322;
    if (appearance === 'square') return $c1e5df8e84d43a31$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $c1e5df8e84d43a31$export$aeb48196afcd236a;
    return $c1e5df8e84d43a31$export$d87a47989c00f322;
};

});

parcelRegister("1Jvgi", function(module, exports) {
$parcel$export(module.exports, "ContentLoadingErrorMessage", () => $660e1b9796141d3e$export$86b6c8e2cf41b115);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $660e1b9796141d3e$export$86b6c8e2cf41b115 = ({ isHidden: isHidden })=>// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        style: {
            display: isHidden ? 'none' : 'block'
        },
        children: "We couldn't load this content"
    });

});


parcelRegister("49cuj", function(module, exports) {
$parcel$export(module.exports, "UnhandledErrorCard", () => $e39348cf8a7f07c8$export$b5dd0a6175f5992c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $88oIq = parcelRequire("88oIq");


var $iYfp4 = parcelRequire("iYfp4");

var $1n5AE = parcelRequire("1n5AE");

var $1Jvgi = parcelRequire("1Jvgi");
const $e39348cf8a7f07c8$var$isPercentage = (value)=>/^\d+(\.\d+)?%$/.test(value);
const $e39348cf8a7f07c8$var$shouldShowText = ({ width: width, height: height })=>{
    if ($e39348cf8a7f07c8$var$isPercentage(width) || $e39348cf8a7f07c8$var$isPercentage(height)) return false;
    return parseInt(width, 10) >= 240 && parseInt(height, 10) >= 90;
};
const $e39348cf8a7f07c8$var$normalizeDimension = (value, defaultValue)=>{
    const sValue = value.toString();
    return $e39348cf8a7f07c8$var$isPercentage(sValue) ? sValue : isNaN(parseInt(sValue, 10)) ? defaultValue + 'px' : parseInt(sValue, 10) + 'px';
};
const $e39348cf8a7f07c8$var$getConvertedDimension = (dimensions)=>{
    const { width: width = (0, $1n5AE.defaultImageCardDimensions).width, height: height = (0, $1n5AE.defaultImageCardDimensions).height } = dimensions;
    return {
        width: $e39348cf8a7f07c8$var$normalizeDimension(width, (0, $1n5AE.defaultImageCardDimensions).width),
        height: $e39348cf8a7f07c8$var$normalizeDimension(height, (0, $1n5AE.defaultImageCardDimensions).height)
    };
};
const $e39348cf8a7f07c8$var$wrapperStyles = (dimensions = (0, $1n5AE.defaultImageCardDimensions))=>{
    try {
        return /*#__PURE__*/ (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $iYfp4.center), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $iYfp4.borderRadius), {
            background: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`,
            color: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`,
            maxHeight: '100%',
            maxWidth: '100%'
        }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        $e39348cf8a7f07c8$var$getConvertedDimension(dimensions), "display:flex;flex-direction:column;p{font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);text-align:center;}");
    } catch (e) {
        return null;
    }
};
class $e39348cf8a7f07c8$export$b5dd0a6175f5992c extends (0, $eJOHy.Component) {
    render() {
        const { dimensions: dimensions, onClick: onClick } = this.props;
        const isErrorHidden = !$e39348cf8a7f07c8$var$shouldShowText($e39348cf8a7f07c8$var$getConvertedDimension(dimensions ?? (0, $1n5AE.defaultImageCardDimensions)));
        return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/design-system/consistent-css-prop-usage, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $e39348cf8a7f07c8$var$wrapperStyles(dimensions),
            onClick: onClick
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($88oIq))), {
            label: "Error",
            color: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$874739ea9e379ab6)})`,
            LEGACY_size: "medium",
            spacing: "spacious"
        }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1Jvgi.ContentLoadingErrorMessage), {
            isHidden: isErrorHidden
        })));
    }
}

});


parcelRegister("dUG6w", function(module, exports) {
$parcel$export(module.exports, "getRenderSucceededEventPayload", () => $7a3cd0208599350b$export$4006df18b24ad838);
$parcel$export(module.exports, "getDownloadSucceededEventPayload", () => $7a3cd0208599350b$export$30f484b360b0efe8);
$parcel$export(module.exports, "getRenderErrorRequestMetadata", () => $7a3cd0208599350b$export$1a2ec9b4a3a99d5e);
$parcel$export(module.exports, "extractErrorInfo", () => $7a3cd0208599350b$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "getRenderErrorEventPayload", () => $7a3cd0208599350b$export$ea8620de23983ca1);
$parcel$export(module.exports, "getDownloadFailedEventPayload", () => $7a3cd0208599350b$export$bd721ce2bd18db4c);
$parcel$export(module.exports, "getErrorEventPayload", () => $7a3cd0208599350b$export$d3944464e6ecd3d4);
$parcel$export(module.exports, "getRenderFailedFileStatusPayload", () => $7a3cd0208599350b$export$116834b91a04bd49);
$parcel$export(module.exports, "fireMediaCardEvent", () => $7a3cd0208599350b$export$60729f3fb03dcecc);
$parcel$export(module.exports, "createAndFireMediaCardEvent", () => $7a3cd0208599350b$export$4d33ada3618f7626);

var $4rKJa = parcelRequire("4rKJa");

var $1Z1Pq = parcelRequire("1Z1Pq");

var $5fWw9 = parcelRequire("5fWw9");
const $7a3cd0208599350b$export$31786e85bf49987b = (metadata, fileStatus)=>({
        fileMediatype: metadata.mediaType,
        fileMimetype: metadata.mimeType,
        fileId: metadata.id,
        fileSize: metadata.size,
        fileStatus: fileStatus
    });
const $7a3cd0208599350b$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $7a3cd0208599350b$export$30f484b360b0efe8 = (fileAttributes, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'success',
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $7a3cd0208599350b$export$81661af638dd90bc = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'cache-hit',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $7a3cd0208599350b$export$62c7b749808f1b8f = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'Remote-success',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $7a3cd0208599350b$export$c9d988402f74bba = (fileAttributes, performanceAttributes)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'external-uri'
        }
    });
const $7a3cd0208599350b$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $7a3cd0208599350b$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $7a3cd0208599350b$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError) && secondaryError.innerError?.message) return secondaryError.innerError?.message;
    if (secondaryError instanceof Error) return secondaryError.message;
    return error.message;
};
const $7a3cd0208599350b$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $7a3cd0208599350b$export$1a2ec9b4a3a99d5e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
};
const $7a3cd0208599350b$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $7a3cd0208599350b$export$4af9d71992e89714(error),
        error: $7a3cd0208599350b$export$88c61dcad53762da(error),
        errorDetail: $7a3cd0208599350b$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $7a3cd0208599350b$export$29aa614726672b2e(error)
    };
};
const $7a3cd0208599350b$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...$7a3cd0208599350b$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $7a3cd0208599350b$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    });
const $7a3cd0208599350b$export$bd721ce2bd18db4c = (fileAttributes, error, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$7a3cd0208599350b$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $7a3cd0208599350b$export$1a2ec9b4a3a99d5e(error),
            traceContext: traceContext
        }
    });
const $7a3cd0208599350b$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$7a3cd0208599350b$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $7a3cd0208599350b$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    });
const $7a3cd0208599350b$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
function $7a3cd0208599350b$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $1Z1Pq.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $1f17110950ea8e13$export$ec1779cb96554e1));
    }
}
const $7a3cd0208599350b$export$4d33ada3618f7626 = (payload)=>{
    return (0, $5fWw9.default)((0, $1f17110950ea8e13$export$ec1779cb96554e1))((0, $1Z1Pq.sanitiseAnalyticsPayload)(payload));
};

});
const $1f17110950ea8e13$export$ec1779cb96554e1 = 'media';

parcelRegister("1Z1Pq", function(module, exports) {
$parcel$export(module.exports, "sanitiseAnalyticsPayload", () => $20926ab34ea0b90c$export$e24d38cbdf73bc1a);

var $eaj78 = parcelRequire("eaj78");

var $K2rwM = parcelRequire("K2rwM");
const $20926ab34ea0b90c$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $20926ab34ea0b90c$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $20926ab34ea0b90c$export$e24d38cbdf73bc1a = (payload)=>$20926ab34ea0b90c$var$hasFileAttributesWithFileId(payload) ? (0, $K2rwM.produce)(payload, $20926ab34ea0b90c$var$sanitiseFileId) : payload;

});



parcelRegister("8c47P", function(module, exports) {
$parcel$export(module.exports, "Card", () => $b42972dfe81f93d3$export$60332b2344f7fe41);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4n4MY = parcelRequire("4n4MY");

var $aV4Nu = parcelRequire("aV4Nu");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");

var $g2wnj = parcelRequire("g2wnj");

var $gKRet = parcelRequire("gKRet");

var $gMOdC = parcelRequire("gMOdC");

var $ftN6c = parcelRequire("ftN6c");

var $lfkxd = parcelRequire("lfkxd");
const $b42972dfe81f93d3$var$packageName = "platform-pkg";
const $b42972dfe81f93d3$var$packageVersion = "0.0.0-use.local";
const $b42972dfe81f93d3$export$7a6ccaf429ad93a8 = ({ identifier: identifier, ...otherProps })=>{
    const innerContent = (0, $4n4MY.isFileIdentifier)(identifier) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lfkxd.default), {
        name: "media-card-file-card",
        children: /*#__PURE__*/ (0, $eJOHy.createElement)((0, $gKRet.FileCard), {
            ...otherProps,
            identifier: identifier,
            key: identifier.id
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lfkxd.default), {
        name: "media-card-external-image",
        children: /*#__PURE__*/ (0, $eJOHy.createElement)((0, $g2wnj.ExternalImageCard), {
            ...otherProps,
            identifier: identifier,
            key: identifier.dataURI
        })
    });
    return otherProps.intl ? innerContent : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: innerContent
    });
};
const $b42972dfe81f93d3$export$ec84c9f4597a734b = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $gMOdC.startResourceObserver)();
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        (0, $gMOdC.setAnalyticsContext)(createAnalyticsEvent);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b42972dfe81f93d3$export$7a6ccaf429ad93a8, {
        ...props
    });
};
const $b42972dfe81f93d3$export$60332b2344f7fe41 = (0, $aV4Nu.withMediaAnalyticsContext)({
    packageVersion: $b42972dfe81f93d3$var$packageVersion,
    packageName: $b42972dfe81f93d3$var$packageName,
    componentName: 'mediaCard',
    component: 'mediaCard'
})((0, $6YFG2.default)($b42972dfe81f93d3$export$ec84c9f4597a734b, {
    enforceContext: false
}));

});
parcelRegister("4n4MY", function(module, exports) {
$parcel$export(module.exports, "isFileIdentifier", () => $1fa54a33e2048453$export$7695387cd66cf5b5);
$parcel$export(module.exports, "isExternalImageIdentifier", () => $1fa54a33e2048453$export$2782f2fbff82f0c9);

var $eXV21 = parcelRequire("eXV21");
const $1fa54a33e2048453$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
const $1fa54a33e2048453$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
const $1fa54a33e2048453$export$5883721593c4e4b1 = (a, b)=>{
    if ($1fa54a33e2048453$export$7695387cd66cf5b5(a) && $1fa54a33e2048453$export$7695387cd66cf5b5(b)) return a.id !== b.id || a.collectionName !== b.collectionName || a.occurrenceKey !== b.occurrenceKey;
    else return !(0, (/*@__PURE__*/$parcel$interopDefault($eXV21)))(a, b);
};

});
parcelRegister("eXV21", function(module, exports) {

var $iJBzN = parcelRequire("iJBzN");

var $8NKMi = parcelRequire("8NKMi");

var $gh4Iw = parcelRequire("gh4Iw");

var $dJkAY = parcelRequire("dJkAY");

var $lHqCr = parcelRequire("lHqCr");

var $dgRHw = parcelRequire("dgRHw");
var $ae52d0a65c161185$var$getTime = Date.prototype.getTime;
function $ae52d0a65c161185$var$deepEqual(actual, expected, options) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $gh4Iw(actual, expected) : actual === expected) return true;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') return opts.strict ? $gh4Iw(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return $ae52d0a65c161185$var$objEquiv(actual, expected, opts);
}
function $ae52d0a65c161185$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $ae52d0a65c161185$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $ae52d0a65c161185$var$objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if ($ae52d0a65c161185$var$isUndefinedOrNull(a) || $ae52d0a65c161185$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if ($8NKMi(a) !== $8NKMi(b)) return false;
    var aIsRegex = $dJkAY(a);
    var bIsRegex = $dJkAY(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && $lHqCr(a) === $lHqCr(b);
    if ($dgRHw(a) && $dgRHw(b)) return $ae52d0a65c161185$var$getTime.call(a) === $ae52d0a65c161185$var$getTime.call(b);
    var aIsBuffer = $ae52d0a65c161185$var$isBuffer(a);
    var bIsBuffer = $ae52d0a65c161185$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = $iJBzN(a);
        var kb = $iJBzN(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$ae52d0a65c161185$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
module.exports = $ae52d0a65c161185$var$deepEqual;

});
parcelRegister("iJBzN", function(module, exports) {
'use strict';
var $da3993d5c090e106$var$slice = Array.prototype.slice;

var $dwUql = parcelRequire("dwUql");
var $da3993d5c090e106$var$origKeys = Object.keys;

var $da3993d5c090e106$var$keysShim = $da3993d5c090e106$var$origKeys ? function keys(o) {
    return $da3993d5c090e106$var$origKeys(o);
} : (parcelRequire("2xgn7"));
var $da3993d5c090e106$var$originalKeys = Object.keys;
$da3993d5c090e106$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($dwUql(object)) return $da3993d5c090e106$var$originalKeys($da3993d5c090e106$var$slice.call(object));
            return $da3993d5c090e106$var$originalKeys(object);
        };
    } else Object.keys = $da3993d5c090e106$var$keysShim;
    return Object.keys || $da3993d5c090e106$var$keysShim;
};
module.exports = $da3993d5c090e106$var$keysShim;

});
parcelRegister("dwUql", function(module, exports) {
'use strict';
var $9d9a082105a3d623$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $9d9a082105a3d623$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $9d9a082105a3d623$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("2xgn7", function(module, exports) {
'use strict';
var $1d8b5cf8e4b6d4ac$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $1d8b5cf8e4b6d4ac$var$has = Object.prototype.hasOwnProperty;
    var $1d8b5cf8e4b6d4ac$var$toStr = Object.prototype.toString;
    var $1d8b5cf8e4b6d4ac$var$isArgs = (parcelRequire("dwUql")); // eslint-disable-line global-require
    var $1d8b5cf8e4b6d4ac$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $1d8b5cf8e4b6d4ac$var$hasDontEnumBug = !$1d8b5cf8e4b6d4ac$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $1d8b5cf8e4b6d4ac$var$hasProtoEnumBug = $1d8b5cf8e4b6d4ac$var$isEnumerable.call(function() {}, 'prototype');
    var $1d8b5cf8e4b6d4ac$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $1d8b5cf8e4b6d4ac$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $1d8b5cf8e4b6d4ac$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$1d8b5cf8e4b6d4ac$var$excludedKeys['$' + k] && $1d8b5cf8e4b6d4ac$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$1d8b5cf8e4b6d4ac$var$hasAutomationEqualityBug) return $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype(o);
        try {
            return $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $1d8b5cf8e4b6d4ac$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $1d8b5cf8e4b6d4ac$var$toStr.call(object) === '[object Function]';
        var isArguments = $1d8b5cf8e4b6d4ac$var$isArgs(object);
        var isString = isObject && $1d8b5cf8e4b6d4ac$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $1d8b5cf8e4b6d4ac$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$1d8b5cf8e4b6d4ac$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $1d8b5cf8e4b6d4ac$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($1d8b5cf8e4b6d4ac$var$hasDontEnumBug) {
            var skipConstructor = $1d8b5cf8e4b6d4ac$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $1d8b5cf8e4b6d4ac$var$dontEnums.length; ++k)if (!(skipConstructor && $1d8b5cf8e4b6d4ac$var$dontEnums[k] === 'constructor') && $1d8b5cf8e4b6d4ac$var$has.call(object, $1d8b5cf8e4b6d4ac$var$dontEnums[k])) theKeys.push($1d8b5cf8e4b6d4ac$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $1d8b5cf8e4b6d4ac$var$keysShim;

});


parcelRegister("8NKMi", function(module, exports) {
'use strict';

var $66872f7ca248cb6e$var$hasToStringTag = (parcelRequire("5nSZG"))();

var $2TUjA = parcelRequire("2TUjA");
var $66872f7ca248cb6e$var$$toString = $2TUjA('Object.prototype.toString');
var $66872f7ca248cb6e$var$isStandardArguments = function isArguments(value) {
    if ($66872f7ca248cb6e$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $66872f7ca248cb6e$var$$toString(value) === '[object Arguments]';
};
var $66872f7ca248cb6e$var$isLegacyArguments = function isArguments(value) {
    if ($66872f7ca248cb6e$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $66872f7ca248cb6e$var$$toString(value) !== '[object Array]' && $66872f7ca248cb6e$var$$toString(value.callee) === '[object Function]';
};
var $66872f7ca248cb6e$var$supportsStandardArguments = function() {
    return $66872f7ca248cb6e$var$isStandardArguments(arguments);
}();
$66872f7ca248cb6e$var$isStandardArguments.isLegacyArguments = $66872f7ca248cb6e$var$isLegacyArguments; // for tests
module.exports = $66872f7ca248cb6e$var$supportsStandardArguments ? $66872f7ca248cb6e$var$isStandardArguments : $66872f7ca248cb6e$var$isLegacyArguments;

});
parcelRegister("5nSZG", function(module, exports) {
'use strict';

var $cwWvF = parcelRequire("cwWvF");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $cwWvF() && !!Symbol.toStringTag;
};

});

parcelRegister("2TUjA", function(module, exports) {
'use strict';

var $1b3Ts = parcelRequire("1b3Ts");

var $6zl1T = parcelRequire("6zl1T");
var $21cc66c4c492aea4$var$$indexOf = $6zl1T($1b3Ts('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1b3Ts(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $21cc66c4c492aea4$var$$indexOf(name, '.prototype.') > -1) return $6zl1T(intrinsic);
    return intrinsic;
};

});
parcelRegister("6zl1T", function(module, exports) {
'use strict';

var $fSty5 = parcelRequire("fSty5");

var $1Yj66 = parcelRequire("1Yj66");

var $giui0 = parcelRequire("giui0");

var $1w5ZU = parcelRequire("1w5ZU");
module.exports = function callBind(originalFunction) {
    var func = $giui0(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $fSty5(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($1Yj66) $1Yj66(module.exports, 'apply', {
    value: $1w5ZU
});
else module.exports.apply = $1w5ZU;

});
parcelRegister("fSty5", function(module, exports) {
'use strict';

var $1b3Ts = parcelRequire("1b3Ts");

var $gAEXI = parcelRequire("gAEXI");

var $b8f2d1ef0d4df03e$var$hasDescriptors = (parcelRequire("9ndBI"))();

var $kwOoE = parcelRequire("kwOoE");

var $imbfI = parcelRequire("imbfI");
var $b8f2d1ef0d4df03e$var$$floor = $1b3Ts('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $imbfI('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $b8f2d1ef0d4df03e$var$$floor(length) !== length) throw new $imbfI('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $kwOoE) {
        var desc = $kwOoE(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($b8f2d1ef0d4df03e$var$hasDescriptors) $gAEXI(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $gAEXI(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("gAEXI", function(module, exports) {
'use strict';

var $1Yj66 = parcelRequire("1Yj66");

var $bqoCM = parcelRequire("bqoCM");

var $imbfI = parcelRequire("imbfI");

var $kwOoE = parcelRequire("kwOoE");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $imbfI('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $imbfI('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $imbfI('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $imbfI('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $imbfI('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $imbfI('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$kwOoE && $kwOoE(obj, property);
    if ($1Yj66) $1Yj66(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $bqoCM('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("9ndBI", function(module, exports) {
'use strict';

var $1Yj66 = parcelRequire("1Yj66");
var $6d30d12bc8205bd1$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$1Yj66;
};
$6d30d12bc8205bd1$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$1Yj66) return null;
    try {
        return $1Yj66([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $6d30d12bc8205bd1$var$hasPropertyDescriptors;

});


parcelRegister("1w5ZU", function(module, exports) {
'use strict';

var $inBv6 = parcelRequire("inBv6");

var $gJ8ML = parcelRequire("gJ8ML");

var $9xm9a = parcelRequire("9xm9a");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $9xm9a($inBv6, $gJ8ML, arguments);
};

});




parcelRegister("gh4Iw", function(module, exports) {
'use strict';

var $hSIPK = parcelRequire("hSIPK");

var $6zl1T = parcelRequire("6zl1T");

var $6Mteo = parcelRequire("6Mteo");

var $4LgTG = parcelRequire("4LgTG");

var $2fKtp = parcelRequire("2fKtp");
var $bd91e494441fd9ab$var$polyfill = $6zl1T($4LgTG(), Object);
$hSIPK($bd91e494441fd9ab$var$polyfill, {
    getPolyfill: $4LgTG,
    implementation: $6Mteo,
    shim: $2fKtp
});
module.exports = $bd91e494441fd9ab$var$polyfill;

});
parcelRegister("hSIPK", function(module, exports) {
'use strict';

var $iJBzN = parcelRequire("iJBzN");
var $d04a41db78b5c12d$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $d04a41db78b5c12d$var$toStr = Object.prototype.toString;
var $d04a41db78b5c12d$var$concat = Array.prototype.concat;

var $gAEXI = parcelRequire("gAEXI");
var $d04a41db78b5c12d$var$isFunction = function(fn) {
    return typeof fn === 'function' && $d04a41db78b5c12d$var$toStr.call(fn) === '[object Function]';
};

var $d04a41db78b5c12d$var$supportsDescriptors = (parcelRequire("9ndBI"))();
var $d04a41db78b5c12d$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$d04a41db78b5c12d$var$isFunction(predicate) || !predicate()) return;
    }
    if ($d04a41db78b5c12d$var$supportsDescriptors) $gAEXI(object, name, value, true);
    else $gAEXI(object, name, value);
};
var $d04a41db78b5c12d$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $iJBzN(map);
    if ($d04a41db78b5c12d$var$hasSymbols) props = $d04a41db78b5c12d$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$d04a41db78b5c12d$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$d04a41db78b5c12d$var$defineProperties.supportsDescriptors = !!$d04a41db78b5c12d$var$supportsDescriptors;
module.exports = $d04a41db78b5c12d$var$defineProperties;

});

parcelRegister("6Mteo", function(module, exports) {
'use strict';
var $4efde67e20b2f54e$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4efde67e20b2f54e$var$numberIsNaN(a) && $4efde67e20b2f54e$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("4LgTG", function(module, exports) {
'use strict';

var $6Mteo = parcelRequire("6Mteo");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $6Mteo;
};

});

parcelRegister("2fKtp", function(module, exports) {
'use strict';

var $4LgTG = parcelRequire("4LgTG");

var $hSIPK = parcelRequire("hSIPK");
module.exports = function shimObjectIs() {
    var polyfill = $4LgTG();
    $hSIPK(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("dJkAY", function(module, exports) {
'use strict';

var $f8M6V = parcelRequire("f8M6V");

var $9fef7420da06e941$var$hasToStringTag = (parcelRequire("5nSZG"))();

var $aZSJo = parcelRequire("aZSJo");

var $kwOoE = parcelRequire("kwOoE");
/** @type {import('.')} */ var $9fef7420da06e941$var$fn;
if ($9fef7420da06e941$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $9fef7420da06e941$var$$exec = $f8M6V('RegExp.prototype.exec');
    /** @type {object} */ var $9fef7420da06e941$var$isRegexMarker = {};
    var $9fef7420da06e941$var$throwRegexMarker = function() {
        throw $9fef7420da06e941$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $9fef7420da06e941$var$badStringifier = {
        toString: $9fef7420da06e941$var$throwRegexMarker,
        valueOf: $9fef7420da06e941$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $9fef7420da06e941$var$badStringifier[Symbol.toPrimitive] = $9fef7420da06e941$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $9fef7420da06e941$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $kwOoE(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $aZSJo(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $9fef7420da06e941$var$$exec(value, /** @type {unknown} */ $9fef7420da06e941$var$badStringifier);
        } catch (e) {
            return e === $9fef7420da06e941$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $9fef7420da06e941$var$$toString = $f8M6V('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $9fef7420da06e941$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $9fef7420da06e941$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $9fef7420da06e941$var$$toString(value) === $9fef7420da06e941$var$regexClass;
    };
}
module.exports = $9fef7420da06e941$var$fn;

});

parcelRegister("lHqCr", function(module, exports) {
'use strict';

var $hSIPK = parcelRequire("hSIPK");

var $6zl1T = parcelRequire("6zl1T");

var $gptGk = parcelRequire("gptGk");

var $dg7R1 = parcelRequire("dg7R1");

var $9TOH3 = parcelRequire("9TOH3");
var $fcc2431c26bc18f8$var$flagsBound = $6zl1T($dg7R1());
$hSIPK($fcc2431c26bc18f8$var$flagsBound, {
    getPolyfill: $dg7R1,
    implementation: $gptGk,
    shim: $9TOH3
});
module.exports = $fcc2431c26bc18f8$var$flagsBound;

});
parcelRegister("gptGk", function(module, exports) {
'use strict';

var $gmjss = parcelRequire("gmjss");

var $imbfI = parcelRequire("imbfI");
var $bf26014954193e3e$var$$Object = Object;
module.exports = $gmjss(function flags() {
    if (this == null || this !== $bf26014954193e3e$var$$Object(this)) throw new $imbfI('RegExp.prototype.flags getter called on non-object');
    var result = '';
    if (this.hasIndices) result += 'd';
    if (this.global) result += 'g';
    if (this.ignoreCase) result += 'i';
    if (this.multiline) result += 'm';
    if (this.dotAll) result += 's';
    if (this.unicode) result += 'u';
    if (this.unicodeSets) result += 'v';
    if (this.sticky) result += 'y';
    return result;
}, 'get flags', true);

});
parcelRegister("gmjss", function(module, exports) {
'use strict';

var $gAEXI = parcelRequire("gAEXI");

var $be8dcb62f668ebf9$var$hasDescriptors = (parcelRequire("9ndBI"))();

var $be8dcb62f668ebf9$var$functionsHaveConfigurableNames = (parcelRequire("4Jd08")).functionsHaveConfigurableNames();

var $imbfI = parcelRequire("imbfI");
/** @type {import('.')} */ module.exports = function setFunctionName(fn, name) {
    if (typeof fn !== 'function') throw new $imbfI('`fn` is not a function');
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || $be8dcb62f668ebf9$var$functionsHaveConfigurableNames) {
        if ($be8dcb62f668ebf9$var$hasDescriptors) $gAEXI(/** @type {Parameters<define>[0]} */ fn, 'name', name, true, true);
        else $gAEXI(/** @type {Parameters<define>[0]} */ fn, 'name', name);
    }
    return fn;
};

});
parcelRegister("4Jd08", function(module, exports) {
'use strict';
var $371573269d91b1c2$var$functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === 'string';
};
var $371573269d91b1c2$var$gOPD = Object.getOwnPropertyDescriptor;
if ($371573269d91b1c2$var$gOPD) try {
    $371573269d91b1c2$var$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $371573269d91b1c2$var$gOPD = null;
}
$371573269d91b1c2$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!$371573269d91b1c2$var$functionsHaveNames() || !$371573269d91b1c2$var$gOPD) return false;
    var desc = $371573269d91b1c2$var$gOPD(function() {}, 'name');
    return !!desc && !!desc.configurable;
};
var $371573269d91b1c2$var$$bind = Function.prototype.bind;
$371573269d91b1c2$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return $371573269d91b1c2$var$functionsHaveNames() && typeof $371573269d91b1c2$var$$bind === 'function' && (function f() {}).bind().name !== '';
};
module.exports = $371573269d91b1c2$var$functionsHaveNames;

});



parcelRegister("dg7R1", function(module, exports) {
'use strict';

var $gptGk = parcelRequire("gptGk");

var $hSIPK = parcelRequire("hSIPK");
var $9a72dcabf2a652c4$require$supportsDescriptors = $hSIPK.supportsDescriptors;
var $9a72dcabf2a652c4$var$$gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if ($9a72dcabf2a652c4$require$supportsDescriptors && /a/mig.flags === 'gim') {
        var descriptor = $9a72dcabf2a652c4$var$$gOPD(RegExp.prototype, 'flags');
        if (descriptor && typeof descriptor.get === 'function' && 'dotAll' in RegExp.prototype && 'hasIndices' in RegExp.prototype) {
            /* eslint getter-return: 0 */ var calls = '';
            var o = {};
            Object.defineProperty(o, 'hasIndices', {
                get: function() {
                    calls += 'd';
                }
            });
            Object.defineProperty(o, 'sticky', {
                get: function() {
                    calls += 'y';
                }
            });
            descriptor.get.call(o);
            if (calls === 'dy') return descriptor.get;
        }
    }
    return $gptGk;
};

});

parcelRegister("9TOH3", function(module, exports) {
'use strict';

var $hSIPK = parcelRequire("hSIPK");
var $735092c83fc9c552$require$supportsDescriptors = $hSIPK.supportsDescriptors;

var $dg7R1 = parcelRequire("dg7R1");

var $kwOoE = parcelRequire("kwOoE");
var $735092c83fc9c552$var$defineProperty = Object.defineProperty;

var $b2puG = parcelRequire("b2puG");

var $9SzeH = parcelRequire("9SzeH");
var $735092c83fc9c552$var$regex = /a/;
module.exports = function shimFlags() {
    if (!$735092c83fc9c552$require$supportsDescriptors || !$9SzeH) throw new $b2puG('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    var polyfill = $dg7R1();
    var proto = $9SzeH($735092c83fc9c552$var$regex);
    var descriptor = $kwOoE(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) $735092c83fc9c552$var$defineProperty(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

});


parcelRegister("dgRHw", function(module, exports) {
'use strict';

var $f8M6V = parcelRequire("f8M6V");
var $9a966ce24b209744$var$getDay = $f8M6V('Date.prototype.getDay');
/** @type {import('.')} */ var $9a966ce24b209744$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $9a966ce24b209744$var$getDay(value);
        return true;
    } catch (e) {
        return false;
    }
};
/** @type {(value: unknown) => string} */ var $9a966ce24b209744$var$toStr = $f8M6V('Object.prototype.toString');
var $9a966ce24b209744$var$dateClass = '[object Date]';

var $9a966ce24b209744$var$hasToStringTag = (parcelRequire("5nSZG"))();
/** @type {import('.')} */ module.exports = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) return false;
    return $9a966ce24b209744$var$hasToStringTag ? $9a966ce24b209744$var$tryDateObject(value) : $9a966ce24b209744$var$toStr(value) === $9a966ce24b209744$var$dateClass;
};

});



parcelRegister("g2wnj", function(module, exports) {
$parcel$export(module.exports, "ExternalImageCard", () => $3cdd89990b4c259b$export$b7c988f139757a90);

var $gt9Am = parcelRequire("gt9Am");

var $ftN6c = parcelRequire("ftN6c");

var $lRBVi = parcelRequire("lRBVi");

var $3xaEP = parcelRequire("3xaEP");

var $52iZC = parcelRequire("52iZC");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $1yWtS = parcelRequire("1yWtS");

var $bqFvV = parcelRequire("bqFvV");

var $8Io51 = parcelRequire("8Io51");

var $7Or4X = parcelRequire("7Or4X");

var $kszJO = parcelRequire("kszJO");

var $1n5AE = parcelRequire("1n5AE");

var $dQmDm = parcelRequire("dQmDm");

var $1N2Qr = parcelRequire("1N2Qr");

var $1OE0N = parcelRequire("1OE0N");

var $8Uhop = parcelRequire("8Uhop");
const $3cdd89990b4c259b$export$b7c988f139757a90 = ({ mediaClient: mediaClient, appearance: appearance = 'auto', resizeMode: resizeMode = 'crop', disableOverlay: disableOverlay = false, featureFlags: // Media Feature Flag defaults are defined in @atlaskit/media-common
featureFlags = {}, identifier: identifier, dimensions: dimensions, contextId: contextId, alt: alt, actions: actions, shouldOpenMediaViewer: shouldOpenMediaViewer, selectable: selectable, selected: selected, testId: testId, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, shouldHideTooltip: shouldHideTooltip, mediaViewerItems: mediaViewerItems, onClick: onClick, onMouseEnter: onMouseEnter })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cardDimensions = dimensions || (0, $1n5AE.getDefaultCardDimensions)(appearance);
    const internalOccurrenceKey = (0, $eJOHy.useMemo)(()=>(0, $bqFvV.generateUniqueId)(), []);
    const timeElapsedTillCommenced = (0, $eJOHy.useMemo)(()=>(0, $8Uhop.performanceNow)(), []);
    // Generate unique traceId for file
    const traceContext = (0, $eJOHy.useMemo)(()=>({
            traceId: (0, $3xaEP.getRandomTelemetryId)()
        }), []);
    const fileStateFlagsRef = (0, $eJOHy.useRef)({
        wasStatusUploading: false,
        wasStatusProcessing: false
    });
    const startUfoExperienceRef = (0, $kszJO.useCurrentValueRef)(()=>{
        if (shouldSendPerformanceEventRef.current) (0, $7Or4X.startUfoExperience)(internalOccurrenceKey);
    });
    const [status, setStatus] = (0, $eJOHy.useState)('loading-preview');
    const cardPreview = (0, $eJOHy.useMemo)(()=>({
            dataURI: identifier.dataURI,
            orientation: 1,
            source: 'external'
        }), [
        identifier.dataURI
    ]);
    const metadata = {
        id: identifier.mediaItemType,
        name: identifier.name || identifier.dataURI,
        mediaType: 'image'
    };
    const fileAttributes = {
        fileMediatype: 'image',
        fileId: metadata.id
    };
    // for analytics
    const ssrReliability = {
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    };
    const [previewDidRender, setPreviewDidRender] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)();
    const [mediaViewerSelectedItem, setMediaViewerSelectedItem] = (0, $eJOHy.useState)(null);
    const shouldSendPerformanceEventRef = (0, $eJOHy.useRef)((0, $7Or4X.shouldPerformanceBeSampled)());
    //----------------------------------------------------------------//
    //---------------------- Analytics  ------------------------------//
    //----------------------------------------------------------------//
    const fireOperationalEventRef = (0, $kszJO.useCurrentValueRef)(()=>{
        const timeElapsedTillEvent = (0, $8Uhop.performanceNow)();
        const durationSinceCommenced = timeElapsedTillEvent - timeElapsedTillCommenced;
        const performanceAttributes = {
            overall: {
                durationSincePageStart: timeElapsedTillEvent,
                durationSinceCommenced: durationSinceCommenced
            }
        };
        createAnalyticsEvent && (0, $1N2Qr.fireOperationalEvent)(createAnalyticsEvent, status, fileAttributes, performanceAttributes, ssrReliability, error, traceContext, undefined);
        shouldSendPerformanceEventRef.current && (0, $7Or4X.completeUfoExperience)(internalOccurrenceKey, status, fileAttributes, fileStateFlagsRef.current, ssrReliability, error);
    });
    const fireAbortedEventRef = (0, $kszJO.useCurrentValueRef)(()=>{
        // UFO won't abort if it's already in a final state (succeeded, failed, aborted, etc)
        if (shouldSendPerformanceEventRef.current) (0, $7Or4X.abortUfoExperience)(internalOccurrenceKey, {
            fileAttributes: fileAttributes,
            fileStateFlags: fileStateFlagsRef?.current,
            ssrReliability: ssrReliability
        });
    });
    //----------------------------------------------------------------//
    //------------------------ useEffects ----------------------------//
    //----------------------------------------------------------------//
    (0, $eJOHy.useEffect)(()=>{
        startUfoExperienceRef.current();
    }, [
        startUfoExperienceRef
    ]);
    const prevStatus = (0, $dQmDm.usePrevious)(status);
    (0, $eJOHy.useEffect)(()=>{
        if (prevStatus !== undefined && status !== prevStatus) fireOperationalEventRef.current();
    }, [
        fireOperationalEventRef,
        prevStatus,
        status
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (previewDidRender && status === 'loading-preview') setStatus('complete');
    }, [
        previewDidRender,
        status
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            fireAbortedEventRef.current();
        };
    }, [
        fireAbortedEventRef
    ]);
    //----------------------------------------------------------------//
    //---------------------- Render Functions ------------------------//
    //----------------------------------------------------------------//
    const renderMediaViewer = ()=>{
        if (!mediaViewerSelectedItem) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).createPortal(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $52iZC.default), {
            collectionName: '',
            items: mediaViewerItems || [],
            mediaClientConfig: mediaClient.config,
            selectedItem: mediaViewerSelectedItem,
            onClose: ()=>{
                setMediaViewerSelectedItem(null);
            },
            contextId: contextId,
            featureFlags: featureFlags
        }), document.body);
    };
    //----------------------------------------------------------------//
    //-------------------------- RENDER ------------------------------//
    //----------------------------------------------------------------//
    const mediaCardCursor = (0, $8Io51.getMediaCardCursor)(false, !!shouldOpenMediaViewer, status === 'error', !!cardPreview, metadata.mediaType);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1OE0N.CardView), {
                identifier: identifier,
                status: status,
                error: error,
                mediaItemType: identifier.mediaItemType,
                metadata: metadata,
                cardPreview: cardPreview,
                alt: alt,
                resizeMode: resizeMode,
                dimensions: cardDimensions,
                actions: actions,
                selectable: selectable,
                selected: selected,
                onClick: (event, analyticsEvent)=>{
                    if (onClick) {
                        const cardEvent = {
                            event: event,
                            mediaItemDetails: metadata
                        };
                        onClick(cardEvent, analyticsEvent);
                    }
                    if (shouldOpenMediaViewer) setMediaViewerSelectedItem({
                        mediaItemType: 'external-image',
                        dataURI: identifier.dataURI,
                        name: identifier.name
                    });
                },
                onMouseEnter: (event)=>{
                    onMouseEnter?.({
                        event: event,
                        mediaItemDetails: metadata
                    });
                },
                disableOverlay: disableOverlay,
                onDisplayImage: ()=>{
                    const payloadPart = {
                        fileId: identifier.dataURI,
                        isUserCollection: false
                    };
                    (0, $lRBVi.globalMediaEventEmitter).emit('media-viewed', {
                        viewingLevel: 'minimal',
                        ...payloadPart
                    });
                },
                testId: testId,
                titleBoxBgColor: titleBoxBgColor,
                titleBoxIcon: titleBoxIcon,
                onImageError: (newCardPreview)=>{
                    // If the dataURI has been replaced, we can dismiss this error
                    if (newCardPreview?.dataURI !== cardPreview?.dataURI) return;
                    const error = new (0, $1yWtS.ImageLoadError)(newCardPreview?.source);
                    setStatus('error');
                    setError(error);
                },
                onImageLoad: (newCardPreview)=>{
                    // If the dataURI has been replaced, we can dismiss this callback
                    if (newCardPreview?.dataURI !== cardPreview?.dataURI) return;
                    setPreviewDidRender(true);
                },
                mediaCardCursor: mediaCardCursor,
                shouldHideTooltip: shouldHideTooltip
            }),
            mediaViewerSelectedItem ? renderMediaViewer() : null
        ]
    });
};

});
parcelRegister("52iZC", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0820605509642c1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8uE0z = parcelRequire("8uE0z");

var $3ilWa = parcelRequire("3ilWa");

const $a0820605509642c1$var$MediaViewer = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2x7m5")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $a0820605509642c1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uE0z.default), {}),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3ilWa.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($a0820605509642c1$var$MediaViewer, {
                ...props
            })
        })
    });
}

});
parcelRegister("8uE0z", function(module, exports) {
$parcel$export(module.exports, "headerAndSidebarBackgroundColor", () => $acef3481867ac96c$export$442b7be89436c101);
$parcel$export(module.exports, "default", () => $acef3481867ac96c$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cydC6 = parcelRequire("cydC6");

var $58yRG = parcelRequire("58yRG");
const $acef3481867ac96c$export$442b7be89436c101 = '#101214';
const $acef3481867ac96c$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cydC6.default), {
        blankedColor: $acef3481867ac96c$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $acef3481867ac96c$export$2e2bcd8739ae039 = $acef3481867ac96c$var$ModalSpinner;

});
parcelRegister("cydC6", function(module, exports) {
$parcel$export(module.exports, "default", () => $de987251ba68b050$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hsRKd = parcelRequire("hsRKd");

var $6TR4y = parcelRequire("6TR4y");

var $eGOwo = parcelRequire("eGOwo");
const $de987251ba68b050$var$ModalSpinner = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6TR4y.default), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hsRKd.default), {
        ...props
    });
var $de987251ba68b050$export$2e2bcd8739ae039 = $de987251ba68b050$var$ModalSpinner;

});
parcelRegister("hsRKd", function(module, exports) {
$parcel$export(module.exports, "default", () => $602a58390d6d877a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $IW7jS = parcelRequire("IW7jS");

var $7ep4S = parcelRequire("7ep4S");

var $aWILV = parcelRequire("aWILV");
function $602a58390d6d877a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $602a58390d6d877a$var$overlayZindex = (0, $IW7jS.layers).modal() + 10;
const $602a58390d6d877a$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1if7vbe1"
})({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: $602a58390d6d877a$var$overlayZindex
});
$602a58390d6d877a$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $602a58390d6d877a$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1if7vbe0"
})({
    name: "1aslf6p",
    styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$602a58390d6d877a$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $602a58390d6d877a$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $602a58390d6d877a$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)($602a58390d6d877a$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $602a58390d6d877a$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($602a58390d6d877a$export$52b4dfd89a6b3a1b, {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: "large",
                appearance: invertSpinnerColor || $602a58390d6d877a$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});

parcelRegister("6TR4y", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c5a6db7c09246b1$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
const $7c5a6db7c09246b1$var$blanketStyles = null;
const $7c5a6db7c09246b1$var$spinnerStyles = null;
const $7c5a6db7c09246b1$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $7c5a6db7c09246b1$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            backgroundColor: blankedColor || $7c5a6db7c09246b1$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $hcewu.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: "large",
                appearance: invertSpinnerColor || $7c5a6db7c09246b1$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});



parcelRegister("3ilWa", function(module, exports) {
$parcel$export(module.exports, "MediaViewerPortal", () => $a84a2d0c9c47ded9$export$51aee4c01b17acde);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $67YQP = parcelRequire("67YQP");
const $a84a2d0c9c47ded9$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
        zIndex: 510,
        children: children
    });

});

parcelRegister("2x7m5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7uCGO").then(()=>parcelRequire('fnhCF'));

});


parcelRegister("1yWtS", function(module, exports) {
$parcel$export(module.exports, "MediaCardError", () => $f1bbe05207027c63$export$ec8d022824f41295);
$parcel$export(module.exports, "ImageLoadError", () => $f1bbe05207027c63$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isUploadError", () => $f1bbe05207027c63$export$11f9f5835c5b9a04);
class $f1bbe05207027c63$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $f1bbe05207027c63$export$2c035820a31723e extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $f1bbe05207027c63$export$10ab445310d30114 extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $f1bbe05207027c63$export$18e89b7e50818288 extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $f1bbe05207027c63$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $f1bbe05207027c63$export$d0a45ab59b4606b extends $f1bbe05207027c63$export$ec8d022824f41295 {
    constructor(source){
        super($f1bbe05207027c63$export$921ab4548acefaa4(source));
    }
}
function $f1bbe05207027c63$export$36b43e3dd9a92(err) {
    return err instanceof $f1bbe05207027c63$export$ec8d022824f41295;
}
const $f1bbe05207027c63$export$b380593ba3516c6f = (err)=>err instanceof $f1bbe05207027c63$export$2c035820a31723e;
const $f1bbe05207027c63$export$e1d87830b3784f94 = (err)=>err instanceof $f1bbe05207027c63$export$10ab445310d30114;
const $f1bbe05207027c63$export$443aeb298d35d79d = (err)=>$f1bbe05207027c63$export$36b43e3dd9a92(err) && err.primaryReason === 'local-preview-unsupported';
function $f1bbe05207027c63$export$f00bb5a138da22e1(err) {
    return err instanceof $f1bbe05207027c63$export$d0a45ab59b4606b;
}
const $f1bbe05207027c63$export$4536ca0b68b4caf9 = (primaryReason, error, updatePrimaryReason)=>{
    if ($f1bbe05207027c63$export$36b43e3dd9a92(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $f1bbe05207027c63$export$ec8d022824f41295(primaryReason, error.secondaryError);
        return error;
    }
    return new $f1bbe05207027c63$export$ec8d022824f41295(primaryReason, error);
};
const $f1bbe05207027c63$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';

});

parcelRegister("bqFvV", function(module, exports) {
$parcel$export(module.exports, "generateUniqueId", () => $7376f416f0bdd39d$export$48da330df5248c4c);
const $7376f416f0bdd39d$export$48da330df5248c4c = ()=>{
    return (performance.now().toString(36) + Math.random().toString(36)).replace(/\./g, '');
};

});

parcelRegister("8Io51", function(module, exports) {
$parcel$export(module.exports, "getMediaCardCursor", () => $c9a45c81f3734266$export$c364ca3a4cf16be0);

var $9mNAm = parcelRequire("9mNAm");
const $c9a45c81f3734266$export$c364ca3a4cf16be0 = (useInlinePlayer, useMediaViewer, isErrorStatus, hasCardPreview, mediaType)=>{
    // If error status or no action is requested = NoAction
    if (isErrorStatus || !useInlinePlayer && !useMediaViewer) return;
    if (!mediaType && (useInlinePlayer || useInlinePlayer && useMediaViewer)) return (0, $9mNAm.MediaCardCursor).NotReady;
    else if (mediaType === 'video' && hasCardPreview && useInlinePlayer) return (0, $9mNAm.MediaCardCursor).Action;
    if (useMediaViewer) return (0, $9mNAm.MediaCardCursor).Action;
    return;
};

});
parcelRegister("9mNAm", function(module, exports) {
$parcel$export(module.exports, "isSSRPreview", () => $7b884326d1ef84dd$export$dea79d05143ccf4);
$parcel$export(module.exports, "MediaCardCursor", () => $7b884326d1ef84dd$export$2abd8762d023dc4c);
/**
 * Entry Point: @atlaskit/media-card/types
 * tsconfig.entry-points.json
 */ const $7b884326d1ef84dd$export$dea79d05143ccf4 = (preview)=>$7b884326d1ef84dd$export$36aae1afbc0a9661(preview) || $7b884326d1ef84dd$export$48a298744248dfdd(preview) || $7b884326d1ef84dd$export$f366c2c8a792cce6(preview);
const $7b884326d1ef84dd$export$48a298744248dfdd = (preview)=>{
    const ssrClientSources = [
        'ssr-server',
        'cache-ssr-server'
    ];
    return ssrClientSources.includes(preview.source);
};
const $7b884326d1ef84dd$export$36aae1afbc0a9661 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'cache-ssr-client'
    ];
    return ssrClientSources.includes(preview.source);
};
const $7b884326d1ef84dd$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
var $7b884326d1ef84dd$export$2abd8762d023dc4c = /*#__PURE__*/ function(MediaCardCursor) {
    MediaCardCursor["Action"] = "pointer";
    MediaCardCursor["NotReady"] = "wait";
    return MediaCardCursor;
}({});

});


parcelRegister("7Or4X", function(module, exports) {
$parcel$export(module.exports, "shouldPerformanceBeSampled", () => $3451769c7cc978e6$export$b21c64f4f93d10f4);
$parcel$export(module.exports, "startUfoExperience", () => $3451769c7cc978e6$export$5e9287b6a10f8075);
$parcel$export(module.exports, "completeUfoExperience", () => $3451769c7cc978e6$export$9d46b54f7b0bb11a);
$parcel$export(module.exports, "abortUfoExperience", () => $3451769c7cc978e6$export$b1021040eb94cdca);

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");

var $6vtYl = parcelRequire("6vtYl");

var $eaj78 = parcelRequire("eaj78");

var $dUG6w = parcelRequire("dUG6w");

var $1yWtS = parcelRequire("1yWtS");

var $jkwTu = parcelRequire("jkwTu");
const $3451769c7cc978e6$var$packageName = "platform-pkg";
const $3451769c7cc978e6$var$packageVersion = "0.0.0-use.local";
const $3451769c7cc978e6$var$SAMPLE_RATE = 0.05;
let $3451769c7cc978e6$var$concurrentExperience;
const $3451769c7cc978e6$var$getExperience = (id)=>{
    if (!$3451769c7cc978e6$var$concurrentExperience) {
        const inlineExperience = {
            platform: {
                component: 'media-card'
            },
            type: (0, $aRnO1.ExperienceTypes).Experience,
            performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult,
            featureFlags: (0, $6vtYl.getFeatureFlagKeysAllProducts)()
        };
        $3451769c7cc978e6$var$concurrentExperience = new (0, $9iIu4.ConcurrentExperience)('media-card-render', inlineExperience);
    }
    return $3451769c7cc978e6$var$concurrentExperience.getInstance(id);
};
const $3451769c7cc978e6$export$b21c64f4f93d10f4 = ()=>// We generate about 100M events UFOv1 events, we want to reduce this to about 5M as we can get the same info from there
    // Math.random() generates a random floating-point number between 0 (inclusive) and 1 (exclusive).
    // The condition Math.random() < SAMPLE_RATE (0.05) will be true approximately 5% of the time.
    Math.random() < $3451769c7cc978e6$var$SAMPLE_RATE;
const $3451769c7cc978e6$export$5e9287b6a10f8075 = (id)=>{
    $3451769c7cc978e6$var$getExperience(id).start();
};
const $3451769c7cc978e6$var$sanitiseFileAttributes = (fileAttributes)=>{
    /*
  	Allow external image mediaItemType as fileId
  	See ExternalImageIdentifier interface on platform/packages/media/media-client/src/identifier.ts
   */ let sanitisedFileId = 'INVALID_FILE_ID';
    if (fileAttributes.fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(fileAttributes.fileId)) sanitisedFileId = fileAttributes.fileId;
    return {
        ...fileAttributes,
        fileId: sanitisedFileId
    };
};
const $3451769c7cc978e6$export$9d46b54f7b0bb11a = (id, status, fileAttributes, fileStateFlags, ssrReliability, error = new (0, $1yWtS.MediaCardError)('missing-error-data'))=>{
    switch(status){
        case 'complete':
            $3451769c7cc978e6$var$succeedUfoExperience(id, {
                fileAttributes: fileAttributes,
                ssrReliability: ssrReliability,
                fileStateFlags: fileStateFlags
            });
            break;
        case 'failed-processing':
            $3451769c7cc978e6$var$failUfoExperience(id, {
                fileAttributes: fileAttributes,
                failReason: 'failed-processing',
                ssrReliability: ssrReliability,
                fileStateFlags: fileStateFlags
            });
            break;
        case 'error':
            $3451769c7cc978e6$var$failUfoExperience(id, {
                fileAttributes: fileAttributes,
                ...(0, $dUG6w.extractErrorInfo)(error),
                request: (0, $dUG6w.getRenderErrorRequestMetadata)(error),
                ssrReliability: ssrReliability,
                fileStateFlags: fileStateFlags
            });
            break;
    }
};
const $3451769c7cc978e6$var$getBasePayloadAttributes = ()=>({
        packageName: $3451769c7cc978e6$var$packageName,
        packageVersion: $3451769c7cc978e6$var$packageVersion,
        mediaEnvironment: (0, $jkwTu.getMediaEnvironment)(),
        mediaRegion: (0, $jkwTu.getMediaRegion)()
    });
const $3451769c7cc978e6$var$succeedUfoExperience = (id, properties)=>{
    if (properties?.fileAttributes) properties.fileAttributes = $3451769c7cc978e6$var$sanitiseFileAttributes(properties.fileAttributes);
    $3451769c7cc978e6$var$getExperience(id).success({
        metadata: {
            ...properties,
            ...$3451769c7cc978e6$var$getBasePayloadAttributes()
        }
    });
};
const $3451769c7cc978e6$var$failUfoExperience = (id, properties)=>{
    if (properties?.fileAttributes) properties.fileAttributes = $3451769c7cc978e6$var$sanitiseFileAttributes(properties.fileAttributes);
    $3451769c7cc978e6$var$getExperience(id).failure({
        metadata: {
            ...properties,
            ...$3451769c7cc978e6$var$getBasePayloadAttributes()
        }
    });
};
const $3451769c7cc978e6$export$b1021040eb94cdca = (id, properties)=>{
    // UFO won't abort if it's already in a final state (succeeded, failed, aborted, etc)
    if (properties?.fileAttributes) properties.fileAttributes = $3451769c7cc978e6$var$sanitiseFileAttributes(properties.fileAttributes);
    $3451769c7cc978e6$var$getExperience(id).abort({
        metadata: {
            ...properties,
            ...$3451769c7cc978e6$var$getBasePayloadAttributes()
        }
    });
};

});
parcelRegister("6vtYl", function(module, exports) {
$parcel$export(module.exports, "getFeatureFlagKeysAllProducts", () => $24cefc5ffd662373$export$c8bcd5e6111ea1f3);
$parcel$export(module.exports, "getMediaFeatureFlag", () => $24cefc5ffd662373$export$383e8f51978266d);

var $8ngE5 = parcelRequire("8ngE5");

var $9FkwL = parcelRequire("9FkwL");

var $iuRgS = parcelRequire("iuRgS");
const $24cefc5ffd662373$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $24cefc5ffd662373$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $9FkwL.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $8ngE5.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $24cefc5ffd662373$export$836625761e76d373 = {
    mediaInline: false
};
function $24cefc5ffd662373$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $iuRgS.getGenericFeatureFlag)(flagName, $24cefc5ffd662373$export$836625761e76d373, featureFlags);
}

});
parcelRegister("8ngE5", function(module, exports) {
$parcel$export(module.exports, "supportedProducts", () => $98ad2e5fd97982ae$export$2db74afa1ef496f1);
// Media feature flags - type and defaults defined here in one source of truth
const $98ad2e5fd97982ae$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];

});

parcelRegister("9FkwL", function(module, exports) {
$parcel$export(module.exports, "getProductKeys", () => $ccdb9efc3f6e279d$export$189fe120be7e73fc);
const $ccdb9efc3f6e279d$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $ccdb9efc3f6e279d$export$189fe120be7e73fc = ()=>$ccdb9efc3f6e279d$var$productKeys;

});

parcelRegister("iuRgS", function(module, exports) {
$parcel$export(module.exports, "getGenericFeatureFlag", () => $10b1d576322a73b7$export$f2687d0de19e4973);

var $dR4vQ = parcelRequire("dR4vQ");
function $10b1d576322a73b7$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $dR4vQ.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}

});
parcelRegister("dR4vQ", function(module, exports) {
$parcel$export(module.exports, "getLocalMediaFeatureFlag", () => $2391711880598637$export$d125817a2695dbc9);
// window.localStorage is easier to mock in tests if wrapped in this module
const $2391711880598637$export$d125817a2695dbc9 = (key)=>{
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};

});




parcelRegister("kszJO", function(module, exports) {
$parcel$export(module.exports, "useCurrentValueRef", () => $eb110defb0440db9$export$b3e10e1f0fbb71db);

var $eJOHy = parcelRequire("eJOHy");
function $eb110defb0440db9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}

});

parcelRegister("dQmDm", function(module, exports) {
$parcel$export(module.exports, "usePrevious", () => $71895e2f3ba92f68$export$5cae361ad82dce8b);

var $eJOHy = parcelRequire("eJOHy");
function $71895e2f3ba92f68$export$5cae361ad82dce8b(value) {
    const ref = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("1N2Qr", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $d34cea097fc7f90e$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireNonCriticalErrorEvent", () => $d34cea097fc7f90e$export$6505e60579e04cbd);
$parcel$export(module.exports, "fireDownloadSucceededEvent", () => $d34cea097fc7f90e$export$8f39639231268ced);
$parcel$export(module.exports, "fireDownloadFailedEvent", () => $d34cea097fc7f90e$export$f0368e92a624442a);

var $dUG6w = parcelRequire("dUG6w");

var $1yWtS = parcelRequire("1yWtS");
const $d34cea097fc7f90e$export$a1fb57756f0de62b = (createAnalyticsEvent, status, fileAttributes, performanceAttributes, ssrReliability, error = new (0, $1yWtS.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext)=>{
    const fireEvent = (payload)=>(0, $dUG6w.fireMediaCardEvent)(payload, createAnalyticsEvent);
    switch(status){
        case 'complete':
            fireEvent((0, $dUG6w.getRenderSucceededEventPayload)(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext));
            break;
        case 'failed-processing':
            fireEvent((0, $dUG6w.getRenderFailedFileStatusPayload)(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext));
            break;
        case 'error':
            fireEvent((0, $dUG6w.getRenderErrorEventPayload)(fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext));
            break;
    }
};
const $d34cea097fc7f90e$export$6505e60579e04cbd = (createAnalyticsEvent, cardStatus, fileAttributes, ssrReliability, error = new (0, $1yWtS.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext)=>{
    const errorPayload = (0, $dUG6w.getErrorEventPayload)(cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext);
    (0, $dUG6w.fireMediaCardEvent)(errorPayload, createAnalyticsEvent);
};
const $d34cea097fc7f90e$export$8f39639231268ced = (createAnalyticsEvent, fileAttributes, traceContext, metadataTraceContext)=>{
    const payload = (0, $dUG6w.getDownloadSucceededEventPayload)(fileAttributes, traceContext, metadataTraceContext);
    (0, $dUG6w.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $d34cea097fc7f90e$export$f0368e92a624442a = (createAnalyticsEvent, fileAttributes, error = new (0, $1yWtS.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext)=>{
    const payload = (0, $dUG6w.getDownloadFailedEventPayload)(fileAttributes, error, traceContext, metadataTraceContext);
    (0, $dUG6w.fireMediaCardEvent)(payload, createAnalyticsEvent);
};

});

parcelRegister("1OE0N", function(module, exports) {
$parcel$export(module.exports, "CardView", () => $d4dfec7dee22342a$export$7e52c821f7b6f422);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4n4MY = parcelRequire("4n4MY");

var $4J0ad = parcelRequire("4J0ad");

var $jJlhO = parcelRequire("jJlhO");

var $7ep4S = parcelRequire("7ep4S");

var $k71qx = parcelRequire("k71qx");

var $82KGI = parcelRequire("82KGI");

var $lk6TK = parcelRequire("lk6TK");

var $dUG6w = parcelRequire("dUG6w");

var $k7TlJ = parcelRequire("k7TlJ");

var $cZsO3 = parcelRequire("cZsO3");

var $6McwC = parcelRequire("6McwC");

var $hOl09 = parcelRequire("hOl09");

var $3K8qV = parcelRequire("3K8qV");

var $98895 = parcelRequire("98895");

var $b9tta = parcelRequire("b9tta");

var $hh0qm = parcelRequire("hh0qm");

var $3g5Nx = parcelRequire("3g5Nx");

var $eLvoQ = parcelRequire("eLvoQ");

var $1yWtS = parcelRequire("1yWtS");

var $6U66H = parcelRequire("6U66H");
var $4NdcT = parcelRequire("4NdcT");


var $7SEfT = parcelRequire("7SEfT");

var $hxpDY = parcelRequire("hxpDY");

var $kszJO = parcelRequire("kszJO");

var $1pW0T = parcelRequire("1pW0T");

var $eGOwo = parcelRequire("eGOwo");
const $d4dfec7dee22342a$export$fe522702db3259fa = ({ identifier: identifier, innerRef: innerRef = null, onImageLoad: onImageLoad, onImageError: onImageError, dimensions: dimensions, onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, metadata: metadata, status: status, selected: selected, selectable: selectable, cardPreview: cardPreview, mediaCardCursor: mediaCardCursor, shouldHideTooltip: shouldHideTooltip, progress: progress, alt: alt, resizeMode: resizeMode, onDisplayImage: onDisplayImage, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay, actions: actions, disableOverlay: disableOverlay, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, error: error, disableAnimation: disableAnimation, openMediaViewerButtonRef: openMediaViewerButtonRef = null, shouldOpenMediaViewer: shouldOpenMediaViewer, overriddenCreationDate: overriddenCreationDate, onSvgError: onSvgError, onSvgLoad: onSvgLoad })=>{
    const [didSvgRender, setDidSvgRender] = (0, $eJOHy.useState)(false);
    const [didImageRender, setDidImageRender] = (0, $eJOHy.useState)(false);
    const divRef = (0, $eJOHy.useRef)(null);
    const prevCardPreviewRef = (0, $eJOHy.useRef)();
    const breakpoint = (0, $7SEfT.useBreakpoint)(dimensions?.width, divRef);
    (0, $eJOHy.useEffect)(()=>{
        // We should only switch didImageRender to false when cardPreview goes undefined, not when it is changed. as this method could be triggered after onImageLoad callback, falling on a race condition
        if (prevCardPreviewRef.current && !cardPreview) setDidImageRender(false);
        prevCardPreviewRef.current = cardPreview;
    }, [
        cardPreview
    ]);
    const handleOnImageLoad = (prevCardPreview)=>{
        if (prevCardPreview.dataURI !== cardPreview?.dataURI) return;
        /*
      We render the icon & icon message always, even if there is cardPreview available.
      If the image fails to load/render, the icon will remain, i.e. the user won't see a change until the root card decides to chage status to error.
      If the image renders successfully, we switch this variable to hide the icon & icon message behind the thumbnail in case the image has transparency.
      It is less likely that root component replaces a suceeded cardPreview for a failed one than the opposite case. Therefore we prefer to hide the icon instead show when the image fails, for a smoother transition
    */ setDidImageRender(true);
        onImageLoad?.(cardPreview);
    };
    const handleOnImageError = (prevCardPreview)=>{
        if (prevCardPreview.dataURI !== cardPreview?.dataURI) return;
        setDidImageRender(false);
        onImageError?.(cardPreview);
    };
    const shouldRenderPlayButton = ()=>{
        const { mediaType: mediaType } = metadata || {};
        if (mediaType !== 'video' || !cardPreview) return false;
        return true;
    };
    const mergedRef = (0, $82KGI.useMergeRefs)([
        divRef,
        innerRef
    ]);
    const getRenderConfigByStatus = ()=>{
        const { name: name, mediaType: mediaType, mimeType: mimeType } = metadata || {};
        const isZeroSize = metadata && metadata.size === 0;
        const defaultConfig = {
            renderTypeIcon: !didImageRender && !didSvgRender,
            renderImageRenderer: !didSvgRender,
            renderSvgView: mimeType === 'image/svg+xml',
            renderPlayButton: !!cardPreview && mediaType === 'video',
            renderBlanket: !disableOverlay,
            renderTitleBox: !disableOverlay,
            renderTickBox: !disableOverlay && !!selectable
        };
        const loadingConfig = {
            ...defaultConfig,
            renderPlayButton: false,
            renderTypeIcon: false,
            renderSpinner: !didImageRender && !didSvgRender
        };
        switch(status){
            case 'uploading':
                return {
                    ...defaultConfig,
                    renderBlanket: !disableOverlay || mediaType !== 'video',
                    isFixedBlanket: true,
                    renderProgressBar: true
                };
            case 'processing':
                return {
                    ...defaultConfig,
                    iconMessage: !didImageRender && !isZeroSize ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eLvoQ.CreatingPreview), {
                        disableAnimation: disableAnimation
                    }) : undefined
                };
            case 'complete':
                return defaultConfig;
            case 'error':
            case 'failed-processing':
                if (status === 'failed-processing' && mimeType === 'image/svg+xml') return loadingConfig;
                const baseErrorConfig = {
                    ...defaultConfig,
                    renderTypeIcon: true,
                    renderImageRenderer: false,
                    renderSvgView: false,
                    renderTitleBox: false,
                    renderPlayButton: false
                };
                let iconMessage;
                let customTitleMessage;
                if ((0, $1yWtS.isUploadError)(error)) {
                    iconMessage = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eLvoQ.FailedToUpload), {});
                    customTitleMessage = (0, $lk6TK.messages).failed_to_upload;
                } else if (!metadata) iconMessage = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eLvoQ.FailedToLoad), {});
                else iconMessage = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eLvoQ.PreviewUnavailable), {});
                if (!disableOverlay) {
                    const renderFailedTitleBox = !name || !!customTitleMessage;
                    return {
                        ...baseErrorConfig,
                        renderTitleBox: !!name && !customTitleMessage,
                        renderFailedTitleBox: renderFailedTitleBox,
                        iconMessage: !renderFailedTitleBox ? iconMessage : undefined,
                        customTitleMessage: customTitleMessage
                    };
                }
                return {
                    ...baseErrorConfig,
                    iconMessage: iconMessage
                };
            case 'loading-preview':
            case 'loading':
            default:
                return loadingConfig;
        }
    };
    const { renderTypeIcon: renderTypeIcon, iconMessage: iconMessage, renderImageRenderer: renderImageRenderer, renderSvgView: renderSvgView, renderSpinner: renderSpinner, renderPlayButton: renderPlayButton, renderBlanket: renderBlanket, renderProgressBar: renderProgressBar, renderTitleBox: renderTitleBox, renderFailedTitleBox: renderFailedTitleBox, renderTickBox: renderTickBox, isFixedBlanket: isFixedBlanket, customTitleMessage: customTitleMessage } = getRenderConfigByStatus();
    const shouldDisplayBackground = !cardPreview || !disableOverlay || status === 'error' || status === 'failed-processing';
    const isPlayButtonClickable = shouldRenderPlayButton() && !!disableOverlay;
    const isTickBoxSelectable = !disableOverlay && !!selectable && !selected;
    // Disable tooltip for Media Single
    const shouldDisplayTooltip = !disableOverlay && !shouldHideTooltip;
    const { mediaType: mediaType, mimeType: mimeType, name: name, createdAt: createdAt } = metadata || {};
    const isTitleBoxVisible = renderTitleBox && name;
    const hasVisibleTitleBox = !!(isTitleBoxVisible || renderFailedTitleBox);
    const metadataRef = (0, $kszJO.useCurrentValueRef)(metadata);
    const actionsWithDetails = (0, $eJOHy.useMemo)(()=>{
        if (!actions) return [];
        return actions.map((action)=>({
                ...action,
                handler: ()=>{
                    if (!metadataRef.current) action.handler();
                    else action.handler({
                        type: 'file',
                        details: metadataRef.current
                    });
                }
            }));
    }, [
        actions,
        metadataRef
    ]);
    const onSvgLoadBase = ()=>{
        setDidSvgRender(true);
        onSvgLoad?.();
    };
    const contents = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6U66H.ImageContainer), {
                centerElements: didSvgRender && !(0, $eGOwo.fg)('platform_media_card_image_render'),
                testId: (0, $87b212d64266f221$export$7a6526d4be3b7eb3),
                mediaName: name,
                status: status,
                progress: progress,
                selected: selected,
                source: cardPreview?.source,
                children: [
                    renderTypeIcon && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3g5Nx.IconWrapper), {
                        breakpoint: breakpoint,
                        hasTitleBox: hasVisibleTitleBox,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jJlhO.MimeTypeIcon), {
                                testId: "media-card-file-type-icon",
                                mediaType: mediaType,
                                mimeType: mimeType,
                                name: name
                            }),
                            iconMessage
                        ]
                    }),
                    renderSpinner && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3g5Nx.IconWrapper), {
                        breakpoint: breakpoint,
                        hasTitleBox: hasVisibleTitleBox,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                            testId: "media-card-loading",
                            interactionName: "media-card-loading"
                        })
                    }),
                    renderSvgView && identifier && (0, $4n4MY.isFileIdentifier)(identifier) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1pW0T.SvgView), {
                        identifier: identifier,
                        resizeMode: resizeMode || 'crop',
                        onError: onSvgError,
                        onLoad: onSvgLoadBase,
                        wrapperRef: divRef
                    }),
                    renderImageRenderer && identifier && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k7TlJ.ImageRenderer), {
                        cardPreview: cardPreview,
                        mediaType: metadata?.mediaType || 'unknown',
                        alt: alt ?? name,
                        resizeMode: resizeMode,
                        onDisplayImage: onDisplayImage,
                        onImageLoad: handleOnImageLoad,
                        onImageError: handleOnImageError,
                        nativeLazyLoad: nativeLazyLoad,
                        forceSyncDisplay: forceSyncDisplay,
                        identifier: identifier,
                        wrapperRef: divRef
                    }),
                    renderPlayButton && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3g5Nx.IconWrapper), {
                        breakpoint: breakpoint,
                        hasTitleBox: hasVisibleTitleBox,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3K8qV.PlayButton), {})
                    }),
                    renderBlanket && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b9tta.Blanket), {
                        isFixed: isFixedBlanket
                    }),
                    renderTitleBox && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cZsO3.TitleBox), {
                        name: name,
                        createdAt: overriddenCreationDate ?? createdAt,
                        breakpoint: breakpoint,
                        titleBoxIcon: titleBoxIcon,
                        titleBoxBgColor: titleBoxBgColor,
                        hidden: !isTitleBoxVisible
                    }),
                    renderFailedTitleBox && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6McwC.FailedTitleBox), {
                        breakpoint: breakpoint,
                        customMessage: customTitleMessage
                    }),
                    renderProgressBar && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hOl09.ProgressBar), {
                        progress: progress,
                        breakpoint: breakpoint,
                        positionBottom: !hasVisibleTitleBox
                    }),
                    renderTickBox && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $98895.TickBox), {
                        selected: selected
                    })
                ]
            }),
            disableOverlay || !actions || actions.length === 0 ? null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hh0qm.ActionsBar), {
                filename: name,
                actions: actionsWithDetails
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            shouldOpenMediaViewer && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hxpDY.default), {
                fileName: name ?? '',
                innerRef: openMediaViewerButtonRef,
                onClick: onClick
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4NdcT.Wrapper), {
                testId: testId || 'media-card-view',
                dimensions: dimensions,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                innerRef: mergedRef,
                breakpoint: breakpoint,
                mediaCardCursor: mediaCardCursor,
                disableOverlay: !!disableOverlay,
                selected: !!selected,
                displayBackground: shouldDisplayBackground,
                isPlayButtonClickable: isPlayButtonClickable,
                isTickBoxSelectable: isTickBoxSelectable,
                shouldDisplayTooltip: shouldDisplayTooltip,
                children: shouldDisplayTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                    content: name,
                    position: "bottom",
                    tag: "div",
                    children: contents
                }) : contents
            })
        ]
    });
};
const $d4dfec7dee22342a$export$7e52c821f7b6f422 = (0, $4J0ad.default)({
    onClick: (0, $dUG6w.createAndFireMediaCardEvent)({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'mediaCard',
        attributes: {}
    })
})($d4dfec7dee22342a$export$fe522702db3259fa);

});
parcelRegister("jJlhO", function(module, exports) {
$parcel$export(module.exports, "MimeTypeIcon", () => $9c1f8dd6ce4397d9$export$875d423332b93b5f);
/* mime-type-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fOXQV = parcelRequire("fOXQV");

var $gONfj = parcelRequire("gONfj");
var $7Mde1 = parcelRequire("7Mde1");

var $eGOwo = parcelRequire("eGOwo");
const $9c1f8dd6ce4397d9$var$iconWrapperStyleMap = {
    small: "",
    large: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $9c1f8dd6ce4397d9$var$iconWrapperStyles = null;
const $9c1f8dd6ce4397d9$export$875d423332b93b5f = ({ mediaType: mediaType = 'unknown', mimeType: mimeType = 'unknown', name: name = 'unknown', testId: testId, size: size = 'large' })=>{
    // retrieve mimetype icon and label
    const iconInfo = (0, $fOXQV.getMimeIcon)(mimeType, name);
    // a corresponding mimetype icon and label was found.
    if (iconInfo) {
        const Icon = iconInfo.icon;
        return (0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": testId,
            "data-type": iconInfo.label,
            className: (0, $hcewu.default)([
                "_1e0c116y",
                $9c1f8dd6ce4397d9$var$iconWrapperStyleMap[size ?? 'small']
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                label: iconInfo.label
            })
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gONfj.IconWrapper), {
            "data-testid": testId,
            "data-type": iconInfo.label,
            size: size,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                label: iconInfo.label
            })
        });
    }
    // no corresponding mimetype icon/label was found.
    // Hence, return a mediatype (image/doc/audio/video/unknown) icon
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Mde1.MediaTypeIcon), {
        testId: testId,
        type: mediaType,
        size: size
    });
};

});
parcelRegister("fOXQV", function(module, exports) {
$parcel$export(module.exports, "dataURItoFile", () => $cb7adf01e70d1e12$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $cb7adf01e70d1e12$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $cb7adf01e70d1e12$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $cb7adf01e70d1e12$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $cb7adf01e70d1e12$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $cb7adf01e70d1e12$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $cb7adf01e70d1e12$export$61a1de0822e2820);

var $6OBnQ = parcelRequire("6OBnQ");

var $2Pj0H = parcelRequire("2Pj0H");

var $jb8ZN = parcelRequire("jb8ZN");

var $4w1Xx = parcelRequire("4w1Xx");

var $heBKY = parcelRequire("heBKY");

var $jP9Cl = parcelRequire("jP9Cl");

var $gAsmN = parcelRequire("gAsmN");

var $iqmbF = parcelRequire("iqmbF");

var $hLw8T = parcelRequire("hLw8T");

var $jpYYq = parcelRequire("jpYYq");

var $4SXVP = parcelRequire("4SXVP");

var $91IX3 = parcelRequire("91IX3");

var $i9oSq = parcelRequire("i9oSq");

var $1TONM = parcelRequire("1TONM");

var $3LgN4 = parcelRequire("3LgN4");

var $jmdLl = parcelRequire("jmdLl");
function $cb7adf01e70d1e12$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $cb7adf01e70d1e12$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $cb7adf01e70d1e12$export$849633012686f7ee(file)
    };
}
async function $cb7adf01e70d1e12$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $cb7adf01e70d1e12$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $cb7adf01e70d1e12$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $cb7adf01e70d1e12$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $cb7adf01e70d1e12$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $cb7adf01e70d1e12$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $cb7adf01e70d1e12$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6OBnQ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SXVP)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jpYYq)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iqmbF)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4w1Xx)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jb8ZN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Pj0H)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($91IX3)))
    }
];
function $cb7adf01e70d1e12$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $cb7adf01e70d1e12$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $jmdLl.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3LgN4)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($heBKY)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jP9Cl)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gAsmN)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("6OBnQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $4f6469314c3d6ff1$var$_react = $4f6469314c3d6ff1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f6469314c3d6ff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6469314c3d6ff1$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $4f6469314c3d6ff1$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$4f6469314c3d6ff1$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $4f6469314c3d6ff1$var$_default = module.exports.default = $4f6469314c3d6ff1$var$PdfDocument24Icon;

});

parcelRegister("2Pj0H", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $20ef173efcc507e4$var$_react = $20ef173efcc507e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $20ef173efcc507e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $20ef173efcc507e4$var$Gif24Icon = (props)=>/*#__PURE__*/ $20ef173efcc507e4$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$20ef173efcc507e4$var$Gif24Icon.displayName = 'Gif24Icon';
var $20ef173efcc507e4$var$_default = module.exports.default = $20ef173efcc507e4$var$Gif24Icon;

});

parcelRegister("jb8ZN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $df6605c69004c362$var$_react = $df6605c69004c362$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $df6605c69004c362$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $df6605c69004c362$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $df6605c69004c362$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$df6605c69004c362$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $df6605c69004c362$var$_default = module.exports.default = $df6605c69004c362$var$PowerpointPresentation24Icon;

});

parcelRegister("4w1Xx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $349babaa4a8a09e8$var$_react = $349babaa4a8a09e8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $349babaa4a8a09e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $349babaa4a8a09e8$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $349babaa4a8a09e8$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$349babaa4a8a09e8$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $349babaa4a8a09e8$var$_default = module.exports.default = $349babaa4a8a09e8$var$WordDocument24Icon;

});

parcelRegister("heBKY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c8c1082e5cae77c8$var$_react = $c8c1082e5cae77c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c8c1082e5cae77c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c8c1082e5cae77c8$var$Sketch24Icon = (props)=>/*#__PURE__*/ $c8c1082e5cae77c8$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c8c1082e5cae77c8$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $c8c1082e5cae77c8$var$_default = module.exports.default = $c8c1082e5cae77c8$var$Sketch24Icon;

});

parcelRegister("jP9Cl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6ea3d8b8f4b0c1d$var$_react = $e6ea3d8b8f4b0c1d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e6ea3d8b8f4b0c1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6ea3d8b8f4b0c1d$var$Figma24Icon = (props)=>/*#__PURE__*/ $e6ea3d8b8f4b0c1d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e6ea3d8b8f4b0c1d$var$Figma24Icon.displayName = 'Figma24Icon';
var $e6ea3d8b8f4b0c1d$var$_default = module.exports.default = $e6ea3d8b8f4b0c1d$var$Figma24Icon;

});

parcelRegister("gAsmN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1360329a45292df$var$_react = $c1360329a45292df$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c1360329a45292df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1360329a45292df$var$Executable24Icon = (props)=>/*#__PURE__*/ $c1360329a45292df$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1360329a45292df$var$Executable24Icon.displayName = 'Executable24Icon';
var $c1360329a45292df$var$_default = module.exports.default = $c1360329a45292df$var$Executable24Icon;

});

parcelRegister("iqmbF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d69bdda0af90a430$var$_react = $d69bdda0af90a430$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d69bdda0af90a430$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d69bdda0af90a430$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d69bdda0af90a430$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d69bdda0af90a430$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d69bdda0af90a430$var$_default = module.exports.default = $d69bdda0af90a430$var$GoogleDoc24Icon;

});

parcelRegister("hLw8T", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ceefc245c72865b3$var$_react = $ceefc245c72865b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $ceefc245c72865b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ceefc245c72865b3$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $ceefc245c72865b3$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ceefc245c72865b3$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $ceefc245c72865b3$var$_default = module.exports.default = $ceefc245c72865b3$var$GoogleForm24Icon;

});

parcelRegister("jpYYq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e22fa632d0a47674$var$_react = $e22fa632d0a47674$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e22fa632d0a47674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e22fa632d0a47674$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $e22fa632d0a47674$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e22fa632d0a47674$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $e22fa632d0a47674$var$_default = module.exports.default = $e22fa632d0a47674$var$GoogleSheet24Icon;

});

parcelRegister("4SXVP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $38eab1c43401fe51$var$_react = $38eab1c43401fe51$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $38eab1c43401fe51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $38eab1c43401fe51$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $38eab1c43401fe51$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$38eab1c43401fe51$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $38eab1c43401fe51$var$_default = module.exports.default = $38eab1c43401fe51$var$GoogleSlide24Icon;

});

parcelRegister("91IX3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $69271380a604c514$var$_react = $69271380a604c514$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $69271380a604c514$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69271380a604c514$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $69271380a604c514$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$69271380a604c514$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $69271380a604c514$var$_default = module.exports.default = $69271380a604c514$var$ExcelSpreadsheet24Icon;

});

parcelRegister("3LgN4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2bd2c91c79a3039e$var$_react = $2bd2c91c79a3039e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $2bd2c91c79a3039e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bd2c91c79a3039e$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2bd2c91c79a3039e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2bd2c91c79a3039e$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2bd2c91c79a3039e$var$_default = module.exports.default = $2bd2c91c79a3039e$var$SourceCode24Icon;

});

parcelRegister("jmdLl", function(module, exports) {
$parcel$export(module.exports, "getExtension", () => $d6ba8b104df87d35$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d6ba8b104df87d35$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d6ba8b104df87d35$export$ba4368c844580f9e);

var $eGOwo = parcelRequire("eGOwo");
function $d6ba8b104df87d35$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d6ba8b104df87d35$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d6ba8b104df87d35$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d6ba8b104df87d35$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d6ba8b104df87d35$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            if (mimetype === 'text/plain' && (0, $eGOwo.fg)('platform_media-default-code-viewer-for-plain-text')) return 'text';
            return null;
    }
}

});


parcelRegister("gONfj", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $f2870f29b61acb07$export$be58b4326e23250f);
$parcel$export(module.exports, "MediaTypeIcon", () => $f2870f29b61acb07$export$3787195047fd197b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3LEcI = parcelRequire("3LEcI");

var $3Br58 = parcelRequire("3Br58");

var $2VCtV = parcelRequire("2VCtV");

var $gxCW9 = parcelRequire("gxCW9");

var $8ALRN = parcelRequire("8ALRN");

var $btZ6J = parcelRequire("btZ6J");

var $5pSEP = parcelRequire("5pSEP");

var $k5t0f = parcelRequire("k5t0f");

var $gBZ18 = parcelRequire("gBZ18");

var $lImMk = parcelRequire("lImMk");

var $8UJE5 = parcelRequire("8UJE5");

var $hLSBq = parcelRequire("hLSBq");

var $aWILV = parcelRequire("aWILV");
const $f2870f29b61acb07$export$be58b4326e23250f = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "exhtxam0"
})("display:inline-flex;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ size: size })=>size === 'large' ? `padding: 4px;` : '');
$f2870f29b61acb07$export$be58b4326e23250f.displayName = 'IconWrapper';
const $f2870f29b61acb07$var$largeIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($3LEcI))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($3Br58))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($2VCtV))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($gxCW9))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($8ALRN))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($btZ6J)))
};
const $f2870f29b61acb07$var$smallIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($5pSEP))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($k5t0f))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($gBZ18))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($lImMk))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($8UJE5))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($hLSBq)))
};
const $f2870f29b61acb07$var$defaultType = 'unknown';
class $f2870f29b61acb07$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            type: $f2870f29b61acb07$var$defaultType,
            testId: 'file-type-icon',
            size: 'large'
        };
    }
    render() {
        const { type: type, size: size, testId: testId } = this.props;
        const typeWithDefault = type || $f2870f29b61acb07$var$defaultType;
        const icons = size === 'large' ? $f2870f29b61acb07$var$largeIcons : $f2870f29b61acb07$var$smallIcons;
        const Icon = icons[typeWithDefault] || icons[$f2870f29b61acb07$var$defaultType];
        return /*#__PURE__*/ (0, $gt9Am.jsx)($f2870f29b61acb07$export$be58b4326e23250f, {
            "data-testid": testId,
            "data-type": type,
            size: size,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                label: "media-type"
            })
        });
    }
}

});
parcelRegister("3LEcI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2be4f2961bc81c35$var$_react = $2be4f2961bc81c35$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $2be4f2961bc81c35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2be4f2961bc81c35$var$Image24Icon = (props)=>/*#__PURE__*/ $2be4f2961bc81c35$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m7 17-1.293-1.293a1 1 0 0 0-1.414 0L4 19h16v-3.6l-3.295-3.624a1 1 0 0 0-1.447-.034zm-3.333-6.667a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2be4f2961bc81c35$var$Image24Icon.displayName = 'Image24Icon';
var $2be4f2961bc81c35$var$_default = module.exports.default = $2be4f2961bc81c35$var$Image24Icon;

});

parcelRegister("3Br58", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $29f9d5ab633d0494$var$_react = $29f9d5ab633d0494$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $29f9d5ab633d0494$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $29f9d5ab633d0494$var$Audio24Icon = (props)=>/*#__PURE__*/ $29f9d5ab633d0494$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m16 6.673V5.619c0-.38-.322-.656-.72-.615l-8.56.886c-.41.043-.72.383-.72.764v6.462A2.8 2.8 0 0 0 8.2 13h-.4A2.8 2.8 0 0 0 5 15.8v.4A2.8 2.8 0 0 0 7.8 19h.4a2.8 2.8 0 0 0 2.8-2.8V8.863l6-.62v3.873a2.8 2.8 0 0 0-.8-.116h-.4a2.8 2.8 0 0 0-2.8 2.8v.4a2.8 2.8 0 0 0 2.8 2.8h.4a2.8 2.8 0 0 0 2.8-2.8z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$29f9d5ab633d0494$var$Audio24Icon.displayName = 'Audio24Icon';
var $29f9d5ab633d0494$var$_default = module.exports.default = $29f9d5ab633d0494$var$Audio24Icon;

});

parcelRegister("2VCtV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $221ec14f8aa18852$var$_react = $221ec14f8aa18852$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $221ec14f8aa18852$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $221ec14f8aa18852$var$Video24Icon = (props)=>/*#__PURE__*/ $221ec14f8aa18852$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7.995v8.01c0 .54.446.995.995.995h8.01c.54 0 .995-.446.995-.995v-8.01c0-.54-.446-.995-.995-.995h-8.01C4.455 7 4 7.446 4 7.995m15.16 7.943c.38.185.84-.066.84-.457V8.52c0-.39-.46-.642-.84-.457L16 9.592v4.817z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$221ec14f8aa18852$var$Video24Icon.displayName = 'Video24Icon';
var $221ec14f8aa18852$var$_default = module.exports.default = $221ec14f8aa18852$var$Video24Icon;

});

parcelRegister("8ALRN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6416d0dae574fbfa$var$_react = $6416d0dae574fbfa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $6416d0dae574fbfa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6416d0dae574fbfa$var$Archive24Icon = (props)=>/*#__PURE__*/ $6416d0dae574fbfa$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m6 3v3h3V3zm3 3v3h3V6zM9 9v3h3V9zm3 3v3h3v-3zm-3 3v3h3v-3zm3 3v3h3v-3z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6416d0dae574fbfa$var$Archive24Icon.displayName = 'Archive24Icon';
var $6416d0dae574fbfa$var$_default = module.exports.default = $6416d0dae574fbfa$var$Archive24Icon;

});

parcelRegister("5pSEP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3f19af665d269b27$var$_react = $3f19af665d269b27$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $3f19af665d269b27$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3f19af665d269b27$var$Image16Icon = (props)=>/*#__PURE__*/ $3f19af665d269b27$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
    }, props, {
        size: 'small'
    }));
$3f19af665d269b27$var$Image16Icon.displayName = 'Image16Icon';
var $3f19af665d269b27$var$_default = module.exports.default = $3f19af665d269b27$var$Image16Icon;

});

parcelRegister("k5t0f", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e9fac5a5456cbea9$var$_react = $e9fac5a5456cbea9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e9fac5a5456cbea9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e9fac5a5456cbea9$var$Audio16Icon = (props)=>/*#__PURE__*/ $e9fac5a5456cbea9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 0 0-.514.545v4.616a2 2 0 0 0-.571-.083H5a2 2 0 0 0-2 2V11a2 2 0 0 0 2 2h.286a2 2 0 0 0 2-2V5.76l4.285-.444v2.767A2 2 0 0 0 11 8h-.286a2 2 0 0 0-2 2v.286a2 2 0 0 0 2 2H11a2 2 0 0 0 2-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$e9fac5a5456cbea9$var$Audio16Icon.displayName = 'Audio16Icon';
var $e9fac5a5456cbea9$var$_default = module.exports.default = $e9fac5a5456cbea9$var$Audio16Icon;

});

parcelRegister("gBZ18", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c17f6eccb9d428df$var$_react = $c17f6eccb9d428df$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c17f6eccb9d428df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c17f6eccb9d428df$var$Video16Icon = (props)=>/*#__PURE__*/ $c17f6eccb9d428df$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11.37 10.954c.285.138.63-.05.63-.343V5.39c0-.293-.345-.481-.63-.343L11 6.194v3.613zM2 5.99v4.018c0 .54.449.991 1.003.991h4.994A.99.99 0 0 0 9 10.01V5.99C9 5.452 8.551 5 7.997 5H3.003A.99.99 0 0 0 2 5.99"/></svg>`
    }, props, {
        size: 'small'
    }));
$c17f6eccb9d428df$var$Video16Icon.displayName = 'Video16Icon';
var $c17f6eccb9d428df$var$_default = module.exports.default = $c17f6eccb9d428df$var$Video16Icon;

});

parcelRegister("8UJE5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $67d6f5f5cee4dc32$var$_react = $67d6f5f5cee4dc32$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $67d6f5f5cee4dc32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $67d6f5f5cee4dc32$var$Archive16Icon = (props)=>/*#__PURE__*/ $67d6f5f5cee4dc32$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4 3v2h2V3zm2 2v2h2V5zM6 7v2h2V7zm2 2v2h2V9zm-2.307 2v2h2v-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$67d6f5f5cee4dc32$var$Archive16Icon.displayName = 'Archive16Icon';
var $67d6f5f5cee4dc32$var$_default = module.exports.default = $67d6f5f5cee4dc32$var$Archive16Icon;

});


parcelRegister("7Mde1", function(module, exports) {
$parcel$export(module.exports, "MediaTypeIcon", () => $fd316cc019a1738d$export$3787195047fd197b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gONfj = parcelRequire("gONfj");

var $h85aN = parcelRequire("h85aN");

var $eGOwo = parcelRequire("eGOwo");
class $fd316cc019a1738d$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        return (0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h85aN.MediaTypeIcon), {
            ...this.props
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gONfj.MediaTypeIcon), {
            ...this.props
        });
    }
}

});
parcelRegister("h85aN", function(module, exports) {
$parcel$export(module.exports, "MediaTypeIcon", () => $bf79530dc7aa2279$export$3787195047fd197b);
/* media-type-icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3LEcI = parcelRequire("3LEcI");

var $3Br58 = parcelRequire("3Br58");

var $2VCtV = parcelRequire("2VCtV");

var $gxCW9 = parcelRequire("gxCW9");

var $8ALRN = parcelRequire("8ALRN");

var $btZ6J = parcelRequire("btZ6J");

var $5pSEP = parcelRequire("5pSEP");

var $k5t0f = parcelRequire("k5t0f");

var $gBZ18 = parcelRequire("gBZ18");

var $lImMk = parcelRequire("lImMk");

var $8UJE5 = parcelRequire("8UJE5");

var $hLSBq = parcelRequire("hLSBq");
const $bf79530dc7aa2279$var$iconStyleMap = {
    small: "",
    large: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $bf79530dc7aa2279$var$iconStyles = null;
const $bf79530dc7aa2279$var$largeIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($3LEcI))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($3Br58))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($2VCtV))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($gxCW9))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($8ALRN))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($btZ6J)))
};
const $bf79530dc7aa2279$var$smallIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($5pSEP))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($k5t0f))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($gBZ18))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($lImMk))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($8UJE5))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($hLSBq)))
};
const $bf79530dc7aa2279$var$defaultType = 'unknown';
class $bf79530dc7aa2279$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            type: $bf79530dc7aa2279$var$defaultType,
            testId: 'file-type-icon',
            size: 'large'
        };
    }
    render() {
        const { type: type, size: size, testId: testId } = this.props;
        const typeWithDefault = type || $bf79530dc7aa2279$var$defaultType;
        const icons = size === 'large' ? $bf79530dc7aa2279$var$largeIcons : $bf79530dc7aa2279$var$smallIcons;
        const Icon = icons[typeWithDefault] || icons[$bf79530dc7aa2279$var$defaultType];
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            "data-testid": testId,
            "data-type": type,
            className: (0, $hcewu.default)([
                "_1e0c116y",
                $bf79530dc7aa2279$var$iconStyleMap[size ?? 'small']
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                label: "media-type"
            })
        });
    }
}

});



parcelRegister("lk6TK", function(module, exports) {
$parcel$export(module.exports, "messages", () => $9cfa1bfa7cf4055c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $9cfa1bfa7cf4055c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    click_to_join: {
        id: 'fabric.media.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.media.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    request_access: {
        id: 'fabric.media.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_description: {
        id: 'fabric.media.request_access_description',
        defaultMessage: 'Request access to {context} view this preview.',
        description: 'Allows the user to request access to a product'
    },
    request_access_pending: {
        id: 'fabric.media.request_access_pending',
        defaultMessage: 'Access pending',
        description: 'Allows the user to try an action again with their current account'
    },
    request_access_pending_description: {
        id: 'fabric.media.request_access_pending_description',
        defaultMessage: 'Your access request is pending.',
        description: 'Informs the user that their request to view this content is pending'
    },
    forbidden_description: {
        id: 'fabric.media.forbidden_description',
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access.",
        description: 'Informs the user that they cannot view this content.'
    },
    request_denied_description: {
        id: 'fabric.media.request_denied_description',
        defaultMessage: 'Your access request was denied. Contact the site admin if you still need access.',
        description: 'Informs the user that their request to view this content was denied'
    },
    retry: {
        id: 'fabric.media.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    failed_to_load: {
        id: 'fabric.media.failed_to_load',
        defaultMessage: 'Failed to load',
        description: 'We show this message when we have an error loading a file'
    },
    failed_to_upload: {
        id: 'fabric.media.failed_to_upload',
        defaultMessage: 'Failed to upload',
        description: 'We show this message when we have an error uploading a file'
    },
    recent_uploads: {
        id: 'fabric.media.recent_uploads',
        defaultMessage: 'Recent uploads',
        description: 'Title of a section where we show the user recent uploaded files'
    },
    upload_file: {
        id: 'fabric.media.upload_file',
        defaultMessage: 'Upload a file',
        description: 'Call to action that initiates the upload of a file'
    },
    drag_and_drop_your_files: {
        id: 'fabric.media.drag_and_drop_your_files',
        defaultMessage: 'Drag and drop your files anywhere or',
        description: 'Used to describe the area where the user can drag and drop files to upload'
    },
    drag_and_drop_your_files_and_folders: {
        id: 'fabric.media.drag_and_drop_your_files_and_folders',
        defaultMessage: 'Drag and drop your files and folders anywhere or',
        description: 'Used to describe the area where the user can drag and drop files AND folders to upload'
    },
    drop_your_files: {
        id: 'fabric.media.drop_your_files',
        defaultMessage: 'Drop your files to upload',
        description: 'Indicates that the files will be uploaded when the user drops them in the drag and drop area'
    },
    upload: {
        id: 'fabric.media.upload',
        defaultMessage: 'Upload',
        description: 'upload'
    },
    cancel: {
        id: 'fabric.media.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    delete: {
        id: 'fabric.media.delete',
        defaultMessage: 'Delete',
        description: 'delete'
    },
    success: {
        id: 'fabric.media.success',
        defaultMessage: 'Success',
        description: 'success'
    },
    error: {
        id: 'fabric.media.error',
        defaultMessage: 'Error',
        description: 'error'
    },
    search_all_gifs: {
        id: 'fabric.media.search_all_gifs',
        defaultMessage: 'Search all the GIFs!',
        description: 'Used as input placeholder to let the user know that they can search for GIF image files'
    },
    cant_retrieve_gifs: {
        id: 'fabric.media.cant_retrieve_gifs',
        defaultMessage: 'Ouch! We could not retrieve any GIFs',
        description: 'Error message when we can not find any GIF images for that text'
    },
    cant_retrieve_files: {
        id: 'fabric.media.cant_retrieve_files',
        defaultMessage: 'Ouch! We could not retrieve any files',
        description: 'Error message when we can not find any files in dropbox/google drive'
    },
    check_your_network: {
        id: 'fabric.media.check_your_network',
        defaultMessage: 'Check your network connection',
        description: 'Error message when network does not work'
    },
    try_again: {
        id: 'fabric.media.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.media.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    no_gifs_found: {
        id: 'fabric.media.no_gifs_found',
        defaultMessage: "Hello? Was it me you're looking for?",
        description: 'Not expected error that happens when searching for GIF images'
    },
    no_gifs_found_suggestion: {
        id: 'fabric.media.no_gifs_found_suggestion',
        defaultMessage: 'We couldn\'t find anything for "{query}"',
        description: 'There are no results for GIFs matching that query'
    },
    load_more_gifs: {
        id: 'fabric.media.load_more_gifs',
        defaultMessage: 'Load more GIFs',
        description: 'Used to load next page of GIF images'
    },
    add_account: {
        id: 'fabric.media.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    unlink_account: {
        id: 'fabric.media.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    upload_file_from: {
        id: 'fabric.media.upload_file_from',
        defaultMessage: 'Upload a file from {name}',
        description: 'Allows to upload a file from different sources'
    },
    connect_to: {
        id: 'fabric.media.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.media.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.media.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.media.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.media.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.media.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    invalid_permissions: {
        id: 'fabric.media.invalid_permissions',
        defaultMessage: 'Restricted link',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.media.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    select_an_avatar: {
        id: 'fabric.media.select_an_avatar',
        defaultMessage: 'Select a default avatar',
        description: 'Shown when the user selects an avatar from a list of avatars'
    },
    upload_an_avatar: {
        id: 'fabric.media.upload_an_avatar',
        defaultMessage: 'Upload an avatar',
        description: 'Indicates that the user can upload a new avatar'
    },
    select_an_avatar_from_all_defaults: {
        id: 'fabric.media.select_an_avatar_from_all_defaults',
        defaultMessage: 'Select from all default options',
        description: 'Announced when user is required to select an avatar from the complete list of default options'
    },
    show_more_avatars_btn_label: {
        id: 'fabric.media.show_more_avatars_btn_label',
        defaultMessage: 'Show more',
        description: 'Button label to show more default avatar options'
    },
    or_select_default_avatars: {
        id: 'fabric.media.or_select_default_avatars',
        defaultMessage: 'Upload a photo or select from some default options',
        description: 'Announced when a user is required to select an avatar by uploading an avatar or selecting from default options'
    },
    loading: {
        id: 'fabric.media.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    loading_file: {
        id: 'fabric.media.loading_file',
        defaultMessage: 'Loading file...',
        description: 'Shown when a file is being fetched'
    },
    save: {
        id: 'fabric.media.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    or: {
        id: 'fabric.media.or',
        defaultMessage: 'or',
        description: 'Just the "or" word'
    },
    upload_photo: {
        id: 'fabric.media.upload_photo',
        defaultMessage: 'Upload a photo',
        description: 'Call to action for the user to upload a new photo'
    },
    default_avatars: {
        id: 'fabric.media.default_avatars',
        defaultMessage: 'Default avatars',
        description: 'Showed above the default avatar list'
    },
    avatar_picker_back_btn_label: {
        id: 'fabric.media.avatar_picker_back_btn_label',
        defaultMessage: 'Go Back',
        description: 'Button text to navigate back to the previous screen'
    },
    drag_and_drop_images_here: {
        id: 'fabric.media.drag_and_drop_images_here',
        defaultMessage: 'Drag and drop your images here',
        description: 'Indicates that the user can drag and drop images in that area'
    },
    alt_text: {
        id: 'fabric.media.alt_text_label',
        defaultMessage: 'Alt text',
        description: 'Shown above the alt text field'
    },
    alt_text_description: {
        id: 'fabric.media.alt_text_helper_message',
        defaultMessage: 'How would you describe the selected image to someone with low vision?',
        description: 'Shown below the alt text field'
    },
    image_url_invalid_error: {
        id: 'fabric.media.image_url_invalid_error',
        defaultMessage: 'Could not load image, the url is invalid.',
        description: 'There was an error parsing the image url'
    },
    image_format_invalid_error: {
        id: 'fabric.media.image_format_invalid_error',
        defaultMessage: 'Could not load image, the format is invalid.',
        description: 'The provided image format is not valid'
    },
    image_size_too_large_error: {
        id: 'fabric.media.image_size_too_large_error',
        defaultMessage: 'Image is too large, must be no larger than {MAX_SIZE_MB}Mb',
        description: 'The provided image size is too big'
    },
    something_went_wrong: {
        id: 'fabric.media.something_went_wrong',
        defaultMessage: 'Something went wrong.',
        description: 'Showed when an error happen but we dont have more info about it'
    },
    might_be_a_hiccup: {
        id: 'fabric.media.might_be_a_hiccup',
        defaultMessage: 'It might just be a hiccup.',
        description: 'Used when an unknow error happens, just in a funny way of saying that we dont have more info about it'
    },
    couldnt_generate_preview: {
        id: 'fabric.media.couldnt_generate_preview',
        defaultMessage: "We couldn't generate a preview for this file.",
        description: 'Error case for when the backend cant generate a preview for that file'
    },
    couldnt_generate_encrypted_entry_preview: {
        id: 'fabric.media.couldnt_generate_encrypted_entry_preview',
        defaultMessage: "We can't preview encrypted or password protected files.",
        description: 'Error case for when an entry selected is encrypted'
    },
    cant_preview_file_type: {
        id: 'fabric.media.cant_preview_file_type',
        defaultMessage: "We can't preview this file type.",
        description: 'Error case for when we have no available preview for that file'
    },
    item_not_found_in_list: {
        id: 'fabric.media.item_not_found_in_list',
        defaultMessage: 'The selected item was not found on the list.',
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.media.not_found_title',
        defaultMessage: "Uh oh. We can't find this link!",
        description: 'Error case for when a provided link is not found'
    },
    not_found_description: {
        id: 'fabric.media.not_found_description',
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    no_pdf_artifacts: {
        id: 'fabric.media.no_pdf_artifacts',
        defaultMessage: 'No PDF artifacts found for this file.',
        description: 'Error case for when we cant preview a PDF file'
    },
    password_protected_pdf: {
        id: 'fabric.media.password_protected_pdf',
        defaultMessage: 'This file is password protected.',
        description: 'Describing that a PDF cannot be viewed because it is protected by password'
    },
    password: {
        id: 'fabric.media.password',
        defaultMessage: 'Password',
        description: 'Description of Password text field.'
    },
    enter_password: {
        id: 'fabric.media.enter_password',
        defaultMessage: 'Enter password',
        description: 'Prompting user to enter the password.'
    },
    incorrect_password: {
        id: 'fabric.media.incorrect_password',
        defaultMessage: 'Incorrect password. Please try again.',
        description: 'Error case for when a wrong password is inputted.'
    },
    submit: {
        id: 'fabric.media.submit',
        defaultMessage: 'Submit',
        description: 'Description for a button to submit the form.'
    },
    give_feedback: {
        id: 'fabric.media.give_feedback',
        defaultMessage: 'Give feedback',
        description: 'Call to action that opens a popup to get feedback from the users'
    },
    try_downloading_file: {
        id: 'fabric.media.try_downloading_file',
        defaultMessage: 'Try downloading the file to view it.',
        description: 'We show this message to allow users to download a file'
    },
    webgl_warning_description: {
        id: 'fabric.media.webgl_warning_description',
        defaultMessage: 'Your browser does not support WebGL. Use a WebGL enabled browser to annotate images.',
        description: 'We show this error message when the browser doesnt support this feature'
    },
    unable_to_annotate_image: {
        id: 'fabric.media.unable_to_annotate_image',
        defaultMessage: "You're unable to annotate this image",
        description: 'If there is an error trying to annotate an image we show this'
    },
    learn_more: {
        id: 'fabric.media.learn_more',
        defaultMessage: 'Learn More',
        description: ''
    },
    accounts: {
        id: 'fabric.media.accounts',
        defaultMessage: 'Accounts',
        description: ''
    },
    actions: {
        id: 'fabric.media.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    error_hint_retry: {
        id: 'fabric.media.error_hint_retry',
        defaultMessage: "Try again and we'll give it another shot.",
        description: 'Generic message that we show if an action failed'
    },
    error_hint_critical: {
        id: 'fabric.media.error_hint_critical',
        defaultMessage: 'If the problem keeps happening contact support.',
        description: 'We show this error message if we cant recover from the action'
    },
    close: {
        id: 'fabric.media.close',
        defaultMessage: 'Close',
        description: ''
    },
    could_not_load_editor: {
        id: 'fabric.media.could_not_load_editor',
        defaultMessage: 'Ouch! We could not load the editor',
        description: 'Error message to communicate that we cant load the editor'
    },
    could_not_save_image: {
        id: 'fabric.media.could_not_save_image',
        defaultMessage: 'Ouch! We could not save the image',
        description: 'Error message to communicate that we cant save an image'
    },
    could_not_load_link: {
        id: 'fabric.media.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    annotate: {
        id: 'fabric.media.annotate',
        defaultMessage: 'Annotate',
        description: ''
    },
    annotate_tool_arrow: {
        id: 'fabric.media.annotate.tool.arrow',
        defaultMessage: 'Arrow',
        description: ''
    },
    annotate_tool_text: {
        id: 'fabric.media.annotate.tool.text',
        defaultMessage: 'Text',
        description: ''
    },
    annotate_tool_shape: {
        id: 'fabric.media.annotate.tool.shape',
        defaultMessage: 'Shape',
        description: ''
    },
    annotate_tool_brush: {
        id: 'fabric.media.annotate.tool.brush',
        defaultMessage: 'Brush',
        description: ''
    },
    annotate_tool_blur: {
        id: 'fabric.media.annotate.tool.blur',
        defaultMessage: 'Blur',
        description: ''
    },
    annotate_tool_line_thickness: {
        id: 'fabric.media.annotate.tool.line.thickness',
        defaultMessage: 'Line thickness',
        description: ''
    },
    annotate_tool_color: {
        id: 'fabric.media.annotate.tool.color',
        defaultMessage: 'Color',
        description: ''
    },
    annotate_confirmation_close_anyway: {
        id: 'fabric.media.annotate.confirmation.close.anyway',
        defaultMessage: 'Close anyway',
        description: ''
    },
    annotate_confirmation_heading: {
        id: 'fabric.media.annotate.confirmation.heading',
        defaultMessage: 'Unsaved changes',
        description: ''
    },
    annotate_confirmation_content: {
        id: 'fabric.media.annotate.confirmation.content',
        defaultMessage: 'You have some unsaved changes. Are you sure you want to leave?',
        description: ''
    },
    drop_your_files_here: {
        id: 'fabric.media.drop_your_files_here',
        defaultMessage: 'Drop your files here',
        description: 'Info message that we show to indicate that the user can drag and drop files'
    },
    share_files_instantly: {
        id: 'fabric.media.share_files_instantly',
        defaultMessage: "We'll share them instantly",
        description: 'It means that we will upload the files you drag and drop automatically'
    },
    insert_files: {
        id: 'fabric.media.insert_files',
        defaultMessage: 'Insert {0, plural, one {a file} other {{0} files}}',
        description: 'Showed when the user selects 1 or more files to insert'
    },
    zoom_out: {
        id: 'fabric.media.zoom_out',
        defaultMessage: 'zoom out',
        description: 'Indicates the user can zoom out a file'
    },
    zoom_in: {
        id: 'fabric.media.zoom_in',
        defaultMessage: 'zoom in',
        description: 'Indicates the user can zoom in a file'
    },
    remove_image: {
        id: 'fabric.media.remove_image',
        defaultMessage: 'Remove image',
        description: 'Allows the user to remove a file'
    },
    play: {
        id: 'fabric.media.play',
        defaultMessage: 'Play',
        description: ''
    },
    pause: {
        id: 'fabric.media.pause',
        defaultMessage: 'Pause',
        description: ''
    },
    disable_fullscreen: {
        id: 'fabric.media.disable_fullscreen',
        defaultMessage: 'disable fullscreen',
        description: 'Hint to let the user know they can disable the fullscreen mode'
    },
    enable_fullscreen: {
        id: 'fabric.media.enable_fullscreen',
        defaultMessage: 'enable fullscreen',
        description: 'Hint to let the user know they can enable the fullscreen mode'
    },
    error_loading_file: {
        id: 'fabric.media.error_loading_file',
        defaultMessage: 'Error loading file',
        description: 'Message showed when we had an error trying to load the file'
    },
    error_generating_preview: {
        id: 'fabric.media.error_generating_preview',
        defaultMessage: 'Error generating preview',
        description: 'Message showed when we had an error trying generate a preview for a file'
    },
    download: {
        id: 'fabric.media.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_disabled_security_policy: {
        id: 'fabric.media.download_disabled_security_policy',
        defaultMessage: "Download is blocked by your organization's security policy.",
        description: ''
    },
    unknown: {
        id: 'fabric.media.unknown',
        defaultMessage: 'unknown',
        description: ''
    },
    document: {
        id: 'fabric.media.document',
        defaultMessage: 'document',
        description: ''
    },
    audio: {
        id: 'fabric.media.audio',
        defaultMessage: 'audio',
        description: ''
    },
    video: {
        id: 'fabric.media.video',
        defaultMessage: 'video',
        description: ''
    },
    image: {
        id: 'fabric.media.image',
        defaultMessage: 'image',
        description: ''
    },
    archive: {
        id: 'fabric.media.archive',
        defaultMessage: 'archive',
        description: ''
    },
    email: {
        id: 'fabric.media.email',
        defaultMessage: 'email',
        description: ''
    },
    text: {
        id: 'fabric.media.text',
        defaultMessage: 'text',
        description: ''
    },
    displayThumbnail: {
        id: 'fabric.media.display_thumbnail',
        defaultMessage: 'Display thumbnail',
        description: 'Display file with as a thumbnail.'
    },
    search: {
        id: 'fabric.media.search',
        defaultMessage: 'search',
        description: ''
    },
    view: {
        id: 'fabric.media.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.media.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.media.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    changeView: {
        id: 'fabric.media.change_view',
        defaultMessage: 'Change view',
        description: 'In the context of a file, it allows the user to select a different way of displaying the file either as inline or a card'
    },
    playbackSpeed: {
        id: 'fabric.media.playback_speed',
        defaultMessage: 'Playback speed',
        description: 'In the context of a video player, it allows user to switch the speed of the video'
    },
    video_captions_enable: {
        id: 'fabric.media.video_captions_enable',
        defaultMessage: 'Closed Captions',
        description: 'In the context of a video player, it allows user to switch on/off captions'
    },
    video_captions_select_captions: {
        id: 'fabric.media.video_captions_select_captions',
        defaultMessage: 'Select Captions',
        description: 'In the context of a video player, it allows user to select captions'
    },
    video_captions_upload_captions_form_header: {
        id: 'fabric.media.video_captions_upload_captions_form_header',
        defaultMessage: 'Upload Captions',
        description: 'In the context of a video player, it allows user to upload captions'
    },
    video_captions_upload_captions_form_language_picker: {
        id: 'fabric.media.video_captions_upload_captions_form_language_picker',
        defaultMessage: 'Select the file language',
        description: 'In the context of a video player, it allows user to select the language of the uploading captions'
    },
    video_captions_upload_success_description: {
        id: 'fabric.media.video_captions_upload_success_description',
        defaultMessage: 'The caption was successfully uploaded for this video.',
        description: 'In the context of a video player, it provides feedback when a caption was successfully uploadd'
    },
    video_captions_upload_error_description: {
        id: 'fabric.media.video_captions_upload_error_description',
        defaultMessage: 'The caption failed to upload.',
        description: 'In the context of a video player, it provides feedback when a caption failed to upload'
    },
    video_captions_delete_captions_confirmation_header: {
        id: 'fabric.media.video_captions_delete_captions_confirmation_header',
        defaultMessage: 'Delete Caption',
        description: 'In the context of a video player, it provides a confirmation header before deleting captions'
    },
    video_captions_delete_captions_confirmation_description: {
        id: 'fabric.media.video_captions_delete_captions_confirmation_description',
        defaultMessage: 'Please confirm that you want to delete this caption.',
        description: 'In the context of a video player, it provides a confirmation description before deleting captions'
    },
    video_captions_delete_success_description: {
        id: 'fabric.media.video_captions_delete_success_description',
        defaultMessage: 'The caption was successfully removed from this video.',
        description: 'In the context of a video player, it provides feedback when a caption was successfully deleted'
    },
    video_captions_delete_error_description: {
        id: 'fabric.media.video_captions_delete_error_description',
        defaultMessage: 'The caption failed to delete.',
        description: 'In the context of a video player, it provides feedback when a caption failed to delete'
    },
    manage_captions: {
        id: 'fabric.media.manage_captions',
        defaultMessage: 'Manage Captions',
        description: 'In the context of a video player, it allows user to manage captions'
    },
    add_captions: {
        id: 'fabric.media.add_captions',
        defaultMessage: 'Add Captions',
        description: 'In the context of a video player, it allows user to add captions'
    },
    skipBackward: {
        id: 'fabric.media.skip_backward',
        defaultMessage: 'Back 10 seconds',
        description: 'In the context of a video player, it allows user to skip 10 seconds of play time backward.'
    },
    skipForward: {
        id: 'fabric.media.skip_forward',
        defaultMessage: 'Forward 10 seconds',
        description: 'In the context of a video player, it allows user to skip 10 seconds of play time forward.'
    },
    sizeOptions: {
        id: 'fabric.media.size_options',
        defaultMessage: 'Size options',
        description: 'A dropdown with buttons that allow to convert an image to an inline or to an image or original size'
    },
    fileDisplayOptions: {
        id: 'fabric.media.file.display_options',
        defaultMessage: 'Display options',
        description: 'A dropdown with buttons that allow to convert between an inline file or a thumbnail file'
    },
    volumeLevelControlAria: {
        id: 'fabric.media.volume_level',
        defaultMessage: 'volume',
        description: 'In the context of a video player and screen reader. Aria label for volume level control'
    },
    volumeMuteButtonAria: {
        id: 'fabric.media.volume_level',
        defaultMessage: 'mute',
        description: 'In the context of a video player and screen reader. Aria label for mute button'
    },
    playbackDefaultSpeed: {
        id: 'fabric.media.playback_default_speed',
        defaultMessage: 'Default',
        description: 'In the context of a video player, it is a value of a default playback speed'
    },
    preview: {
        id: 'fabric.media.preview',
        defaultMessage: 'Preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    creating_preview: {
        id: 'fabric.media.creating_preview',
        defaultMessage: 'Creating preview...',
        description: 'Preview is being created for a media card'
    },
    preview_unavailable: {
        id: 'fabric.media.preview_unavailable',
        defaultMessage: 'Preview unavailable',
        description: 'Preview is unavailable for a media card'
    },
    couldnt_load_file: {
        id: 'fabric.media.couldnt_load_file',
        defaultMessage: "We couldn't load the file.",
        description: 'File is rate limited without metadata'
    },
    error_429: {
        id: 'fabric.media.error_429',
        defaultMessage: 'Error 429',
        description: 'Error 429 is thrown'
    },
    close_and_reopen: {
        id: 'fabric.media.close_and_reopen',
        defaultMessage: 'Try closing this file and reopening.',
        description: 'The preview is rate limited'
    },
    viewer_rateLimited: {
        id: 'fabric.media.viewer_rateLimited',
        defaultMessage: `We're having difficulties loading your file.`,
        description: 'Mediaviewer has been rate limited'
    },
    zip_entry_load_fail: {
        id: 'fabric.media.zip_entry_load_failed',
        defaultMessage: `We couldn't load that zip file item to preview`,
        description: 'Zip entry failed to load'
    },
    file_image_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Image {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded image'
    },
    file_video_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Video {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded video'
    },
    file_audio_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Audio {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded audio'
    },
    file_doc_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Document {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded document'
    },
    file_archive_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Archive {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded archive'
    },
    file_unknown_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'File {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded file'
    },
    open_file_in_viewer: {
        id: 'fabric.media.open_file_in_viewer',
        defaultMessage: 'Open {name}',
        description: 'Shown when user focuses on preview to open the full screen viewer of the file with {name}'
    },
    video_seeker_assistive_text_time_value: {
        id: 'fabric.media.video_seeker_assistive_text_time_value',
        defaultMessage: '{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}',
        description: 'Video time seeker information for screen reader users - final format example: 1 hour 12 minutes 13 seconds of 1 hours 16 minutes 1 second. Units are already translated via Intl.NumberFormat'
    },
    video_seeker_label_assistive_text: {
        id: 'fabric.media.video_seeker_label_assistive_text',
        defaultMessage: 'Seek slider',
        description: 'Video time seek slider aria-label'
    },
    abuse_modal_body: {
        id: 'fabric.media.abuse_modal_body',
        defaultMessage: 'For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content',
        description: 'Abuse Modal Body Message'
    },
    abuse_modal_title: {
        id: 'fabric.media.abuse_modal_title',
        defaultMessage: 'Warning',
        description: 'Abuse Modal Title'
    },
    abuse_modal_submit: {
        id: 'fabric.media.abuse_modal_submit',
        defaultMessage: 'Proceed with download',
        description: 'Abuse Modal Submit button caption'
    },
    image_cropper_arrow_keys_label: {
        id: 'media.media-avatar-picker.image-cropper.arrow-keys.label',
        defaultMessage: 'Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image',
        description: 'Inform about the image crop functionality using arrow keys'
    },
    image_cropper_image_moved: {
        id: 'media.media-avatar-picker.image-cropper.arrow-keys.action',
        defaultMessage: 'You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image',
        description: 'Inform about the image movement when the arrow keys are pressed'
    },
    image_cropper_zoom_out: {
        id: 'media.media-avatar-picker.image-cropper.zoom_out',
        defaultMessage: 'Zoom out',
        description: 'Label for the zoom out button in image cropper slider'
    },
    image_cropper_zoom_in: {
        id: 'media.media-avatar-picker.image-cropper.zoom_in',
        defaultMessage: 'Zoom in',
        description: 'Label for the zoom in button in image cropper slider'
    },
    image_cropper_zoom_slider: {
        id: 'media.media-avatar-picker.image-cropper.zoom_slider',
        defaultMessage: 'set zoom',
        description: 'Label for the zoom slider to adjust image zoom'
    }
});

});

parcelRegister("k7TlJ", function(module, exports) {
$parcel$export(module.exports, "ImageRenderer", () => $a8739f8ac0d29f69$export$a8e6523ab063becd);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $efSBe = parcelRequire("efSBe");

var $7pbB3 = parcelRequire("7pbB3");

var $eGOwo = parcelRequire("eGOwo");
const $a8739f8ac0d29f69$export$a8e6523ab063becd = (props)=>{
    return (0, $eGOwo.fg)('platform_media_card_image_render') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7pbB3.ImageRenderer), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $efSBe.ImageRenderer), {
        ...props
    });
};

});
parcelRegister("efSBe", function(module, exports) {
$parcel$export(module.exports, "ImageRenderer", () => $12a60c87332b0c69$export$a8e6523ab063becd);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eJ3rj = parcelRequire("eJ3rj");

var $hsNRo = parcelRequire("hsNRo");

var $kszJO = parcelRequire("kszJO");
const $12a60c87332b0c69$export$a8e6523ab063becd = ({ cardPreview: cardPreview, alt: alt, resizeMode: resizeMode, onImageLoad: onImageLoad, onImageError: onImageError, onDisplayImage: onDisplayImage, mediaType: mediaType, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay })=>{
    const onDisplayImageRef = (0, $kszJO.useCurrentValueRef)(onDisplayImage);
    (0, $eJOHy.useEffect)(()=>{
        // TODO: trigger accordingly with the succeeded event. This could be a breaking change
        if (mediaType === 'image') onDisplayImageRef.current?.();
    }, [
        mediaType,
        onDisplayImageRef
    ]);
    const onLoad = ()=>{
        onImageLoad && cardPreview && onImageLoad(cardPreview);
    };
    const onError = ()=>{
        onImageError && cardPreview && onImageError(cardPreview);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ3rj.MediaImage), {
        dataURI: cardPreview?.dataURI,
        alt: alt,
        previewOrientation: cardPreview?.orientation,
        onImageLoad: onLoad,
        onImageError: onError,
        loading: nativeLazyLoad ? 'lazy' : undefined,
        forceSyncDisplay: forceSyncDisplay,
        ...(0, $hsNRo.resizeModeToMediaImageProps)(resizeMode)
    });
};

});
parcelRegister("eJ3rj", function(module, exports) {
$parcel$export(module.exports, "MediaImage", () => $ae3b633856a58a58$export$1f97dc1e9d072692);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jgJtD = parcelRequire("jgJtD");

var $2gvG4 = parcelRequire("2gvG4");

var $7meaC = parcelRequire("7meaC");

var $kHzU5 = parcelRequire("kHzU5");

var $82KGI = parcelRequire("82KGI");
const $ae3b633856a58a58$export$1f97dc1e9d072692 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ dataURI: dataURI, alt: alt = '', crop: crop = false, stretch: stretch = false, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: forceSyncDisplay = false }, ref)=>{
    const [{ width: parentWidth, height: parentHeight }, setParentDimensions] = (0, $eJOHy.useState)({
        width: Infinity,
        height: Infinity
    });
    const [{ width: imgWidth, height: imgHeight }, setImageDimensions] = (0, $eJOHy.useState)({
        width: 0,
        height: 0
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $eJOHy.useState)(false);
    const imgRef = (0, $eJOHy.useRef)(null);
    const imageRef = (0, $eJOHy.useCallback)((imgElem)=>{
        if (!imgElem || imgRef.current) return;
        if (imgElem.parentElement) {
            const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
            setParentDimensions({
                width: width,
                height: height
            });
        }
        imgRef.current = imgElem;
    }, []);
    const mergedRef = (0, $82KGI.useMergeRefs)([
        imageRef,
        ref
    ]);
    const imageLoadHandler = (e)=>{
        if (!imgRef.current) return;
        setImageDimensions({
            width: imgRef.current.naturalWidth,
            height: imgRef.current.naturalHeight
        });
        setIsImageLoaded(true);
        onImageLoad?.(e.currentTarget);
    };
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = '100%';
    /*
      Cover strategy means we want to full entire screen with an image. Here is an example:

         Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
    /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:

             Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
    const isImageRotated = previewOrientation !== 'from-image' && (0, $kHzU5.isRotated)(previewOrientation);
    /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:

      Example #1:

      Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘

      Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6

      To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.

      In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

      According to this variables state css will become:
        height: 100%;

      Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.

      ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.

      And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:

      ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘

      To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)

      New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px

      ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘

      Unfortunately this is not over yet.



      Example #2:

      Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6

      Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

       According to this variables state css will become:
        width: 100%;

      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.

      ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.

      Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘

      This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%

      New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px

      So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:

        Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|

      For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
    /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    const style = {
        transform: 'translate(-50%, -50%)'
    };
    if (isStretchingAllowed) {
        if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
          Image matches its width to container's and height scales accordingly.

            Image       Container       Result
                       ┌─────────┐    ┌─────────┐
           ┌──────┐    │         │    ├─────────┤
           │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           └──────┘    │         │    ├─────────┤
                       └─────────┘    └─────────┘
         */ style.width = percentSize;
        else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
          Image matches its height to container's and width scales accordingly.
         */ style.height = percentSize;
        else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          In order to cover whole container guaranteed (even in expense of stretching)
          image matches its height to container's. Width scales accordingly and crops out sides.

             Image       Container    Result (░ - is what cropped out)
                       ┌─────────┐    ┌──┬──────┬──┐
           ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
           └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                       └─────────┘    └──┴──────┴──┘
         */ style.height = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
    } else {
        if (isFitStrategy) {
            /*
          We want image to be as wide and as height as container but not bigger then it's own size.

            Image       Container       Result
           ┌───────────┐    ┌─────────┐    ┌─────────┐
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
           └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                            │         │    ├─────────┤
                            └─────────┘    └─────────┘

         And if image is smaller it doesn't change its size

            Image       Container       Result
                       ┌──────────┐    ┌──────────┐
                       │          │    │          │
           ┌──────┐    │          │    │ ┌──────┐ │
           │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
           │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
           └──────┘    │          │    │ └──────┘ │
                       │          │    │          │
                       └──────────┘    └──────────┘
         */ style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          We want to fill container but we can't stretch an image if it's smaller then container.

            Image            Container       Result
           ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
           └────────────┘

         */ style.maxHeight = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
    }
    if (!showImage || !dataURI) style.display = 'none';
    if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
    else if (previewOrientation > 1) {
        const transform = (0, $kHzU5.getCssFromImageOrientation)(previewOrientation);
        style.transform += ` ${transform}`;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2gvG4.default), {
                data: {
                    hasMediaComponent: true
                }
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7meaC.ImageComponent), {
                loading: loading,
                "data-testid": "media-image",
                "data-vc": "media-image",
                draggable: false,
                alt: alt,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                onLoad: imageLoadHandler,
                onError: onImageError,
                imageRef: mergedRef,
                src: dataURI,
                crossOrigin: crossOrigin,
                ...(0, $jgJtD.VcMediaWrapperProps)
            })
        ]
    });
});

});
parcelRegister("2gvG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbfbe10f2ed80f4c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $bbfbe10f2ed80f4c$export$d12f56a472cdbe6c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $bbfbe10f2ed80f4c$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    (0, $eJOHy.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $bbfbe10f2ed80f4c$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $2QO3b.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $2QO3b.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("7meaC", function(module, exports) {
$parcel$export(module.exports, "ImageComponent", () => $decf1876772446e6$export$fd536c918b58ab76);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $decf1876772446e6$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $decf1876772446e6$export$fd536c918b58ab76 = (props)=>{
    const { style: style, imageRef: imageRef, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jsx-a11y/alt-text -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        ...otherProps,
        ref: imageRef,
        style: {
            ...$decf1876772446e6$var$imgStyle,
            ...style
        }
    }));
};

});

parcelRegister("kHzU5", function(module, exports) {
$parcel$export(module.exports, "isRotated", () => $d080920ecf648ea4$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $d080920ecf648ea4$export$43142f95b8de7a91);
const $d080920ecf648ea4$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $d080920ecf648ea4$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $d080920ecf648ea4$export$43142f95b8de7a91 = (orientation)=>{
    return $d080920ecf648ea4$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("hsNRo", function(module, exports) {
$parcel$export(module.exports, "resizeModeToMediaImageProps", () => $9b431bed70199119$export$31853d267a6d0b0b);
function $9b431bed70199119$export$31853d267a6d0b0b(resizeMode) {
    return {
        crop: resizeMode === 'crop',
        stretch: resizeMode === 'stretchy-fit'
    };
}

});


parcelRegister("7pbB3", function(module, exports) {
$parcel$export(module.exports, "ImageRenderer", () => $4f14bb82c1003677$export$a8e6523ab063becd);
/* imageRendererV2.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $25Itv = parcelRequire("25Itv");

var $kszJO = parcelRequire("kszJO");

var $fZ5T8 = parcelRequire("fZ5T8");

var $4n4MY = parcelRequire("4n4MY");

var $eGOwo = parcelRequire("eGOwo");

var $2gvG4 = parcelRequire("2gvG4");

var $7aoMz = parcelRequire("7aoMz");
const $4f14bb82c1003677$var$baseStyles = null;
const $4f14bb82c1003677$var$backgroundStyles = null;
const $4f14bb82c1003677$export$a8e6523ab063becd = ({ cardPreview: cardPreview, alt: alt = '', resizeMode: resizeMode = 'crop', onImageLoad: onImageLoad, onImageError: onImageError, onDisplayImage: onDisplayImage, mediaType: mediaType, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay, identifier: identifier, wrapperRef: wrapperRef, useWhiteBackground: useWhiteBackground, testId: testId })=>{
    const onDisplayImageRef = (0, $kszJO.useCurrentValueRef)(onDisplayImage);
    const ufoContext = (0, $7aoMz.useInteractionContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (mediaType === 'image') onDisplayImageRef.current?.();
    }, [
        mediaType,
        onDisplayImageRef
    ]);
    const [didRender, setDidRender] = (0, $eJOHy.useState)(false);
    const [resolvedDimensions, setResolvedDimensions] = (0, $eJOHy.useState)((0, $25Itv.calculateInitialDimensions)(resizeMode));
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!didRender && (0, $eGOwo.fg)('platfrom_close_blindspot_for_img')) return ufoContext?.hold('img-loading');
    }, [
        didRender,
        ufoContext
    ]);
    const imgRef = (0, $eJOHy.useRef)(null);
    const onLoad = (evt)=>{
        wrapperRef.current && setResolvedDimensions((0, $25Itv.calculateDimensions)(evt.currentTarget, wrapperRef.current, resizeMode));
        setDidRender(true);
        cardPreview && onImageLoad?.(cardPreview);
    };
    const onError = ()=>{
        onImageError && cardPreview && onImageError(cardPreview);
    };
    (0, $eJOHy.useEffect)(()=>{
        if (imgRef.current && wrapperRef.current && imgRef.current) setResolvedDimensions((0, $25Itv.calculateDimensions)(imgRef.current, wrapperRef.current, resizeMode));
    }, [
        resizeMode,
        wrapperRef
    ]);
    return cardPreview ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fZ5T8.ImageRendererWrapper), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2gvG4.default), {
                data: {
                    hasMediaComponent: true
                }
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                ref: imgRef,
                "data-testid": testId,
                "data-fileid": (0, $4n4MY.isFileIdentifier)(identifier) ? identifier.id : null,
                "data-filecollection": (0, $4n4MY.isFileIdentifier)(identifier) ? identifier.collectionName : null,
                "data-resizemode": resizeMode,
                "data-source": cardPreview.source,
                src: cardPreview.dataURI,
                alt: alt,
                onLoad: onLoad,
                onError: onError,
                loading: nativeLazyLoad ? 'lazy' : undefined,
                style: {
                    visibility: didRender || forceSyncDisplay ? 'visible' : 'hidden',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    ...resolvedDimensions
                },
                className: (0, $hcewu.default)([
                    "_5ral1f51",
                    useWhiteBackground && "_bfhku67f"
                ])
            })
        ]
    }) : null;
};

});
parcelRegister("25Itv", function(module, exports) {
$parcel$export(module.exports, "calculateDimensions", () => $607edd1e285dae89$export$da67e68efa508cf6);
$parcel$export(module.exports, "calculateInitialDimensions", () => $607edd1e285dae89$export$6e6f68a4ed3ceffe);
const $607edd1e285dae89$export$da67e68efa508cf6 = (imgElement, parentElement, resizeMode)=>{
    const { naturalWidth: naturalWidth, width: width, naturalHeight: naturalHeight, height: height } = imgElement;
    // Firefox & Safari can't always read the "natural" dimensions correctly.
    // When these are undefined or zero, we replace them with the rendered values
    const imgWidth = naturalWidth || width;
    const imgHeight = naturalHeight || height;
    const { width: parentWidth, height: parentHeight } = parentElement.getBoundingClientRect();
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `min(100%, ${imgWidth}px)`,
        maxHeight: `min(100%, ${imgHeight}px)`
    };
    const imgRatio = imgWidth / imgHeight;
    const cardRatio = parentWidth / parentHeight;
    const isImageLandscapier = imgRatio > cardRatio;
    if (resizeMode === 'stretchy-fit') {
        if (isImageLandscapier) return {
            width: '100%',
            maxHeight: '100%'
        };
        else return {
            height: '100%',
            maxWidth: '100%'
        };
    }
    if (resizeMode === 'crop') {
        if (isImageLandscapier) return {
            height: imgHeight,
            maxHeight: '100%'
        };
        else return {
            width: imgWidth,
            maxWidth: '100%'
        };
    }
    return {};
};
const $607edd1e285dae89$export$6e6f68a4ed3ceffe = (resizeMode)=>{
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `100%`,
        maxHeight: `100%`
    };
    if (resizeMode === 'stretchy-fit') // assume the image is landscape
    return {
        width: '100%',
        maxHeight: '100%'
    };
    // resizeMode === 'crop'
    // assume the image is landscape
    return {
        width: '100%'
    };
};

});

parcelRegister("fZ5T8", function(module, exports) {
$parcel$export(module.exports, "ImageRendererWrapper", () => $a03d5f4f11d5c598$export$e2adeb4aa5a3be1d);
/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $a03d5f4f11d5c598$var$wrapperStyles = null;
const $a03d5f4f11d5c598$export$e2adeb4aa5a3be1d = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": "ImageRendererWrapper",
        className: (0, $hcewu.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
        ]),
        children: children
    });

});



parcelRegister("cZsO3", function(module, exports) {
$parcel$export(module.exports, "TitleBox", () => $804c8fae2bbf1727$export$e3ce443f3b72c291);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $eDFE1 = parcelRequire("eDFE1");

var $jEm2W = parcelRequire("jEm2W");

var $3zvdv = parcelRequire("3zvdv");

var $1xVuR = parcelRequire("1xVuR");
const $804c8fae2bbf1727$var$placeholderText = ' ';
const $804c8fae2bbf1727$var$isValidTimestamp = (timeStamp)=>new Date(timeStamp).getTime() > 0;
const $804c8fae2bbf1727$export$e3ce443f3b72c291 = (0, $6YFG2.default)(({ name: name, createdAt: createdAt, breakpoint: breakpoint, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, hidden: hidden, intl: intl })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1xVuR.TitleBoxWrapper), {
        hidden: hidden,
        breakpoint: breakpoint,
        titleBoxBgColor: titleBoxBgColor,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xVuR.TitleBoxHeader), {
                hasIconOverlap: !!titleBoxIcon && !createdAt,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jEm2W.Truncate), {
                    text: name ?? $804c8fae2bbf1727$var$placeholderText
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xVuR.TitleBoxFooter), {
                hasIconOverlap: !!titleBoxIcon,
                children: createdAt !== undefined && $804c8fae2bbf1727$var$isValidTimestamp(createdAt) ? (0, $3zvdv.formatDate)(createdAt, intl?.locale ?? 'en') : $804c8fae2bbf1727$var$placeholderText
            }),
            titleBoxIcon === 'LockFilledIcon' && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xVuR.TitleBoxIcon), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eDFE1))), {
                    color: "currentColor",
                    label: "",
                    LEGACY_size: "small",
                    size: "small"
                })
            })
        ]
    }), {
    enforceContext: false
});

});
parcelRegister("eDFE1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7218fd1b3900cbe5e5759b8477131dab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02c014b15cbf2673$var$_react = $02c014b15cbf2673$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $02c014b15cbf2673$var$_lockLocked = $02c014b15cbf2673$var$_interopRequireDefault((parcelRequire("9QgTI")));

var $02c014b15cbf2673$var$_lockFilled = $02c014b15cbf2673$var$_interopRequireDefault((parcelRequire("kKPzl")));
function $02c014b15cbf2673$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02c014b15cbf2673$var$LockLockedIcon = (props)=>/*#__PURE__*/ $02c014b15cbf2673$var$_react.default.createElement($02c014b15cbf2673$var$_lockLocked.default, Object.assign({
        name: "LockLockedIcon",
        LEGACY_fallbackIcon: $02c014b15cbf2673$var$_lockFilled.default
    }, props));
$02c014b15cbf2673$var$LockLockedIcon.displayName = 'LockLockedIconMigration';
var $02c014b15cbf2673$var$_default = module.exports.default = $02c014b15cbf2673$var$LockLockedIcon;

});

parcelRegister("jEm2W", function(module, exports) {
$parcel$export(module.exports, "Truncate", () => $e8bda2d6bfc11597$export$cf4c160b6f7612df);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eeQTh = parcelRequire("eeQTh");

var $h5k1R = parcelRequire("h5k1R");

var $eGOwo = parcelRequire("eGOwo");
const $e8bda2d6bfc11597$export$cf4c160b6f7612df = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h5k1R.Truncate), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eeQTh.Truncate), {
        ...props
    });
const $e8bda2d6bfc11597$export$79559b74b73162c4 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h5k1R.TruncateLeft), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eeQTh.TruncateLeft), {
        ...props
    });
const $e8bda2d6bfc11597$export$59f20ffe54d328be = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h5k1R.TruncateRight), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eeQTh.TruncateRight), {
        ...props
    });

});
parcelRegister("eeQTh", function(module, exports) {
$parcel$export(module.exports, "TruncateLeft", () => $6fdaa5353b2e6db0$export$79559b74b73162c4);
$parcel$export(module.exports, "TruncateRight", () => $6fdaa5353b2e6db0$export$59f20ffe54d328be);
$parcel$export(module.exports, "Truncate", () => $6fdaa5353b2e6db0$export$cf4c160b6f7612df);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $h5k1R = parcelRequire("h5k1R");

var $aWILV = parcelRequire("aWILV");
const $6fdaa5353b2e6db0$var$truncateCommonStyles = `
  display: inline-block;
  vertical-align: bottom;
  white-space: nowrap;
  overflow: hidden;
`;
const $6fdaa5353b2e6db0$export$79559b74b73162c4 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ery3jaq1"
})($6fdaa5353b2e6db0$var$truncateCommonStyles, " max-width:calc(100% - ", ({ fontSizePX: fontSizePX, endFixedChars: endFixedChars })=>$6fdaa5353b2e6db0$var$fontFaceScaleFactor(fontSizePX) * endFixedChars + 1, "em);min-width:", ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars })=>$6fdaa5353b2e6db0$var$fontFaceScaleFactor(fontSizePX) * startFixedChars, ";text-overflow:ellipsis;");
const $6fdaa5353b2e6db0$export$59f20ffe54d328be = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ery3jaq0"
})($6fdaa5353b2e6db0$var$truncateCommonStyles, " max-width:calc(100% - ", ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars })=>$6fdaa5353b2e6db0$var$fontFaceScaleFactor(fontSizePX) * startFixedChars, ");position:relative;");
const $6fdaa5353b2e6db0$var$fontFaceScaleFactor = (fontSizePX)=>fontSizePX / 11 * 0.46; /* factor for fontSize of 11px */ 
const $6fdaa5353b2e6db0$var$placeholder = ' ';
const $6fdaa5353b2e6db0$export$cf4c160b6f7612df = ({ text: text, fontSizePX: fontSizePX = 11, startFixedChars: // Must be calibrated with fontSize
startFixedChars = 4, endFixedChars: // 1 char + 3 dots
endFixedChars = 7 // file extension 3/4 chars + a fraction of the name
 })=>{
    const { left: leftStr, right: rightStr } = (0, $h5k1R.calculateTruncation)(text, startFixedChars, endFixedChars);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($6fdaa5353b2e6db0$export$79559b74b73162c4, {
                fontSizePX: fontSizePX,
                startFixedChars: startFixedChars,
                endFixedChars: endFixedChars,
                "data-testid": "truncate-left",
                children: leftStr
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($6fdaa5353b2e6db0$export$59f20ffe54d328be, {
                fontSizePX: fontSizePX,
                startFixedChars: startFixedChars,
                endFixedChars: endFixedChars,
                "data-testid": "truncate-right",
                children: leftStr === rightStr ? $6fdaa5353b2e6db0$var$placeholder : rightStr
            })
        ]
    });
};

});
parcelRegister("h5k1R", function(module, exports) {
$parcel$export(module.exports, "calculateTruncation", () => $690e7d763239d2fd$export$76bc6de55c805afb);
$parcel$export(module.exports, "TruncateLeft", () => $690e7d763239d2fd$export$79559b74b73162c4);
$parcel$export(module.exports, "TruncateRight", () => $690e7d763239d2fd$export$59f20ffe54d328be);
$parcel$export(module.exports, "Truncate", () => $690e7d763239d2fd$export$cf4c160b6f7612df);
/* truncateText-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $690e7d763239d2fd$export$76bc6de55c805afb = (text, startFixedChars, endFixedChars)=>{
    const minAllowedLength = endFixedChars + startFixedChars;
    if (text.length <= minAllowedLength) // if no truncation return same value for left and right
    return {
        left: text,
        right: text
    };
    const splitAt = text.length - endFixedChars;
    const left = text.substr(0, splitAt);
    const right = text.substr(splitAt);
    return {
        left: left,
        right: right
    };
};
const $690e7d763239d2fd$var$truncateCommonStyles = null;
const $690e7d763239d2fd$var$truncateLeftStyles = null;
const $690e7d763239d2fd$export$79559b74b73162c4 = ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars, endFixedChars: endFixedChars, children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            maxWidth: `calc(
		100% -
			${$690e7d763239d2fd$var$fontFaceScaleFactor(fontSizePX) * endFixedChars + 1}em
	)`,
            minWidth: $690e7d763239d2fd$var$fontFaceScaleFactor(fontSizePX) * startFixedChars
        },
        "data-testid": "truncate-left",
        ...props,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _s7n4yfq0 _o5721q9c",
            "_1bto1l2s"
        ]),
        children: children
    });
const $690e7d763239d2fd$var$truncateRightStyles = null;
const $690e7d763239d2fd$export$59f20ffe54d328be = ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars, endFixedChars: endFixedChars, children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            maxWidth: `calc(
				100% -
					${({ fontSizePX: fontSizePX, startFixedChars: startFixedChars })=>$690e7d763239d2fd$var$fontFaceScaleFactor(fontSizePX) * startFixedChars}
			)`
        },
        "data-testid": "truncate-right",
        ...props,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _s7n4yfq0 _o5721q9c",
            "_kqswh2mm"
        ]),
        children: children
    });
const $690e7d763239d2fd$var$fontFaceScaleFactor = (fontSizePX)=>fontSizePX / 11 * 0.46; /* factor for fontSize of 11px */ 
const $690e7d763239d2fd$var$placeholder = ' ';
const $690e7d763239d2fd$export$cf4c160b6f7612df = ({ text: text, fontSizePX: fontSizePX = 11, startFixedChars: // Must be calibrated with fontSize
startFixedChars = 4, endFixedChars: // 1 char + 3 dots
endFixedChars = 7 // file extension 3/4 chars + a fraction of the name
 })=>{
    const { left: leftStr, right: rightStr } = $690e7d763239d2fd$export$76bc6de55c805afb(text, startFixedChars, endFixedChars);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($690e7d763239d2fd$export$79559b74b73162c4, {
                fontSizePX: fontSizePX,
                startFixedChars: startFixedChars,
                endFixedChars: endFixedChars,
                children: leftStr
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($690e7d763239d2fd$export$59f20ffe54d328be, {
                fontSizePX: fontSizePX,
                startFixedChars: startFixedChars,
                endFixedChars: endFixedChars,
                children: leftStr === rightStr ? $690e7d763239d2fd$var$placeholder : rightStr
            })
        ]
    });
};

});



parcelRegister("3zvdv", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $8c1089fe5577dbb6$export$3ae94a2503e890a1);

var $cK9J2 = parcelRequire("cK9J2");
const $8c1089fe5577dbb6$export$f34a3540a1aa68e4 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
};
const $8c1089fe5577dbb6$export$20911720278c41 = ({ day: day, month: month, year: year, hour: hour, minute: minute, dayPeriod: dayPeriod = '' })=>{
    const formattedDayPeriod = dayPeriod.replace(/\./g, '').replace(/\s/g, '');
    return `${day} ${month} ${year}, ${hour}:${minute} ${formattedDayPeriod}`;
};
const $8c1089fe5577dbb6$export$3ae94a2503e890a1 = (timestamp, locale = 'en')=>{
    const l10n = (0, $cK9J2.createLocalizationProvider)(locale, $8c1089fe5577dbb6$export$f34a3540a1aa68e4);
    return $8c1089fe5577dbb6$export$20911720278c41(l10n.formatToParts(timestamp));
};

});
parcelRegister("cK9J2", function(module, exports) {
$parcel$export(module.exports, "createLocalizationProvider", () => $2150f4a906bcb332$export$ea56ca58f08ffa52);

var $4ZGCx = parcelRequire("4ZGCx");

var $ktSIT = parcelRequire("ktSIT");

var $92aEh = parcelRequire("92aEh");
const $2150f4a906bcb332$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $ktSIT.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("4ZGCx", function(module, exports) {
$parcel$export(module.exports, "normalizeLocale", () => $caa7b379de4e9e4d$export$dca0327c9b9c6498);
const $caa7b379de4e9e4d$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("ktSIT", function(module, exports) {
$parcel$export(module.exports, "createDateParser", () => $f0407708fddca50b$export$cfa2ef2687faeda2);

var $4ZGCx = parcelRequire("4ZGCx");

var $61I7t = parcelRequire("61I7t");
const $f0407708fddca50b$var$INVALID_DATE = new Date(NaN);
const $f0407708fddca50b$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $f0407708fddca50b$var$INVARIANT_DATE = (0, $61I7t.toDate)($f0407708fddca50b$var$INVARIANT);
const $f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $f0407708fddca50b$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $f0407708fddca50b$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $f0407708fddca50b$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $f0407708fddca50b$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($f0407708fddca50b$var$INVARIANT_DATE);
    const shortDate = $f0407708fddca50b$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $f0407708fddca50b$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $f0407708fddca50b$var$stripExtras(date).match($f0407708fddca50b$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $f0407708fddca50b$var$INVALID_DATE;
        const dateParts = $f0407708fddca50b$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $61I7t.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $61I7t.isValid)(normalizedDate)) return $f0407708fddca50b$var$INVALID_DATE;
        return (0, $61I7t.toDate)(normalizedDate);
    };
};

});
parcelRegister("61I7t", function(module, exports) {
$parcel$export(module.exports, "toDate", () => $862914b96a01ecbb$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $862914b96a01ecbb$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $862914b96a01ecbb$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $862914b96a01ecbb$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $862914b96a01ecbb$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $862914b96a01ecbb$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $862914b96a01ecbb$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $862914b96a01ecbb$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $862914b96a01ecbb$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $862914b96a01ecbb$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $862914b96a01ecbb$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $862914b96a01ecbb$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("92aEh", function(module, exports) {
$parcel$export(module.exports, "toFormattedParts", () => $0bfc942d7a009811$export$9b7ca29af37c192);
const $0bfc942d7a009811$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});



parcelRegister("1xVuR", function(module, exports) {
$parcel$export(module.exports, "TitleBoxWrapper", () => $f90f990023930c3b$export$213c428ce4ec143c);
$parcel$export(module.exports, "TitleBoxHeader", () => $f90f990023930c3b$export$43970d913b015380);
$parcel$export(module.exports, "TitleBoxFooter", () => $f90f990023930c3b$export$1004da4fc5583975);
$parcel$export(module.exports, "TitleBoxIcon", () => $f90f990023930c3b$export$70e996312f72d22d);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $f90f990023930c3b$export$9e874bb1adc98a55);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $fFepK = parcelRequire("fFepK");

var $2ODnB = parcelRequire("2ODnB");
const $f90f990023930c3b$export$213c428ce4ec143c = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fFepK.TitleBoxWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2ODnB.TitleBoxWrapper), {
        ...props
    });
const $f90f990023930c3b$export$43970d913b015380 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fFepK.TitleBoxHeader), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2ODnB.TitleBoxHeader), {
        ...props
    });
const $f90f990023930c3b$export$1004da4fc5583975 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fFepK.TitleBoxFooter), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2ODnB.TitleBoxFooter), {
        ...props
    });
const $f90f990023930c3b$export$70e996312f72d22d = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fFepK.TitleBoxIcon), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2ODnB.TitleBoxIcon), {
        ...props
    });
const $f90f990023930c3b$export$9e874bb1adc98a55 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fFepK.ErrorMessageWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2ODnB.ErrorMessageWrapper), {
        ...props
    });

});
parcelRegister("fFepK", function(module, exports) {
$parcel$export(module.exports, "TitleBoxWrapper", () => $286b56541a4aa25a$export$213c428ce4ec143c);
$parcel$export(module.exports, "TitleBoxHeader", () => $286b56541a4aa25a$export$43970d913b015380);
$parcel$export(module.exports, "TitleBoxFooter", () => $286b56541a4aa25a$export$1004da4fc5583975);
$parcel$export(module.exports, "TitleBoxIcon", () => $286b56541a4aa25a$export$70e996312f72d22d);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $286b56541a4aa25a$export$9e874bb1adc98a55);
/* titleBoxComponents-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");


var $f0A3O = parcelRequire("f0A3O");
const $286b56541a4aa25a$var$smallLineHeight = 14;
const $286b56541a4aa25a$var$smallVerticalPadding = 4;
const $286b56541a4aa25a$var$smallHorizontalPadding = 8;
const $286b56541a4aa25a$var$largeLineHeight = 22;
const $286b56541a4aa25a$var$largeVerticalPadding = 8;
const $286b56541a4aa25a$var$largeHorizontalPadding = 12;
const $286b56541a4aa25a$var$responsiveStyleMap = {
    small: "_ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _4t3i14no",
    large: "_ca0qftgi _u5f31crf _n3tdftgi _19bv1crf _4t3i1wqb"
};
const $286b56541a4aa25a$var$HEX_REGEX = /^#[0-9A-F]{6}$/i;
const $286b56541a4aa25a$var$titleBoxWrapperStyles = null;
const $286b56541a4aa25a$export$213c428ce4ec143c = (props)=>{
    const { breakpoint: breakpoint, titleBoxBgColor: titleBoxBgColor, hidden: hidden } = props;
    const color = titleBoxBgColor && (0, $f0A3O.rgba)($286b56541a4aa25a$var$HEX_REGEX.test(titleBoxBgColor) ? titleBoxBgColor : (0, $7bb4c1736002a04a$export$29a4f05edc054374), 1);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        id: "titleBoxWrapper",
        "data-testid": "media-title-box",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            backgroundColor: color,
            display: hidden ? 'none' : undefined
        },
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_kqswstnw _94n5idpf _1bsb1osq _bfhkvuon _syaz1fxt _80om1kw7 _lcxvglyw _1e0c1txw _2lx21bp4 _1bah1h6o",
            $286b56541a4aa25a$var$responsiveStyleMap[breakpoint]
        ]),
        children: props.children
    });
};
$286b56541a4aa25a$export$213c428ce4ec143c.displayName = 'TitleBoxWrapper';
const $286b56541a4aa25a$var$infoStyles = null;
const $286b56541a4aa25a$var$iconOverlapStyle = null;
const $286b56541a4aa25a$var$titleBoxHeaderStyles = null;
const $286b56541a4aa25a$export$43970d913b015380 = (props)=>{
    const { hasIconOverlap: hasIconOverlap } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        id: "titleBoxHeader",
        "data-testid": "title-box-header",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_k48p1pd9",
            "_1reo15vq _18m915vq _o5721q9c",
            hasIconOverlap && "_u5f319bv"
        ]),
        children: props.children
    });
};
$286b56541a4aa25a$export$43970d913b015380.displayName = 'FailedTitleBoxHeader';
const $286b56541a4aa25a$var$titleBoxFooterStyles = null;
const $286b56541a4aa25a$export$1004da4fc5583975 = (props)=>{
    const { hasIconOverlap: hasIconOverlap } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        id: "titleBoxFooter",
        "data-testid": "title-box-footer",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bto1l2s",
            "_1reo15vq _18m915vq _o5721q9c",
            hasIconOverlap && "_u5f319bv"
        ]),
        children: props.children
    });
};
$286b56541a4aa25a$export$1004da4fc5583975.displayName = 'TitleBoxFooter';
const $286b56541a4aa25a$var$titleBoxIconStyles = null;
const $286b56541a4aa25a$var$newTitleBoxIconStyles = null;
const $286b56541a4aa25a$export$70e996312f72d22d = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        id: "titleBoxIcon",
        "data-testid": "title-box-icon",
        className: (0, $hcewu.default)([
            (0, $eGOwo.fg)('platform-visual-refresh-icons') && "_kqswstnw _1xi21b66 _94n51b66",
            !(0, $eGOwo.fg)('platform-visual-refresh-icons') && "_kqswstnw _1xi21b66 _94n5idpf"
        ]),
        children: props.children
    });
};
const $286b56541a4aa25a$var$errorMessageWrapperStyles = null;
const $286b56541a4aa25a$export$9e874bb1adc98a55 = (props)=>{
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_zulpv77o _1e0c1txw _4cvr1h6o _1bah1y6m _bozgv77o _e4kmnkob _1nm41b66 _184u1b66"
        ]),
        children: props.children
    });
};

});
parcelRegister("f0A3O", function(module, exports) {
$parcel$export(module.exports, "calcBreakpointSize", () => $cc566ed2e6ae819b$export$e1417862e51f29fd);
$parcel$export(module.exports, "generateResponsiveStyles", () => $cc566ed2e6ae819b$export$bb6eded75bc31192);
$parcel$export(module.exports, "getWrapperDimensions", () => $cc566ed2e6ae819b$export$eef272c84d43db07);
$parcel$export(module.exports, "getWrapperShadow", () => $cc566ed2e6ae819b$export$c180fc73343eee05);
$parcel$export(module.exports, "getCursorStyle", () => $cc566ed2e6ae819b$export$fa35f3322c52262f);
$parcel$export(module.exports, "getClickablePlayButtonStyles", () => $cc566ed2e6ae819b$export$38af25052ecc50f9);
$parcel$export(module.exports, "getSelectableTickBoxStyles", () => $cc566ed2e6ae819b$export$364272ae84df16a);
$parcel$export(module.exports, "transition", () => $cc566ed2e6ae819b$export$66bb15e2994e6a26);
$parcel$export(module.exports, "rgba", () => $cc566ed2e6ae819b$export$4e46ac54fc82cf3b);


var $7yBx7 = parcelRequire("7yBx7");

var $4MFrL = parcelRequire("4MFrL");

var $1n5AE = parcelRequire("1n5AE");

var $iTy75 = parcelRequire("iTy75");

var $3vp1h = parcelRequire("3vp1h");

var $7lRfg = parcelRequire("7lRfg");
const $cc566ed2e6ae819b$var$breakpointSizes = [
    [
        (0, $7lRfg.Breakpoint).SMALL,
        599
    ],
    [
        (0, $7lRfg.Breakpoint).LARGE,
        Infinity
    ]
];
const $cc566ed2e6ae819b$export$e1417862e51f29fd = (wrapperWidth = 0)=>{
    const [breakpoint] = $cc566ed2e6ae819b$var$breakpointSizes.find(([_breakpoint, limit])=>wrapperWidth <= limit) || [
        (0, $7lRfg.Breakpoint).SMALL
    ];
    return breakpoint;
};
const $cc566ed2e6ae819b$export$bb6eded75bc31192 = (breakpoint = (0, $7lRfg.Breakpoint).SMALL)=>{
    const setting = (0, $7lRfg.responsiveSettings)[breakpoint];
    return `
    font-size: ${setting.fontSize}px;
    line-height: ${setting.lineHeight}px;
  `;
};
const $cc566ed2e6ae819b$export$eef272c84d43db07 = (dimensions, appearance)=>{
    const { width: width, height: height } = dimensions || {};
    const { width: defaultWidth, height: defaultHeight } = (0, $1n5AE.getDefaultCardDimensions)(appearance);
    return `
	/* If container doesn't exists, it will fallback to this */
	width: ${(0, $4MFrL.getCSSUnitValue)(width || defaultWidth)};

    max-width: 100%;
    height: ${(0, $4MFrL.getCSSUnitValue)(height || defaultHeight)};
    max-height: 100%;
  `;
};
const $cc566ed2e6ae819b$export$c180fc73343eee05 = (disableOverlay, selected)=>{
    const withOverlayShadow = !disableOverlay ? `${`var(--ds-shadow-raised, ${`0 1px 1px ${0, $7bb4c1736002a04a$export$d2d3bedfb276cac0}, 0 0 1px 0 ${0, $7bb4c1736002a04a$export$d2d3bedfb276cac0}`})`}` : '';
    const selectedShadow = selected ? (0, $7yBx7.akEditorSelectedBoxShadow) : '';
    const shadow = [
        selectedShadow,
        withOverlayShadow
    ].filter(Boolean).join(', ');
    return shadow ? `box-shadow: ${shadow};` : '';
};
const $cc566ed2e6ae819b$export$fa35f3322c52262f = (cursor)=>!!cursor ? `cursor: ${cursor};` : '';
const $cc566ed2e6ae819b$export$38af25052ecc50f9 = (isPlayButtonClickable)=>{
    if (!isPlayButtonClickable) return '';
    return `
    &:hover .${0, $3vp1h.playButtonClassName} {
      ${0, $3vp1h.fixedPlayButtonStyles}
    }
  `;
};
const $cc566ed2e6ae819b$export$364272ae84df16a = (isTickBoxSelectable)=>{
    if (!isTickBoxSelectable) return '';
    return `
    &:hover .${0, $iTy75.tickBoxClassName} {
      ${0, $iTy75.tickboxFixedStyles}
    }
  `;
};
const $cc566ed2e6ae819b$var$defaultTransitionDuration = '.3s';
const $cc566ed2e6ae819b$export$66bb15e2994e6a26 = (propertyName = 'all')=>`
  transition: ${propertyName} ${$cc566ed2e6ae819b$var$defaultTransitionDuration};
`;
const $cc566ed2e6ae819b$var$hexToRgb = (hex)=>{
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}` : null;
};
const $cc566ed2e6ae819b$export$4e46ac54fc82cf3b = (hex, opacity)=>`rgba(${$cc566ed2e6ae819b$var$hexToRgb(hex)}, ${opacity})`;

});
parcelRegister("4MFrL", function(module, exports) {
$parcel$export(module.exports, "getCSSUnitValue", () => $1d9b6e35a51a0370$export$c42371b64d1354a0);
function $1d9b6e35a51a0370$export$c42371b64d1354a0(value) {
    return typeof value === 'string' ? value : `${value}px`;
}

});

parcelRegister("iTy75", function(module, exports) {
$parcel$export(module.exports, "tickBoxClassName", () => $2d58e96729a61a43$export$9f1541de0780ef27);
$parcel$export(module.exports, "tickboxFixedStyles", () => $2d58e96729a61a43$export$5ce7b7639ec5e726);

const $2d58e96729a61a43$export$9f1541de0780ef27 = 'media-card-tickbox';
const $2d58e96729a61a43$export$5ce7b7639ec5e726 = `
  background-color: ${`var(--ds-background-input, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`};
  color: ${`var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$export$d6447c357493214f)})`};
`;

});

parcelRegister("3vp1h", function(module, exports) {
$parcel$export(module.exports, "playButtonClassName", () => $41921c4809c2c85e$export$2fb57774a6fa9716);
$parcel$export(module.exports, "bkgClassName", () => $41921c4809c2c85e$export$4199e73dcf70a929);
$parcel$export(module.exports, "fixedPlayButtonStyles", () => $41921c4809c2c85e$export$8d26a4dc335bc84b);
$parcel$export(module.exports, "playButtonWrapperStyles", () => $41921c4809c2c85e$export$1daeab9e7392037d);
$parcel$export(module.exports, "backgroundStyles", () => $41921c4809c2c85e$export$1e38306701346cd5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

const $41921c4809c2c85e$export$2fb57774a6fa9716 = 'media-card-play-button';
const $41921c4809c2c85e$export$4199e73dcf70a929 = 'play-icon-background';
const $41921c4809c2c85e$var$discSize = 48;
const $41921c4809c2c85e$var$discSizeHover = 56;
const $41921c4809c2c85e$export$8d26a4dc335bc84b = `
  .${$41921c4809c2c85e$export$4199e73dcf70a929} {
    width: ${$41921c4809c2c85e$var$discSizeHover}px;
    height: ${$41921c4809c2c85e$var$discSizeHover}px;
  }
`;
const $41921c4809c2c85e$export$1daeab9e7392037d = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    span: {
        position: 'absolute'
    }
});
const $41921c4809c2c85e$export$1e38306701346cd5 = /*#__PURE__*/ (0, $1NIU8.css)({
    transitionProperty: 'width, height',
    transitionDuration: '0.1s',
    position: 'absolute',
    width: `${$41921c4809c2c85e$var$discSize}px`,
    height: `${$41921c4809c2c85e$var$discSize}px`,
    background: `var(--ds-background-neutral-bold, ${(0, $7bb4c1736002a04a$export$d092757d7c64925c)})`,
    borderRadius: "var(--ds-radius-full, 9999px)"
});

});

parcelRegister("7lRfg", function(module, exports) {
$parcel$export(module.exports, "Breakpoint", () => $fecd6c91fedd0062$export$114247090b0aae30);
$parcel$export(module.exports, "responsiveSettings", () => $fecd6c91fedd0062$export$195ea22bb2417d03);
$parcel$export(module.exports, "getTitleBoxHeight", () => $fecd6c91fedd0062$export$5141d851393c8198);
var $fecd6c91fedd0062$export$114247090b0aae30 = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint["SMALL"] = "small";
    Breakpoint["LARGE"] = "large";
    return Breakpoint;
}({});
const $fecd6c91fedd0062$export$195ea22bb2417d03 = {
    ["small"]: {
        fontSize: 11,
        lineHeight: 14,
        titleBox: {
            verticalPadding: 4,
            horizontalPadding: 8
        }
    },
    ["large"]: {
        fontSize: 14,
        lineHeight: 22,
        titleBox: {
            verticalPadding: 8,
            horizontalPadding: 12
        }
    }
};
const $fecd6c91fedd0062$export$5141d851393c8198 = (breakpoint)=>($fecd6c91fedd0062$export$195ea22bb2417d03[breakpoint].lineHeight + $fecd6c91fedd0062$export$195ea22bb2417d03[breakpoint].titleBox.verticalPadding) * 2;

});



parcelRegister("2ODnB", function(module, exports) {
$parcel$export(module.exports, "TitleBoxWrapper", () => $4082fd692e5f8861$export$213c428ce4ec143c);
$parcel$export(module.exports, "TitleBoxHeader", () => $4082fd692e5f8861$export$43970d913b015380);
$parcel$export(module.exports, "TitleBoxFooter", () => $4082fd692e5f8861$export$1004da4fc5583975);
$parcel$export(module.exports, "TitleBoxIcon", () => $4082fd692e5f8861$export$70e996312f72d22d);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $4082fd692e5f8861$export$9e874bb1adc98a55);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");

var $1mGBe = parcelRequire("1mGBe");
const $4082fd692e5f8861$export$213c428ce4ec143c = (props)=>{
    const { breakpoint: breakpoint, titleBoxBgColor: titleBoxBgColor, hidden: hidden } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "titleBoxWrapper",
        "data-testid": "media-title-box",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1mGBe.titleBoxWrapperStyles)({
            breakpoint: breakpoint,
            display: hidden ? 'none' : 'flex',
            titleBoxBgColor: titleBoxBgColor
        })
    }, props.children);
};
const $4082fd692e5f8861$export$43970d913b015380 = (props)=>{
    const { hasIconOverlap: hasIconOverlap } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "titleBoxHeader",
        "data-testid": "title-box-header",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1mGBe.titleBoxHeaderStyles)({
            hasIconOverlap: hasIconOverlap
        })
    }, props.children);
};
const $4082fd692e5f8861$export$1004da4fc5583975 = (props)=>{
    const { hasIconOverlap: hasIconOverlap } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "titleBoxFooter",
        "data-testid": "title-box-footer",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1mGBe.titleBoxFooterStyles)({
            hasIconOverlap: hasIconOverlap
        })
    }, props.children);
};
const $4082fd692e5f8861$export$70e996312f72d22d = (props)=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "titleBoxIcon",
        "data-testid": "title-box-icon",
        css: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        (0, $1mGBe.newTitleBoxIconStyles) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        (0, $1mGBe.titleBoxIconStyles)
    }, props.children);
};
const $4082fd692e5f8861$export$9e874bb1adc98a55 = (props)=>{
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $1mGBe.errorMessageWrapperStyles)
    }, props.children);
};

});
parcelRegister("1mGBe", function(module, exports) {
$parcel$export(module.exports, "titleBoxWrapperStyles", () => $324aefc26a0a6b81$export$67519283632017a5);
$parcel$export(module.exports, "titleBoxHeaderStyles", () => $324aefc26a0a6b81$export$ad849f87817ca9ae);
$parcel$export(module.exports, "titleBoxFooterStyles", () => $324aefc26a0a6b81$export$ef98c107c6908fb2);
$parcel$export(module.exports, "titleBoxIconStyles", () => $324aefc26a0a6b81$export$4d49b02261d82f);
$parcel$export(module.exports, "newTitleBoxIconStyles", () => $324aefc26a0a6b81$export$c614ab182d7a390d);
$parcel$export(module.exports, "errorMessageWrapperStyles", () => $324aefc26a0a6b81$export$6fed64482f59b82c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7lRfg = parcelRequire("7lRfg");


var $f0A3O = parcelRequire("f0A3O");
function $324aefc26a0a6b81$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $324aefc26a0a6b81$var$generateResponsiveStyles = (breakpoint = (0, $7lRfg.Breakpoint).SMALL)=>{
    const setting = (0, $7lRfg.responsiveSettings)[breakpoint];
    const verticalPadding = setting.titleBox.verticalPadding;
    const horizontalPadding = setting.titleBox.horizontalPadding;
    const height = (0, $7lRfg.getTitleBoxHeight)(breakpoint);
    return `height: ${height}px;
    padding: ${verticalPadding}px ${horizontalPadding}px;`;
};
const $324aefc26a0a6b81$var$HEX_REGEX = /^#[0-9A-F]{6}$/i;
const $324aefc26a0a6b81$export$67519283632017a5 = ({ breakpoint: breakpoint, display: display = 'flex', titleBoxBgColor: titleBoxBgColor })=>/*#__PURE__*/ (0, $1NIU8.css)({
        position: 'absolute',
        bottom: 0,
        width: '100%',
        backgroundColor: `var(--ds-surface, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        (0, $f0A3O.rgba)(titleBoxBgColor && $324aefc26a0a6b81$var$HEX_REGEX.test(titleBoxBgColor) ? titleBoxBgColor : (0, $7bb4c1736002a04a$export$29a4f05edc054374), 1)})`,
        color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`,
        cursor: 'inherit',
        pointerEvents: 'none',
        display: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display,
        flexDirection: 'column',
        justifyContent: 'center'
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $324aefc26a0a6b81$var$generateResponsiveStyles(breakpoint));
$324aefc26a0a6b81$export$67519283632017a5.displayName = 'TitleBoxWrapper';
const $324aefc26a0a6b81$var$infoStyles = `white-space: nowrap;overflow: hidden;`;
const $324aefc26a0a6b81$var$iconOverlapStyles = `padding-right: 10px;`;
const $324aefc26a0a6b81$export$ad849f87817ca9ae = ({ hasIconOverlap: hasIconOverlap })=>/*#__PURE__*/ (0, $1NIU8.css)("font-weight:var(--ds-font-weight-semibold, 600);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $324aefc26a0a6b81$var$infoStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasIconOverlap && $324aefc26a0a6b81$var$iconOverlapStyles);
$324aefc26a0a6b81$export$ad849f87817ca9ae.displayName = 'FailedTitleBoxHeader';
const $324aefc26a0a6b81$export$ef98c107c6908fb2 = ({ hasIconOverlap: hasIconOverlap })=>/*#__PURE__*/ (0, $1NIU8.css)("text-overflow:ellipsis;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $324aefc26a0a6b81$var$infoStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasIconOverlap && $324aefc26a0a6b81$var$iconOverlapStyles);
$324aefc26a0a6b81$export$ef98c107c6908fb2.displayName = 'TitleBoxFooter';
const $324aefc26a0a6b81$export$4d49b02261d82f = {
    name: "9adycr",
    styles: "position:absolute;right:var(--ds-space-050, 4px);bottom:0px"
};
const $324aefc26a0a6b81$export$c614ab182d7a390d = {
    name: "1w19ra2",
    styles: "position:absolute;right:var(--ds-space-050, 4px);bottom:var(--ds-space-050, 4px)"
};
const $324aefc26a0a6b81$export$6fed64482f59b82c = {
    name: "clvfm2",
    styles: "display:flex;align-items:center;justify-content:flex-start;padding-inline-start:var(--ds-space-025, 2px);gap:var(--ds-space-025, 2px);span{vertical-align:middle;:nth-child(2){margin-left:var(--ds-space-050, 4px);margin-right:var(--ds-space-050, 4px);}}"
};

});




parcelRegister("6McwC", function(module, exports) {
$parcel$export(module.exports, "FailedTitleBox", () => $777ce11a06472de9$export$9b3b0baef32e2e39);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $88oIq = parcelRequire("88oIq");

var $lk6TK = parcelRequire("lk6TK");


var $1xVuR = parcelRequire("1xVuR");
const $777ce11a06472de9$export$9b3b0baef32e2e39 = ({ breakpoint: breakpoint, customMessage: customMessage = (0, $lk6TK.messages).failed_to_load })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xVuR.TitleBoxWrapper), {
        breakpoint: breakpoint,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1xVuR.ErrorMessageWrapper), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($88oIq))), {
                    label: 'Warning',
                    LEGACY_size: 'small',
                    LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                    color: `var(--ds-text-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
                    size: "small"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...customMessage
                    })
                })
            ]
        })
    });
};

});

parcelRegister("hOl09", function(module, exports) {
$parcel$export(module.exports, "ProgressBar", () => $e9a5a5808e1da8b6$export$c17561cb55d4db30);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $50QI5 = parcelRequire("50QI5");

var $7lRfg = parcelRequire("7lRfg");
const $e9a5a5808e1da8b6$export$7b5a7c65f0c5d278 = (progress)=>{
    return Math.min(1, Math.max(0, progress || 0)) * 100;
};
const $e9a5a5808e1da8b6$export$c17561cb55d4db30 = ({ progress: progress, breakpoint: breakpoint = (0, $7lRfg.Breakpoint).SMALL, positionBottom: positionBottom = false, showOnTop: showOnTop = false, ariaLabel: ariaLabel = 'Loading progress' })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $50QI5.StyledBar), {
        progress: $e9a5a5808e1da8b6$export$7b5a7c65f0c5d278(progress),
        breakpoint: breakpoint,
        positionBottom: positionBottom,
        showOnTop: showOnTop,
        ariaLabel: ariaLabel
    });
};

});
parcelRegister("50QI5", function(module, exports) {
$parcel$export(module.exports, "StyledBar", () => $4320e86ceaa63cbb$export$cb8b5a20ccbacd09);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $lqQIz = parcelRequire("lqQIz");

var $90ALz = parcelRequire("90ALz");
const $4320e86ceaa63cbb$export$cb8b5a20ccbacd09 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lqQIz.StyledBar), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $90ALz.StyledBar), {
        ...props
    });

});
parcelRegister("lqQIz", function(module, exports) {
$parcel$export(module.exports, "StyledBar", () => $c77543fee8afa5cd$export$cb8b5a20ccbacd09);
/* styledBar-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7lRfg = parcelRequire("7lRfg");
const $c77543fee8afa5cd$var$height = 3;
const $c77543fee8afa5cd$var$padding = 1;
const $c77543fee8afa5cd$var$width = 95; // %
const $c77543fee8afa5cd$var$smallSizeSettings = {
    marginBottom: 4
};
const $c77543fee8afa5cd$var$largeSizeSettings = {
    marginBottom: 12
};
function $c77543fee8afa5cd$export$bb6eded75bc31192(breakpoint, positionBottom, showOnTop, multiplier = 1) {
    const setting = breakpoint === (0, $7lRfg.Breakpoint).SMALL ? $c77543fee8afa5cd$var$smallSizeSettings : $c77543fee8afa5cd$var$largeSizeSettings;
    const marginPositionBottom = (0, $7lRfg.responsiveSettings)[breakpoint].titleBox.verticalPadding;
    const marginBottom = setting.marginBottom * multiplier + (positionBottom ? marginPositionBottom : (0, $7lRfg.getTitleBoxHeight)(breakpoint));
    const spacing = `${marginBottom}px`;
    return showOnTop ? {
        top: spacing
    } : {
        bottom: spacing
    };
}
const $c77543fee8afa5cd$var$styledBarStyles = null;
const $c77543fee8afa5cd$var$styleChild = null;
const $c77543fee8afa5cd$export$cb8b5a20ccbacd09 = (props)=>{
    const { progress: progress, breakpoint: breakpoint, positionBottom: positionBottom, showOnTop: showOnTop, ariaLabel: ariaLabel } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        id: "styledBar",
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": ariaLabel,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...$c77543fee8afa5cd$export$bb6eded75bc31192(breakpoint, positionBottom, showOnTop)
        },
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _2rkofajl _kqswstnw _1bsb1lk2 _1ltv1ghs _bfhkatjl _4t3i14y2 _vchhusvi"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            style: {
                width: `${progress}%`
            },
            className: (0, $hcewu.default)([
                "_2rkofajl _bfhk1p0d _1e0c1ule _4t3i1osq"
            ])
        })
    });
};
$c77543fee8afa5cd$export$cb8b5a20ccbacd09.displayName = 'StyledProgressBar';

});

parcelRegister("90ALz", function(module, exports) {
$parcel$export(module.exports, "StyledBar", () => $ff2e538e32da72e3$export$cb8b5a20ccbacd09);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $dU3KG = parcelRequire("dU3KG");
const $ff2e538e32da72e3$export$cb8b5a20ccbacd09 = (props)=>{
    const { progress: progress, breakpoint: breakpoint, positionBottom: positionBottom, showOnTop: showOnTop, ariaLabel: ariaLabel } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "styledBar",
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": ariaLabel,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $dU3KG.styledBarStyles)({
            progress: progress,
            breakpoint: breakpoint,
            positionBottom: positionBottom,
            showOnTop: showOnTop
        })
    });
};

});
parcelRegister("dU3KG", function(module, exports) {
$parcel$export(module.exports, "styledBarStyles", () => $fdd4fcb66c0bdb47$export$c7c110ef29c6fcf1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $iYfp4 = parcelRequire("iYfp4");

var $f0A3O = parcelRequire("f0A3O");


var $7lRfg = parcelRequire("7lRfg");
const $fdd4fcb66c0bdb47$var$height = 3;
const $fdd4fcb66c0bdb47$var$padding = 1;
const $fdd4fcb66c0bdb47$var$width = 95; // %
const $fdd4fcb66c0bdb47$var$left = (100 - $fdd4fcb66c0bdb47$var$width) / 2; // %
const $fdd4fcb66c0bdb47$var$smallSizeSettings = {
    marginBottom: 4
};
const $fdd4fcb66c0bdb47$var$largeSizeSettings = {
    marginBottom: 12
};
function $fdd4fcb66c0bdb47$export$bb6eded75bc31192(breakpoint, positionBottom, showOnTop, multiplier = 1) {
    const setting = breakpoint === (0, $7lRfg.Breakpoint).SMALL ? $fdd4fcb66c0bdb47$var$smallSizeSettings : $fdd4fcb66c0bdb47$var$largeSizeSettings;
    const marginPositionBottom = (0, $7lRfg.responsiveSettings)[breakpoint].titleBox.verticalPadding;
    const marginBottom = setting.marginBottom * multiplier + (positionBottom ? marginPositionBottom : (0, $7lRfg.getTitleBoxHeight)(breakpoint));
    return `
    ${showOnTop ? 'top' : 'bottom'}: ${marginBottom}px
  `;
}
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $fdd4fcb66c0bdb47$var$getStyledBarStylesBasedOnProps = ({ progress: progress, breakpoint: breakpoint, positionBottom: positionBottom, showOnTop: showOnTop })=>`
${0, $iYfp4.borderRadius}
overflow: hidden;
position: absolute;
width: ${$fdd4fcb66c0bdb47$var$width}%;
left: ${$fdd4fcb66c0bdb47$var$left}%;
background-color: ${(0, $f0A3O.rgba)((0, $7bb4c1736002a04a$export$29a4f05edc054374), 0.8)};
height: ${$fdd4fcb66c0bdb47$var$height + $fdd4fcb66c0bdb47$var$padding * 2}px;
padding: ${$fdd4fcb66c0bdb47$var$padding}px;
box-sizing: border-box;

::before {
  content: '';
  width: ${progress}%;
  height: 100%;
  background-color: #44546F;
  ${0, $iYfp4.borderRadius}
  display: block;
}
${$fdd4fcb66c0bdb47$export$bb6eded75bc31192(breakpoint, positionBottom, showOnTop)}
`;
const $fdd4fcb66c0bdb47$export$c7c110ef29c6fcf1 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $1NIU8.css)($fdd4fcb66c0bdb47$var$getStyledBarStylesBasedOnProps(props));
};
$fdd4fcb66c0bdb47$export$c7c110ef29c6fcf1.displayName = 'StyledProgressBar';

});




parcelRegister("3K8qV", function(module, exports) {
$parcel$export(module.exports, "PlayButton", () => $3b25fa88e8c8fb2d$export$fbed5f62d839a0cd);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7elOh = parcelRequire("7elOh");

var $dVfs0 = parcelRequire("dVfs0");

var $iM9ss = parcelRequire("iM9ss");

var $3XBjY = parcelRequire("3XBjY");
const $3b25fa88e8c8fb2d$export$fbed5f62d839a0cd = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $iM9ss.PlayButtonWrapper), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3XBjY.PlayButtonBackground), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dVfs0))), {
                color: "currentColor",
                label: "play",
                LEGACY_size: "large",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7elOh)))
            })
        ]
    });
};

});
parcelRegister("7elOh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $543ac23c5ad5db14$var$_react = $543ac23c5ad5db14$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $543ac23c5ad5db14$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $543ac23c5ad5db14$var$VidPlayIcon = (props)=>/*#__PURE__*/ $543ac23c5ad5db14$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.595 19.522C7.162 20.364 6 19.702 6 18.04V5.963C6 4.3 7.158 3.635 8.595 4.479l11.083 6.51c.951.559.958 1.46 0 2.023z"/></svg>`
    }, props));
$543ac23c5ad5db14$var$VidPlayIcon.displayName = 'VidPlayIcon';
var $543ac23c5ad5db14$var$_default = module.exports.default = $543ac23c5ad5db14$var$VidPlayIcon;

});

parcelRegister("dVfs0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::377c8bcd43f8b7193395b89e37187d5f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a22c956957d4dc68$var$_react = $a22c956957d4dc68$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a22c956957d4dc68$var$_baseNew = $a22c956957d4dc68$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $a22c956957d4dc68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a22c956957d4dc68$var$VideoPlayOverlayIcon = (props)=>/*#__PURE__*/ $a22c956957d4dc68$var$_react.default.createElement($a22c956957d4dc68$var$_baseNew.default, Object.assign({
        name: "VideoPlayOverlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888z" clip-rule="evenodd"/>`
    }, props));
$a22c956957d4dc68$var$VideoPlayOverlayIcon.displayName = 'VideoPlayOverlayIcon';
var $a22c956957d4dc68$var$_default = module.exports.default = $a22c956957d4dc68$var$VideoPlayOverlayIcon;

});

parcelRegister("iM9ss", function(module, exports) {
$parcel$export(module.exports, "PlayButtonWrapper", () => $0dafc68cd98f8f4a$export$4b5a99ec12fb6a16);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $13zQ3 = parcelRequire("13zQ3");

var $5IUbI = parcelRequire("5IUbI");
const $0dafc68cd98f8f4a$export$4b5a99ec12fb6a16 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $13zQ3.PlayButtonWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5IUbI.PlayButtonWrapper), {
        ...props
    });

});
parcelRegister("13zQ3", function(module, exports) {
$parcel$export(module.exports, "PlayButtonWrapper", () => $4c9b9e68ae470a4a$export$4b5a99ec12fb6a16);
/* playButtonWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3vp1h = parcelRequire("3vp1h");
const $4c9b9e68ae470a4a$var$playButtonWrapperStyles = null;
const $4c9b9e68ae470a4a$export$4b5a99ec12fb6a16 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o _syaz5w2r _vr2wstnw",
            (0, $3vp1h.playButtonClassName)
        ]),
        children: props.children
    });
};

});

parcelRegister("5IUbI", function(module, exports) {
$parcel$export(module.exports, "PlayButtonWrapper", () => $cbe065f94a0665ef$export$4b5a99ec12fb6a16);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $3vp1h = parcelRequire("3vp1h");
const $cbe065f94a0665ef$export$4b5a99ec12fb6a16 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $3vp1h.playButtonWrapperStyles),
        className: (0, $3vp1h.playButtonClassName)
    }, props.children));
};

});


parcelRegister("3XBjY", function(module, exports) {
$parcel$export(module.exports, "PlayButtonBackground", () => $070b04cdfaf29118$export$b9f4dfad351e8285);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $3vp1h = parcelRequire("3vp1h");
const $070b04cdfaf29118$export$b9f4dfad351e8285 = ()=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $3vp1h.backgroundStyles),
        className: (0, $3vp1h.bkgClassName)
    });
};

});


parcelRegister("98895", function(module, exports) {
$parcel$export(module.exports, "TickBox", () => $2fa0545d836fed84$export$58be5bf2cd389559);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $entZ3 = parcelRequire("entZ3");

var $bZ8m6 = parcelRequire("bZ8m6");
const $2fa0545d836fed84$export$58be5bf2cd389559 = ({ selected: selected })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $bZ8m6.TickBoxWrapper), {
        selected: selected,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($entZ3))), {
            color: "currentColor",
            label: "tick",
            size: "small"
        })
    });

});
parcelRegister("entZ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e5baeaa2c36dad27a8b98ef155f7a5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a77a78d359015cce$var$_react = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a77a78d359015cce$var$_checkMark = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("lwpci")));

var $a77a78d359015cce$var$_check = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("2kdvq")));
function $a77a78d359015cce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a77a78d359015cce$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a77a78d359015cce$var$_react.default.createElement($a77a78d359015cce$var$_checkMark.default, Object.assign({
        name: "CheckMarkIcon",
        LEGACY_fallbackIcon: $a77a78d359015cce$var$_check.default
    }, props));
$a77a78d359015cce$var$CheckMarkIcon.displayName = 'CheckMarkIconMigration';
var $a77a78d359015cce$var$_default = module.exports.default = $a77a78d359015cce$var$CheckMarkIcon;

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});

parcelRegister("2kdvq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b17ecff78f4ff04$var$_react = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $1b17ecff78f4ff04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1b17ecff78f4ff04$var$CheckIcon = (props)=>/*#__PURE__*/ $1b17ecff78f4ff04$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props));
$1b17ecff78f4ff04$var$CheckIcon.displayName = 'CheckIcon';
var $1b17ecff78f4ff04$var$_default = module.exports.default = $1b17ecff78f4ff04$var$CheckIcon;

});


parcelRegister("bZ8m6", function(module, exports) {
$parcel$export(module.exports, "TickBoxWrapper", () => $a2098ab13d2bbd99$export$65704ff0d0294857);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $2QdF0 = parcelRequire("2QdF0");

var $gcqsS = parcelRequire("gcqsS");
const $a2098ab13d2bbd99$export$65704ff0d0294857 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2QdF0.TickBoxWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gcqsS.TickBoxWrapper), {
        ...props
    });
$a2098ab13d2bbd99$export$65704ff0d0294857.displayName = 'TickBoxWrapper';

});
parcelRegister("2QdF0", function(module, exports) {
$parcel$export(module.exports, "TickBoxWrapper", () => $b2a06b37da9c47b4$export$65704ff0d0294857);
/* tickBoxWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $iTy75 = parcelRequire("iTy75");
const $b2a06b37da9c47b4$var$selectedStyles = null;
const $b2a06b37da9c47b4$var$oldWrapperStyes = null;
const $b2a06b37da9c47b4$var$wrapperStyles = null;
const $b2a06b37da9c47b4$export$65704ff0d0294857 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        id: "tickBoxWrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_11c82smr _2rkov47k _4cvr1h6o _6a6z1h6o _v564ybtr _1bsbpxbi _4t3ipxbi _kqswstnw _154i1tpr _1ltv1tpr _syaz3acm _1e0c11p5 _1b941ule",
            !(0, $eGOwo.fg)('platform-visual-refresh-icons') && "_1bsbdlk8 _4t3idlk8 _1mcmdlk8",
            props.selected && "_bfhk8sto _syaz5w2r",
            (0, $iTy75.tickBoxClassName)
        ]),
        children: props.children
    });
};
$b2a06b37da9c47b4$export$65704ff0d0294857.displayName = 'TickBoxWrapper';

});

parcelRegister("gcqsS", function(module, exports) {
$parcel$export(module.exports, "TickBoxWrapper", () => $04e902968fc41f3d$export$65704ff0d0294857);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");

var $iTy75 = parcelRequire("iTy75");

var $f0A3O = parcelRequire("f0A3O");

function $04e902968fc41f3d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $04e902968fc41f3d$var$getSelectedStyles = (selected)=>selected ? `background-color: ${`var(--ds-icon-information, ${0, $7bb4c1736002a04a$export$215b7063051591f1})`};
      color: ${"var(--ds-icon-inverse, white)"};` : ``;
const $04e902968fc41f3d$var$oldWrapperStyes = {
    name: "1k581ha",
    styles: "width:14px;height:14px;span{svg{height:14px;}}"
};
const $04e902968fc41f3d$var$wrapperStyles = (selected)=>/*#__PURE__*/ (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $f0A3O.transition) && (0, $f0A3O.transition)(), "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);position:absolute;top:var(--ds-space-075, 7px);left:var(--ds-space-075, 7px);border-radius:var(--ds-space-250, 20px);color:transparent;span{display:block;}display:grid;place-items:center;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $04e902968fc41f3d$var$getSelectedStyles(selected));
$04e902968fc41f3d$var$wrapperStyles.displayName = 'TickBoxWrapper';
const $04e902968fc41f3d$export$65704ff0d0294857 = (props)=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "tickBoxWrapper",
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $04e902968fc41f3d$var$wrapperStyles(props.selected),
            !(0, $eGOwo.fg)('platform-visual-refresh-icons') && $04e902968fc41f3d$var$oldWrapperStyes
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iTy75.tickBoxClassName)
    }, props.children);
};

});



parcelRegister("b9tta", function(module, exports) {
$parcel$export(module.exports, "Blanket", () => $12834f1b6a7e5e26$export$5b927fc1ef8c468b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $2DfX1 = parcelRequire("2DfX1");

var $4qGJv = parcelRequire("4qGJv");
const $12834f1b6a7e5e26$export$5b927fc1ef8c468b = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2DfX1.Blanket), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4qGJv.Blanket), {
        ...props
    });

});
parcelRegister("2DfX1", function(module, exports) {
$parcel$export(module.exports, "Blanket", () => $866c6a3c3d54b988$export$5b927fc1ef8c468b);
/* blanket-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $866c6a3c3d54b988$export$5a1cb4139dc6683d = 'media-card-blanket';
const $866c6a3c3d54b988$export$3141ecf58e7b3585 = `background-color: ${`var(--ds-blanket, ${(0, $7bb4c1736002a04a$export$d092757d7c64925c)})`};`;
const $866c6a3c3d54b988$var$blanketStyles = null;
const $866c6a3c3d54b988$var$fixedBlanketStyle = null;
const $866c6a3c3d54b988$export$5b927fc1ef8c468b = (props)=>{
    const { isFixed: isFixed } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_v564ybtr _kqswstnw _1bsb1osq _4t3i1osq _c71l1osq _p12f1osq _1ltvidpf _154iidpf",
            isFixed && "_bfhka8ns",
            $866c6a3c3d54b988$export$5a1cb4139dc6683d
        ]),
        "data-testid": "media-card-blanket"
    });
};
$866c6a3c3d54b988$export$5b927fc1ef8c468b.displayName = 'Blanket';

});

parcelRegister("4qGJv", function(module, exports) {
$parcel$export(module.exports, "Blanket", () => $099d75676b5f8ed1$export$5b927fc1ef8c468b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $jzWHk = parcelRequire("jzWHk");
const $099d75676b5f8ed1$export$5b927fc1ef8c468b = (props)=>{
    const { isFixed: isFixed } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $jzWHk.blanketStyles)(isFixed),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jzWHk.blanketClassName),
        "data-testid": "media-card-blanket"
    });
};

});
parcelRegister("jzWHk", function(module, exports) {
$parcel$export(module.exports, "blanketClassName", () => $07aac7b2427de7c3$export$5a1cb4139dc6683d);
$parcel$export(module.exports, "fixedBlanketStyles", () => $07aac7b2427de7c3$export$3141ecf58e7b3585);
$parcel$export(module.exports, "blanketStyles", () => $07aac7b2427de7c3$export$db1173ffa5e2194);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $f0A3O = parcelRequire("f0A3O");

const $07aac7b2427de7c3$export$5a1cb4139dc6683d = 'media-card-blanket';
const $07aac7b2427de7c3$export$3141ecf58e7b3585 = `background-color: ${`var(--ds-blanket, ${(0, $7bb4c1736002a04a$export$d092757d7c64925c)})`};`;
const $07aac7b2427de7c3$export$db1173ffa5e2194 = (isFixed)=>/*#__PURE__*/ (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $f0A3O.transition)(), "position:absolute;width:100%;height:100%;max-height:100%;max-width:100%;left:0;top:0;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    isFixed ? $07aac7b2427de7c3$export$3141ecf58e7b3585 : '');
$07aac7b2427de7c3$export$db1173ffa5e2194.displayName = 'Blanket';

});



parcelRegister("hh0qm", function(module, exports) {
$parcel$export(module.exports, "ActionsBar", () => $6ddebdad1f8b76b3$export$8c8e9293b68041de);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aQ95r = parcelRequire("aQ95r");
var $4VFUa = parcelRequire("4VFUa");

var $l5HCG = parcelRequire("l5HCG");
class $6ddebdad1f8b76b3$export$8c8e9293b68041de extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isFixed: isFixed, filename: filename, actions: actions } = this.props;
        if (actions.length === 0) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l5HCG.ActionsBarWrapper), {
            isFixed: isFixed,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VFUa.CardActionsView), {
                filename: filename,
                actions: actions,
                variant: (0, $aQ95r.CardActionIconButtonVariant).filled
            })
        });
    }
}

});
parcelRegister("aQ95r", function(module, exports) {
$parcel$export(module.exports, "CardActionIconButtonVariant", () => $1c938cd925f33a7c$export$1092897f622d4253);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $iYfp4 = parcelRequire("iYfp4");

var $f0A3O = parcelRequire("f0A3O");
var $1c938cd925f33a7c$export$1092897f622d4253 = /*#__PURE__*/ function(CardActionIconButtonVariant) {
    CardActionIconButtonVariant["default"] = "default";
    CardActionIconButtonVariant["filled"] = "filled";
    return CardActionIconButtonVariant;
}({});
const $1c938cd925f33a7c$var$getVariantStyles = (variant)=>{
    return variant === 'filled' ? `
    background-color: ${`var(--ds-surface-overlay, ${(0, $f0A3O.rgba)((0, $7bb4c1736002a04a$export$29a4f05edc054374), 0.8)})`};

    &:hover {
      background-color: ${`var(--ds-surface-overlay-hovered, ${(0, $f0A3O.rgba)((0, $7bb4c1736002a04a$export$29a4f05edc054374), 0.6)})`}
    }
  ` : `
    &:hover {
      background-color: ${"var(--ds-background-neutral-subtle-hovered, rgba(9, 30, 66, 0.06))"};
    }
  `;
};
const $1c938cd925f33a7c$export$7554c3d9ed9d9659 = ({ variant: variant })=>/*#__PURE__*/ (0, $1NIU8.css)("appearance:none;border:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $iYfp4.center), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $iYfp4.borderRadius), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $iYfp4.size)(26), {
        color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
        '&:hover': {
            cursor: 'pointer'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $1c938cd925f33a7c$var$getVariantStyles(variant));

});

parcelRegister("4VFUa", function(module, exports) {
$parcel$export(module.exports, "CardActionsView", () => $d00ac83b3dff9b8d$export$8b95be1301afd485);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dRe1t = parcelRequire("dRe1t");

var $glICV = parcelRequire("glICV");
class $d00ac83b3dff9b8d$export$8b95be1301afd485 extends (0, $eJOHy.Component) {
    render() {
        const { actions: actions } = this.props;
        if (!actions.length) return null;
        const primaryAction = actions.find($d00ac83b3dff9b8d$var$actionWithIcon);
        const otherActions = actions.filter($d00ac83b3dff9b8d$var$actionNotEqualTo(primaryAction));
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                primaryAction ? this.renderActionIconButton(primaryAction, true) : null,
                this.renderOtherActionButtons(otherActions)
            ]
        });
    }
    renderActionIconButton(action, isPrimary) {
        const { triggerColor: triggerColor, filename: filename, variant: variant } = this.props;
        const { icon: icon, handler: handler, label: label, isDisabled: isDisabled, tooltip: tooltip } = action;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dRe1t.CardActionIconButton), {
            icon: icon,
            label: label,
            filename: filename,
            isPrimary: isPrimary,
            triggerColor: triggerColor,
            onClick: ()=>handler(),
            variant: variant,
            isDisabled: isDisabled,
            tooltip: tooltip
        });
    }
    renderOtherActionButtons(actions) {
        if (actions.length === 0) return null;
        else {
            const { triggerColor: triggerColor, onToggle: onToggle, variant: variant } = this.props;
            const firstActionWithIcon = actions.find($d00ac83b3dff9b8d$var$actionWithIcon);
            const otherActions = actions.filter($d00ac83b3dff9b8d$var$actionNotEqualTo(firstActionWithIcon));
            if (firstActionWithIcon && otherActions.length === 0) return this.renderActionIconButton(firstActionWithIcon, false);
            else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $glICV.CardActionsDropdownMenu), {
                actions: actions,
                triggerColor: triggerColor,
                onOpenChange: onToggle,
                triggerVariant: variant
            });
        }
    }
}
function $d00ac83b3dff9b8d$var$actionWithIcon(action) {
    return !!action.icon;
}
function $d00ac83b3dff9b8d$var$actionNotEqualTo(otherAction) {
    return (action)=>action !== otherAction;
}

});
parcelRegister("dRe1t", function(module, exports) {
$parcel$export(module.exports, "CardActionIconButton", () => $f159a7e68bb3b7a5$export$8cc1a92de7a95c90);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $3gCUX = parcelRequire("3gCUX");

var $k71qx = parcelRequire("k71qx");

var $dUG6w = parcelRequire("dUG6w");
const $f159a7e68bb3b7a5$export$8cc1a92de7a95c90 = ({ icon: icon, label: label, filename: filename, triggerColor: triggerColor, onClick: onClick, isPrimary: isPrimary, variant: variant, isDisabled: isDisabled, tooltip: tooltip })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // this is to prevent currently focused text to loose cursor on clicking card action
    // this does not prevent onclick behavior
    const onMouseDown = (event)=>{
        event.preventDefault();
    };
    const handleClick = (e)=>{
        const actionSubjectId = isPrimary ? 'mediaCardPrimaryActionButton' : 'mediaCardSecondaryActionButton';
        (0, $dUG6w.fireMediaCardEvent)({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                label: label
            }
        }, createAnalyticsEvent);
        onClick?.(e);
    };
    const cardActionButton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3gCUX.CardActionButton), {
        onClick: handleClick,
        onMouseDown: onMouseDown,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            color: triggerColor
        },
        label: filename ? `${filename} \u{2014} ${label}` : label,
        variant: variant,
        disabled: isDisabled,
        children: icon
    });
    return tooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltip,
        position: "bottom",
        tag: "span",
        children: cardActionButton
    }) : cardActionButton;
};

});
parcelRegister("3gCUX", function(module, exports) {
$parcel$export(module.exports, "CardActionButton", () => $16598b383cf14501$export$19effabad32bd757);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $8iiNo = parcelRequire("8iiNo");
const $16598b383cf14501$export$19effabad32bd757 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8iiNo.CardActionButton), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8iiNo.CardActionButton), {
        ...props,
        ref: ref
    }));

});
parcelRegister("8iiNo", function(module, exports) {
$parcel$export(module.exports, "CardActionButton", () => $fae7bcc8a3089182$export$19effabad32bd757);
/* cardActionButton-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fae7bcc8a3089182$var$variantStyleMap = {
    filled: "_bfhk37p7 _irr3u1o1",
    default: "_irr3166n"
};
const $fae7bcc8a3089182$var$cardActionButtonStyles = null;
const $fae7bcc8a3089182$export$19effabad32bd757 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        ...props,
        id: "cardActionButton",
        "data-testid": "media-card-primary-action",
        "aria-label": props.label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...props.style,
            cursor: props.disabled ? 'not-allowed' : 'default'
        },
        onClick: props.onClick,
        onMouseDown: props.onMouseDown,
        ref: ref,
        className: (0, $hcewu.default)([
            "_19itglyw _2rkofajl _r06hglyw _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ou6 _4t3i1ou6 _syazilmm _d0altlke",
            $fae7bcc8a3089182$var$variantStyleMap[props.variant ?? 'default']
        ]),
        children: props.children
    });
});

});



parcelRegister("glICV", function(module, exports) {
$parcel$export(module.exports, "CardActionsDropdownMenu", () => $e4d539686a8b35c6$export$2b7a7909eccadfb9);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");
var $4J0ad = parcelRequire("4J0ad");

var $aMdh8 = parcelRequire("aMdh8");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $dUG6w = parcelRequire("dUG6w");

var $3gCUX = parcelRequire("3gCUX");
const $e4d539686a8b35c6$var$DropdownItemWithProps = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        testId: "media-card-actions-menu-item",
        ...props
    });
const $e4d539686a8b35c6$var$createDropdownItemWithAnalytics = (action, index)=>{
    const { label: label, handler: handler, isDisabled: isDisabled } = action;
    const DropdownItemWithAnalytics = (0, $4J0ad.default)({
        onClick: (0, $dUG6w.createAndFireMediaCardEvent)({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'mediaCardDropDownMenuItem',
            attributes: {
                label: label
            }
        })
    })($e4d539686a8b35c6$var$DropdownItemWithProps);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(DropdownItemWithAnalytics, {
        onClick: ()=>handler(),
        isDisabled: isDisabled,
        children: label
    }, index);
};
const $e4d539686a8b35c6$export$2b7a7909eccadfb9 = ({ actions: actions, triggerColor: triggerColor, onOpenChange: onOpenChange, triggerVariant: triggerVariant })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (actions.length > 0) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        testId: "media-card-actions-menu",
        onOpenChange: onOpenChange,
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, onClick: onClick, ...providedProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $3gCUX.CardActionButton), {
                variant: triggerVariant,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    color: triggerColor
                },
                ref: triggerRef,
                onClick: (e)=>{
                    (0, $dUG6w.fireMediaCardEvent)({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'mediaCardDropDownMenu',
                        attributes: {}
                    }, createAnalyticsEvent);
                    onClick?.(e);
                },
                ...providedProps,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "more"
                })
            }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: actions.map($e4d539686a8b35c6$var$createDropdownItemWithAnalytics)
        })
    });
    else return null;
};

});


parcelRegister("l5HCG", function(module, exports) {
$parcel$export(module.exports, "ActionsBarWrapper", () => $5840772c83299ebd$export$e9414cbfa812f398);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $4p4y7 = parcelRequire("4p4y7");

var $botoO = parcelRequire("botoO");
const $5840772c83299ebd$export$e9414cbfa812f398 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4p4y7.ActionsBarWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $botoO.ActionsBarWrapper), {
        ...props
    });

});
parcelRegister("4p4y7", function(module, exports) {
$parcel$export(module.exports, "ActionsBarWrapper", () => $ae9ad3a52fbac40b$export$e9414cbfa812f398);
/* actionsBarWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6L8Yj = parcelRequire("6L8Yj");
const $ae9ad3a52fbac40b$var$wrapperStyles = null;
const $ae9ad3a52fbac40b$var$fixedActionBarStyle = null;
const $ae9ad3a52fbac40b$export$e9414cbfa812f398 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        id: "actionsBarWrapper",
        "data-testId": "actionsBarWrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_v564ybtr _2lx2vrvc _1n261q9c _zulpu2gc _kqswstnw _154iidpf _1xi2idpf _1e0c1txw _1bahusic _ca0qu2gc _n3tdu2gc _u5f3u2gc _19bvu2gc _tzy4idpf",
            props.isFixed && "_tzy4kb7n",
            (0, $6L8Yj.actionsBarClassName)
        ]),
        onClick: (event)=>{
            event.stopPropagation();
            event.preventDefault();
        },
        children: props.children
    });
};
$ae9ad3a52fbac40b$export$e9414cbfa812f398.displayName = 'ActionsBarWrapper';

});
parcelRegister("6L8Yj", function(module, exports) {
$parcel$export(module.exports, "actionsBarClassName", () => $adbe84233641580b$export$a7a5a7c9a03af11);
$parcel$export(module.exports, "fixedActionBarStyles", () => $adbe84233641580b$export$11387bc0e0bf1d5a);
$parcel$export(module.exports, "wrapperStyles", () => $adbe84233641580b$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $f0A3O = parcelRequire("f0A3O");
const $adbe84233641580b$export$a7a5a7c9a03af11 = 'media-card-actions-bar';
const $adbe84233641580b$export$11387bc0e0bf1d5a = `opacity: 1;`;
const $adbe84233641580b$export$491e6397d7c1480b = (isFixed)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $1NIU8.css)(isFixed ? $adbe84233641580b$export$11387bc0e0bf1d5a : 'opacity: 0;', (0, $f0A3O.transition)(), "position:absolute;top:0;right:0;display:flex;flex-flow:row nowrap;justify-content:right;padding:var(--ds-space-100, 8px);gap:var(--ds-space-100, 8px);");
$adbe84233641580b$export$491e6397d7c1480b.displayName = 'ActionsBarWrapper';

});


parcelRegister("botoO", function(module, exports) {
$parcel$export(module.exports, "ActionsBarWrapper", () => $15a2e1bc87251a3a$export$e9414cbfa812f398);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $6L8Yj = parcelRequire("6L8Yj");
const $15a2e1bc87251a3a$export$e9414cbfa812f398 = (props)=>{
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "actionsBarWrapper",
        "data-testId": "actionsBarWrapper",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $6L8Yj.wrapperStyles)(props.isFixed),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6L8Yj.actionsBarClassName),
        onClick: (event)=>{
            event.stopPropagation();
            event.preventDefault();
        }
    }, props.children));
};

});



parcelRegister("3g5Nx", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $9189f9ead972a4dc$export$be58b4326e23250f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $3TTqg = parcelRequire("3TTqg");

var $71dyA = parcelRequire("71dyA");
const $9189f9ead972a4dc$export$be58b4326e23250f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3TTqg.IconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $71dyA.IconWrapper), {
        ...props
    });

});
parcelRegister("3TTqg", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $bcc28e4b6ca93477$export$be58b4326e23250f);
/* iconWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7lRfg = parcelRequire("7lRfg");
function $bcc28e4b6ca93477$export$292aa76b104692f8(hasTitleBox, breakpoint) {
    // there is no titlebox
    if (!hasTitleBox) return `0px`;
    // calculate height of the titlebox
    const marginBottom = (0, $7lRfg.getTitleBoxHeight)(breakpoint);
    return `${marginBottom}px`;
}
const $bcc28e4b6ca93477$var$iconWrapperStyles = null;
const $bcc28e4b6ca93477$export$be58b4326e23250f = (props)=>{
    const { breakpoint: breakpoint, hasTitleBox: hasTitleBox } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        id: "iconWrapper",
        style: {
            height: `calc(100% - ${$bcc28e4b6ca93477$export$292aa76b104692f8(hasTitleBox, breakpoint)})`
        },
        className: (0, $hcewu.default)([
            "_kqswstnw _1bsb1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
        ]),
        children: props.children
    });
};
$bcc28e4b6ca93477$export$be58b4326e23250f.displayName = 'MediaIconWrapper';

});

parcelRegister("71dyA", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $bf74dec2e991c0d0$export$be58b4326e23250f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $dSpL0 = parcelRequire("dSpL0");
const $bf74dec2e991c0d0$export$be58b4326e23250f = (props)=>{
    const { breakpoint: breakpoint, hasTitleBox: hasTitleBox } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "iconWrapper",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $dSpL0.iconWrapperStyles)({
            breakpoint: breakpoint,
            hasTitleBox: hasTitleBox
        })
    }, props.children);
};

});
parcelRegister("dSpL0", function(module, exports) {
$parcel$export(module.exports, "iconWrapperStyles", () => $156873013397e6eb$export$7bb30bfb2c35845e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7lRfg = parcelRequire("7lRfg");
function $156873013397e6eb$export$292aa76b104692f8(hasTitleBox, breakpoint) {
    // there is no titlebox
    if (!hasTitleBox) return `0px`;
    // calculate height of the titlebox
    const marginBottom = (0, $7lRfg.getTitleBoxHeight)(breakpoint);
    return `${marginBottom}px`;
}
const $156873013397e6eb$export$7bb30bfb2c35845e = ({ hasTitleBox: hasTitleBox, breakpoint: breakpoint })=>/*#__PURE__*/ (0, $1NIU8.css)({
        position: 'absolute',
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% - ${$156873013397e6eb$export$292aa76b104692f8(hasTitleBox, breakpoint)})`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    });
$156873013397e6eb$export$7bb30bfb2c35845e.displayName = 'MediaIconWrapper';

});



parcelRegister("eLvoQ", function(module, exports) {
$parcel$export(module.exports, "CreatingPreview", () => $ce315439b8945432$export$4a80244213cb4afc);
$parcel$export(module.exports, "PreviewUnavailable", () => $ce315439b8945432$export$35337070c6dafccf);
$parcel$export(module.exports, "FailedToLoad", () => $ce315439b8945432$export$a712c963efa9c728);
$parcel$export(module.exports, "FailedToUpload", () => $ce315439b8945432$export$f6b7f98fc8b4c6c7);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7kOki = parcelRequire("7kOki");

var $lk6TK = parcelRequire("lk6TK");

var $kDaaB = parcelRequire("kDaaB");
const $ce315439b8945432$export$49a5d8503f8a110a = ({ messageDescriptor: messageDescriptor, animated: animated = false })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7kOki.IconMessageWrapper), {
        animated: animated,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...messageDescriptor
            })
        })
    });
};
const $ce315439b8945432$export$4a80244213cb4afc = ({ disableAnimation: disableAnimation })=>/*#__PURE__*/ (0, $gt9Am.jsx)($ce315439b8945432$export$49a5d8503f8a110a, {
        messageDescriptor: (0, $lk6TK.messages).creating_preview,
        animated: !disableAnimation
    });
const $ce315439b8945432$export$35337070c6dafccf = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($ce315439b8945432$export$49a5d8503f8a110a, {
        ...props,
        messageDescriptor: (0, $lk6TK.messages).preview_unavailable
    });
const $ce315439b8945432$export$a712c963efa9c728 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($ce315439b8945432$export$49a5d8503f8a110a, {
        ...props,
        messageDescriptor: (0, $lk6TK.messages).failed_to_load
    });
const $ce315439b8945432$export$f6b7f98fc8b4c6c7 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($ce315439b8945432$export$49a5d8503f8a110a, {
        ...props,
        messageDescriptor: (0, $lk6TK.messages).failed_to_upload
    });

});
parcelRegister("7kOki", function(module, exports) {
$parcel$export(module.exports, "IconMessageWrapper", () => $a8f4e0646dfbeef2$export$e33129280ab99883);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $eO0iT = parcelRequire("eO0iT");

var $eBKjx = parcelRequire("eBKjx");
const $a8f4e0646dfbeef2$export$e33129280ab99883 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eO0iT.IconMessageWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eBKjx.IconMessageWrapper), {
        ...props
    });

});
parcelRegister("eO0iT", function(module, exports) {
$parcel$export(module.exports, "IconMessageWrapper", () => $721c34a77a832b18$export$e33129280ab99883);
/* iconMessageWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $721c34a77a832b18$var$breatheAnimation = null;
const $721c34a77a832b18$var$animatedStyles = null;
const $721c34a77a832b18$var$baseStyles = null;
const $721c34a77a832b18$export$e33129280ab99883 = (props)=>{
    const { animated: animated } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        id: "iconMessageWrapper",
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1rjc1b66 _18zru2gc _tzy4kb7n _k48p1wq8 _syaz1e9r _y3gn1h6o _otyr1d21",
            animated && "",
            animated && "_j7hqq7op _5sag1nwe _1pgl1ytf _tip812c5"
        ]),
        children: props.children
    });
};

});

parcelRegister("eBKjx", function(module, exports) {
$parcel$export(module.exports, "IconMessageWrapper", () => $b2c2e570376bf106$export$e33129280ab99883);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $b2c2e570376bf106$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b2c2e570376bf106$var$breatheAnimation = (0, $1NIU8.keyframes)({
    '0%': {
        opacity: 1
    },
    '50%': {
        opacity: 0.3
    },
    '100%': {
        opacity: 1
    }
});
const $b2c2e570376bf106$var$animatedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    animationName: $b2c2e570376bf106$var$breatheAnimation,
    animationDuration: '3.5s',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite'
});
const $b2c2e570376bf106$var$baseStyles = {
    name: "dl0jwy",
    styles: "overflow:hidden;opacity:1;font-weight:var(--ds-font-weight-medium, 500);color:var(--ds-text-subtlest, #7A869A);text-align:center;margin-bottom:-1em;padding-block:var(--ds-space-050, 4px);padding-inline:var(--ds-space-100, 8px)"
};
const $b2c2e570376bf106$export$e33129280ab99883 = (props)=>{
    const { animated: animated } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "iconMessageWrapper",
        css: [
            $b2c2e570376bf106$var$baseStyles,
            animated && $b2c2e570376bf106$var$animatedStyles
        ]
    }, props.children);
};

});



parcelRegister("6U66H", function(module, exports) {
$parcel$export(module.exports, "ImageContainer", () => $cbe69eba3261a529$export$94026ee33dbabc26);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $1VWMb = parcelRequire("1VWMb");
const $cbe69eba3261a529$export$94026ee33dbabc26 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1VWMb.ImageContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1VWMb.ImageContainer), {
        ...props
    });

});
parcelRegister("1VWMb", function(module, exports) {
$parcel$export(module.exports, "ImageContainer", () => $87dd61a9d89d75bf$export$94026ee33dbabc26);
/* imageContainer-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $87dd61a9d89d75bf$var$imageContainerStyles = null;
const $87dd61a9d89d75bf$var$imageContainerCenterStyles = null;
const $87dd61a9d89d75bf$export$94026ee33dbabc26 = ({ children: children, mediaName: mediaName, status: status, progress: progress, selected: selected, source: source, centerElements: centerElements })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": (0, $87b212d64266f221$export$7a6526d4be3b7eb3),
        /**
 * This wrapper MUST add the classname in order to allow the editor to prevent bubbling up the click event.
 * See the method isInteractiveElement in source platform/packages/editor/renderer/src/ui/Renderer/click-to-edit.ts
 * Also, many other consumer tests rely on this selector.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _2rkofajl _1e0c1txw _kqswh2mm _p12f1osq _1bsb1osq _4t3i1osq _c71l1osq",
            centerElements && "_2lx21bp4 _1bah1h6o _4cvr1h6o",
            (0, $87b212d64266f221$export$7a6526d4be3b7eb3)
        ]),
        "data-test-media-name": mediaName,
        "data-test-status": status,
        "data-test-progress": progress,
        "data-test-selected": selected,
        "data-test-source": source,
        children: children
    });

});
const $87b212d64266f221$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $87b212d64266f221$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';



parcelRegister("4NdcT", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $bd97fc8f08620e81$export$e6dfd72ab29f8598);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $lsmRf = parcelRequire("lsmRf");

var $eKHyA = parcelRequire("eKHyA");
const $bd97fc8f08620e81$export$e6dfd72ab29f8598 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lsmRf.Wrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eKHyA.Wrapper), {
        ...props
    });

});
parcelRegister("lsmRf", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $6c1624eabbf6772a$export$e6dfd72ab29f8598);
/* wrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $jgJtD = parcelRequire("jgJtD");

var $1n5AE = parcelRequire("1n5AE");

var $4MFrL = parcelRequire("4MFrL");

var $2gvG4 = parcelRequire("2gvG4");
const $6c1624eabbf6772a$var$LOCAL_WIDTH_VARIABLE = '--media-wrapper-width';
const $6c1624eabbf6772a$var$LOCAL_HEIGHT_VARIABLE = '--media-wrapper-height';
const $6c1624eabbf6772a$var$wrapperStyles = {
    default: "_2rkofajl _vchhusvi _kqswh2mm _ect41gqc _p12f1osq _c71l1osq _1bsb1qmm _4t3ine4n _1hlmjc5g _1rquusvi _eg54a8ns _mts3kb7n _1ntskb7n"
};
const $6c1624eabbf6772a$var$backgroundStyle = null;
const $6c1624eabbf6772a$var$cursorStyleMap = {
    pointer: "_80omtlke",
    wait: "_80omv00u"
};
const $6c1624eabbf6772a$var$shadowStyleMap = {
    withOverlay: "_16qsx49n",
    selected: "_16qs666x",
    selectedWithOverlay: "_16qs1sw4"
};
const $6c1624eabbf6772a$var$getShadowKey = (disableOverlay, selected)=>{
    if (!disableOverlay && selected) return 'selectedWithOverlay';
    if (!disableOverlay) return 'withOverlay';
    if (selected) return 'selected';
    return '';
};
const $6c1624eabbf6772a$var$hideNativeBrowserTextSelectionStyles = null;
const $6c1624eabbf6772a$var$clickableButtonPlayButtonStyles = null;
const $6c1624eabbf6772a$var$selectableTickboxStyle = null;
const $6c1624eabbf6772a$var$tooltipStyle = null;
const $6c1624eabbf6772a$var$getResponsiveStyles = (breakpoint)=>{
    // dynamically setting the properties to avoid ratcheting build errors. These need to be removed however for the compiled transformation.
    return breakpoint === 'small' ? {
        ['fontSize']: '11px',
        ['lineHeight']: '14px'
    } : {
        ['fontSize']: '14px',
        ['lineHeight']: '22px'
    };
};
const $6c1624eabbf6772a$export$e6dfd72ab29f8598 = (props)=>{
    const { testId: testId, dimensions: dimensions, appearance: appearance, onClick: onClick, onMouseEnter: onMouseEnter, innerRef: innerRef, breakpoint: breakpoint, mediaCardCursor: mediaCardCursor, disableOverlay: disableOverlay, selected: selected, displayBackground: displayBackground, isPlayButtonClickable: isPlayButtonClickable, isTickBoxSelectable: isTickBoxSelectable, shouldDisplayTooltip: shouldDisplayTooltip } = props;
    const defaultImageCardDimensions = (0, $1n5AE.getDefaultCardDimensions)(appearance);
    const width = (0, $4MFrL.getCSSUnitValue)(dimensions?.width || defaultImageCardDimensions.width);
    const height = (0, $4MFrL.getCSSUnitValue)(dimensions?.height || defaultImageCardDimensions.height);
    const wrapperShadowKey = $6c1624eabbf6772a$var$getShadowKey(disableOverlay, selected);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        id: "newFileExperienceWrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $6c1624eabbf6772a$var$wrapperStyles.default,
            displayBackground && "_bfhk1s4m",
            mediaCardCursor && $6c1624eabbf6772a$var$cursorStyleMap[mediaCardCursor],
            wrapperShadowKey && $6c1624eabbf6772a$var$shadowStyleMap[wrapperShadowKey],
            selected && "_1p1y18uv _1rk818uv _14r118uv _1np218uv",
            isPlayButtonClickable && "_1y898vuz _19zy8vuz",
            isTickBoxSelectable && "_1yf91j9a _1xp5kufk",
            shouldDisplayTooltip && "_9m3z1osq _10pb1osq",
            (0, $c214caf0b65ba182$export$c5ba918dbb0b00f3)
        ]),
        "data-testid": testId,
        style: {
            [$6c1624eabbf6772a$var$LOCAL_WIDTH_VARIABLE]: width,
            [$6c1624eabbf6772a$var$LOCAL_HEIGHT_VARIABLE]: height,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...$6c1624eabbf6772a$var$getResponsiveStyles(breakpoint)
        },
        ref: innerRef,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        ...(0, $jgJtD.VcMediaWrapperProps),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2gvG4.default), {
                data: {
                    hasMediaComponent: true
                }
            }),
            props.children
        ]
    });
};
$6c1624eabbf6772a$export$e6dfd72ab29f8598.displayName = 'NewFileExperienceWrapper';

});
const $c214caf0b65ba182$export$c5ba918dbb0b00f3 = 'new-file-experience-wrapper';


parcelRegister("eKHyA", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $62e64f42d7a65978$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $4BaPb = parcelRequire("4BaPb");

var $jgJtD = parcelRequire("jgJtD");

var $2gvG4 = parcelRequire("2gvG4");
const $62e64f42d7a65978$export$e6dfd72ab29f8598 = (props)=>{
    const { testId: testId, dimensions: dimensions, appearance: appearance, onClick: onClick, onMouseEnter: onMouseEnter, innerRef: innerRef, breakpoint: breakpoint, mediaCardCursor: mediaCardCursor, disableOverlay: disableOverlay, selected: selected, displayBackground: displayBackground, isPlayButtonClickable: isPlayButtonClickable, isTickBoxSelectable: isTickBoxSelectable, shouldDisplayTooltip: shouldDisplayTooltip } = props;
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "newFileExperienceWrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $c214caf0b65ba182$export$c5ba918dbb0b00f3),
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $4BaPb.wrapperStyles)({
            breakpoint: breakpoint,
            dimensions: dimensions,
            appearance: appearance,
            disableOverlay: disableOverlay,
            displayBackground: displayBackground,
            selected: selected,
            isPlayButtonClickable: isPlayButtonClickable,
            isTickBoxSelectable: isTickBoxSelectable,
            shouldDisplayTooltip: shouldDisplayTooltip,
            mediaCardCursor: mediaCardCursor
        }),
        ref: innerRef,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        ...(0, $jgJtD.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2gvG4.default), {
        data: {
            hasMediaComponent: true
        }
    }), props.children));
};

});
parcelRegister("4BaPb", function(module, exports) {
$parcel$export(module.exports, "wrapperStyles", () => $3093c099734d3d2c$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $iYfp4 = parcelRequire("iYfp4");


var $2N2k8 = parcelRequire("2N2k8");

var $f0A3O = parcelRequire("f0A3O");

var $jzWHk = parcelRequire("jzWHk");

var $6L8Yj = parcelRequire("6L8Yj");
const $3093c099734d3d2c$export$491e6397d7c1480b = ({ breakpoint: breakpoint, dimensions: dimensions, appearance: appearance, disableOverlay: disableOverlay, displayBackground: displayBackground, selected: selected, isPlayButtonClickable: isPlayButtonClickable, isTickBoxSelectable: isTickBoxSelectable, shouldDisplayTooltip: shouldDisplayTooltip, mediaCardCursor: mediaCardCursor })=>/*#__PURE__*/ (0, $1NIU8.css)((0, $f0A3O.transition)(), " box-sizing:border-box;*{box-sizing:border-box;}position:relative;font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (0, $f0A3O.getWrapperDimensions)(dimensions, appearance), " ", displayBackground && `background: ${`var(--ds-background-neutral, ${0, $7bb4c1736002a04a$export$9fdfb749e33cdf97})`};`, " ", (0, $iYfp4.borderRadius), " ", (0, $f0A3O.getCursorStyle)(mediaCardCursor), " ", (0, $f0A3O.getWrapperShadow)(disableOverlay, selected), " ", (0, $f0A3O.generateResponsiveStyles)(breakpoint), ";", selected ? (0, $2N2k8.hideNativeBrowserTextSelectionStyles) : '', (0, $f0A3O.getClickablePlayButtonStyles)(isPlayButtonClickable), " ", (0, $f0A3O.getSelectableTickBoxStyles)(isTickBoxSelectable), " &:hover .", (0, $jzWHk.blanketClassName), "{", (0, $jzWHk.fixedBlanketStyles), ";}&:hover .", (0, $6L8Yj.actionsBarClassName), ",&:focus-within .", (0, $6L8Yj.actionsBarClassName), "{", (0, $6L8Yj.fixedActionBarStyles), ";}", shouldDisplayTooltip && `> div { width: 100%; height: 100%; }`, " button:focus+&{outline:solid 2px ", `var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a)})`, ";}");
$3093c099734d3d2c$export$491e6397d7c1480b.displayName = 'NewFileExperienceWrapper';

});
parcelRegister("2N2k8", function(module, exports) {
$parcel$export(module.exports, "getSelectionStyles", () => $6b23a7199e707c88$export$fb186b651805ffe4);
$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $6b23a7199e707c88$export$a716852a0c5e54d5);

var $7yBx7 = parcelRequire("7yBx7");

var $egs2l = parcelRequire("egs2l");
const $6b23a7199e707c88$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$6b23a7199e707c88$var$getSelectionStyle(selectionStyle)).concat($6b23a7199e707c88$export$a716852a0c5e54d5).join('\n');
const $6b23a7199e707c88$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $6b23a7199e707c88$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $egs2l.SelectionStyle).Border:
            return `
        border: ${0, $7yBx7.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $7yBx7.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $egs2l.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $7yBx7.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $egs2l.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FF)"};`;
        case (0, $egs2l.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $7yBx7.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};

});
parcelRegister("egs2l", function(module, exports) {
$parcel$export(module.exports, "SelectionStyle", () => $947335242c3fddd4$export$80010201b36a8290);
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $947335242c3fddd4$export$80010201b36a8290 = /*#__PURE__*/ function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    return SelectionStyle;
}({});

});





parcelRegister("7SEfT", function(module, exports) {
$parcel$export(module.exports, "useBreakpoint", () => $9262032354efe83d$export$199d6754bdf4e1e3);

var $eJOHy = parcelRequire("eJOHy");

var $f0A3O = parcelRequire("f0A3O");

var $1n5AE = parcelRequire("1n5AE");
var $bvnIh = parcelRequire("bvnIh");
var $dUCca = parcelRequire("dUCca");
const $9262032354efe83d$export$199d6754bdf4e1e3 = (dimensionWidth = 0, divRef)=>{
    const breakpoint = (0, $eJOHy.useMemo)(()=>{
        let widthToCalculate;
        if (dimensionWidth) {
            if ((0, $dUCca.isValidPercentageUnit)(dimensionWidth) && divRef.current) {
                const width = (0, $bvnIh.getElementDimension)(divRef.current, 'width');
                widthToCalculate = width || (0, $1n5AE.defaultImageCardDimensions).width;
            } else widthToCalculate = dimensionWidth;
        } else widthToCalculate = (0, $1n5AE.defaultImageCardDimensions).width;
        return (0, $f0A3O.calcBreakpointSize)(parseInt(`${widthToCalculate}`, 10));
    }, [
        dimensionWidth,
        divRef
    ]);
    return breakpoint;
};

});
parcelRegister("bvnIh", function(module, exports) {
$parcel$export(module.exports, "getElementDimension", () => $f6fa2700f4252d40$export$5ceade75ca11ae14);
const $f6fa2700f4252d40$export$5ceade75ca11ae14 = (element, dimension)=>{
    const dimensionValue = element.getBoundingClientRect()[dimension];
    return Math.round(dimensionValue);
};

});

parcelRegister("dUCca", function(module, exports) {
$parcel$export(module.exports, "isValidPercentageUnit", () => $ab79c0892b986377$export$c30ed4dee1ebdfbf);
// Utility used to know if the integrator is using percentage values
const $ab79c0892b986377$export$c30ed4dee1ebdfbf = (value)=>{
    const valueString = `${value}`;
    return valueString[valueString.length - 1] === '%' && !isNaN(+valueString.slice(0, -1));
};

});


parcelRegister("hxpDY", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecaf54b8d1f91967$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $lk6TK = parcelRequire("lk6TK");

var $46R8N = parcelRequire("46R8N");

var $6fs4r = parcelRequire("6fs4r");
const $ecaf54b8d1f91967$var$OpenMediaViewerButton = ({ fileName: fileName, innerRef: innerRef, ...props })=>{
    const intl = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            ref: innerRef,
            ...props,
            children: intl.formatMessage((0, $lk6TK.messages).open_file_in_viewer, {
                name: fileName
            })
        })
    });
};
const $ecaf54b8d1f91967$var$OpenMediaViewerButtonWrapper = (props)=>{
    return props.intl ? /*#__PURE__*/ (0, $gt9Am.jsx)($ecaf54b8d1f91967$var$OpenMediaViewerButton, {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($ecaf54b8d1f91967$var$OpenMediaViewerButton, {
            ...props
        })
    });
};
var $ecaf54b8d1f91967$export$2e2bcd8739ae039 = (0, $6YFG2.default)($ecaf54b8d1f91967$var$OpenMediaViewerButtonWrapper, {
    enforceContext: false
});

});

parcelRegister("1pW0T", function(module, exports) {
$parcel$export(module.exports, "SvgView", () => $0d273983b6695cf2$export$cf98b60e5f1e2515);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $ixvAT = parcelRequire("ixvAT");

var $ik6Vx = parcelRequire("ik6Vx");

var $1DL83 = parcelRequire("1DL83");
const $0d273983b6695cf2$export$cf98b60e5f1e2515 = (props)=>{
    return (0, $eGOwo.fg)('platform_media_card_image_render') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1DL83.SvgView), {
        ...props
    }) : (0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ixvAT.SvgView), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik6Vx.SvgView), {
        ...props
    });
};

});
parcelRegister("ixvAT", function(module, exports) {
$parcel$export(module.exports, "SvgView", () => $4675e12415e14638$export$cf98b60e5f1e2515);
/* svgImage-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1yWtS = parcelRequire("1yWtS");

var $j6ECA = parcelRequire("j6ECA");

var $4uQRW = parcelRequire("4uQRW");
var $8U7G1 = parcelRequire("8U7G1");
const $4675e12415e14638$var$getErrorReason = (svgReason)=>{
    switch(svgReason){
        case 'img-error':
            return 'svg-img-error';
        case 'binary-fetch':
            return 'svg-binary-fetch';
        case 'blob-to-datauri':
            return 'svg-blob-to-datauri';
        default:
            return 'svg-unknown-error';
    }
};
const $4675e12415e14638$var$svgRendererStyles = null;
const $4675e12415e14638$var$svgRendererMaxDimensionStyles = null;
const $4675e12415e14638$export$cf98b60e5f1e2515 = ({ identifier: identifier, resizeMode: resizeMode, onLoad: onLoad, onError: onError, wrapperRef: wrapperRef, alt: alt })=>{
    const [didSvgRender, setDidSvgRender] = (0, $eJOHy.useState)(false);
    const [svgDimensions, setSvgDimensions] = (0, $eJOHy.useState)({});
    const imgRef = (0, $eJOHy.useRef)(null);
    const calculateDimensions = (0, $eJOHy.useCallback)((targetImgElem)=>{
        if (!wrapperRef.current || !targetImgElem) return;
        setSvgDimensions((0, $j6ECA.calculateSvgDimensions)(targetImgElem, wrapperRef.current, resizeMode));
    }, [
        resizeMode,
        wrapperRef
    ]);
    const onSvgLoad = (evt)=>{
        calculateDimensions(evt.currentTarget);
        setDidSvgRender(true);
        onLoad?.();
    };
    const onSvgError = (err)=>{
        const error = new (0, $1yWtS.MediaCardError)($4675e12415e14638$var$getErrorReason(err.primaryReason), err.secondaryError);
        onError?.(error);
    };
    (0, $eJOHy.useEffect)(()=>{
        if (imgRef.current) calculateDimensions(imgRef.current);
    }, [
        imgRef,
        calculateDimensions
    ]);
    const { svgUrl: svgUrl, source: source } = (0, $8U7G1.useResolveSvg)(identifier, onSvgError);
    const { width: width, height: height } = svgDimensions;
    return svgUrl && source ? /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        "data-testid": 'media-card-svg',
        "data-fileid": identifier.id,
        "data-filecollection": identifier.collectionName,
        "data-source": source,
        src: svgUrl,
        alt: alt,
        style: {
            visibility: didSvgRender ? 'visible' : 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...svgDimensions
        },
        onLoad: onSvgLoad,
        onError: ()=>{
            onSvgError(new (0, $4uQRW.MediaSVGError)('img-error'));
        },
        ref: imgRef,
        className: (0, $hcewu.default)([
            "_5ral1f51 _bfhku67f",
            !width && !height && "_p12f1osq _c71l1osq"
        ])
    }) : null;
};

});
parcelRegister("j6ECA", function(module, exports) {
$parcel$export(module.exports, "calculateSvgDimensions", () => $4e55c830f8c84634$export$56f32e61c4316384);
const $4e55c830f8c84634$export$56f32e61c4316384 = (imgElement, parentElement, resizeMode)=>{
    const { naturalWidth: naturalWidth, width: width, naturalHeight: naturalHeight, height: height } = imgElement;
    // Firefox & Safari can't always read the "natural" dimensions correctly.
    // When these are undefined or zero, we replace them with the rendered values
    const imgWidth = naturalWidth || width;
    const imgHeight = naturalHeight || height;
    const { width: parentWidth, height: parentHeight } = parentElement.getBoundingClientRect();
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `min(100%, ${imgWidth}px)`,
        maxHeight: `min(100%, ${imgHeight}px)`
    };
    const imgRatio = imgWidth / imgHeight;
    const cardRatio = parentWidth / parentHeight;
    const isImageLandscapier = imgRatio > cardRatio;
    if (resizeMode === 'stretchy-fit') {
        if (isImageLandscapier) return {
            width: '100%',
            maxHeight: '100%'
        };
        else return {
            height: '100%',
            maxWidth: '100%'
        };
    }
    if (resizeMode === 'crop') {
        if (isImageLandscapier) return {
            height: imgHeight,
            maxHeight: '100%'
        };
        else return {
            width: imgWidth,
            maxWidth: '100%'
        };
    }
    return {};
};

});

parcelRegister("4uQRW", function(module, exports) {
$parcel$export(module.exports, "MediaSVGError", () => $50b90756e53a243e$export$c4ae8d1d12c193a7);
$parcel$export(module.exports, "createUnexpectedErrorCallback", () => $50b90756e53a243e$export$ba08301c71bd9cf6);
class $50b90756e53a243e$export$c4ae8d1d12c193a7 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
const $50b90756e53a243e$export$ba08301c71bd9cf6 = (onError)=>(e)=>{
        onError?.(new $50b90756e53a243e$export$c4ae8d1d12c193a7('unexpected', e));
    };

});

parcelRegister("8U7G1", function(module, exports) {
$parcel$export(module.exports, "useResolveSvg", () => $509627b11395cd8c$export$d127d14f68c2bbcf);

var $eJOHy = parcelRequire("eJOHy");

var $djK7X = parcelRequire("djK7X");
var $3cc2J = parcelRequire("3cc2J");

var $eoc4s = parcelRequire("eoc4s");

var $g4S3q = parcelRequire("g4S3q");

var $4uQRW = parcelRequire("4uQRW");
// We need to convert the blob into Base64 for security reasons: https://asecurityteam.atlassian.net/browse/VULN-1495952
// Make sure to update the test helper mockFileReader if this is changed
function $509627b11395cd8c$var$blobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(// reader.readAsDataURL makes reader.result a string
            // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            reader.result);
        reader.onerror = (e)=>reject(new (0, $4uQRW.MediaSVGError)('blob-to-datauri', e instanceof Error ? e : undefined));
        reader.readAsDataURL(blob);
    });
}
const $509627b11395cd8c$var$getLocalSvg = async (preview)=>{
    const { value: value } = await preview;
    if (typeof value === 'string') return value;
    return $509627b11395cd8c$var$blobToBase64(value);
};
const $509627b11395cd8c$var$getRemoteSvg = async ({ id: id, collectionName: collectionName }, mediaClient)=>{
    const blob = await mediaClient.mediaStore.getFileBinary(id, collectionName).catch((e)=>{
        throw new (0, $4uQRW.MediaSVGError)('binary-fetch', e instanceof Error ? e : undefined);
    });
    return await $509627b11395cd8c$var$blobToBase64(blob);
};
const $509627b11395cd8c$export$d127d14f68c2bbcf = (identifier, onError)=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const { id: id, collectionName: collectionName } = identifier;
    const { id: prevId } = (0, $g4S3q.usePrevious)(identifier) || identifier;
    const { fileState: fileState } = (0, $djK7X.useFileState)(id, {
        collectionName: collectionName
    });
    const [svgUrl, setSvgUrl] = (0, $eJOHy.useState)(undefined);
    const [source, setSource] = (0, $eJOHy.useState)(undefined);
    const onErrorRef = (0, $eoc4s.useCurrentValueRef)(onError);
    (0, $eJOHy.useEffect)(()=>{
        if (id !== prevId) setSvgUrl(undefined);
    }, [
        id,
        prevId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (svgUrl || !fileState || fileState.status === 'error' || fileState?.mimeType !== 'image/svg+xml') return;
        const { preview: preview } = fileState;
        if (preview) $509627b11395cd8c$var$getLocalSvg(preview).then((content)=>{
            setSvgUrl(content);
            setSource('local');
        }).catch(onErrorRef.current);
        else $509627b11395cd8c$var$getRemoteSvg(identifier, mediaClient).then((content)=>{
            setSvgUrl(content);
            setSource('remote');
        }).catch(onErrorRef.current);
    }, [
        identifier,
        fileState,
        mediaClient,
        onErrorRef,
        svgUrl
    ]);
    return {
        svgUrl: svgUrl,
        source: source
    };
};

});
parcelRegister("djK7X", function(module, exports) {
$parcel$export(module.exports, "useFileState", () => $5a07b53d359ee7c3$export$90ff537b0999afb);

var $eJOHy = parcelRequire("eJOHy");

var $3cc2J = parcelRequire("3cc2J");

var $kNd6B = parcelRequire("kNd6B");
function $5a07b53d359ee7c3$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const fileState = (0, $kNd6B.useMediaStore)((state)=>state.files[id]);
    (0, $eJOHy.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("3cc2J", function(module, exports) {
$parcel$export(module.exports, "useMediaClient", () => $d8e7b96ea4671e74$export$8b3e87ea56c3a345);

var $eJOHy = parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");

var $f7iZ0 = parcelRequire("f7iZ0");
const $d8e7b96ea4671e74$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $93R6D.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $f7iZ0.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});

parcelRegister("kNd6B", function(module, exports) {
$parcel$export(module.exports, "useMediaStore", () => $d5b1e147a2796345$export$8a9cc8c330400af8);

var $eOVQp = parcelRequire("eOVQp");

var $3cc2J = parcelRequire("3cc2J");
const $d5b1e147a2796345$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $eOVQp.useStore)(store, selector, equals);
function $d5b1e147a2796345$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $d5b1e147a2796345$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("eOVQp", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $aca29ade4cd157ce$export$6ccbb43953eebf8);
$parcel$export(module.exports, "create", () => $aca29ade4cd157ce$export$185802fd694ee1f5);

var $96y8R = parcelRequire("96y8R");

var $eJOHy = parcelRequire("eJOHy");

var $iHcr1 = parcelRequire("iHcr1");
var $aca29ade4cd157ce$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $aca29ade4cd157ce$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)));
const { useSyncExternalStoreWithSelector: $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($iHcr1)));
let $aca29ade4cd157ce$var$didWarnAboutEqualityFn = false;
const $aca29ade4cd157ce$var$identity = (arg)=>arg;
function $aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector = $aca29ade4cd157ce$var$identity, equalityFn) {
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$aca29ade4cd157ce$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $aca29ade4cd157ce$var$didWarnAboutEqualityFn = true;
    }
    const slice = $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $aca29ade4cd157ce$var$useDebugValue(slice);
    return slice;
}
const $aca29ade4cd157ce$var$createImpl = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $96y8R.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $aca29ade4cd157ce$export$185802fd694ee1f5 = (createState)=>createState ? $aca29ade4cd157ce$var$createImpl(createState) : $aca29ade4cd157ce$var$createImpl;
var $aca29ade4cd157ce$export$2e2bcd8739ae039 = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $aca29ade4cd157ce$export$185802fd694ee1f5(createState);
};

});



parcelRegister("eoc4s", function(module, exports) {
$parcel$export(module.exports, "useCurrentValueRef", () => $0a699ee4e49e0d68$export$b3e10e1f0fbb71db);

var $eJOHy = parcelRequire("eJOHy");
function $0a699ee4e49e0d68$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}

});

parcelRegister("g4S3q", function(module, exports) {
$parcel$export(module.exports, "usePrevious", () => $3fa1b3d072ae6ae2$export$5cae361ad82dce8b);

var $eJOHy = parcelRequire("eJOHy");
function $3fa1b3d072ae6ae2$export$5cae361ad82dce8b(value) {
    const ref = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});



parcelRegister("ik6Vx", function(module, exports) {
$parcel$export(module.exports, "SvgView", () => $2593d027ceb8ba48$export$cf98b60e5f1e2515);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $1yWtS = parcelRequire("1yWtS");

var $j6ECA = parcelRequire("j6ECA");

var $4uQRW = parcelRequire("4uQRW");
var $8U7G1 = parcelRequire("8U7G1");
function $2593d027ceb8ba48$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2593d027ceb8ba48$var$getErrorReason = (svgReason)=>{
    switch(svgReason){
        case 'img-error':
            return 'svg-img-error';
        case 'binary-fetch':
            return 'svg-binary-fetch';
        case 'blob-to-datauri':
            return 'svg-blob-to-datauri';
        default:
            return 'svg-unknown-error';
    }
};
const $2593d027ceb8ba48$var$svgRendererStyles = {
    name: "19l0qnz",
    styles: "object-fit:contain;background-color:white"
};
const $2593d027ceb8ba48$var$svgRendererMaxDimensionStyles = {
    name: "vb5fe1",
    styles: "max-width:100%;max-height:100%"
};
const $2593d027ceb8ba48$export$cf98b60e5f1e2515 = ({ identifier: identifier, resizeMode: resizeMode, onLoad: onLoad, onError: onError, wrapperRef: wrapperRef, alt: alt })=>{
    const [didSvgRender, setDidSvgRender] = (0, $eJOHy.useState)(false);
    const [svgDimensions, setSvgDimensions] = (0, $eJOHy.useState)({});
    const imgRef = (0, $eJOHy.useRef)(null);
    const calculateDimensions = (0, $eJOHy.useCallback)((targetImgElem)=>{
        if (!wrapperRef.current || !targetImgElem) return;
        setSvgDimensions((0, $j6ECA.calculateSvgDimensions)(targetImgElem, wrapperRef.current, resizeMode));
    }, [
        resizeMode,
        wrapperRef
    ]);
    const onSvgLoad = (evt)=>{
        calculateDimensions(evt.currentTarget);
        setDidSvgRender(true);
        onLoad?.();
    };
    const onSvgError = (err)=>{
        const error = new (0, $1yWtS.MediaCardError)($2593d027ceb8ba48$var$getErrorReason(err.primaryReason), err.secondaryError);
        onError?.(error);
    };
    (0, $eJOHy.useEffect)(()=>{
        if (imgRef.current) calculateDimensions(imgRef.current);
    }, [
        imgRef,
        calculateDimensions
    ]);
    const { svgUrl: svgUrl, source: source } = (0, $8U7G1.useResolveSvg)(identifier, onSvgError);
    const { width: width, height: height } = svgDimensions;
    return svgUrl && source ? /*#__PURE__*/ (0, $1NIU8.jsx)("img", {
        "data-testid": 'media-card-svg',
        "data-fileid": identifier.id,
        "data-filecollection": identifier.collectionName,
        "data-source": source,
        src: svgUrl,
        alt: alt,
        css: [
            $2593d027ceb8ba48$var$svgRendererStyles,
            !width && !height && $2593d027ceb8ba48$var$svgRendererMaxDimensionStyles
        ],
        style: {
            visibility: didSvgRender ? 'visible' : 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...svgDimensions
        },
        onLoad: onSvgLoad,
        onError: ()=>{
            onSvgError(new (0, $4uQRW.MediaSVGError)('img-error'));
        },
        ref: imgRef
    }) : null;
};

});

parcelRegister("1DL83", function(module, exports) {
$parcel$export(module.exports, "SvgView", () => $460ac77578d5f974$export$cf98b60e5f1e2515);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $1yWtS = parcelRequire("1yWtS");

var $4uQRW = parcelRequire("4uQRW");
var $8U7G1 = parcelRequire("8U7G1");

var $7pbB3 = parcelRequire("7pbB3");
const $460ac77578d5f974$var$getErrorReason = (svgReason)=>{
    switch(svgReason){
        case 'img-error':
            return 'svg-img-error';
        case 'binary-fetch':
            return 'svg-binary-fetch';
        case 'blob-to-datauri':
            return 'svg-blob-to-datauri';
        default:
            return 'svg-unknown-error';
    }
};
const $460ac77578d5f974$export$cf98b60e5f1e2515 = ({ identifier: identifier, resizeMode: resizeMode, onLoad: onLoad, onError: onError, wrapperRef: wrapperRef, alt: alt })=>{
    const onSvgError = (err)=>{
        const error = new (0, $1yWtS.MediaCardError)($460ac77578d5f974$var$getErrorReason(err.primaryReason), err.secondaryError);
        onError?.(error);
    };
    const { svgUrl: svgUrl, source: source } = (0, $8U7G1.useResolveSvg)(identifier, onSvgError);
    const cardPreview = (0, $eJOHy.useMemo)(()=>svgUrl && source ? {
            dataURI: svgUrl,
            source: source
        } : undefined, [
        svgUrl,
        source
    ]);
    return cardPreview ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7pbB3.ImageRenderer), {
        testId: "media-card-svg",
        identifier: identifier,
        cardPreview: cardPreview,
        alt: alt,
        resizeMode: resizeMode,
        onImageLoad: onLoad,
        onImageError: ()=>{
            onSvgError(new (0, $4uQRW.MediaSVGError)('img-error'));
        },
        wrapperRef: wrapperRef,
        mediaType: "image",
        useWhiteBackground: true
    }) : null;
};

});



parcelRegister("8Uhop", function(module, exports) {
$parcel$export(module.exports, "performanceNow", () => $d0915183535ef13c$export$fb4230f160368c88);
const $d0915183535ef13c$export$fb4230f160368c88 = ()=>performance.now();

});


parcelRegister("gKRet", function(module, exports) {
$parcel$export(module.exports, "FileCard", () => $93cc0fd373008fd4$export$593fd10f7e6c6505);

var $gt9Am = parcelRequire("gt9Am");

var $ftN6c = parcelRequire("ftN6c");

var $lRBVi = parcelRequire("lRBVi");
var $dNFQE = parcelRequire("dNFQE");
var $bbNl0 = parcelRequire("bbNl0");
var $6PCIn = parcelRequire("6PCIn");
var $4rKJa = parcelRequire("4rKJa");

var $djK7X = parcelRequire("djK7X");
var $3cc2J = parcelRequire("3cc2J");

var $3xaEP = parcelRequire("3xaEP");
var $fK3MF = parcelRequire("fK3MF");
var $5JVfG = parcelRequire("5JVfG");

var $52iZC = parcelRequire("52iZC");

var $eJOHy = parcelRequire("eJOHy");

var $82KGI = parcelRequire("82KGI");

var $1yWtS = parcelRequire("1yWtS");

var $9mNAm = parcelRequire("9mNAm");

var $bqFvV = parcelRequire("bqFvV");

var $6i8sx = parcelRequire("6i8sx");

var $8Io51 = parcelRequire("8Io51");

var $bRwGt = parcelRequire("bRwGt");

var $7Or4X = parcelRequire("7Or4X");

var $kszJO = parcelRequire("kszJO");

var $dQmDm = parcelRequire("dQmDm");

var $2066v = parcelRequire("2066v");

var $1n5AE = parcelRequire("1n5AE");

var $1N2Qr = parcelRequire("1N2Qr");

var $1OE0N = parcelRequire("1OE0N");

var $hqfTB = parcelRequire("hqfTB");

var $iN7PZ = parcelRequire("iN7PZ");

var $81Qv0 = parcelRequire("81Qv0");

var $8Uhop = parcelRequire("8Uhop");

var $0456t = parcelRequire("0456t");

var $lRq8t = parcelRequire("lRq8t");

var $6qVXk = parcelRequire("6qVXk");

var $eGOwo = parcelRequire("eGOwo");

var $fiPhB = parcelRequire("fiPhB");

var $dllpM = parcelRequire("dllpM");
const $93cc0fd373008fd4$var$traceContextRetriever = ()=>{
    const trace = (0, $fiPhB.getActiveTrace)();
    if (trace && (0, $eGOwo.fg)('platform-filecard-ufo-trace')) return {
        traceId: trace?.traceId,
        spanId: trace?.spanId
    };
    else return {
        traceId: (0, $3xaEP.getRandomTelemetryId)()
    };
};
const $93cc0fd373008fd4$export$593fd10f7e6c6505 = ({ appearance: appearance = 'auto', resizeMode: resizeMode = 'crop', isLazy: isLazy = true, disableOverlay: disableOverlay = false, featureFlags: // Media Feature Flag defaults are defined in @atlaskit/media-common
featureFlags = {}, identifier: identifier, ssr: ssr, dimensions: dimensions, originalDimensions: originalDimensions, contextId: contextId, alt: alt, actions: actions, shouldEnableDownloadButton: shouldEnableDownloadButton, useInlinePlayer: useInlinePlayer, shouldOpenMediaViewer: shouldOpenMediaViewer, onFullscreenChange: onFullscreenChange, selectable: selectable, selected: selected, testId: testId, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, shouldHideTooltip: shouldHideTooltip, mediaViewerItems: mediaViewerItems, onClick: onClick, onMouseEnter: onMouseEnter, videoControlsWrapperRef: videoControlsWrapperRef, viewerOptions: viewerOptions, includeHashForDuplicateFiles: includeHashForDuplicateFiles })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isAbuseModalOpen, setIsAbuseModalOpen] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    //----------------------------------------------------------------//
    //------------ State, Refs & Initial Values ----------------------//
    //----------------------------------------------------------------//
    const pressTracing = (0, $dllpM.default)('click-file-card');
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const [cardElement, setCardElement] = (0, $eJOHy.useState)(null);
    const cardDimensions = dimensions || (0, $1n5AE.getDefaultCardDimensions)(appearance);
    // Calculate the preview dimensions if card dimensions are "percentage" based
    const previewDimensions = (0, $eJOHy.useMemo)(()=>// resolving dimensions is eventually an expensive operation if the dimensions are a percentage
        // thus needs to be memoized
        (0, $6i8sx.resolveCardPreviewDimensions)({
            dimensions: cardDimensions,
            element: cardElement
        }), [
        cardDimensions,
        cardElement
    ]);
    const [isCardVisible, setIsCardVisible] = (0, $eJOHy.useState)(!isLazy);
    const { fileState: fileState } = (0, $djK7X.useFileState)(identifier.id, {
        skipRemote: !isCardVisible,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey,
        includeHashForDuplicateFiles: includeHashForDuplicateFiles
    });
    const prevFileState = (0, $dQmDm.usePrevious)(fileState && (0, $bbNl0.isErrorFileState)(fileState) ? undefined : fileState);
    const fileStateValue = (0, $eJOHy.useMemo)(()=>{
        if (fileState && !(0, $bbNl0.isErrorFileState)(fileState)) return fileState;
        return prevFileState;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fileState
    ]);
    const dateOverrides = (0, $eJOHy.useContext)((0, $0456t.DateOverrideContext));
    const overridenDate = dateOverrides?.[identifier.id];
    //----------------------------------------------------------------//
    //------------ State, Refs & Initial Values ----------------------//
    //----------------------------------------------------------------//
    const internalOccurrenceKey = (0, $eJOHy.useMemo)(()=>(0, $bqFvV.generateUniqueId)(), []);
    const timeElapsedTillCommenced = (0, $eJOHy.useMemo)(()=>(0, $8Uhop.performanceNow)(), []);
    const fileStateFlagsRef = (0, $eJOHy.useRef)({
        wasStatusUploading: false,
        wasStatusProcessing: false
    });
    const mediaViewerButtonRef = (0, $eJOHy.useRef)(null);
    // Generate unique traceId for file
    const traceContext = (0, $eJOHy.useMemo)($93cc0fd373008fd4$var$traceContextRetriever, []);
    const [status, setStatus] = (0, $eJOHy.useState)('loading');
    const [isPlayingFile, setIsPlayingFile] = (0, $eJOHy.useState)(false);
    const [shouldAutoplay, setShouldAutoplay] = (0, $eJOHy.useState)(false);
    const [previewDidRender, setPreviewDidRender] = (0, $eJOHy.useState)(false);
    const mediaBlobUrlAttrs = (0, $eJOHy.useMemo)(()=>{
        const { id: id, collectionName: collection } = identifier;
        const { mimeType: mimeType, name: name, size: size } = (0, $bRwGt.getFileDetails)(identifier, fileStateValue);
        return contextId ? {
            id: id,
            collection: collection,
            contextId: contextId,
            mimeType: mimeType,
            name: name,
            size: size,
            ...originalDimensions || previewDimensions,
            alt: alt
        } : undefined;
    }, [
        alt,
        previewDimensions,
        contextId,
        fileStateValue,
        identifier,
        originalDimensions
    ]);
    const { preview: preview, status: previewStatus, error: previewError, nonCriticalError: nonCriticalError, ssrReliability: ssrReliability, onImageError: onImageErrorBase, onImageLoad: onImageLoadBase, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $iN7PZ.useFilePreview)({
        mediaBlobUrlAttrs: mediaBlobUrlAttrs,
        resizeMode: (0, $dNFQE.imageResizeModeToFileImageMode)(resizeMode),
        identifier: identifier,
        ssr: ssr,
        dimensions: previewDimensions,
        traceContext: traceContext,
        skipRemote: !isCardVisible,
        source: 'mediaCard'
    });
    const shouldSendPerformanceEventRef = (0, $eJOHy.useRef)((0, $7Or4X.shouldPerformanceBeSampled)());
    const [error, setError] = (0, $eJOHy.useState)();
    // CXP-2723 TODO: TEMPORARY VARIABLES
    const finalError = error || (previewError && previewError.primaryReason !== 'failed-processing' && fileStateValue?.mimeType !== 'image/svg+xml' ? previewError : undefined);
    const finalStatus = finalError ? 'error' : status === 'failed-processing' && fileStateValue?.mimeType === 'image/svg+xml' ? 'loading-preview' : status;
    const [mediaViewerSelectedItem, setMediaViewerSelectedItem] = (0, $eJOHy.useState)(null);
    const uploadProgressRef = (0, $eJOHy.useRef)();
    const metadata = (0, $eJOHy.useMemo)(()=>{
        const getProcessingStatusFromFileState = (status)=>{
            switch(status){
                case 'processed':
                    return 'succeeded';
                case 'processing':
                    return 'running';
                case 'failed-processing':
                    return 'failed';
            }
        };
        if (fileStateValue) return {
            id: fileStateValue.id,
            name: fileStateValue.name,
            size: fileStateValue.size,
            mimeType: fileStateValue.mimeType,
            createdAt: fileStateValue.createdAt,
            mediaType: fileStateValue.mediaType,
            processingStatus: getProcessingStatusFromFileState(fileStateValue.status)
        };
        else return {
            id: identifier.id
        };
    }, [
        fileStateValue,
        identifier.id
    ]);
    const fileAttributes = (0, $eJOHy.useMemo)(()=>{
        return {
            fileMediatype: metadata.mediaType,
            fileMimetype: metadata.mimeType,
            fileId: metadata.id,
            fileSize: metadata.size,
            fileStatus: fileStateValue?.status
        };
    }, [
        fileStateValue?.status,
        metadata.id,
        metadata.mediaType,
        metadata.mimeType,
        metadata.size
    ]);
    const downloadFn = (0, $eJOHy.useCallback)(async ()=>{
        try {
            await mediaClient.file.downloadBinary(identifier.id, metadata.name, identifier.collectionName, traceContext);
            (0, $1N2Qr.fireDownloadSucceededEvent)(createAnalyticsEvent, fileAttributes, traceContext, fileStateValue?.metadataTraceContext);
        } catch (e) {
            const error = new (0, $1yWtS.MediaCardError)('download', e);
            (0, $1N2Qr.fireDownloadFailedEvent)(createAnalyticsEvent, fileAttributes, error, traceContext, fileStateValue?.metadataTraceContext);
        }
    }, [
        createAnalyticsEvent,
        fileAttributes,
        fileStateValue?.metadataTraceContext,
        identifier.collectionName,
        identifier.id,
        mediaClient.file,
        metadata.name,
        traceContext
    ]);
    const computedActions = (0, $eJOHy.useMemo)(()=>{
        if (finalStatus === 'failed-processing' || shouldEnableDownloadButton) {
            const handler = async ()=>{
                if (!!fileStateValue?.abuseClassification) setIsAbuseModalOpen(true);
                else await downloadFn();
            };
            const downloadAction = (0, $81Qv0.createDownloadAction)({
                handler: handler,
                isDisabled: mediaClient.config.enforceDataSecurityPolicy
            }, formatMessage);
            return [
                downloadAction,
                ...actions ?? []
            ];
        } else return actions;
    }, [
        actions,
        mediaClient.config.enforceDataSecurityPolicy,
        shouldEnableDownloadButton,
        finalStatus,
        formatMessage,
        fileStateValue?.abuseClassification,
        downloadFn
    ]);
    //----------------------------------------------------------------//
    //---------------------- Analytics  ------------------------------//
    //----------------------------------------------------------------//
    const fireOperationalEventRef = (0, $kszJO.useCurrentValueRef)(()=>{
        const timeElapsedTillEvent = (0, $8Uhop.performanceNow)();
        const durationSinceCommenced = timeElapsedTillEvent - timeElapsedTillCommenced;
        const performanceAttributes = {
            overall: {
                durationSincePageStart: timeElapsedTillEvent,
                durationSinceCommenced: durationSinceCommenced
            }
        };
        createAnalyticsEvent && (0, $1N2Qr.fireOperationalEvent)(createAnalyticsEvent, finalStatus, fileAttributes, performanceAttributes, ssrReliability, finalError, traceContext, fileStateValue?.metadataTraceContext);
        shouldSendPerformanceEventRef.current && (0, $7Or4X.completeUfoExperience)(internalOccurrenceKey, finalStatus, fileAttributes, fileStateFlagsRef.current, ssrReliability, finalError);
    });
    const fireNonCriticalErrorEventRef = (0, $kszJO.useCurrentValueRef)((error)=>{
        createAnalyticsEvent && (0, $1N2Qr.fireNonCriticalErrorEvent)(createAnalyticsEvent, finalStatus, fileAttributes, ssrReliability, error, traceContext, fileStateValue?.metadataTraceContext);
    });
    (0, $eJOHy.useEffect)(()=>{
        if (nonCriticalError) fireNonCriticalErrorEventRef.current(nonCriticalError);
    }, [
        nonCriticalError,
        fireNonCriticalErrorEventRef
    ]);
    const startUfoExperienceRef = (0, $kszJO.useCurrentValueRef)(()=>{
        if (shouldSendPerformanceEventRef.current) (0, $7Or4X.startUfoExperience)(internalOccurrenceKey);
    });
    const fireAbortedEventRef = (0, $kszJO.useCurrentValueRef)(()=>{
        // UFO won't abort if it's already in a final state (succeeded, failed, aborted, etc)
        if (shouldSendPerformanceEventRef.current) (0, $7Or4X.abortUfoExperience)(internalOccurrenceKey, {
            fileAttributes: fileAttributes,
            fileStateFlags: fileStateFlagsRef?.current,
            ssrReliability: ssrReliability
        });
    });
    //----------------------------------------------------------------//
    //--------------------- Focus on Close Viewer  -------------------//
    //----------------------------------------------------------------//
    const wasViewerPreviouslyOpen = (0, $dQmDm.usePrevious)(mediaViewerSelectedItem);
    (0, $eJOHy.useEffect)(()=>{
        if (wasViewerPreviouslyOpen && !mediaViewerSelectedItem) mediaViewerButtonRef.current?.focus();
    }, [
        wasViewerPreviouslyOpen,
        mediaViewerSelectedItem
    ]);
    //----------------------------------------------------------------//
    //---------------------- Callbacks & Handlers  -------------------//
    //----------------------------------------------------------------//
    const onSvgError = (error)=>{
        setError(error);
        setStatus('error');
    };
    const onImageError = (newCardPreview)=>{
        if (metadata.mimeType === 'image/svg+xml') return;
        onImageErrorBase(newCardPreview);
    };
    const onSvgLoad = ()=>{
        setPreviewDidRender(true);
    };
    const onImageLoad = (newCardPreview)=>{
        if (metadata.mimeType === 'image/svg+xml') return;
        onImageLoadBase(newCardPreview);
        setPreviewDidRender(true);
    };
    const onCardClick = (event, analyticsEvent)=>{
        if (onClick) {
            const cardEvent = {
                event: event,
                mediaItemDetails: metadata
            };
            onClick(cardEvent, analyticsEvent);
        }
    };
    const onCardViewClick = (event, analyticsEvent)=>{
        onCardClick(event, analyticsEvent);
        if (!metadata) return;
        const isVideo = metadata.mediaType === 'video';
        const isBrowserSupported = metadata.mimeType && (0, $fK3MF.isMimeTypeSupportedByBrowser)(metadata.mimeType);
        // TODO: this should be handled by Inline Player
        const isPlayable = !!fileState && (fileState.status === 'processed' || isBrowserSupported && [
            'processing',
            'uploading'
        ].includes(fileState.status));
        if (useInlinePlayer && isVideo && isPlayable && finalStatus !== 'error') {
            setIsPlayingFile(true);
            setShouldAutoplay(true);
        } else if (shouldOpenMediaViewer) setMediaViewerSelectedItem({
            id: identifier.id,
            mediaItemType: 'file',
            collectionName: identifier.collectionName,
            occurrenceKey: identifier.occurrenceKey
        });
        // Abort VC when click file card
        pressTracing();
    };
    //----------------------------------------------------------------//
    //----------------- update status flags --------------------------//
    //----------------------------------------------------------------//
    (0, $eJOHy.useEffect)(()=>{
        if (fileStateValue?.status === 'processing') fileStateFlagsRef.current.wasStatusProcessing = true;
        else if (fileStateValue?.status === 'uploading') fileStateFlagsRef.current.wasStatusUploading = true;
    }, [
        fileStateValue?.status
    ]);
    //----------------------------------------------------------------//
    //---------------- fetch and resolve card preview ----------------//
    //----------------------------------------------------------------//
    const prevStatus = (0, $dQmDm.usePrevious)(finalStatus);
    const prevIsCardVisible = (0, $dQmDm.usePrevious)(isCardVisible);
    (0, $eJOHy.useEffect)(()=>{
        if (prevStatus !== undefined && finalStatus !== prevStatus) fireOperationalEventRef.current();
    }, [
        fireOperationalEventRef,
        prevStatus,
        finalStatus
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const turnedVisible = !prevIsCardVisible && isCardVisible;
        if (turnedVisible) startUfoExperienceRef.current();
    }, [
        startUfoExperienceRef,
        isCardVisible,
        prevIsCardVisible
    ]);
    //----------------------------------------------------------------//
    //----------------- set isPlayingFile state ----------------------//
    //----------------------------------------------------------------//
    (0, $eJOHy.useEffect)(()=>{
        const isVideo = fileAttributes.fileMediatype === 'video';
        const { mimeType: mimeType } = (0, $bRwGt.getFileDetails)(identifier, fileStateValue);
        const isVideoPlayable = mimeType && (0, $5JVfG.isVideoMimeTypeSupportedByBrowser)(mimeType) || fileStateValue && (0, $bbNl0.isProcessedFileState)(fileStateValue);
        if (/**
			 * We need to check that the card is visible before switching to inline player
			 * in order to avoid race conditions of the ViewportDector being unmounted before
			 * it is able to set isCardVisible to true.
			 */ isCardVisible && isVideo && !isPlayingFile && disableOverlay && useInlinePlayer && isVideoPlayable && fileStateValue?.status !== 'failed-processing' && finalStatus !== 'error') setIsPlayingFile(true);
    }, [
        isCardVisible,
        disableOverlay,
        fileAttributes.fileMediatype,
        fileStateValue,
        identifier,
        isPlayingFile,
        finalStatus,
        useInlinePlayer
    ]);
    //----------------------------------------------------------------//
    //----------------- abort UFO experience -------------------------//
    //----------------------------------------------------------------//
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            fireAbortedEventRef.current();
        };
    }, [
        fireAbortedEventRef
    ]);
    //----------------------------------------------------------------//
    // Update Status
    //----------------------------------------------------------------//
    const updateFileStateRef = (0, $kszJO.useCurrentValueRef)(()=>{
        // This effect has race condition with Complete effect. We share the same check to ovid status overrides
        // do not update the card status if the status is final
        if ([
            'complete',
            'error',
            'failed-processing'
        ].includes(finalStatus)) return;
        if (previewDidRender && // We should't complete if status is uploading
        [
            'loading-preview',
            'processing'
        ].includes(finalStatus)) setStatus('complete');
        else if (fileState) {
            if (fileState.status !== 'error') {
                let newStatus;
                switch(fileState.status){
                    case 'uploading':
                    case 'failed-processing':
                    case 'processing':
                        newStatus = fileState.status;
                        break;
                    case 'processed':
                        // Set complete if processing is done and there is no preview
                        if (!preview && previewStatus === 'complete') {
                            newStatus = 'complete';
                            break;
                        }
                        newStatus = 'loading-preview';
                        break;
                    default:
                        newStatus = 'loading';
                }
                const newProgress = newStatus === 'uploading' && fileState.status === 'uploading' ? fileState.progress : 1;
                setStatus(newStatus);
                uploadProgressRef.current = newProgress;
            } else {
                const e = (0, $4rKJa.toCommonMediaClientError)(fileState);
                const errorReason = finalStatus === 'uploading' ? 'upload' : 'metadata-fetch';
                setError(new (0, $1yWtS.MediaCardError)(errorReason, e));
                setStatus('error');
            }
        }
    });
    const mergedRef = (0, $82KGI.useMergeRefs)([
        setCardElement,
        copyNodeRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        updateFileStateRef.current();
    }, [
        fileState,
        preview,
        previewStatus,
        updateFileStateRef,
        previewDidRender,
        finalStatus
    ]);
    //----------------------------------------------------------------//
    // Shared Card View & SVG View resources
    //----------------------------------------------------------------//
    const mediaCardCursor = (0, $8Io51.getMediaCardCursor)(!!useInlinePlayer, !!shouldOpenMediaViewer, finalStatus === 'error' || finalStatus === 'failed-processing', !!preview, metadata.mediaType);
    const onImageMouseEnter = (event)=>{
        onMouseEnter?.({
            event: event,
            mediaItemDetails: metadata
        });
    };
    //----------------------------------------------------------------//
    //---------------------- Render Card Function --------------------//
    //----------------------------------------------------------------//
    const renderCard = (withCallbacks = true, cardStatusOverride, izLazyOverride)=>{
        const { mediaItemType: mediaItemType } = identifier;
        const isLazyWithOverride = izLazyOverride === undefined ? isLazy : izLazyOverride;
        // We should natively lazy load an SSR preview when card is not visible,
        // otherwise we'll fire the metadata fetch from outside the viewport
        // Side note: We should not lazy load if the cardPreview is available from local cache,
        // in order to avoid flickers during re-mount of the component
        // CXP-2723 TODO: Create test cases for the above scenarios
        const nativeLazyLoad = isLazyWithOverride && !isCardVisible && preview && (0, $9mNAm.isSSRPreview)(preview);
        // Force Media Image to always display img for SSR
        const forceSyncDisplay = !!ssr;
        const card = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1OE0N.CardView), {
            identifier: identifier,
            status: cardStatusOverride || finalStatus,
            error: finalError,
            mediaItemType: mediaItemType,
            metadata: metadata,
            cardPreview: preview,
            alt: alt,
            resizeMode: resizeMode,
            dimensions: cardDimensions,
            actions: computedActions,
            selectable: selectable,
            selected: selected,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            openMediaViewerButtonRef: mediaViewerButtonRef,
            onClick: withCallbacks ? onCardViewClick : undefined,
            onMouseEnter: withCallbacks ? onImageMouseEnter : undefined,
            disableOverlay: disableOverlay,
            progress: uploadProgressRef.current,
            onDisplayImage: withCallbacks ? ()=>{
                const payloadPart = {
                    fileId: identifier.id,
                    isUserCollection: identifier.collectionName === (0, $6PCIn.RECENTS_COLLECTION)
                };
                (0, $lRBVi.globalMediaEventEmitter).emit('media-viewed', {
                    viewingLevel: 'minimal',
                    ...payloadPart
                });
            } : undefined,
            innerRef: mergedRef,
            testId: testId,
            titleBoxBgColor: titleBoxBgColor,
            titleBoxIcon: titleBoxIcon,
            onImageError: withCallbacks ? onImageError : undefined,
            onImageLoad: withCallbacks ? onImageLoad : undefined,
            onSvgError: onSvgError,
            onSvgLoad: onSvgLoad,
            nativeLazyLoad: nativeLazyLoad,
            forceSyncDisplay: forceSyncDisplay,
            mediaCardCursor: mediaCardCursor,
            shouldHideTooltip: shouldHideTooltip,
            overriddenCreationDate: overridenDate
        });
        return isLazyWithOverride ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2066v.ViewportDetector), {
            cardEl: cardElement,
            onVisible: ()=>{
                setIsCardVisible(true);
            },
            children: card
        }) : card;
    };
    //----------------------------------------------------------------//
    //-------------------------- RENDER ------------------------------//
    //----------------------------------------------------------------//
    const inlinePlayerFallback = isPlayingFile ? renderCard(false, 'loading', false) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {});
    const collectionName = identifier.collectionName || '';
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            !!fileStateValue?.abuseClassification && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qVXk.AbuseModal), {
                isOpen: isAbuseModalOpen,
                onConfirm: downloadFn,
                onClose: ()=>setIsAbuseModalOpen(false)
            }),
            isPlayingFile ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: inlinePlayerFallback,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqfTB.InlinePlayerLazy), {
                    dimensions: cardDimensions,
                    originalDimensions: originalDimensions,
                    identifier: identifier,
                    autoplay: !!shouldAutoplay,
                    onFullscreenChange: onFullscreenChange,
                    onError: (e)=>{
                        setError(new (0, $1yWtS.MediaCardError)('error-file-state', e));
                        setStatus('error');
                        setIsPlayingFile(false);
                    },
                    onClick: onCardClick,
                    selected: selected,
                    ref: setCardElement,
                    testId: testId,
                    cardPreview: preview,
                    videoControlsWrapperRef: videoControlsWrapperRef
                })
            }) : renderCard(),
            mediaViewerSelectedItem ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $52iZC.default), {
                collectionName: collectionName,
                items: mediaViewerItems || [],
                mediaClientConfig: mediaClient.config,
                selectedItem: mediaViewerSelectedItem,
                onClose: ()=>{
                    setMediaViewerSelectedItem(null);
                },
                contextId: contextId,
                featureFlags: featureFlags,
                viewerOptions: viewerOptions
            }) : null,
            getSsrScriptProps && /*#__PURE__*/ (0, $gt9Am.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};

});
parcelRegister("dNFQE", function(module, exports) {
$parcel$export(module.exports, "imageResizeModeToFileImageMode", () => $067beadc547b40c8$export$dc1fb2767ac9a82f);
const $067beadc547b40c8$export$dc1fb2767ac9a82f = (resizeMode)=>resizeMode === 'stretchy-fit' ? 'full-fit' : resizeMode;

});

parcelRegister("6i8sx", function(module, exports) {
$parcel$export(module.exports, "resolveCardPreviewDimensions", () => $acdad2ad4dc154bf$export$f187979e6522f007);

var $haBoW = parcelRequire("haBoW");

var $bvnIh = parcelRequire("bvnIh");

var $1n5AE = parcelRequire("1n5AE");

var $dUCca = parcelRequire("dUCca");

var $bIVWO = parcelRequire("bIVWO");
const $acdad2ad4dc154bf$export$726bc1818ebaed3b = (dimension, options)=>{
    const retinaFactor = (0, $haBoW.isRetina)() ? 2 : 1;
    const dimensionValue = options.dimensions && options.dimensions[dimension] || '';
    if ((0, $dUCca.isValidPercentageUnit)(dimensionValue) && options.element) return (0, $bvnIh.getElementDimension)(options.element, dimension) * retinaFactor;
    if (typeof dimensionValue === 'number') return dimensionValue * retinaFactor;
    if ((0, $bIVWO.containsPixelUnit)(`${dimensionValue}`)) return parseInt(`${dimensionValue}`, 10) * retinaFactor;
    return (0, $1n5AE.defaultImageCardDimensions)[dimension] * retinaFactor;
};
const $acdad2ad4dc154bf$export$5b11506bddb36f50 = (options)=>{
    const width = $acdad2ad4dc154bf$export$726bc1818ebaed3b('width', options);
    const height = $acdad2ad4dc154bf$export$726bc1818ebaed3b('height', options);
    return {
        width: width,
        height: height
    };
};
const $acdad2ad4dc154bf$export$a94e513ca3122718 = (dimensionName, { dimensions: dimensions, element: element })=>{
    const dimensionValue = dimensions?.[dimensionName] || '';
    if ((0, $dUCca.isValidPercentageUnit)(dimensionValue) && element) return (0, $bvnIh.getElementDimension)(element, dimensionName);
    if (typeof dimensionValue === 'number') return dimensionValue;
    if ((0, $bIVWO.containsPixelUnit)(`${dimensionValue}`)) return parseInt(`${dimensionValue}`, 10);
    return (0, $1n5AE.defaultImageCardDimensions)[dimensionName];
};
const $acdad2ad4dc154bf$export$f187979e6522f007 = (options)=>{
    const width = $acdad2ad4dc154bf$export$a94e513ca3122718('width', options);
    const height = $acdad2ad4dc154bf$export$a94e513ca3122718('height', options);
    return {
        width: width,
        height: height
    };
};

});
parcelRegister("haBoW", function(module, exports) {
$parcel$export(module.exports, "isRetina", () => $30bd7b2401952d65$export$2f19d859969045b7);
function $30bd7b2401952d65$export$2f19d859969045b7() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}

});

parcelRegister("bIVWO", function(module, exports) {
$parcel$export(module.exports, "containsPixelUnit", () => $7556d55c2f8e736d$export$9dd9ef980c055cad);
const $7556d55c2f8e736d$export$9dd9ef980c055cad = (value)=>value.substr(-2) === 'px' && !isNaN(+value.slice(0, -2));

});


parcelRegister("bRwGt", function(module, exports) {
$parcel$export(module.exports, "getFileDetails", () => $01df947a9212e7e1$export$7e125c11d42de4d1);

var $bbNl0 = parcelRequire("bbNl0");
var $4n4MY = parcelRequire("4n4MY");
const $01df947a9212e7e1$var$getProcessingStatusFromFileState = (status)=>{
    switch(status){
        case 'processed':
            return 'succeeded';
        case 'processing':
            return 'running';
        case 'failed-processing':
            return 'failed';
    }
};
const $01df947a9212e7e1$var$getFileDetailsFromFileState = (state)=>({
        id: state.id,
        name: state.name,
        size: state.size,
        mimeType: state.mimeType,
        createdAt: state.createdAt,
        mediaType: state.mediaType,
        processingStatus: $01df947a9212e7e1$var$getProcessingStatusFromFileState(state.status)
    });
const $01df947a9212e7e1$export$7e125c11d42de4d1 = (identifier, fileState)=>{
    return (0, $4n4MY.isFileIdentifier)(identifier) ? fileState && !(0, $bbNl0.isErrorFileState)(fileState) ? $01df947a9212e7e1$var$getFileDetailsFromFileState(fileState) : {
        id: identifier.id
    } : {
        id: identifier.mediaItemType,
        name: identifier.name || identifier.dataURI,
        mediaType: 'image'
    };
};

});

parcelRegister("2066v", function(module, exports) {
$parcel$export(module.exports, "ViewportDetector", () => $daf161cca8c9df1f$export$35aa735df177ee7c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jVMEg = parcelRequire("jVMEg");

var $127KM = parcelRequire("127KM");
const $daf161cca8c9df1f$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP = 900; //px
const $daf161cca8c9df1f$var$createIntersectionObserverCallback = (onVisible)=>(entries, observer)=>{
        for (let entry of entries)if (entry.isIntersecting) {
            onVisible();
            observer.disconnect();
            break;
        }
    };
const $daf161cca8c9df1f$var$ViewportObserver = ({ onVisible: onVisible, cardEl: cardEl, children: children })=>{
    const [isVisible, setIsVisible] = (0, $eJOHy.useState)(false);
    const onVisibleCallback = (0, $eJOHy.useCallback)(()=>{
        setIsVisible(true);
        onVisible();
    }, [
        onVisible
    ]);
    (0, $eJOHy.useEffect)(()=>{
        let intersectionObserver;
        try {
            intersectionObserver = new IntersectionObserver($daf161cca8c9df1f$var$createIntersectionObserverCallback(onVisibleCallback), {
                root: (0, $127KM.default)(),
                rootMargin: `${$daf161cca8c9df1f$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP}px`
            });
        } catch (error) {
            intersectionObserver = new IntersectionObserver($daf161cca8c9df1f$var$createIntersectionObserverCallback(onVisibleCallback), {
                root: null,
                rootMargin: `${$daf161cca8c9df1f$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP}px`
            });
        }
        cardEl && intersectionObserver.observe(cardEl);
        return ()=>{
            intersectionObserver.disconnect();
        };
    }, [
        cardEl,
        onVisibleCallback
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jVMEg.default), {
        ignore: !isVisible,
        children: children
    });
};
const $daf161cca8c9df1f$export$35aa735df177ee7c = ({ cardEl: cardEl, onVisible: onVisible, children: children })=>{
    if (typeof IntersectionObserver === 'undefined') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($daf161cca8c9df1f$var$ViewportObserver, {
        cardEl: cardEl,
        onVisible: onVisible,
        children: children
    });
};

});
parcelRegister("jVMEg", function(module, exports) {
$parcel$export(module.exports, "default", () => $7198a9f02a598e87$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $huC5X = parcelRequire("huC5X");
function $7198a9f02a598e87$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $huC5X.default), {
        ...props
    });
}

});

parcelRegister("127KM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f178bc8e6ba3f670$export$2e2bcd8739ae039);
var $f178bc8e6ba3f670$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("hqfTB", function(module, exports) {
$parcel$export(module.exports, "InlinePlayerLazy", () => $3ef93e8bc17f64d4$export$c7e2887eae92d53c);

var $eJOHy = parcelRequire("eJOHy");

const $3ef93e8bc17f64d4$export$c7e2887eae92d53c = /*#__PURE__*/ (0, $eJOHy.lazy)(async ()=>{
    const { InlinePlayer: InlinePlayer } = await (parcelRequire("gzBLd"));
    return {
        default: InlinePlayer
    };
});

});
parcelRegister("gzBLd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3y1uh")
]).then(()=>parcelRequire('9YQrj'));

});


parcelRegister("iN7PZ", function(module, exports) {
$parcel$export(module.exports, "useFilePreview", () => $e54d3f9e11f733f6$export$4eaebdef02112fe4);

var $eJOHy = parcelRequire("eJOHy");

var $bbNl0 = parcelRequire("bbNl0");
var $4rKJa = parcelRequire("4rKJa");

var $kCvcX = parcelRequire("kCvcX");
var $djK7X = parcelRequire("djK7X");
var $3cc2J = parcelRequire("3cc2J");

var $fK3MF = parcelRequire("fK3MF");

var $eGOwo = parcelRequire("eGOwo");

var $7aoMz = parcelRequire("7aoMz");

var $e2t9t = parcelRequire("e2t9t");

var $33YQ1 = parcelRequire("33YQ1");

var $k9eRE = parcelRequire("k9eRE");
var $hNvWT = parcelRequire("hNvWT");
var $9Mg12 = parcelRequire("9Mg12");

var $i0gVY = parcelRequire("i0gVY");
var $8Dv9L = parcelRequire("8Dv9L");

var $3c1p9 = parcelRequire("3c1p9");
const $e54d3f9e11f733f6$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const [status, setStatus] = (0, $eJOHy.useState)('loading');
    const [error, setError] = (0, $eJOHy.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eJOHy.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eJOHy.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eJOHy.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eJOHy.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $7aoMz.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isLoading && (0, $eGOwo.fg)('platform_close_image_blindspot_2')) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $eJOHy.useMemo)(()=>dimensions ? (0, $3c1p9.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $3c1p9.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $8Dv9L.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $k9eRE.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $e2t9t.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eJOHy.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $djK7X.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $bbNl0.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eJOHy.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('metadata-fetch', (0, $4rKJa.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $3c1p9.useCurrentValueRef)(()=>{
        return (0, $k9eRE.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eJOHy.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $3c1p9.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $3c1p9.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $eJOHy.useEffect)(()=>{
        const cachedPreview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $3c1p9.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $hNvWT.isSupportedLocalPreview)(mediaType) && (0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $k9eRE.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $3c1p9.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $k9eRE.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $33YQ1.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eJOHy.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $k9eRE.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        const isSSR = (0, $k9eRE.isSSRDataPreview)(failedPreview);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) {
            ssrReliabilityRef.current.server = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $k9eRE.isLocalPreview)(failedPreview);
        const isRemote = (0, $k9eRE.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error = new (0, $33YQ1.ImageLoadError)(failedPreview?.source);
            (0, $9Mg12.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eJOHy.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $k9eRE.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $k9eRE.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $i0gVY.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $kCvcX.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("kCvcX", function(module, exports) {
$parcel$export(module.exports, "useCopyIntent", () => $556b9eb703c9e12d$export$46fd859414de9d62);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $3cc2J = parcelRequire("3cc2J");

var $bMoFA = parcelRequire("bMoFA");

var $b7hyt = parcelRequire("b7hyt");
function $556b9eb703c9e12d$var$useCurrentValueRef(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}
const $556b9eb703c9e12d$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const innerRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const registerCopyIntentRef = $556b9eb703c9e12d$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $bMoFA.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $bMoFA.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $eJOHy.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $eJOHy.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) (0, $b7hyt.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $b7hyt.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("bMoFA", function(module, exports) {
$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $93f079c5c30deecd$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $93f079c5c30deecd$export$aacb463551da2e8f);

var $h3W10 = parcelRequire("h3W10");
const $93f079c5c30deecd$var$getRequestErrorDetails = (err)=>{
    if ((0, $h3W10.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $93f079c5c30deecd$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $h3W10.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$93f079c5c30deecd$var$getRequestErrorDetails(error)
        }
    };
};
const $93f079c5c30deecd$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("b7hyt", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $b67882b47b14e094$export$f65ca476c09acec0);
const $b67882b47b14e094$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("e2t9t", function(module, exports) {
$parcel$export(module.exports, "extractErrorInfo", () => $3f058c26ca766723$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $3f058c26ca766723$export$768c370ed0dbaeb3);

var $4rKJa = parcelRequire("4rKJa");

var $33YQ1 = parcelRequire("33YQ1");
const $3f058c26ca766723$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $3f058c26ca766723$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $3f058c26ca766723$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $3f058c26ca766723$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $3f058c26ca766723$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $3f058c26ca766723$export$4af9d71992e89714(error),
        error: $3f058c26ca766723$export$88c61dcad53762da(error),
        errorDetail: $3f058c26ca766723$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $3f058c26ca766723$export$29aa614726672b2e(error)
    };
};
const $3f058c26ca766723$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$3f058c26ca766723$export$74aaf4784c2edb2c(new (0, $33YQ1.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("33YQ1", function(module, exports) {
$parcel$export(module.exports, "MediaFilePreviewError", () => $ba556c1ff2a47bc7$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ba556c1ff2a47bc7$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ba556c1ff2a47bc7$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ba556c1ff2a47bc7$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ba556c1ff2a47bc7$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ba556c1ff2a47bc7$export$7156ce7b78b49bd7);
class $ba556c1ff2a47bc7$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ba556c1ff2a47bc7$export$2c035820a31723e extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$10ab445310d30114 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$18e89b7e50818288 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $ba556c1ff2a47bc7$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ba556c1ff2a47bc7$export$d0a45ab59b4606b extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(source){
        super($ba556c1ff2a47bc7$var$getImageLoadPrimaryReason(source));
    }
}
function $ba556c1ff2a47bc7$export$553696a6e769784c(err) {
    return err instanceof $ba556c1ff2a47bc7$export$96e559194c287cf4;
}
const $ba556c1ff2a47bc7$export$b380593ba3516c6f = (err)=>err instanceof $ba556c1ff2a47bc7$export$2c035820a31723e;
const $ba556c1ff2a47bc7$export$e1d87830b3784f94 = (err)=>err instanceof $ba556c1ff2a47bc7$export$10ab445310d30114;
const $ba556c1ff2a47bc7$export$443aeb298d35d79d = (err)=>$ba556c1ff2a47bc7$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ba556c1ff2a47bc7$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ba556c1ff2a47bc7$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("k9eRE", function(module, exports) {
$parcel$export(module.exports, "getSSRPreview", () => $acdcd6198e7dee1d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $acdcd6198e7dee1d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $acdcd6198e7dee1d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $acdcd6198e7dee1d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $acdcd6198e7dee1d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $acdcd6198e7dee1d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $acdcd6198e7dee1d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $acdcd6198e7dee1d$export$98e935d981c884d);

var $bajro = parcelRequire("bajro");

var $33YQ1 = parcelRequire("33YQ1");

var $9Mg12 = parcelRequire("9Mg12");

var $hNvWT = parcelRequire("hNvWT");
const $acdcd6198e7dee1d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $9Mg12.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $acdcd6198e7dee1d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $33YQ1.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $acdcd6198e7dee1d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $acdcd6198e7dee1d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $acdcd6198e7dee1d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $hNvWT.getRemotePreview)(mediaClient, id, params, traceContext);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $acdcd6198e7dee1d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $hNvWT.getLocalPreview)(filePreview);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("bajro", function(module, exports) {
$parcel$export(module.exports, "isMediaBlobUrl", () => $dd0a5c69b434a5a7$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $dd0a5c69b434a5a7$export$e51a8146182600b8);
const $dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $dd0a5c69b434a5a7$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $dd0a5c69b434a5a7$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $dd0a5c69b434a5a7$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'collection'),
        alt: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'alt'),
        height: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'height'),
        width: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'width'),
        size: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'size'),
        name: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'name'),
        mimeType: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'mimeType')
    };
};
const $dd0a5c69b434a5a7$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $dd0a5c69b434a5a7$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $dd0a5c69b434a5a7$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("9Mg12", function(module, exports) {
$parcel$export(module.exports, "mediaFilePreviewCache", () => $d9909271b08294f2$export$b7e8ee3f7a41459);

var $4ZQua = parcelRequire("4ZQua");
const $d9909271b08294f2$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $d9909271b08294f2$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $d9909271b08294f2$export$b7e8ee3f7a41459 = new $d9909271b08294f2$export$7b50526c091bb915((0, $4ZQua.createObjectURLCache)());

});
parcelRegister("4ZQua", function(module, exports) {
$parcel$export(module.exports, "createObjectURLCache", () => $7640c7504dcb2ad6$export$ba71be67d5c32535);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $7640c7504dcb2ad6$export$36d0f9859761643d = 50;
class $7640c7504dcb2ad6$var$ExtendedLRUCache extends (0, $7xkt0.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $7640c7504dcb2ad6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $7640c7504dcb2ad6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $7640c7504dcb2ad6$export$ba71be67d5c32535 = ()=>new $7640c7504dcb2ad6$export$75d1c8c9ba1d0773($7640c7504dcb2ad6$export$36d0f9859761643d);

});


parcelRegister("hNvWT", function(module, exports) {
$parcel$export(module.exports, "isSupportedLocalPreview", () => $3247cef0fce3851d$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3247cef0fce3851d$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3247cef0fce3851d$export$bfe20bd01db02b3);

var $5JVfG = parcelRequire("5JVfG");

var $cK5G4 = parcelRequire("cK5G4");

var $33YQ1 = parcelRequire("33YQ1");

var $heXDA = parcelRequire("heXDA");
const $3247cef0fce3851d$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3247cef0fce3851d$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $cK5G4.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $heXDA.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3247cef0fce3851d$var$getImageLocalPreview(value);
            case 'video':
                return $3247cef0fce3851d$var$getVideoLocalPreview(value);
            default:
                throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
};
const $3247cef0fce3851d$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $33YQ1.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("cK5G4", function(module, exports) {
$parcel$export(module.exports, "getImageInfo", () => $4622caaad73ce041$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $4622caaad73ce041$export$67689507e8404821);

var $9PgO0 = parcelRequire("9PgO0");

var $f8uqC = parcelRequire("f8uqC");

var $fOXQV = parcelRequire("fOXQV");

var $kHzU5 = parcelRequire("kHzU5");
const { Orientation: $4622caaad73ce041$var$Orientation, XResolution: $4622caaad73ce041$var$XResolution } = (0, $9PgO0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $4622caaad73ce041$var$DPI_WEB_BASELINE = 72;
async function $4622caaad73ce041$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $4622caaad73ce041$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $4622caaad73ce041$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $4622caaad73ce041$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
        else return $4622caaad73ce041$export$268f92356524130b(tags, $4622caaad73ce041$var$XResolution, $4622caaad73ce041$var$DPI_WEB_BASELINE) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $4622caaad73ce041$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$4622caaad73ce041$var$Orientation]) {
        const tagValue = tags[$4622caaad73ce041$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $9PgO0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $4622caaad73ce041$export$67689507e8404821(file) {
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    return $4622caaad73ce041$var$getOrientationFromTags(tags);
}
function $4622caaad73ce041$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $4622caaad73ce041$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $fOXQV.loadImage)(src);
        const { width: width, height: height } = (0, $fOXQV.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("9PgO0", function(module, exports) {
$parcel$export(module.exports, "ImageType", () => $c8d64cb551bef33f$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $c8d64cb551bef33f$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $c8d64cb551bef33f$export$f6ea0c89fd7d156);
var $c8d64cb551bef33f$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $c8d64cb551bef33f$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $c8d64cb551bef33f$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("f8uqC", function(module, exports) {
$parcel$export(module.exports, "readImageMetaTags", () => $80e2aeeb99751964$export$41982b5c7acb23c4);

var $9PgO0 = parcelRequire("9PgO0");

var $dCEVY = parcelRequire("dCEVY");

var $7BlyC = parcelRequire("7BlyC");

var $3yAnp = parcelRequire("3yAnp");
async function $80e2aeeb99751964$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $9PgO0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $7BlyC.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $3yAnp.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $9PgO0.ImageType).JPEG) return await (0, $dCEVY.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("dCEVY", function(module, exports) {
$parcel$export(module.exports, "readJPEGExifMetaData", () => $ff103de7f6ab6f18$export$556b2ccec62d7f2a);

var $9PgO0 = parcelRequire("9PgO0");
const { XResolution: $ff103de7f6ab6f18$var$XResolution, YResolution: $ff103de7f6ab6f18$var$YResolution } = (0, $9PgO0.SupportedImageMetaTag);
let $ff103de7f6ab6f18$var$loadImage;

function $ff103de7f6ab6f18$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$ff103de7f6ab6f18$var$loadImage) {
            const module = await (parcelRequire("lm4Lq"));
            $ff103de7f6ab6f18$var$loadImage = module.default || module;
        }
        $ff103de7f6ab6f18$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $ff103de7f6ab6f18$var$XResolution || key === $ff103de7f6ab6f18$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("lm4Lq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2HU4O").then(()=>parcelRequire('4Mu1O'));

});


parcelRegister("7BlyC", function(module, exports) {
$parcel$export(module.exports, "readPNGXMPMetaData", () => $e9cd4ca7c89b16ee$export$5fb37736440fca6f);

var $fOXQV = parcelRequire("fOXQV");
let $e9cd4ca7c89b16ee$var$pngChunksExtract;

async function $e9cd4ca7c89b16ee$export$5fb37736440fca6f(file) {
    if (!$e9cd4ca7c89b16ee$var$pngChunksExtract) {
        const module = await (parcelRequire("6FWCb"));
        $e9cd4ca7c89b16ee$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $fOXQV.fileToArrayBuffer)(file);
    const chunks = $e9cd4ca7c89b16ee$var$pngChunksExtract(buffer);
    return await $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks);
}
async function $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("6FWCb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fWdHm").then(()=>parcelRequire('6TwJU'));

});


parcelRegister("3yAnp", function(module, exports) {
$parcel$export(module.exports, "parseXMPMetaData", () => $a54c683875c3acaa$export$55c3bc9841b19de2);
function $a54c683875c3acaa$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});



parcelRegister("heXDA", function(module, exports) {
$parcel$export(module.exports, "takeSnapshot", () => $e7f813388d1815ac$export$4269d30173168e5c);
const $e7f813388d1815ac$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("i0gVY", function(module, exports) {
$parcel$export(module.exports, "getMediaCardSSR", () => $c6ffe105f3de4b84$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $c6ffe105f3de4b84$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $c6ffe105f3de4b84$export$de7c49925e44d75d);

var $itX9h = parcelRequire("itX9h");
const $c6ffe105f3de4b84$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $c6ffe105f3de4b84$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $c6ffe105f3de4b84$var$dashed = (param)=>param ? `-${param}` : '';
const $c6ffe105f3de4b84$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$c6ffe105f3de4b84$var$dashed(collectionName)}${$c6ffe105f3de4b84$var$dashed(occurrenceKey)}`;
const $c6ffe105f3de4b84$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $c6ffe105f3de4b84$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $itX9h.printFunctionCall)($c6ffe105f3de4b84$export$4310981e0aa4ce67, $c6ffe105f3de4b84$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $itX9h.printScript)([
        $c6ffe105f3de4b84$export$ede93d4564eaa8da.toString(),
        $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $c6ffe105f3de4b84$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $c6ffe105f3de4b84$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("itX9h", function(module, exports) {
$parcel$export(module.exports, "printFunctionCall", () => $58d2f85efd2afaca$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $58d2f85efd2afaca$export$8b902fb69a2f17c1);
const $58d2f85efd2afaca$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $58d2f85efd2afaca$var$printParams = (args)=>args.map((arg)=>$58d2f85efd2afaca$var$printParam(arg)).join(',');
const $58d2f85efd2afaca$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$58d2f85efd2afaca$var$printParams(args)});`;
const $58d2f85efd2afaca$export$8b902fb69a2f17c1 = (statements)=>`(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		`;

});


parcelRegister("8Dv9L", function(module, exports) {
$parcel$export(module.exports, "getSSRData", () => $2f30a37781c6f0c3$export$d3a890b0f7844b6f);

var $i0gVY = parcelRequire("i0gVY");
const $2f30a37781c6f0c3$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $i0gVY.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $i0gVY.getKey)(identifier)];
};

});

parcelRegister("3c1p9", function(module, exports) {
$parcel$export(module.exports, "isBigger", () => $f93a7743871712e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $f93a7743871712e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $f93a7743871712e9$export$b3e10e1f0fbb71db);

var $eJOHy = parcelRequire("eJOHy");
const $f93a7743871712e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $f93a7743871712e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $f93a7743871712e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $f93a7743871712e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $f93a7743871712e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}

});


parcelRegister("81Qv0", function(module, exports) {
$parcel$export(module.exports, "createDownloadAction", () => $6ad7fc989859e952$export$948607b7587fecda);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kHcBe = parcelRequire("kHcBe");

var $lk6TK = parcelRequire("lk6TK");
function $6ad7fc989859e952$export$1390767202e8e51e(actions, details) {
    return actions.map((action)=>({
            ...action,
            handler: ()=>{
                action.handler({
                    type: 'file',
                    details: details
                });
            }
        }));
}
const $6ad7fc989859e952$export$948607b7587fecda = (baseAction, formatMessage)=>{
    const { isDisabled: isDisabled } = baseAction;
    const label = isDisabled ? 'Download Disabled' : 'Download';
    const tooltip = isDisabled ? formatMessage((0, $lk6TK.messages).download_disabled_security_policy) : undefined;
    return {
        ...baseAction,
        label: label,
        tooltip: tooltip,
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHcBe))), {
            color: isDisabled ? "var(--ds-icon-disabled, #091E424F)" : 'currentColor',
            spacing: "spacious",
            label: "Download"
        })
    };
};

});

parcelRegister("0456t", function(module, exports) {
$parcel$export(module.exports, "DateOverrideContext", () => $ba91aeb62837168a$export$5bc85d7cf4a39f3e);

var $eJOHy = parcelRequire("eJOHy");
const $ba91aeb62837168a$export$5bc85d7cf4a39f3e = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);

});

parcelRegister("6qVXk", function(module, exports) {
$parcel$export(module.exports, "AbuseModal", () => $9919d467927118db$export$9b832d04bd876d78);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $5CSKW = parcelRequire("5CSKW");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $lk6TK = parcelRequire("lk6TK");
const $9919d467927118db$export$9b832d04bd876d78 = (0, $6YFG2.default)(({ isOpen: isOpen, onConfirm: onConfirm, onClose: onClose, intl: { formatMessage: formatMessage } })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gHHv2.default), {
            onClose: onClose,
            testId: "mediaAbuseModal",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                        appearance: "warning",
                        children: formatMessage((0, $lk6TK.messages).abuse_modal_title)
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                    children: formatMessage((0, $lk6TK.messages).abuse_modal_body)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kseeK.default), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: formatMessage((0, $lk6TK.messages).cancel)
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                            appearance: "warning",
                            onClick: onConfirm,
                            children: formatMessage((0, $lk6TK.messages).abuse_modal_submit)
                        })
                    ]
                })
            ]
        })
    });
});

});

parcelRegister("dllpM", function(module, exports) {
$parcel$export(module.exports, "default", () => $4adf76c7a26850b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $d0Gew = parcelRequire("d0Gew");
function $4adf76c7a26850b8$export$2e2bcd8739ae039(name) {
    const context = (0, $eJOHy.useContext)((0, $d0Gew.default));
    const handleClick = (0, $eJOHy.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});


parcelRegister("gMOdC", function(module, exports) {
$parcel$export(module.exports, "setAnalyticsContext", () => $623a156115f73720$export$70c58d75bd83664);
$parcel$export(module.exports, "startResourceObserver", () => $623a156115f73720$export$8840d7cbe19419a0);


var $eGOwo = parcelRequire("eGOwo");

var $6un1Q = parcelRequire("6un1Q");

var $8eng6 = parcelRequire("8eng6");
const $623a156115f73720$var$MEDIA_CARD_PERF_STATE_KEY = '__mediaCardPerfState_asflkajsdflja';
const $623a156115f73720$var$urlRegex = /https:\/\/(?:media\.(?:dev|staging|prod)\.atl-paas\.net|api\.media\.atlassian\.com|media-cdn(?:\.stg\.|\.)atlassian\.com)\/file\/([^/]+)\/image.*[?&]source=mediaCard/;
const $623a156115f73720$var$clientIdParamRegex = /[?&]clientId=([^&]+)/;
const $623a156115f73720$var$ssrParamRegex = /[?&]token=([^&]+)/;
const $623a156115f73720$var$createAndGetResourceObserver = ()=>{
    return new PerformanceObserver((list)=>{
        list.getEntries().forEach((baseEntry)=>{
            const entry = baseEntry;
            const matchFileId = entry.name.match($623a156115f73720$var$urlRegex);
            const matchClientId = entry.name.match($623a156115f73720$var$clientIdParamRegex);
            const matchSSR = entry.name.match($623a156115f73720$var$ssrParamRegex);
            if (matchFileId && window[$623a156115f73720$var$MEDIA_CARD_PERF_STATE_KEY]?.mediaCardCreateAnalyticsEvent) {
                const fileId = matchFileId[1];
                const clientId = matchClientId?.[1];
                const ssr = matchSSR ? 'server' : undefined;
                const navigationTime = performance.getEntriesByType('navigation')[0];
                const mediaDurationMetrics = (0, $6un1Q.createMediaDurationMetrics)(entry, navigationTime);
                const event = window[$623a156115f73720$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardCreateAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'mediaCardPerfObserver',
                    attributes: {
                        ssr: ssr,
                        fileId: fileId,
                        mediaClientId: clientId,
                        featureFlags: {
                            'media-cdn-single-host': (0, $eGOwo.fg)('platform_media_cdn_single_host')
                        },
                        ...mediaDurationMetrics
                    }
                });
                event.fire((0, $1f17110950ea8e13$export$ec1779cb96554e1));
                if ((0, $eGOwo.fg)('platform_media_card_ufo_network_metrics')) {
                    const ufoDurationMetrics = (0, $6un1Q.createUfoDurationMetrics)(entry, navigationTime);
                    const endpointName = 'image';
                    (0, $8eng6.sendUfoDurationMetrics)(ufoDurationMetrics, endpointName);
                }
            }
        });
    });
};
const $623a156115f73720$export$70c58d75bd83664 = (newAnalyticsContext)=>{
    if (!window[$623a156115f73720$var$MEDIA_CARD_PERF_STATE_KEY]) window[$623a156115f73720$var$MEDIA_CARD_PERF_STATE_KEY] = {};
    window[$623a156115f73720$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardCreateAnalyticsEvent = newAnalyticsContext;
};
const $623a156115f73720$var$isDefinedPerformanceObserver = ()=>typeof window['PerformanceObserver'] !== 'undefined';
const $623a156115f73720$export$8840d7cbe19419a0 = ()=>{
    if (!$623a156115f73720$var$isDefinedPerformanceObserver()) return;
    if (window[$623a156115f73720$var$MEDIA_CARD_PERF_STATE_KEY]?.mediaCardPerfObserver) return;
    if (!window[$623a156115f73720$var$MEDIA_CARD_PERF_STATE_KEY]) window[$623a156115f73720$var$MEDIA_CARD_PERF_STATE_KEY] = {};
    window[$623a156115f73720$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardPerfObserver = $623a156115f73720$var$createAndGetResourceObserver();
    window[$623a156115f73720$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardPerfObserver.observe({
        type: 'resource',
        buffered: true
    });
};

});
parcelRegister("6un1Q", function(module, exports) {
$parcel$export(module.exports, "createMediaDurationMetrics", () => $7d269c2c91e712b7$export$b22670df0917866e);
$parcel$export(module.exports, "createUfoDurationMetrics", () => $7d269c2c91e712b7$export$45a6f341f1a26a5d);
const $7d269c2c91e712b7$var$getStartedAt = (entry, navigationTime)=>entry.startTime - (navigationTime?.domContentLoadedEventEnd || 0);
const $7d269c2c91e712b7$var$getCommonMetrics = (entry)=>({
        tcpHandshakeTime: {
            end: entry.connectEnd,
            start: entry.connectStart
        },
        dnsLookupTime: {
            end: entry.domainLookupEnd,
            start: entry.domainLookupStart
        },
        redirectTimeTaken: {
            end: entry.redirectEnd,
            start: entry.redirectStart
        },
        tlsConnectNegotiationTime: {
            end: entry.requestStart,
            start: entry.secureConnectionStart
        },
        timeTakenToFetchWithoutRedirect: {
            end: entry.responseEnd,
            start: entry.fetchStart
        },
        /**
	 * `interimRequestTime` represents the entire time the browser took to
	 * request the resource from the server. This includes the interim response time
	 * (for example, 100 Continue or 103 Early Hints).
	 *
	 * i.e. It is the time taken for the request to be sent
	 * + the waiting time for the server to send a response
	 *
	 * Please, note that this value
	 * is distinctly different from the aforementioned document.
	 */ interimRequestTime: {
            end: entry.responseStart,
            start: entry.requestStart
        },
        /**
	 * `requestInvocationTime` represents the actual time the browser took to request
	 * the resource from the server (i.e. it does not include the interim reponse
	 * time).
	 * NOTE: it relies on an experimental feature (`firstInterimResponseStart`) that is
	 * available in Chrome, but not in FireFox or Safari. This value will be undefined
	 * when `firstInterimResponseStart` is unavailable.
	 */ requestInvocationTime: entry.firstInterimResponseStart ? {
            end: entry.firstInterimResponseStart,
            start: entry.requestStart
        } : undefined,
        /**
	 * `contentDownloadTime` represents the time taken for the browser to receive
	 * the resource from the server. This may be cut short if the transport
	 * connection is closed.
	 */ contentDownloadTime: {
            end: entry.responseEnd,
            start: entry.responseStart
        }
    });
const $7d269c2c91e712b7$var$calculateCommonDurations = (metrics)=>Object.fromEntries(Object.entries(metrics).map(([key, marks])=>{
        if (!marks) return [
            key,
            undefined
        ];
        const { start: start, end: end } = marks;
        return [
            key,
            end - start
        ];
    }));
const $7d269c2c91e712b7$export$b22670df0917866e = (entry, navigationTime)=>{
    return {
        startedAt: $7d269c2c91e712b7$var$getStartedAt(entry, navigationTime),
        /**
		 * Performance resource timing data regarding the loading of an
		 * application's resources as described in
		 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming
		 */ transferSize: entry.transferSize,
        decodedBodySize: entry.decodedBodySize,
        totalDuration: entry.duration,
        initiatorType: entry.initiatorType,
        responseEnd: entry.responseEnd,
        browserCacheHit: entry.transferSize === 0,
        nextHopProtocol: entry.nextHopProtocol,
        ...$7d269c2c91e712b7$var$calculateCommonDurations($7d269c2c91e712b7$var$getCommonMetrics(entry)),
        /**
		 * The user agent string for the current browser
		 * Read more: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgent
		 */ userAgent: window.navigator.userAgent,
        /**
		 * Performance resource timing data sent by the server. This includes:
		 *
		 * `cdnCacheHit` is a boolean determining whether the CDN cache was hit or missed.
		 *
		 * `cdnDownstreamFBL` is the 'CDN Downstream First Byte Latency'. It represents
		 * how long the it took the CDN to respond to the frontend.
		 *
		 * `cdnUpstreamFBL` is the 'CDN Upstream First Byte Latency'. It represents the
		 * time the Media backend took to respond to the CDN, in the case that the CDN
		 * cache was a miss. Notably, this timing is a subset of the `cdnDownstreamFBL` timing.
		 */ cdnCacheHit: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-cache-hit';
        }) ? true : false,
        cdnDownstreamFBL: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-downstream-fbl';
        })?.duration,
        cdnUpstreamFBL: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-upstream-fbl';
        })?.duration
    };
};
const $7d269c2c91e712b7$var$filterCommonMetrics = (metrics)=>Object.fromEntries(Object.entries(metrics).filter(([, marks])=>!!marks));
const $7d269c2c91e712b7$export$45a6f341f1a26a5d = (entry, navigationTime)=>{
    return {
        resourceTiming: {
            start: $7d269c2c91e712b7$var$getStartedAt(entry, navigationTime),
            end: entry.responseEnd
        },
        ...$7d269c2c91e712b7$var$filterCommonMetrics($7d269c2c91e712b7$var$getCommonMetrics(entry))
    };
};

});

parcelRegister("8eng6", function(module, exports) {
$parcel$export(module.exports, "sendUfoDurationMetrics", () => $495eb310ab0d7384$export$be8beb5937d1436e);

var $2QO3b = parcelRequire("2QO3b");
const $495eb310ab0d7384$var$mediaLabelStack = [
    {
        name: 'media'
    }
];
const $495eb310ab0d7384$export$be8beb5937d1436e = (ufoDurationMetrics, endpoint)=>{
    const labelStack = [
        ...$495eb310ab0d7384$var$mediaLabelStack,
        {
            name: endpoint
        }
    ];
    Object.entries(ufoDurationMetrics).map(([name, { start: start, end: end, size: size }])=>{
        (0, $2QO3b.addCustomSpans)(name, start, end, size, labelStack);
    });
};

});


parcelRegister("lfkxd", function(module, exports) {
$parcel$export(module.exports, "default", () => $59bcdab4948f2926$export$2e2bcd8739ae039);

var $dxAg1 = parcelRequire("dxAg1");
var $59bcdab4948f2926$export$2e2bcd8739ae039 = (0, $dxAg1.default);

});
parcelRegister("dxAg1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9e1cf510df590c5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");
function $e9e1cf510df590c5$export$2e2bcd8739ae039({ name: name, children: children }) {
    const context = (0, $7aoMz.useInteractionContext)();
    const newContext = (0, $eJOHy.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7aoMz.default).Provider, {
        value: newContext,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
}

});





parcelRegister("5s6bt", function(module, exports) {
$parcel$export(module.exports, "withImageLoader", () => $e51a33182b24142b$export$9b0f795b2e33f057);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $e51a33182b24142b$export$3a0bcc6ff2e20f36 = (Wrapped)=>class WithImageLoader extends (0, $eJOHy.Component) {
        /**
		 *
		 * @example
		 */ componentDidMount() {
            this.fetchImage(this.props);
        }
        /**
		 *
		 * @param nextProps
		 * @example
		 */ // Ignored via go/ees005
        // eslint-disable-next-line react/no-unsafe
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        /**
		 *
		 * @example
		 */ componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        /**
		 *
		 * @param root0
		 * @param root0.url
		 * @example
		 */ fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        /**
		 *
		 * @example
		 */ render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $e51a33182b24142b$var$withImageLoaderNew = (Wrapped)=>class WithImageLoader extends (0, $eJOHy.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $e51a33182b24142b$export$9b0f795b2e33f057 = (Wrapped)=>{
    return $e51a33182b24142b$var$withImageLoaderNew(Wrapped);
};

});


parcelRegister("9Ybet", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $0340e326d8501f19$export$bad3c41dd33cb4bc);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $0340e326d8501f19$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $0340e326d8501f19$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $0340e326d8501f19$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #091E4224)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #758195)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #172B4D)"
};

});

parcelRegister("9XXFf", function(module, exports) {
$parcel$export(module.exports, "RESOLVE_METHOD", () => $b3cdb4a4cbb698e4$export$ecd1fed429542b49);
$parcel$export(module.exports, "VIEW_METHOD", () => $b3cdb4a4cbb698e4$export$9cf3651d97128b9c);
var $b3cdb4a4cbb698e4$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $b3cdb4a4cbb698e4$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});

});

parcelRegister("11jfh", function(module, exports) {
$parcel$export(module.exports, "CommentBadge", () => $5ce53efbf51888c4$export$ef88b752358da42);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3s8bj = parcelRequire("3s8bj");

var $abjs4 = parcelRequire("abjs4");

var $7yBx7 = parcelRequire("7yBx7");

var $gDKBr = parcelRequire("gDKBr");

var $04OD1 = parcelRequire("04OD1");

var $k71qx = parcelRequire("k71qx");

var $kH7By = parcelRequire("kH7By");
const $5ce53efbf51888c4$var$commentBadgeWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'absolute',
    // closest parent element with position relative is .resizer-hover-zone, which includes 10px padding
    right: '2px',
    top: '2px',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $7yBx7.akEditorUnitZIndex) * 10
});
const $5ce53efbf51888c4$var$commentBadgeEditorOverrides = (badgeOffsetRight)=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: badgeOffsetRight,
        zIndex: 100
    });
const $5ce53efbf51888c4$export$1019384fb8540123 = (width, height)=>{
    // width is the original width of image, not resized or currently rendered to user. Defaulting to medium for now
    return width && width < 70 || height && height < 70 ? 'small' : 'medium';
};
const $5ce53efbf51888c4$export$ef88b752358da42 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ intl: intl, width: width, height: height, status: status = 'default', mediaSingleElement: mediaSingleElement, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, badgeOffsetRight: badgeOffsetRight }, ref)=>{
    const [badgeSize, setBadgeSize] = (0, $eJOHy.useState)($5ce53efbf51888c4$export$1019384fb8540123(width, height));
    const title = intl.formatMessage((0, $kH7By.commentMessages).viewCommentsOnMedia);
    (0, $eJOHy.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setBadgeSize($5ce53efbf51888c4$export$1019384fb8540123(width, height));
        }));
        if (mediaSingleElement instanceof HTMLElement) observer.observe(mediaSingleElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement
    ]);
    const badgeDimensions = badgeSize === 'medium' ? '24px' : '16px';
    const colourToken = (0, $eJOHy.useMemo)(()=>{
        switch(status){
            case 'active':
                return "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)";
            case 'entered':
                return "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)";
            default:
                return "var(--ds-background-accent-yellow-subtlest, #FFF7D6)";
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: ref,
        css: badgeOffsetRight ? [
            $5ce53efbf51888c4$var$commentBadgeWrapper,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $5ce53efbf51888c4$var$commentBadgeEditorOverrides(badgeOffsetRight)
        ] : $5ce53efbf51888c4$var$commentBadgeWrapper,
        // This is needed so that mediaWrapperStyle in editor/editor-common/src/ui/MediaSingle/styled.tsx
        // can target the correct div
        "data-comment-badge": "true"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $abjs4.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: badgeDimensions,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: badgeDimensions,
            background: colourToken,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center'
        },
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        iconAfter: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
            label: title,
            spacing: "spacious",
            color: "currentColor",
            LEGACY_size: badgeSize,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($04OD1)))
        })
    })));
});

});
parcelRegister("gDKBr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33181fb6c3dda951a22e3b4873cc95fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1d470387d991694$var$_react = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c1d470387d991694$var$_baseNew = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c1d470387d991694$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1d470387d991694$var$CommentIcon = (props)=>/*#__PURE__*/ $c1d470387d991694$var$_react.default.createElement($c1d470387d991694$var$_baseNew.default, Object.assign({
        name: "CommentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$c1d470387d991694$var$CommentIcon.displayName = 'CommentIcon';
var $c1d470387d991694$var$_default = module.exports.default = $c1d470387d991694$var$CommentIcon;

});

parcelRegister("04OD1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00e7a599837ddc3e$var$_react = $00e7a599837ddc3e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $00e7a599837ddc3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $00e7a599837ddc3e$var$CommentIcon = (props)=>/*#__PURE__*/ $00e7a599837ddc3e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props));
$00e7a599837ddc3e$var$CommentIcon.displayName = 'CommentIcon';
var $00e7a599837ddc3e$var$_default = module.exports.default = $00e7a599837ddc3e$var$CommentIcon;

});

parcelRegister("kH7By", function(module, exports) {
$parcel$export(module.exports, "commentMessages", () => $a53c9034f68ab7f9$export$4c0d145df60cfb04);

var $7qGN1 = parcelRequire("7qGN1");
const $a53c9034f68ab7f9$export$4c0d145df60cfb04 = (0, $7qGN1.defineMessages)({
    addCommentOnMedia: {
        id: 'fabric.editor.addCommentOnMedia',
        defaultMessage: 'Add comment',
        description: 'Add a comment for this media (image/video)'
    },
    viewCommentsOnMedia: {
        id: 'fabric.editor.viewCommentOnMedia',
        defaultMessage: 'View comments',
        description: 'View a existing comment for this media (image/video)'
    },
    viewAndAddCommentsOnMedia: {
        id: 'fabric.editor.viewAndAddCommentsOnMedia',
        defaultMessage: 'View and add comments',
        description: 'View and add comments for this image'
    }
});

});


parcelRegister("a61Rj", function(module, exports) {
$parcel$export(module.exports, "CommentBadgeNext", () => $3d21c0f76897116c$export$d5da84b0136a0cc4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gDKBr = parcelRequire("gDKBr");

var $04OD1 = parcelRequire("04OD1");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $kH7By = parcelRequire("kH7By");
const $3d21c0f76897116c$var$baseStyles = (0, $1DXK0.xcss)({
    borderRadius: 'radius.small'
});
const $3d21c0f76897116c$var$mediumBadgeStyles = (0, $1DXK0.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $3d21c0f76897116c$export$d5da84b0136a0cc4 = ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $lRq8t.default)();
    const title = intl.formatMessage((0, $kH7By.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $eJOHy.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        position: "top",
        content: title,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
            xcss: [
                $3d21c0f76897116c$var$baseStyles,
                $3d21c0f76897116c$var$mediumBadgeStyles
            ],
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
                label: title,
                spacing: "spacious",
                color: "currentColor",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($04OD1)))
            })
        })
    });
};

});

parcelRegister("avOy4", function(module, exports) {
$parcel$export(module.exports, "ExternalImageBadge", () => $fc1bed99f2b44345$export$66bf2ed7a5d4691f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $i4Iw4 = parcelRequire("i4Iw4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $aGtA3 = parcelRequire("aGtA3");
const $fc1bed99f2b44345$var$baseStyles = (0, $1DXK0.xcss)({
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $fc1bed99f2b44345$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com'
];
const $fc1bed99f2b44345$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    return Boolean(hostname && $fc1bed99f2b44345$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $fc1bed99f2b44345$export$66bf2ed7a5d4691f = ({ type: type, url: url })=>{
    const intl = (0, $lRq8t.default)();
    const message = intl.formatMessage((0, $aGtA3.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $fc1bed99f2b44345$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
        padding: "space.050",
        xcss: $fc1bed99f2b44345$var$baseStyles,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                "data-testid": "external-image-badge"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                content: message,
                position: "top",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))), {
                    LEGACY_size: "small",
                    label: message
                })
            })
        ]
    });
};

});
parcelRegister("aGtA3", function(module, exports) {
$parcel$export(module.exports, "externalMediaMessages", () => $6d685c4974759cb5$export$8e36294abfabe45e);

var $7qGN1 = parcelRequire("7qGN1");
const $6d685c4974759cb5$export$8e36294abfabe45e = (0, $7qGN1.defineMessages)({
    externalMediaFile: {
        id: 'fabric.editor.externalMediaFile',
        defaultMessage: 'External media file',
        description: 'External media file'
    }
});

});


parcelRegister("88noB", function(module, exports) {
$parcel$export(module.exports, "MediaBadges", () => $e2b99d7830d902d4$export$6a31fc38737d0e58);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $e2b99d7830d902d4$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT = 200;
const $e2b99d7830d902d4$var$containerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $e2b99d7830d902d4$var$hackedZIndexStyles = (0, $1DXK0.xcss)({
    // @ts-ignore
    zIndex: '1'
});
const $e2b99d7830d902d4$var$resizeOffsetStyles = (0, $1DXK0.xcss)({
    right: 'space.150'
});
const $e2b99d7830d902d4$var$getBadgeVisible = (width, height)=>{
    return width && width < $e2b99d7830d902d4$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT || height && height < $e2b99d7830d902d4$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $e2b99d7830d902d4$export$6a31fc38737d0e58 = ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $eJOHy.useState)($e2b99d7830d902d4$var$getBadgeVisible(mediaWidth, mediaHeight));
    (0, $eJOHy.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($e2b99d7830d902d4$var$getBadgeVisible(width, height));
        }));
        if (mediaElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(children) === 0) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        xcss: [
            $e2b99d7830d902d4$var$containerStyles,
            useMinimumZIndex && $e2b99d7830d902d4$var$hackedZIndexStyles,
            extendedResizeOffset && $e2b99d7830d902d4$var$resizeOffsetStyles
        ],
        children: children
    });
};

});


parcelRegister("2FwjZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $85dfa6ab83027e14$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1n5AE = parcelRequire("1n5AE");

var $8TCRV = parcelRequire("8TCRV");

var $jgJtD = parcelRequire("jgJtD");
class $85dfa6ab83027e14$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const numChildren = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(this.props.children);
        let content;
        if (numChildren === 1) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const card = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(this.props.children)[0];
            switch(card.props.type){
                case 'file':
                    content = this.renderSingleFile(card);
                    break;
                case 'link':
                    content = null;
                    break;
                default:
                    content = this.renderSingleLink(card);
            }
        } else content = this.renderStrip();
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: "MediaGroup",
                ...(0, $jgJtD.VcMediaWrapperProps),
                children: content
            })
        });
    }
    renderSingleFile(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            resizeMode: 'stretchy-fit',
            cardDimensions: (0, $1n5AE.defaultImageCardDimensions),
            useInlinePlayer: false,
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderSingleLink(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            appearance: 'auto',
            featureFlags: this.props.featureFlags
        });
    }
    cloneFileCard(child, surroundingItems) {
        const cardClickHandler = this.props && this.props.eventHandlers && this.props.eventHandlers.media && this.props.eventHandlers.media.onClick;
        const onClick = cardClickHandler ? this.onMediaClick(cardClickHandler, child, surroundingItems) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            useInlinePlayer: false,
            eventHandlers: {
                ...child.props.eventHandlers,
                media: {
                    onClick: onClick
                }
            },
            featureFlags: this.props.featureFlags,
            enableDownloadButton: this.props.enableDownloadButton
        });
    }
    renderStrip() {
        const { children: children } = this.props;
        const { animate: animate, offset: offset } = this.state;
        const childIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) return this.mapMediaPropsToIdentifier(child.props);
        });
        const surroundingItems = (childIdentifiers || []).filter((identifier)=>!!identifier);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8TCRV.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: this.handleSize,
            onScroll: this.handleScroll,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (rawChild)=>{
                const child = rawChild;
                switch(child.props.type){
                    case 'file':
                        return this.cloneFileCard(child, surroundingItems);
                    case 'link':
                        return null;
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                            featureFlags: this.props.featureFlags,
                            enableDownloadButton: this.props.enableDownloadButton
                        });
                }
            })
        });
    }
    mapMediaPropsToIdentifier({ id: id, type: type, occurrenceKey: occurrenceKey, collection: collection }) {
        switch(type){
            case 'file':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: type,
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
            case 'link':
                return undefined;
            case 'external':
                return {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: id,
                    mediaItemType: 'file',
                    occurrenceKey: occurrenceKey,
                    collectionName: collection
                };
        }
    }
    constructor(...args){
        super(...args), this.state = {
            animate: false,
            offset: 0
        }, this.handleSize = ({ offset: offset })=>this.setState({
                offset: offset
            }), this.handleScroll = ({ animate: animate, offset: offset })=>this.setState({
                animate: animate,
                offset: offset
            }), this.onMediaClick = (cardClickHandler, child, surroundingItems)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (event, analyticsEvent)=>{
                const surroundings = {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    collectionName: child.props.collection,
                    list: surroundingItems
                };
                cardClickHandler(event, surroundings, analyticsEvent);
            };
    }
}

});
parcelRegister("8TCRV", function(module, exports) {
$parcel$export(module.exports, "MediaFilmStripListItemSelector", () => $51e2bdb89be2a557$export$9f2ec2b609810bce);
$parcel$export(module.exports, "FilmstripView", () => $51e2bdb89be2a557$export$817db220b90d8024);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6whbE = parcelRequire("6whbE");

var $fpMeu = parcelRequire("fpMeu");
const $51e2bdb89be2a557$var$DURATION_MIN = 0.5;
const $51e2bdb89be2a557$var$DURATION_MAX = 1.0;
const $51e2bdb89be2a557$var$EXTRA_PADDING = 4;
const $51e2bdb89be2a557$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $51e2bdb89be2a557$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $51e2bdb89be2a557$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            animate: false,
            offset: 0
        };
    }
    constructor(props){
        super(props), this.previousOffset = 0, this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        }, this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        }, this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        }, this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        }, this.handleMutation = (mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        }, this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        }, this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        }, this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        }, this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        }, this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        }, this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($6whbE)))(this.handleMutation, 30, true));
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
	 * The furthest we can scroll, where the end of the buffer is just in view
	 */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $51e2bdb89be2a557$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $51e2bdb89be2a557$var$DURATION_MAX - $51e2bdb89be2a557$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $51e2bdb89be2a557$var$DURATION_MAX), $51e2bdb89be2a557$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $51e2bdb89be2a557$export$ba458cf715b18bd1);
        }
    }
    triggerScrollEvent() {
        if (!this.windowElement) return;
        const event = document.createEvent('MouseEvents');
        event.initEvent('scroll', true, true);
        this.windowElement.dispatchEvent(event);
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $51e2bdb89be2a557$var$EXTRA_PADDING) return newOffset - $51e2bdb89be2a557$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $51e2bdb89be2a557$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $51e2bdb89be2a557$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
        // trigger a "real" scroll event so lazily loaded cards realize they've been shown
        // note: we have to wait for the transition to end, otherwise the cards not visible when the scroll
        // event is triggered will be forever stuck in the loading screen (due to the lazy load)
        window.setTimeout(()=>this.triggerScrollEvent(), this.transitionDuration * 1000);
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fpMeu.FilmStripViewWrapper), {
            "data-testid": testId,
            children: [
                this.renderLeftArrow(),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.FilmStripListWrapper), {
                    ref: this.handleWindowElementChange,
                    onWheel: this.handleScroll,
                    onTouchStart: this.handleTouchStart,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd,
                    "data-testid": "filmstrip-list-wrapper",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.FilmStripList), {
                        ref: this.handleBufferElementChange,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            transform: transform,
                            transitionProperty: transitionProperty,
                            transitionDuration: transitionDuration
                        },
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, $51e2bdb89be2a557$var$mapReactChildToReactNode)
                    })
                }),
                this.renderRightArrow()
            ]
        });
    }
}
function $51e2bdb89be2a557$var$mapReactChildToReactNode(child, index) {
    const key = $51e2bdb89be2a557$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fpMeu.FilmStripListItem), {
        index: key,
        children: child
    }, key);
}
function $51e2bdb89be2a557$var$isReactElement(child) {
    return !!child.type;
}

});
parcelRegister("6whbE", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $4bf31031c1570027$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$4bf31031c1570027$var$debounce.debounce = $4bf31031c1570027$var$debounce;
module.exports = $4bf31031c1570027$var$debounce;

});

parcelRegister("fpMeu", function(module, exports) {
$parcel$export(module.exports, "LeftArrow", () => $54f9ccb1c3ca850e$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $54f9ccb1c3ca850e$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $54f9ccb1c3ca850e$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $54f9ccb1c3ca850e$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $54f9ccb1c3ca850e$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $54f9ccb1c3ca850e$export$54cfc70c184c0713);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $k1DaH = parcelRequire("k1DaH");

var $1xzHS = parcelRequire("1xzHS");
const $54f9ccb1c3ca850e$export$924abd21043fc000 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.ArrowLeftWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.ArrowLeftWrapper), {
        ...props
    });
const $54f9ccb1c3ca850e$export$a5ffe38c17bbc0a1 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.ShadowRight), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.ShadowRight), {
        ...props
    });
const $54f9ccb1c3ca850e$export$abf07652016c7e56 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.ArrowRightWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.ArrowRightWrapper), {
        ...props
    });
const $54f9ccb1c3ca850e$export$b39b1b86b48b621f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.LeftArrow), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.LeftArrow), {
        ...props
    });
const $54f9ccb1c3ca850e$export$6208675820d4cc50 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.RightArrow), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.RightArrow), {
        ...props
    });
const $54f9ccb1c3ca850e$export$d37eb83491863cbb = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripViewWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripViewWrapper), {
        ...props
    });
const $54f9ccb1c3ca850e$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripListWrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $54f9ccb1c3ca850e$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripList), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripList), {
        ...props,
        ref: ref
    }));
const $54f9ccb1c3ca850e$export$54cfc70c184c0713 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xzHS.FilmStripListItem), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k1DaH.FilmStripListItem), {
        ...props
    });

});
parcelRegister("k1DaH", function(module, exports) {
$parcel$export(module.exports, "ArrowLeftWrapper", () => $bcdff6ce7bf895cc$export$924abd21043fc000);
$parcel$export(module.exports, "ShadowRight", () => $bcdff6ce7bf895cc$export$a5ffe38c17bbc0a1);
$parcel$export(module.exports, "ArrowRightWrapper", () => $bcdff6ce7bf895cc$export$abf07652016c7e56);
$parcel$export(module.exports, "LeftArrow", () => $bcdff6ce7bf895cc$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $bcdff6ce7bf895cc$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $bcdff6ce7bf895cc$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $bcdff6ce7bf895cc$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $bcdff6ce7bf895cc$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $bcdff6ce7bf895cc$export$54cfc70c184c0713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $lqfmR = parcelRequire("lqfmR");

var $bcitO = parcelRequire("bcitO");

var $8TCRV = parcelRequire("8TCRV");

function $bcdff6ce7bf895cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bcdff6ce7bf895cc$var$filmStripViewStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'relative',
    padding: `${"var(--ds-space-025, 3px)"} 0`,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover .arrow': {
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ellipsed-text': {
        whiteSpace: 'initial'
    }
});
const $bcdff6ce7bf895cc$var$filmStripListWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    width: 'inherit',
    overflow: 'hidden',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-025, 3px)"}`
});
const $bcdff6ce7bf895cc$var$filmStripListStyles = {
    name: "1gi9lio",
    styles: "margin:0;padding:0 !important;transition-property:transform;transition-timing-function:cubic-bezier(0.77, 0, 0.175, 1);white-space:nowrap;display:inline-block"
};
const $bcdff6ce7bf895cc$var$filmStripListItemStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    listStyleType: 'none',
    margin: 0,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingLeft: 0
    },
    display: 'inline-block',
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0
});
const $bcdff6ce7bf895cc$var$arrowWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`,
    borderRadius: "var(--ds-radius-full, 9999px)",
    display: 'flex',
    cursor: 'pointer',
    transition: 'opacity 0.3s',
    boxShadow: "var(--ds-shadow-overlay, 0 1px 6px 0 rgba(0, 0, 0, 0.6))",
    color: "var(--ds-icon, black)",
    width: '30px',
    height: '30px',
    justifyContent: 'center',
    opacity: 0,
    '&:hover': {
        color: "var(--ds-text-subtle, black)",
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`
    },
    '&:active': {
        color: `var(--ds-text-selected, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
        backgroundColor: `var(--ds-background-selected, ${(0, $7bb4c1736002a04a$export$226de0355ed012f8)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        height: '30px',
        width: '20px'
    }
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$arrowLeftWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$arrowWrapperStyles, "left:var(--ds-space-100, 8px);svg{padding-right:var(--ds-space-025, 2px);}");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$arrowRightWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$arrowWrapperStyles, "right:var(--ds-space-100, 8px);svg{padding-left:var(--ds-space-025, 2px);}");
const $bcdff6ce7bf895cc$var$shadowStyles = {
    name: "atrqgo",
    styles: "position:absolute;z-index:10;height:100%;top:0;width:2px;background-color:var(--ds-border, rgba(0, 0, 0, 0.2))"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$shadowLeftStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$shadowStyles, "left:0;");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bcdff6ce7bf895cc$var$shadowRightStyles = /*#__PURE__*/ (0, $1NIU8.css)($bcdff6ce7bf895cc$var$shadowStyles, "right:0;");
const $bcdff6ce7bf895cc$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$shadowLeftStyles
    }, children);
const $bcdff6ce7bf895cc$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$arrowLeftWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $bcdff6ce7bf895cc$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$shadowRightStyles
    }, children);
const $bcdff6ce7bf895cc$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$arrowRightWrapperStyles,
        className: "arrow",
        onClick: onClick
    }, children);
const $bcdff6ce7bf895cc$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$var$ShadowLeft, null, /*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lqfmR))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $bcdff6ce7bf895cc$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, $1NIU8.jsx)($bcdff6ce7bf895cc$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bcitO))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $bcdff6ce7bf895cc$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$filmStripViewStyles,
        "data-testid": dataTestId
    }, children);
const $bcdff6ce7bf895cc$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $bcdff6ce7bf895cc$var$filmStripListWrapperStyles,
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId
    }, children));
const $bcdff6ce7bf895cc$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, $1NIU8.jsx)("ul", {
        css: [
            $bcdff6ce7bf895cc$var$filmStripListStyles
        ],
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children));
const $bcdff6ce7bf895cc$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, $1NIU8.jsx)("li", {
        css: $bcdff6ce7bf895cc$var$filmStripListItemStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8TCRV.MediaFilmStripListItemSelector),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);

});
parcelRegister("bcitO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01fe897a0e06a68c5bba306cb49fbc94>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $826f266802ea1177$var$_react = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $826f266802ea1177$var$_arrowRight = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("ePxSL")));

var $826f266802ea1177$var$_arrowRight2 = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("WCqcH")));
function $826f266802ea1177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $826f266802ea1177$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $826f266802ea1177$var$_react.default.createElement($826f266802ea1177$var$_arrowRight.default, Object.assign({
        name: "ArrowRightIcon",
        LEGACY_fallbackIcon: $826f266802ea1177$var$_arrowRight2.default
    }, props));
$826f266802ea1177$var$ArrowRightIcon.displayName = 'ArrowRightIconMigration';
var $826f266802ea1177$var$_default = module.exports.default = $826f266802ea1177$var$ArrowRightIcon;

});
parcelRegister("ePxSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::702c7642ca2bbc12ec1dc2b75efbc1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc01c6bd1fc51c7$var$_react = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $acc01c6bd1fc51c7$var$_baseNew = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $acc01c6bd1fc51c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc01c6bd1fc51c7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc01c6bd1fc51c7$var$_react.default.createElement($acc01c6bd1fc51c7$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$acc01c6bd1fc51c7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $acc01c6bd1fc51c7$var$_default = module.exports.default = $acc01c6bd1fc51c7$var$ArrowRightIcon;

});

parcelRegister("WCqcH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b0338a1f0c13ece$var$_react = $0b0338a1f0c13ece$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $0b0338a1f0c13ece$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0b0338a1f0c13ece$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $0b0338a1f0c13ece$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props));
$0b0338a1f0c13ece$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $0b0338a1f0c13ece$var$_default = module.exports.default = $0b0338a1f0c13ece$var$ArrowRightIcon;

});



parcelRegister("1xzHS", function(module, exports) {
$parcel$export(module.exports, "ArrowLeftWrapper", () => $28567b493ea4c8a6$export$924abd21043fc000);
$parcel$export(module.exports, "ShadowRight", () => $28567b493ea4c8a6$export$a5ffe38c17bbc0a1);
$parcel$export(module.exports, "ArrowRightWrapper", () => $28567b493ea4c8a6$export$abf07652016c7e56);
$parcel$export(module.exports, "LeftArrow", () => $28567b493ea4c8a6$export$b39b1b86b48b621f);
$parcel$export(module.exports, "RightArrow", () => $28567b493ea4c8a6$export$6208675820d4cc50);
$parcel$export(module.exports, "FilmStripViewWrapper", () => $28567b493ea4c8a6$export$d37eb83491863cbb);
$parcel$export(module.exports, "FilmStripListWrapper", () => $28567b493ea4c8a6$export$4b7fe5339e3afada);
$parcel$export(module.exports, "FilmStripList", () => $28567b493ea4c8a6$export$710ee13c74b7a1f0);
$parcel$export(module.exports, "FilmStripListItem", () => $28567b493ea4c8a6$export$54cfc70c184c0713);
/* wrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lqfmR = parcelRequire("lqfmR");

var $bcitO = parcelRequire("bcitO");

var $8TCRV = parcelRequire("8TCRV");
const $28567b493ea4c8a6$var$filmStripViewStyles = null;
const $28567b493ea4c8a6$var$filmStripListWrapperStyles = null;
const $28567b493ea4c8a6$var$filmStripListStyles = null;
const $28567b493ea4c8a6$var$filmStripListItemStyles = null;
const $28567b493ea4c8a6$var$arrowWrapperStyles = null;
const $28567b493ea4c8a6$var$arrowLeftWrapperStyles = null;
const $28567b493ea4c8a6$var$arrowRightWrapperStyles = null;
const $28567b493ea4c8a6$var$shadowStyles = null;
const $28567b493ea4c8a6$var$shadowLeftStyles = null;
const $28567b493ea4c8a6$var$shadowRightStyles = null;
const $28567b493ea4c8a6$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhkbq8d",
            "_1ltvidpf"
        ]),
        children: children
    });
const $28567b493ea4c8a6$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhkexu1 _1e0c1txw _80omtlke _16qs1wkk _syazgpis _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3lyvy _irr3376n _9h8h1ldt _1di629zg",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick,
        children: children
    });
const $28567b493ea4c8a6$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhkbq8d",
            "_1xi2idpf"
        ]),
        children: children
    });
const $28567b493ea4c8a6$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhkexu1 _1e0c1txw _80omtlke _16qs1wkk _syazgpis _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3lyvy _irr3376n _9h8h1ldt _1di629zg",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick,
        children: children
    });
const $28567b493ea4c8a6$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$var$ShadowLeft, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$export$924abd21043fc000, {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lqfmR))), {
                color: "currentColor",
                spacing: "spacious",
                label: "left"
            })
        })
    });
const $28567b493ea4c8a6$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$export$a5ffe38c17bbc0a1, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($28567b493ea4c8a6$export$abf07652016c7e56, {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bcitO))), {
                color: "currentColor",
                spacing: "spacious",
                label: "right"
            })
        })
    });
const $28567b493ea4c8a6$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": dataTestId,
        className: (0, $hcewu.default)([
            "_2rkofajl _kqswh2mm _ca0q1ysw _u5f3idpf _n3td1ysw _19bvidpf _1yqxkb7n _1ajs4jg8"
        ]),
        children: children
    });
const $28567b493ea4c8a6$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f31ysw _n3tdv77o _19bv1ysw"
        ]),
        children: children
    }));
const $28567b493ea4c8a6$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ]),
        children: children
    }));
const $28567b493ea4c8a6$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $8TCRV.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        children: children
    }, index);

});




parcelRegister("dHHKP", function(module, exports) {
$parcel$export(module.exports, "default", () => $307e48cc7be010e9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $jSAy9 = parcelRequire("jSAy9");

var $6Ramj = parcelRequire("6Ramj");

var $gAeD7 = parcelRequire("gAeD7");

var $aRuva = parcelRequire("aRuva");
var $93R6D = parcelRequire("93R6D");

var $1dILD = parcelRequire("1dILD");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $jMtSb = parcelRequire("jMtSb");

var $ftN6c = parcelRequire("ftN6c");

var $7DXmb = parcelRequire("7DXmb");

var $ex5uO = parcelRequire("ex5uO");

var $bMFKb = parcelRequire("bMFKb");
const $307e48cc7be010e9$var$RenderMediaInline = ({ rendererAppearance: rendererAppearance, clipboardAttrs: clipboardAttrs, collection: collectionName, eventHandlers: eventHandlers, identifier: identifier })=>{
    const [contextIdentifier, setContextIdentifier] = (0, $eJOHy.useState)();
    const [fileState, setFileState] = (0, $eJOHy.useState)();
    const mediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
    const contextIdentifierProvider = (0, $6Ramj.useProvider)('contextIdentifierProvider');
    (0, $eJOHy.useEffect)(()=>{
        if (contextIdentifierProvider) contextIdentifierProvider.then((resolvedContextID)=>{
            if (contextIdentifier !== resolvedContextID) setContextIdentifier(resolvedContextID);
        });
    }, [
        contextIdentifier,
        contextIdentifierProvider
    ]);
    const updateFileState = (0, $eJOHy.useCallback)(async (id)=>{
        const options = {
            collectionName: collectionName
        };
        try {
            if (mediaClient) {
                const fileState = await mediaClient.file.getCurrentState(id, options);
                setFileState(fileState);
            }
        } catch (error) {
        // do not set state on error
        }
    }, [
        collectionName,
        mediaClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const { id: id } = identifier;
        const nodeIsInCache = id && (0, $jMtSb.mediaIdentifierMap).has(id);
        if (!nodeIsInCache) (0, $jMtSb.mediaIdentifierMap).set(identifier.id, {
            ...identifier,
            collectionName: collectionName
        });
        return ()=>{
            (0, $jMtSb.mediaIdentifierMap).delete(id);
        };
    }, [
        identifier,
        collectionName
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const { id: id } = clipboardAttrs;
        id && updateFileState(id);
    }, [
        contextIdentifier,
        clipboardAttrs,
        updateFileState
    ]);
    /*
	 * Only show the loading view if the media client is not ready
	 * prevents calling the media API before the provider is ready
	 */ if (!mediaClient) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dILD.MediaInlineCardLoadingView), {
        message: "",
        isSelected: false
    });
    const handleMediaInlineClick = (result)=>{
        if (eventHandlers?.media?.onClick) eventHandlers?.media?.onClick(result);
    };
    const shouldOpenMediaViewer = true;
    const shouldDisplayToolTip = true;
    const { id: id, collection: collection } = clipboardAttrs;
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...(0, $jMtSb.getClipboardAttrs)({
            id: id,
            collection: collection,
            contextIdentifierProvider: contextIdentifier,
            fileState: fileState
        }),
        "data-node-type": "mediaInline",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gAeD7.default), {
            identifier: identifier,
            onClick: handleMediaInlineClick,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            shouldDisplayToolTip: shouldDisplayToolTip,
            mediaClientConfig: mediaClient.mediaClientConfig,
            mediaViewerItems: Array.from((0, $jMtSb.mediaIdentifierMap).values())
        })
    }));
};
const $307e48cc7be010e9$var$MediaInline = (props)=>{
    const { collection: collection, id: id, intl: intl, rendererAppearance: rendererAppearance, featureFlags: featureFlags, type: fileType, alt: alt, width: width, height: height, marks: marks, ssr: ssr } = props;
    const clipboardAttrs = {
        id: id,
        collection: collection
    };
    const identifier = {
        id: id,
        mediaItemType: 'file',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        collectionName: collection
    };
    const mediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (fileType === 'image') {
        const hasLinkMark = marks?.find((mark)=>mark.type.name === 'link');
        const borderMark = marks?.find((mark)=>mark?.type.name === 'border');
        const borderColor = borderMark?.attrs.color ?? '';
        const borderSize = borderMark?.attrs.size ?? 0;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7DXmb.ErrorBoundary), {
            component: (0, $ex5uO.ACTION_SUBJECT).RENDERER,
            componentId: (0, $bMFKb.ACTION_SUBJECT_ID).MEDIA_INLINE_IMAGE,
            createAnalyticsEvent: createAnalyticsEvent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jSAy9.MediaInlineImageCard), {
                mediaClient: ssr?.config ? (0, $aRuva.getMediaClient)(ssr.config) : mediaClient,
                identifier: identifier,
                alt: alt,
                width: width,
                height: height,
                ssr: ssr,
                border: {
                    borderSize: borderSize,
                    borderColor: borderColor
                },
                serializeDataAttrs: true,
                shouldOpenMediaViewer: !hasLinkMark
            })
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)($307e48cc7be010e9$var$RenderMediaInline, {
        identifier: identifier,
        clipboardAttrs: clipboardAttrs,
        eventHandlers: props.eventHandlers,
        rendererAppearance: rendererAppearance,
        intl: intl,
        collection: collection,
        featureFlags: featureFlags
    });
};
var $307e48cc7be010e9$export$2e2bcd8739ae039 = (0, $6YFG2.default)($307e48cc7be010e9$var$MediaInline);

});
parcelRegister("jSAy9", function(module, exports) {
$parcel$export(module.exports, "MediaInlineImageCard", () => $1ce01a8e27c54526$export$fca833ae4278270f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");
var $6YFG2 = parcelRequire("6YFG2");

var $ftN6c = parcelRequire("ftN6c");

var $fhbkk = parcelRequire("fhbkk");
var $1yWtS = parcelRequire("1yWtS");

var $iPHIU = parcelRequire("iPHIU");

var $93R6D = parcelRequire("93R6D");

var $52iZC = parcelRequire("52iZC");

var $92xoS = parcelRequire("92xoS");

var $2u6SE = parcelRequire("2u6SE");

var $hgI1e = parcelRequire("hgI1e");

var $7FDta = parcelRequire("7FDta");

var $cXjeN = parcelRequire("cXjeN");

var $71iJ2 = parcelRequire("71iJ2");

var $jOuuz = parcelRequire("jOuuz");
const $1ce01a8e27c54526$export$5d2cd1bea8591ba3 = ({ mediaClient: mediaClient, identifier: identifier, isSelected: isSelected, intl: intl, alt: alt, isLazy: isLazy, width: width, height: height, border: border, ssr: ssr, serializeDataAttrs: serializeDataAttrs, shouldOpenMediaViewer: shouldOpenMediaViewer, isViewOnly: isViewOnly })=>{
    const [fileState, setFileState] = (0, $eJOHy.useState)();
    const [subscribeError, setSubscribeError] = (0, $eJOHy.useState)();
    const [isFailedEventSent, setIsFailedEventSent] = (0, $eJOHy.useState)(false);
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $eJOHy.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = intl || (0, $4nehu.createIntl)({
        locale: 'en'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $1yWtS.MediaCardError)('missing-error-data'), failReason)=>{
        if (!isFailedEventSent && fileState) {
            setIsFailedEventSent(true);
            (0, $fhbkk.fireFailedOperationalEvent)(fileState, error, failReason, createAnalyticsEvent);
        }
    };
    const fireSucceededOperationalEvent = ()=>{
        if (!isSucceededEventSent && fileState) {
            setIsSucceededEventSent(true);
            (0, $fhbkk.fireSucceededOperationalEvent)(fileState, createAnalyticsEvent);
        }
    };
    (0, $eJOHy.useEffect)(()=>{
        if (mediaClient) {
            const subscription = mediaClient.file.getFileState(identifier.id, {
                collectionName: identifier.collectionName
            }).subscribe({
                next: (fileState)=>{
                    setFileState(fileState);
                    setSubscribeError(undefined);
                },
                error: (e)=>{
                    setSubscribeError(e);
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        identifier,
        mediaClient
    ]);
    const content = (dimensions)=>{
        if (!mediaClient) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jOuuz.InlineImageCardLoadingView), null);
        if (!ssr) {
            if (subscribeError) {
                const isUploading = fileState?.status === 'uploading';
                const errorMessage = isUploading ? (0, $2u6SE.messages).failedToUpload : (0, $2u6SE.messages).unableToLoadContent;
                const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
                fireFailedOperationalEvent(new (0, $1yWtS.MediaCardError)(errorReason, subscribeError));
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage(errorMessage)
                });
            }
            if (!fileState || fileState?.status === 'uploading') return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jOuuz.InlineImageCardLoadingView), null);
            if (fileState.status === 'error') {
                fireFailedOperationalEvent(new (0, $1yWtS.MediaCardError)('error-file-state', new Error(fileState.message)));
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                });
            } else if (fileState.status === 'failed-processing') {
                fireFailedOperationalEvent(undefined, 'failed-processing');
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                });
            } else if (!fileState.name) {
                fireFailedOperationalEvent(new (0, $1yWtS.MediaCardError)('metadata-fetch', new (0, $iPHIU.FileFetcherError)('emptyFileName', {
                    id: fileState.id
                })));
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                });
            }
            if (fileState.status === 'processed') fireSucceededOperationalEvent();
        }
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $93R6D.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7FDta.InlineImageCard), {
            dimensions: dimensions,
            identifier: identifier,
            renderError: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $71iJ2.InlineImageCardErrorView), {
                    message: formatMessage((0, $2u6SE.messages).unableToLoadContent)
                }),
            alt: alt,
            ssr: ssr?.mode,
            isLazy: isLazy,
            crop: true,
            stretch: false
        }));
    };
    const aspectRatio = (0, $eJOHy.useMemo)(()=>width && height ? width / height : undefined, [
        width,
        height
    ]);
    /**
   * scaledDimensions is used to define the correct media size fetched from media service
   * inline images will only ever be rendered at a maximum height of H1 and so scaled dimensions
   * will only ever return a width and height where the height has a maximum height of H1
   */ const scaledDimension = (0, $eJOHy.useMemo)(()=>{
        if (!width || !height || !aspectRatio) return {
            width: width,
            height: height
        };
        return {
            width: Math.round(aspectRatio * (0, $hgI1e.referenceHeights)['h1']),
            height: (0, $hgI1e.referenceHeights)['h1']
        };
    }, [
        width,
        height,
        aspectRatio
    ]);
    const htmlAttributes = (0, $eJOHy.useMemo)(()=>{
        if (serializeDataAttrs) {
            const resolvedAttrs = fileState && fileState.status !== 'error' ? {
                'data-file-size': fileState.size,
                'data-file-mime-type': fileState.mimeType,
                'data-file-name': fileState.name
            } : {};
            return {
                'data-type': 'image',
                'data-node-type': 'mediaInline',
                'data-id': identifier.id,
                'data-collection': identifier.collectionName,
                'data-width': width,
                'data-height': height,
                'data-alt': alt,
                ...resolvedAttrs
            };
        }
        return {};
    }, [
        alt,
        fileState,
        height,
        identifier,
        width,
        serializeDataAttrs
    ]);
    const onMediaInlineImageClick = (0, $eJOHy.useCallback)((e)=>{
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
        // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
        // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
        // another URL if the media node is wrapped in a link mark.
        if (isViewOnly && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) e.preventDefault();
    }, [
        shouldOpenMediaViewer,
        isViewOnly
    ]);
    const onMediaInlinePreviewClose = (0, $eJOHy.useCallback)(()=>{
        setMediaViewerVisible(false);
    }, []);
    const mediaViewer = (0, $eJOHy.useMemo)(()=>{
        if (isMediaViewerVisible && mediaClient?.mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).createPortal(/*#__PURE__*/ (0, $1NIU8.jsx)((0, $52iZC.default), {
            collectionName: identifier.collectionName || '',
            items: [
                identifier
            ],
            mediaClientConfig: mediaClient?.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaInlinePreviewClose
        }), document.body);
        return null;
    }, [
        identifier,
        isMediaViewerVisible,
        mediaClient?.mediaClientConfig,
        onMediaInlinePreviewClose
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cXjeN.InlineImageWrapper), {
        isSelected: isSelected,
        aspectRatio: aspectRatio,
        borderColor: border?.borderColor,
        borderSize: border?.borderSize,
        htmlAttrs: htmlAttributes,
        onClick: onMediaInlineImageClick
    }, content(scaledDimension)), mediaViewer);
};
const $1ce01a8e27c54526$export$fca833ae4278270f = (0, $6YFG2.default)($1ce01a8e27c54526$export$5d2cd1bea8591ba3, {
    enforceContext: false
});

});
parcelRegister("fhbkk", function(module, exports) {
$parcel$export(module.exports, "getSucceededStatusPayload", () => $fc8abd8d5aaead0b$export$95e48cf5f4b392a4);
$parcel$export(module.exports, "getErrorStatusPayload", () => $fc8abd8d5aaead0b$export$b37f976ad373d2e0);
$parcel$export(module.exports, "getFailedProcessingStatusPayload", () => $fc8abd8d5aaead0b$export$d0b5daf3b6a26055);
$parcel$export(module.exports, "fireFailedOperationalEvent", () => $fc8abd8d5aaead0b$export$d66a74eca3334206);
$parcel$export(module.exports, "fireSucceededOperationalEvent", () => $fc8abd8d5aaead0b$export$3bc90882cb04fda4);

var $dUG6w = parcelRequire("dUG6w");

var $1yWtS = parcelRequire("1yWtS");
const $fc8abd8d5aaead0b$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $fc8abd8d5aaead0b$export$b37f976ad373d2e0 = (fileId, error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            ...(0, $dUG6w.extractErrorInfo)(error)
        }
    };
};
const $fc8abd8d5aaead0b$export$d0b5daf3b6a26055 = (fileId, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing'
        }
    };
};
const $fc8abd8d5aaead0b$export$d66a74eca3334206 = (fileState, error = new (0, $1yWtS.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    const payload = failReason ? $fc8abd8d5aaead0b$export$d0b5daf3b6a26055(fileState?.id || 'unknown-id', fileState) : $fc8abd8d5aaead0b$export$b37f976ad373d2e0(fileState?.id || 'unknown-id', error, fileState);
    (0, $dUG6w.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $fc8abd8d5aaead0b$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $fc8abd8d5aaead0b$export$95e48cf5f4b392a4(fileState);
    (0, $dUG6w.fireMediaCardEvent)(payload, createAnalyticsEvent);
};

});

parcelRegister("2u6SE", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a6a633f8f2ba076f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $a6a633f8f2ba076f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unableToLoadContent: {
        id: 'fabric.editor.unableToLoadContent',
        defaultMessage: "We couldn't load this content",
        description: 'Display this message when there is an error loading file content'
    },
    failedToUpload: {
        id: 'fabric.editor.failed_to_upload',
        defaultMessage: 'Failed to upload',
        description: 'Display this message when there is an error uploading a file'
    }
});

});

parcelRegister("7FDta", function(module, exports) {
$parcel$export(module.exports, "InlineImageCard", () => $2153b1d1e8a88e8e$export$bb1dd14451154199);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3xaEP = parcelRequire("3xaEP");

var $iN7PZ = parcelRequire("iN7PZ");

var $eJ3rj = parcelRequire("eJ3rj");

var $jOuuz = parcelRequire("jOuuz");
const $2153b1d1e8a88e8e$export$bb1dd14451154199 = ({ dimensions: dimensions, identifier: identifier, renderError: renderError, alt: alt, isLazy: isLazy, ssr: ssr, crop: crop, stretch: stretch })=>{
    // Generate unique traceId for file
    const traceContext = (0, $eJOHy.useMemo)(()=>({
            traceId: (0, $3xaEP.getRandomHex)(8)
        }), []);
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO do we need to handle nonCriticalError
    const { preview: preview, error: previewError, onImageError: onImageError, onImageLoad: onImageLoad, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $iN7PZ.useFilePreview)({
        identifier: identifier,
        ssr: ssr,
        dimensions: dimensions,
        traceContext: traceContext
    });
    if (previewError) return renderError({
        error: previewError
    });
    if (!preview) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jOuuz.InlineImageCardLoadingView), null);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJ3rj.MediaImage), {
        dataURI: preview.dataURI,
        alt: alt,
        previewOrientation: preview.orientation,
        onImageLoad: ()=>{
            onImageLoad(preview);
        },
        onImageError: onImageError,
        loading: isLazy ? 'lazy' : undefined,
        forceSyncDisplay: !!ssr,
        crop: crop,
        stretch: stretch,
        ref: copyNodeRef
    }), getSsrScriptProps && /*#__PURE__*/ (0, $1NIU8.jsx)("script", getSsrScriptProps()));
};

});
parcelRegister("jOuuz", function(module, exports) {
$parcel$export(module.exports, "InlineImageCardLoadingView", () => $e52ee95dd819f1f5$export$4b1a62d8f05056a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7ep4S = parcelRequire("7ep4S");


var $gs8y9 = parcelRequire("gs8y9");
const $e52ee95dd819f1f5$export$4b1a62d8f05056a7 = ({ testId: testId = 'media-inline-image-card-loading-view', height: height = (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gs8y9.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7ep4S.default), {
        size: height > (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) ? 'medium' : 'small',
        interactionName: "media-inline-spinner"
    }));
};

});
/** Height threshold that determines icon size to be small or medium */ const $4cc10c9d7cf0f335$export$88e3664eef60c981 = 24;

parcelRegister("gs8y9", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $749039277bbba6eb$export$b89a827e9254211a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $h2bfU = parcelRequire("h2bfU");
const $749039277bbba6eb$export$b89a827e9254211a = ({ children: children, testId: testId })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: (0, $h2bfU.wrapperStyle),
        "data-testid": testId
    }, children);

});
parcelRegister("h2bfU", function(module, exports) {
$parcel$export(module.exports, "wrapperStyle", () => $fc77b29b684fca05$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $fc77b29b684fca05$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxDecorationBreak: 'clone',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    color: `${"var(--ds-text, #172B4D)"}`,
    backgroundColor: `${"var(--ds-background-neutral, #091E420F)"}`,
    transition: '0.1s all ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${"var(--ds-background-neutral-hovered, #091E4224)"}`
    }
});

});




parcelRegister("cXjeN", function(module, exports) {
$parcel$export(module.exports, "InlineImageWrapper", () => $d4bafcc76de9e7c0$export$8519fee8cc913056);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $9Ybet = parcelRequire("9Ybet");

var $dA9km = parcelRequire("dA9km");
function $d4bafcc76de9e7c0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// The MediaImage component needs to obtain its parent's dimensions.
// To achieve this, we have added an additional wrapper that allows
// for better interaction with the parent element. This is necessary
//  because the parent size changes its box-sizing with the node border.
const $d4bafcc76de9e7c0$var$sizeWrapperStyle = {
    name: "1ogmv4n",
    styles: "display:inline-flex;width:100%;height:100%"
};
const $d4bafcc76de9e7c0$export$8519fee8cc913056 = ({ children: children, isSelected: isSelected, aspectRatio: aspectRatio, borderSize: borderSize, borderColor: borderColor, htmlAttrs: htmlAttrs = {}, onClick: onClick })=>{
    const borderStyleVars = borderSize && borderColor ? {
        [(0, $dA9km.INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY)]: borderSize,
        [(0, $dA9km.INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY)]: (0, $9Ybet.hexToEditorBorderPaletteColor)(borderColor) || borderColor
    } : {};
    const aspectStyleVars = aspectRatio ? {
        [(0, $dA9km.INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY)]: aspectRatio
    } : {};
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...borderStyleVars,
            ...aspectStyleVars
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $dA9km.wrapperStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            borderSize && borderColor && (0, $dA9km.borderStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isSelected && (0, $dA9km.selectedStyle)
        ],
        "data-testid": "inline-image-wrapper",
        onClick: onClick,
        ...htmlAttrs
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $d4bafcc76de9e7c0$var$sizeWrapperStyle
    }, children)));
};

});

parcelRegister("71iJ2", function(module, exports) {
$parcel$export(module.exports, "InlineImageCardErrorView", () => $0e978e36eb47184d$export$cbdc50f98f4f8d00);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $jkYbX = parcelRequire("jkYbX");

var $k71qx = parcelRequire("k71qx");


var $gs8y9 = parcelRequire("gs8y9");

var $8wscQ = parcelRequire("8wscQ");
const $0e978e36eb47184d$export$cbdc50f98f4f8d00 = ({ testId: testId = 'media-inline-image-card-error-view', message: message, icon: icon, height: height = (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gs8y9.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: message,
        position: "top",
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8wscQ.IconWrapper), null, icon || /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        label: "error",
        LEGACY_size: height > (0, $4cc10c9d7cf0f335$export$88e3664eef60c981) ? 'medium' : 'small',
        color: "var(--ds-icon-danger, #C9372C)"
    }))));
};

});
parcelRegister("8wscQ", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $dd51a983eed3d150$export$be58b4326e23250f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $dd51a983eed3d150$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dd51a983eed3d150$var$wrapperStyle = {
    name: "1xutr1y",
    styles: "display:flex;span > svg{vertical-align:top;}"
};
const $dd51a983eed3d150$export$be58b4326e23250f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $dd51a983eed3d150$var$wrapperStyle,
        "data-testid": "media-inline-image-card-icon"
    }, children);
};

});



parcelRegister("gAeD7", function(module, exports) {
$parcel$export(module.exports, "default", () => $7756ce5e045a8803$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1dILD = parcelRequire("1dILD");

var $e2B2h = parcelRequire("e2B2h");



class $7756ce5e045a8803$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.displayName = 'MediaInlineCardLoader';
    }
    async componentDidMount() {
        this.mounted = true;
        if (!this.state.MediaInlineCard) try {
            const [mediaClient, cardModule, mediaInlineErrorBoundaryModule] = await Promise.all([
                (parcelRequire("8AqjI")),
                (parcelRequire("kfhdS")),
                (parcelRequire("eeXs7"))
            ]);
            $7756ce5e045a8803$export$2e2bcd8739ae039.MediaInlineCard = mediaClient.withMediaClient(cardModule.MediaInlineCard);
            $7756ce5e045a8803$export$2e2bcd8739ae039.ErrorBoundary = mediaInlineErrorBoundaryModule.default;
            if (this.mounted) this.setState({
                MediaInlineCard: $7756ce5e045a8803$export$2e2bcd8739ae039.MediaInlineCard,
                ErrorBoundary: $7756ce5e045a8803$export$2e2bcd8739ae039.ErrorBoundary
            });
        } catch (error) {}
    }
    async componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { MediaInlineCard: MediaInlineCard, ErrorBoundary: ErrorBoundary } = this.state;
        const analyticsContext = {
            packageVersion: "platform-pkg",
            packageName: "0.0.0-use.local",
            componentName: 'mediaInlineCard',
            component: 'mediaInlineCard'
        };
        if (!MediaInlineCard || !ErrorBoundary) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dILD.MediaInlineCardLoadingView), {
            message: ""
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: analyticsContext,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorBoundary, {
                isSelected: this.props.isSelected,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(MediaInlineCard, {
                    ...this.props
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            MediaInlineCard: $7756ce5e045a8803$export$2e2bcd8739ae039.MediaInlineCard,
            ErrorBoundary: $7756ce5e045a8803$export$2e2bcd8739ae039.ErrorBoundary
        };
    }
}

});
parcelRegister("1dILD", function(module, exports) {
$parcel$export(module.exports, "MediaInlineCardLoadingView", () => $d9d101fa7192f9b2$export$4449fcbb2ad61ad1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gPm7N = parcelRequire("gPm7N");

var $7ep4S = parcelRequire("7ep4S");

var $l31fP = parcelRequire("l31fP");

var $5ciG6 = parcelRequire("5ciG6");

var $j2rnC = parcelRequire("j2rnC");
class $d9d101fa7192f9b2$export$4449fcbb2ad61ad1 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { message: message, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, innerRef: innerRef, testId: testId = 'media-inline-card-loading-view' } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPm7N.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $j2rnC.IconTitleWrapper), {
                children: [
                    message,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.RightIconPositionWrapper), {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5ciG6.SpinnerWrapper), {
                            className: "inline-loading-spinner",
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                                size: 14
                            })
                        })
                    })
                ]
            })
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPm7N.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l31fP.IconAndTitleLayout), {
                title: message,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5ciG6.SpinnerWrapper), {
                    className: "inline-loading-spinner",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                        size: 14
                    })
                })
            })
        });
    }
}

});
parcelRegister("gPm7N", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $6c704da71263c31c$export$b89a827e9254211a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6Qiyl = parcelRequire("6Qiyl");
class $6c704da71263c31c$export$b89a827e9254211a extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isSelected: isSelected, children: children, onClick: onClick, innerRef: innerRef, testId: testId, isError: isError } = this.props;
        const isInteractive = Boolean(onClick);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Qiyl.Wrapper), {
            ref: innerRef,
            isSelected: isSelected,
            isError: isError,
            tabIndex: isInteractive ? 0 : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            "data-testid": testId,
            children: children
        });
    }
    constructor(...args){
        super(...args), this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        }, this.handleKeyPress = (event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}

});
parcelRegister("6Qiyl", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $4d86fdfdcd037721$export$e6dfd72ab29f8598);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $f2zWK = parcelRequire("f2zWK");

var $kH9TH = parcelRequire("kH9TH");

var $eGOwo = parcelRequire("eGOwo");
const $4d86fdfdcd037721$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kH9TH.Wrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f2zWK.Wrapper), {
        ...props,
        ref: ref
    }));

});
parcelRegister("f2zWK", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $2d6ca48d8599c26d$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $aWILV = parcelRequire("aWILV");
const $2d6ca48d8599c26d$var$selected = `
  cursor: pointer;
  box-shadow: 0 0 0 1px ${`var(--ds-border-selected, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`};
  outline: none;
  user-select: none;
  border-color: transparent;
  &, :hover, :focus, :active {
    text-decoration: none;
  }
`;
const $2d6ca48d8599c26d$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $2d6ca48d8599c26d$var$selected;
    else return 'user-select: text';
};
const $2d6ca48d8599c26d$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e1t1vqsr0"
})({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
    boxDecorationBreak: 'clone',
    display: 'inline',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$fbda843f0a27fe96)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>$2d6ca48d8599c26d$var$isSelected(props), {
    transition: '0.1s all ease-in-out',
    MozUserSelect: 'none',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isError && {
        backgroundColor: `var(--ds-background-danger, ${0, $7bb4c1736002a04a$export$4b84fd0e2c617bd})`,
        cursor: 'default',
        '&:hover': {
            backgroundColor: `var(--ds-background-danger, ${0, $7bb4c1736002a04a$export$4b84fd0e2c617bd})`
        }
    });

});

parcelRegister("kH9TH", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $4a20dcc0fc7797ca$export$e6dfd72ab29f8598);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4a20dcc0fc7797ca$var$selectedStyles = null;
const $4a20dcc0fc7797ca$var$notSelectedStyles = null;
const $4a20dcc0fc7797ca$var$errorStyles = null;
const $4a20dcc0fc7797ca$var$wrapperStyles = null;
const $4a20dcc0fc7797ca$export$e6dfd72ab29f8598 = ({ isSelected: isSelected, isError: isError, children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": "frame-wrapper",
        ...props,
        className: (0, $hcewu.default)([
            "_2rkofajl _v56415x0 _vwz47vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _16d9qvcn _1e0c1nu9 _syazj3m3 _bfhk155y _1rkwglyw _80omtlke _irr3u9me",
            isSelected && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d3acm _80omtlke _16qs1s9b _uiztglyw _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            !isSelected && "_uizt1kdv",
            isError && "_bfhktaeo _80om73ad _irr3taeo"
        ]),
        children: children
    });

});



parcelRegister("l31fP", function(module, exports) {
$parcel$export(module.exports, "IconAndTitleLayout", () => $4a09982d44befcac$export$d34be4d513116847);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2HNHt = parcelRequire("2HNHt");

var $aAlzy = parcelRequire("aAlzy");

var $j2rnC = parcelRequire("j2rnC");

var $av9Of = parcelRequire("av9Of");
class $4a09982d44befcac$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.EmojiWrapper), {
            children: emoji
        });
        if (!icon || typeof icon === 'string') return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconWrapper), {
            children: icon
        });
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
            src: url,
            loaded: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aAlzy.Icon), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "smart-link-icon",
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: errored
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconWrapper), {
            children: defaultIcon
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconWrapper), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                color: "currentColor",
                label: "link",
                LEGACY_size: "small",
                testId: `${testId}-default`
            })
        });
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, testId: testId = 'media-inline-card-icon-and-title' } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $j2rnC.IconTitleWrapper), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: titleColor ? {
                    color: titleColor
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconPositionWrapper), {
                        children: children || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j2rnC.IconEmptyWrapper), {}),
                                this.renderIcon(testId)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        "data-test-id": "title",
                        children: title
                    })
                ]
            })
        });
    }
}

});
parcelRegister("aAlzy", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $96d4786aad5cbd79$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $96d4786aad5cbd79$export$a201b065fc2e76a1);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $YR3FN = parcelRequire("YR3FN");

var $gbQOq = parcelRequire("gbQOq");

var $eGOwo = parcelRequire("eGOwo");
const $96d4786aad5cbd79$export$f04a61298a47a40f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gbQOq.Icon), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $YR3FN.Icon), {
        ...props
    });
const $96d4786aad5cbd79$export$a201b065fc2e76a1 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gbQOq.AKIconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $YR3FN.AKIconWrapper), {
        ...props
    });

});
parcelRegister("YR3FN", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $b89f5ef283d8dda8$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $b89f5ef283d8dda8$export$a201b065fc2e76a1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aWILV = parcelRequire("aWILV");
function $b89f5ef283d8dda8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b89f5ef283d8dda8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $aWILV.default)("img", {
    target: "ebf58rv1"
})({
    name: "1p42ivd",
    styles: "height:14px;width:14px;margin-right:var(--ds-space-050, 4px);border-radius:var(--ds-radius-xsmall, 2px);user-select:none;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$b89f5ef283d8dda8$export$f04a61298a47a40f.defaultProps = {
    alt: 'icon'
};
const $b89f5ef283d8dda8$export$a201b065fc2e76a1 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ebf58rv0"
})({
    name: "18dmqdk",
    styles: "margin-right:var(--ds-space-negative-025, -2px)"
});

});

parcelRegister("gbQOq", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $c1a7d8f879d0ef13$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $c1a7d8f879d0ef13$export$a201b065fc2e76a1);
/* Icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c1a7d8f879d0ef13$var$iconStyles = null;
const $c1a7d8f879d0ef13$export$f04a61298a47a40f = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        alt: alt || 'icon',
        ...props,
        className: (0, $hcewu.default)([
            "_2rkolb4i _4t3idlk8 _1bsbdlk8 _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    });
// Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// TODO: Replace this override with proper AtlasKit solution.
const $c1a7d8f879d0ef13$var$akIconWrapperStyles = null;
const $c1a7d8f879d0ef13$export$a201b065fc2e76a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_2hwx1i6y"
        ]),
        children: children
    });

});


parcelRegister("j2rnC", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $886d47d94cf849e3$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $886d47d94cf849e3$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $886d47d94cf849e3$export$c73a53738ef9e3f);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $886d47d94cf849e3$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $886d47d94cf849e3$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $886d47d94cf849e3$export$ddce81e032b0736e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fgqnC = parcelRequire("fgqnC");

var $fJTWk = parcelRequire("fJTWk");

var $eGOwo = parcelRequire("eGOwo");
const $886d47d94cf849e3$export$be58b4326e23250f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$e31a6cc0a4c97f0e = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.EmojiWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.EmojiWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$c73a53738ef9e3f = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconTitleWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconTitleWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$75180efdd3f4d9c2 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.LozengeWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.LozengeWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$a16269f205a2f280 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.LozengeBlockWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.LozengeBlockWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$91b164375b8037b5 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.RightIconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.RightIconPositionWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$7291f9f954790243 = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconPositionWrapper), {
        ...props
    });
const $886d47d94cf849e3$export$ddce81e032b0736e = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fJTWk.IconEmptyWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fgqnC.IconEmptyWrapper), {
        ...props
    });

});
parcelRegister("fgqnC", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $074dc70059ec90b0$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $074dc70059ec90b0$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $074dc70059ec90b0$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $074dc70059ec90b0$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $074dc70059ec90b0$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $074dc70059ec90b0$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $074dc70059ec90b0$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $074dc70059ec90b0$export$ddce81e032b0736e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aWILV = parcelRequire("aWILV");
function $074dc70059ec90b0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $074dc70059ec90b0$export$b993aa7bab57be12 = `
  & > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 14px;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $074dc70059ec90b0$export$ded9fa9f58c8840e = `
  & > * > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $074dc70059ec90b0$export$be58b4326e23250f = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts57"
})("user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$b993aa7bab57be12);
const $074dc70059ec90b0$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts56"
})("display:inline-block;margin-right:var(--ds-space-025, 2px);user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$074dc70059ec90b0$export$b993aa7bab57be12);
const $074dc70059ec90b0$export$c73a53738ef9e3f = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts55"
})({
    name: "1h3cbh4",
    styles: "white-space:pre-wrap;word-break:break-all"
});
const $074dc70059ec90b0$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts54"
})({
    display: 'inline-block',
    verticalAlign: '1px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $074dc70059ec90b0$export$a16269f205a2f280 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts53"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $074dc70059ec90b0$export$91b164375b8037b5 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts52"
})({
    name: "1v89jht",
    styles: "margin-left:var(--ds-space-025, 2px);margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $074dc70059ec90b0$export$7291f9f954790243 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts51"
})({
    name: "166gprz",
    styles: "margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $074dc70059ec90b0$export$ddce81e032b0736e = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "ec5pts50"
})({
    name: "vehdi",
    styles: "width:14px;height:100%;display:inline-block;opacity:0"
});

});

parcelRegister("fJTWk", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $fc17436d07b7b030$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $fc17436d07b7b030$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $fc17436d07b7b030$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $fc17436d07b7b030$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $fc17436d07b7b030$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $fc17436d07b7b030$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $fc17436d07b7b030$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $fc17436d07b7b030$export$ddce81e032b0736e);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fc17436d07b7b030$var$iconObjectOverrideStyles = null;
// TODO: remove this override behaviour for @atlaskit/icon
const $fc17436d07b7b030$var$iconOverrideStyles = null;
const $fc17436d07b7b030$var$iconWrapperStyles = null;
const $fc17436d07b7b030$export$be58b4326e23250f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$emojiWrapperStyles = null;
const $fc17436d07b7b030$export$e31a6cc0a4c97f0e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$iconTitleWrapperStyles = null;
const $fc17436d07b7b030$export$c73a53738ef9e3f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_o5721jtm _1nmz9jpi"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$lozengeWrapperStyles = null;
const $fc17436d07b7b030$export$75180efdd3f4d9c2 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$lozengeBlockWrapperStyles = null;
const $fc17436d07b7b030$export$a16269f205a2f280 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$rightIconPositionWrapperStyles = null;
const $fc17436d07b7b030$export$91b164375b8037b5 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_18u0v77o _2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$iconPositionWrapperStyles = null;
const $fc17436d07b7b030$export$7291f9f954790243 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $fc17436d07b7b030$var$iconEmptyWrapperStyles = null;
const $fc17436d07b7b030$export$ddce81e032b0736e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_1bsbdlk8 _4t3i1osq _1e0c1o8l _tzy4idpf"
        ]),
        children: children
    });

});



parcelRegister("5ciG6", function(module, exports) {
$parcel$export(module.exports, "SpinnerWrapper", () => $50909b30725a64a2$export$52b4dfd89a6b3a1b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4pVLY = parcelRequire("4pVLY");

var $46TX0 = parcelRequire("46TX0");

var $eGOwo = parcelRequire("eGOwo");
const $50909b30725a64a2$export$52b4dfd89a6b3a1b = (props)=>(0, $eGOwo.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46TX0.SpinnerWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4pVLY.SpinnerWrapper), {
        ...props
    });

});
parcelRegister("4pVLY", function(module, exports) {
$parcel$export(module.exports, "SpinnerWrapper", () => $cbdd9d686d2b8174$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $fgqnC = parcelRequire("fgqnC");

var $aWILV = parcelRequire("aWILV");
function $cbdd9d686d2b8174$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cbdd9d686d2b8174$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $aWILV.default)((0, $fgqnC.IconTitleWrapper), {
    target: "e9a5khx0"
})({
    name: "1hde2gn",
    styles: "vertical-align:baseline;margin-left:var(--ds-space-025, 2px)"
});

});

parcelRegister("46TX0", function(module, exports) {
$parcel$export(module.exports, "SpinnerWrapper", () => $f3d89c2e8c2ae7e2$export$52b4dfd89a6b3a1b);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f3d89c2e8c2ae7e2$var$spinnerWrapperStyles = null;
const $f3d89c2e8c2ae7e2$export$52b4dfd89a6b3a1b = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props,
        className: (0, $hcewu.default)([
            "_o5721jtm _1nmz9jpi _s7n418uv _18u0v77o"
        ]),
        children: children
    });

});



parcelRegister("8AqjI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lrf77").then(()=>parcelRequire('bJDDe'));

});

parcelRegister("kfhdS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dxftE").then(()=>parcelRequire('1I6Li'));

});

parcelRegister("eeXs7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8WIWL").then(()=>parcelRequire('04V4O'));

});



parcelRegister("5KYHN", function(module, exports) {
$parcel$export(module.exports, "default", () => $1056964a4a2008d5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $jYx9G = parcelRequire("jYx9G");
var $2bEPZ = parcelRequire("2bEPZ");

var $7yBx7 = parcelRequire("7yBx7");

var $fNh22 = parcelRequire("fNh22");

var $eGOwo = parcelRequire("eGOwo");


var $e2m7L = parcelRequire("e2m7L");

var $8dxEE = parcelRequire("8dxEE");
function $1056964a4a2008d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1056964a4a2008d5$var$DEFAULT_WIDTH = 250;
const $1056964a4a2008d5$var$DEFAULT_HEIGHT = 200;
const $1056964a4a2008d5$var$uiMediaSingleBaseStyles = {
    name: "1a43hhz",
    styles: "transition:all 0.1s linear"
};
const $1056964a4a2008d5$var$uiMediaSingleLayoutStyles = {
    name: "1abqfmo",
    styles: "margin-left:50%;transform:translateX(-50%)"
};
const $1056964a4a2008d5$var$isMediaElement = (media)=>{
    if (!media) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { nodeType: nodeType, type: type } = media.props || {};
    // Use this to perform a rough check
    // better than assume the first item in children is media
    return nodeType === 'media' || [
        'external',
        'file',
        'link'
    ].indexOf(type) >= 0;
};
const $1056964a4a2008d5$var$checkForMediaElement = (children)=>{
    const [media] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (media && !$1056964a4a2008d5$var$isMediaElement(media) && media.props.children) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return $1056964a4a2008d5$var$checkForMediaElement(media.props.children);
    return media;
};
const $1056964a4a2008d5$export$507465eaf3c57f05 = (currentContainerWidth, layout)=>{
    if (!currentContainerWidth) // SSR mode fallback to default layout width
    switch(layout){
        case 'full-width':
            return 0, $7yBx7.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $7yBx7.akEditorWideLayoutWidth;
        default:
            return 0, $7yBx7.akEditorDefaultLayoutWidth;
    }
    return currentContainerWidth;
};
const $1056964a4a2008d5$var$MediaSingleWithChildren = (props)=>{
    const { rendererAppearance: rendererAppearance, featureFlags: featureFlags, isInsideOfBlockNode: isInsideOfBlockNode, layout: layout, width: widthAttr, widthType: widthType, allowCaptions: allowCaptions = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, media: media, caption: caption, editorAppearance: editorAppearance } = props;
    const [externalImageDimensions, setExternalImageDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        width: 0,
        height: 0
    });
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const onExternalImageLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ width: width, height: height })=>{
        setExternalImageDimensions({
            width: width,
            height: height
        });
    }, []);
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { width: width = $1056964a4a2008d5$var$DEFAULT_WIDTH, height: height = $1056964a4a2008d5$var$DEFAULT_HEIGHT, type: type } = media.props;
    if (type === 'external') {
        const { width: stateWidth, height: stateHeight } = externalImageDimensions;
        if (width === null) width = stateWidth || $1056964a4a2008d5$var$DEFAULT_WIDTH;
        if (height === null) height = stateHeight || $1056964a4a2008d5$var$DEFAULT_HEIGHT;
    }
    if (width === null) {
        width = $1056964a4a2008d5$var$DEFAULT_WIDTH;
        height = $1056964a4a2008d5$var$DEFAULT_HEIGHT;
    }
    const isFullPage = rendererAppearance === 'full-page';
    const isFullWidth = rendererAppearance === 'full-width';
    const padding = isFullPage ? (0, $9a762f515f769003$export$12fd658e5eef0d79) * 2 : 0;
    const calcDimensions = (0, $eJOHy.useCallback)((mediaContainerWidth)=>{
        const containerWidth = $1056964a4a2008d5$export$507465eaf3c57f05(mediaContainerWidth, layout);
        const maxWidth = (0, $fNh22.isSSR)() && widthAttr && typeof widthAttr === 'number' && (0, $eGOwo.fg)('platform_editor_fix_image_size_diff_during_ssr') ? Math.max(widthAttr, containerWidth) : containerWidth;
        const maxHeight = height / width * maxWidth;
        const cardDimensions = {
            width: `${maxWidth}px`,
            height: `${maxHeight}px`
        };
        let nonFullWidthSize = containerWidth;
        if (!isInsideOfBlockNode && rendererAppearance !== 'comment') {
            const isContainerSizeGreaterThanMaxFullPageWidth = containerWidth - padding >= (0, $7yBx7.akEditorDefaultLayoutWidth);
            if (isContainerSizeGreaterThanMaxFullPageWidth) nonFullWidthSize = (0, $7yBx7.akEditorDefaultLayoutWidth);
            else nonFullWidthSize = containerWidth - padding;
        }
        const minWidth = Math.min((0, $7yBx7.akEditorFullWidthLayoutWidth), containerWidth - padding);
        const lineLength = isFullWidth ? minWidth : nonFullWidthSize;
        return {
            cardDimensions: cardDimensions,
            lineLength: lineLength
        };
    }, [
        height,
        isFullWidth,
        isInsideOfBlockNode,
        layout,
        padding,
        rendererAppearance,
        width,
        widthAttr
    ]);
    const originalDimensions = (0, $eJOHy.useMemo)(()=>({
            width: width,
            height: height
        }), [
        height,
        width
    ]);
    const { setHoverTarget: setHoverTarget } = (0, $e2m7L.useAnnotationRangeDispatch)();
    const { cancelTimeout: cancelTimeout, initiateTimeout: initiateTimeout, setIsWithinRange: setIsWithinRange } = (0, $8dxEE.useAnnotationHoverDispatch)();
    const isFullPageRenderer = isFullPage || isFullWidth;
    (0, $eJOHy.useEffect)(()=>{
        const mediaSingleElement = ref.current;
        const handleMouseEnter = (event)=>{
            cancelTimeout();
            if (event.buttons === 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                setHoverTarget && setHoverTarget(event.target);
                setIsWithinRange(true);
            }
        };
        const handleMouseLeave = ()=>{
            initiateTimeout();
        };
        if (mediaSingleElement && isFullPageRenderer) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseenter', handleMouseEnter);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaSingleElement.addEventListener('mouseleave', handleMouseLeave);
        }
        return ()=>{
            if (mediaSingleElement && isFullPageRenderer) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseenter', handleMouseEnter);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                mediaSingleElement.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, [
        setHoverTarget,
        isFullPageRenderer,
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    // Note: in SSR mode the `window` object is not defined,
    // therefore width here is 0, see:
    // packages/editor/editor-common/src/ui/WidthProvider/index.tsx
    const { width: renderWidth } = (0, $eJOHy.useContext)((0, $2bEPZ.WidthContext));
    const containerWidth = $1056964a4a2008d5$export$507465eaf3c57f05(renderWidth, layout);
    const { cardDimensions: cardDimensions, lineLength: lineLength } = (0, $eJOHy.useMemo)(()=>calcDimensions(containerWidth), [
        calcDimensions,
        containerWidth
    ]);
    const renderMediaSingle = ()=>{
        const mediaComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(media, {
            resizeMode: 'stretchy-fit',
            cardDimensions: cardDimensions,
            originalDimensions: originalDimensions,
            onExternalImageLoaded: onExternalImageLoaded,
            disableOverlay: true,
            featureFlags: featureFlags,
            mediaSingleElement: ref.current
        });
        const uiMediaSingleStyles = layout === 'full-width' || layout === 'wide' ? [
            $1056964a4a2008d5$var$uiMediaSingleBaseStyles,
            $1056964a4a2008d5$var$uiMediaSingleLayoutStyles
        ] : [
            $1056964a4a2008d5$var$uiMediaSingleBaseStyles
        ];
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jYx9G.default), {
            css: uiMediaSingleStyles,
            handleMediaSingleRef: ref,
            layout: layout,
            width: width,
            height: height,
            lineLength: isInsideOfBlockNode ? containerWidth : lineLength,
            containerWidth: containerWidth,
            size: {
                width: widthAttr,
                widthType: widthType
            },
            fullWidthMode: isFullWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            dataAttributes: dataAttributes,
            editorAppearance: editorAppearance
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, mediaComponent), allowCaptions && caption);
    };
    return renderMediaSingle();
};
const $1056964a4a2008d5$var$MediaSingle = (props)=>{
    const { children: children } = props;
    let media;
    const [node, caption] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
    if (!$1056964a4a2008d5$var$isMediaElement(node)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mediaElement = $1056964a4a2008d5$var$checkForMediaElement(node.props.children);
        if (!mediaElement) return node;
        media = mediaElement;
    } else media = node;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $1NIU8.jsx)($1056964a4a2008d5$var$MediaSingleWithChildren, {
        ...props,
        media: media,
        caption: caption
    });
};
var $1056964a4a2008d5$export$2e2bcd8739ae039 = (0, $6YFG2.default)($1056964a4a2008d5$var$MediaSingle);

});


parcelRegister("7esWo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e21e95329b61c77$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $ioMWp = parcelRequire("ioMWp");

var $aEpcu = parcelRequire("aEpcu");

var $8nyI6 = parcelRequire("8nyI6");

var $2XJ8t = parcelRequire("2XJ8t");

var $6L7mA = parcelRequire("6L7mA");

var $glEdp = parcelRequire("glEdp");

var $7naaD = parcelRequire("7naaD");

var $LiaMl = parcelRequire("LiaMl");

var $MUFrj = parcelRequire("MUFrj");

var $lu3aG = parcelRequire("lu3aG");

var $dF4iL = parcelRequire("dF4iL");
/**
 * Synchronous renderer node mapping for "small" / simple nodes
 *
 * WARNING: This is an EXPERIMENTAL entry point and may change without notice in the future. Use it only at your own risk!
 *
 * Context: https://hello.atlassian.net/wiki/spaces/JIE/pages/5342146338 (Atlassian-internal)
 */ const $2e21e95329b61c77$var$nodeToReact = {
    codeBlock: (0, $ioMWp.default),
    date: (0, $aEpcu.default),
    decisionList: (0, $8nyI6.default),
    decisionItem: (0, $2XJ8t.default),
    emoji: (0, $6L7mA.default),
    mention: (0, $glEdp.default),
    panel: (0, $7naaD.default),
    status: (0, $LiaMl.default),
    taskItem: (0, $MUFrj.default),
    taskList: (0, $lu3aG.default),
    expand: (0, $dF4iL.default)
};
var $2e21e95329b61c77$export$2e2bcd8739ae039 = $2e21e95329b61c77$var$nodeToReact;

});
parcelRegister("ioMWp", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b61bebfdfa14986$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $gBkUB = parcelRequire("gBkUB");

var $JQPCf = parcelRequire("JQPCf");

var $brgNx = parcelRequire("brgNx");

var $393V9 = parcelRequire("393V9");
function $4b61bebfdfa14986$var$CodeBlock(props) {
    const { text: text, language: language, allowCopyToClipboard: allowCopyToClipboard = false, allowWrapCodeBlock: allowWrapCodeBlock = false, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, localId: localId } = props;
    const codeBidiWarningLabel = props.intl.formatMessage((0, $brgNx.codeBidiWarningMessages).label);
    const className = [
        (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
        props.className
    ].join(' ');
    const [wrapLongLines, setWrapLongLines] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $393V9.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        localId: localId,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $JQPCf.default), {
        testId: "renderer-code-block",
        language: language,
        text: text,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        shouldWrapLongLines: allowWrapCodeBlock && wrapLongLines
    }));
}
var $4b61bebfdfa14986$export$2e2bcd8739ae039 = (0, $6YFG2.default)($4b61bebfdfa14986$var$CodeBlock);

});
parcelRegister("JQPCf", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d29b310f5adcbb7$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4eDgu = parcelRequire("4eDgu");

var $bRPNB = parcelRequire("bRPNB");

var $1wVTG = parcelRequire("1wVTG");

var $gvE0s = parcelRequire("gvE0s");

var $2qMvj = parcelRequire("2qMvj");

var $9LvmA = parcelRequire("9LvmA");
const $9d29b310f5adcbb7$var$getCodeBlockStyles = {
    root: "_2rko12b0 _1dqoglyw _1wyb1crf _k48pi7a9 _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhktkvp _syaz1fxt _ect41odn _1ozdn7od _7xinn7od _t7aun7od _r28du2gc _tajqu2gc _1ohiu2gc _m802u2gc _i6ntu2gc _1w2xu2gc _1hmyegat _vblregat _vbulegat _196q1j08 _1vbw1j08 _1v9c1j08 _1srn17d7 _18r6myb0 _vyvc1n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _ra6gww7y _13cdh2mm _1pp0126e _zvy9f705 _qcxof705 _qzn01a66 _j0l11wug _1weckb7n _1na21hna _vsnzgrf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909m7j4 _scgayz1z _ipl81e17 _40uk1l04 _i81p1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _pyovu2gc _ccm6u2gc _1ascu2gc _1yuau2gc _xr0w1a66 _4io21a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgcpf9b _bu7zpf9b _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t361fxt _137bh55r _1k7d1fxt _97lipnps _12nh9lu1 _1g0517qg _i2ig10m5 _326z1fxt _113p131l _1n6tpnps _tgu817qg _1k47pnps _g0lx1fxt _ys4e131l _7gp8h55r _1yvq10m5 _1vww10m5 _1rju10m5 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o610m5 _kxov17qg _1np517qg _m2f517qg _1b9tpnps _1tq6pnps _1rd2pnps _1pbkpnps _k3lipnps _13zt131l _2g12fb2s _k86b10m5 _b5iy131l _gti3131l _1f0gpnps _9d3e17qg _qdiapnps _72uvpnps",
    showLineNumbers: "_170714ej _1i3h1txw _16noidpf _h4fuidpf _pp6yidpf _1g4tidpf _11wmidpf _1bx8idpf",
    dontShowLineNumbers: "_1i3h1ule _16nou2gc _h4fuu2gc _pp6yu2gc _1g4tu2gc _11wmu2gc _1bx8u2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $9d29b310f5adcbb7$var$CodeBlock = /*#__PURE__*/ (0, $eJOHy.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $eJOHy.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $eJOHy.useState)(false);
    // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $gvE0s.getLineNumWidth)(numLines) : 0;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $eJOHy.useEffect)(()=>{
        const schedule = (0, $bRPNB.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $4eDgu.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $1wVTG.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $eJOHy.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $eJOHy.useMemo)(()=>(0, $2qMvj.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9LvmA.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $hcewu.default)([
            $9d29b310f5adcbb7$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $9d29b310f5adcbb7$var$getCodeBlockStyles.shouldWrapLongLines : $9d29b310f5adcbb7$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $9d29b310f5adcbb7$var$getCodeBlockStyles.showLineNumbers : $9d29b310f5adcbb7$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $9d29b310f5adcbb7$export$2e2bcd8739ae039 = $9d29b310f5adcbb7$var$CodeBlock;

});
parcelRegister("1wVTG", function(module, exports) {
$parcel$export(module.exports, "useHighlightLines", () => $118a07406fdcc42b$export$84415a200bdf33ed);

var $eJOHy = parcelRequire("eJOHy");
const $118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $118a07406fdcc42b$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $118a07406fdcc42b$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $eJOHy.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $eJOHy.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("gvE0s", function(module, exports) {
$parcel$export(module.exports, "getLineNumWidth", () => $505da49d0d7d5a0b$export$cb7aec0206b595d2);
const $505da49d0d7d5a0b$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

});

parcelRegister("2qMvj", function(module, exports) {
$parcel$export(module.exports, "normalizeLanguage", () => $aca27a94c0d64a9d$export$f38728011c178796);

var $LFmXM = parcelRequire("LFmXM");

var $236Qa = parcelRequire("236Qa");
const $aca27a94c0d64a9d$export$f38728011c178796 = (0, $LFmXM.default)((language)=>{
    if (!language) return '';
    const match = (0, $236Qa.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("236Qa", function(module, exports) {
$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $32521280e8fb1b12$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $32521280e8fb1b12$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("9LvmA", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cdbe531236814ef$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $2Csjy = parcelRequire("2Csjy");
var $5cdbe531236814ef$export$2e2bcd8739ae039 = (0, $2Csjy.default);

});
parcelRegister("2Csjy", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a371b7eb48e23c4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9JmNq = parcelRequire("9JmNq");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $1a371b7eb48e23c4$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $9JmNq.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $gt9Am.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $1a371b7eb48e23c4$var$asyncGenerator = $1a371b7eb48e23c4$var$generator({
    loader: ()=>(parcelRequire("1WK8s")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $1a371b7eb48e23c4$export$2e2bcd8739ae039 = $1a371b7eb48e23c4$var$asyncGenerator;

});
parcelRegister("9JmNq", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb3e56997f5681d6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $31Mrt = parcelRequire("31Mrt");

var $aRMho = parcelRequire("aRMho");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $bb3e56997f5681d6$var$Highlight = /*#__PURE__*/ (0, $eJOHy.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $31Mrt.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $aRMho.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $bb3e56997f5681d6$export$2e2bcd8739ae039 = $bb3e56997f5681d6$var$Highlight;

});
parcelRegister("31Mrt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad9006a9331ecad2$export$2e2bcd8739ae039);

var $iWzFr = parcelRequire("iWzFr");

var $8RUxU = parcelRequire("8RUxU");

var $26DGa = parcelRequire("26DGa");

var $f2iL7 = parcelRequire("f2iL7");
const $ad9006a9331ecad2$var$newLineRegex = /\n/g;
function $ad9006a9331ecad2$var$getNewLines(str) {
    return str.match($ad9006a9331ecad2$var$newLineRegex);
}
function $ad9006a9331ecad2$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $f2iL7.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $iWzFr.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $26DGa.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $ad9006a9331ecad2$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $8RUxU.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $8RUxU.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("iWzFr", function(module, exports) {
$parcel$export(module.exports, "default", () => $4195943504268cef$export$2e2bcd8739ae039);

var $8RUxU = parcelRequire("8RUxU");

var $cyPrZ = parcelRequire("cyPrZ");
function $4195943504268cef$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $8RUxU.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $cyPrZ.default)(lineNumber));
            return children;
        }
    };
}
var $4195943504268cef$export$2e2bcd8739ae039 = $4195943504268cef$var$createLineGenerator;

});
parcelRegister("8RUxU", function(module, exports) {
$parcel$export(module.exports, "default", () => $20548ef38714ae82$export$2e2bcd8739ae039);

var $cyPrZ = parcelRequire("cyPrZ");
function $20548ef38714ae82$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $cyPrZ.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $cyPrZ.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("cyPrZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $03d9e4c0cc14d81b$export$2e2bcd8739ae039);
function $03d9e4c0cc14d81b$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("26DGa", function(module, exports) {
$parcel$export(module.exports, "default", () => $380a054e11b3c43e$export$2e2bcd8739ae039);

var $8RUxU = parcelRequire("8RUxU");
function $380a054e11b3c43e$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $8RUxU.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $380a054e11b3c43e$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("f2iL7", function(module, exports) {
$parcel$export(module.exports, "default", () => $a951287c386786be$export$2e2bcd8739ae039);
function $a951287c386786be$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("aRMho", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ec570abb3fe649d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $JWUl7 = parcelRequire("JWUl7");
function $9ec570abb3fe649d$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $JWUl7.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("JWUl7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed639690821efdab$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hDNIq = parcelRequire("hDNIq");

var $2E9Su = parcelRequire("2E9Su");

var $a4ixf = parcelRequire("a4ixf");
function $ed639690821efdab$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $ed639690821efdab$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $2E9Su.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDNIq.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $a4ixf.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $ed639690821efdab$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("a4ixf", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0ac4ebb91026fe6$export$2e2bcd8739ae039);

var $JWUl7 = parcelRequire("JWUl7");
function $e0ac4ebb91026fe6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $JWUl7.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("1WK8s", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5sFLQ").then(()=>parcelRequire('5eKjD'));

});




parcelRegister("393V9", function(module, exports) {
$parcel$export(module.exports, "default", () => $92e5f697e9fa7fb8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $gBkUB = parcelRequire("gBkUB");

var $lPhtO = parcelRequire("lPhtO");
const $92e5f697e9fa7fb8$var$codeBlockStyleOverrides = /*#__PURE__*/ (0, $1NIU8.css)({
    tabSize: 4,
    backgroundColor: `var(--ds-surface-raised, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        opacity: 0,
        transition: 'opacity 0.2s ease 0s'
    },
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        button: {
            opacity: 1
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $gBkUB.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5rem',
        backgroundImage: `linear-gradient(
			to right,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to left,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			)`,
        backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
        backgroundPosition: '0 0, 0 0, 100% 0, 100% 0, 100% 0, 100% 0, 0 0, 0 0'
    }
});
const $92e5f697e9fa7fb8$var$CodeBlockContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, children: children, className: className, localId: localId, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-local-id": localId,
        css: $92e5f697e9fa7fb8$var$codeBlockStyleOverrides
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lPhtO.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }), children);
};
var $92e5f697e9fa7fb8$export$2e2bcd8739ae039 = $92e5f697e9fa7fb8$var$CodeBlockContainer;

});
parcelRegister("lPhtO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6a7be88d7acaf4d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $iCiOj = parcelRequire("iCiOj");

var $aI5uR = parcelRequire("aI5uR");

const $c6a7be88d7acaf4d$var$codeBlockButtonsWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'sticky',
    top: '0px',
    background: `${`var(--ds-surface, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`}`
});
const $c6a7be88d7acaf4d$var$codeBlockButtonsStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    height: '0',
    width: '100%',
    right: "var(--ds-space-075, 6px)",
    top: "var(--ds-space-050, 4px)",
    padding: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        height: '32px',
        width: '32px',
        border: `${"var(--ds-border-width-selected, 2px)"} solid ${`var(--ds-border, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`}`,
        borderRadius: "var(--ds-radius-small, 4px)",
        marginLeft: "var(--ds-space-050, 4px)",
        padding: "var(--ds-space-025, 2px)",
        background: `${`var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`}`,
        color: `${"var(--ds-icon, rgb(66, 82, 110))"}`,
        '&:hover': {
            borderWidth: "var(--ds-border-width-selected, 2px)",
            backgroundColor: `${`var(--ds-surface-overlay-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`}`,
            height: '32px',
            width: '32px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.clicked': {
            backgroundColor: `${`var(--ds-background-neutral-bold-pressed, ${(0, $7bb4c1736002a04a$export$ad0bacf983b7ddaa)})`}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${`var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`} !important`
        }
    }
});
const $c6a7be88d7acaf4d$var$CodeBlockButtonContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $c6a7be88d7acaf4d$var$codeBlockButtonsWrapper
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $c6a7be88d7acaf4d$var$codeBlockButtonsStyle
    }, allowWrapCodeBlock && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aI5uR.default), {
        setWrapLongLines: setWrapLongLines,
        wrapLongLines: wrapLongLines
    }), allowCopyToClipboard && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $iCiOj.default), {
        content: text
    })));
};
var $c6a7be88d7acaf4d$export$2e2bcd8739ae039 = $c6a7be88d7acaf4d$var$CodeBlockButtonContainer;

});
parcelRegister("iCiOj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b33990a57461daa1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $abjs4 = parcelRequire("abjs4");

var $ehejR = parcelRequire("ehejR");

var $4TA31 = parcelRequire("4TA31");

var $k71qx = parcelRequire("k71qx");

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $bdjbf = parcelRequire("bdjbf");

var $ex5uO = parcelRequire("ex5uO");

var $hhRpb = parcelRequire("hhRpb");
const $b33990a57461daa1$var$CopyButton = ({ content: content, intl: intl })=>{
    const [tooltip, setTooltip] = (0, $eJOHy.useState)(intl.formatMessage((0, $ehejR.codeBlockButtonMessages).copyCodeToClipboard));
    const [className, setClassName] = (0, $eJOHy.useState)('copy-to-clipboard');
    const onMouseLeave = ()=>{
        setTooltip(intl.formatMessage((0, $ehejR.codeBlockButtonMessages).copyCodeToClipboard));
        setClassName('copy-to-clipboard');
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bdjbf.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $1NIU8.jsx)("span", null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
            content: tooltip,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            onMouseLeave: onMouseLeave
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $abjs4.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": tooltip,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4TA31))), {
                label: tooltip
            }),
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'.
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $ex5uO.ACTION).CLICKED,
                    actionSubject: (0, $ex5uO.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $ex5uO.ACTION_SUBJECT_ID).CODEBLOCK_COPY,
                    eventType: (0, $ex5uO.EVENT_TYPE).UI
                });
                (0, $hhRpb.copyTextToClipboard)(content);
                setTooltip(intl.formatMessage((0, $ehejR.codeBlockButtonMessages).copiedCodeToClipboard));
                setClassName('copy-to-clipboard clicked');
                event.stopPropagation();
            },
            spacing: "compact"
        })))));
};
var $b33990a57461daa1$export$2e2bcd8739ae039 = (0, $6YFG2.default)($b33990a57461daa1$var$CopyButton);

});

parcelRegister("aI5uR", function(module, exports) {
$parcel$export(module.exports, "default", () => $96c99907faa2d78c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $abjs4 = parcelRequire("abjs4");

var $ehejR = parcelRequire("ehejR");

var $fL0In = parcelRequire("fL0In");

var $k71qx = parcelRequire("k71qx");

var $bdjbf = parcelRequire("bdjbf");

var $ex5uO = parcelRequire("ex5uO");
const $96c99907faa2d78c$var$WrapIcon = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("g", {
        fill: "currentColor",
        clipPath: "url(#clip0_654_431)"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("path", {
        d: "M20 4h-1v16h1V4ZM3 8a1 1 0 0 1 1-1h9.5a4.5 4.5 0 1 1 0 9h-2.086l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H13.5a2.5 2.5 0 0 0 0-5H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    })));
};
const $96c99907faa2d78c$var$CodeBlockWrapButton = ({ setWrapLongLines: setWrapLongLines, wrapLongLines: wrapLongLines, intl: intl })=>{
    const wrapMessage = intl.formatMessage(wrapLongLines ? (0, $ehejR.codeBlockButtonMessages).unwrapCode : (0, $ehejR.codeBlockButtonMessages).wrapCode);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bdjbf.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $1NIU8.jsx)("span", null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
            content: wrapMessage,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $abjs4.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": wrapMessage,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `wrap-code ${wrapLongLines ? 'clicked' : ''}`,
            iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fL0In.default), {
                glyph: $96c99907faa2d78c$var$WrapIcon,
                label: ""
            }),
            isSelected: wrapLongLines,
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $ex5uO.ACTION).CLICKED,
                    actionSubject: (0, $ex5uO.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $ex5uO.ACTION_SUBJECT_ID).CODEBLOCK_WRAP,
                    attributes: {
                        wrapped: !wrapLongLines
                    },
                    eventType: (0, $ex5uO.EVENT_TYPE).UI
                });
                setWrapLongLines(!wrapLongLines);
                event.stopPropagation();
            },
            spacing: "compact"
        }))));
};
var $96c99907faa2d78c$export$2e2bcd8739ae039 = (0, $6YFG2.default)($96c99907faa2d78c$var$CodeBlockWrapButton);

});




parcelRegister("aEpcu", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf37206f694b28ff$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fDsDd = parcelRequire("fDsDd");

var $dZ5Iy = parcelRequire("dZ5Iy");

var $6YFG2 = parcelRequire("6YFG2");

var $51MtK = parcelRequire("51MtK");

var $8KqmO = parcelRequire("8KqmO");
const $bf37206f694b28ff$var$Date = /*#__PURE__*/ (0, $eJOHy.memo)(function Date(props) {
    const inlineAnnotationProps = (0, $8KqmO.useInlineAnnotationProps)(props);
    const { timestamp: timestamp, parentIsIncompleteTask: parentIsIncompleteTask, intl: intl } = props;
    const className = !!parentIsIncompleteTask && (0, $dZ5Iy.isPastDate)(timestamp) ? 'date-node date-node-highlighted' : 'date-node';
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fDsDd.DateSharedCssClassName).DATE_WRAPPER,
        ...inlineAnnotationProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-node-type": "date",
            "data-timestamp": timestamp,
            children: parentIsIncompleteTask ? (0, $dZ5Iy.timestampToTaskContext)(timestamp, intl) : (0, $dZ5Iy.timestampToString)(timestamp, intl)
        })
    });
});
const $bf37206f694b28ff$export$19285a5b05c4ea7c = (0, $6YFG2.default)($bf37206f694b28ff$var$Date);
function $bf37206f694b28ff$var$DateWithFormatContext(props) {
    const [isChecked] = (0, $51MtK.useTaskItemsFormatContext)();
    let parentIsIncompleteTask = props.parentIsIncompleteTask;
    if (typeof isChecked !== 'undefined') parentIsIncompleteTask = !isChecked;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)($bf37206f694b28ff$export$19285a5b05c4ea7c, {
        ...props,
        parentIsIncompleteTask: parentIsIncompleteTask
    });
}
var $bf37206f694b28ff$export$2e2bcd8739ae039 = $bf37206f694b28ff$var$DateWithFormatContext;

});
parcelRegister("dZ5Iy", function(module, exports) {
$parcel$export(module.exports, "timestampToUTCDate", () => $588f444e520afb69$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $588f444e520afb69$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $588f444e520afb69$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $588f444e520afb69$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $588f444e520afb69$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $588f444e520afb69$export$fbc04a9e57b04a80);

var $btz6U = parcelRequire("btz6U");

var $bf0oy = parcelRequire("bf0oy");
var $588f444e520afb69$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($588f444e520afb69$var$FORMATS || {});
const $588f444e520afb69$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $588f444e520afb69$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $588f444e520afb69$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $588f444e520afb69$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $588f444e520afb69$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $588f444e520afb69$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $588f444e520afb69$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$588f444e520afb69$var$addLeadingZero(date.getUTCMonth() + 1)}-${$588f444e520afb69$var$addLeadingZero(date.getUTCDate())}`;
};
const $588f444e520afb69$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $bf0oy.default)(new Date(Number(timestamp)), new Date(Number($588f444e520afb69$export$6297728405c48562())));
};
const $588f444e520afb69$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($588f444e520afb69$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $btz6U.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $588f444e520afb69$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $588f444e520afb69$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});

parcelRegister("51MtK", function(module, exports) {
$parcel$export(module.exports, "TaskItemsFormatProvider", () => $fe0ad539e8418b69$export$1ca88acfa8fef6b0);
$parcel$export(module.exports, "useTaskItemsFormatContext", () => $fe0ad539e8418b69$export$617439880b48c653);
$parcel$export(module.exports, "TaskItemsFormatConsumer", () => $fe0ad539e8418b69$export$be32c078f3ebeea0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $fe0ad539e8418b69$var$defaultValue = [
    undefined,
    ()=>{}
];
const $fe0ad539e8418b69$var$TaskItemsFormatContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($fe0ad539e8418b69$var$defaultValue);
const $fe0ad539e8418b69$var$reducer = (_state, action)=>{
    return action;
};
function $fe0ad539e8418b69$export$1ca88acfa8fef6b0({ children: children }) {
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useReducer($fe0ad539e8418b69$var$reducer, undefined);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($fe0ad539e8418b69$var$TaskItemsFormatContext.Provider, {
        value: value,
        children: children
    });
}
function $fe0ad539e8418b69$export$617439880b48c653() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($fe0ad539e8418b69$var$TaskItemsFormatContext);
}
function $fe0ad539e8418b69$export$be32c078f3ebeea0({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($fe0ad539e8418b69$var$TaskItemsFormatContext.Consumer, {
        children: children
    });
}

});


parcelRegister("8nyI6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7272273f0a960bf1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $69E4k = parcelRequire("69E4k");
class $7272273f0a960bf1$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const { children: children } = this.props;
        if ((0, $eJOHy.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $69E4k.default), {
            children: children
        });
    }
}

});
parcelRegister("69E4k", function(module, exports) {
$parcel$export(module.exports, "default", () => $d953788856e0e4a9$export$2e2bcd8739ae039);
/* DecisionList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
/*
	Increasing specificity with double ampersand to ensure these rules take
	priority over the global styles applied to 'ol' elements.
*/ const $d953788856e0e4a9$var$listStyles = null;
class $d953788856e0e4a9$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
        // Data attributes are required for copy and paste from rendered content
        // to the editor to preserve the decision.
        // This allows the editor to differentiate between numbered and ordered lists,
        // and action items, which all share the common `<li>` element.
        // The value of `data-decision-local-id` should be discarded upon paste, with a
        // a new uuid generated by the editor for the cloned content.
        return /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
            "data-decision-list-local-id": "",
            "data-node-type": "decisionList",
            className: (0, $hcewu.default)([
                "_1braglyw _1yxxidpf"
            ]),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child, idx)=>{
                const { localId: localId } = child.props;
                return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                    "data-decision-local-id": localId || '',
                    "data-decision-state": "DECIDED",
                    children: child
                }, idx);
            })
        });
    }
}

});


parcelRegister("2XJ8t", function(module, exports) {
$parcel$export(module.exports, "default", () => $930079dcdcf2ddcb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $CEjVk = parcelRequire("CEjVk");
function $930079dcdcf2ddcb$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEjVk.default), {
        dataAttributes: dataAttributes,
        children: children
    });
}

});
parcelRegister("CEjVk", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea95daa1bdf24abb$export$2e2bcd8739ae039);
/* DecisionItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $luDPF = parcelRequire("luDPF");

var $6BQTj = parcelRequire("6BQTj");
const $ea95daa1bdf24abb$var$iconStyles = null;
const $ea95daa1bdf24abb$var$iconStylesWithPlaceholder = null;
const $ea95daa1bdf24abb$var$DecisionItem = ({ appearance: appearance, children: children, contentRef: contentRef, placeholder: placeholder, showPlaceholder: showPlaceholder, dataAttributes: dataAttributes })=>{
    const icon = /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        contentEditable: false,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dlexct _4t3i7vkz _1bsb7vkz _19pk1b66 _2hwxutpp _otyridpf _18u0idpf _syaz1yjp _1e0c1txw _4cvr1h6o _1bah1h6o",
            showPlaceholder && "_syaz1oju"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($luDPF))), {
            label: "Decision",
            spacing: "spacious",
            color: "currentColor",
            LEGACY_size: "large"
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6BQTj.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "DECISION",
        dataAttributes: dataAttributes,
        children: children
    });
};
var $ea95daa1bdf24abb$export$2e2bcd8739ae039 = $ea95daa1bdf24abb$var$DecisionItem;

});
parcelRegister("luDPF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::09b32cb7d4442686961e5cde83b86b0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa5b4c2ffbdf39ba$var$_react = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fa5b4c2ffbdf39ba$var$_decision = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("kXFxs")));

var $fa5b4c2ffbdf39ba$var$_decision2 = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("fvh9f")));
function $fa5b4c2ffbdf39ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "EditorDecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa5b4c2ffbdf39ba$var$DecisionIcon = (props)=>/*#__PURE__*/ $fa5b4c2ffbdf39ba$var$_react.default.createElement($fa5b4c2ffbdf39ba$var$_decision.default, Object.assign({
        name: "DecisionIcon",
        LEGACY_fallbackIcon: $fa5b4c2ffbdf39ba$var$_decision2.default
    }, props));
$fa5b4c2ffbdf39ba$var$DecisionIcon.displayName = 'DecisionIconMigration';
var $fa5b4c2ffbdf39ba$var$_default = module.exports.default = $fa5b4c2ffbdf39ba$var$DecisionIcon;

});
parcelRegister("kXFxs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cf6befe44e2552b8aec07f847b9be00>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4298a06d23defad$var$_react = $f4298a06d23defad$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f4298a06d23defad$var$_baseNew = $f4298a06d23defad$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f4298a06d23defad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4298a06d23defad$var$DecisionIcon = (props)=>/*#__PURE__*/ $f4298a06d23defad$var$_react.default.createElement($f4298a06d23defad$var$_baseNew.default, Object.assign({
        name: "DecisionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$f4298a06d23defad$var$DecisionIcon.displayName = 'DecisionIcon';
var $f4298a06d23defad$var$_default = module.exports.default = $f4298a06d23defad$var$DecisionIcon;

});

parcelRegister("fvh9f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4970d82e75d8a32$var$_react = $b4970d82e75d8a32$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $b4970d82e75d8a32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b4970d82e75d8a32$var$EditorDecisionIcon = (props)=>/*#__PURE__*/ $b4970d82e75d8a32$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0"/></svg>`
    }, props));
$b4970d82e75d8a32$var$EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var $b4970d82e75d8a32$var$_default = module.exports.default = $b4970d82e75d8a32$var$EditorDecisionIcon;

});


parcelRegister("6BQTj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6d363850cec0944$export$2e2bcd8739ae039);
/* Item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b6d363850cec0944$var$placeholderStyles = null;
const $b6d363850cec0944$var$placeholderTaskStyles = null;
const $b6d363850cec0944$var$decisionStyles = null;
const $b6d363850cec0944$var$contentStyles = null;
const $b6d363850cec0944$var$taskStyles = null;
class $b6d363850cec0944$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            appearance: 'inline'
        };
    }
    renderPlaceholder() {
        const { children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, itemType: itemType } = this.props;
        if (!showPlaceholder || !placeholder || children) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            "data-testid": "task-decision-item-placeholder",
            "data-component": "placeholder",
            contentEditable: false,
            className: (0, $hcewu.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0tu8f _1reo15vq _18m915vq _kqswstnw _syaz131l _lcxvglyw _1bto1l2s _o5721q9c _p12f1dza",
                itemType === 'TASK' && "_19pkidpf _2hwxidpf _otyridpf _18u0hwpb"
            ]),
            children: placeholder
        });
    }
    renderMessageAppearance() {
        const { contentRef: contentRef, children: children, icon: icon, itemType: itemType, checkBoxId: checkBoxId, dataAttributes: dataAttributes } = this.props;
        if (itemType === 'TASK') return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            id: `${checkBoxId}-wrapper`,
            className: (0, $hcewu.default)([
                "_1e0c1txw _2lx2vrvc _kqswh2mm"
            ]),
            children: [
                icon,
                this.renderPlaceholder(),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    "data-component": "content",
                    ref: contentRef,
                    ...dataAttributes,
                    className: (0, $hcewu.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"
                    ]),
                    children: children
                })
            ]
        });
        else if (itemType === 'DECISION') return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            "data-testid": "elements-decision-item",
            "data-decision-wrapper": "true",
            className: (0, $hcewu.default)([
                "_2rkofajl _1e0c1txw _2lx2vrvc _19pku2gc _2hwxidpf _otyridpf _18u0idpf _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvutpp _bfhkm7j4 _kqswh2mm _14hd1wug"
            ]),
            children: [
                icon,
                this.renderPlaceholder(),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    "data-component": "content",
                    ref: contentRef,
                    ...dataAttributes,
                    className: (0, $hcewu.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1wug _slp31hna _1ul9idpf"
                    ]),
                    children: children
                })
            ]
        });
        return null;
    }
    render() {
        return this.renderMessageAppearance();
    }
}

});



parcelRegister("6L7mA", function(module, exports) {
$parcel$export(module.exports, "default", () => $d256ab20218572b8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");

var $4IKFn = parcelRequire("4IKFn");

var $eJOHy = parcelRequire("eJOHy");

var $1RDZV = parcelRequire("1RDZV");
var $4sxxB = parcelRequire("4sxxB");

var $8KqmO = parcelRequire("8KqmO");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $d256ab20218572b8$var$EmojiNode extends (0, $eJOHy.PureComponent) {
    static{
        this.displayName = 'EmojiNode';
    }
    static{
        this.defaultProps = {
            showTooltip: true
        };
    }
    constructor(props){
        super(props), this.renderWithProvider = (providers)=>{
            const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig } = this.props;
            if (allowTextFallback && !providers.emojiProvider) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                "data-emoji-id": id,
                "data-emoji-short-name": shortName,
                "data-emoji-text": fallback || shortName
            }, fallback || shortName);
            if (!providers.emojiProvider) return null;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4IKFn.default), {
                emojiId: {
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                },
                emojiProvider: providers.emojiProvider,
                showTooltip: showTooltip,
                fitToHeight: fitToHeight,
                optimistic: true,
                optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                }),
                editorEmoji: true,
                onEmojiLoadSuccess: resourceConfig?.onEmojiLoadSuccess,
                onEmojiLoadFail: resourceConfig?.onEmojiLoadFail
            });
        };
        this.providerFactory = props.providers || new (0, $1RDZV.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4sxxB.WithProviders), {
            providers: [
                'emojiProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}
function $d256ab20218572b8$var$EmojiItem(props) {
    const { id: id, providers: providers, shortName: shortName, text: text, fitToHeight: fitToHeight, resourceConfig: resourceConfig } = props;
    const inlineAnnotationProps = (0, $8KqmO.useInlineAnnotationProps)(props);
    if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", inlineAnnotationProps, /*#__PURE__*/ (0, $1NIU8.jsx)($d256ab20218572b8$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        resourceConfig: resourceConfig
    })));
    return /*#__PURE__*/ (0, $1NIU8.jsx)($d256ab20218572b8$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        resourceConfig: resourceConfig
    });
}
// Working around an issue with pre existing tests using react-test-renderer
// https://github.com/facebook/react/issues/17301#issuecomment-557765213
$d256ab20218572b8$var$EmojiItem.defaultProps = {};
var $d256ab20218572b8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($d256ab20218572b8$var$EmojiItem);

});
parcelRegister("4IKFn", function(module, exports) {
$parcel$export(module.exports, "default", () => $60846143e9fc24cc$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $htczl = parcelRequire("htczl");

var $b9cFG = parcelRequire("b9cFG");

var $8B8Wm = parcelRequire("8B8Wm");

var $8iUeU = parcelRequire("8iUeU");
const $60846143e9fc24cc$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $eJOHy.useEffect)(()=>{
        if (!emojiId) return;
        (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $8iUeU.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $8B8Wm.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b9cFG.UfoErrorBoundary), {
        experiences: [
            (0, $8B8Wm.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ],
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $htczl.ResourcedEmojiComponent), {
            ...props
        })
    });
};
var $60846143e9fc24cc$export$2e2bcd8739ae039 = $60846143e9fc24cc$var$ResourcedEmoji;

});
parcelRegister("htczl", function(module, exports) {
$parcel$export(module.exports, "ResourcedEmojiComponent", () => $b3a1b7c1097f467f$export$7bfde52eceb3e2f6);
/* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8iUeU = parcelRequire("8iUeU");

var $fqzOa = parcelRequire("fqzOa");

var $adGgK = parcelRequire("adGgK");

var $i4Ljn = parcelRequire("i4Ljn");

var $k8ZdJ = parcelRequire("k8ZdJ");

var $8B8Wm = parcelRequire("8B8Wm");

var $4FlMD = parcelRequire("4FlMD");

var $8B8Wm = parcelRequire("8B8Wm");
var $b3a1b7c1097f467f$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($b3a1b7c1097f467f$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $b3a1b7c1097f467f$export$7bfde52eceb3e2f6 = ({ emojiProvider: emojiProvider, emojiId: emojiId, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $8iUeU.defaultEmojiHeight), optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, placeholderXcss: placeholderXcss, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $eJOHy.useState)();
    const [loaded, setLoaded] = (0, $eJOHy.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $eJOHy.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $eJOHy.useState)();
    const fetchOrGetEmoji = (0, $eJOHy.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch);
        (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).mark((0, $adGgK.UfoEmojiTimings).METADATA_START);
        if ((0, $fqzOa.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                    // emoji is undefined
                    (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).mark((0, $adGgK.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).mark((0, $adGgK.UfoEmojiTimings).METADATA_END);
        }
    }, [
        onEmojiLoadFail
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $8B8Wm.hasUfoMarked)((0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId), (0, $adGgK.UfoEmojiTimings).FMP_END)) (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    (0, $eJOHy.useMemo)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
   * Setting resolved emoji provider for optimistic rendering
   */ (0, $eJOHy.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $eJOHy.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $eJOHy.useMemo)(()=>{
        if (optimisticImageURL) {
            if (emoji && ((0, $fqzOa.isImageRepresentation)(emoji.representation) || (0, $fqzOa.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $8iUeU.defaultEmojiHeight),
                    width: fitToHeight || (0, $8iUeU.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName
    ]);
    const handleOnLoadError = (0, $eJOHy.useCallback)((emojiId)=>{
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $8B8Wm.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail
    ]);
    const handleOnLoadSuccess = (0, $eJOHy.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4FlMD.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
            "data-emoji-id": id,
            "data-emoji-short-name": shortName,
            "data-emoji-text": fallback || shortName,
            "data-ssr-placeholder": `emoji-${id ?? shortName}`,
            "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`,
            children: [
                emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8ZdJ.default), {
                    shortName: shortName,
                    showTooltip: showTooltip,
                    size: fitToHeight || (0, $8iUeU.defaultEmojiHeight),
                    loading: true,
                    xcss: placeholderXcss
                }),
                emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                    children: customFallback || fallback || shortName
                }),
                emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i4Ljn.default), {
                    emoji: optimisticEmojiDescription,
                    onLoadError: handleOnLoadError,
                    onLoadSuccess: handleOnLoadSuccess,
                    showTooltip: showTooltip,
                    fitToHeight: fitToHeight,
                    autoWidth: !!emoji ? false : true,
                    editorEmoji: editorEmoji
                })
            ]
        })
    });
};
var $b3a1b7c1097f467f$export$2e2bcd8739ae039 = $b3a1b7c1097f467f$export$7bfde52eceb3e2f6;

});
parcelRegister("8iUeU", function(module, exports) {
$parcel$export(module.exports, "customCategory", () => $2c4fbc100f789f14$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $2c4fbc100f789f14$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $2c4fbc100f789f14$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $2c4fbc100f789f14$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $2c4fbc100f789f14$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $2c4fbc100f789f14$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $2c4fbc100f789f14$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $2c4fbc100f789f14$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $2c4fbc100f789f14$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $2c4fbc100f789f14$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $2c4fbc100f789f14$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $2c4fbc100f789f14$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $2c4fbc100f789f14$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $2c4fbc100f789f14$export$7722b8e9522021df);
$parcel$export(module.exports, "localStoragePrefix", () => $2c4fbc100f789f14$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $2c4fbc100f789f14$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $2c4fbc100f789f14$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $2c4fbc100f789f14$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $2c4fbc100f789f14$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $2c4fbc100f789f14$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $2c4fbc100f789f14$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $2c4fbc100f789f14$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $2c4fbc100f789f14$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $2c4fbc100f789f14$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $2c4fbc100f789f14$export$66cabad5e268b05e);
const $2c4fbc100f789f14$export$5e4e3d1c3e43156a = 'CUSTOM';
const $2c4fbc100f789f14$export$78ccdc4be403c468 = 'FREQUENT';
const $2c4fbc100f789f14$export$2c4b04c3aacdf1b3 = 'SITE';
const $2c4fbc100f789f14$export$1b0258512be88334 = 'SEARCH';
const $2c4fbc100f789f14$export$42b510423367f354 = 'USER_CUSTOM';
const $2c4fbc100f789f14$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $2c4fbc100f789f14$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $2c4fbc100f789f14$export$8ac325bfd32359b0 = 'data:';
const $2c4fbc100f789f14$export$a330961542edfe6f = 'delete-emoji';
const $2c4fbc100f789f14$export$1a817f1886276c6d = 100000;
const $2c4fbc100f789f14$export$3f99ac31dc0406db = 20;
const $2c4fbc100f789f14$export$d171dc12fee2b1da = 350;
const $2c4fbc100f789f14$export$c10ac8125a260041 = 80;
const $2c4fbc100f789f14$export$5248fb9e0cccc41f = 'medium';
const $2c4fbc100f789f14$export$94f75d625e7801d3 = 260;
const $2c4fbc100f789f14$export$7ed599d166d65aea = 295;
const $2c4fbc100f789f14$export$7722b8e9522021df = $2c4fbc100f789f14$export$7ed599d166d65aea - 58; // picker height - actions height
const $2c4fbc100f789f14$export$e218e5cb105a0e22 = 54;
const $2c4fbc100f789f14$export$e67f617938b111f1 = $2c4fbc100f789f14$export$7ed599d166d65aea + $2c4fbc100f789f14$export$e218e5cb105a0e22;
const $2c4fbc100f789f14$export$e394a0c530ae5631 = 'fabric.emoji';
const $2c4fbc100f789f14$export$79ee4ef84c545f8f = `${$2c4fbc100f789f14$export$e394a0c530ae5631}.selectedTone`;
const $2c4fbc100f789f14$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $2c4fbc100f789f14$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $2c4fbc100f789f14$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $2c4fbc100f789f14$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $2c4fbc100f789f14$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $2c4fbc100f789f14$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $2c4fbc100f789f14$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $2c4fbc100f789f14$export$4f0ee90b28d6efc5 = 0;
const $2c4fbc100f789f14$export$9f7de4293d27f3aa = 50;
const $2c4fbc100f789f14$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $2c4fbc100f789f14$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $2c4fbc100f789f14$export$2829f3ec323f8ec0 = 8;
const $2c4fbc100f789f14$export$ce3a0e7d2d7d6ba2 = 5;
const $2c4fbc100f789f14$export$858e8dc100a97278 = 150;
const $2c4fbc100f789f14$export$83aab2ae64548423 = 20;
const $2c4fbc100f789f14$export$66cabad5e268b05e = 100;

});

parcelRegister("fqzOa", function(module, exports) {
$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $23c7073f5fdbdf31$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $23c7073f5fdbdf31$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $23c7073f5fdbdf31$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $23c7073f5fdbdf31$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $23c7073f5fdbdf31$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $23c7073f5fdbdf31$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $23c7073f5fdbdf31$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $23c7073f5fdbdf31$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $23c7073f5fdbdf31$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $23c7073f5fdbdf31$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $23c7073f5fdbdf31$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $23c7073f5fdbdf31$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $23c7073f5fdbdf31$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $23c7073f5fdbdf31$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $23c7073f5fdbdf31$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $23c7073f5fdbdf31$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $23c7073f5fdbdf31$export$4bcbf61cb6832a8e);

var $2lSsS = parcelRequire("2lSsS");

var $8iUeU = parcelRequire("8iUeU");
const $23c7073f5fdbdf31$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $23c7073f5fdbdf31$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $23c7073f5fdbdf31$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $23c7073f5fdbdf31$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $23c7073f5fdbdf31$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $23c7073f5fdbdf31$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $23c7073f5fdbdf31$export$a7e82c67204c73a1 = (emoji)=>$23c7073f5fdbdf31$export$979133dc1df141c6(emoji.representation);
const $23c7073f5fdbdf31$export$7720a4954d6f75f8 = (rep)=>$23c7073f5fdbdf31$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $8iUeU.dataURLPrefix)) === 0;
const $23c7073f5fdbdf31$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $8iUeU.customCategory) && $23c7073f5fdbdf31$export$7720a4954d6f75f8(emoji.representation);
const $23c7073f5fdbdf31$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $23c7073f5fdbdf31$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $23c7073f5fdbdf31$export$dddfba07c16c94d2 = (key)=>key in (0, $2lSsS.messages);
const $23c7073f5fdbdf31$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $23c7073f5fdbdf31$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $23c7073f5fdbdf31$export$8d7d3de6b5b305d1(emoji);
};
const $23c7073f5fdbdf31$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $23c7073f5fdbdf31$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($23c7073f5fdbdf31$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $23c7073f5fdbdf31$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $23c7073f5fdbdf31$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $23c7073f5fdbdf31$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$23c7073f5fdbdf31$export$979133dc1df141c6(mediaRepresentation) && !$23c7073f5fdbdf31$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $23c7073f5fdbdf31$export$979133dc1df141c6(mediaRepresentation) ? $23c7073f5fdbdf31$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $23c7073f5fdbdf31$export$979133dc1df141c6(mediaAltRepresentation) ? $23c7073f5fdbdf31$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $23c7073f5fdbdf31$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $23c7073f5fdbdf31$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $23c7073f5fdbdf31$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("2lSsS", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8dae1054855c684a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8dae1054855c684a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status.count',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Atlassian & productivity',
        description: 'Emoji Atlassian & productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("adGgK", function(module, exports) {
$parcel$export(module.exports, "SearchSort", () => $a40ac3523e94d0b5$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $a40ac3523e94d0b5$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $a40ac3523e94d0b5$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $a40ac3523e94d0b5$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $a40ac3523e94d0b5$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $a40ac3523e94d0b5$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $a40ac3523e94d0b5$export$482549d945a3723);
var $a40ac3523e94d0b5$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $a40ac3523e94d0b5$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $a40ac3523e94d0b5$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $a40ac3523e94d0b5$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $a40ac3523e94d0b5$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $a40ac3523e94d0b5$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $a40ac3523e94d0b5$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("i4Ljn", function(module, exports) {
$parcel$export(module.exports, "EmojiNodeWrapper", () => $ce7d8292c0049cae$export$ce5eef59d8e46687);
$parcel$export(module.exports, "default", () => $ce7d8292c0049cae$export$2e2bcd8739ae039);
/* Emoji.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $cBxa0 = parcelRequire("cBxa0");

var $8iUeU = parcelRequire("8iUeU");

var $fqzOa = parcelRequire("fqzOa");

var $adGgK = parcelRequire("adGgK");

var $huLzh = parcelRequire("huLzh");

var $01aoY = parcelRequire("01aoY");


var $8B8Wm = parcelRequire("8B8Wm");
var $iVp1F = parcelRequire("iVp1F");

var $3PZQJ = parcelRequire("3PZQJ");

var $lXMGu = parcelRequire("lXMGu");

var $8B8Wm = parcelRequire("8B8Wm");

var $4g9mX = parcelRequire("4g9mX");

var $chAs1 = parcelRequire("chAs1");
const $ce7d8292c0049cae$var$emojiSpriteContainer = null;
const $ce7d8292c0049cae$var$emojiImageContainer = null;
const $ce7d8292c0049cae$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $8iUeU.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $huLzh.leftClick)(event)) onSelected((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleKeyDown = (props, event)=>{
    if (!(0, $8iUeU.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $8iUeU.KeyboardKeys).Enter || event.key === (0, $8iUeU.KeyboardKeys).Space)) onSelected((0, $fqzOa.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $8iUeU.KeyboardKeys).Backspace) $ce7d8292c0049cae$var$handleDelete(props, event);
};
const $ce7d8292c0049cae$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleDelete = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $fqzOa.toEmojiId)(emoji), emoji, event);
};
const $ce7d8292c0049cae$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $eb4c5e773f9bbee2$export$b06c4aab1d012063)} ${selected ? (0, $eb4c5e773f9bbee2$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $eb4c5e773f9bbee2$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) sizing = {
        width: `${fitToHeight}px`,
        height: `${fitToHeight}px`,
        minHeight: `${fitToHeight}px`,
        minWidth: `${fitToHeight}px`
    };
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$ce5eef59d8e46687, {
        ...props,
        type: "sprite",
        className: classes,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $eb4c5e773f9bbee2$export$1c10634420a08d8a),
            style: style
        })
    }));
};
const $ce7d8292c0049cae$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
    const [ref, inView] = (0, $lXMGu.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $8B8Wm.sampledUfoRenderedEmoji)(emoji);
    const classes = `${(0, $eb4c5e773f9bbee2$export$11462c0756c24ab6)} ${(0, $eb4c5e773f9bbee2$export$b06c4aab1d012063)} ${selected ? (0, $eb4c5e773f9bbee2$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $eb4c5e773f9bbee2$export$860109dfd198259b) : ''} ${(0, $eb4c5e773f9bbee2$export$da61cef1c8919f7c)} ${className ? className : ''} ${showDelete ? (0, $eb4c5e773f9bbee2$export$22b19c311e9caa4) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $cBxa0.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $fqzOa.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $fqzOa.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) // Presize image, to prevent reflow due to size changes after loading
    sizing = {
        // Size of <img> needs to be deterministic when rendered on server-side. Auto will cause width to be 0 before image is loaded.
        width: autoWidth && !(0, $chAs1.isSSR)() ? 'auto' : fitToHeight / height * width,
        height: fitToHeight
    };
    const onError = (0, $eJOHy.useCallback)((event)=>{
        $ce7d8292c0049cae$var$handleImageError(props, event);
    }, [
        props
    ]);
    const onLoad = (0, $eJOHy.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $adGgK.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $adGgK.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $3PZQJ.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $eJOHy.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!document.activeElement?.contains(e.target)) e.stopPropagation();
    }, []);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $eJOHy.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const emojiNode = /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        //@ts-ignore
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        alt: emoji.name || emoji.shortName,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }, src);
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4g9mX.DeletableEmojiTooltipContent), {}),
        position: "right-start",
        tag: "span",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)($ce7d8292c0049cae$export$ce5eef59d8e46687, {
            ...props,
            "aria-labelledby": `screenreader-emoji-${emoji.id}`,
            type: "image",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: classes,
            ref: ref,
            showTooltip: false,
            onMouseOver: onMouseOver,
            children: [
                emojiNode,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $01aoY.default), {
                    onClick: (event)=>$ce7d8292c0049cae$var$handleDelete(props, event)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4g9mX.DeletableEmojiTooltipContentForScreenReader), {
                    emoji: emoji
                })
            ]
        })
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$ce5eef59d8e46687, {
        ...props,
        type: "image",
        className: classes,
        ref: ref,
        children: emojiNode
    }));
};
const $ce7d8292c0049cae$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, ...other } = props;
    let accessibilityProps;
    if (editorEmoji) accessibilityProps = {
        role: undefined
    };
    else if (shouldBeInteractive) accessibilityProps = {
        role: 'button',
        'aria-label': emoji.shortName
    };
    else accessibilityProps = {
        role: 'img',
        'aria-label': emoji.shortName
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...accessibilityProps,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50scvx _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j14ae _3naf14ae _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc" : "_2rkofajl _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk18uv _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j14ae _3naf14ae _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc",
            className
        ]),
        onKeyDown: (event)=>$ce7d8292c0049cae$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $ce7d8292c0049cae$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $ce7d8292c0049cae$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $ce7d8292c0049cae$var$handleFocus(props, event);
        },
        title: showTooltip ? emoji.shortName : undefined,
        ...other,
        children: children
    });
});
const $ce7d8292c0049cae$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $iVp1F.useSampledUFOComponentExperience)((0, $8B8Wm.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $8iUeU.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $eJOHy.useEffect)(()=>{
        const ufoExp = (0, $8B8Wm.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $8B8Wm.hasUfoMarked)(ufoExp, (0, $adGgK.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $adGgK.UfoEmojiTimings).MOUNTED_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $fqzOa.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$ef49ddbb198ce334, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ce7d8292c0049cae$export$99dfeb9d71c11788, {
        ...props
    });
};
var $ce7d8292c0049cae$export$2e2bcd8739ae039 = $ce7d8292c0049cae$export$56cc48506ff790a;

});
parcelRegister("cBxa0", function(module, exports) {
$parcel$export(module.exports, "emojiRequest", () => $37cc264674c90168$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $37cc264674c90168$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $37cc264674c90168$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $37cc264674c90168$export$b7e9058f156d8d19);

var $kp3br = parcelRequire("kp3br");

var $fqzOa = parcelRequire("fqzOa");

var $32Nbx = parcelRequire("32Nbx");
const $37cc264674c90168$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $37cc264674c90168$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $37cc264674c90168$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $kp3br.utils).requestService(serviceConfig, requestOptions);
};
const $37cc264674c90168$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $37cc264674c90168$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $37cc264674c90168$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$37cc264674c90168$var$calculateScale($37cc264674c90168$export$d39ce20a37bba061).altScale];
};
const $37cc264674c90168$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $37cc264674c90168$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $fqzOa.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $fqzOa.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($37cc264674c90168$export$db05e6ae1fd416af(imagePath, meta)) return (0, $fqzOa.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $32Nbx.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $37cc264674c90168$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $37cc264674c90168$export$55077db3efc820aa($37cc264674c90168$export$4a0301d636367e1d(altReps), meta);
};
const $37cc264674c90168$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $37cc264674c90168$export$55077db3efc820aa(representation, meta),
            altRepresentation: $37cc264674c90168$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $37cc264674c90168$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $37cc264674c90168$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $37cc264674c90168$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $37cc264674c90168$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $fqzOa.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $37cc264674c90168$var$getHeight = (fitToHeight)=>$37cc264674c90168$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $37cc264674c90168$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $37cc264674c90168$var$getHeight(fitToHeight) > emoji.representation.height);

});
parcelRegister("kp3br", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("7Eo2D")).AbstractResource);
$parcel$export(module.exports, "utils", () => $6d8672354a8f8023$export$eab97d15b1788b8d);
parcelRequire("cVQsv");
parcelRequire("7Eo2D");

var $cT1cs = parcelRequire("cT1cs");

var $dyzJo = parcelRequire("dyzJo");
const $6d8672354a8f8023$export$eab97d15b1788b8d = $cT1cs;
const $6d8672354a8f8023$export$3b4c04cf7dad0e50 = $dyzJo;

});
parcelRegister("cVQsv", function(module, exports) {
$parcel$export(module.exports, "buildCredentials", () => $f9c5af0d8b1f4531$export$2ac26f1ab7eda637);
const $f9c5af0d8b1f4531$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("7Eo2D", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => $33168f42924c071f$export$4529f10aed0950d4);
class $33168f42924c071f$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("cT1cs", function(module, exports) {
$parcel$export(module.exports, "requestService", () => $8293192fd096fa7a$export$97bfde5a702aaeca);

var $fiPhB = parcelRequire("fiPhB");

var $eGOwo = parcelRequire("eGOwo");

var $4iJGP = parcelRequire("4iJGP");

var $cVQsv = parcelRequire("cVQsv");

var $2Ndb8 = parcelRequire("2Ndb8");
const $8293192fd096fa7a$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $2Ndb8.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2Ndb8.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2Ndb8.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $cVQsv.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $eGOwo.fg)('platform_collab_provider_tracingheaders');
    (0, $4iJGP.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $fiPhB.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $8293192fd096fa7a$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("2Ndb8", function(module, exports) {
$parcel$export(module.exports, "defaultRequestServiceOptions", () => $fdc006ca8b04950a$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $fdc006ca8b04950a$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $fdc006ca8b04950a$export$7d6ed858a91629c3);
const $fdc006ca8b04950a$export$160dbda113bfad3b = {};
const $fdc006ca8b04950a$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $fdc006ca8b04950a$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $fdc006ca8b04950a$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $fdc006ca8b04950a$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $fdc006ca8b04950a$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("dyzJo", function(module, exports) {
$parcel$export(module.exports, "requestServiceMultipart", () => $94befa78e14abede$export$8b13532c81e8ac89);

var $hCu6N = parcelRequire("hCu6N");

var $cVQsv = parcelRequire("cVQsv");

var $2Ndb8 = parcelRequire("2Ndb8");

var $eGOwo = parcelRequire("eGOwo");

var $4iJGP = parcelRequire("4iJGP");

var $fiPhB = parcelRequire("fiPhB");
const $94befa78e14abede$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $2Ndb8.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2Ndb8.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2Ndb8.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $cVQsv.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $eGOwo.fg)('platform_collab_provider_tracingheaders');
    (0, $4iJGP.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $fiPhB.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $hCu6N.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $94befa78e14abede$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("hCu6N", function(module, exports) {
$parcel$export(module.exports, "meros", () => $cd3d5734723579c0$export$74e0a034be2368c7);
var $cd3d5734723579c0$var$e = new TextDecoder;
async function $cd3d5734723579c0$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $cd3d5734723579c0$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});



parcelRegister("32Nbx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aab8f9e1de525a0$export$2e2bcd8739ae039);
let $9aab8f9e1de525a0$var$debugEnabled = false;
let $9aab8f9e1de525a0$var$stacktracesEnabled = false;
function $9aab8f9e1de525a0$export$748ada60eaf985cc(enable) {
    $9aab8f9e1de525a0$var$debugEnabled = enable;
}
function $9aab8f9e1de525a0$export$4f7017086af31c25(enable) {
    $9aab8f9e1de525a0$var$stacktracesEnabled = enable;
}
function $9aab8f9e1de525a0$export$2a858f450a2f66d() {
    if ($9aab8f9e1de525a0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $9aab8f9e1de525a0$export$2e2bcd8739ae039(msg, ...args) {
    if ($9aab8f9e1de525a0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});


parcelRegister("huLzh", function(module, exports) {
$parcel$export(module.exports, "leftClick", () => $730123a1a1d68375$export$34ebdaf2c517ae75);
function $730123a1a1d68375$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $730123a1a1d68375$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $730123a1a1d68375$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("01aoY", function(module, exports) {
$parcel$export(module.exports, "default", () => $485888db4a729b65$export$2e2bcd8739ae039);
/* DeleteButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $kXEdL = parcelRequire("kXEdL");


var $8iUeU = parcelRequire("8iUeU");


var $8IeH1 = parcelRequire("8IeH1");
const $485888db4a729b65$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $485888db4a729b65$var$deleteButton = null;
const $485888db4a729b65$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $485888db4a729b65$var$DeleteButton = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            (0, $eb4c5e773f9bbee2$export$b11fa39b56a371f6)
        ]),
        "data-testid": $485888db4a729b65$export$28fc7374cf1206d4,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $485888db4a729b65$var$styles.boxWrapperStyle,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXEdL))), {
                    label: (0, $8iUeU.deleteEmojiLabel),
                    color: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
                    LEGACY_size: "small",
                    size: "small"
                })
            }),
            onClick: props.onClick,
            // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
            appearance: "subtle-link",
            spacing: "none",
            testId: "emoji-delete-button",
            tabIndex: -1
        })
    });
var $485888db4a729b65$export$2e2bcd8739ae039 = $485888db4a729b65$var$DeleteButton;

});
const $eb4c5e773f9bbee2$export$8633a0edef8e95dd = 'emoji-common-selected';
const $eb4c5e773f9bbee2$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $eb4c5e773f9bbee2$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $eb4c5e773f9bbee2$export$b06c4aab1d012063 = 'emoji-common-node';
const $eb4c5e773f9bbee2$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $eb4c5e773f9bbee2$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $eb4c5e773f9bbee2$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $eb4c5e773f9bbee2$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $eb4c5e773f9bbee2$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $eb4c5e773f9bbee2$export$b0fe756d87022806 = 'emoji-picker-add-emoji';


parcelRegister("8B8Wm", function(module, exports) {
$parcel$export(module.exports, "ufoExperiences", () => $883d6eb80cdaaaf8$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $883d6eb80cdaaaf8$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $883d6eb80cdaaaf8$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $883d6eb80cdaaaf8$export$1466212a1606133);

var $adGgK = parcelRequire("adGgK");

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
var $2pMzV = parcelRequire("2pMzV");

var $jZzVI = parcelRequire("jZzVI");
const $883d6eb80cdaaaf8$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $aRnO1.ExperienceTypes).Load,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $883d6eb80cdaaaf8$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $aRnO1.ExperienceTypes).Experience,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
    };
};
const $883d6eb80cdaaaf8$var$customEmojiTimings = [
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $adGgK.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $adGgK.UfoEmojiTimings).METADATA_START,
        endMark: (0, $adGgK.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $adGgK.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $adGgK.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $adGgK.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $adGgK.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $adGgK.UfoEmojiTimings).ONLOAD_END
    }
];
const $883d6eb80cdaaaf8$export$615f888019c45765 = {
    'emoji-rendered': new (0, $9iIu4.ConcurrentExperience)((0, $adGgK.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $adGgK.UfoComponentName).EMOJI
        },
        type: (0, $aRnO1.ExperienceTypes).Operation,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).Custom,
        timings: $883d6eb80cdaaaf8$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $9iIu4.ConcurrentExperience)((0, $adGgK.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $883d6eb80cdaaaf8$var$createRenderExperience((0, $adGgK.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_PICKER_OPENED, $883d6eb80cdaaaf8$var$createRenderExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_SELECTION_RECORDED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_UPLOADED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_SEARCHED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER))
};
const $883d6eb80cdaaaf8$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $jZzVI.withSampling)($883d6eb80cdaaaf8$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $883d6eb80cdaaaf8$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $883d6eb80cdaaaf8$export$1466212a1606133 = (providerType)=>{
    return (0, $jZzVI.withSampling)($883d6eb80cdaaaf8$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("jZzVI", function(module, exports) {
$parcel$export(module.exports, "withSampling", () => $79a9e98a54aa22fe$export$dc2f0946255b3f89);
const $79a9e98a54aa22fe$export$c7c4959fece2f3ec = {};
const $79a9e98a54aa22fe$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($79a9e98a54aa22fe$export$c7c4959fece2f3ec))delete $79a9e98a54aa22fe$export$c7c4959fece2f3ec[prop];
};
const $79a9e98a54aa22fe$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $79a9e98a54aa22fe$var$hasSampledFromStart = (experience)=>{
    if (!$79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $79a9e98a54aa22fe$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id]) $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $79a9e98a54aa22fe$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("iVp1F", function(module, exports) {
$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $6912adc371031cc9$export$f959821a7419dee1);

var $eJOHy = parcelRequire("eJOHy");

var $jZzVI = parcelRequire("jZzVI");
const $6912adc371031cc9$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eJOHy.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $6912adc371031cc9$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            (0, $jZzVI.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $6912adc371031cc9$var$useConstructor(()=>{
        (0, $jZzVI.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("3PZQJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $99400fbc97a519f7$export$2e2bcd8739ae039);
const $99400fbc97a519f7$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $99400fbc97a519f7$var$result.mac = /Mac/.test(navigator.platform);
    $99400fbc97a519f7$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $99400fbc97a519f7$export$2e2bcd8739ae039 = $99400fbc97a519f7$var$result;

});

parcelRegister("lXMGu", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $3e5fc6b003616943$export$2f62ee6831462844);

var $1fvOh = parcelRequire("1fvOh");

var $3PZQJ = parcelRequire("3PZQJ");
const $3e5fc6b003616943$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $1fvOh.useInView)(options);
    if (!(0, $3PZQJ.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("1fvOh", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $0e8fddefcb6714fc$export$2f62ee6831462844);
$parcel$export(module.exports, "default", () => $0e8fddefcb6714fc$export$a62107ca74432f44);

var $eJOHy = parcelRequire("eJOHy");
function $0e8fddefcb6714fc$var$_extends() {
    $0e8fddefcb6714fc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e8fddefcb6714fc$var$_extends.apply(this, arguments);
}
function $0e8fddefcb6714fc$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $0e8fddefcb6714fc$var$_setPrototypeOf(subClass, superClass);
}
function $0e8fddefcb6714fc$var$_setPrototypeOf(o, p) {
    $0e8fddefcb6714fc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0e8fddefcb6714fc$var$_setPrototypeOf(o, p);
}
function $0e8fddefcb6714fc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0e8fddefcb6714fc$var$observerMap = new Map();
var $0e8fddefcb6714fc$var$RootIds = new WeakMap();
var $0e8fddefcb6714fc$var$rootId = 0;
var $0e8fddefcb6714fc$var$unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function $0e8fddefcb6714fc$export$2ef3a60ee1f37bec(inView) {
    $0e8fddefcb6714fc$var$unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $0e8fddefcb6714fc$var$getRootId(root) {
    if (!root) return '0';
    if ($0e8fddefcb6714fc$var$RootIds.has(root)) return $0e8fddefcb6714fc$var$RootIds.get(root);
    $0e8fddefcb6714fc$var$rootId += 1;
    $0e8fddefcb6714fc$var$RootIds.set(root, $0e8fddefcb6714fc$var$rootId.toString());
    return $0e8fddefcb6714fc$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function $0e8fddefcb6714fc$var$optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== undefined;
    }).map(function(key) {
        return key + "_" + (key === 'root' ? $0e8fddefcb6714fc$var$getRootId(options.root) : options[key]);
    }).toString();
}
function $0e8fddefcb6714fc$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = $0e8fddefcb6714fc$var$optionsToId(options);
    var instance = $0e8fddefcb6714fc$var$observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                }); // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $0e8fddefcb6714fc$var$observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function $0e8fddefcb6714fc$export$d1203567a167490e(element, callback, options, fallbackInView) {
    if (options === void 0) options = {};
    if (fallbackInView === void 0) fallbackInView = $0e8fddefcb6714fc$var$unsupportedValue;
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {};
    } // An observer with the same options can be reused, so lets use this fact
    var _createObserver = $0e8fddefcb6714fc$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements; // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $0e8fddefcb6714fc$var$observerMap["delete"](id);
        }
    };
}
var $0e8fddefcb6714fc$var$_excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function $0e8fddefcb6714fc$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ var $0e8fddefcb6714fc$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $0e8fddefcb6714fc$var$_inheritsLoose(InView, _React$Component);
    function InView(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                // Clear the old observer, before we start observing a new element
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            if (inView && _this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            _this.unobserve();
            if (!$0e8fddefcb6714fc$var$isPlainChildren(_this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        _this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
        this.node = null;
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
        this._unobserveCb = $0e8fddefcb6714fc$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        if (!$0e8fddefcb6714fc$var$isPlainChildren(this.props)) {
            var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = $0e8fddefcb6714fc$var$_objectWithoutPropertiesLoose(_this$props2, $0e8fddefcb6714fc$var$_excluded);
        return /*#__PURE__*/ $eJOHy.createElement(as || 'div', $0e8fddefcb6714fc$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}($eJOHy.Component);
$0e8fddefcb6714fc$export$a62107ca74432f44.displayName = 'InView';
$0e8fddefcb6714fc$export$a62107ca74432f44.defaultProps = {
    threshold: 0,
    triggerOnce: false,
    initialInView: false
};
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function $0e8fddefcb6714fc$export$2f62ee6831462844(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView;
    var unobserve = $eJOHy.useRef();
    var _React$useState = $eJOHy.useState({
        inView: !!initialInView
    }), state = _React$useState[0], setState = _React$useState[1];
    var setRef = $eJOHy.useCallback(function(node) {
        if (unobserve.current !== undefined) {
            unobserve.current();
            unobserve.current = undefined;
        } // Skip creating the observer
        if (skip) return;
        if (node) unobserve.current = $0e8fddefcb6714fc$export$d1203567a167490e(node, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && triggerOnce && unobserve.current) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve.current();
                unobserve.current = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    /* eslint-disable-next-line */ (0, $eJOHy.useEffect)(function() {
        if (!unobserve.current && state.entry && !triggerOnce && !skip) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState({
            inView: !!initialInView
        });
    });
    var result = [
        setRef,
        state.inView,
        state.entry
    ]; // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});


parcelRegister("4g9mX", function(module, exports) {
$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $0d652cd35182c73f$export$4727956877b6f612);
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $0d652cd35182c73f$export$d151e4941072147c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $2lSsS = parcelRequire("2lSsS");

var $jA3IN = parcelRequire("jA3IN");

var $cfLrC = parcelRequire("cfLrC");

var $6fs4r = parcelRequire("6fs4r");
const $0d652cd35182c73f$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jA3IN.ToolTipContentWithKeymap), {
        description: formatMessage((0, $2lSsS.messages).deleteEmojiTooltip),
        keymap: (0, $cfLrC.backspace)
    });
};
const $0d652cd35182c73f$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
        id: `screenreader-emoji-${emoji.id}`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $2lSsS.messages).deleteEmojiTooltipForScreenreader,
            values: {
                shortName: emoji.shortName
            }
        })
    });
};

});
parcelRegister("jA3IN", function(module, exports) {
$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $e82b8fc1f7abac1c$export$c7308f5f9ed494ac);
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cfLrC = parcelRequire("cfLrC");
const $e82b8fc1f7abac1c$var$tooltipShortcutStyle = null;
const $e82b8fc1f7abac1c$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $cfLrC.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            description,
            shortcut && description && '\u00A0',
            shortcut && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    "_2rkofajl _bfhk17rn _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
                ]),
                children: shortcut
            })
        ]
    }) : null;
});

});
parcelRegister("cfLrC", function(module, exports) {
$parcel$export(module.exports, "backspace", () => $2d3a83954aa08a62$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "formatShortcut", () => $2d3a83954aa08a62$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $3PZQJ = parcelRequire("3PZQJ");
const $2d3a83954aa08a62$export$1ea584ca7009bcc1 = $2d3a83954aa08a62$export$7e6b588cc98b34f1('Backspace', 'Backspace');
function $2d3a83954aa08a62$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $2d3a83954aa08a62$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return $2d3a83954aa08a62$export$d8a7f422d8d42038(description, windows, mac, common);
}
const $2d3a83954aa08a62$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
function $2d3a83954aa08a62$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $3PZQJ.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $2d3a83954aa08a62$export$8d734690d3a46118[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $3PZQJ.default).mac ? '' : '+');
}

});



parcelRegister("chAs1", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $a4876ac4e3ec9e73$export$48d7c418edadb60c);

var $igDjg = parcelRequire("igDjg");
function $a4876ac4e3ec9e73$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $igDjg !== 'undefined' && $igDjg?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});


parcelRegister("k8ZdJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5122c9670f038eb1$export$2e2bcd8739ae039);
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $8iUeU = parcelRequire("8iUeU");

const $5122c9670f038eb1$var$placeholderContainer = null;
const $5122c9670f038eb1$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
const $5122c9670f038eb1$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $8iUeU.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false, xcss: xcss } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": $5122c9670f038eb1$export$73987987fac5266b(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkofajl _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhkttw1 _s7n4nkob _o5721q9c _y3gn1h6o",
            [
                (0, $eb4c5e773f9bbee2$export$c7187bbd1a7a9244),
                (0, $eGOwo.fg)('platform_reactions_placeholder_custom_background') ? xcss : ''
            ].join(' ')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $5122c9670f038eb1$export$2e2bcd8739ae039 = $5122c9670f038eb1$var$EmojiPlaceholder;

});

parcelRegister("4FlMD", function(module, exports) {
$parcel$export(module.exports, "EmojiCommonProvider", () => $3ad4b3a3694a9c33$export$1120e666998e21b5);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7qseJ = parcelRequire("7qseJ");
const $3ad4b3a3694a9c33$export$1120e666998e21b5 = (props)=>{
    if (props.emojiProvider) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qseJ.EmojiContextProvider), {
        emojiContextValue: {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        },
        children: props.children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: props.children
    });
};

});
parcelRegister("7qseJ", function(module, exports) {
$parcel$export(module.exports, "EmojiContextProvider", () => $e6e58c0a6a6190fa$export$f4a09143833145ed);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $64Cd4 = parcelRequire("64Cd4");

var $32Nbx = parcelRequire("32Nbx");
const $e6e58c0a6a6190fa$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $eJOHy.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $32Nbx.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $64Cd4.EmojiContext).Provider, {
        value: memoizedEmojiContextValue,
        children: children
    });
};

});
parcelRegister("64Cd4", function(module, exports) {
$parcel$export(module.exports, "EmojiContext", () => $5eb1e8c0c6fbfd3d$export$9fab6c37a453c65e);

var $eJOHy = parcelRequire("eJOHy");
const $5eb1e8c0c6fbfd3d$export$9fab6c37a453c65e = (0, $eJOHy.createContext)(null);

});




parcelRegister("b9cFG", function(module, exports) {
$parcel$export(module.exports, "UfoErrorBoundary", () => $54cade362a3b2ab3$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");
class $54cade362a3b2ab3$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("glEdp", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d48ab14c082dbe8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $l2YrF = parcelRequire("l2YrF");

var $eGOwo = parcelRequire("eGOwo");

var $8KqmO = parcelRequire("8KqmO");
var $1d48ab14c082dbe8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)(function MentionItem(props) {
    const { eventHandlers: eventHandlers, id: id, providers: providers, text: text, accessLevel: accessLevel, localId: localId } = props;
    const inlineAnnotationProps = (0, $8KqmO.useInlineAnnotationProps)(props);
    if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...inlineAnnotationProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l2YrF.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            providers: providers,
            localId: localId,
            eventHandlers: eventHandlers && eventHandlers.mention
        })
    }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l2YrF.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        providers: providers,
        localId: localId,
        eventHandlers: eventHandlers && eventHandlers.mention
    });
});

});
parcelRegister("l2YrF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad900880cd9dc016$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1RDZV = parcelRequire("1RDZV");
var $4sxxB = parcelRequire("4sxxB");

var $4kfHb = parcelRequire("4kfHb");
class $ad900880cd9dc016$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.renderWithProvider = (providers)=>{
            const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, text: text, localId: localId } = this.props;
            const { mentionProvider: mentionProvider, profilecardProvider: profilecardProvider } = providers;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4kfHb.MentionWithProviders), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                eventHandlers: eventHandlers,
                mentionProvider: mentionProvider,
                profilecardProvider: profilecardProvider
            });
        };
        this.providerFactory = props.providers || new (0, $1RDZV.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sxxB.WithProviders), {
            providers: [
                'mentionProvider',
                'profilecardProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}

});
parcelRegister("4kfHb", function(module, exports) {
$parcel$export(module.exports, "MentionWithProviders", () => $c69cef2e68c26109$export$cd21803c89efe790);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dNi7s = parcelRequire("dNi7s");

var $2C7bh = parcelRequire("2C7bh");
const $c69cef2e68c26109$var$GENERIC_USER_IDS = [
    'HipChat',
    'all',
    'here'
];
const $c69cef2e68c26109$export$cd21803c89efe790 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderResolver, text: text, localId: localId })=>{
    const [profilecardProvider, setProfilecardProvider] = (0, $eJOHy.useState)(null);
    const mountedRef = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        profilecardProviderResolver?.then((result)=>{
            if (mountedRef.current) setProfilecardProvider(result);
        }).catch(()=>{
            if (mountedRef.current) setProfilecardProvider(null);
        });
    }, [
        profilecardProviderResolver
    ]);
    const MentionComponent = profilecardProvider && profilecardProviderResolver && $c69cef2e68c26109$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $2C7bh.default) : (0, $dNi7s.default);
    const ssrPlaceholderId = `mention-${id}`;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(MentionComponent, {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        profilecardProvider: profilecardProvider,
        onClick: eventHandlers?.onClick,
        onMouseEnter: eventHandlers?.onMouseEnter,
        onMouseLeave: eventHandlers?.onMouseLeave,
        ssrPlaceholderId: ssrPlaceholderId
    });
});

});
parcelRegister("dNi7s", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4e28c88c9024778$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $231b4 = parcelRequire("231b4");

var $49R7i = parcelRequire("49R7i");

var $8BCOX = parcelRequire("8BCOX");

var $lAjeM = parcelRequire("lAjeM");
class $d4e28c88c9024778$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    constructor(props){
        super(props), this.handleMentionProvider = (props)=>{
            const { id: id, mentionProvider: mentionProvider, text: text } = props;
            if (mentionProvider) mentionProvider.then((provider)=>{
                const newState = {
                    isHighlighted: provider.shouldHighlightMention({
                        id: id
                    })
                };
                if (!text && (0, $231b4.isResolvingMentionProvider)(provider)) {
                    const nameDetail = provider.resolveMentionName(id);
                    if ((0, $49R7i.isPromise)(nameDetail)) nameDetail.then((nameDetailResult)=>{
                        this.setStateSafely({
                            resolvedMentionName: this.processName(nameDetailResult)
                        });
                    });
                    else newState.resolvedMentionName = this.processName(nameDetail);
                }
                this.setStateSafely(newState);
            }).catch(()=>{
                this.setStateSafely({
                    isHighlighted: false
                });
            });
            else this.setStateSafely({
                isHighlighted: false
            });
        };
        this._isMounted = false;
        this.state = {
            isHighlighted: false
        };
    }
    componentDidMount() {
        this.handleMentionProvider(this.props);
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { props: props } = this;
        if (props.id !== nextProps.id || props.mentionProvider !== nextProps.mentionProvider) this.handleMentionProvider(nextProps);
    }
    setStateSafely(newState) {
        if (!this._isMounted) {
            (0, $lAjeM.default)('[ResourcedMention]: cannot setState when component is unmounted.');
            return;
        }
        this.setState(newState);
    }
    processName(name) {
        let mentionName;
        switch(name.status){
            case (0, $49R7i.MentionNameStatus).OK:
                mentionName = name.name || '';
                break;
            case (0, $49R7i.MentionNameStatus).SERVICE_ERROR:
            case (0, $49R7i.MentionNameStatus).UNKNOWN:
            default:
                mentionName = (0, $8BCOX.UNKNOWN_USER_ID);
                break;
        }
        return `@${mentionName}`;
    }
    render() {
        const { props: props, state: state } = this;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8BCOX.default), {
            id: props.id,
            text: props.text || state.resolvedMentionName || '',
            isHighlighted: state.isHighlighted,
            accessLevel: props.accessLevel,
            localId: props.localId,
            onClick: props.onClick,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            ssrPlaceholderId: props.ssrPlaceholderId
        });
    }
}

});
parcelRegister("231b4", function(module, exports) {
$parcel$export(module.exports, "AbstractMentionResource", () => $ccd5ccb172c3212e$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $ccd5ccb172c3212e$export$ae1fce5f69858ef3);

var $kp3br = parcelRequire("kp3br");

var $49R7i = parcelRequire("49R7i");

var $lAjeM = parcelRequire("lAjeM");

var $bPSqT = parcelRequire("bPSqT");

var $3s8bj = parcelRequire("3s8bj");
const $ccd5ccb172c3212e$var$MAX_QUERY_ITEMS = 100;
const $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS = 20;
const $ccd5ccb172c3212e$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $ccd5ccb172c3212e$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $ccd5ccb172c3212e$export$8576ba1ed2760927 extends $ccd5ccb172c3212e$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $lAjeM.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $lAjeM.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $ccd5ccb172c3212e$export$5a4331e3e1c43553 extends $ccd5ccb172c3212e$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $lAjeM.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $49R7i.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $ccd5ccb172c3212e$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $kp3br.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).INITIAL_STATE, (0, $49R7i.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).INITIAL_STATE, (0, $49R7i.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $ccd5ccb172c3212e$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $kp3br.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).SEARCH, (0, $49R7i.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).SEARCH, (0, $49R7i.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $49R7i.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $49R7i.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
}
class $ccd5ccb172c3212e$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $ccd5ccb172c3212e$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $ccd5ccb172c3212e$export$2e2bcd8739ae039 = $ccd5ccb172c3212e$export$5a4331e3e1c43553;

});
parcelRegister("49R7i", function(module, exports) {
$parcel$export(module.exports, "MentionType", () => $35dcc6829e4a1d1d$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $35dcc6829e4a1d1d$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $35dcc6829e4a1d1d$export$8436e53e45ffe15b);
$parcel$export(module.exports, "SliNames", () => $35dcc6829e4a1d1d$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "ComponentNames", () => $35dcc6829e4a1d1d$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "Actions", () => $35dcc6829e4a1d1d$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "MentionNameStatus", () => $35dcc6829e4a1d1d$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $35dcc6829e4a1d1d$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $35dcc6829e4a1d1d$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $35dcc6829e4a1d1d$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $35dcc6829e4a1d1d$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $35dcc6829e4a1d1d$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $35dcc6829e4a1d1d$export$4369c812aac99591);
var $35dcc6829e4a1d1d$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $35dcc6829e4a1d1d$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $35dcc6829e4a1d1d$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $35dcc6829e4a1d1d$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $35dcc6829e4a1d1d$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $35dcc6829e4a1d1d$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $35dcc6829e4a1d1d$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $35dcc6829e4a1d1d$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $35dcc6829e4a1d1d$export$81124e6148ca5db0[0];
}
function $35dcc6829e4a1d1d$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[1];
}
function $35dcc6829e4a1d1d$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[2];
}
function $35dcc6829e4a1d1d$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[3];
}
function $35dcc6829e4a1d1d$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $35dcc6829e4a1d1d$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("lAjeM", function(module, exports) {
$parcel$export(module.exports, "default", () => $11dfa2f74f082c3a$export$2e2bcd8739ae039);
let $11dfa2f74f082c3a$var$debugEnabled = false;
let $11dfa2f74f082c3a$var$stacktracesEnabled = false;
function $11dfa2f74f082c3a$export$748ada60eaf985cc(enable) {
    $11dfa2f74f082c3a$var$debugEnabled = enable;
}
function $11dfa2f74f082c3a$export$4f7017086af31c25(enable) {
    $11dfa2f74f082c3a$var$stacktracesEnabled = enable;
}
function $11dfa2f74f082c3a$export$2a858f450a2f66d() {
    if ($11dfa2f74f082c3a$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $11dfa2f74f082c3a$export$2e2bcd8739ae039(msg, ...args) {
    if ($11dfa2f74f082c3a$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("bPSqT", function(module, exports) {
$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $504a08bf167f720e$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $504a08bf167f720e$export$c724588856bbfbcf);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $504a08bf167f720e$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $504a08bf167f720e$export$91b2fa6a0fe06408);



var $49R7i = parcelRequire("49R7i");
const $504a08bf167f720e$var$packageName = "platform-pkg";
const $504a08bf167f720e$var$packageVersion = "0.0.0-use.local";
const $504a08bf167f720e$export$245097525aef1262 = 'sli';
const $504a08bf167f720e$export$c724588856bbfbcf = 'smart';
const $504a08bf167f720e$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $49R7i.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $504a08bf167f720e$var$packageName,
                    packageVersion: $504a08bf167f720e$var$packageVersion,
                    componentName: (0, $49R7i.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
const $504a08bf167f720e$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
            attributes: {
                packageName: $504a08bf167f720e$var$packageName,
                packageVersion: $504a08bf167f720e$var$packageVersion,
                componentName: (0, $49R7i.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $49R7i.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        return event;
    };
const $504a08bf167f720e$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $504a08bf167f720e$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
const $504a08bf167f720e$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
        attributes: {
            packageName: $504a08bf167f720e$var$packageName,
            packageVersion: $504a08bf167f720e$var$packageVersion,
            componentName: (0, $49R7i.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $504a08bf167f720e$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $49R7i.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $504a08bf167f720e$var$packageName,
                    packageVersion: $504a08bf167f720e$var$packageVersion,
                    componentName: (0, $49R7i.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $504a08bf167f720e$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $504a08bf167f720e$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$504a08bf167f720e$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $49R7i.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';

const $ab7a4be2f9c8c36f$export$d821aa4c8afb384e = 'fabric-elements';



parcelRegister("8BCOX", function(module, exports) {
$parcel$export(module.exports, "UNKNOWN_USER_ID", () => $3cb666b6a539664c$export$af8124aa496797f2);
$parcel$export(module.exports, "default", () => $3cb666b6a539664c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3U4Mr = parcelRequire("3U4Mr");

var $eQ8jX = parcelRequire("eQ8jX");

var $a9LCE = parcelRequire("a9LCE");

var $21z29 = parcelRequire("21z29");

var $49R7i = parcelRequire("49R7i");

var $bPSqT = parcelRequire("bPSqT");

var $4J0ad = parcelRequire("4J0ad");

var $g0oDq = parcelRequire("g0oDq");

var $9pZhV = parcelRequire("9pZhV");

var $fRHzw = parcelRequire("fRHzw");
const $3cb666b6a539664c$export$7452d7062a4d0634 = 1000;
const $3cb666b6a539664c$export$af8124aa496797f2 = '_|unknown|_';
class $3cb666b6a539664c$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    constructor(props){
        super(props), this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        }, this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $3cb666b6a539664c$export$7452d7062a4d0634);
        }, this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        }, this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $49R7i.MentionType).SELF;
            if ((0, $49R7i.isRestricted)(accessLevel)) return (0, $49R7i.MentionType).RESTRICTED;
            return (0, $49R7i.MentionType).DEFAULT;
        };
        (0, $fRHzw.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
    componentDidMount() {
        (0, $fRHzw.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $fRHzw.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $g0oDq.UFOExperienceState)['STARTED'],
            (0, $g0oDq.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9pZhV.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            },
            children: (message)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                    children: `@${message}`
                })
        });
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$3cb666b6a539664c$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $49R7i.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3U4Mr.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $a9LCE.default), {
                mentionType: mentionType,
                onClick: handleOnClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                spellCheck: false,
                "data-testid": `mention-${id}`,
                "data-mention-type": mentionType,
                "data-mention-tooltip": showTooltip,
                children: failedMention ? this.renderUnknownUserError(id) : text || '@...'
            })
        });
        const ssrPlaceholderProp = props.ssrPlaceholderId ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fRHzw.UfoErrorBoundary), {
            id: id,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: localId,
                "data-mention-id": id,
                "data-local-id": localId,
                "data-access-level": accessLevel,
                spellCheck: false,
                ...ssrPlaceholderProp,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eQ8jX.default), {
                    children: showTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
                        fallback: mentionComponent,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $21z29.default), {
                            name: text,
                            children: mentionComponent
                        })
                    }) : mentionComponent
                })
            })
        });
    }
}
const $3cb666b6a539664c$var$MentionWithAnalytics = (0, $4J0ad.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $bPSqT.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $bPSqT.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($3cb666b6a539664c$export$92ab8442e7a15cef);
const $3cb666b6a539664c$var$Mention = $3cb666b6a539664c$var$MentionWithAnalytics;
var $3cb666b6a539664c$export$2e2bcd8739ae039 = $3cb666b6a539664c$var$Mention;

});
parcelRegister("eQ8jX", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2080416dc299e9c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $9pZhV = parcelRequire("9pZhV");
const $b2080416dc299e9c$var$EMPTY = {};
const $b2080416dc299e9c$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState($b2080416dc299e9c$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        let aborted = false;
        setMessages($b2080416dc299e9c$var$EMPTY);
        (0, $9pZhV.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $b2080416dc299e9c$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $lRq8t.default)();
    const messages = $b2080416dc299e9c$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $b2080416dc299e9c$export$2e2bcd8739ae039 = $b2080416dc299e9c$var$MessagesIntlProvider;

});
parcelRegister("9pZhV", function(module, exports) {
$parcel$export(module.exports, "UnknownUserError", () => $2f0cb1eb1c5f7ba5$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $2f0cb1eb1c5f7ba5$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $2f0cb1eb1c5f7ba5$export$da9f8ce14593162f);
$parcel$export(module.exports, "getMessagesForLocale", () => $2f0cb1eb1c5f7ba5$export$d0a3169680473b6c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $a6i5A = parcelRequire("a6i5A");
const $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $lRq8t.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $2f0cb1eb1c5f7ba5$export$98e06fe7a6174253 = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).unknownUserError);
const $2f0cb1eb1c5f7ba5$export$58bd5a2057b6b855 = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).noAccessWarning);
const $2f0cb1eb1c5f7ba5$export$da9f8ce14593162f = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).noAccessLabel);
const $2f0cb1eb1c5f7ba5$export$4a258ffee7316766 = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).defaultHeadline);
const $2f0cb1eb1c5f7ba5$export$702321a50d74536e = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).defaultAdvisedAction);
const $2f0cb1eb1c5f7ba5$export$ed7f16088a93ae9d = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).loginAgain);
const $2f0cb1eb1c5f7ba5$export$3ab158df56460d1c = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).differentText);































const $2f0cb1eb1c5f7ba5$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("95VfY")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("iTfll")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("iSBh2")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("jpBsY")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("edV8o")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("9C4FO")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("3bIiU")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("3XyO4")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("8tnSh")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("5gAfy")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("1sRWU")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("4uFQD")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("inUEy")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("8W6S8")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("fwnU6")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("d84Rh")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("ds9K9")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("aEH4A")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("96hBA")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6Nh6b")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("dYUaj")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("p4P2f")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("gTeyO")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("5wEEA")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("aRiXN")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("cV4RC")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("fTmdX")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("OMpad")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("6oeKD")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("cnpxZ")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $2f0cb1eb1c5f7ba5$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("jpBsY")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("a6i5A", function(module, exports) {
$parcel$export(module.exports, "messages", () => $fdd92d7113791d0a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fdd92d7113791d0a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unknownUserError: {
        id: 'fabric.mention.unknow.user.error',
        defaultMessage: 'Unknown user {userId}',
        description: 'Mention user name could not be found or look up failed'
    },
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified"
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon'
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend'
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs'
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs'
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.mentions.team.member.count',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.mentions.team.member.count.including.you',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.mentions.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.mentions.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    xProductMentionDescription: {
        id: 'fabric.elements.mentions.xproduct.mention.description',
        defaultMessage: 'Needs access to Confluence',
        description: 'Description for a x-product mention item in the mention list in Confluence'
    }
});

});

parcelRegister("95VfY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5EqMw").then(()=>parcelRequire('2EsuB'));

});

parcelRegister("iTfll", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("18eMn").then(()=>parcelRequire('jy2NA'));

});

parcelRegister("iSBh2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9yF73").then(()=>parcelRequire('cMOoZ'));

});

parcelRegister("jpBsY", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7n0BP").then(()=>parcelRequire('8iZ79'));

});

parcelRegister("edV8o", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hyqM1").then(()=>parcelRequire('35wYa'));

});

parcelRegister("9C4FO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("YxfNT").then(()=>parcelRequire('fuRMK'));

});

parcelRegister("3bIiU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9eAO5").then(()=>parcelRequire('3eJc8'));

});

parcelRegister("3XyO4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("32vaB").then(()=>parcelRequire('il84e'));

});

parcelRegister("8tnSh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("leYa9").then(()=>parcelRequire('5ymPj'));

});

parcelRegister("5gAfy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hzekf").then(()=>parcelRequire('4fX4g'));

});

parcelRegister("1sRWU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3hppq").then(()=>parcelRequire('4Wl86'));

});

parcelRegister("4uFQD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("71qoR").then(()=>parcelRequire('2HdNw'));

});

parcelRegister("inUEy", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kZ9Jj").then(()=>parcelRequire('cvwB6'));

});

parcelRegister("8W6S8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("01BCB").then(()=>parcelRequire('5aO99'));

});

parcelRegister("fwnU6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9n2u9").then(()=>parcelRequire('4vSeO'));

});

parcelRegister("d84Rh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aVj0b").then(()=>parcelRequire('42yuB'));

});

parcelRegister("ds9K9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4OI9P").then(()=>parcelRequire('8uMOi'));

});

parcelRegister("aEH4A", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9J4QP").then(()=>parcelRequire('9VAR9'));

});

parcelRegister("96hBA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lF2XI").then(()=>parcelRequire('12Lpf'));

});

parcelRegister("6Nh6b", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1HsGI").then(()=>parcelRequire('jedO8'));

});

parcelRegister("dYUaj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lXnsR").then(()=>parcelRequire('fr01P'));

});

parcelRegister("p4P2f", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8qZjs").then(()=>parcelRequire('471XU'));

});

parcelRegister("gTeyO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("e9lyC").then(()=>parcelRequire('alq7p'));

});

parcelRegister("5wEEA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("31jpa").then(()=>parcelRequire('gLqyT'));

});

parcelRegister("aRiXN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3phC6").then(()=>parcelRequire('cxEzV'));

});

parcelRegister("cV4RC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gQN5G").then(()=>parcelRequire('i4k66'));

});

parcelRegister("fTmdX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eYOjB").then(()=>parcelRequire('6zdul'));

});

parcelRegister("OMpad", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jaR1c").then(()=>parcelRequire('llxNs'));

});

parcelRegister("6oeKD", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a5Ksd").then(()=>parcelRequire('fc11e'));

});

parcelRegister("cnpxZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jUx2Z").then(()=>parcelRequire('4raZH'));

});



parcelRegister("a9LCE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d6272fa0b467372$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $49R7i = parcelRequire("49R7i");

var $eJOHy = parcelRequire("eJOHy");
const $2d6272fa0b467372$var$mentionStyle = {
    [(0, $49R7i.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`
    },
    [(0, $49R7i.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
        text: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $49R7i.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`
    }
};
const $2d6272fa0b467372$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $2d6272fa0b467372$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $2d6272fa0b467372$var$PrimitiveMention = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1NIU8.css)("display:inline;border:var(--ds-border-width, 1px) solid ", $2d6272fa0b467372$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $2d6272fa0b467372$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $2d6272fa0b467372$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $2d6272fa0b467372$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $2d6272fa0b467372$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $2d6272fa0b467372$export$2e2bcd8739ae039 = $2d6272fa0b467372$var$PrimitiveMention;

});

parcelRegister("21z29", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a684ea7707ceeb8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $8a684ea7707ceeb8$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("9RLQj")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $8a684ea7707ceeb8$export$2e2bcd8739ae039 = $8a684ea7707ceeb8$var$AsyncNoAccessTooltip;

});
parcelRegister("9RLQj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kCPaP").then(()=>parcelRequire('4aHpv'));

});


parcelRegister("fRHzw", function(module, exports) {
$parcel$export(module.exports, "mentionRenderedUfoExperience", () => $94df87fd4b0cb8b6$export$1d011e4240507c78);
$parcel$export(module.exports, "UfoErrorBoundary", () => $94df87fd4b0cb8b6$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
const $94df87fd4b0cb8b6$export$1d011e4240507c78 = new (0, $9iIu4.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
});
class $94df87fd4b0cb8b6$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        $94df87fd4b0cb8b6$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



parcelRegister("2C7bh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d131d6e38f6c2191$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dNi7s = parcelRequire("dNi7s");

var $caeqU = parcelRequire("caeqU");
function $d131d6e38f6c2191$export$2e2bcd8739ae039({ autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId, ssrPlaceholderId: ssrPlaceholderId }) {
    const { cloudId: cloudId, resourceClient: resourceClient } = profilecardProvider;
    const actions = (0, $eJOHy.useMemo)(()=>profilecardProvider.getActions(id, text, accessLevel), [
        accessLevel,
        id,
        profilecardProvider,
        text
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $caeqU.default), {
        autoFocus: autoFocus,
        cloudId: cloudId,
        userId: id,
        resourceClient: resourceClient,
        actions: actions,
        trigger: "click",
        position: "bottom-end",
        testId: "mention-with-profilecard-trigger",
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        ariaLabel: text.replace(/^@/, ''),
        ssrPlaceholderId: ssrPlaceholderId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dNi7s.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ssrPlaceholderId: ssrPlaceholderId
        })
    });
}

});
parcelRegister("caeqU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9b60a56512bd43f$export$2e2bcd8739ae039);


var $1GAK3 = parcelRequire("1GAK3");

var $39Fdj = parcelRequire("39Fdj");
var $f9b60a56512bd43f$export$2e2bcd8739ae039 = (0, $39Fdj.default);

});
parcelRegister("1GAK3", function(module, exports) {
$parcel$export(module.exports, "ProfileCardLazy", () => $500dc3728366069c$export$403d297463f226af);

var $eJOHy = parcelRequire("eJOHy");

const $500dc3728366069c$export$403d297463f226af = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2mJ6Y")));

});
parcelRegister("2mJ6Y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("2wjWj")
]).then(()=>parcelRequire('k60Oj'));

});


parcelRegister("39Fdj", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a556daa2b306b37$export$2e2bcd8739ae039);
/* ProfileCardTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $8IeH1 = parcelRequire("8IeH1");

var $IW7jS = parcelRequire("IW7jS");

var $gh6xW = parcelRequire("gh6xW");

var $8WJ7D = parcelRequire("8WJ7D");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");


var $bQmsU = parcelRequire("bQmsU");

var $1GAK3 = parcelRequire("1GAK3");

var $5H2ec = parcelRequire("5H2ec");
const $9a556daa2b306b37$var$styles = {
    profileCardTrigger: "_m5ny16oo"
};
function $9a556daa2b306b37$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, trigger: trigger, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQmsU.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        trigger: trigger,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1GAK3.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $9a556daa2b306b37$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible, ssrPlaceholderId: ssrPlaceholderId, showDelay: customShowDelay, hideDelay: customHideDelay }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isMounted = (0, $eJOHy.useRef)(false);
    const [visible, setVisible] = (0, $eJOHy.useState)(false);
    const showTimer = (0, $eJOHy.useRef)(0);
    const hideTimer = (0, $eJOHy.useRef)(0);
    const isExternalControl = propsIsVisible !== undefined && propsIsVisible !== visible;
    const showDelay = trigger === 'click' || isExternalControl && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : customShowDelay ?? (0, $776ef75d5b01ad48$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || isExternalControl && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : customHideDelay ?? (0, $776ef75d5b01ad48$export$89a9f35a94d7f196);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(undefined);
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eJOHy.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eJOHy.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eJOHy.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eJOHy.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eJOHy.useState)(false);
    const triggerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eJOHy.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eJOHy.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eJOHy.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eJOHy.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $eGOwo.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eJOHy.useCallback)(()=>{
        return (0, $gh6xW.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    const ssrPlaceholderProp = ssrPlaceholderId ? {
        'data-ssr-placeholder-replace': ssrPlaceholderId
    } : {};
    if ((0, $eGOwo.fg)('enable_absolute_positioning_profile_card')) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                xcss: $9a556daa2b306b37$var$styles.profileCardTrigger,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                    isOpen: !!visible,
                    onClose: (event)=>{
                        hideProfilecard();
                        handleKeyboardClose(event);
                    },
                    placement: position,
                    offset: offset ?? [
                        0,
                        8
                    ],
                    content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ...wrapperProps,
                            children: showLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$LoadingView, {
                                fireAnalytics: fireAnalytics
                            }) : visible && /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$ProfileCardContent, {
                                profilecardProps: profilecardProps,
                                isAgent: !!data?.isAgent,
                                userId: userId,
                                cloudId: cloudId,
                                resourceClient: resourceClient,
                                viewingUserId: viewingUserId,
                                trigger: trigger,
                                product: product,
                                profileCardAction: filterActions(),
                                errorType: error,
                                hasError: hasError,
                                agentActions: agentActions,
                                addFlag: addFlag
                            })
                        }),
                    trigger: (triggerProps)=>{
                        const { ref: callbackRef, ...innerProps } = triggerProps;
                        const ref = (element)=>{
                            triggerRef.current = element;
                            if (typeof callbackRef === 'function') callbackRef(element);
                        };
                        const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            ...disabledAriaAttributes ? restInnerProps : triggerProps,
                            ...containerListeners,
                            ref: ref,
                            "data-testid": testId,
                            ...!ariaHideProfileTrigger && {
                                'aria-labelledby': ariaLabelledBy
                            },
                            ...disabledAriaAttributes ? {} : {
                                role: 'button',
                                //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                                tabIndex: ariaHideProfileTrigger ? -1 : 0,
                                'aria-label': ariaHideProfileTrigger ? undefined : (0, $8WJ7D.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                            },
                            ...ariaHideProfileTrigger && {
                                'aria-hidden': 'true'
                            },
                            ...ssrPlaceholderProp,
                            children: children
                        });
                    },
                    zIndex: (0, $IW7jS.layers).modal(),
                    shouldUseCaptureOnOutsideClick: true,
                    autoFocus: autoFocus ?? trigger === 'click',
                    shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card') || (0, $eGOwo.fg)('enable_absolute_positioning_profile_card'),
                    shouldDisableFocusLock: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card') || (0, $eGOwo.fg)('enable_absolute_positioning_profile_card'),
                    strategy: "absolute",
                    id: "profile-card-trigger-popup-wrapper"
                })
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $8WJ7D.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        ...ssrPlaceholderProp,
                        children: children
                    });
                },
                zIndex: (0, $IW7jS.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card'),
                shouldDisableFocusLock: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $9a556daa2b306b37$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5H2ec.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("7m76n", function(module, exports) {
$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $ec00209f14041f24$export$93fe397a02fe8b76);

var $eJOHy = parcelRequire("eJOHy");

const $ec00209f14041f24$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("cZiA6")));

});
parcelRegister("cZiA6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("2tv8I")
]).then(()=>parcelRequire('3dj1A'));

});


parcelRegister("XUWry", function(module, exports) {
$parcel$export(module.exports, "KudosType", () => $2c3b135763fda18f$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $2c3b135763fda18f$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $2c3b135763fda18f$export$7a1fc1a1b0477464);
var $2c3b135763fda18f$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $2c3b135763fda18f$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $2c3b135763fda18f$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($2c3b135763fda18f$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("gh6xW", function(module, exports) {
$parcel$export(module.exports, "default", () => $4adbe5caf86a5ece$export$2e2bcd8739ae039);
const $4adbe5caf86a5ece$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $4adbe5caf86a5ece$export$2e2bcd8739ae039 = $4adbe5caf86a5ece$var$filterActions;

});

parcelRegister("8WJ7D", function(module, exports) {
$parcel$export(module.exports, "default", () => $95a2772a88ae71e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $95a2772a88ae71e4$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($95a2772a88ae71e4$var$messages.label, {
        fullName: fullName
    }) : formatMessage($95a2772a88ae71e4$var$messages.fallbackLabel);
};
const $95a2772a88ae71e4$var$messages = (0, $7qGN1.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $95a2772a88ae71e4$export$2e2bcd8739ae039 = $95a2772a88ae71e4$var$getLabelMessage;

});

parcelRegister("b4A0H", function(module, exports) {
$parcel$export(module.exports, "CardWrapper", () => $d37aab7a36a1d923$export$6aa22a823032b784);
$parcel$export(module.exports, "SpinnerContainer", () => $d37aab7a36a1d923$export$a5e06607a5ac6158);
/* UserTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ // PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $d37aab7a36a1d923$var$styles = {
    cardWrapper: "_2rko12b0 _1bsb1gwv",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
const $d37aab7a36a1d923$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    });
const $d37aab7a36a1d923$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.spinnerContainer),
        children: children
    });

});

parcelRegister("2EPX4", function(module, exports) {
$parcel$export(module.exports, "fireEvent", () => $7d8a130fd15a8bb5$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $7d8a130fd15a8bb5$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $7d8a130fd15a8bb5$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $7d8a130fd15a8bb5$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $7d8a130fd15a8bb5$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $7d8a130fd15a8bb5$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $7d8a130fd15a8bb5$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $7d8a130fd15a8bb5$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $7d8a130fd15a8bb5$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $7d8a130fd15a8bb5$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $7d8a130fd15a8bb5$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $7d8a130fd15a8bb5$export$a9f8c9f412cf5664);

var $kNQN4 = parcelRequire("kNQN4");
/** Below lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $7d8a130fd15a8bb5$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $7d8a130fd15a8bb5$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $7d8a130fd15a8bb5$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$TEAM_SUBJECT = 'teamProfileCard';
const $7d8a130fd15a8bb5$var$USER_SUBJECT = 'profilecard';
const $7d8a130fd15a8bb5$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */ const $7d8a130fd15a8bb5$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $kNQN4.getPageTime)())
        }
    });
const $7d8a130fd15a8bb5$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $7d8a130fd15a8bb5$var$USER_SUBJECT;
        case 'team':
            return $7d8a130fd15a8bb5$var$TEAM_SUBJECT;
        case 'agent':
            return $7d8a130fd15a8bb5$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $7d8a130fd15a8bb5$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $7d8a130fd15a8bb5$var$createEvent('ui', 'triggered', $7d8a130fd15a8bb5$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $7d8a130fd15a8bb5$export$c9b0e37b229a297b = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$12dae48763368ac9 = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$USER_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$41816a317479160b = (type, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'rendered', $7d8a130fd15a8bb5$var$getActionSubject(type), actionSubjectId, attributes);
const $7d8a130fd15a8bb5$export$fdcd134fbeb1f921 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'action', attributes);
const $7d8a130fd15a8bb5$export$93260987012593be = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$USER_SUBJECT, 'reportingLines', attributes);
const $7d8a130fd15a8bb5$export$79befd155063a6a7 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'moreActions', attributes);
const $7d8a130fd15a8bb5$export$2703289b35687fde = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'avatar', attributes);
const $7d8a130fd15a8bb5$export$b4411a7661cf2d3f = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $7d8a130fd15a8bb5$export$c86679da702d560e = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $7d8a130fd15a8bb5$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("kNQN4", function(module, exports) {
$parcel$export(module.exports, "getPageTime", () => $64b9704217d393a1$export$e9faea7c41053334);
const $64b9704217d393a1$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $64b9704217d393a1$var$performanceAvailable = $64b9704217d393a1$var$isPerformanceAvailable();
const $64b9704217d393a1$var$initialPageTime = Date.now();
const $64b9704217d393a1$export$e9faea7c41053334 = ()=>{
    if ($64b9704217d393a1$var$performanceAvailable) return performance.now();
    return Date.now() - $64b9704217d393a1$var$initialPageTime;
};

});


const $776ef75d5b01ad48$export$5b956b542f1bc1b3 = 800;
const $776ef75d5b01ad48$export$89a9f35a94d7f196 = 200;

parcelRegister("bQmsU", function(module, exports) {
$parcel$export(module.exports, "AgentProfileCardResourced", () => $2dca9d01bdb4de20$export$4b013ffffcb40af8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $j19W0 = parcelRequire("j19W0");

var $2EPX4 = parcelRequire("2EPX4");

var $46Rs7 = parcelRequire("46Rs7");

var $dWlMJ = parcelRequire("dWlMJ");

var $kKboJ = parcelRequire("kKboJ");

var $5TZsz = parcelRequire("5TZsz");
const $2dca9d01bdb4de20$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $eJOHy.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $46Rs7.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const { href: profileHref } = (0, $j19W0.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    const getCreator = (0, $eJOHy.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $eGOwo.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKboJ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWlMJ.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5TZsz.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent
        })
    });
};

});
parcelRegister("j19W0", function(module, exports) {
$parcel$export(module.exports, "navigateToTeamsApp", () => $bcd485df6c831087$export$cd99a4ca8e852372);
$parcel$export(module.exports, "toTeamsAppURL", () => $bcd485df6c831087$export$196b2cec97b1c87c);

var $fvpPO = parcelRequire("fvpPO");

var $0FujR = parcelRequire("0FujR");
const $bcd485df6c831087$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $fvpPO.isTeamsAppEnabled)(action) : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $0FujR.getHostProductFromPath)()
    };
    const { path: path, query: query } = (0, $0FujR.getPathAndQuery)(actionWithDefaults);
    const href = (0, $0FujR.generatePath)(path, actionWithDefaults, query);
    const onNavigate = (0, $0FujR.onNavigateBase)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};
const $bcd485df6c831087$export$196b2cec97b1c87c = (path, search, config)=>{
    return (0, $0FujR.generateTeamsAppPath)(path, config, new URLSearchParams(search));
};

});
parcelRegister("fvpPO", function(module, exports) {
$parcel$export(module.exports, "isTeamsAppEnabled", () => $e45f3caa2e661ed2$export$5921b2a93a401547);

var $lopBx = parcelRequire("lopBx");
var $7pw1V = parcelRequire("7pw1V");

var $59rsN = parcelRequire("59rsN");

var $eGOwo = parcelRequire("eGOwo");
function $e45f3caa2e661ed2$export$5921b2a93a401547(config) {
    //  Hard kill switch for isolated cloud until Standalone directory is deployed
    if ((0, $7pw1V.isIsolatedCloud)()) return false;
    // Due to experiment exposures, we need to first check if Nav4 is enabled to see if the user is in the cohort
    // In FedRamp, we are ignoring the Nav4 dependency
    if (!(0, $lopBx.isFedRamp)() && config.userHasNav4Enabled !== undefined && !config.userHasNav4Enabled) return false;
    if ((0, $59rsN.default).initializeCompleted()) {
        // Next we check the experiment value based on the host product
        if (config.hostProduct === 'jira' && (0, $59rsN.default).getExperimentValue('migrate-jira-people-directory-to-teams-app', 'isEnabled', false)) return true;
        if (config.hostProduct === 'confluence' && (0, $59rsN.default).getExperimentValue('migrate-confluence-people-directory-to-teams-app', 'isEnabled', false)) return true;
    }
    // Lastly we check the feature gate which we are using for dogfooding, we won't roll this flag out in production.
    return (0, $eGOwo.fg)('should-redirect-directory-to-teams-app');
}

});

parcelRegister("0FujR", function(module, exports) {
$parcel$export(module.exports, "generateTeamsAppPath", () => $a228ae66ede9224c$export$9665cb78fbba2c92);
$parcel$export(module.exports, "generatePath", () => $a228ae66ede9224c$export$82476f982757e71e);
$parcel$export(module.exports, "onNavigateBase", () => $a228ae66ede9224c$export$39f25014273b0a58);
$parcel$export(module.exports, "getPathAndQuery", () => $a228ae66ede9224c$export$b406f12e2156b3fe);
$parcel$export(module.exports, "getHostProductFromPath", () => $a228ae66ede9224c$export$a792d22ca73cc3ca);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $chYv1 = parcelRequire("chYv1");

var $fvpPO = parcelRequire("fvpPO");
function $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $lopBx.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${$a228ae66ede9224c$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    return `${(0, $8RHPx.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}
function $a228ae66ede9224c$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    if ((0, $fvpPO.isTeamsAppEnabled)(config) || config.hostProduct === 'home' || !config.hostProduct) return $a228ae66ede9224c$export$9665cb78fbba2c92(path, config, query, anchor);
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $chYv1.origin)()}/${config.hostProduct === 'confluence' ? 'wiki' : 'jira'}/people/${path}${queryString}`;
}
const $a228ae66ede9224c$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ((0, $fvpPO.isTeamsAppEnabled)(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $chYv1.redirect)(href);
                return;
            }
            (0, $chYv1.openInNewTab)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $chYv1.redirect)(href);
            return;
        } else {
            (0, $chYv1.openInNewTab)(href);
            return;
        }
    };
function $a228ae66ede9224c$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.includes('/') ? id.split('/').pop() || '' : id;
}
function $a228ae66ede9224c$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            // Safety check for undefined userId, just redirect to the landing page as the profile redirect will fail
            if (!action.payload?.userId) return {
                path: ''
            };
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            // Safety check for undefined teamId, just redirect to the landing page as the team redirect will fail
            if (!action.payload?.teamId) return {
                path: ''
            };
            return {
                path: `team/${$a228ae66ede9224c$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            // Safety check for undefined agentId, just redirect to the landing page as the agent redirect will fail
            if (!action.payload?.agentId) return {
                path: ''
            };
            return {
                path: `agent/${$a228ae66ede9224c$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            // Safety check for undefined kudosId, just redirect to the landing page as the kudos redirect will fail
            if (!action.payload?.kudosId) return {
                path: ''
            };
            return {
                path: `kudos/${$a228ae66ede9224c$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            return {
                path: `search/people`,
                query: new URLSearchParams(action.payload.query)
            };
        case 'USER_WORK':
            return {
                path: `${$a228ae66ede9224c$var$stripAriFromId(action.payload.userId)}/work`
            };
        case 'CURRENT_USER_PROFILE':
            return {
                path: 'me'
            };
        default:
            return {
                path: ''
            };
    }
}
function $a228ae66ede9224c$export$a9f2c34176fff494() {
    const host = (0, $chYv1.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    return false;
}
function $a228ae66ede9224c$export$a792d22ca73cc3ca() {
    const path = (0, $chYv1.pathname)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $chYv1.hostname)().startsWith('home')) return 'home';
    return undefined;
}

});
parcelRegister("chYv1", function(module, exports) {
$parcel$export(module.exports, "redirect", () => $c76ad79e98e47bfd$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $c76ad79e98e47bfd$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "hostname", () => $c76ad79e98e47bfd$export$640106f6dc7d2706);
$parcel$export(module.exports, "origin", () => $c76ad79e98e47bfd$export$f710a83a91838a36);
$parcel$export(module.exports, "pathname", () => $c76ad79e98e47bfd$export$7333db99aa99d383);
function $c76ad79e98e47bfd$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $c76ad79e98e47bfd$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $c76ad79e98e47bfd$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
const $c76ad79e98e47bfd$export$f710a83a91838a36 = ()=>globalThis.location?.origin;
const $c76ad79e98e47bfd$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;

});



parcelRegister("46Rs7", function(module, exports) {
$parcel$export(module.exports, "getAAIDFromARI", () => $5342ced741c59880$export$3761e66a04602cbd);
const $5342ced741c59880$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $5342ced741c59880$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($5342ced741c59880$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("dWlMJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4c4e00d9fd0e109$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $a03qM = parcelRequire("a03qM");

var $jZF1f = parcelRequire("jZF1f");

var $5qJVF = parcelRequire("5qJVF");

var $3CCXY = parcelRequire("3CCXY");

var $2EPX4 = parcelRequire("2EPX4");
const $d4c4e00d9fd0e109$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3CCXY.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $gt9Am.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jZF1f))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                onClick: reload,
                children: "Try again"
            })
        ]
    });
};
var $d4c4e00d9fd0e109$export$2e2bcd8739ae039 = $d4c4e00d9fd0e109$var$ErrorMessage;

});
parcelRegister("3CCXY", function(module, exports) {
$parcel$export(module.exports, "ErrorWrapper", () => $f4fe046f369d0d86$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $f4fe046f369d0d86$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $f4fe046f369d0d86$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $f4fe046f369d0d86$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $f4fe046f369d0d86$export$bb27b7e39840238f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorWrapper),
        ...props
    });
const $f4fe046f369d0d86$export$b065fd053267ec81 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorTitle),
        children: props.children
    });
const $f4fe046f369d0d86$export$90d92ccfb27352c6 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.teamErrorText),
        children: props.children
    });

});


parcelRegister("kKboJ", function(module, exports) {
$parcel$export(module.exports, "AgentProfileCardWrapper", () => $d15bd5f3ea87f8ed$export$2c6604b50c274e6f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $d15bd5f3ea87f8ed$var$styles = (0, $1DXK0.xcss)({
    width: '360px'
});
const $d15bd5f3ea87f8ed$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $d15bd5f3ea87f8ed$var$styles,
        children: children
    });
};

});

parcelRegister("5TZsz", function(module, exports) {
$parcel$export(module.exports, "AgentProfileCardLazy", () => $aff86c6979038d17$export$ed0ca9c1d49ea0bf);

var $eJOHy = parcelRequire("eJOHy");

const $aff86c6979038d17$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dxaGw")));

});
parcelRegister("dxaGw", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gsod0")
]).then(()=>parcelRequire('e1nCN'));

});



parcelRegister("5H2ec", function(module, exports) {
$parcel$export(module.exports, "default", () => $75ec444a04f48b56$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");
const $75ec444a04f48b56$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });
};
var $75ec444a04f48b56$export$2e2bcd8739ae039 = $75ec444a04f48b56$var$UserLoadingState;

});







parcelRegister("7naaD", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d39984529f5e148$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $5WAQt = parcelRequire("5WAQt");

var $ePdnq = parcelRequire("ePdnq");

var $7kf0Z = parcelRequire("7kf0Z");

var $kZPQ0 = parcelRequire("kZPQ0");

var $lhPrb = parcelRequire("lhPrb");

var $6L7mA = parcelRequire("6L7mA");

var $dkTgd = parcelRequire("dkTgd");
var $35vki = parcelRequire("35vki");
var $cH4bN = parcelRequire("cH4bN");
var $2r7GW = parcelRequire("2r7GW");
var $clzOA = parcelRequire("clzOA");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");
function $4d39984529f5e148$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $4d39984529f5e148$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $7yBx7.akEditorCustomIconSize)) / 2;
const $4d39984529f5e148$var$panelEmojiImageVerticalAlignment = $4d39984529f5e148$var$panelEmojiSpriteVerticalAlignment - 1;
const $4d39984529f5e148$var$blockNodesVerticalMargin = '0.75rem';
const $4d39984529f5e148$var$akEditorTableCellMinWidth = 48;
const $4d39984529f5e148$var$panelBaseStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.ak-editor-panel': {
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${$4d39984529f5e148$var$blockNodesVerticalMargin} 0 0`,
        paddingTop: "var(--ds-space-100, 8px)",
        paddingRight: "var(--ds-space-200, 16px)",
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-100, 8px)",
        minWidth: `${$4d39984529f5e148$var$akEditorTableCellMinWidth}px`,
        display: 'flex',
        position: 'relative',
        alignItems: 'normal',
        wordBreak: 'break-word',
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #DEEBFF)",
        color: 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__icon': {
            flexShrink: 0,
            height: "var(--ds-space-300, 24px)",
            width: "var(--ds-space-300, 24px)",
            boxSizing: 'content-box',
            paddingRight: "var(--ds-space-100, 8px)",
            textAlign: 'center',
            userSelect: 'none',
            MozUserSelect: 'none',
            WebkitUserSelect: 'none',
            MsUserSelect: 'none',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '0.1em',
            color: "var(--ds-icon-information, #1D7AFC)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span': {
                verticalAlign: 'middle',
                display: 'inline-flex'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-sprite': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$4d39984529f5e148$var$panelEmojiSpriteVerticalAlignment}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-image': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$4d39984529f5e148$var$panelEmojiImageVerticalAlignment}px`,
                // Vertical align only works for inline-block elements in Firefox
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '@-moz-document url-prefix()': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    img: {
                        display: 'inline-block'
                    }
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__content': {
            margin: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"}`,
            flex: '1 0 0',
            /*
      https://ishadeed.com/article/min-max-css/#setting-min-width-to-zero-with-flexbox
      The default value for min-width is auto, which is computed to zero. When an element is a flex item, the value of min-width doesn’t compute to zero. The minimum size of a flex item is equal to the size of its contents.
      */ minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="note"]': {
            backgroundColor: "var(--ds-background-accent-purple-subtlest, #EAE6FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-discovery, #8270DB)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="tip"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #E3FCEF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #22A06B)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="warning"]': {
            backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-warning, #E56910)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="error"]': {
            backgroundColor: "var(--ds-background-accent-red-subtlest, #FFEBE6)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-danger, #C9372C)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="success"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #E3FCEF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #22A06B)"
            }
        }
    }
});
const $4d39984529f5e148$var$panelHasNoIconStyles = {
    name: "vaqcwq",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}}"
};
const $4d39984529f5e148$var$panelNestedIconStyles = {
    name: "dsr7j7",
    styles: "&.ak-editor-panel__no-icon{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}"
};
const $4d39984529f5e148$var$nestedPanelStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__content .ak-editor-panel': {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E42)"}`
    }
});
const $4d39984529f5e148$var$panelCustomBackground = {
    name: "bjtns3",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{background-color:var(--ak-renderer-panel-custom-bg-color);}}"
};
const $4d39984529f5e148$var$PanelStyled = ({ backgroundColor: backgroundColor, hasIcon: hasIcon, ...props })=>{
    const customBackgroundColor = backgroundColor ? (0, $kZPQ0.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : undefined;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        {
            '--ak-renderer-panel-custom-bg-color': customBackgroundColor
        },
        css: [
            $4d39984529f5e148$var$panelBaseStyles,
            !hasIcon && $4d39984529f5e148$var$panelHasNoIconStyles,
            props['data-panel-type'] === (0, $ePdnq.PanelType).CUSTOM && backgroundColor && $4d39984529f5e148$var$panelCustomBackground,
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && $4d39984529f5e148$var$panelNestedIconStyles,
            (0, $eGOwo.fg)('platform_editor_add_border_for_nested_panel') && $4d39984529f5e148$var$nestedPanelStyles
        ],
        ...props
    }, props.children);
};
$4d39984529f5e148$var$PanelStyled.displayName = 'PanelStyled';
const $4d39984529f5e148$var$panelIcons = {
    info: (0, $35vki.PanelInfoIcon),
    success: (0, $2r7GW.PanelSuccessIcon),
    note: (0, $cH4bN.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($5WAQt))),
    warning: (0, $clzOA.PanelWarningIcon),
    error: (0, $dkTgd.PanelErrorIcon),
    custom: (0, (/*@__PURE__*/$parcel$interopDefault($lhPrb)))
};
const $4d39984529f5e148$var$Panel = (props)=>{
    const { allowCustomPanels: allowCustomPanels, panelType: type, panelColor: panelColor, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText, providers: providers, children: children, localId: localId } = props;
    // only allow custom panel type if flag is set
    // otherwise fall back to info if custom panel is given
    const panelType = allowCustomPanels ? type : type === (0, $ePdnq.PanelType).CUSTOM ? (0, $ePdnq.PanelType).INFO : type;
    const getIcon = ()=>{
        if (panelType === (0, $ePdnq.PanelType).CUSTOM) {
            if (panelIcon && providers) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6L7mA.default), {
                id: panelIconId,
                text: panelIconText,
                shortName: panelIcon,
                providers: providers
            });
            return null;
        }
        const Icon = $4d39984529f5e148$var$panelIcons[panelType];
        return /*#__PURE__*/ (0, $1NIU8.jsx)(Icon, {
            label: `${panelType} panel`
        });
    };
    const icon = getIcon();
    const renderIcon = ()=>{
        if (icon) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            className: (0, $7kf0Z.PanelSharedCssClassName).icon
        }, icon);
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)($4d39984529f5e148$var$PanelStyled, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7kf0Z.PanelSharedCssClassName).prefix,
        "data-local-id": localId,
        "data-panel-type": panelType,
        "data-panel-color": panelColor,
        "data-panel-icon": panelIcon,
        "data-panel-icon-id": panelIconId,
        "data-panel-icon-text": panelIconText,
        backgroundColor: panelColor,
        hasIcon: Boolean(icon)
    }, renderIcon(), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        className: (0, $7kf0Z.PanelSharedCssClassName).content
    }, children));
};
var $4d39984529f5e148$export$2e2bcd8739ae039 = $4d39984529f5e148$var$Panel;

});
parcelRegister("5WAQt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f3aefae583a022abe386e582aacff41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $453ef33abfecf01e$var$_react = $453ef33abfecf01e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $453ef33abfecf01e$var$_lightbulb = $453ef33abfecf01e$var$_interopRequireDefault((parcelRequire("cfSUy")));

var $453ef33abfecf01e$var$_hint = $453ef33abfecf01e$var$_interopRequireDefault((parcelRequire("bqzz1")));
function $453ef33abfecf01e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LightbulbIcon.
 * This component is LightbulbIcon, with `UNSAFE_fallbackIcon` set to "EditorHintIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $453ef33abfecf01e$var$LightbulbIcon = (props)=>/*#__PURE__*/ $453ef33abfecf01e$var$_react.default.createElement($453ef33abfecf01e$var$_lightbulb.default, Object.assign({
        name: "LightbulbIcon",
        LEGACY_fallbackIcon: $453ef33abfecf01e$var$_hint.default
    }, props));
$453ef33abfecf01e$var$LightbulbIcon.displayName = 'LightbulbIconMigration';
var $453ef33abfecf01e$var$_default = module.exports.default = $453ef33abfecf01e$var$LightbulbIcon;

});
parcelRegister("bqzz1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $851db5a925fd71ea$var$_react = $851db5a925fd71ea$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $851db5a925fd71ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $851db5a925fd71ea$var$EditorHintIcon = (props)=>/*#__PURE__*/ $851db5a925fd71ea$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14 16h-4s0-.5-1-2-2.5-3-2.5-5S7 4 12 4s5.5 3 5.5 5-1.5 3.5-2.5 5-1 2-1 2m-4 1h4v1l-1.5 2h-1L10 18z"/></svg>`
    }, props));
$851db5a925fd71ea$var$EditorHintIcon.displayName = 'EditorHintIcon';
var $851db5a925fd71ea$var$_default = module.exports.default = $851db5a925fd71ea$var$EditorHintIcon;

});


parcelRegister("7kf0Z", function(module, exports) {
$parcel$export(module.exports, "darkPanelColors", () => $8f40ff547e3f0696$export$804476272fbaff5e);
$parcel$export(module.exports, "PanelSharedCssClassName", () => $8f40ff547e3f0696$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $8f40ff547e3f0696$export$8099afddf1b1be78);
$parcel$export(module.exports, "panelSharedStyles", () => $8f40ff547e3f0696$export$fc98407afe711ba8);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $ePdnq = parcelRequire("ePdnq");

var $kZPQ0 = parcelRequire("kZPQ0");

var $7yBx7 = parcelRequire("7yBx7");

var $7yBx7 = parcelRequire("7yBx7");


var $eGOwo = parcelRequire("eGOwo");
const $8f40ff547e3f0696$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $8f40ff547e3f0696$export$804476272fbaff5e = {
    // standard panels
    info: `#0C294F`,
    error: `#441C13`,
    warning: `#413001`,
    tip: `#052E21`,
    success: `#052E21`,
    note: `#282249`,
    // Reds
    R900: '#601D16',
    // Red Saturated
    R100S: `#FFEFEB`,
    R300S: `#FFB5A3`,
    R500S: `#FF6B47`,
    R800S: `#C4320E`,
    R1200S: `#441C13`,
    // Yellows
    Y900: '#533F04',
    // Yellow Saturated
    Y100S: `#FFF3D1`,
    Y300S: `#FFDC7A`,
    Y500S: `#FFC933`,
    Y800S: `#D8A003`,
    Y1200S: `#413001`,
    // Greens
    G900: '#164B35',
    // Green Saturated
    G100S: `#E3FCF0`,
    G300S: `#95EEC5`,
    G400S: `#60DCA8`,
    G900S: `#086848`,
    G1200S: `#052E21`,
    // Blues
    B900: '#09326C',
    // Saturated Blues
    B100S: '#E5F0FF',
    B300S: '#A3C9FF',
    B500S: '#4794FF',
    B800S: '#0055CC',
    B1200S: '#0C294F',
    // Purples
    P900: `#352C63`,
    // Purple Saturated
    P100S: `#EEEBFF`,
    P300S: `#CCC3FE`,
    P500S: `#A292F7`,
    P800S: `#5E49CA`,
    P1200S: `#282249`,
    // Teals
    T900: '#1D474C',
    // Teal Saturated
    T100S: `#DBFAFF`,
    T300S: `#78EBFC`,
    T400S: `#3AD6EE`,
    T900S: `#056270`,
    T1200S: `#0B3037`,
    // Dark Mode Alpha
    DarkGray: '#161A1D',
    Gray: '#2C333A',
    LightGray: '#5A6977',
    TextColor: '#D9DDE3'
};
const $8f40ff547e3f0696$var$lightIconColor = {
    info: "var(--ds-icon-information, #1D7AFC)",
    note: "var(--ds-icon-discovery, #8270DB)",
    tip: "var(--ds-icon-success, #22A06B)",
    success: "var(--ds-icon-success, #22A06B)",
    warning: "var(--ds-icon-warning, #E56910)",
    error: "var(--ds-icon-danger, #C9372C)"
};
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $8f40ff547e3f0696$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $7yBx7.akEditorCustomIconSize)) / 2;
const $8f40ff547e3f0696$var$panelEmojiImageVerticalAlignment = $8f40ff547e3f0696$var$panelEmojiSpriteVerticalAlignment - 1;
function $8f40ff547e3f0696$export$9490e629452e7f9e(colorName, colorValue) {
    return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$8f40ff547e3f0696$export$804476272fbaff5e.TextColor};
  }
  `;
}
const $8f40ff547e3f0696$var$prefix = 'ak-editor-panel';
const $8f40ff547e3f0696$export$6dd740b6c888e050 = {
    prefix: $8f40ff547e3f0696$var$prefix,
    content: `${$8f40ff547e3f0696$var$prefix}__content`,
    icon: `${$8f40ff547e3f0696$var$prefix}__icon`,
    noIcon: `${$8f40ff547e3f0696$var$prefix}__no-icon`
};
const $8f40ff547e3f0696$export$b0ee08fae091706a = {
    infoPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).INFO}]`,
    notePanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).NOTE}]`,
    warningPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).WARNING}]`,
    errorPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).ERROR}]`,
    successPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $8f40ff547e3f0696$var$getIconStyles = (panelType)=>{
    return `
		.${$8f40ff547e3f0696$export$6dd740b6c888e050.icon}[data-panel-type='${panelType}'] {
			color: ${$8f40ff547e3f0696$var$lightIconColor[panelType]};
		}
	`;
};
const $8f40ff547e3f0696$export$8099afddf1b1be78 = (panelType)=>$8f40ff547e3f0696$var$lightPanelColors[panelType] || 'none';
const $8f40ff547e3f0696$export$dd3f0fd482ae7ccc = (panelType)=>(0, $kZPQ0.hexToEditorBackgroundPaletteColor)($8f40ff547e3f0696$var$lightPanelColors[panelType]) || 'none';
const $8f40ff547e3f0696$var$mainDynamicStyles = (panelType)=>{
    return `
    background-color: ${$8f40ff547e3f0696$export$dd3f0fd482ae7ccc(panelType)};
    color: inherit;
  `;
};
const $8f40ff547e3f0696$export$d707b378cb63679a = ()=>/*#__PURE__*/ (0, $1NIU8.css)("border-radius:var(--ds-radius-small, 3px);margin:", (0, $7yBx7.blockNodesVerticalMargin), " 0 0;padding-top:var(--ds-space-100, 8px);padding-right:var(--ds-space-200, 16px);padding-bottom:var(--ds-space-100, 8px);padding-left:var(--ds-space-100, 8px);min-width:", (0, $7yBx7.akEditorTableCellMinWidth), "px;display:flex;position:relative;align-items:normal;word-break:break-word;", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).INFO), " .", $8f40ff547e3f0696$export$6dd740b6c888e050.icon, "{flex-shrink:0;height:var(--ds-space-300, 24px);width:var(--ds-space-300, 24px);box-sizing:content-box;padding-right:var(--ds-space-100, 8px);text-align:center;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;margin-top:0.1em;>span{vertical-align:middle;display:inline-flex;}.", (0, $eb4c5e773f9bbee2$export$1c10634420a08d8a), "{vertical-align:", $8f40ff547e3f0696$var$panelEmojiSpriteVerticalAlignment, "px;}.", (0, $eb4c5e773f9bbee2$export$da61cef1c8919f7c), "{vertical-align:", $8f40ff547e3f0696$var$panelEmojiImageVerticalAlignment, "px;@-moz-document url-prefix(){img{display:inline-block;}}}}.ak-editor-panel__content{margin:var(--ds-space-025, 2px) 0 var(--ds-space-025, 2px);flex:1 0 0;min-width:0;}", (0, $eGOwo.fg)('platform_editor_add_border_for_nested_panel') ? `.${$8f40ff547e3f0696$export$6dd740b6c888e050.content} .${$8f40ff547e3f0696$var$prefix} {
			border: 1px solid ${"var(--ds-border, #091E42)"};
		}` : '', " &[data-panel-type='", (0, $ePdnq.PanelType).INFO, "']{", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).INFO), ";}&[data-panel-type='", (0, $ePdnq.PanelType).NOTE, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).NOTE), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).NOTE), ";}&[data-panel-type='", (0, $ePdnq.PanelType).TIP, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).TIP), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).TIP), ";}&[data-panel-type='", (0, $ePdnq.PanelType).WARNING, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).WARNING), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).WARNING), ";}&[data-panel-type='", (0, $ePdnq.PanelType).ERROR, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).ERROR), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).ERROR), ";}&[data-panel-type='", (0, $ePdnq.PanelType).SUCCESS, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).SUCCESS), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).SUCCESS), ";}", (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? `&.${$8f40ff547e3f0696$export$6dd740b6c888e050.noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}` : '', ";");
const $8f40ff547e3f0696$export$fc98407afe711ba8 = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$8f40ff547e3f0696$export$6dd740b6c888e050.prefix}`]: $8f40ff547e3f0696$export$d707b378cb63679a()
    });

});

parcelRegister("lhPrb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76c3d1c8c171022a94e8d1953855fefa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7f315edef134345$var$_react = $f7f315edef134345$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f7f315edef134345$var$_emoji = $f7f315edef134345$var$_interopRequireDefault((parcelRequire("euu4D")));

var $f7f315edef134345$var$_emoji2 = $f7f315edef134345$var$_interopRequireDefault((parcelRequire("gF0HQ")));
function $f7f315edef134345$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiIcon.
 * This component is EmojiIcon, with `UNSAFE_fallbackIcon` set to "EditorEmojiIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7f315edef134345$var$EmojiIcon = (props)=>/*#__PURE__*/ $f7f315edef134345$var$_react.default.createElement($f7f315edef134345$var$_emoji.default, Object.assign({
        name: "EmojiIcon",
        LEGACY_fallbackIcon: $f7f315edef134345$var$_emoji2.default
    }, props));
$f7f315edef134345$var$EmojiIcon.displayName = 'EmojiIconMigration';
var $f7f315edef134345$var$_default = module.exports.default = $f7f315edef134345$var$EmojiIcon;

});
parcelRegister("euu4D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1c30d577c7234bb5109e7b6cea91ee6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8cb3213f8552b4b$var$_react = $a8cb3213f8552b4b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a8cb3213f8552b4b$var$_baseNew = $a8cb3213f8552b4b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $a8cb3213f8552b4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8cb3213f8552b4b$var$EmojiIcon = (props)=>/*#__PURE__*/ $a8cb3213f8552b4b$var$_react.default.createElement($a8cb3213f8552b4b$var$_baseNew.default, Object.assign({
        name: "EmojiIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$a8cb3213f8552b4b$var$EmojiIcon.displayName = 'EmojiIcon';
var $a8cb3213f8552b4b$var$_default = module.exports.default = $a8cb3213f8552b4b$var$EmojiIcon;

});

parcelRegister("gF0HQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c21105e2bf1e9d5b$var$_react = $c21105e2bf1e9d5b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c21105e2bf1e9d5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c21105e2bf1e9d5b$var$EditorEmojiIcon = (props)=>/*#__PURE__*/ $c21105e2bf1e9d5b$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 12.5c3.033 0 5.5-2.467 5.5-5.5S15.033 6.5 12 6.5A5.506 5.506 0 0 0 6.5 12c0 3.033 2.467 5.5 5.5 5.5m-1.5-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m.27 1.583a.626.626 0 0 1 .932.834A3.63 3.63 0 0 1 12 15.125a3.63 3.63 0 0 1-2.698-1.204.625.625 0 0 1 .93-.835c.901 1.003 2.639 1.003 3.538-.003"/></svg>`
    }, props));
$c21105e2bf1e9d5b$var$EditorEmojiIcon.displayName = 'EditorEmojiIcon';
var $c21105e2bf1e9d5b$var$_default = module.exports.default = $c21105e2bf1e9d5b$var$EditorEmojiIcon;

});


parcelRegister("dkTgd", function(module, exports) {
$parcel$export(module.exports, "PanelErrorIcon", () => $b3ff119bcd5893cd$export$76fa6c311f4e2871);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $b3ff119bcd5893cd$var$PanelErrorGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        })
    });
};
const $b3ff119bcd5893cd$export$76fa6c311f4e2871 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $b3ff119bcd5893cd$var$PanelErrorGlyph,
        ...props
    });
};

});

parcelRegister("35vki", function(module, exports) {
$parcel$export(module.exports, "PanelInfoIcon", () => $cc40bb8be77074e6$export$2187dc2d495c3efc);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $cc40bb8be77074e6$var$PanelInfoGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        })
    });
};
const $cc40bb8be77074e6$export$2187dc2d495c3efc = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $cc40bb8be77074e6$var$PanelInfoGlyph,
        ...props
    });
};

});

parcelRegister("cH4bN", function(module, exports) {
$parcel$export(module.exports, "PanelNoteIcon", () => $5c8972d1e5b87c27$export$d4f894f0c3f0db6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $5c8972d1e5b87c27$var$PanelNoteGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        })
    });
};
const $5c8972d1e5b87c27$export$d4f894f0c3f0db6 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $5c8972d1e5b87c27$var$PanelNoteGlyph,
        ...props
    });
};

});

parcelRegister("2r7GW", function(module, exports) {
$parcel$export(module.exports, "PanelSuccessIcon", () => $1afdcee6e1f3b6cc$export$a5a5162e21242c3c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $1afdcee6e1f3b6cc$var$PanelSuccessGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        })
    });
};
const $1afdcee6e1f3b6cc$export$a5a5162e21242c3c = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $1afdcee6e1f3b6cc$var$PanelSuccessGlyph,
        ...props
    });
};

});

parcelRegister("clzOA", function(module, exports) {
$parcel$export(module.exports, "PanelWarningIcon", () => $772f3f472f7c2a19$export$246c5468186717b7);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $772f3f472f7c2a19$var$PanelWarningGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        })
    });
};
const $772f3f472f7c2a19$export$246c5468186717b7 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $772f3f472f7c2a19$var$PanelWarningGlyph,
        ...props
    });
};

});


parcelRegister("LiaMl", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff1bb9ffafc4e03c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ghHlh = parcelRequire("ghHlh");

var $eUaD0 = parcelRequire("eUaD0");

var $eGOwo = parcelRequire("eGOwo");

var $8KqmO = parcelRequire("8KqmO");
var $ff1bb9ffafc4e03c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)(function Status(props) {
    const { text: text, color: color, localId: localId } = props;
    const inlineAnnotationProps = (0, $8KqmO.useInlineAnnotationProps)(props);
    if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...inlineAnnotationProps,
        role: 'emphasis',
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.FabricElementsAnalyticsContext), {
            data: {
                userContext: 'document'
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghHlh.Status), {
                text: text,
                color: color,
                localId: localId,
                role: undefined,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh')
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.FabricElementsAnalyticsContext), {
        data: {
            userContext: 'document'
        },
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            role: "emphasis",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghHlh.Status), {
                text: text,
                color: color,
                localId: localId,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh')
            })
        })
    });
});

});
parcelRegister("ghHlh", function(module, exports) {
$parcel$export(module.exports, "Status", () => $0768993856a47129$export$96e9906d6d93a972);
/* Status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");

var $4J0ad = parcelRequire("4J0ad");

var $l9Hbg = parcelRequire("l9Hbg");

const $0768993856a47129$var$colorToLozengeAppearanceMap = {
    neutral: 'default',
    purple: 'new',
    blue: 'inprogress',
    red: 'removed',
    yellow: 'moved',
    green: 'success'
};
const $0768993856a47129$var$DEFAULT_APPEARANCE = 'default';
const $0768993856a47129$var$MAX_WIDTH = 200;
/**
 * This is to account for a bug in android chromium and should be removed
 * when the editor fixes its focus handling with respect to Status.
 *
 * See DSP-7701 for additional context.
 */ const $0768993856a47129$var$inlineBlockStyles = null;
// eg. Version/4.0 Chrome/95.0.4638.50
const $0768993856a47129$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $0768993856a47129$var$StatusInternal extends (0, $eJOHy.PureComponent) {
    static{
        this.displayName = 'StatusInternal';
    }
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = $0768993856a47129$var$colorToLozengeAppearanceMap[color] || $0768993856a47129$var$DEFAULT_APPEARANCE;
        // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $hcewu.default)([
                $0768993856a47129$var$isAndroidChromium && "_d0dzdf4r _1k0l7vkz _1frxnkob",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            "data-node-type": "status",
            "data-color": color,
            "data-style": style,
            role: role,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                maxWidth: $0768993856a47129$var$MAX_WIDTH,
                isBold: isBold,
                children: text
            })
        });
    }
    constructor(...args){
        super(...args), this.hoverStartTime = 0, this.handleMouseEnter = (_e)=>{
            this.hoverStartTime = Date.now();
        }, this.handleMouseLeave = (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $234b7ac352310435$export$7452d7062a4d0634) && onHover) onHover();
            this.hoverStartTime = 0;
        };
    }
}
const $0768993856a47129$export$96e9906d6d93a972 = (0, $4J0ad.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $l9Hbg.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $l9Hbg.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($0768993856a47129$var$StatusInternal);

});
parcelRegister("l9Hbg", function(module, exports) {
$parcel$export(module.exports, "createStatusAnalyticsAndFire", () => $4a06859375ef2dec$export$aa98853957f9f5aa);
const $4a06859375ef2dec$export$d821aa4c8afb384e = 'fabric-elements';
const $4a06859375ef2dec$var$packageName = "platform-pkg";
const $4a06859375ef2dec$var$packageVersion = "0.0.0-use.local";
const $4a06859375ef2dec$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $4a06859375ef2dec$var$packageName;
        statusPayload.attributes.packageVersion = $4a06859375ef2dec$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($4a06859375ef2dec$export$d821aa4c8afb384e);
        return event;
    };

});

const $234b7ac352310435$export$7452d7062a4d0634 = 1000;



parcelRegister("MUFrj", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5694c83ed8520b5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1RDZV = parcelRequire("1RDZV");
var $4sxxB = parcelRequire("4sxxB");

var $33824 = parcelRequire("33824");

var $eUaD0 = parcelRequire("eUaD0");

var $51MtK = parcelRequire("51MtK");
class $f5694c83ed8520b5$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.renderWithProvider = (providers)=>{
            const { taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { children: children, localId: localId, state: state, rendererContext: rendererContext, disabled: disabled, dataAttributes: dataAttributes } = this.props;
            let objectAri = '';
            if (rendererContext) objectAri = rendererContext.objectAri || '';
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.FabricElementsAnalyticsContext), {
                data: {
                    userContext: 'document'
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $51MtK.TaskItemsFormatProvider), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $51MtK.TaskItemsFormatConsumer), {
                        children: ([, dispatch])=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $33824.default), {
                                objectAri: objectAri,
                                taskId: localId,
                                isDone: state === 'DONE',
                                isRenderer: true,
                                disabled: disabled,
                                taskDecisionProvider: taskDecisionProvider,
                                contextIdentifierProvider: contextIdentifierProvider,
                                dataAttributes: dataAttributes,
                                onChange: (_, isChecked)=>{
                                    dispatch(isChecked);
                                },
                                children: children
                            })
                    })
                })
            });
        };
        this.providerFactory = props.providers || new (0, $1RDZV.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sxxB.WithProviders), {
            providers: [
                'taskDecisionProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}

});
parcelRegister("33824", function(module, exports) {
$parcel$export(module.exports, "default", () => $373a7a89ce56c03e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7VA4p = parcelRequire("7VA4p");
function $373a7a89ce56c03e$export$2e2bcd8739ae039(props) {
    const { contextIdentifierProvider: contextIdentifierProvider, objectAri: objectAri, isRenderer: isRenderer, ...otherProps } = props;
    const [resolvedContextProvider, setResolvedContextProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(undefined);
    const updateContextIdentifierProvider = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(async (contextIdentifierProvider)=>{
        if (contextIdentifierProvider) try {
            const resolvedContextProvider = await contextIdentifierProvider;
            setResolvedContextProvider(resolvedContextProvider);
            return;
        } catch (err) {}
        setResolvedContextProvider(undefined);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        updateContextIdentifierProvider(props.contextIdentifierProvider);
    }, [
        props.contextIdentifierProvider,
        updateContextIdentifierProvider
    ]);
    const resolvedObjectId = resolvedContextProvider && resolvedContextProvider.objectId || objectAri;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7VA4p.default), {
        ...otherProps,
        objectAri: resolvedObjectId,
        isRenderer: isRenderer
    });
}

});
parcelRegister("7VA4p", function(module, exports) {
$parcel$export(module.exports, "default", () => $f384e712381868c5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kJy0l = parcelRequire("kJy0l");

var $eUaD0 = parcelRequire("eUaD0");
class $f384e712381868c5$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            appearance: 'inline'
        };
    }
    constructor(props){
        super(props), this.mounted = false, this.onUpdate = (state)=>{
            this.setState({
                isDone: state === 'DONE'
            });
        }, this.handleOnChange = (taskId, isDone)=>{
            const { taskDecisionProvider: taskDecisionProvider, objectAri: objectAri, onChange: onChange, disableOnChange: disableOnChange } = this.props;
            if (disableOnChange) return;
            // Optimistically update the task
            this.setState({
                isDone: isDone
            });
            if (taskDecisionProvider && objectAri) // Call provider to update task
            taskDecisionProvider.then((provider)=>{
                if (!this.mounted) return;
                provider.toggleTask({
                    localId: taskId,
                    objectAri: objectAri
                }, isDone ? 'DONE' : 'TODO');
                // onChange could trigger a rerender, in order to get the correct state
                // we should only call onChange once the internal state have been modified
                if (onChange) onChange(taskId, isDone);
            });
            else // No provider - state managed by consumer
            if (onChange) onChange(taskId, isDone);
        }, this.handleOnClick = ()=>{
            const { onClick: onClick } = this.props;
            if (onClick) onClick();
        };
        this.state = {
            isDone: props.isDone
        };
    }
    componentDidMount() {
        this.mounted = true;
        this.subscribe(this.props.taskDecisionProvider, this.props.objectAri, this.props.isDone);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isDone !== this.props.isDone) // This only occurs for Actions (DONE vs TODO), since Decisions only support DECIDED.
        // If the document is refreshed or changed, we need to reset the local state to match the new
        // source of truth from the revised data.
        this.onUpdate(nextProps.isDone ? 'DONE' : 'TODO');
        if (nextProps.taskDecisionProvider !== this.props.taskDecisionProvider || nextProps.objectAri !== this.props.objectAri) {
            this.unsubscribe();
            this.subscribe(nextProps.taskDecisionProvider, nextProps.objectAri, nextProps.isDone);
        }
    }
    componentWillUnmount() {
        this.unsubscribe();
        this.mounted = false;
    }
    subscribe(taskDecisionProvider, objectAri, isDone) {
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            if (!this.mounted) return;
            const { taskId: taskId } = this.props;
            const objectKey = {
                localId: taskId,
                objectAri: objectAri
            };
            const item = {
                ...objectKey,
                state: isDone ? 'DONE' : 'TODO',
                lastUpdateDate: new Date(),
                type: 'TASK'
            };
            provider.subscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate, item);
        });
    }
    unsubscribe() {
        const { taskDecisionProvider: taskDecisionProvider, taskId: taskId, objectAri: objectAri } = this.props;
        if (taskDecisionProvider && objectAri) taskDecisionProvider.then((provider)=>{
            provider.unsubscribe({
                localId: taskId,
                objectAri: objectAri
            }, this.onUpdate);
        });
    }
    render() {
        const { isDone: isDone } = this.state;
        const { appearance: appearance, children: children, contentRef: contentRef, objectAri: objectAri, showPlaceholder: showPlaceholder, placeholder: placeholder, taskId: taskId, disabled: disabled, dataAttributes: dataAttributes, isRenderer: isRenderer, isFocused: isFocused, inputRef: inputRef } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.FabricElementsAnalyticsContext), {
            data: {
                objectAri: objectAri
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJy0l.default), {
                isDone: isDone,
                isRenderer: isRenderer,
                isFocused: isFocused,
                taskId: taskId,
                onChange: this.handleOnChange,
                onClick: this.handleOnClick,
                appearance: appearance,
                contentRef: contentRef,
                showPlaceholder: showPlaceholder,
                placeholder: placeholder,
                disabled: disabled,
                dataAttributes: dataAttributes,
                inputRef: inputRef,
                children: children
            })
        });
    }
}

});
parcelRegister("kJy0l", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5c1a691111a34ce$export$2e2bcd8739ae039);
/* TaskItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5EfQi = parcelRequire("5EfQi");

var $hagIH = parcelRequire("hagIH");

var $7h0lN = parcelRequire("7h0lN");

var $6BQTj = parcelRequire("6BQTj");

var $4J0ad = parcelRequire("4J0ad");

var $7pdp2 = parcelRequire("7pdp2");

var $82KGI = parcelRequire("82KGI");
const $f5c1a691111a34ce$var$CheckboxUncheckedIcon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $5EfQi.Icon), {
        dangerouslySetGlyph: `<rect width="12.5" height="12.5" x="1.75" y="1.75" stroke="currentcolor" stroke-width="1.5" rx="1.25"/>`,
        type: 'core',
        ...props
    });
/**
 * References packages/design-system/checkbox/src/checkbox.tsx
 * To be used until mobile editor does not require legacy themed() API anymore,
 * which will allow migration to use @atlaskit/checkbox instead
 */ const $f5c1a691111a34ce$var$checkboxStyles = null;
let $f5c1a691111a34ce$var$taskCount = 0;
const $f5c1a691111a34ce$var$getCheckBoxId = (localId)=>`${localId}-${$f5c1a691111a34ce$var$taskCount++}`;
const $f5c1a691111a34ce$var$TaskItem = (props)=>{
    const { appearance: appearance, isDone: isDone, isFocused: isFocused, contentRef: contentRef, children: children, placeholder: placeholder, showPlaceholder: showPlaceholder, disabled: disabled, dataAttributes: dataAttributes, taskId: taskId, onChange: onChange, onClick: onClick, createAnalyticsEvent: createAnalyticsEvent, inputRef: inputRefFromProps } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const checkBoxId = (0, $eJOHy.useMemo)(()=>$f5c1a691111a34ce$var$getCheckBoxId(taskId), [
        taskId
    ]);
    const handleOnChange = (0, $eJOHy.useMemo)(()=>{
        return (_evt)=>{
            const newIsDone = !isDone;
            if (onChange) onChange(taskId, newIsDone);
            const action = newIsDone ? 'checked' : 'unchecked';
            if (createAnalyticsEvent) (0, $7pdp2.createAndFireEventInElementsChannel)({
                action: action,
                actionSubject: 'action',
                eventType: 'ui',
                attributes: {
                    localId: taskId
                }
            })(createAnalyticsEvent);
        };
    }, [
        onChange,
        taskId,
        isDone,
        createAnalyticsEvent
    ]);
    const handleOnKeyPress = (0, $eJOHy.useMemo)(()=>(event)=>{
            if (event.key === 'Enter') handleOnChange(event);
        }, [
        handleOnChange
    ]);
    const localInputRef = (0, $eJOHy.useRef)(null);
    const inputRef = (0, $82KGI.useMergeRefs)(inputRefFromProps === undefined ? [
        localInputRef
    ] : [
        inputRefFromProps,
        localInputRef
    ]);
    const icon = /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        contentEditable: false,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1tcg _1bsb1tcg _4t3i1tcg _kqswh2mm _1wpzv2br _1snx1r31 _1746glyw _dx3f1o36 _1h5xidpf _sqizidpf _fs2cidpf _1smcidpf _oezm15vq _1l0615vq _1abj1mn3 _18a711so _16np1elr _a27kkb7n _q3p7usvi _qhqx1nu9 _10cr1ssb _zfav1ssb _m7eu1ooe _l9o0n7od _1efjn7od _1u2istnw _32ro1j9a _1wn015vq _den51vyt _zh8l1b66 _g5w3stnw _whhepxbi _1stbpxbi _18tob3bt _1awt1ule _haf81ssb _ra781ssb _cr751ooe _1q8r7vkz _9l2s7vkz _1mh7kb7n _s3uktlke _1davidpf _8bo8stnw _psnc1ssb _4k421ssb _1rvv1ooe _13vl73ad _1t711tcg _1nuz1tcg _cs4qstnw _9j2j1ssb _1mwj1ssb _19l51ooe _12yy1d5g _1miy1elr _1umo18hz _tpz25w2r _k6dg18hz _1qduewfl _q8ft1fvw _1y9t5w2r _ut031fvw _gi9hr01l _1qp6muej _wxkgr01l _wo245w2r _c8dpmuej _d2dcsyzs _1eulsyzs _1bc7syzs _16fmsyzs _bhkusyzs _czfesyzs _1gxgsyzs _19w0syzs _1x1y1lg7"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                id: checkBoxId,
                "aria-label": formatMessage(isDone ? (0, $7h0lN.messages).markTaskAsNotCompleted : (0, $7h0lN.messages).markTaskAsCompleted),
                name: checkBoxId,
                type: "checkbox",
                onChange: handleOnChange,
                onClick: onClick,
                checked: !!isDone,
                disabled: !!disabled,
                suppressHydrationWarning: true,
                onKeyPress: handleOnKeyPress,
                ref: inputRef
            }),
            isDone ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hagIH))), {
                label: ""
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)($f5c1a691111a34ce$var$CheckboxUncheckedIcon, {
                label: ""
            })
        ]
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (isFocused && inputRef.current) {
            inputRef.current?.focus();
            inputRef.current?.blur();
            setTimeout(()=>{
                inputRef.current?.focus();
            }, 100);
        }
    }, [
        isFocused,
        inputRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6BQTj.default), {
        appearance: appearance,
        contentRef: contentRef,
        icon: icon,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder,
        itemType: "TASK",
        dataAttributes: dataAttributes,
        checkBoxId: checkBoxId,
        children: children
    });
};
var $f5c1a691111a34ce$export$2e2bcd8739ae039 = (0, $4J0ad.default)()($f5c1a691111a34ce$var$TaskItem);

});
parcelRegister("hagIH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3cffb1e2896c4c9b0f7d38ebabc4260>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7f057169373f605$var$_react = $c7f057169373f605$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c7f057169373f605$var$_baseNew = $c7f057169373f605$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c7f057169373f605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7f057169373f605$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $c7f057169373f605$var$_react.default.createElement($c7f057169373f605$var$_baseNew.default, Object.assign({
        name: "CheckboxCheckedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$c7f057169373f605$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $c7f057169373f605$var$_default = module.exports.default = $c7f057169373f605$var$CheckboxCheckedIcon;

});

parcelRegister("7h0lN", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e47ea32d041ea095$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e47ea32d041ea095$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    fieldsetLabel: {
        id: 'fabric.editor.fieldsetLabel',
        defaultMessage: 'Action Item List',
        description: 'Label for a list of tasks/ action items'
    },
    markTaskAsCompleted: {
        id: 'platform.taskDecision.markTaskAsCompleted',
        defaultMessage: 'Mark task as completed',
        description: 'Button to mark a task as complete in the editor'
    },
    markTaskAsNotCompleted: {
        id: 'platform.taskDecision.markTaskAsNotCompleted',
        defaultMessage: 'Mark task as not completed',
        description: 'Button to mark a task as not complete in the editor'
    }
});

});

parcelRegister("7pdp2", function(module, exports) {
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $9dde8a4521254c42$export$53eef0dcd9611650);

var $5fWw9 = parcelRequire("5fWw9");
const $9dde8a4521254c42$export$7ba5d2eed2cf9f14 = 'fabric-elements';
const $9dde8a4521254c42$export$53eef0dcd9611650 = (0, $5fWw9.default)($9dde8a4521254c42$export$7ba5d2eed2cf9f14);

});





parcelRegister("lu3aG", function(module, exports) {
$parcel$export(module.exports, "default", () => $67ad49ccc2cb2822$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kiT34 = parcelRequire("kiT34");
class $67ad49ccc2cb2822$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const { children: children, localId: localId } = this.props;
        if ((0, $eJOHy.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kiT34.default), {
            listId: localId,
            children: children
        });
    }
}

});
parcelRegister("kiT34", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ac385d690279893$export$2e2bcd8739ae039);
/* TaskList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eUaD0 = parcelRequire("eUaD0");

var $7h0lN = parcelRequire("7h0lN");

var $lRq8t = parcelRequire("lRq8t");
const $9ac385d690279893$var$listStyles = null;
const $9ac385d690279893$var$taskListStyles = null;
const $9ac385d690279893$var$TaskList = ({ listId: listId, children: children })=>{
    const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(children);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!children) return null;
    // Data attributes are required for copy and paste from rendered content
    // to the editor to preserve the task.
    // This allows the editor to differentiate between numbered and ordered lists,
    // and action items, which all share the common '‹li›' element.
    // The value of 'data-task-local-id' should be discarded upon paste, with a
    // a new uuid generated by the editor for the cloned content.
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "group",
        "data-task-list-local-id": "",
        "aria-label": formatMessage((0, $7h0lN.messages).fieldsetLabel),
        className: (0, $hcewu.default)([
            "_2mzuglyw _19bvidpf"
        ]),
        children: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child, idx)=>{
            const { localId: localId } = child.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eUaD0.FabricElementsAnalyticsContext), {
                data: {
                    listLocalId: listId,
                    listSize: listSize,
                    position: idx
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    "data-task-local-id": localId || '',
                    className: (0, $hcewu.default)([
                        "_19pk1b66"
                    ]),
                    children: child
                }, idx)
            });
        })
    });
};
var $9ac385d690279893$export$2e2bcd8739ae039 = $9ac385d690279893$var$TaskList;

});


parcelRegister("dF4iL", function(module, exports) {
$parcel$export(module.exports, "default", () => $03d18e2bd4aa58df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $8DkU8 = parcelRequire("8DkU8");
var $2bEPZ = parcelRequire("2bEPZ");

var $7yBx7 = parcelRequire("7yBx7");

var $fRBiY = parcelRequire("fRBiY");

var $cQxBL = parcelRequire("cQxBL");

var $k71qx = parcelRequire("k71qx");

var $9UJzd = parcelRequire("9UJzd");

var $6YFG2 = parcelRequire("6YFG2");

var $7ueoK = parcelRequire("7ueoK");

var $jzI2h = parcelRequire("jzI2h");
function $03d18e2bd4aa58df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $03d18e2bd4aa58df$var$titleStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    outline: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $7yBx7.akEditorLineHeight),
    fontWeight: "var(--ds-font-weight-regular, 400)",
    display: 'flex',
    flex: 1,
    margin: 0,
    padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
    textAlign: 'left'
});
const $03d18e2bd4aa58df$var$containerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    borderWidth: "var(--ds-border-width, 1px)",
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: "var(--ds-radius-small, 4px)",
    minHeight: '25px',
    background: "var(--ds-background-neutral-subtle, transparent)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `background 0.3s ${(0, $7yBx7.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $7yBx7.akEditorSwoopCubicBezier)}`,
    padding: "var(--ds-space-0, 0px)",
    paddingBottom: "var(--ds-space-0, 0px)",
    marginTop: "var(--ds-space-050, 0.25rem)",
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'td > :not(style):first-child, td > style:first-child + *': {
        marginTop: 0
    }
});
const $03d18e2bd4aa58df$var$containerStylesExpanded = {
    name: "1ynzp6s",
    styles: "background:var(--ds-surface, rgba(255, 255, 255, 0.6));padding-bottom:var(--ds-space-100, 8px);border-color:var(--ds-border, #091E4224)"
};
const $03d18e2bd4aa58df$var$containerStylesFocused = {
    name: "12e71wc",
    styles: "border-color:var(--ds-border-focused, #388BFF)"
};
const $03d18e2bd4aa58df$var$containerStylesDataNodeTypeExpand = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginLeft: `-${(0, $7yBx7.akLayoutGutterOffset)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginRight: `-${(0, $7yBx7.akLayoutGutterOffset)}px`
});
const $03d18e2bd4aa58df$var$titleContainerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    alignItems: 'flex-start',
    background: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    width: '100%',
    color: "var(--ds-text-subtle, #44546F)",
    overflow: 'hidden',
    cursor: 'pointer',
    padding: "var(--ds-space-100, 8px)",
    '&:focus': {
        outline: 0
    }
});
const $03d18e2bd4aa58df$var$titleContainerStylesExpanded = {
    name: "dkidh7",
    styles: "padding-bottom:var(--ds-space-0, 0px)"
};
const $03d18e2bd4aa58df$var$contentContainerStyles = {
    name: "288te1",
    styles: "padding-top:var(--ds-space-0, 0px);margin-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-200, 16px);padding-left:var(--ds-space-400, 32px);display:flow-root;visibility:hidden;@supports not (display: flow-root){width:100%;box-sizing:border-box;}"
};
const $03d18e2bd4aa58df$var$contentContainerStylesExpanded = {
    name: "xhzdsf",
    styles: "padding-top:var(--ds-space-100, 8px);visibility:visible"
};
const $03d18e2bd4aa58df$var$contentContainerStylesNotExpanded = {
    name: "1njmbsg",
    styles: ".expand-content-wrapper, .nestedExpand-content-wrapper{width:100%;display:block;height:0;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);user-select:none;}"
};
const $03d18e2bd4aa58df$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $03d18e2bd4aa58df$var$Container = (props)=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $03d18e2bd4aa58df$var$containerStyles,
            props['data-node-type'] === 'expand' && $03d18e2bd4aa58df$var$containerStylesDataNodeTypeExpand,
            props.expanded && $03d18e2bd4aa58df$var$containerStylesExpanded,
            props.focused && $03d18e2bd4aa58df$var$containerStylesFocused
        ],
        ...props
    }, props.children);
};
const $03d18e2bd4aa58df$var$TitleContainer = (props)=>{
    const { expanded: expanded, ...buttonProps } = props;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, $1NIU8.jsx)("button", {
        type: "button",
        css: [
            $03d18e2bd4aa58df$var$titleContainerStyles,
            expanded && $03d18e2bd4aa58df$var$titleContainerStylesExpanded
        ],
        ...buttonProps
    }, props.children));
};
$03d18e2bd4aa58df$var$TitleContainer.displayName = 'TitleContainerButton';
const $03d18e2bd4aa58df$var$ContentContainer = (props)=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $03d18e2bd4aa58df$var$contentContainerStyles,
            props.expanded && $03d18e2bd4aa58df$var$contentContainerStylesExpanded,
            !props.expanded && $03d18e2bd4aa58df$var$contentContainerStylesNotExpanded
        ],
        ...props
    }, props.children);
};
function $03d18e2bd4aa58df$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent) {
    if (!fireAnalyticsEvent) return;
    fireAnalyticsEvent({
        action: (0, $bMFKb.ACTION).TOGGLE_EXPAND,
        actionSubject: nodeType === 'expand' ? (0, $bMFKb.ACTION_SUBJECT).EXPAND : (0, $bMFKb.ACTION_SUBJECT).NESTED_EXPAND,
        attributes: {
            platform: (0, $7ueoK.PLATFORM).WEB,
            mode: (0, $7ueoK.MODE).RENDERER,
            expanded: !expanded
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    });
}
function $03d18e2bd4aa58df$var$Expand({ title: title, children: children, nodeType: nodeType, intl: intl, fireAnalyticsEvent: fireAnalyticsEvent, localId: localId, nestedHeaderIds: nestedHeaderIds, rendererAppearance: rendererAppearance }) {
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const isMobile = false;
    const label = intl.formatMessage(expanded ? (0, $8DkU8.messages).collapseNode : (0, $8DkU8.messages).expandNode);
    const { current: id } = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))('expand-title-'));
    const handleFocus = (0, $eJOHy.useCallback)(()=>setFocused(true), []);
    const handleBlur = (0, $eJOHy.useCallback)(()=>setFocused(false), []);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($03d18e2bd4aa58df$var$Container, {
        "data-testid": `expand-container-${nodeType}-${id}`,
        "data-node-type": nodeType,
        "data-title": title,
        "data-expanded": expanded,
        "data-local-id": localId,
        expanded: expanded,
        focused: focused
    }, nestedHeaderIds && nestedHeaderIds.length > 0 ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jzI2h.ActiveHeaderIdConsumer), {
        nestedHeaderIds: nestedHeaderIds,
        onNestedHeaderIdMatch: ()=>setExpanded(true)
    }) : null, /*#__PURE__*/ (0, $1NIU8.jsx)($03d18e2bd4aa58df$var$TitleContainer, {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            $03d18e2bd4aa58df$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent);
            setExpanded(!expanded);
            e.persist();
            // @ts-ignore detail doesn't exist on type
            e.detail ? handleBlur() : handleFocus();
        },
        onFocus: handleFocus,
        onBlur: handleBlur,
        "aria-labelledby": id,
        "aria-expanded": expanded,
        contentEditable: false,
        expanded: expanded
    }, isMobile ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8DkU8.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        label: label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fRBiY))),
        spacing: "spacious",
        size: "small"
    })) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: label,
        position: "top",
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        tag: (0, $8DkU8.ExpandLayoutWrapperWithRef),
        testId: 'tooltip'
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8DkU8.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        label: label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fRBiY))),
        spacing: "spacious",
        size: "small"
    }))), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $03d18e2bd4aa58df$var$titleStyles,
        id: id
    }, title || intl.formatMessage((0, $8DkU8.messages).expandDefaultTitle))), /*#__PURE__*/ (0, $1NIU8.jsx)($03d18e2bd4aa58df$var$ContentContainer, {
        expanded: expanded
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        className: `${nodeType}-content-wrapper`
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthProvider), null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $03d18e2bd4aa58df$var$clearNextSiblingMarginTopStyle
    }), children))));
}
var $03d18e2bd4aa58df$export$2e2bcd8739ae039 = (0, $6YFG2.default)($03d18e2bd4aa58df$var$Expand);

});
parcelRegister("8DkU8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1e29c793325cc73a$export$defe85febe8b728c);
$parcel$export(module.exports, "ExpandIconWrapper", () => $1e29c793325cc73a$export$4eeef63d68e77552);
$parcel$export(module.exports, "expandLayoutWrapperStyle", () => $1e29c793325cc73a$export$a7ed6bf20867161a);
$parcel$export(module.exports, "ExpandLayoutWrapperWithRef", () => $1e29c793325cc73a$export$c67faf67c1185cba);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7qGN1 = parcelRequire("7qGN1");

var $7yBx7 = parcelRequire("7yBx7");
function $1e29c793325cc73a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e29c793325cc73a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    collapseNode: {
        id: 'fabric.editor.collapseNode',
        defaultMessage: 'Collapse content',
        description: 'Collapse the node'
    },
    expandDefaultTitle: {
        id: 'fabric.editor.expandDefaultTitle',
        defaultMessage: 'Click here to expand...',
        description: 'Placeholder text for an expand node'
    },
    expandNode: {
        id: 'fabric.editor.expandNode',
        defaultMessage: 'Expand content',
        description: 'Expand the node'
    },
    expandPlaceholderText: {
        id: 'fabric.editor.expandPlaceholder',
        defaultMessage: 'Give this expand a title...',
        description: 'Placeholder text for an expand node title input field'
    },
    expandArialabel: {
        id: 'fabric.editor.expandAriaLabel',
        defaultMessage: 'Give this expand a title',
        description: 'aria label for an expand node title input field'
    }
});
const $1e29c793325cc73a$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: ()=>expanded ? [
                $1e29c793325cc73a$var$expandIconWrapperStyle(),
                $1e29c793325cc73a$var$expandIconWrapperExpandedStyle
            ] : $1e29c793325cc73a$var$expandIconWrapperStyle()
    }, children);
};
const $1e29c793325cc73a$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #44546F)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $7yBx7.akEditorSwoopCubicBezier)}`
        }
    });
const $1e29c793325cc73a$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $1e29c793325cc73a$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $1e29c793325cc73a$export$c67faf67c1185cba = /*#__PURE__*/ (0, $eJOHy.forwardRef)(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props, ref)=>{
    const { children: children, ...rest } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $1e29c793325cc73a$export$a7ed6bf20867161a,
        ...rest,
        ref: ref
    }, children));
});

});

parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});




parcelRegister("cAsfm", function(module, exports) {
$parcel$export(module.exports, "getMediaOptions", () => $a5436c1941da7772$export$cbb71ca960bf2b80);
$parcel$export(module.exports, "useGetMediaOptions", () => $a5436c1941da7772$export$26b7e8db38ef2026);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $c5gEr = parcelRequire("c5gEr");
const $a5436c1941da7772$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR = 'mediaProvider unavailable, must use initialAuth';
const $a5436c1941da7772$var$getServerMediaOptions = ({ mediaContext: mediaContext })=>{
    return {
        mode: 'server',
        config: {
            authProvider: ()=>Promise.reject(new Error($a5436c1941da7772$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR)),
            initialAuth: {
                clientId: mediaContext?.viewContext?.clientId || '',
                baseUrl: mediaContext?.viewContext?.serviceHost || '',
                token: mediaContext?.viewContext?.token || ''
            },
            enforceDataSecurityPolicy: false
        }
    };
};
const $a5436c1941da7772$var$getClientMediaOptions = ({ mediaContext: mediaContext })=>{
    return {
        mode: 'client',
        config: {
            authProvider: ()=>Promise.resolve({
                    clientId: mediaContext?.viewContext?.clientId || '',
                    baseUrl: mediaContext?.viewContext?.serviceHost || '',
                    token: mediaContext?.viewContext?.token || ''
                }),
            initialAuth: {
                clientId: mediaContext?.viewContext?.clientId || '',
                baseUrl: mediaContext?.viewContext?.serviceHost || '',
                token: mediaContext?.viewContext?.token || ''
            },
            enforceDataSecurityPolicy: false
        }
    };
};
const $a5436c1941da7772$export$cbb71ca960bf2b80 = ({ mediaContext: mediaContext })=>{
    if ((0, $7jTnu.fg)('jfp-magma-ssr-iv-editor-media')) return {
        allowLinking: true,
        enableSyncMediaCard: true,
        featureFlags: (0, $c5gEr.mediaFeatureFlags)(),
        allowPixelResizing: Boolean((0, $7jTnu.fg)('jfp-magma-ssr-iv-editor-media-pixel-width')),
        ssr: false ? $a5436c1941da7772$var$getServerMediaOptions({
            mediaContext: mediaContext
        }) : $a5436c1941da7772$var$getClientMediaOptions({
            mediaContext: mediaContext
        })
    };
    // This is the current state of the media options.
    return {
        allowLinking: true,
        featureFlags: (0, $c5gEr.mediaFeatureFlags)(),
        allowPixelResizing: Boolean((0, $7jTnu.fg)('jfp-magma-ssr-iv-editor-media-pixel-width'))
    };
};
const $a5436c1941da7772$export$26b7e8db38ef2026 = ({ mediaContext: mediaContext })=>{
    return (0, $eJOHy.useMemo)(()=>$a5436c1941da7772$export$cbb71ca960bf2b80({
            mediaContext: mediaContext
        }), [
        mediaContext
    ]);
};

});
parcelRegister("c5gEr", function(module, exports) {
$parcel$export(module.exports, "mediaFeatureFlags", () => $4eb4ae00e7515f1b$export$250985d9ea13242f);
/**
 * Feature flags should be defined individually in './feature-flags.js'
 * There is processing on that file to automate analytics discovery.
 * We import them here so they can be exported as one value and given to
 * Editor/Renderer/Media components.
 *
 * NOTE: The use of functions vs raw values is intentional. You must use
 * `mediaFeatureFlags()` vs `mediaFeatureFlags` due to the fact that these
 * flags won't be available immediately. This relates to SST and launchdarkly.
 * Otherwise the getters would be executed immediately and blank values
 * will be passed.
 */ const $4eb4ae00e7515f1b$export$250985d9ea13242f = ()=>({
        mediaInline: true,
        // TODO: remove after media team clean up securedClipboard: https://product-fabric.atlassian.net/browse/CXP-2664
        securedClipboard: true
    });

});




$parcel$global.rlb("2tXQt")
//# sourceMappingURL=view-old.2beb5f3c.js.map
